(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(_dereq_,module,exports){
(function (process){(function (){
/* reduce implemintation by Mozila https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FArray%2FReduce*/
if ('function' !== typeof Array.prototype.reduce) {
  Array.prototype.reduce = function(callback, opt_initialValue){
    'use strict';
    if (null === this || 'undefined' === typeof this) {
      // At the moment all modern browsers, that support strict mode, have
      // native implementation of Array.prototype.reduce. For instance, IE8
      // does not support strict mode, so this check is actually useless.
      throw new TypeError(
          'Array.prototype.reduce called on null or undefined');
    }
    if ('function' !== typeof callback) {
      throw new TypeError(callback + ' is not a function');
    }
    var index, value,
        length = this.length >>> 0,
        isValueSet = false;
    if (1 < arguments.length) {
      value = opt_initialValue;
      isValueSet = true;
    }
    for (index = 0; length > index; ++index) {
      if (this.hasOwnProperty(index)) {
        if (isValueSet) {
          value = callback(value, this[index], index, this);
        }
        else {
          value = this[index];
          isValueSet = true;
        }
      }
    }
    if (!isValueSet) {
      throw new TypeError('Reduce of empty array with no initial value');
    }
    return value;
  };
}

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.com/#x15.4.4.18
if (!Array.prototype.forEach) {

  Array.prototype.forEach = function forEach(callback, thisArg) {
    'use strict';
    var T, k;

    if (this == null) {
      throw new TypeError("this is null or not defined");
    }

    var kValue,
        // 1. Let O be the result of calling ToObject passing the |this| value as the argument.
        O = Object(this),

        // 2. Let lenValue be the result of calling the Get internal method of O with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        len = O.length >>> 0; // Hack to convert O.length to a UInt32

    // 4. If IsCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if ({}.toString.call(callback) !== "[object Function]") {
      throw new TypeError(callback + " is not a function");
    }

    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if (arguments.length >= 2) {
      T = thisArg;
    }

    // 6. Let k be 0
    k = 0;

    // 7. Repeat, while k < len
    while (k < len) {

      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty internal method of O with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {

        // i. Let kValue be the result of calling the Get internal method of O with argument Pk.
        kValue = O[k];

        // ii. Call the Call internal method of callback with T as the this value and
        // argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
  Object.keys = (function () {
    'use strict';
    var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
        dontEnums = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor'
        ],
        dontEnumsLength = dontEnums.length;

    return function (obj) {
      if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
        throw new TypeError('Object.keys called on non-object');
      }

      var result = [], prop, i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }());
}

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/some
if (!Array.prototype.some)
{
  Array.prototype.some = function(fun /*, thisArg */)
  {
    'use strict';

    if (this === void 0 || this === null)
      throw new TypeError();

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== 'function')
      throw new TypeError();

    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (var i = 0; i < len; i++)
    {
      if (i in t && fun.call(thisArg, t[i], i, t))
        return true;
    }

    return false;
  };
}

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
if (!Array.prototype.map)
{
  Array.prototype.map = function(fun /*, thisArg */)
  {
    "use strict";

    if (this === void 0 || this === null)
      throw new TypeError();

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== "function")
      throw new TypeError();

    var res = new Array(len);
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (var i = 0; i < len; i++)
    {
      // NOTE: Absolute correctness would demand Object.defineProperty
      //       be used.  But this method is fairly new, and failure is
      //       possible only if Object.prototype or Array.prototype
      //       has a property |i| (very unlikely), so use a less-correct
      //       but more portable alternative.
      if (i in t)
        res[i] = fun.call(thisArg, t[i], i, t);
    }

    return res;
  };
}

//From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
if (!Array.prototype.filter)
{
  Array.prototype.filter = function(fun /*, thisArg */)
  {
    "use strict";

    if (this === void 0 || this === null)
      throw new TypeError();

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun != "function")
      throw new TypeError();

    var res = [];
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (var i = 0; i < len; i++)
    {
      if (i in t)
      {
        var val = t[i];

        // NOTE: Technically this should Object.defineProperty at
        //       the next index, as push can be affected by
        //       properties on Object.prototype and Array.prototype.
        //       But that method's new, and collisions should be
        //       rare, so use the more-compatible alternative.
        if (fun.call(thisArg, val, i, t))
          res.push(val);
      }
    }

    return res;
  };
}

//From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind
if (!Function.prototype.bind) {
  Function.prototype.bind = function (oThis) {
    if (typeof this !== "function") {
      // closest thing possible to the ECMAScript 5 internal IsCallable function
      throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
    }

    var aArgs = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP = function () {},
        fBound = function () {
          return fToBind.apply(this instanceof fNOP && oThis
                                 ? this
                                 : oThis,
                               aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    fNOP.prototype = this.prototype;
    fBound.prototype = new fNOP();

    return fBound;
  };
}

//From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FArray%2FindexOf
if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function (searchElement, fromIndex) {
    if ( this === undefined || this === null ) {
      throw new TypeError( '"this" is null or not defined' );
    }

    var length = this.length >>> 0; // Hack to convert object.length to a UInt32

    fromIndex = +fromIndex || 0;

    if (Math.abs(fromIndex) === Infinity) {
      fromIndex = 0;
    }

    if (fromIndex < 0) {
      fromIndex += length;
      if (fromIndex < 0) {
        fromIndex = 0;
      }
    }

    for (;fromIndex < length; fromIndex++) {
      if (this[fromIndex] === searchElement) {
        return fromIndex;
      }
    }

    return -1;
  };
}

if (typeof Promise !== 'function') {
  (function() {
  var define, requireModule, _dereq_, requirejs;

  (function() {
    var registry = {}, seen = {};

    define = function(name, deps, callback) {
      registry[name] = { deps: deps, callback: callback };
    };

    requirejs = _dereq_ = requireModule = function(name) {
    requirejs._eak_seen = registry;

      if (seen[name]) { return seen[name]; }
      seen[name] = {};

      if (!registry[name]) {
        throw new Error("Could not find module " + name);
      }

      var mod = registry[name],
          deps = mod.deps,
          callback = mod.callback,
          reified = [],
          exports;

      for (var i=0, l=deps.length; i<l; i++) {
        if (deps[i] === 'exports') {
          reified.push(exports = {});
        } else {
          reified.push(requireModule(resolve(deps[i])));
        }
      }

      var value = callback.apply(this, reified);
      return seen[name] = exports || value;

      function resolve(child) {
        if (child.charAt(0) !== '.') { return child; }
        var parts = child.split("/");
        var parentBase = name.split("/").slice(0, -1);

        for (var i=0, l=parts.length; i<l; i++) {
          var part = parts[i];

          if (part === '..') { parentBase.pop(); }
          else if (part === '.') { continue; }
          else { parentBase.push(part); }
        }

        return parentBase.join("/");
      }
    };
  })();

  define("promise/all",
    ["./utils","exports"],
    function(__dependency1__, __exports__) {
      "use strict";
      /* global toString */

      var isArray = __dependency1__.isArray;
      var isFunction = __dependency1__.isFunction;

      /**
        Returns a promise that is fulfilled when all the given promises have been
        fulfilled, or rejected if any of them become rejected. The return promise
        is fulfilled with an array that gives all the values in the order they were
        passed in the `promises` array argument.

        Example:

        ```javascript
        var promise1 = RSVP.resolve(1);
        var promise2 = RSVP.resolve(2);
        var promise3 = RSVP.resolve(3);
        var promises = [ promise1, promise2, promise3 ];

        RSVP.all(promises).then(function(array){
          // The array here would be [ 1, 2, 3 ];
        });
        ```

        If any of the `promises` given to `RSVP.all` are rejected, the first promise
        that is rejected will be given as an argument to the returned promises's
        rejection handler. For example:

        Example:

        ```javascript
        var promise1 = RSVP.resolve(1);
        var promise2 = RSVP.reject(new Error("2"));
        var promise3 = RSVP.reject(new Error("3"));
        var promises = [ promise1, promise2, promise3 ];

        RSVP.all(promises).then(function(array){
          // Code here never runs because there are rejected promises!
        }, function(error) {
          // error.message === "2"
        });
        ```

        @method all
        @for RSVP
        @param {Array} promises
        @param {String} label
        @return {Promise} promise that is fulfilled when all `promises` have been
        fulfilled, or rejected if any of them become rejected.
      */
      function all(promises) {
        /*jshint validthis:true */
        var Promise = this;

        if (!isArray(promises)) {
          throw new TypeError('You must pass an array to all.');
        }

        return new Promise(function(resolve, reject) {
          var results = [], remaining = promises.length,
          promise;

          if (remaining === 0) {
            resolve([]);
          }

          function resolver(index) {
            return function(value) {
              resolveAll(index, value);
            };
          }

          function resolveAll(index, value) {
            results[index] = value;
            if (--remaining === 0) {
              resolve(results);
            }
          }

          for (var i = 0; i < promises.length; i++) {
            promise = promises[i];

            if (promise && isFunction(promise.then)) {
              promise.then(resolver(i), reject);
            } else {
              resolveAll(i, promise);
            }
          }
        });
      }

      __exports__.all = all;
    });
  define("promise/asap",
    ["exports"],
    function(__exports__) {
      "use strict";
      var browserGlobal = (typeof window !== 'undefined') ? window : {};
      var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
      var local = window;

      // node
      function useNextTick() {
        return function() {
          process.nextTick(flush);
        };
      }

      function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode('');
        observer.observe(node, { characterData: true });

        return function() {
          node.data = (iterations = ++iterations % 2);
        };
      }

      function useSetTimeout() {
        return function() {
          local.setTimeout(flush, 1);
        };
      }

      var queue = [];
      function flush() {
        for (var i = 0; i < queue.length; i++) {
          var tuple = queue[i];
          var callback = tuple[0], arg = tuple[1];
          callback(arg);
        }
        queue = [];
      }

      var scheduleFlush;

      // Decide what async method to use to triggering processing of queued callbacks:
      if (typeof process !== 'undefined' && {}.toString.call(process) === '[object process]') {
        scheduleFlush = useNextTick();
      } else if (BrowserMutationObserver) {
        scheduleFlush = useMutationObserver();
      } else {
        scheduleFlush = useSetTimeout();
      }

      function asap(callback, arg) {
        var length = queue.push([callback, arg]);
        if (length === 1) {
          // If length is 1, that means that we need to schedule an async flush.
          // If additional callbacks are queued before the queue is flushed, they
          // will be processed by this flush that we are scheduling.
          scheduleFlush();
        }
      }

      __exports__.asap = asap;
    });
  define("promise/config",
    ["exports"],
    function(__exports__) {
      "use strict";
      var config = {
        instrument: false
      };

      function configure(name, value) {
        if (arguments.length === 2) {
          config[name] = value;
        } else {
          return config[name];
        }
      }

      __exports__.config = config;
      __exports__.configure = configure;
    });
  define("promise/polyfill",
    ["./promise","./utils","exports"],
    function(__dependency1__, __dependency2__, __exports__) {
      "use strict";
      /*global self*/
      var RSVPPromise = __dependency1__.Promise;
      var isFunction = __dependency2__.isFunction;

      function polyfill() {
        var local;

        if (typeof window !== 'undefined' && window.document) {
          local = window;
        } else {
          local = self;
        }

        var es6PromiseSupport =
          "Promise" in local &&
          // Some of these methods are missing from
          // Firefox/Chrome experimental implementations
          "resolve" in local.Promise &&
          "reject" in local.Promise &&
          "all" in local.Promise &&
          "race" in local.Promise &&
          // Older version of the spec had a resolver object
          // as the arg rather than a function
          (function() {
            var resolve;
            new local.Promise(function(r) { resolve = r; });
            return isFunction(resolve);
          }());

        if (!es6PromiseSupport) {
          local.Promise = RSVPPromise;
        }
      }

      __exports__.polyfill = polyfill;
    });
  define("promise/promise",
    ["./config","./utils","./all","./race","./resolve","./reject","./asap","exports"],
    function(__dependency1__, __dependency2__, __dependency3__, __dependency4__, __dependency5__, __dependency6__, __dependency7__, __exports__) {
      "use strict";
      var config = __dependency1__.config;
      var configure = __dependency1__.configure;
      var objectOrFunction = __dependency2__.objectOrFunction;
      var isFunction = __dependency2__.isFunction;
      var now = __dependency2__.now;
      var all = __dependency3__.all;
      var race = __dependency4__.race;
      var staticResolve = __dependency5__.resolve;
      var staticReject = __dependency6__.reject;
      var asap = __dependency7__.asap;

      var counter = 0;

      config.async = asap; // default async is asap;

      function Promise(resolver) {
        if (!isFunction(resolver)) {
          throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
        }

        if (!(this instanceof Promise)) {
          throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
        }

        this._subscribers = [];

        invokeResolver(resolver, this);
      }

      function invokeResolver(resolver, promise) {
        function resolvePromise(value) {
          resolve(promise, value);
        }

        function rejectPromise(reason) {
          reject(promise, reason);
        }

        try {
          resolver(resolvePromise, rejectPromise);
        } catch(e) {
          rejectPromise(e);
        }
      }

      function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback),
            value, error, succeeded, failed;

        if (hasCallback) {
          try {
            value = callback(detail);
            succeeded = true;
          } catch(e) {
            failed = true;
            error = e;
          }
        } else {
          value = detail;
          succeeded = true;
        }

        if (handleThenable(promise, value)) {
          return;
        } else if (hasCallback && succeeded) {
          resolve(promise, value);
        } else if (failed) {
          reject(promise, error);
        } else if (settled === FULFILLED) {
          resolve(promise, value);
        } else if (settled === REJECTED) {
          reject(promise, value);
        }
      }

      var PENDING   = void 0;
      var SEALED    = 0;
      var FULFILLED = 1;
      var REJECTED  = 2;

      function subscribe(parent, child, onFulfillment, onRejection) {
        var subscribers = parent._subscribers;
        var length = subscribers.length;

        subscribers[length] = child;
        subscribers[length + FULFILLED] = onFulfillment;
        subscribers[length + REJECTED]  = onRejection;
      }

      function publish(promise, settled) {
        var child, callback, subscribers = promise._subscribers, detail = promise._detail;

        for (var i = 0; i < subscribers.length; i += 3) {
          child = subscribers[i];
          callback = subscribers[i + settled];

          invokeCallback(settled, child, callback, detail);
        }

        promise._subscribers = null;
      }

      Promise.prototype = {
        constructor: Promise,

        _state: undefined,
        _detail: undefined,
        _subscribers: undefined,

        then: function(onFulfillment, onRejection) {
          var promise = this;

          var thenPromise = new this.constructor(function() {});

          if (this._state) {
            var callbacks = arguments;
            config.async(function invokePromiseCallback() {
              invokeCallback(promise._state, thenPromise, callbacks[promise._state - 1], promise._detail);
            });
          } else {
            subscribe(this, thenPromise, onFulfillment, onRejection);
          }

          return thenPromise;
        },

        'catch': function(onRejection) {
          return this.then(null, onRejection);
        }
      };

      Promise.all = all;
      Promise.race = race;
      Promise.resolve = staticResolve;
      Promise.reject = staticReject;

      function handleThenable(promise, value) {
        var then = null,
        resolved;

        try {
          if (promise === value) {
            throw new TypeError("A promises callback cannot return that same promise.");
          }

          if (objectOrFunction(value)) {
            then = value.then;

            if (isFunction(then)) {
              then.call(value, function(val) {
                if (resolved) { return true; }
                resolved = true;

                if (value !== val) {
                  resolve(promise, val);
                } else {
                  fulfill(promise, val);
                }
              }, function(val) {
                if (resolved) { return true; }
                resolved = true;

                reject(promise, val);
              });

              return true;
            }
          }
        } catch (error) {
          if (resolved) { return true; }
          reject(promise, error);
          return true;
        }

        return false;
      }

      function resolve(promise, value) {
        if (promise === value) {
          fulfill(promise, value);
        } else if (!handleThenable(promise, value)) {
          fulfill(promise, value);
        }
      }

      function fulfill(promise, value) {
        if (promise._state !== PENDING) { return; }
        promise._state = SEALED;
        promise._detail = value;

        config.async(publishFulfillment, promise);
      }

      function reject(promise, reason) {
        if (promise._state !== PENDING) { return; }
        promise._state = SEALED;
        promise._detail = reason;

        config.async(publishRejection, promise);
      }

      function publishFulfillment(promise) {
        publish(promise, promise._state = FULFILLED);
      }

      function publishRejection(promise) {
        publish(promise, promise._state = REJECTED);
      }

      __exports__.Promise = Promise;
    });
  define("promise/race",
    ["./utils","exports"],
    function(__dependency1__, __exports__) {
      "use strict";
      /* global toString */
      var isArray = __dependency1__.isArray;

      /**
        `RSVP.race` allows you to watch a series of promises and act as soon as the
        first promise given to the `promises` argument fulfills or rejects.

        Example:

        ```javascript
        var promise1 = new RSVP.Promise(function(resolve, reject){
          setTimeout(function(){
            resolve("promise 1");
          }, 200);
        });

        var promise2 = new RSVP.Promise(function(resolve, reject){
          setTimeout(function(){
            resolve("promise 2");
          }, 100);
        });

        RSVP.race([promise1, promise2]).then(function(result){
          // result === "promise 2" because it was resolved before promise1
          // was resolved.
        });
        ```

        `RSVP.race` is deterministic in that only the state of the first completed
        promise matters. For example, even if other promises given to the `promises`
        array argument are resolved, but the first completed promise has become
        rejected before the other promises became fulfilled, the returned promise
        will become rejected:

        ```javascript
        var promise1 = new RSVP.Promise(function(resolve, reject){
          setTimeout(function(){
            resolve("promise 1");
          }, 200);
        });

        var promise2 = new RSVP.Promise(function(resolve, reject){
          setTimeout(function(){
            reject(new Error("promise 2"));
          }, 100);
        });

        RSVP.race([promise1, promise2]).then(function(result){
          // Code here never runs because there are rejected promises!
        }, function(reason){
          // reason.message === "promise2" because promise 2 became rejected before
          // promise 1 became fulfilled
        });
        ```

        @method race
        @for RSVP
        @param {Array} promises array of promises to observe
        @param {String} label optional string for describing the promise returned.
        Useful for tooling.
        @return {Promise} a promise that becomes fulfilled with the value the first
        completed promises is resolved with if the first completed promise was
        fulfilled, or rejected with the reason that the first completed promise
        was rejected with.
      */
      function race(promises) {
        /*jshint validthis:true */
        var Promise = this;

        if (!isArray(promises)) {
          throw new TypeError('You must pass an array to race.');
        }
        return new Promise(function(resolve, reject) {
          var results = [], promise;

          for (var i = 0; i < promises.length; i++) {
            promise = promises[i];

            if (promise && typeof promise.then === 'function') {
              promise.then(resolve, reject);
            } else {
              resolve(promise);
            }
          }
        });
      }

      __exports__.race = race;
    });
  define("promise/reject",
    ["exports"],
    function(__exports__) {
      "use strict";
      /**
        `RSVP.reject` returns a promise that will become rejected with the passed
        `reason`. `RSVP.reject` is essentially shorthand for the following:

        ```javascript
        var promise = new RSVP.Promise(function(resolve, reject){
          reject(new Error('WHOOPS'));
        });

        promise.then(function(value){
          // Code here doesn't run because the promise is rejected!
        }, function(reason){
          // reason.message === 'WHOOPS'
        });
        ```

        Instead of writing the above, your code now simply becomes the following:

        ```javascript
        var promise = RSVP.reject(new Error('WHOOPS'));

        promise.then(function(value){
          // Code here doesn't run because the promise is rejected!
        }, function(reason){
          // reason.message === 'WHOOPS'
        });
        ```

        @method reject
        @for RSVP
        @param {Any} reason value that the returned promise will be rejected with.
        @param {String} label optional string for identifying the returned promise.
        Useful for tooling.
        @return {Promise} a promise that will become rejected with the given
        `reason`.
      */
      function reject(reason) {
        /*jshint validthis:true */
        var Promise = this;

        return new Promise(function (resolve, reject) {
          reject(reason);
        });
      }

      __exports__.reject = reject;
    });
  define("promise/resolve",
    ["exports"],
    function(__exports__) {
      "use strict";
      function resolve(value) {
        /*jshint validthis:true */
        if (value && typeof value === 'object' && value.constructor === this) {
          return value;
        }

        var Promise = this;

        return new Promise(function(resolve) {
          resolve(value);
        });
      }

      __exports__.resolve = resolve;
    });
  define("promise/utils",
    ["exports"],
    function(__exports__) {
      "use strict";
      function objectOrFunction(x) {
        return isFunction(x) || (typeof x === "object" && x !== null);
      }

      function isFunction(x) {
        return typeof x === "function";
      }

      function isArray(x) {
        return Object.prototype.toString.call(x) === "[object Array]";
      }

      // Date.now is not available in browsers < IE9
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/now#Compatibility
      var now = Date.now || function() { return new Date().getTime(); };


      __exports__.objectOrFunction = objectOrFunction;
      __exports__.isFunction = isFunction;
      __exports__.isArray = isArray;
      __exports__.now = now;
    });
  requireModule('promise/polyfill').polyfill();
  }());
}

_dereq_('leaflet');
_dereq_('html5shiv');

// DG inheritance
var oldDG = window.DG;
var DG = new (
    (function() {
        var DgApi = function() {},
            DgApiCore = function() {};

        DgApiCore.prototype = L;
        DgApi.prototype = new DgApiCore();

        return DgApi;
    })()
)();

for (var prop in oldDG) {
    if (oldDG.hasOwnProperty(prop) && typeof DG[prop] === 'undefined') {
        DG[prop] = oldDG[prop];
    }
}

window.__dgApi__ = window.__dgApi__ || {};
DG.version = window.__dgApi__.version;
DG.Icon.Default.imagePath  = '../img/vendors/leaflet';

// Improve IHandler
DG.Map.include({
    addHandler: function(name, HandlerClass) {
        if (!HandlerClass) { return this; }

        var options = this.options[name],
            param = (options === Object(options)) ? options : null,
            handler = this[name] = new HandlerClass(this, param);

        this._handlers.push(handler);

        if (options) {
            handler.enable();
        }

        return this;
    }
});

// Apply class to map container for detect when we dont need hover effects
DG.Map.addInitHook(function() {
    if (!DG.Browser.touchEnabled) {
        DG.DomUtil.addClass(this._container, 'no-touch');
    }
});

window.DG = DG;
module.exports = DG;

var handlers = window.__dgApi__.callbacks || [],
    chain = Promise.resolve();

handlers.forEach(function(handlers) {
    chain = chain.then(handlers[0], handlers[1]);
});

DG.then = function(resolve, reject) {
    return chain.then(resolve, reject);
};

// IE8 throw error if `chain.catch`
/* eslint-disable dot-notation, no-console */
chain['catch'](function(err) {
    console.error(err);
});
/* eslint-enable dot-notation, no-console */

DG.plugin = function(plugins) {
    var count,
        jsReg = new RegExp(/.js$/i),
        cssReg = new RegExp(/.css$/i);

    return new Promise(function(resolve) {
        function checkLoading() {
            count--;

            if (count === 0) {
                resolve();
            }
        }

        function appendJS(link) {
            var js = document.createElement('script');
            js.setAttribute('type', 'text/javascript');
            js.setAttribute('src', link);
            js.onload = function() {
                checkLoading();
            };
            js.onerror = function() {
                checkLoading();
            };
            // load/error for IE
            js.onreadystatechange = function() {
                if (js.readyState === 'complete' || js.readyState === 'loaded') {
                    checkLoading();
                }
            };

            document.getElementsByTagName('head')[0].appendChild(js);
        }

        function appendCSS(link) {
            var css = document.createElement('link');
            css.setAttribute('rel', 'stylesheet');
            css.setAttribute('type', 'text/css');
            css.setAttribute('href', link);
            document.getElementsByTagName('head')[0].appendChild(css);

            checkLoading();
        }

        function isJs(url) {
            return jsReg.test(url);
        }

        function isCss(url) {
            return cssReg.test(url);
        }

        function appendAsset(asset) {
            if (isJs(asset)) {
                appendJS(asset);
            } else if (isCss(asset)) {
                appendCSS(asset);
            } else {
                count--;
            }
        }

        if (DG.Util.isArray(plugins)) {
            count = plugins.length;
            plugins.forEach(function(plugin) {
                appendAsset(plugin);
            });
        }

        if (typeof plugins === 'string') {
            count = 1;
            appendAsset(plugins);
        }
    });
};

DG.ajax = (function() {

    var win = window,
        doc = document,

        rurl = /^([\w.+-]+:)?(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,
        twoHundo = /^20\d$/,

        // Document location
        ajaxLocParts,
        ajaxLocation,

        byTag = 'getElementsByTagName',
        readyState = 'readyState',
        contentType = 'Content-Type',
        requestedWith = 'X-Requested-With',
        head = doc[byTag]('head')[0],
        uniqid = 0,
        callbackPrefix = 'l_dg_ajax_callback_' + (+new Date()),
        lastValue, // data stored by the most recent JSONP callback
        xmlHttpRequest = 'XMLHttpRequest',
        xDomainRequest = 'XDomainRequest', // IE 8 and 9 only
        noop = function() {},
        defaultHeaders = {
            contentType: 'application/x-www-form-urlencoded',
            requestedWith: xmlHttpRequest,
            accept: {
                '*':  'text/javascript, text/html, application/xml, text/xml, */*',
                xml:  'application/xml, text/xml',
                html: 'text/html',
                text: 'text/plain',
                json: 'application/json, text/javascript',
                js:   'application/javascript, text/javascript'
            }
        },
        /*global XDomainRequest:false */
        xhr = function(o) {
            // is it x-domain
            if (o.crossDomain === true) {
                var xhr = win[xmlHttpRequest] ? new XMLHttpRequest() : null;
                if (xhr && 'withCredentials' in xhr) {
                    return xhr;
                } else if (win[xDomainRequest]) {
                    return new XDomainRequest();
                } else {
                    throw new Error('Browser does not support cross-origin requests');
                }
            } else {
                return new XMLHttpRequest();
            }
        },

        globalSetupOptions = {
            dataFilter: function(data) {
                return data;
            }
        };

    // IE may throw an exception when accessing
    // a field from window.location if document.domain has been set
    try {
        ajaxLocation = location.href;
    } catch (e) {
        // Use the href attribute of an A element
        // since IE will modify it given document.location
        ajaxLocation = document.createElement('a');
        ajaxLocation.href = '';
        ajaxLocation = ajaxLocation.href;
    }

    // Segment location into parts
    ajaxLocParts = rurl.exec(ajaxLocation.toLowerCase()) || [];

    function handleReadyState(r, success, error) {
        return function() {
            // use _aborted to mitigate against IE err c00c023f
            // (can't read props on aborted request objects)
            if (r._aborted) {
                return error(r.request);
            }
            if (r.request && r.request[readyState] === 4) {
                r.request.onreadystatechange = noop;
                if (twoHundo.test(r.request.status)) {
                    success(r.request);
                } else {
                    error(r.request);
                }
            }
        };
    }

    function setHeaders(http, o) {
        var headers = o.headers || {},
            h;

        headers.Accept = headers.Accept || defaultHeaders.accept[o.dataType] || defaultHeaders.accept['*'];

        // breaks cross-origin requests with legacy browsers
        if (!o.crossDomain && !headers[requestedWith]) {
            headers[requestedWith] = defaultHeaders.requestedWith;
        }
        if (!headers[contentType]) {
            headers[contentType] = o.contentType || defaultHeaders.contentType;
        }
        for (h in headers) {
            if (headers.hasOwnProperty(h) && 'setRequestHeader' in http) {
                http.setRequestHeader(h, headers[h]);
            }
        }
    }

    function setCredentials(http, o) {
        if (typeof o.withCredentials !== 'undefined' && typeof http.withCredentials !== 'undefined') {
            http.withCredentials = !!o.withCredentials;
        }
    }

    function generalCallback(data) {
        lastValue = data;
    }

    function urlappend(url, s) {
        return url + (/\?/.test(url) ? '&' : '?') + s;
    }

    function handleJsonp(o, fn, err, url) {
        var reqId = uniqid++,
            cbkey = o.jsonpCallback || 'callback', // the 'callback' key
            cbval = o.jsonpCallbackName || callbackPrefix,
            cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)'),
            match = url.match(cbreg),
            script = doc.createElement('script'),
            loaded = 0,
            isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1;

        if (match) {
            if (match[3] === '?') {
                url = url.replace(cbreg, '$1=' + cbval); // wildcard callback func name
            } else {
                cbval = match[3]; // provided callback func name
            }
        } else {
            url = urlappend(url, cbkey + '=' + cbval); // no callback details, add 'em
        }

        win[cbval] = generalCallback;

        script.type = 'text/javascript';
        script.src = url;
        script.async = true;
        if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
            // need this for IE due to out-of-order onreadystatechange(), binding script
            // execution to an event listener gives us control over when the script
            // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
            //
            // if this hack is used in IE10 jsonp callback are never called
            script.event = 'onclick';
            script.htmlFor = script.id = '_request_' + reqId;
        }

        script.onerror = function() {
            script.onerror = script.onload = script.onreadystatechange = null;
            err({}, 'Request unknown error', {});
            lastValue = undefined;
            head.removeChild(script);
            loaded = 1;
        };
        script.onload = script.onreadystatechange = function() {
            if ((script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded') || loaded) {
                return false;
            }
            script.onerror = script.onload = script.onreadystatechange = null;
            if (script.onclick) {
                script.onclick();
            }
            // Call the user callback with the last value stored and clean up values and scripts.
            fn(lastValue);
            lastValue = undefined;
            head.removeChild(script);
            loaded = 1;
        };

        // Add the script to the DOM head
        head.appendChild(script);

        // Enable JSONP timeout
        return {
            abort: function() {
                script.onerror = script.onload = script.onreadystatechange = null;
                err({}, 'Request is aborted: timeout', {});
                lastValue = undefined;
                head.removeChild(script);
                loaded = 1;
            }
        };
    }

    function getRequest(fn, err) {
        var o = this.options,
            method = (o.type || 'GET').toUpperCase(),
            url = typeof o === 'string' ? o : o.url,
            // convert non-string objects to query-string form unless o.processData is false
            data = (o.processData !== false && o.data && typeof o.data !== 'string') ? Ajax.toQueryString(o.data) : (o.data || null),
            http,
            sendWait = false;

        // if we're working on a GET request and we have data then we should append
        // query string to end of URL and not post data
        if ((o.type === 'jsonp' || method === 'GET') && data) {
            url = urlappend(url, data);
            data = null;
        }

        if (o.type === 'jsonp') {
            return handleJsonp(o, fn, err, url);
        }

        http = xhr(o);
        http.open(method, url, o.async !== false);

        setHeaders(http, o);
        setCredentials(http, o);

        if (win[xDomainRequest] && http instanceof win[xDomainRequest]) {
            http.onload = fn;
            http.onprogress = function() {};
            http.ontimeout = function() {};
            http.onerror = err;
            sendWait = true;
        } else {
            http.onreadystatechange = handleReadyState(this, fn, err);
        }
        if (sendWait) {
            setTimeout(function() {
                http.send(data);
            }, 200);
        } else {
            http.send(data);
        }
        return http;
    }

    function buildParams(prefix, obj, traditional, add) {
        var name, i, v,
            rbracket = /\[\]$/;

        if (DG.Util.isArray(obj)) {
        // Serialize array item.
            for (i = 0; obj && i < obj.length; i++) {
                v = obj[i];
                if (traditional || rbracket.test(prefix)) {
                    // Treat each array item as a scalar.
                    add(prefix, v);
                } else {
                    buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v, traditional, add);
                }
            }
        } else if (obj && obj.toString() === '[object Object]') {
            // Serialize object item.
            for (name in obj) {
                if (obj.hasOwnProperty(name)) {
                    buildParams(prefix + '[' + name + ']', obj[name], traditional, add);
                }
            }
        } else {
            // Serialize scalar item.
            add(prefix, obj);
        }
    }

    function setType(url) {
        var m = url.match(/\.(json|jsonp|html|xml)(\?|$)/);
        return m ? m[1] : 'js';
    }

    function isCrossDomain(url) {
        var parts = rurl.exec(url.toLowerCase());
        return !!(parts &&
                (parts[1] !== ajaxLocParts[1] || parts[2] !== ajaxLocParts[2] ||
                    (parts[3] || (parts[1] === 'http:' ? '80' : '443')) !==
                        (ajaxLocParts[3] || (ajaxLocParts[1] === 'http:' ? '80' : '443')))
        );
    }

    function doRequest(o) {

        if (!('crossDomain' in o)) {
            o.crossDomain = isCrossDomain(o.url);
        }

        var self = {};
        self.promise = new Promise(function(resolve, reject) {
            self.abort = function() {
                self._aborted = true;
                reject('aborted');
            };

            self.url = o.url;
            self.timeout = null;
            self.options = o;

            self._aborted = false;
            self._erred = false;
            self._responseArgs = {};

            var type = o.type === 'jsonp' ? o.type : (o.dataType || setType(self.url));

            if (o.timeout) {
                self.timeout = setTimeout(function() {
                    self.abort();
                }, o.timeout);
            }

            function complete(resp) {
                if (o.timeout) {
                    clearTimeout(self.timeout);
                }
                self.timeout = null;
                if (self._erred) {
                    reject(resp);
                } else {
                    resolve(resp);
                }
            }

            function success(resp) {
                resp = (type !== 'jsonp') ? self.request : resp;
                // use global data filter on response text
                var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type),
                    r = filteredResponse;

                try {
                    resp.responseText = r;
                } catch (e) {
                    // can't assign this in IE<=8, just ignore
                }
                /* eslint-disable no-eval */
                if (r) {
                    switch (type) {
                        case 'json':
                            try {
                                resp = win.JSON.parse(r);
                            } catch (err) {
                                return error(resp, 'Could not parse JSON in response', err);
                            }
                            break;
                        case 'js':
                            resp = eval('(' + r + ')');
                            break;
                        case 'html':
                            resp = r;
                            break;
                        case 'xml':
                            resp = resp.responseXML && resp.responseXML.parseError && resp.responseXML.parseError.errorCode && resp.responseXML.parseError.reason ? null : resp.responseXML;
                            break;
                    }
                }
                /* eslint-enable no-eval */
                self._responseArgs.resp = resp;
                complete(resp);
            }

            function error(resp, msg, t) {
                resp = self.request;
                self._responseArgs.resp = resp;
                self._responseArgs.msg = msg;
                self._responseArgs.t = t;
                self._erred = true;
                complete(resp);
            }

            self.request = getRequest.call(self, success, error);
        });

        return self;
    }

    function Ajax(url, options) {

        if (Object.prototype.toString.call(url) === '[object Object]') {
            options = url;
            url = undefined;
        }
        options = options || {};
        options.url = url || options.url;

        var requestPromise = doRequest(options),
            resultPromise = requestPromise.promise;

        if (options.success || options.error || options.complete) {
            resultPromise.then(options.success, options.error);
        }

        resultPromise.abort = requestPromise.abort;

        return resultPromise;
    }

    Ajax.setup = function(options) {
        options = options || {};
        for (var k in options) {
            if (options.hasOwnProperty(k)) {
                globalSetupOptions[k] = options[k];
            }
        }
    };

    Ajax.toQueryString = function(o, trad) {
        var prefix, i,
            traditional = trad || false,
            s = [],
            enc = encodeURIComponent,
            add = function(key, value) {
                // If value is a function, invoke it and return its value
                if (typeof value == 'function') {
                    value = value();
                } else {
                    value = value || '';
                }

                s[s.length] = enc(key) + '=' + enc(value);
            };

        // If an array was passed in, assume that it is an array of form elements.
        if (DG.Util.isArray(o)) {
            for (i = 0; o && i < o.length; i++) {
                add(o[i].name, o[i].value);
            }
        } else {
            // If traditional, encode the "old" way (the way 1.3.2 or older
            // did it), otherwise encode params recursively.
            for (prefix in o) {
                if (o.hasOwnProperty(prefix)) {
                    buildParams(prefix, o[prefix], traditional, add);
                }
            }
        }

        // spaces should be + according to spec
        return s.join('&').replace(/%20/g, '+');
    };

    var testxhr = win[xmlHttpRequest] ? new XMLHttpRequest() : null;

    Ajax.corsSupport = !(!(testxhr && 'withCredentials' in testxhr) && !win[xDomainRequest]) &&
        // cors not available in IE and with cyrillic domain
        !(DG.Browser.ie && document.location.host.toLowerCase().search(/[а-я]/) != -1);

    return Ajax;
})();

DG.Wkt = {};

DG.Wkt.toGeoJSON = function (data) {
    if (DG.Util.isArray(data)) {
        data = data[0];
    }
    var parts = data.split(';');
    data = parts.pop();

    var i = 0,
        srid = (parts.shift() || '').split('=').pop();

    function $(re) {
        var match = data.substring(i).match(re);
        if (!match) {
            return null;
        }
        else {
            i += match[0].length;
            return match[0];
        }
    }

    function crs(obj) {
        if (obj && srid.match(/\d+/)) {
            obj.crs = {
                type: 'name',
                'properties': {
                    name: 'urn:ogc:def:crs:EPSG::' + srid
                }
            };
        }

        return obj;
    }

    function white() { $(/^\s*/); }

    function multicoords() {
        white();
        var depth = 0, rings = [], stack = [rings],
            pointer = rings, elem;
        while (elem =
            $(/^(\()/) ||
            $(/^(\))/) ||
            $(/^(\,)/) ||
            $(/^[-+]?([0-9]*\.[0-9]+|[0-9]+)/)) {
            if (elem === '(') {
                stack.push(pointer);
                pointer = [];
                stack[stack.length - 1].push(pointer);
                depth++;
            } else if (elem === ')') {
                pointer = stack.pop();
                depth--;
                if (depth === 0) {
                    break;
                }
            } else if (elem === ',') {
                pointer = [];
                stack[stack.length - 1].push(pointer);
            } else {
                pointer.push(parseFloat(elem));
            }
            white();
        }
        stack.length = 0;
        if (depth !== 0) {
            return null;
        }
        return rings;
    }

    function coords() {
        var list = [], item, pt;
        while (pt =
            $(/^[-+]?([0-9]*\.[0-9]+|[0-9]+)/) ||
            $(/^(\,)/)) {
            if (pt === ',') {
                list.push(item);
                item = [];
            } else {
                if (!item) {
                    item = [];
                }
                item.push(parseFloat(pt));
            }
            white();
        }
        if (item) {
            list.push(item);
        }
        return list.length ? list : null;
    }

    function point() {
        if (!$(/^(point)/i)) { return null; }
        white();
        if (!$(/^(\()/)) { return null; }
        var c = coords();
        white();
        if (!$(/^(\))/)) { return null; }
        return {
            type: 'Point',
            coordinates: c[0]
        };
    }

    function multipoint() {
        if (!$(/^(multipoint)/i)) { return null; }
        white();
        var c = multicoords();
        white();
        return {
            type: 'MultiPoint',
            coordinates: c
        };
    }

    function multilinestring() {
        if (!$(/^(multilinestring)/i)) { return null; }
        white();
        var c = multicoords();
        white();
        return {
            type: 'MultiLineString',
            coordinates: c
        };
    }

    function linestring() {
        if (!$(/^(linestring)/i)) { return null; }
        white();
        if (!$(/^(\()/)) { return null; }
        var c = coords();
        if (!$(/^(\))/)) { return null; }
        return {
            type: 'LineString',
            coordinates: c
        };
    }

    function polygon() {
        if (!$(/^(polygon)/i)) { return null; }
        white();
        return {
            type: 'Polygon',
            coordinates: multicoords()
        };
    }

    function multipolygon() {
        if (!$(/^(multipolygon)/i)) { return null; }
        white();
        return {
            type: 'MultiPolygon',
            coordinates: multicoords()
        };
    }

    function geometrycollection() {
        var geometries = [], geometry;

        if (!$(/^(geometrycollection)/i)) { return null; }
        white();

        if (!$(/^(\()/)) { return null; }
        while (geometry = root()) {
            geometries.push(geometry);
            white();
            $(/^(\,)/);
            white();
        }
        if (!$(/^(\))/)) { return null; }

        return {
            type: 'GeometryCollection',
            geometries: geometries
        };
    }

    function root() {
        return point() ||
            linestring() ||
            polygon() ||
            multipoint() ||
            multilinestring() ||
            multipolygon() ||
            geometrycollection();
    }

    return crs(root());
};

DG.Wkt.geoJsonLayer = function (data, opts) {
    return DG.geoJson(DG.Wkt.toGeoJSON(data), opts);
};

DG.Wkt._coordsToLatLngs = function (coords) {
    if (DG.Util.isArray(coords) && !DG.Util.isArray(coords[0])) {
        return [DG.GeoJSON.coordsToLatLng(coords)];
    }

    return coords.map(function (el) {
            return DG.Wkt._coordsToLatLngs(el);
        })
        .reduce(function (arr, coord) {
            return arr.concat(coord);
        });
};

DG.Wkt.toLatLngs = function (data) {
    if (!DG.Util.isArray(data)) {
        data = [data];
    }

    return data.map(function (el) {
        var coords = DG.Wkt.toGeoJSON(el).coordinates;

        return DG.Wkt._coordsToLatLngs(coords);
    }).reduce(function (arr, coord) {
        return arr.concat(coord);
    });
};

DG.Wkt.toPoints = function (data) {
    return DG.Wkt.toGeoJSON(data).coordinates;
};

DG.Wkt.pointsToLatLngOnMap = function (wkt, map) {
    return (function parsePoints(points) {
        return (Array.isArray(points) && Array.isArray(points[0])) ?
            points.map(parsePoints) :
            map.containerPointToLatLng(points);
    })(DG.Wkt.toPoints(wkt));
};

DG.ProjectDetector = DG.Handler.extend({
    initialize: function(map) { // (Object)
        this._map = map;
        this._project = undefined;
        this._loadProjectList();
    },

    addHooks: function() {
        this._projectWatch();
        this._map.on('move', this._projectWatch, this);
    },

    removeHooks: function() {
        this._map.off('move', this._projectWatch, this);
    },

    getProject: function() {
        if (!this._project) { return false; }

        return DG.Util.extend({}, this._project);
    },

    getProjectsList: function() {
        return this._projectList.slice(0);
    },

    isProjectHere: function(coords, project, checkMethod) {
        if (!coords) { return null; }

        if (!(coords instanceof DG.LatLng) && !(coords instanceof DG.LatLngBounds)) {
            coords = DG.latLng(coords);
        }

        coords = (coords instanceof DG.LatLngBounds) ?
            DG.latLngBounds(coords.getSouthWest().wrap(), coords.getNorthEast().wrap()) : coords.wrap();

        checkMethod = checkMethod || ((coords instanceof DG.LatLngBounds) ?  'intersects' : 'contains');

        var method = checkMethod == 'intersects' ? this._testProjectIntersects : this._testProjectContains;
        method = method.bind(this, coords);

        if (project) {
            return method(project);
        } else {
            return this._projectList.filter(method)[0];
        }
    },

    _projectWatch: function() {
        if (!this._map._loaded) {
            return;
        }

        if (this._project && this._zoomInProject(this._project) && this._centerInProject(this._project)) {
            return;
        }

        this._searchProject();

        if (this._project) {
            this._map.attributionControl._update(null, this._project.country_code);
        }
    },

    _checkProjectData: function(project) {
        function check(value) {
            return value !== undefined && value !== null;
        }

        return project &&
                project.bounds &&
                check(project.code) &&
                check(project.domain) &&
                check(project.country_code) &&
                check(project.flags) &&
                project.zoom_level &&
                    check(project.zoom_level.min) &&
                    check(project.zoom_level.max) &&
                project.time_zone &&
                    check(project.time_zone.offset);
    },

    _loadProjectList: function() {
        DG.fallbackProjectsList = DG.fallbackProjectsList || [];

        if (!DG.projectsList) {
            DG.projectsList = DG.fallbackProjectsList;
        }
        delete DG.fallbackProjectsList;

        this._projectList = DG.projectsList
            .filter(this._checkProjectData)
            .map(function(project) {
                var bound = DG.Wkt.toGeoJSON(project.bounds);
                var latLngBounds = DG.geoJSON(bound).getBounds();
                var defaultPos = project.default_pos ? DG.latLng(project.default_pos.lat, project.default_pos.lon) : null;


                /* eslint-disable camelcase */
                return {
                    id: project.id,
                    code: project.code,
                    minZoom: project.zoom_level.min,
                    maxZoom: project.zoom_level.max,
                    timeOffset: project.time_zone.offset,
                    bound: bound,
                    latLngBounds: latLngBounds,
                    traffic: !!project.flags.traffic,
                    transport: !!project.flags.public_transport,
                    roads: !!project.flags.road_network,
                    country_code: project.country_code,
                    domain: project.domain,
                    defaultPos: defaultPos
                };
                /* eslint-enable camelcase */
            });
    },

    _searchProject: function() {
        // Вначале отсеиваем регионы по зуму
        var filteredByZoom = this._projectList.filter(this._zoomInProject, this);

        // Находим проект в границы которого попадает центр карты
        var foundProjects = filteredByZoom.filter(this._centerInProject, this);

        // Если такой проект не найден, то ищем проекты баунд боксы которых пересекаются с экраном
        if (foundProjects.length === 0) {
            var mapBounds = this._map.getBounds();
            foundProjects = filteredByZoom.filter(DG.bind(this._testProjectIntersects, this, mapBounds));

            if (foundProjects.length > 1) {
                var mapCenter = this._map.getCenter();
                var neareastProject = foundProjects[0];
                for (var i = 1; i < foundProjects.length; i++) {
                    var currentProject = foundProjects[i];
                    if (currentProject.defaultPos &&
                        mapCenter.distanceTo(neareastProject.defaultPos) >
                        mapCenter.distanceTo(currentProject.defaultPos)
                    ) {
                        neareastProject = currentProject;
                    }
                }
                foundProjects = [neareastProject];
            }
        }

        var newProject = foundProjects[0] || null;

        if (this._project === newProject) {
            return;
        }

        var self = this;

        if (this._project !== null) {
            this._project = null;
            setTimeout(function() {
                self._map.fire('projectleave');
            }, 1);
        }

        if (newProject) {
            this._project = newProject;
            setTimeout(function() {
                self._map.fire('projectchange', {getProject: self.getProject.bind(self)});
            }, 1);
        }
    },

    _testProjectIntersects: function(bounds, project) {
        return project.latLngBounds.intersects(bounds);
    },

    _testProjectContains: function(latlng, project) {
        return DG.PolyUtil.inside([latlng.lng, latlng.lat], project.bound);
    },

    _centerInProject: function(project, checkMethod) {
        return this.isProjectHere(this._map.getCenter(), project, checkMethod);
    },

    _zoomInProject: function(project) {
        return (this._map.getZoom() >= project.minZoom);
    }
});

DG.Map.mergeOptions({
    projectDetector: true
});

DG.Map.addInitHook('addHandler', 'projectDetector', DG.ProjectDetector);

/*
 * Utility functions
 */

DG.Metric = function() {};

/*
 * DG.Metric.Segments class can calculate total pushed segments length and used to shortcut
 * 'get Something by provided Length' calculations (segment's Index, segment's Length, etc...)
 */
DG.Metric.Segments = function() {
    this.length = 0;
};

DG.Metric.Segments.prototype = {
    push: function(len) {
        this[this.length] = this.length > 0 ? this[this.length - 1] + len : len;
        this.length += 1;

        return this;
    },

    getLength: function() {
        return this[this.length - 1];
    },

    getReverse: function() {
        var segments = new DG.Metric.Segments();
        var i = this.length - 1;

        if (i < 0) { return segments; }

        while (i--) {
            segments.push(this[i + 1] - this[i]);
        }

        return segments.push(this[0]);
    },

    getIndex: function(len) {
        var i = this.length - 1;

        if (i < 0) { return i; }

        while (i--) {
            if (this[i] <= len) { break; }
        }

        return i + 1;
    },

    getSegRatio: function(len) {
        var i = this.getIndex(len);
        var sub = i > 0 ? this[i - 1] : 0;

        return (len - sub) / (this[i] - sub);
    },

    getSegLength: function(len) {
        var i = this.getIndex(len);
        var sub = i > 0 ? this[i - 1] : 0;

        return len - sub;
    }
};

/*
 * DG.VertexTransform is a classic 2D matrix transformation class
 *
 * Prototype methods can scale/rotate/translate vertices
 *
 * Static methods do the same but return simple array instances with attached
 * .clone() method which can reconstruct full DG.VertexTransform object
 */

DG.VertexTransform = DG.Class.extend({
    initialize: function(vertices) {
        this._vertices = vertices;

        this._scale = null;
        this._angle = null;
        this._trans = null;
        this._matrix = null;

        this.load();
    },

    load: function() {
        this.vertices = this._vertices.map(function(vertex) { return vertex.clone(); });
        this.vertices.clone = DG.VertexTransform.clone;

        return this;
    },

    save: function() {
        this._vertices = this.vertices.map(function(vertex) { return vertex.clone(); });

        return this;
    },

    setScale: function(scale) {
        this._scale = scale;
        return this;
    },

    getScale: function() {
        return this._scale;
    },

    setAngle: function(angle) {
        this._angle = angle;
        return this;
    },

    getAngle: function() {
        return this._angle;
    },

    setTranslation: function(trans) {
        this._trans = trans;
        return this;
    },

    getTranslation: function() {
        return this._trans;
    },

    setMatrix: function(matrix) {
        this._matrix = matrix;
        return this;
    },

    getMatrix: function() {
        return this._matrix;
    },

    scale: function(scale) {
        var v = this.vertices;
        var i = v.length;

        scale = scale || this._scale || 1;
        while (i--) {
            v[i].x *= scale;
            v[i].y *= scale;
        }

        return this;
    },

    unScale: function(scale) {
        scale = scale || this._scale || 1;      //  Also safeguard against zero scale
        return this.scale(1 / scale);
    },

    rotate: function(angle) {
        var cos = angle ? angle.cos : (this._angle ? this._angle.cos : 1);
        var sin = angle ? angle.sin : (this._angle ? this._angle.sin : 0);
        var v = this.vertices;
        var i = v.length;
        var x, y;

        while (i--) {
            x = v[i].x;
            y = v[i].y;
            v[i].x = x * cos - y * sin;
            v[i].y = x * sin + y * cos;
        }

        return this;
    },

    unRotate: function(angle) {
        var cos = angle ? angle.cos : (this._angle ? this._angle.cos : 1);
        var sin = angle ? angle.sin : (this._angle ? this._angle.sin : 0);

        return this.rotate({cos: cos, sin: -sin});
    },

    translate: function(trans) {
        var dx = trans ? trans.x : (this._trans ? this._trans.x : 0);
        var dy = trans ? trans.y : (this._trans ? this._trans.y : 0);
        var v = this.vertices;
        var i = v.length;

        while (i--) {
            v[i].x += dx;
            v[i].y += dy;
        }

        return this;
    },

    unTranslate: function(trans) {
        var dx = trans ? trans.x : (this._trans ? this._trans.x : 0);
        var dy = trans ? trans.y : (this._trans ? this._trans.y : 0);

        return this.translate({x: -dx, y: -dy});
    },

    transform: function(matrix) {
        var a, b, c, d, dx, dy;
        var v = this.vertices;
        var i = v.length;
        var x, y;

        if (matrix) {
            a = matrix[0]; b = matrix[1]; dx = matrix[2];
            c = matrix[3]; d = matrix[4]; dy = matrix[5];
        } else if (this._matrix) {
            a = this._matrix[0]; b = this._matrix[1]; dx = this._matrix[2];
            c = this._matrix[3]; d = this._matrix[4]; dy = this._matrix[5];
        } else {
            a = 1; b = 0; dx = 0;
            c = 0; d = 1; dy = 0;
        }

        while (i--) {
            x = v[i].x;
            y = v[i].y;
            v[i].x = x * a + y * b + dx;
            v[i].y = x * c + y * d + dy;
        }

        return this;
    },

    statics: {
        scale: function(vt, scale) {
            var v = vt.vertices;
            var result = [];
            var x, y;

            scale = scale || 1;
            for (var i = 0; i < v.length; i++) {
                x = v[i].x * scale;
                y = v[i].y * scale;
                result.push(new DG.Point(x, y));
            }
            result.clone = DG.VertexTransform.clone;

            return result;
        },

        unScale: function(vt, scale) {
            scale = scale || 1;         //  Also safeguard against zero scale
            return DG.VertexTransform.scale(vt, 1 / scale);
        },

        rotate: function(vt, angle) {
            var cos = angle ? angle.cos : 1;
            var sin = angle ? angle.sin : 0;
            var v = vt.vertices;
            var x, y, rx, ry;
            var result = [];

            for (var i = 0; i < v.length; i++) {
                rx = v[i].x;
                ry = v[i].y;
                x = rx * cos - ry * sin;
                y = rx * sin + ry * cos;
                result.push(new DG.Point(x, y));
            }
            result.clone = DG.VertexTransform.clone;

            return result;
        },

        unRotate: function(vt, angle) {
            var cos = angle ? angle.cos : 1;
            var sin = angle ? angle.sin : 0;

            return DG.VertexTransform.rotate(vt, {cos: cos, sin: -sin});
        },

        translate: function(vt, trans) {
            var dx = trans ? trans.x : 0;
            var dy = trans ? trans.y : 0;
            var v = vt.vertices;
            var result = [];
            var x, y;

            for (var i = 0; i < v.length; i++) {
                x = v[i].x + dx;
                y = v[i].y + dy;
                result.push(new DG.Point(x, y));
            }
            result.clone = DG.VertexTransform.clone;

            return result;
        },

        unTranslate: function(vt, trans) {
            var dx = trans ? trans.x : 0;
            var dy = trans ? trans.y : 0;

            return DG.VertexTransform.translate(vt, {x: -dx, y: -dy});
        },

        clone: function() {
            //  'this' is an array
            return new DG.VertexTransform(this).save();
        },

        getLength: function(vec1, vec2) {
            var dx, dy;

            if (typeof vec1 === 'number') {
                //  'vec1' and 'vec2' are absolute coordinates of vector
                return Math.sqrt(vec1 * vec1 + vec2 * vec2);
            } else {
                //  'vec1' and 'vec2' are vector objects
                dx = vec2.x - vec1.x;
                dy = vec2.y - vec1.y;
                return Math.sqrt(dx * dx + dy * dy);
            }
        },

        getScaled: function(vec1, vec2, scale) {
            var dx, dy;

            if (typeof vec1 === 'number') {
                //  'vec1' and 'vec2' are absolute coordinates of vector
                return new DG.Point(vec1 * scale, vec2 * scale);
            } else {
                //  'vec1' and 'vec2' are vector objects
                dx = (vec2.x - vec1.x) * scale;
                dy = (vec2.y - vec1.y) * scale;
                return new DG.Point(vec1.x + dx, vec1.y + dy);
            }
        },

        getAngle: function(vec1, vec2, origin) {
            var l, sp, x1, y1, x2, y2;

            if (typeof vec1 === 'number') {
                //  'vec1' and 'vec2' are absolute coordinates of vector
                l = Math.sqrt(vec1 * vec1 + vec2 * vec2);
                if (l > 0) {
                    return {cos: vec1 / l, sin: vec2 / l};
                } else {
                    return {cos: 1, sin: 0};
                }
            } else {
                //  'vec1' and 'vec2' are vector objects
                x1 = vec1.x; y1 = vec1.y;
                x2 = vec2.x; y2 = vec2.y;
                if (origin) {
                    x1 -= origin.x; y1 -= origin.y;
                    x2 -= origin.x; y2 -= origin.y;
                }
                sp = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2);
                return {
                    cos: (x1 * x2 + y1 * y2) / sp,
                    sin: (x1 * y2 - x2 * y1) / sp
                };
            }
        },

        getAnglesSum: function(angle1, angle2) {
            return {
                cos: angle1.cos * angle2.cos - angle1.sin * angle2.sin,
                sin: angle1.sin * angle2.cos + angle1.cos * angle2.sin
            };
        },

        getAnglesDif: function(angle1, angle2) {
            return {
                cos: angle1.cos * angle2.cos + angle1.sin * angle2.sin,
                sin: angle1.sin * angle2.cos - angle1.cos * angle2.sin
            };
        }
    }
});

/*
 * DG.ArrowPathTransform class is a core of arrow's body calculations
 *
 * General ideas are:
 *      We construct arrow body with stroke points making arcs on outer path turns
 *      Processing is done segment by segment around {0, 0} virtual point
 *          and resulting 'path' finally rotated to it's original map's angle (.fullAngle)
 *      Subset of this vertices lately used in .subPath() calculations which can be used
 *          in animations for ex.
 *
 *  Final translation (see DG.Entrance.Arrow) moves arrow objects to their original positions
 */

DG.ArrowPathTransform = DG.VertexTransform.extend({
    initialize: function(path) {
        //  'path.offset' is initial points offset (-x / +x) to compensate arrow tip length

        //  Skip super initialization as we need only subset of DG.VertexTransform power
        this._lengths = new DG.Metric.Segments();
        this._vertices = [[], []];
        this._drawings = [[], []];
        //  this._arcs = [];    //  initialized in _setPath()

        this._setPath(path);
        this.subPath(1);
    },

    load: function() {
        return this.subPath(1);
    },

    save: function() {
        return this;    //  NoOp
    },

    //  Method constructs new path points with some displacement from original 'path'
    //  Outer corners will be smoothed by arcs (cubic Bézier curves)
    _setPath: function(path) {
        var transform = DG.ArrowPathTransform.transform;
        var vertices = this._vertices;
        var drawings = this._drawings;
        var Point = DG.Point;
        var width = path.width;
        var arcs = [[], [], []];
        var lengths = [];

        var i, x,
            ax, bx, cx,
            angles, angle;

        vertices.push(path.vertices);   //  expect .pop() in final transform
        vertices[0].push(new DG.Point(path.offset, +width));
        vertices[1].push(new DG.Point(path.offset, -width));
        angles = DG.ArrowPathTransform.getAngles(path);

        cx = -path.offset;
        for (i = 0; i < angles.length; i++) {
            x = path.vertices[i + 1].x;
            ax = width * angles[i].cot;

            //  http://pomax.github.io/bezierinfo/#circles_cubic
            //  actual equation is (4/3 * tan(α/4) * radius)
            bx = angles[i].tan * width * 8 / 3;

            //  Next code can be combined by -/+ inversion but for simplicity it is left as is
            if (ax > 0) {
                vertices[0].push(new Point(x + ax,      +width));
                drawings[0].push('L');

                arcs[2].push(1);
                arcs[1].push(vertices[1].length);
                vertices[1].push(new Point(x + ax,      -width));
                vertices[1].push(new Point(x + ax - bx, -width));

                transform(vertices, angles[i], {x: x, y: 0});

                vertices[1].push(new Point(0 - ax + bx, -width));
                vertices[1].push(new Point(0 - ax,      -width));
                drawings[1].push('L', 'C');

                lengths.push(Math.abs(x + ax) - cx); cx = +ax;
            } else {
                vertices[1].push(new Point(x - ax,      -width));
                drawings[1].push('L');

                arcs[2].push(0);
                arcs[0].push(vertices[0].length);
                vertices[0].push(new Point(x - ax,      +width));
                vertices[0].push(new Point(x - ax + bx, +width));

                transform(vertices, angles[i], {x: x, y: 0});

                vertices[0].push(new Point(0 + ax - bx, +width));
                vertices[0].push(new Point(0 + ax,      +width));
                drawings[0].push('L', 'C');

                lengths.push(Math.abs(x - ax) - cx); cx = -ax;
            }
        }

        //  Final segments and tail arc
        ax = path.vertices[i + 1].x;
        bx = width * 4 / 3; // tan(PI/4) = 1

        vertices[0].push(new Point(ax, +width));
        vertices[1].push(new Point(ax, -width));

        vertices[0].push(new Point(ax - bx, +width));
        vertices[1].push(new Point(ax - bx, -width));

        drawings[0].push('L');
        drawings[1].push('L');

        lengths.push(Math.abs(ax) - cx);

        //  Reverse right path
        vertices[1].reverse();
        drawings[1].reverse();

        //  Move vertices into original position (before last translation)
        angle = DG.VertexTransform.getAnglesSum(angles.fullAngle, path.getAngle());
        transform(vertices, angle, vertices.pop()[0]);  //  path.vertices[0]

        //  We need to reconstruct arc's indexes but too many variables already touched, reuse some of them
        ax = vertices[0].length;
        bx = vertices[1].length;
        this._arcs = arcs[2].map(function(i) {
            cx = arcs[i].shift();
            if (i > 0) {
                return new DG.ArcBezier(vertices[1].slice(bx - cx - 4, bx - cx));
            } else {
                return new DG.ArcBezier(vertices[0].slice(cx, cx + 4).reverse());
            }
        }).reverse();

        this._lengths.push(lengths.pop());
        lengths.reverse().forEach(function(l, i) {
            this._lengths.push(this._arcs[i].getLength()).push(l);
        }, this);

        //  Shortcut border cases (0%-length sub-path and full-path)
        this[0] = {
            vertices: [vertices[0][ax - 2], vertices[0][ax - 1], vertices[1][0], vertices[1][1]],
            drawings: ['M', 'C']
        };
        this[1] = {
            vertices: vertices[0].concat(vertices[1]),
            drawings: ['M'].concat(drawings[0], 'C', drawings[1])
        };
    },

    _setAngleAndDisplacement: function(vL, vR) { // Used in DG.ArrowTipTransform.subShape()
        this.angle = DG.VertexTransform.getAngle({x: vL.x - vR.x, y: vL.y - vR.y}, {x: 0, y: 1});
        this.displ = vR.clone();
    },

    subPath: function(pathRatio) {
        pathRatio = pathRatio > 1 ? 1 : pathRatio;

        //  Shortcut border cases (0%-length sub-path and full-path)
        if (pathRatio === 0 || pathRatio === 1) {
            this.vertices = this[pathRatio].vertices.map(function(vertex) { return vertex.clone(); });
            this.drawings = this[pathRatio].drawings;
            this._setAngleAndDisplacement(this.vertices[0], this.vertices[this.vertices.length - 1]);
            return this;
        }

        var getScaled = DG.VertexTransform.getScaled;
        var vertices = this._vertices;
        var drawings = this._drawings;
        var lengths = this._lengths;
        var len = lengths.getLength() * pathRatio;
        var segIndex = lengths.getIndex(len);
        var segRatio = lengths.getSegRatio(len);
        var vertexIndexLeft = vertices[0].length - 2;
        var vertexIndexRight = 1;
        var drawingIndexLeft = drawings[0].length - 1;
        var drawingIndexRight = 0;
        var vertexLeft, vertexRight;
        var arc = 0, aed = 0;

        while (aed++ < segIndex) {
            if (aed % 2 == 1) {
                vertexIndexLeft--;
                drawingIndexLeft--;
                vertexIndexRight++;
                drawingIndexRight++;
            } else {
                if (drawings[0][drawingIndexLeft] === 'C') {
                    vertexIndexLeft -= 3;
                    drawingIndexLeft -= 1;
                } else {
                    vertexIndexRight += 3;
                    drawingIndexRight += 1;
                }
                arc++;
            }
        }

        if (segIndex % 2 == 1) {
            //  One path ends with an arc
            arc = this._arcs[arc];
            if (drawings[0][drawingIndexLeft] === 'C') {
                arc = arc.getCurveBefore(arc.getTbyL(lengths.getSegLength(len)));
                vertexLeft = arc.points[3];
                vertexRight = vertices[1][vertexIndexRight];
                this.vertices = arc.points.slice(1).reverse()
                    .concat(vertices[0].slice(vertexIndexLeft), vertices[1].slice(0, vertexIndexRight + 1))
                    .map(function(vertex) { return vertex.clone(); });
                this.drawings = ['M'].concat(drawings[0].slice(drawingIndexLeft), 'C', drawings[1].slice(0, drawingIndexRight));
            } else {
                arc = arc.getCurveBefore(arc.getTbyL(lengths.getSegLength(len)));
                vertexLeft = vertices[0][vertexIndexLeft];
                vertexRight = arc.points[3];
                this.vertices = vertices[0].slice(vertexIndexLeft)
                    .concat(vertices[1].slice(0, vertexIndexRight + 1), arc.points.slice(1))
                    .map(function(vertex) { return vertex.clone(); });
                this.drawings = ['M'].concat(drawings[0].slice(drawingIndexLeft + 1), 'C', drawings[1].slice(0, drawingIndexRight + 1));
            }
        } else {
            //  Both paths end with lines
            vertexLeft = getScaled(vertices[0][vertexIndexLeft], vertices[0][vertexIndexLeft - 1], segRatio);
            vertexRight = getScaled(vertices[1][vertexIndexRight], vertices[1][vertexIndexRight + 1], segRatio);
            this.vertices = [vertexLeft]
                .concat(vertices[0].slice(vertexIndexLeft), vertices[1].slice(0, vertexIndexRight + 1), vertexRight)
                .map(function(vertex) { return vertex.clone(); });
            this.drawings = ['M'].concat(drawings[0].slice(drawingIndexLeft), 'C', drawings[1].slice(0, drawingIndexRight + 1));
        }

        this._setAngleAndDisplacement(vertexLeft, vertexRight);
        return this;
    },

    statics: {
        getAngles: function(path) {
            var getAngle = DG.VertexTransform.getAngle;
            var fullAngle = {cos: 1, sin: 0};
            var vertices = path.vertices;
            var angles = [];

            var absSin, angle,
                cos, sin, cot, temp, sign;

            for (var i = 1, len = vertices.length - 1; i < len; i++) {
                angle = getAngle(vertices[i - 1], vertices[i + 1], vertices[i]);

                absSin = Math.abs(angle.sin);
                if (absSin < 0.000001) {
                    //  Exclude 180° angle from vertices array
                    vertices.splice(vertices.length - i - 1, 1);
                    len--;
                    i--;
                } else {
                    //  This is half ∢α cotangent, sign describes angle direction and used to shortcut stroke calculations
                    //  '-1' - right angle is inner angle, '1' - left angle is inner angle (if seen from [0, 0] to [-1, 0])
                    angle.cot = (1 + angle.cos) / angle.sin;

                    //  We need to rotate next segment to [-1, 0] axis, so we need complementary angle actually
                    angle.cos = -angle.cos;

                    //  Complimentary angle also used to calculate it's quaternary ∢β tangent
                    //  ∢β tangent used in approximation of outer arc segment by Bézier curve
                    cot = (1 + angle.cos) / angle.sin;
                    sign = cot < 0 ? -1 : 1;
                    temp = sign * Math.sqrt(4 * cot * cot + 4);
                    angle.tan = -0.5 * (cot + cot - temp);

                    angles.push(angle);

                    cos = fullAngle.cos * angle.cos - fullAngle.sin * angle.sin;
                    sin = fullAngle.sin * angle.cos + fullAngle.cos * angle.sin;

                    fullAngle = {cos: cos, sin: sin};
                }
            }

            //  Used in final stroke points translation
            angles.fullAngle =  {cos: fullAngle.cos, sin: -fullAngle.sin};
            return angles;
        },

        //  TODO - if length of 'latlngs' array is less than 2 or it is undefined next function produces exception
        //  check this condition in outer routines?!
        getTranslatedPath: function(map, latlngs) {
            var path = new DG.VertexTransform([]);
            var i = latlngs.length - 1;
            var v = map.project(latlngs[i]);
            var dx = v.x, dy = v.y;

            path.vertices.push(new DG.Point(0, 0));
            while (i--) {
                v = map.project(latlngs[i]);
                path.vertices.push(new DG.Point(v.x - dx, v.y - dy));
            }
            return path
                .setAngle(DG.VertexTransform.getAngle(-path.vertices[1].x, -path.vertices[1].y))
                .unRotate();
        },

        transform: function(rings, angle, vector) {
            var i = rings.length;
            var cos = angle.cos;
            var sin = angle.sin;
            var dx = vector.x;
            var dy = vector.y;
            var ring, x, y, j;

            while (i--) {
                ring = rings[i];
                j = ring.length;
                while (j--) {
                    x = ring[j].x - dx;
                    y = ring[j].y - dy;
                    ring[j].x = x * cos - y * sin;
                    ring[j].y = x * sin + y * cos;
                }
            }
        }
    }
});

/*
 * DG.ArrowTipTransform class is a core of arrow's tip calculations
 *
 * .subShape() routine 'bound' arrow's tip to the ending points of .subPath()
 * calculated separately in DG.ArrowPathTransform
 *
 *  Final translation (see DG.Entrance.Arrow) moves arrow objects to their original positions
 */

DG.ArrowTipTransform = DG.VertexTransform.extend({
    initialize: function(path, shape) {
        this.drawings = shape.drawings; //  static mapping
        this._vertices = shape.vertices;

        this._setShape(path, shape);
    },

    _setShape: function(path, shape) {
        var sp = shape.vertices[0];
        var width = Math.abs(sp.y);
        var pl = path.vertices[1].x;    //  negative value
        var length = sp.x;              //  negative value
        var offset = pl - length + width + width;

        path.width = width;
        path.offset = length + (offset > 0 ? offset : 0);
        if (path.vertices.length < 3 && length > -10) {
            path.offset += 2.5;
        }

        this._vertices = this.load().unTranslate(sp).vertices;
    },

    subShape: function(transform) {
        this.load().unRotate(transform.angle).translate(transform.displ);
        return this;
    }
});

/*
 * DG.ComplexPath is a simple vector layer class with empty .getEvents() object(!)
 * It's drawing logic is maintained in DG.Entrance.Arrow class
 *
 * _pxBounds is a pixel bounds of this drawings and they are used in L.Canvas
 */

DG.ComplexPath = DG.Path.extend({
    options: {
        fill: true,
        fillOpacity: 1,
        interactive: false
    },

    initialize: function(options) {
        DG.setOptions(this, options);

        this._empty = [];

        this._pxEmpty = DG.bounds(
            DG.point(0, 0), DG.point(0, 0)
        );
        this._pxBounds = this._pxEmpty;

        this._vertices = [this._empty];
        this._drawings = [this._empty];
    },

    getEvents: function() {
        return {};
    },

    _project: function() {
        var opts = this.options,
            zoom, weight;

        if (this._map) {
            zoom = this._map.getZoom();
        } else {
            return;
        }

        if (opts.visibility.isShown && opts.transform[zoom]) {
            //  Next numbers was empirically selected in order to provide visual compliance
            //  to the original arrow's implementation
            weight = 2.2 - ((19 - zoom) * 0.2);
            if (opts.weight !== weight) {
                this.setStyle({weight: +weight.toFixed(2)});
            }

            this._vertices[0] = opts.transform[zoom].vertices;
            this._drawings[0] = opts.transform[zoom].drawings;

            this._pxBounds = opts.transform[zoom]._pxBounds;
        } else {
            this._vertices[0] = this._empty;
            this._drawings[0] = this._empty;

            this._pxBounds = this._pxEmpty;
        }
    },

    _update: function() {
        if (this._map) {
            this._updatePath();
        }
    },

    _updatePath: function() {  //  used in Canvas renderer
        this._renderer._updateComplexPath(this);
    }
});

/*
 * Actual painting methods that can draw complex objects with curves
 *
 * Point coordinates must be provided in layer._vertices object
 * And types of line must be provided in layer._drawings object
 */

DG.extend(L.Canvas.prototype, {
    _updateComplexPath: function(layer, closed) {
        var i, j, k, d, x, y, _x, _y, $x, $y, points;
        var drawings = layer._drawings;
        var vertices = layer._vertices;
        var ctx = this._ctx;

        this._drawnLayers[layer._leaflet_id] = layer;

        //  TODO: Do we need to do a 'beginPath()' and possible 'closePath()' per ring?!
        ctx.beginPath();

        for (i = 0; i < vertices.length; i++) {
            points = vertices[i];
            x = y = 0;
            j = k = 0;
            while (j < points.length) {
                d = drawings[i][k++];
                switch (d) {
                    case 'M':
                        x = points[j].x;
                        y = points[j].y;
                        j += 1;
                        ctx.moveTo(x, y);
                        break;

                    case 'm':
                        x += points[j].x;
                        y += points[j].y;
                        j += 1;
                        ctx.moveTo(x, y);
                        break;

                    case 'L':
                        x = points[j].x;
                        y = points[j].y;
                        j += 1;
                        ctx.lineTo(x, y);
                        break;

                    case 'l':
                        x += points[j].x;
                        y += points[j].y;
                        j += 1;
                        ctx.lineTo(x, y);
                        break;

                    case 'C':
                        _x = points[j].x;
                        _y = points[j].y;
                        j += 1;
                        $x = points[j].x;
                        $y = points[j].y;
                        j += 1;
                        x = points[j].x;
                        y = points[j].y;
                        j += 1;
                        ctx.bezierCurveTo(_x, _y, $x, $y, x, y);
                        break;

                    case 'c':
                        _x = x + points[j].x;
                        _y = y + points[j].y;
                        j += 1;
                        $x = x + points[j].x;
                        $y = y + points[j].y;
                        j += 1;
                        x = x + points[j].x;
                        y = y + points[j].y;
                        j += 1;
                        ctx.bezierCurveTo(_x, _y, $x, $y, x, y);
                        break;

                    case 'Q':
                        _x = points[j].x;
                        _y = points[j].y;
                        j += 1;
                        x = points[j].x;
                        y = points[j].y;
                        j += 1;
                        ctx.quadraticCurveTo(_x, _y, x, y);
                        break;

                    case 'q':
                        _x = x + points[j].x;
                        _y = y + points[j].y;
                        j += 1;
                        x = x + points[j].x;
                        y = y + points[j].y;
                        j += 1;
                        ctx.quadraticCurveTo(_x, _y, x, y);
                        break;
                }
            }
            if (closed) {
                ctx.closePath();
            }
        }

        this._fillStroke(ctx, layer);
    }
});


DG.extend(L.SVG.prototype, {
    _updateComplexPath: function(layer, closed) {
        this._setPath(layer, L.SVG.complexPointsToPath(layer._vertices, layer._drawings, closed));
    }
});


DG.extend(L.SVG, {
    complexPointsToPath: function(vertices, drawings, closed) {
        var str = '';
        var svg = DG.Browser.svg;
        var i, j, k, n, d, points;

        for (i = 0; i < vertices.length; i++) {
            points = vertices[i];

            //  Speedup hot path by removing if/ternary condition checks but duplicating loops
            if (svg) {
                j = k = 0;
                while (j < points.length) {
                    d = drawings[i][k++];
                    switch (d) {
                        case 'C':
                        case 'c':   n = 3; break;
                        case 'Q':
                        case 'q':   n = 2; break;

                        default:    n = 1;  //  'M', 'm', 'L', 'l', ...
                    }
                    str += d;
                    while (n--) {
                        str += points[j].x.toFixed(4) + ',' + points[j].y.toFixed(4) + ' ';
                        j += 1;
                    }
                }
            } else {
                //  vml in IE8 can support only integer values in 'path', sorry about loss of precision
                j = k = 0;
                while (j < points.length) {
                    d = drawings[i][k++];
                    switch (d) {
                        case 'M':   d = 'm'; n = 1; break;
                        case 'm':   d = 't'; n = 1; break;
                        case 'L':   d = 'l'; n = 1; break;
                        case 'l':   d = 'r'; n = 1; break;
                        case 'C':   d = 'c'; n = 3; break;
                        case 'c':   d = 'v'; n = 3; break;
                        case 'Q':
                            //  VML spec has 'qb' command in 'v' attribute string but no 'relativeTo' compliment
                            //  So we'll emulate Cubic Bézier curve by applying Quadratic variant in both cases
                            //  TODO: Both control points will use the same value but this is not true solution
                            str += 'C' +
                                points[j].x.toFixed(0) + ',' + points[j].y.toFixed(0) + ' ' +
                                points[j].x.toFixed(0) + ',' + points[j].y.toFixed(0) + ' ' +
                                points[j + 1].x.toFixed(0) + ',' + points[j + 1].y.toFixed(0) + ' ';
                            j += 2;
                            d = '';
                            n = 0;
                            break;
                        case 'q':
                            str += 'c' +
                                points[j].x.toFixed(0) + ',' + points[j].y.toFixed(0) + ' ' +
                                points[j].x.toFixed(0) + ',' + points[j].y.toFixed(0) + ' ' +
                                points[j + 1].x.toFixed(0) + ',' + points[j + 1].y.toFixed(0) + ' ';
                            j += 2;
                            d = '';
                            n = 0;
                            break;

                        default:    n = 1;
                    }
                    str += d;
                    while (n--) {
                        str += points[j].x.toFixed(0) + ',' + points[j].y.toFixed(0) + ' ';
                        j += 1;
                    }
                }
            }

            str += closed ? (svg ? 'z' : 'x') : '';
        }

        // SVG complains about empty path strings
        return str || 'm0,0';
    }
});

/*
 * DGBezierCurves is a collection of three classes:
 * Original DG.Bezier class provides basic math for Cubic and Quadratic Bézier curves
 * DG.TimeBezier used in animation effects it can return 'Distance' (Y) by Time (X) value
 * DG.ArcBezier can return 't' value by curve's segment length
 * Actual calculations can be very hard (in math terms) so we use LUT's to optimize them
 *
 * Original ideas come from this source:   https://pomax.github.io/bezierinfo/
 */

DG.Bezier = DG.Class.extend({
    /**
     * Initialize curve object by provided control points
     * @param {Array<DG.Point>} coords Curve's control points in DG.Point format (up to four control points supported)
     * @param {boolean} [clone] Clone original points or not (Default)
     */
    initialize: function(coords, clone) {
        if (clone) {
            this.points = coords.map(function(coord) { return coord.clone(); });
        } else {
            this.points = coords;
        }
        this.dpoints = this._getDerivatives();
        this.order = this.points.length - 1;
        this._lut = [];
    },

    getPoint: function(t) {
        var p = this.points;
        var mt, mt2, t2;
        var a, b, c, d;

        if (t === 0) { return p[0]; }
        if (t === 1) { return p[this.order]; }

        mt = 1 - t;
        mt2 = mt * mt;
        t2 = t * t;

        if (this.order > 2) {
            a = mt2 * mt;
            b = mt2 * t * 3;
            c = mt * t2 * 3;
            d = t * t2;
        } else {
            p = [p[0], p[1], p[2], {x: 0, y: 0}];
            a = mt2;
            b = mt * t * 2;
            c = t2;
            d = 0;
        }

        return new DG.Point(
            a * p[0].x + b * p[1].x + c * p[2].x + d * p[3].x,
            a * p[0].y + b * p[1].y + c * p[2].y + d * p[3].y
        );
    },

    derivative: function(t) {
        var p = this.dpoints[0];
        var mt = 1 - t;
        var a, b, c;

        if (this.order > 2) {
            a = mt * mt;
            b = mt * t * 2;
            c = t * t;
        } else {
            p = [p[0], p[1], {x: 0, y: 0}];
            a = mt; b = t; c = 0;
        }

        return new DG.Point(
            a * p[0].x + b * p[1].x + c * p[2].x,
            a * p[0].y + b * p[1].y + c * p[2].y
        );
    },

    getLength: function() {
        /* eslint-disable camelcase */
        var w_i = DG.Bezier.WEIGHT;
        var x_i = DG.Bezier.ABSCISSA;
        var z = 0.5;
        var sum = 0;
        var d, l, t;

        for (var i = 0; i < x_i.length; i++) {
            t = z * x_i[i] + z;
            d = this.derivative(t);
            l = d.x * d.x + d.y * d.y;
            sum += w_i[i] * Math.sqrt(l);
        }
        /* eslint-enable camelcase */

        return z * sum;
    },

    getCurveBefore: function(z) {
        var p = this.points;
        var z2, z3, mz, mz2, mz3;
        var b$3, b$4, c$4;
        var curve;

        if (z === 1) { return this.clone(); }

        curve = [];
        z2 = z * z;
        mz = z - 1;
        mz2 = mz * mz;

        curve[0] = new DG.Point(
            p[0].x,
            p[0].y
        );

        curve[1] = new DG.Point(
            z * p[1].x - mz * p[0].x,
            z * p[1].y - mz * p[0].y
        );

        b$3 = z * mz * 2;
        curve[2] = new DG.Point(
            z2 * p[2].x - b$3 * p[1].x + mz2 * p[0].x,
            z2 * p[2].y - b$3 * p[1].y + mz2 * p[0].y
        );

        if (this.order > 2) {
            z3 = z2 * z;
            mz3 = mz2 * mz;
            b$4 = z2 * mz * 3;
            c$4 = z * mz2 * 3;
            curve[3] = new DG.Point(
                z3 * p[3].x - b$4 * p[2].x + c$4 * p[1].x - mz3 * p[0].x,
                z3 * p[3].y - b$4 * p[2].y + c$4 * p[1].y - mz3 * p[0].y
            );
        }

        return new DG.Bezier(curve);
    },

    getCurveAfter: function(z) {
        var p = this.points;
        var n = this.order;
        var z2, z3, mz, mz2, mz3;
        var b$3, b$4, c$4;
        var curve;

        if (z === 1) { return this.clone(); }

        curve = [];
        z2 = z * z;
        mz = z - 1;
        mz2 = mz * mz;

        curve[n] = new DG.Point(
            p[n].x,
            p[n].y
        );

        curve[--n] = new DG.Point(
            z * p[n + 1].x - mz * p[n].x,
            z * p[n + 1].y - mz * p[n].y
        );

        b$3 = z * mz * 2;
        curve[--n] = new DG.Point(
            z2 * p[n + 2].x - b$3 * p[n + 1].x + mz2 * p[n].x,
            z2 * p[n + 2].y - b$3 * p[n + 1].y + mz2 * p[n].y
        );

        if (this.order > 2) {
            z3 = z2 * z;
            mz3 = mz2 * mz;
            b$4 = z2 * mz * 3;
            c$4 = z * mz2 * 3;
            curve[--n] = new DG.Point(
                z3 * p[n + 3].x - b$4 * p[n + 2].x + c$4 * p[n + 1].x - mz3 * p[n].x,
                z3 * p[n + 3].y - b$4 * p[n + 2].y + c$4 * p[n + 1].y - mz3 * p[n].y
            );
        }

        return new DG.Bezier(curve);
    },

    _getDerivatives: function() {
        var p = this.points;
        var d, c, j, list;
        var result = [];

        for (d = p.length, c = d - 1; d > 1; d--, c--) {
            list = [];
            for (j = 0; j < c; j++) {
                list.push(new DG.Point(
                    c * (p[j + 1].x - p[j].x),
                    c * (p[j + 1].y - p[j].y)
                ));
            }
            result.push(list);
            p = list;
        }

        return result;
    },

    getLUT: function(steps) {
        steps = steps || 125;

        if (this._lut.length !== steps + 1) {
            if (this.order > 2) {
                this._setLUT3(steps);
            } else {
                this._setLUT2(steps);
            }
        }

        return this._lut;
    },

    _setLUT2: function(steps) {
        var lut = this._lut = [];
        var p = this.points;
        var t, mt;
        var a, b, c;

        lut.push({x: p[0].x, y: p[0].y, l: 0});
        for (var s = 1; s < steps; s++) {
            t = s / steps;
            mt = 1 - t;
            a = mt * mt;
            b = mt * t * 2;
            c = t * t;
            lut.push({
                x: a * p[0].x + b * p[1].x + c * p[2].x,
                y: a * p[0].y + b * p[1].y + c * p[2].y
            });
        }
        lut.push({x: p[2].x, y: p[2].y, l: 0});
    },

    _setLUT3: function(steps) {
        var lut = this._lut = [];
        var p = this.points;
        var t, t2, mt, mt2;
        var a, b, c, d;

        lut.push({x: p[0].x, y: p[0].y, l: 0});
        for (var s = 1; s < steps; s++) {
            t = s / steps;
            mt = 1 - t;
            mt2 = mt * mt;
            t2 = t * t;
            a = mt2 * mt;
            b = mt2 * t * 3;
            c = mt * t2 * 3;
            d = t * t2;
            lut.push({
                x: a * p[0].x + b * p[1].x + c * p[2].x + d * p[3].x,
                y: a * p[0].y + b * p[1].y + c * p[2].y + d * p[3].y
            });
        }
        lut.push({x: p[3].x, y: p[3].y, l: 0});
    },

    clone: function() {
        return new DG.Bezier(this.points, true);
    }
});

DG.bezier = function(coords) {
    if (typeof coords === 'number' || coords instanceof DG.Point) {
        coords = Array.prototype.slice.call(arguments);
    }

    if (typeof coords[0] === 'number') {
        if (coords.length < 7) {
            coords = [
                new DG.Point(coords[0], coords[1]),
                new DG.Point(coords[2], coords[3]),
                new DG.Point(coords[4], coords[5])
            ];
        } else {
            coords = [
                new DG.Point(coords[0], coords[1]),
                new DG.Point(coords[2], coords[3]),
                new DG.Point(coords[4], coords[5]),
                new DG.Point(coords[6], coords[7])
            ];
        }
        return new DG.Bezier(coords);
    } else {
        return new DG.Bezier(coords, true);
    }
};

/* eslint-disable indent */
DG.Bezier.WEIGHT = [
    0.3626837833783620,
    0.3626837833783620,
    0.3137066458778873,
    0.3137066458778873,
    0.2223810344533745,
    0.2223810344533745,
    0.1012285362903763,
    0.1012285362903763
];
DG.Bezier.ABSCISSA = [
   -0.1834346424956498,
    0.1834346424956498,
   -0.5255324099163290,
    0.5255324099163290,
   -0.7966664774136267,
    0.7966664774136267,
   -0.9602898564975363,
    0.9602898564975363
];
/* eslint-enable indent */


//  This curve is monotonically ordered by 'X' coordinate and has P[0] = {0, 0} and P[3] = {1, 1}
//  We can utilize this facts to shortcut calculations
DG.TimeBezier = DG.Bezier.extend({
    initialize: function(controlPoint1, controlPoint2, clone) {
        DG.Bezier.prototype.initialize.call(
            this,
            [DG.TimeBezier.START, controlPoint1, controlPoint2, DG.TimeBezier.END],
            clone
        );
    },

    getYbyX: function(x) {
        var lut = this.getLUT();
        var max = lut.length - 1;
        var min = 0;
        var mid;

        if (x <= 0) { return 0; }
        if (x >= 1) { return 1; }

        //  'X' is monotonically increasing so we can do a simple binary search (LUT)
        //  and then fine-tune the result by linear interpolation assuming 'Y' is not changed so radically
        while (true) {
            mid = min + (max - min >> 1);
            if (x < lut[mid].x) {
                max = mid;
            } else {
                min = mid;
            }
            if (max - min < 2) { break; }
        }
        x = (x - lut[min].x) / (lut[max].x - lut[min].x);

        return (lut[min].y + (lut[max].y - lut[min].y) * x);
    },

    getLUT: function(steps) {
        var p = this.points;
        var t, t2, mt;
        var b, c, d;
        var lut;

        steps = steps || 240;
        if (this._lut.length === steps + 1) {
            return this._lut;
        } else {
            this._lut = lut = [];
        }

        lut.push({x: 0, y: 0});
        for (var s = 1; s < steps; s++) {
            t = s / steps;
            mt = 1 - t;
            t2 = t * t;
            //  We don't need 'a' coefficient because p[0] is {0, 0}
            b = mt * mt * t * 3;
            c = mt * t2 * 3;
            d = t * t2;
            lut.push({
                x: b * p[1].x + c * p[2].x + d,
                y: b * p[1].y + c * p[2].y + d
            });
        }
        lut.push({x: 1, y: 1});

        return lut;
    },

    clone: function() {
        return new DG.TimeBezier(this.points, true);
    }
});

DG.TimeBezier.START = DG.point(0, 0);
DG.TimeBezier.END = DG.point(1, 1);


//  This is cubic Bezier describing circular arc
DG.ArcBezier = DG.Bezier.extend({
    initialize: function(coords, clone) {
        DG.Bezier.prototype.initialize.call(this, coords, clone);
        this.getLUT();
        this._setLutLengths();
    },

    getTbyL: function(l) {
        var lut = this.getLUT();
        var max = lut.length - 1;
        var min = 0;
        var mid;
        var x, y;

        if (l <= 0) { return 0; }
        if (l >= lut[max].l) { return 1; }

        //  'L' is monotonically increasing so we can do a binary search (LUT)
        //  and then fine-tune the result by linear interpolation
        while (true) {
            mid = min + (max - min >> 1);
            if (l < lut[mid].l) {
                max = mid;
            } else {
                min = mid;
            }
            if (max - min < 2) { break; }
        }
        l = (l - lut[min].l) / (lut[max].l - lut[min].l);

        x = (lut[min].x + (lut[max].x - lut[min].x) * l);
        y = (lut[min].y + (lut[max].y - lut[min].y) * l);

        //  BUT this is a part of story, we need a projection of this point to the actual curve and it's reverse 't' val
        var p, dx, dy, t;
        var et = max / lut.length;
        var dt = min / lut.length;
        var s = 1 / lut.length / 10;    //  TODO
        var d = Math.pow(2, 53) - 1;

        for (t = dt; dt < et; dt += s) {
            p = this.getPoint(dt);
            dx = p.x - x; dy = p.y - y;
            l = Math.sqrt(dx * dx + dy * dy);
            if (l < d) {
                d = l;
                t = dt;
            }
        }

        return t;
    },

    _setLutLengths: function() {
        var lut = this._lut;
        var dx, dy;

        lut[0].l = 0;
        for (var i = 1; i < lut.length; i++) {
            dx = lut[i].x - lut[i - 1].x;
            dy = lut[i].y - lut[i - 1].y;
            lut[i].l = lut[i - 1].l + Math.sqrt(dx * dx + dy * dy);
        }
    },

    getLength: function() {
        return this._lut[this._lut.length - 1].l;
    },

    clone: function() {
        return new DG.ArcBezier(this.points, true);
    }
});

/*
 * DG.Animation provides tick (step) logic returning progression values
 * calculated over provided or custom Bézier curves
 * Original input can be array object btw...
 */

DG.Animation = DG.Evented.extend({
    options: {
        // animation: {    //  Or array of objects
        //     function: DG.Animation.EASE,
        //     duration: 2000,
        //     frames: null
        // }

        //offset: 0
        //repeat: 0
    },

    initialize: function(options) {
        DG.setOptions(this, options);

        this._animID = -1;
        this._startTime = 0;
        this._running = false;
        this._animation = null;
        this._durations = null;
    },

    start: function() {
        this.stop();
        this._prepare();

        this._running = true;

        this.fire('start');

        //  Date.now(), but... IE9+
        this._startTime = new Date().getTime();

        this._animate();
    },

    stop: function() {
        if (this._running) {
            this._run(this._durations.getLength());
        }
    },

    _prepare: function() {
        this._animation = DG.Util.isArray(this.options.animation) ? this.options.animation : [this.options.animation];

        this._durations = new DG.Metric.Segments();
        this._animation.forEach(function(animation) {
            this.push(animation.duration);
        }, this._durations);
    },

    _animate: function() {
        this._animID = DG.Util.requestAnimFrame(this._animate, this);
        this._run();
    },

    _run: function(elapsed) {
        var el, index, progress;
        //  Possible skip zero delta time but who cares?!
        elapsed = elapsed ? elapsed : new Date().getTime() - this._startTime;

        if (elapsed < this._durations.getLength()) {
            index = this._durations.getIndex(elapsed);
            el = this._durations.getSegRatio(elapsed);
            progress = this._animation[index]['function'].getYbyX(el);
            this._step(this._getFrameValues(index, progress));
        } else {
            index = this._durations.length - 1;
            this._step(this._getFrameValues(index, 1));
            this._complete();
        }
    },

    _step: function(obj) {
        this.fire('step', obj);
    },

    _complete: function() {
        DG.Util.cancelAnimFrame(this._animID);

        this._durations = null;
        this._animation = null;
        this._running = false;
        this.fire('end');
    },

    _getFrameValues: function(index, progress) {
        var frames = this._animation[index].frames;
        var obj = {progress: progress};
        var fr, to;

        if (frames) {
            for (var key in frames) {
                if (frames[key].progress) {
                    obj[key] = frames[key].progress(progress);
                } else {
                    fr = frames[key].from;
                    to = frames[key].to;
                    obj[key] = fr + (to - fr) * progress;
                }
            }
        }
        return obj;
    }
});

DG.animation = function(options) {
    return new DG.Animation(options);
};

DG.Animation.LINEAR         = new DG.TimeBezier(DG.point(0.00, 0.0), DG.point(1.00, 1.0));
DG.Animation.EASE           = new DG.TimeBezier(DG.point(0.25, 0.1), DG.point(0.25, 1.0));
DG.Animation.EASE_IN        = new DG.TimeBezier(DG.point(0.42, 0.0), DG.point(1.00, 1.0));
DG.Animation.EASE_IN_OUT    = new DG.TimeBezier(DG.point(0.42, 0.0), DG.point(0.58, 1.0));
DG.Animation.EASE_OUT       = new DG.TimeBezier(DG.point(0.00, 0.0), DG.point(0.58, 1.0));

/*
 * DG.Entrance is a main class that hosts actual arrow layers
 * It orchestrates animation and provides user space methods like .show() and .hide()
 */

DG.Entrance = DG.FeatureGroup.extend({

    options: {
        vectors: [],

        fillColor: '#0085a0',
        strokeColor: '#fff',

        enableAnimation: true,
        interactive: false,

        autoClose: true
    },

    initialize: function(options) {
        DG.LayerGroup.prototype.initialize.call(this);

        DG.setOptions(this, options);

        this._bounds =
            new DG.LatLngBounds();
        this._animations = {
            bounce: DG.animation(DG.Entrance.BOUNCE_ANIMATION),
            path: DG.animation(DG.Entrance.PATH_ANIMATION)
        };

        this._initArrows();

        this._isShown = false;
    },

    onAdd: function(map) {
        DG.LayerGroup.prototype.onAdd.call(this, map);
        this.show();
    },

    onRemove: function(map) {
        this.hide();
        DG.LayerGroup.prototype.onRemove.call(this, map);
    },

    getEvents: function() {
        var events = {};

        if (this.options.autoClose) {
            events['layeradd'] = this._removeEntrance;  //  eslint-disable-line dot-notation
        }
        if (this.options.enableAnimation) {
            events['zoomend'] = this._animate;          //  eslint-disable-line dot-notation
        }

        return events;
    },

    show: function(fitBounds) {
        if (this._layers) {
            if (fitBounds) {
                this.fitBounds();
            }
            if (!this._isShown) {
                this._isShown = true;
                this.eachLayer(function(arrow) {
                    arrow.setVisibility(true);
                });
                if (this.options.enableAnimation) {
                    this._animate();
                }
                this._map.fire('entranceshow');
            }
        }

        return this;
    },

    hide: function() {
        if (this._layers && this._isShown) {
            this._isShown = false;
            this.eachLayer(function(arrow) {
                arrow.setVisibility(false);
            });
            this._map.fire('entrancehide');
        }

        return this;
    },

    isShown: function() {
        return this._isShown;
    },

    getBounds: function() {
        return this._bounds;
    },

    setFillColor: function(color) {
        this.eachLayer(function(arrow) {
            arrow.setStyle({fillColor: color});
        });
    },

    setStrokeColor: function(color) {
        this.eachLayer(function(arrow) {
            arrow.setStyle({color: color});
        });
    },

    _initArrows: function() {
        var base = {
            color: this.options.strokeColor,
            fillColor: this.options.fillColor,
            interactive: this.options.interactive
        };

        this.options.vectors
            .map(function(vector) {
                return DG.Wkt.toLatLngs(vector);
            })
            .forEach(function(latlngs) {
                var options = DG.Util.create(base),
                    bounds = DG.latLngBounds(latlngs);

                this._bounds.extend(bounds);

                options.latlngs = latlngs;
                options.bounds = bounds;
                if (this.options.enableAnimation) {
                    if (latlngs.length > 2) {
                        options.animation = this._animations.path;
                    } else {
                        options.animation = this._animations.bounce;
                        options.distance = true;
                    }
                }

                this.addLayer(DG.entrance.arrow(options));
            }, this);
    },


    _animate: function() {
        if (this._isShown) {
            this._animations.bounce.start();
            this._animations.path.start();
        }
    },

    //  Current logic of next four methods extracted from original arrow's implementation
    fitBounds: function() {
        var map = this._map, fitZoom,
            bounds = this.getBounds();

        if (!map.getBounds().contains(bounds) || !this._isAllowedZoom()) {
            fitZoom = this._getFitZoom();
            if (!map.projectDetector.getProject()) {
                map.once('moveend', function() {
                    map.setZoom(this._getFitZoom());
                }, this);
            }
            map.setView(bounds.getCenter(), fitZoom, {animate: true});
        }

        return this;
    },

    _getFitZoom: function() {
        var project = this._map.projectDetector.getProject();
        return project ? project.maxZoom : DG.Entrance.SHOW_FROM_ZOOM;
    },

    _isAllowedZoom: function() {
        return this._map.getZoom() >= DG.Entrance.SHOW_FROM_ZOOM;
    },

    _removeEntrance: function(e) {
        if (e.layer instanceof DG.Popup ||
            (e.layer instanceof DG.Entrance && e.layer !== this)) {

            this.remove();
        }
    }
});

DG.entrance = function(options) {
    return new DG.Entrance(options);
};

DG.Entrance.SHOW_FROM_ZOOM = 16;
DG.Entrance.PATH_ANIMATION = {
    animation: {
        'function': DG.Animation.EASE_IN_OUT,
        'duration': 750
    }
};
DG.Entrance.BOUNCE_ANIMATION = {
    animation: [
        {'function': DG.Animation.EASE_IN_OUT, 'duration': 250, 'frames': {'distance': {'from': 0, 'to': 0.6}}},
        {'function': DG.Animation.EASE_IN, 'duration': 135, 'frames': {'distance': {'from': 0.6, 'to': 0}}},
        {'function': DG.Animation.EASE_OUT, 'duration': 135, 'frames': {'distance': {'from': 0, 'to': 0.16}}},
        {'function': DG.Animation.EASE_IN, 'duration': 90, 'frames': {'distance': {'from': 0.16, 'to': 0}}},
        {'function': DG.Animation.EASE_OUT, 'duration': 90, 'frames': {'distance': {'from': 0, 'to': 0.06}}},
        {'function': DG.Animation.EASE_IN, 'duration': 50, 'frames': {'distance': {'from': 0.06, 'to': 0}}}
    ]
};

/*
 * DG.Entrance.Arrow class hosts two layers, one for arrow body (path) and one for arrow tip
 * It overrides projection events from hosted layers to minimize total overhead
 * Actual calculations produced in DG.ArrowPathTransform and DG.ArrowTipTransform classes
 */

DG.Entrance.Arrow = DG.FeatureGroup.extend({
    initialize: function(options) {
        DG.LayerGroup.prototype.initialize.call(this);

        DG.setOptions(this, options);

        this._progress = 1;
        this._distance = 0;
        this._visibility = {
            isShown: false
        };
        this._position =
            options.latlngs[options.latlngs.length - 1];
        this._shape =
            this.options.shape ||
            DG.Entrance.Arrow.SHAPE;

        this._apt = {}; // DG.ArrowPathTransform objects by zoom levels
        this._att = {}; // DG.ArrowTipTransform objects by zoom levels
    },

    beforeAdd: function(map) {
        //  this._map is not initialized yet, so we can freely addLayer(s)
        var opts = this.options;

        //  TODO: Check Canvas processing order
        //  Additional logic to DISABLE animation on Canvas for now!
        if (opts.animation && !map.options.preferCanvas && !DG.Browser.ielt9) {
            opts.animation.on('step', this._animation, this);
        } else {
            opts.animation = null;
        }

        this.projection();

        this.addLayer(new DG.ComplexPath({
            lineCap: 'butt',
            color: opts.color,
            fillColor: opts.fillColor,
            interactive: opts.interactive,
            visibility: this._visibility,
            transform: this._apt
        }));

        this.addLayer(new DG.ComplexPath({
            lineJoin: 'miter',
            color: opts.color,
            fillColor: opts.fillColor,
            interactive: opts.interactive,
            visibility: this._visibility,
            transform: this._att
        }));
    },

    getEvents: function() {
        return {
            zoomend: this._project,
            moveend: this._update,
            viewreset: this._reset
        };
    },

    setVisibility: function(isShown) {
        if (this._visibility.isShown !== isShown) {
            this._visibility.isShown = isShown;
            if (isShown) {
                if (!this.options.animation) {
                    this._reset();
                }
            } else {
                this._reset();
            }
        }
    },

    getBounds: function() {
        return this.options.bounds;
    },

    projection: function() {
        var map = this._map || this._mapToAdd;
        var zoom = map ? map.getZoom() : 0;
        var vertices = this._shape.vertices[zoom];
        var drawings = this._shape.drawings[zoom];
        var latlngs = this.options.latlngs;
        var shape, path, lastPoint, prevPoint;

        if (zoom && vertices && drawings) {
            if (!this._att[zoom]) {
                path = DG.ArrowPathTransform.getTranslatedPath(map, latlngs);
                shape = {vertices: vertices, drawings: drawings};
                this._att[zoom] = new DG.ArrowTipTransform(path, shape);
                this._apt[zoom] = new DG.ArrowPathTransform(path);
            }

            lastPoint = map.latLngToLayerPoint(this._position);
            prevPoint = map.latLngToLayerPoint(latlngs[latlngs.length - 2]);
            if (!this._apt[zoom]._pxBounds) {
                //  One-time action per 'viewreset' event
                //  Caching _pxBounds for using with Canvas renderer
                this._setBounds(lastPoint, prevPoint, this._apt[zoom], this._att[zoom]);
            }
            if (this.options.distance) {
                //  Arrow position recalculated for Bounce animation effect
                lastPoint = DG.VertexTransform.getScaled(lastPoint, prevPoint, this._distance);
            }

            //  Main calculations
            //  Get part of the arrow path and move (bound) arrow tip to it
            this._apt[zoom].subPath(this._progress).translate(lastPoint);
            this._att[zoom].subShape(this._apt[zoom]).translate(lastPoint);
        }

        return this;
    },

    _animation: function(e) {
        if (e.distance != undefined) {
            this._distance = e.distance;    //  bounce animation effect
        } else {
            this._progress = e.progress;    //  path animation effect
        }
        if (this._visibility.isShown) {
            //  TODO: Additional logic for animation on Canvas
            // this.projection().invoke('redraw');

            this._project();
            this._update();
        }
    },

    _project: function() {
        this.projection().invoke('_project');
    },

    _update: function() {
        this.invoke('_update');
    },

    _reset: function() {
        this._resetBounds();

        this._project();
        this._update();
    },

    _resetBounds: function() {
        //  Canvas renderer specific
        var z;

        for (z in this._apt) {
            this._apt[z]._pxBounds = null;
        }

        for (z in this._att) {
            this._att[z]._pxBounds = null;
        }
    },

    _setBounds: function(pl, pp, apt, att) {
        var _apt = apt.subPath(1).translate(pl).vertices,
            _att = att.subShape(apt).translate(pl).vertices;

        //  TODO: Additional logic for animation on Canvas
        // if (this.options.distance) {
        //     pl = DG.VertexTransform.getScaled(pl, pp, 1);
        //     _apt = _apt.concat(apt.subPath(1).translate(pl).vertices);
        //     _att = _att.concat(att.subShape(apt).translate(pl).vertices);
        // }

        apt._pxBounds = new DG.Bounds(_apt);
        att._pxBounds = new DG.Bounds(_att);
    }
});

DG.entrance.arrow = function(options) {
    return new DG.Entrance.Arrow(options);
};

/*
 * Predefined arrow tips
 */

/* eslint-disable array-bracket-spacing */
DG.Entrance.Arrow.SHAPE = {
    vertices: {
        16: [
            [ -6.5000,  -1.8000],
            [ -6.0522,  -1.8000],
            [ -7.0975,  -5.2537],
            [ -6.6619,  -6.2565], [ -6.5980,  -6.3550], [ -6.1757,  -6.1470],
            [  0.8371,  -0.3552],
            [  0.9275,  -0.1764], [  0.9275,   0.1764], [  0.8371,   0.3552],
            [ -6.1757,   6.1470],
            [ -6.5980,   6.3550], [ -6.6619,   6.2565], [ -7.0975,   5.2537],
            [ -6.0522,   1.8000],
            [ -6.5000,   1.8000]
        ],
        17: [
            [ -9.0000,  -2.4000],
            [ -7.8890,  -2.4000],
            [ -9.9245,  -7.2548],
            [ -9.3363,  -8.6404], [ -9.3448,  -8.6448], [ -8.8717,  -8.3508],
            [  1.0285,  -0.3552],
            [  1.1190,  -0.1764], [  1.1190,   0.1764], [  1.0285,   0.3552],
            [ -8.8717,   8.3508],
            [ -9.3448,   8.6448], [ -9.3363,   8.6404], [ -9.9245,   7.2548],
            [ -7.8890,   2.4000],
            [ -9.0000,   2.4000]
        ],
        18: [
            [-11.5000,  -3.0000],
            [-10.0795,  -3.0000],
            [-12.4909,  -9.3173],
            [-11.8402, -10.7654], [-11.5986, -10.7073], [-10.9380, -10.2258],
            [  1.1497,  -0.3552],
            [  1.2402,  -0.1764], [  1.2402,   0.1764], [  1.1497,   0.3552],
            [-10.9380,  10.2258],
            [-11.5986,  10.7073], [-11.8402,  10.7654], [-12.4909,   9.3173],
            [-10.0795,   3.0000],
            [-11.5000,   3.0000]
        ],
        19: [
            [-13.0000,  -3.6000],
            [-11.6600,  -3.6000],
            [-14.1696, -10.8351],
            [-13.5189, -12.2832], [-13.2773, -12.2251], [-12.6167, -11.7436],
            [  1.3061,  -0.3552],
            [  1.3966,  -0.1764], [  1.3966,   0.1764], [  1.3061,   0.3552],
            [-12.6167,  11.7436],
            [-13.2773,  12.2251], [-13.5189,  12.2832], [-14.1696,  10.8351],
            [-11.6600,   3.6000],
            [-13.0000,   3.6000]
        ]
    },
    drawings: {
        16: ['M', 'L', 'L', 'C', 'L', 'C', 'L', 'C', 'L', 'L'],
        17: ['M', 'L', 'L', 'C', 'L', 'C', 'L', 'C', 'L', 'L'],
        18: ['M', 'L', 'L', 'C', 'L', 'C', 'L', 'C', 'L', 'L'],
        19: ['M', 'L', 'L', 'C', 'L', 'C', 'L', 'C', 'L', 'L']
    }
};
/* eslint-enable array-bracket-spacing */


(function(vertices) {
    for (var i in vertices) {
        vertices[i] = vertices[i].map(function(vertex) { return DG.point(vertex); });
    }
})(DG.Entrance.Arrow.SHAPE.vertices);

DG.Label = DG.Layer.extend({

    options: {
        offset: new DG.Point(12, 15),
        className: 'dg-label',
        zIndexOffset: 0,
        textDirection: 'auto' // 'auto' | 'ltr' | 'rtl
    },

    _typeOfString : Object.prototype.toString.call('s'),
    _defaultZIndex: 100,

    initialize: function(content, options) {
        DG.Util.setOptions(this, options);

        this._animated = DG.Browser.any3d;
        this._content = content;
    },

    onAdd: function(map) {
        this._map = map;

        if (!this._el) {
            this._initDOM();
        }

        this._visible = true;

        this
            .setContent(this._content)
            ._onViewReset();

        map
            .on('viewreset', this._onViewReset, this)
            .on('zoomanim', this._onZoomAnimation, this);
    },

    onRemove: function(map) {
        map
            .off('viewreset', this._onViewReset, this)
            .off('zoomanim', this._onZoomAnimation, this);

        this._visible = false;

        this._el.removeChild(this._container);
        DG.Util.falseFn(this._container.offsetWidth); // we need reflow here
        this._container = null;

        map.getPanes().tooltipPane.removeChild(this._el);
        this._el = null;
    },

    _initDOM: function() {
        this._el = DG.DomUtil.create(
            'div',
            this.options.className + ' leaflet-zoom-' + (this._animated ? 'animated' : 'hide'),
            this._map.getPanes().tooltipPane);
        this._el.style.zIndex = this._defaultZIndex + this.options.zIndexOffset;

        this._container = DG.DomUtil.create('div', this.options.className + '__content', this._el);
        this._container.setAttribute('dir', this.options.textDirection);

        DG.DomEvent
            .disableClickPropagation(this._el)
            .on(this._container, 'mousewheel', DG.DomEvent.stopPropagation)
            .on(this._container, 'contextmenu', DG.DomEvent.stopPropagation);
    },

    _onViewReset: function() {
        if (this._visible && this._latlng) {
            DG.DomUtil.setPosition(this._el, this._map.latLngToLayerPoint(this._latlng).add(this.options.offset), DG.Browser.ie);
        }
    },

    _onZoomAnimation: function(opt) {
        if (this._latlng) {
            DG.DomUtil.setPosition(this._el, this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).add(this.options.offset));
        }
    },

    setOffset: function(point) {
        if (point instanceof DG.Point) {
            this.options.offset = point;
            this._onViewReset();
        }
        return this;
    },

    setZIndexOffset: function(zIndex) {
        if (!isNaN(+zIndex)) {
            this.options.zIndexOffset = +zIndex;
            if (this._visible) {
                this._el.style.zIndex = this._defaultZIndex + this.options.zIndexOffset;
            }
        }
        return this;
    },

    setContent: function(content) {
        if (Object.prototype.toString.call(content) !== this._typeOfString) {
            return this;
        }
        this._content = content;
        if (this._visible) {
            this._container.innerHTML = content;
        }
        return this;
    },

    setPosition: function(latlng) {
        if (!(latlng instanceof DG.LatLng)) {
            return this;
        }

        this._latlng = latlng;
        this._onViewReset();
        return this;
    }
});

DG.label = function(content, options) {
    return new DG.Label(content, options);
};

DG.Marker.include({

    bindLabel: function(content, options) {
        if (this._label) {
            this._label.setContent(content);
            if (options) {
                if (this.options.offset !== options.offset) {
                    this._label.setOffset(this.options.offset = options.offset);
                }
                if (this.options.static !== options.static) {
                    this.unbindLabel().bindLabel(content, options);
                }
            }
        } else {
            options = DG.extend({
                offset: new DG.Point(5, 5)
            }, options);

            this._label = DG.label(content, options);

            this.once('remove', this._onMarkerRemove);

            if (options.static) {
                this.showLabel();
            } else {
                this
                    .on('mouseover', this._mouseOverLabel)
                    .on('mouseout', this._mouseOutLabel)
                    .on('dragstart', this._dragStartLabel)
                    .on('dragend', this._dragEndLabel);
            }

            if (typeof this._map !== 'undefined') {
                this._updateLabelZIndex();
            } else {
                this.once('add', this._updateLabelZIndex);
            }
        }
        return this;
    },

    unbindLabel: function() {
        if (this._label) {
            this
                .hideLabel()
                .off('remove', this.unbindLabel)
                .off('mouseover', this._mouseOverLabel)
                .off('mouseout', this._mouseOutLabel)
                .off('dragstart', this._dragStartLabel)
                .off('dragend', this._dragEndLabel)
                .off('move', this._updatePosition)
                .off('add', this._updateLabelZIndex);

            this._label = null;
        }
        return this;
    },

    _onMarkerRemove: function() {
        if (this._label) {
            var content = this._label._content;
            this.once('add', function() {
                if (this._label) { return; } // new label added after removing marker
                this.bindLabel(content);
            });
            this.unbindLabel();
        }
    },

    getLabel: function() {
        return this._label ? this._label : null;
    },

    _originalUpdateZIndex: DG.Marker.prototype._updateZIndex,
    _updateZIndex: function(offset) {
        if (!this._zIndex) {
            this._zIndex = 0;
        }
        this._originalUpdateZIndex(offset);
        this._updateLabelZIndex();
        return this;
    },

    _updateLabelZIndex: function() {
        if (this._label && this._icon) {
            this._label.setZIndexOffset(this._icon.style.zIndex);
        }
        return this;
    },

    showLabel : function() {
        if (this._label) {
            this
                .on('move', this._updatePosition)
                ._map.addLayer(this._label.setPosition(this.getLatLng()));
        }

        return this;
    },

    hideLabel : function() {
        if (this._label) {
            this
                .off('move', this._updatePosition)
                ._map.removeLayer(this._label);
        }
        return this;
    },

    _updatePosition : function() {
        this._label.setPosition(this.getLatLng());
    },

    _dragStartLabel: function() {
        this._label.isMarkerDragging = true;

        this.hideLabel();
    },

    _dragEndLabel: function() {
        this._label.isMarkerDragging = false;

        if (this._label.isMouseOverMarker) {
            this.showLabel();
        }
    },

    _mouseOverLabel: function() {
        this._label.isMouseOverMarker = true;

        if (!this._label.isMarkerDragging) {
            this.showLabel();
        }
    },

    _mouseOutLabel: function() {
        this._label.isMouseOverMarker = false;

        this.hideLabel();
    }
});

DG.Marker.addInitHook(function() {
    if (typeof this.options.label !== 'undefined') {
        this.bindLabel(this.options.label);
    }
});

DG.Path.include({
    bindLabel: function(content, options) {

        if (!this._label) {
            this._label = DG.label(content, options);
            this.on(this._labelEvents, this);
        } else {
            this._label.setContent(content);

            if (this._label.options.offset !== options.offset) {
                this._label.setOffset(options.offset);
            }
        }
        return this;
    },

    unbindLabel: function() {
        if (this._label) {
            this.off(this._labelEvents, this);
            this._map.removeLayer(this._label);
            this._label = null;
        }
        return this;
    },

    getLabel: function() {
        return this._label ? this._label : null;
    },

    _labelEvents : {
        mouseover: function(event) {
            this._map.addLayer(this._label.setPosition(event.latlng));
            DG.DomEvent.stop(event);
        },
        mousemove: function(event) {
            this._label.setPosition(event.latlng);
            DG.DomEvent.stop(event);
        },
        mouseout: function(event) {
            this._map.removeLayer(this._label);
            DG.DomEvent.stop(event);
        },
        remove: function() {
            this._map.removeLayer(this._label);
        }
    }
});

DG.Path.addInitHook(function() {
    if (typeof this.options.label !== 'undefined') {
        this.bindLabel(this.options.label);
    }
});

DG.Entrance.include({
    bindLabel: function(content, options) {

        if (!this._label) {
            this._label = DG.label(content, options);
            this.on(this._labelEvents, this);
        } else {
            this._label.setContent(content);

            if (this._label.options.offset !== options.offset) {
                this._label.setOffset(options.offset);
            }
        }
        return this;
    },

    unbindLabel: function() {
        if (this._label) {
            this.off(this._labelEvents, this);
            this._map.removeLayer(this._label);
            this._label = null;
        }
        return this;
    },

    getLabel: function() {
        return this._label ? this._label : null;
    },

    _labelEvents : {
        mouseover: function(event) {
            this._map.addLayer(this._label.setPosition(event.latlng));
            DG.DomEvent.stop(event);
        },
        mousemove: function(event) {
            this._label.setPosition(event.latlng);
            DG.DomEvent.stop(event);
        },
        mouseout: function() {
            this._label.remove();
        },
        remove: function() {
            this._label.remove();
        }
    }
});

DG.Entrance.addInitHook(function() {
    if (typeof this.options.label !== 'undefined') {
        this.bindLabel(this.options.label);
    }
});

DG.configTheme = DG.configTheme || {};

DG.configTheme.balloonOptions = {
    offset: {
        x: 1,
        y: -43
    }
};

_dereq_('../../../vendors/baron');

// 2GIS-related popup content wrapper and offset
(function() {
    var offsetX = DG.configTheme.balloonOptions.offset.x,
        offsetY = DG.configTheme.balloonOptions.offset.y,
        originalInitialize = DG.Popup.prototype.initialize,
        originalInitLayout = DG.Popup.prototype._initLayout,
        originalOnAdd = DG.Popup.prototype.onAdd,
        graf = baron.noConflict();

    var BaronDomHelper = function(element) {
        this[0] = element;
        this.length = 1;
    };
    BaronDomHelper.prototype = {
        setAttribute: function(name, value) {
            this[0].setAttribute(name, value);
            return this;
        },
        getAttribute: function(name) {
            return this[0].getAttribute(name);
        },
        removeAttribute: function(name) {
            this[0].removeAttribute(name);
            return this;
        },
        css: function(style, value) {
            if (value) {
                this[0].style[style] = value;
                return this;
            } else {
                return DG.DomUtil.getStyle(this[0], style);
            }
        }
    };

    DG.Popup.prototype.options.offset = DG.point(offsetX, offsetY);

    DG.Popup.mergeOptions({
        border: 16,
        mapControlsWidth: 60,
        textDirection: 'auto' // 'auto' | 'ltr' | 'rtl
    });

    DG.Popup.include({
        _headerContent: null,
        _footerContent: null,

        //baron elements references
        _scroller: null,
        _scrollerBar: null,
        _barWrapper: null,
        _baron: null,
        _isBaronExist: false,

        _popupShowClass: 'leaflet-popup_show_true',
        _popupHideClass: 'leaflet-popup_show_false',

        _popupTipClass: 'leaflet-popup-tip-container',
        _tipSVGPath: 'M0 0c12.643 0 28 7.115 28 44h2c0-36.885 15.358-44 28-44h-58z',

        _isAutoPanPaddingUserDefined: false,

        initialize: function(options, source) { // (Object, Object)
            this._popupStructure = {};
            this._isAutoPanPaddingUserDefined = options && options.hasOwnProperty('autoPanPadding');
            originalInitialize.call(this, options, source);
        },

        onAdd: function(map) { // (Map)
            map.on({
                entranceshow: this._closePopup,
                resize: this.resize
            }, this);
            originalOnAdd.call(this, map);
            this._animateOpening();
        },

        onRemove: function(map) { // (Map)
            this._animateClosing();
            map.off({
                entranceshow: this._closePopup,
                resize: this.resize
            }, this);

            if (DG.DomUtil.TRANSITION) {
                this._removeTimeout = setTimeout(L.bind(L.DomUtil.remove, L.DomUtil, this._container), 200);
            } else {
                L.DomUtil.remove(this._container);
            }

            map.fire('popupclose', {popup: this});

            if (this._source) {
                this._source.fire('popupclose', {popup: this}, true);
            }
        },

        setContent: function(content) { // (DOMElement | Object | HTML) -> Popup
            if (!this._isNode(content) && typeof content === 'object') {
                Object.keys(content).forEach(function(item) {
                    this['_' + item + 'Content'] = content[item];
                }, this);
            } else {
                this._bodyContent = content;
            }

            this.update();

            return this;
        },

        setHeaderContent: function(content) { // (HTML) -> Popup
            this._headerContent = content;
            this.update();

            return this;
        },

        setFooterContent: function(content) { // (HTML) -> Popup
            this._footerContent = content;
            this.update();

            return this;
        },

        getContent: function() { // () -> HTML
            return this._bodyContent;
        },

        getHeaderContent: function() { // () -> HTML
            return this._headerContent;
        },

        getFooterContent: function() { // () -> HTML
            return this._footerContent;
        },

        clear: function() { // () -> Popup
            Object.keys(this._popupStructure).forEach(this._clearElement, this);

            // think about move this set to another public method
            this._isBaronExist = false;
            return this;
        },

        clearHeader: function() { // () -> Popup
            return this._clearElement('header');
        },

        clearFooter: function() { // () -> Popup
            return this._clearElement('footer');
        },

        findElement: function(element) { // (String) -> DOMElement
            return this._contentNode.querySelector(element);
        },

        _animateOpening: function() {
            DG.DomUtil.addClass(this._innerContainer, this._popupShowClass);
            DG.DomUtil.removeClass(this._innerContainer, this._popupHideClass);
        },

        _animateClosing: function() {
            DG.DomUtil.addClass(this._innerContainer, this._popupHideClass);
            DG.DomUtil.removeClass(this._innerContainer, this._popupShowClass);
        },

        _closePopup: function() {
            this._map.closePopup(this);
        },

        _isNode: function(o) { // (Object) -> Boolean
            return (o.nodeName ? true : false);
        },

        _onCloseButtonClick: function(e) {
            if (this._map) {
                this._map.closePopup(this);
            }
            L.DomEvent.stop(e);
        },

        _close: function() {
            if (this._map) {
                if (DG.Browser.mobile && this._map.geoclicker &&
                    (this.options.closeOnClick || this._map.options.closePopupOnClick)) {
                    //  We need to signal geoclicker that popup was open before 'click' event
                    //  But by time it will get it's event the popup will be already closed
                    //  See 'DGGeoclicker' for '_mapEventsListeners' and '_singleClick' method
                    this._map.geoclicker.popupWasOpen = true;
                }

                this._map.closePopup(this);
            }
        },

        _initLayout: function() {
            originalInitLayout.call(this);

            // Prevents scroll events for div.leaflet-popup-content (this._contentNode) from web page scrolling when popup is opened
            DG.DomEvent.on(this._contentNode, 'wheel', function(e) {
                var eventPath;

                if (e.composedPath) {
                    eventPath = e.composedPath();
                } else {
                    var elem = e.target;
                    eventPath = [];
                    while (elem.parentNode) {
                        eventPath.push(elem);
                        elem = elem.parentNode;
                    }
                }

                if (eventPath.indexOf(this._scroller) === -1 || eventPath.indexOf(this._barWrapper) !== -1) {
                    e.preventDefault();
                }
            }, this);

            this._innerContainer = DG.DomUtil.create('div', 'leaflet-popup-inner ' + this._popupHideClass, this._container);

            // Prevents mouse events from leaking through close button
            // See https://github.com/2gis/mapsapi/pull/153/
            DG.DomEvent.disableClickPropagation(this._innerContainer);

            if (this.options.closeButton) {
                this._innerContainer.appendChild(this._detachEl(this._closeButton));
            }

            this._innerContainer.appendChild(this._detachEl(this._wrapper));

            var tip = this._detachEl(this._tipContainer);

            if (DG.Browser.svg) {
                var path = DG.SVG.create('path');
                var svgClass = this._popupTipClass + ' ' + this._popupTipClass + '_svg';

                path.setAttribute('d', this._tipSVGPath);

                tip = DG.SVG.create('svg');
                tip.setAttribute('class', svgClass);

                tip.appendChild(path);
                DG.DomEvent.disableClickPropagation(path);
            } else {
                DG.DomUtil.addClass(tip, this._popupTipClass + '_image');
                DG.DomEvent.disableClickPropagation(tip);
            }

            this._innerContainer.appendChild(tip);
        },

        _clearElement: function(elem) { // (DOMElement) -> Popup
            this['_' + elem + 'Content'] = null;
            this._detachEl(this._popupStructure[elem]);
            delete this._popupStructure[elem];
            return this;
        },

        _updateScrollPosition: function() {
            if (this._baron) {
                this._baron.update();
            }
        },

        resize: function() {
            var scrolled = this._updateLayout();
            this._updatePosition();

            if (!scrolled) {
                if (this._isBaronExist) {
                    this._scrollerWrapper.style.height = '';
                    DG.DomUtil.removeClass(this._scroller, 'dg-scroller');

                    DG.DomUtil.addClass(this._scroller, 'dg-scroller_hidden_true');
                    DG.DomUtil.removeClass(this._scroller, 'dg-scroller');
                    DG.DomEvent.off(this._scroller, 'scroll', this._onScroll);
                }
            } else if (this._isBaronExist) {
                DG.DomUtil.removeClass(this._scroller, 'dg-scroller_hidden_true');
                DG.DomUtil.addClass(this._scroller, 'dg-scroller');

                var scrollTop = this._isBaronExist ? this._scroller.scrollTop : false;

                if (scrollTop) {
                    this._scroller.scrollTop = scrollTop;
                }

                var innerHeight = this.options.maxHeight - this.options.border * 2 - this._getDelta();
                this._scrollerWrapper.style.height = innerHeight + 'px';

                this._updateScrollPosition();
            } else if (!this._isContentHeightEnough()) {
                this._initBaronScroller();
                this._initBaron();
            }

            this._adjustPan();
            this._bindAdjustPanOnTransitionEnd();
        },

        _adjustPan: function(e) {
            if (!this._map) { return; }

            if (e) { // animated popup is opening (height from 0 to max)
                if (e.propertyName === 'max-height') {
                    // when it's finished we are here
                    DG.DomEvent.off(this._wrapper, DG.DomUtil.TRANSITION_END, this._adjustPan);
                } else {
                    // here's intermediate steps - we don't need to process them
                    return;
                }
            }

            var options = this.options;

            if (!options.autoPan) { return; }

            var map = this._map,
                containerHeight = this._container.offsetHeight,
                containerWidth = this._containerWidth,
                layerPos = new L.Point(this._containerLeft, -containerHeight - this._containerBottom);

            if (this._zoomAnimated) {
                layerPos._add(L.DomUtil.getPosition(this._container));
            }

            var autoPanPadding = [options.autoPanPadding[0], options.autoPanPadding[1]];

            // if width of map is more then width of popup and controls
            // set default autoPanPadding to width controls
            if (
                !this._isAutoPanPaddingUserDefined &&
                    this._map._container.offsetWidth >= options.maxWidth + options.mapControlsWidth * 2
            ) {
                autoPanPadding[0] = options.mapControlsWidth;
            }

            var containerPos = map.layerPointToContainerPoint(layerPos),
                padding = L.point(autoPanPadding),
                paddingTL = L.point(options.autoPanPaddingTopLeft || padding),
                paddingBR = L.point(options.autoPanPaddingBottomRight || padding),
                size = map.getSize(),
                dx = 0,
                dy = 0;

            if (size.x === 0 || size.y === 0) {
                // map isn't visible
                return;
            }

            if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
                dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            }
            if (containerPos.x - dx - paddingTL.x < 0) { // left
                dx = containerPos.x - paddingTL.x;
            }
            if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
                dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            }
            if (containerPos.y - dy - paddingTL.y < 0) { // top
                dy = containerPos.y - paddingTL.y;
            }

            if (dx || dy) {
                map
                    .fire('autopanstart')
                    .panBy([dx, dy]);
            }
        },

        _bindAdjustPanOnTransitionEnd: function() {
            if (DG.DomUtil.TRANSITION) {
                DG.DomEvent.on(this._wrapper, DG.DomUtil.TRANSITION_END, this._adjustPan, this);
            } else {
                this._adjustPan();
            }
        },

        _isContentHeightEnough: function() { // () -> Boolean
            var options = this.options;

            if (!options.maxHeight) {
                return true;
            }

            var popupHeight = this._popupStructure.body ?
                this._popupStructure.body.offsetHeight + this._getDelta() :
                this._contentNode.offsetHeight;

            popupHeight += options.border * 2;

            return popupHeight <= options.maxHeight;
        },

        _initBaronScroller: function() {
            var contentNode = this._popupStructure.body.parentNode,
                scrollerWrapper = this._scrollerWrapper = DG.DomUtil.create('div', 'dg-scroller__wrapper', contentNode),
                scroller = this._scroller = DG.DomUtil.create('div', 'dg-scroller', scrollerWrapper),
                barWrapper = this._barWrapper = DG.DomUtil.create('div', 'dg-scroller__bar-wrapper', scroller),
                innerHeight = this.options.maxHeight - this.options.border * 2;

            this._scrollerBar = DG.DomUtil.create('div', 'dg-scroller__bar', barWrapper);
            scroller.appendChild(this._detachEl(this._popupStructure.body));

            innerHeight -= this._getDelta();
            scrollerWrapper.style.height = Math.max(18, innerHeight) + 'px';
            scrollerWrapper.style.width = contentNode.offsetWidth + 5 + 'px'; //TODO

            this._isBaronExist = true;

            this._switchEvents();
        },

        _onScroll: function(e) {
            this.fire('scroll', {originalEvent: e});
        },

        _onClick: function(e) {
            e.target = e.target || e.srcElement;

            if (!this._moving) {
                this.fire('click', {originalEvent: e});
            }
        },

        _onStart: function(e) {
            this._moved = false;

            if (this._moving) { return; }

            var first = e.touches ? e.touches[0] : e;

            this._startPoint = new DG.Point(first.clientX, first.clientY);

            this._toggleTouchEvents();
        },

        _onEnd: function(e) {
            this._toggleTouchEvents(true);

            this._onClick(e);

            this._moving = false;
        },

        _onMove: function(e) {

            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }

            var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
                newPoint = DG.point(first.clientX, first.clientY),
                offset = Math.abs(newPoint.subtract(this._startPoint).y);

            if (!offset || offset < 10) { return; }

            this._moving = this._moved = true;

        },

        _initBaron: function() {
            var context = this._scrollerWrapper;
            this._baron = graf({
                scroller: '.dg-scroller',
                bar: '.dg-scroller__bar',
                track: '.dg-scroller__bar-wrapper',
                $: function(selector) {
                    var node = {}.toString.call(selector) === '[object String]' ?
                        context.querySelector(selector) : selector;

                    return new BaronDomHelper(node);
                },
                event: function(elem, event, func, mode) {
                    event.split(' ').forEach(function(type) {
                        DG.DomEvent[mode || 'on'](elem, type, func);
                    });
                }
            });
        },

        _initHeader: function() {
            this._popupStructure.header = DG.DomUtil.create('header', 'dg-popup__header', this._contentNode);
            this._popupStructure.header.setAttribute('dir', this.options.textDirection);
        },

        _initFooter: function() {
            this._popupStructure.footer = DG.DomUtil.create('footer', 'dg-popup__footer', this._contentNode);
            this._popupStructure.footer.setAttribute('dir', this.options.textDirection);
        },

        _initBodyContainer: function() {
            this._popupStructure.wrapper = DG.DomUtil.create('div', 'dg-popup__container-wrapper', this._contentNode);
            this._popupStructure.body = DG.DomUtil.create('div', 'dg-popup__container', this._popupStructure.wrapper);
            this._popupStructure.body.setAttribute('dir', this.options.textDirection);
        },

        update: function() {
            if (!this._map) { return; }

            if (!DG.Browser.ielt9) {
                this._container.style.visibility = 'hidden';
            }
            this._switchEvents(true);

            this._clearNode(this._contentNode);
            this._isBaronExist = false;

            // init popup content dom structure
            if (this._headerContent) { this._initHeader(); }
            if (this._bodyContent) { this._initBodyContainer(); }
            if (this._footerContent) { this._initFooter(); }

            this._updatePopupStructure();
            this.resize();

            DG.DomEvent.on(this._wrapper, 'click', DG.DomEvent.stopPropagation);
            this._switchEvents();

            if (DG.Browser.ielt9) {
                var elem = this._popupStructure.footer;
                if (elem) {
                    elem.className += ' ie8';
                }
            }

            if (!DG.Browser.ielt9) {
                this._container.style.visibility = '';
            }
        },

        _getDelta: function() { // () -> Number
            var delta = 0,
                popup = this._popupStructure;

            if (popup.header) {
                delta += popup.header.offsetHeight;
            }
            if (popup.footer) {
                delta += popup.footer.offsetHeight;
            }

            return delta;
        },

        _updateLayout: function() {
            var opts = this.options,
                content = this._contentNode, // leaflet-popup-content
                wrapper = this._wrapper, // leaflet-popup-content-wrapper
                style = content.style,
                wrapperStyle = wrapper.style,
                width,
                scrolledClass = 'leaflet-popup-scrolled',
                result = false;

            style.margin = opts.border + 'px';

            DG.DomUtil.removeClass(content, scrolledClass);

            if (this._isContentHeightEnough()) {
                wrapperStyle.maxHeight = content.offsetHeight + opts.border * 2 + 'px';
            } else {
                wrapperStyle.maxHeight = opts.maxHeight + 'px';
                DG.DomUtil.addClass(content, scrolledClass);
                result = true;
            }

            var availableWidth = opts.autoPanPadding[0] * 2;

            if (opts.sprawling) {
                width = opts.maxWidth;

                width = Math.min(width, this._map._container.offsetWidth - availableWidth);
                width = Math.max(width, opts.minWidth);
            } else {
                wrapperStyle.width = '';

                style.whiteSpace = 'nowrap';
                width = wrapper.offsetWidth;
                style.whiteSpace = '';

                width = Math.min(width, this._map._container.offsetWidth - availableWidth);
                width = Math.min(Math.max(width, opts.minWidth), opts.maxWidth);
            }

            wrapperStyle.width = width + 'px';

            this._containerWidth = this._container.offsetWidth;

            return result;
        },

        _updatePopupStructure: function() {
            Object.keys(this._popupStructure).forEach(function(item) {
                this._insertContent(this['_' + item + 'Content'], this._popupStructure[item]);
            }, this);

            this.fire('contentupdate');
        },

        _insertContent: function(content, node) { // (String | DOMElement, DOMElement)
            if (!content || !node) { return; }

            content = (typeof content === 'function') ? content(this._source || this) : content;

            if (typeof content === 'string') {
                node.innerHTML = content;
            } else {
                this._clearNode(node);
                node.appendChild(content);
            }
        },

        _clearNode: function(node) { // (DOMElement)
            while (node.hasChildNodes()) {
                node.removeChild(node.firstChild);
            }
        },

        _detachEl: function(elem) { // (DOMElement) -> DOMElement
            if (elem.parentNode) {
                elem.parentNode.removeChild(elem);
            }
            return elem;
        },

        _switchEvents: function(on) { // (Boolean)
            var switcher = on ? 'off' : 'on';

            if (!DG.Browser.touch) {
                DG.DomEvent[switcher](this._contentNode, 'click', this._onClick, this);
            } else {
                DG.DomEvent[switcher](this._contentNode, 'touchstart mousedown mousemove', this._onStart, this);
            }

            if (this._isBaronExist) {
                DG.DomEvent[switcher](this._scroller, 'scroll', this._onScroll, this);
            }
        },

        _toggleTouchEvents: function(on) {
            var switcher = on ? 'off' : 'on';

            DG.DomEvent[switcher](this._contentNode, 'touchmove', this._onMove, this);
            DG.DomEvent[switcher](this._contentNode, 'touchend', this._onEnd, this);
        }

    });
}());


DG.Map.include({
    _markerClass: 'dg-customization__marker_type_mushroom',
    _markerShowClass: 'dg-customization__marker_appear',
    _markerHideClass: 'dg-customization__marker_disappear',
    _dgHideClass: 'dg-popup_hidden_true',
    openPopup: function(popup, latlng, options) { // (Popup) or (String || HTMLElement, LatLng[, Object])
        if (!(popup instanceof L.Popup)) {
            var content = popup;

            popup = new L.Popup(options).setContent(content);
        }

        if (latlng) {
            popup.setLatLng(latlng);
        }

        if (this.hasLayer(popup)) {
            return this;
        }

        if (this._popup && this._popup.options.autoClose) {
            this.closePopup();
        }

        this._popup = popup;

        if (popup._source && popup._source._icon) {
            if (popup._source._icon.className.indexOf(this._markerClass) !== -1) {
                DG.DomUtil.removeClass(popup._source._icon, this._markerShowClass);
                DG.DomUtil.addClass(popup._source._icon, this._markerHideClass);
            } else {
                DG.DomUtil.addClass(popup._source._icon, this._dgHideClass);
                if (popup._source._shadow) {
                    DG.DomUtil.addClass(popup._source._shadow, this._dgHideClass);
                }
            }
        }

        return this.addLayer(popup);
    },

    closePopup: function(popup) {  // (Popup) -> Popup
        if (!popup || popup === this._popup) {
            popup = this._popup;
            this._popup = null;
        }
        if (popup) {
            if (popup._source && popup._source._icon) {
                if (popup._source._icon.className.indexOf(this._markerClass) !== -1) {
                    DG.DomUtil.removeClass(popup._source._icon, this._markerHideClass);
                    DG.DomUtil.addClass(popup._source._icon, this._markerShowClass);
                } else {
                    DG.DomUtil.removeClass(popup._source._icon, this._dgHideClass);
                    if (popup._source._shadow) {
                        DG.DomUtil.removeClass(popup._source._shadow, this._dgHideClass);
                    }
                }
            }
            this.removeLayer(popup);
        }

        return this;
    }
});

DG.Dictionary = {};

DG.Dictionary.ru = {
    pluralRules: function(n) { // (Number)
        if (n % 10 === 1 && n % 100 !== 11) { // 1, 21
            return 0;
        }
        if ((n % 10 >= 2 && n % 10 <= 4 && (n % 10) % 1 === 0) && (n % 100 < 12 || n % 100 > 14)) { // 2, 3
            return 1;
        }

        if ((n % 10 === 0) || (n % 10 >= 5 && n % 10 <= 9 && (n % 10) % 1 === 0) || (n % 100 >= 11 && (n % 100) <= 14 && (n % 100) % 1 === 0)) { // 13, 17
            return 2;
        }
    }
};

DG.Dictionary.en = {
    pluralRules: function(n) { // (Number)
        if (n === 1) { // 1
            return 0;
        } else {
            return 1; //0, 2, 3, 4 ..
        }
    }
};

DG.Dictionary.it = {
    pluralRules: function(n) { // (Number)
        if (n === 1) { // 1
            return 0;
        } else {
            return 1; //0, 2, 3, 4 ..
        }
    }
};

DG.Dictionary.cs = {
    pluralRules: function(n) { // (Number)
        return (n === 1) ? 0 : (n >= 2 && n <= 4) ? 1 : 2;
    }
};

DG.Dictionary.es = {
    pluralRules: function(n) { // (Number)
        return (n >= 2) ? 1 : 0;
    }
};

// Stub for Arabic language, we don't have cases with plural form usage
// Actually Arabic has 6 plural forms
DG.Dictionary.ar = {
    pluralRules: function() {
        return 0;
    }
};

DG.Locale = {
    t: function(msg, argument) { // (String, Number) -> String
        var result,
            lang = this._map.getLang(),
            msgIsset = false,
            dictionaryMsg,
            exp;

        if (typeof this.constructor.Dictionary[lang] === 'undefined') {
            if (lang === 'ar') {
                lang = 'en';
            } else {
                lang = DG.config.defaultLang;
            }
        }
        dictionaryMsg = this.constructor.Dictionary[lang][msg];
        msgIsset = typeof dictionaryMsg !== 'undefined';
        if (!msgIsset) {
            return msg;
        }
        result = msgIsset ? dictionaryMsg : msg;

        if (argument !== undefined) {
            argument = parseInt(argument, 10);
            argument = isNaN(argument) ? 0 : argument;
            exp = this.constructor.Dictionary[lang].pluralRules(argument);
            result = dictionaryMsg[exp];
        }

        result = DG.Util.template(result, {n: argument});
        return result;
    }
};

DG.Map.include({
    setLang: function(lang) { // (String)
        if (lang && Object.prototype.toString.call(lang) === '[object String]') {
            this.options.currentLang = lang;
            this.fire('langchange', {'lang': lang});
        }
    },

    getLang: function() { // () -> String
        // If the language hasn't been set before, set it to page language or
        // default language from config
        if (!this.options.currentLang) {
            var root = document.documentElement;
            var lang = root.lang || (root.getAttributeNS && root.getAttributeNS('http://www.w3.org/XML/1998/namespace', 'lang')) || DG.config.defaultLang;

            this.options.currentLang = lang;
        }

        return this.options.currentLang;
    }
});

DG.RoundControl = DG.Control.extend({
    includes: DG.Mixin.Events,

    options: {
        position: 'topright',
        iconClass: 'default'
    },

    onAdd: function(map) {
        var controlClass = this._controlCLass = 'dg-control-round',
            controlIconClass = this._controlIconCLass = this._controlCLass + '__icon',
            container = DG.DomUtil.create('div', '');

        if (this._disable) {
            return container;
        }
        DG.DomUtil.addClass(container, controlClass);

        var link = this._link = DG.DomUtil.create(
            'a',
            controlIconClass + ' ' + controlIconClass + '_name_' + this.options.iconClass,
            container
        );

        link.href = '#';

        this._renderTranslation();

        this._map = map;

        DG.DomEvent
            .on(container, 'click', this._toggleControl, this)
            .on(container, 'dblclick', DG.DomEvent.stopPropagation)
            .on(link, 'mousedown', DG.DomEvent.stopPropagation);

        this.fireEvent('add');

        return container;
    },

    onRemove: function() {
        this.fireEvent('remove');
        DG.DomEvent.off(this._link, 'click', this._toggleControl);
    },

    setState: function(state) {
        if (!this._link || !this._container) {
            return this;
        }

        if (this._state) {
            DG.DomUtil.removeClass(this._container, this._controlCLass + '_state_' + this._state);
            DG.DomUtil.removeClass(this._link, this._controlIconCLass + '_state_' + this._state);

            this._state = null;
        }

        if (state) {
            this._state = state;

            DG.DomUtil.addClass(this._container, this._controlCLass + '_state_' + this._state);
            DG.DomUtil.addClass(this._link, this._controlIconCLass + '_state_' + this._state);
        }

        return this;
    },

    _toggleControl: function(e) {
        DG.DomEvent.stop(e);
        this.fireEvent('click');
    }
});

DG.RoundControl.include(DG.Locale);

DG.roundControl = function(options) {
    return new DG.RoundControl(options);
};

var ie9 = (function() {
    var div = document.createElement('div');
    var all = div.getElementsByTagName('i');
    div.innerHTML = '<!--[if IE 9]><i></i><![endif]-->';
    return Boolean(all[0]);
})();

var safari51 = DG.Browser.safari && navigator.userAgent.indexOf('Version/5.1') !== -1;

var wasPreviouslyDisabled = false;

// Old Safari throws error when localStorage.getItem is called in private mode
try {
    wasPreviouslyDisabled = localStorage.getItem('DGMuseum') === 'false';
} catch (err) {
    // do nothing
}

DG.Map.mergeOptions({
    museum: !wasPreviouslyDisabled && (DG.Browser.ielt9 || ie9 || DG.Browser.opera12 || safari51)
});

DG.Map.Museum = DG.Handler.extend({
    statics: {
        Dictionary: {
            ar: {
                wearesorry: 'لا نضمن لك تشغيل ثابت للتطبيق على متصفحك. حاول التحديث:'
            },
            cs: {
                wearesorry: 'Nezaručujeme stabilní fungování aplikace ve Vašem prohlížeči. Zkuste provést aktualizaci:'
            },
            en: {
                wearesorry: 'We do not guarantee stable operation of the application in your browser. Try updating:'
            },
            es: {
                wearesorry: 'No garantizamos un funcionamiento estable de la aplicación en su buscador. Intente actualizarlo:'
            },
            it: {
                wearesorry: 'Non garantiamo il funzionamento stabile dell\'applicazione nel tuo browser. Prova ad aggiornare:'
            },
            ru: {
                wearesorry: 'Мы не гарантируем стабильную работу приложения в вашем браузере. Попробуйте обновиться:'
            }
        }
    },

    includes: [DG.Locale],

    initialize: function(map) {
        this._map = map;

        this._element = document.createElement('div');
        this._element.className = 'dg-museum';
        this._element.innerHTML = '<span></span>' +
            '<a class="dg-museum-browser dg-museum__chrome" target="_blank" href="https://www.google.com/chrome/"></a>' +
            '<a class="dg-museum-browser dg-museum__firefox" target="_blank" href="https://www.mozilla.org/firefox/new/"></a>' +
            '<a class="dg-museum-browser dg-museum__safari" target="_blank" href="https://support.apple.com/downloads/safari"></a>' +
            '<a class="dg-museum-browser dg-museum__opera" target="_blank" href="https://www.opera.com/"></a>' +
            '<a class="dg-museum-browser dg-museum__ie" target="_blank" href="https://windows.microsoft.com/internet-explorer/download-ie"></a>';

        this._text = this._element.children[0];

        this._closeButton = document.createElement('span');
        this._closeButton.className = 'dg-museum__close';
        this._element.appendChild(this._closeButton);

        this._renderTranslation();
    },

    addHooks: function() {
        this._map.getContainer().appendChild(this._element);
        this._map.on('langchange', this._renderTranslation, this);
        DG.DomEvent.on(this._closeButton, 'click', this._onCloseButtonClick, this);
    },

    removeHooks: function() {
        this._map.getContainer().removeChild(this._element);
        this._map.off('langchange', this._renderTranslation, this);
        DG.DomEvent.off(this._closeButton, 'click', this._onCloseButtonClick, this);
    },

    _onCloseButtonClick: function(e) {
        DG.DomEvent.stop(e);

        // Old Safari throws error when localStorage.getItem is called in private mode
        try {
            localStorage.setItem('DGMuseum', 'false');
        } catch (err) {
            // do nothing
        }

        this.disable();
    },

    _renderTranslation: function() {
        var lang = this._map.getLang();
        this._text.innerHTML = this.t('wearesorry');
        this._element.setAttribute('dir', lang === 'ar' ? 'rtl': 'ltr');
    }
});

DG.Map.addInitHook('addHandler', 'museum', DG.Map.Museum);

DG.configTheme = DG.configTheme || {};

DG.configTheme.markersData = {
    iconSize: [22, 34],
    className: 'dg-customization__marker dg-customization__marker_type_mushroom',
    iconAnchor: [10, 32]
};

// Fix a lot of bugs with pinch-zooming
// See https://github.com/2gis/mapsapi/issues/327
DG.Map.mergeOptions({
    bounceAtZoomLimits: false
});

//Inject observing localization change
var controlAddTo = DG.Control.prototype.addTo;

DG.Control.include({
    addTo: function(map) {
        map.on('langchange', this._renderTranslation, this);

        return controlAddTo.call(this, map);
    },
    _renderTranslation: function() {}
});

// Just a copy of toPoint function
// https://github.com/Leaflet/Leaflet/blob/e079588573d0b0c649df95c3d6005373e87f323a/src/geometry/Point.js#L198-L222
function toPoint(x, y, round) {
    if (x instanceof DG.Point) {
        return x;
    }
    if (DG.Util.isArray(x)) {
        return new DG.Point(x[0], x[1]);
    }
    if (x === undefined || x === null) {
        return x;
    }
    if (typeof x === 'object' && 'x' in x && 'y' in x) {
        return new DG.Point(x.x, x.y);
    }
    return new DG.Point(x, y, round);
}

// Add ability to pass HTMLElement in DG.divIcon html parameter
// See https://github.com/Leaflet/Leaflet/pull/6571
// TODO: Remove it after updating leaflet at least to v1.5.0
DG.DivIcon.include({
    createIcon: function(oldIcon) {
        var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
            options = this.options;

        if (options.html instanceof Element) {
            DG.DomUtil.empty(div);
            div.appendChild(options.html);
        } else {
            div.innerHTML = options.html !== false ? options.html : '';
        }

        if (options.bgPos) {
            var bgPos = toPoint(options.bgPos);
            div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
        }
        this._setIconStyles(div, 'icon');

        return div;
    },
});

// Add some browser detection
DG.Browser.safari51 = DG.Browser.safari && navigator.userAgent.indexOf('Version/5.1') !== -1;

// DG.Browser.touch checks whether touch events supported or not; touchEnabled checks if it's a touch device
var msPointer = navigator.msPointerEnabled && navigator.msMaxTouchPoints && !window.PointerEvent;
var pointer = (window.PointerEvent && navigator.pointerEnabled && navigator.maxTouchPoints) || msPointer;
var documentTouch = window.DocumentTouch && document instanceof window.DocumentTouch;
DG.Browser.touchEnabled = pointer || 'ontouchstart' in window || documentTouch;

// Applies 2GIS divIcon to marker
DG.Marker.prototype.options.icon = DG.divIcon(DG.configTheme.markersData);

// support old option clickable
var utilSetOptions = DG.Util.setOptions;

DG.setOptions = L.setOptions = DG.Util.setOptions = function(obj, options) {
    if (options && typeof options.clickable !== 'undefined') {
        options.interactive = options.clickable;
    }

    return utilSetOptions.call(this, obj, options);
};

DG.Layer.mergeOptions({
    nonBubblingEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu']
});

L.Canvas.include({
    // overwrite the function without mousemove debounce as it breaks metalayers events
    _initContainer: function() {
        var container = this._container = document.createElement('canvas');

        L.DomEvent
            .on(container, 'mousemove', this._onMouseMove, this)
            .on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this)
            .on(container, 'mouseout', this._handleMouseOut, this);

        this._ctx = container.getContext('2d');
    }
});

// Monitor geometry usage
// TODO: remove after successful research
if (DG.Path) {
    var pathInitialize = DG.Path.prototype.onAdd;

    DG.Path.include({
        onAdd: function(map) {
            return pathInitialize.call(this, map);
        },
    });
}

var initMap = DG.Map.prototype.initialize,
    panBy = DG.Map.prototype.panBy,
    getBoundsZoom = DG.Map.prototype.getBoundsZoom,
    setMaxZoom = DG.Map.prototype.setMaxZoom;

// Restrict zoom level according to 2gis projects, in case if dgTileLayer is only one
DG.Map.include({

    // number of tileLayers without 2gis layers
    _tileLayersNumber: 0,

    _mapMaxZoomCache: null,

    //TODO try refactor it after up on new leaflet (> 0.7)
    initialize: function(id, options) { // (HTMLElement or String, Object)
        // Override default wheelPxPerZoomLevel value to avoid zooming too fast
        // on mouse wheel rotation
        // See https://github.com/2gis/mapsapi/issues/343
        options = DG.extend({wheelPxPerZoomLevel: 10000}, options);

        this.metaLayers = [];

        initMap.call(this, id, options);

        //  Project must be checked after BaseLayer init which occurs in InitHook (see orig method definition)
        if (this.options.center && this.options.zoom !== undefined) {
            this.setView(DG.latLng(this.options.center), this.options.zoom, {reset: true});
        }

        this._lastMetalayer = {
            layer: undefined,
            entity: undefined
        };
    },

    setView: function(center, zoom, options) {
        this._restrictZoom(center, zoom);

        zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
        center = this._limitCenter(DG.latLng(center), zoom, this.options.maxBounds);
        options = options || {};

        if (options.animate) {
            options.animate = this._testAnimation(center);
        }

        this._stop();

        if (this._loaded && !options.reset && options !== true) {

            if (options.animate !== undefined) {
                options.zoom = DG.extend({
                    animate: options.animate,
                    duration: options.duration
                }, options.zoom);
                options.pan = DG.extend({
                    animate: options.animate,
                    duration: options.duration
                }, options.pan);
            }

            // try animating pan or zoom
            var animated = (this._zoom !== zoom) ?
                this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
                this._tryAnimatedPan(center, options.pan);

            if (animated) {
                // prevent resize handler call, the view will refresh after animation anyway
                clearTimeout(this._sizeTimer);
                return this;
            }
        }

        // animation didn't start, just reset the map view
        this._resetView(center, zoom);

        return this;
    },

    panBy: function(offset, options) {
        var map = panBy.call(this, offset, options);

        var zoom = this._restrictZoom(this.getCenter());
        if (this.getZoom() > zoom) {
            this.setZoom(zoom);
        }

        return map;
    },

    getBoundsZoom: function(bounds, inside, padding) {
        bounds = DG.latLngBounds(bounds);
        this._restrictZoom(bounds);
        return getBoundsZoom.call(this, bounds, inside, padding);
    },

    getTileLayersNumber: function() {
        return this._tileLayersNumber;
    },

    setMaxZoom: function(zoom) {
        this._mapMaxZoomCache = null;
        return setMaxZoom.call(this, zoom);
    },

    _testAnimation: function(coords) {//if we jump to other project - disable animation
        if (this.projectDetector.enabled()) {
            var projectFrom = this.projectDetector.getProject(),
                projectTo = this.projectDetector.isProjectHere(coords);

            if (projectFrom && projectTo) {
                return projectFrom.code === projectTo.code;
            }
        }

        return true;
    },

    _updateTileLayers: function(e) {
        if (!(e.layer instanceof DG.TileLayer) || e.layer._isDg) { return; }

        if (e.type === 'layeradd') {
            this._tileLayersNumber++;
        } else {
            this._tileLayersNumber--;
        }
    },

    _getNewBounds: function(coords, zoom) {
        if (coords instanceof DG.LatLngBounds) {
            return coords;
        }

        var point = this.project(coords, zoom);
        var screenSize = this.getSize().divideBy(2);

        var sw = this.unproject(point.subtract(screenSize), zoom);
        var ne = this.unproject(point.add(screenSize), zoom);

        return DG.latLngBounds(sw, ne);
    },

    _restrictZoom: function(coords, zoom) {
        if (this._layers &&
            this.projectDetector.enabled() &&
            (this._tileLayersNumber === 0)) {

            var mapOptions = this.options,
                isMapMaxZoom = !!mapOptions.maxZoom,
                dgTileLayer = this.baseLayer,
                bounds = this._getNewBounds(coords, zoom),
                project = this.projectDetector.isProjectHere(bounds);

            if (isMapMaxZoom) {
                if (!this._mapMaxZoomCache) {
                    if (this.baseLayer.options.detectRetina && DG.Browser.retina && mapOptions.maxZoom > 0) {
                        mapOptions.maxZoom--;
                    }

                    this._mapMaxZoomCache = mapOptions.maxZoom;
                }
                mapOptions.maxZoom = (this._mapMaxZoomCache && project) ? this._mapMaxZoomCache :  DG.config.projectLeaveMaxZoom;
                if (project) {
                    this._mapMaxZoomCache = mapOptions.maxZoom;
                }

                return mapOptions.maxZoom;
            } else {
                if (project) {
                    if (dgTileLayer.options.detectRetina && DG.Browser.retina && project.maxZoom > 0) {
                        dgTileLayer.options.maxZoom = project.maxZoom - 1;
                    } else {
                        dgTileLayer.options.maxZoom = project.maxZoom;
                    }
                } else {
                    dgTileLayer.options.maxZoom = DG.config.projectLeaveMaxZoom;
                }

                dgTileLayer.options.maxNativeZoom = dgTileLayer.options.maxZoom;
                this._updateZoomLevels();

                return dgTileLayer.options.maxZoom;
            }
        }
    },

    // Added meta layers events processing before map events
    _fireDOMEvent: function(e, type, targets) {
        if (e.keyCode === 13) {
            // https://github.com/Leaflet/Leaflet/issues/5499
            return;
        }
        if (e.type === 'click') {
            // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
            // @event preclick: MouseEvent
            // Fired before mouse click on the map (sometimes useful when you
            // want something to happen on click before any existing click
            // handlers start running).
            var synth = L.Util.extend({}, e);
            synth.type = 'preclick';
            this._fireDOMEvent(synth, synth.type, targets);
        }

        if (e._stopped) { return; }

        // Find the layer the event is propagating from and its parents.
        targets = (targets || []).concat(this._findEventTargets(e, type));

        if (!targets.length) { return; }

        var target = targets[0];
        if (type === 'contextmenu' && target.listens(type, true)) {
            L.DomEvent.preventDefault(e);
        }

        // The eventTargets and eventTargetsMapIndex properties are used for fire events continuation to
        // remaining targets when the event was stopped due to the tile meta data request in progress.
        // In this case there is need to fire events to remaining targets asynchronously.
        var data = {
            originalEvent: e,
            eventTargets: targets,
            eventTargetsMapIndex: targets.indexOf(this)
        };

        if (e.type !== 'keypress') {
            var isMarker = target instanceof L.Marker;
            data.containerPoint = isMarker ?
                this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
            data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
            data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
        }

        for (var i = 0; i < targets.length; i++) {
            // Check metalayers before dispatch the event to the map
            if (targets[i] === this) {
                var metalayer = this._getCurrentMetaLayer(data);

                if (type === 'mousemove') {
                    if (this._lastMetalayer.entity && metalayer.entity &&
                        this._lastMetalayer.entity.id === metalayer.entity.id) {
                        this._fireMetalayerEvent('mousemove', metalayer, data);
                    } else {
                        this._fireMetalayerEvent('mouseout', this._lastMetalayer, data);
                        this._fireMetalayerEvent('mouseover', metalayer, data);
                        this._fireMetalayerEvent('mousemove', metalayer, data);
                        this._lastMetalayer = metalayer;
                    }
                } else {
                    this._fireMetalayerEvent(type, metalayer, data);
                }

                // If the event wasn't stopped in metalayers, dispatch it to the map
                if (!data.originalEvent._stopped) {
                    targets[i].fire(type, data, true);
                }
            } else {
                targets[i].fire(type, data, true);
                if (this._lastMetalayer.entity && data.originalEvent._stopped) {
                    // fixes L.circle([54.983136831455, 82.897440725094], 200).addTo(map);
                    this._fireMetalayerEvent('mouseout', this._lastMetalayer, data);
                    this._lastMetalayer = {
                        layer: undefined,
                        entity: undefined
                    };
                }
            }

            if (data.originalEvent._stopped ||
                (targets[i].options.nonBubblingEvents && L.Util.indexOf(targets[i].options.nonBubblingEvents, type) !== -1)) { return; }
        }
    },

    _getCurrentMetaLayer: function(data) {
        // Not forget for IE8 with srcElement
        var eventTarget = data.originalEvent.target || data.originalEvent.srcElement;
        var isClick = data.originalEvent.type === 'click';

        // Suppose that user can interact with the metalayer only if there are no layers between cursor and map
        if (
            // For all browsers which support pointer-events: none on tiles
            eventTarget === this._container ||
            // And for IE10 or less where targets are tiles
            DG.Browser.ie && eventTarget.className === 'leaflet-tile leaflet-tile-loaded' ||
            // The only exception is canvas, because a canvas layer occupies the whole screen
            eventTarget.tagName === 'CANVAS'
        ) {
            for (var j = this.metaLayers.length - 1; j >= 0; j--) {
                var metaEntity = this.metaLayers[j].getHoveredObject(data);
                if (metaEntity) {
                    return {
                        layer: this.metaLayers[j],
                        entity: metaEntity
                    };
                } else if (isClick) {
                    // Additional condition for click event, because there may not be the tile meta data.
                    // E.g. when the tile meta data request in progress. In this case the metalayer must be
                    // returned without an entity.
                    return {
                        layer: this.metaLayers[j],
                        entity: undefined
                    }
                }
            }
        }
        return {
            layer: undefined,
            entity: undefined
        };
    },

    _fireMetalayerEvent: function(type, metalayer, data) {
        // There is need to continue if the event type is click, because there may not be the tile meta data.
        // That's why it will be processed in the metalayer click handler.
        if (!metalayer.entity && type !== 'click') {
            return;
        }

        // There is no need to fire metalayer event if the metalayer is undefined.
        if (!metalayer.layer) {
            return;
        }

        var listener = metalayer.layer.mapEvents[type];
        if (!listener) {
            return;
        }
        data.entity = metalayer.entity;
        listener.call(metalayer.layer, data);
    }
});

DG.Map.addInitHook(function() {
    this.on('layeradd layerremove', this._updateTileLayers);
});

// Set css property touch-action to auto if dragging is false.
// Need for scrolling page in mobile using our map dom element.
// todo: I made issue in leaflet https://github.com/Leaflet/Leaflet/issues/4415
DG.Map.addInitHook(function() {
    if (this.options.dragging == false && this.options.tap == false) {
        DG.DomUtil.addClass(this._container, 'dg-dragging-false');
    }
});

DG.Map.addInitHook(function() {
    var errorUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX28t5R0k5UAAAAH0lEQVR4Xu3AAQkAAADCMPunNsdhWxwAAAAAAAAAwAEhAAABg2UP5AAAAABJRU5ErkJggg==';
    var errorRuUrl = DG.config.protocol + DG.config.baseUrl + '/img/nomap_ru.png';

    var TileLayer = DG.Browser.mobile ? DG.MobileTileLayer : DG.TileLayer;

    var BaseLayer = TileLayer.extend({
        initialize: function(url, options) {
            this._isDg = true;
            TileLayer.prototype.initialize.call(this, url, options);
        },

        getTiles: function() {
            return this._tiles;
        }
    });

    var apiKey = this.options.key || DG.config.key;
    var mapContainer = this.getContainer();
    var validator = new DG.ApiKeyValidator(apiKey, mapContainer);
    var showCommPoi = (this.options.showCommPoi ? '' : '&layerType=nc');
    validator.validateKeyResponse();

    var protocol = this.options.protocol || DG.config.secureProtocol;
    // Check that last symbol is colon, and if not add it
    if (protocol[protocol.length - 1] !== ':') {
        protocol = protocol + ':';
    }

    var tileUrl = protocol + (DG.Browser.retina ? DG.config.retinaTileServer : DG.config.tileServer) + showCommPoi;
    var arabicTileUrl = protocol +
        (DG.Browser.retina ? DG.config.arabicRetinaTileServer : DG.config.arabicTileServer) + showCommPoi;

    var previewTileUrl = protocol +
        (DG.Browser.retina ? DG.config.previewRetinaTileServer : DG.config.previewTileServer) + showCommPoi;
    var arabicPreviewTileUrl = protocol +
        (DG.Browser.retina ? DG.config.arabicPreviewRetinaTileServer : DG.config.arabicPreviewTileServer) + showCommPoi;

    this.baseLayer = new BaseLayer(tileUrl, {
        subdomains: '0123',
        errorTileUrl: this.getLang() === 'ru' ? errorRuUrl : errorUrl,
        detectRetina: DG.config.detectRetina,
        maxZoom: 20,
        maxNativeZoom: 20,
        zIndex: 0,
        updateWhenIdle: false, // it's okay with preview tiles
        previewUrl: previewTileUrl,
        key: apiKey,
        crossOrigin: true // force Origin request header
    });

    var currentTilesLang = ''; // 'ar' | ''

    function updateTileUrl() {
        var lang = this.getLang();
        var project = this.projectDetector && this.projectDetector.getProject();

        if (lang === 'ru' && !project) {
            this.baseLayer.options.errorTileUrl = errorRuUrl;
        } else {
            this.baseLayer.options.errorTileUrl = errorUrl;
        }

        // Change 2GIS tiles for Arabic language in Dubai project
        if (currentTilesLang === '' && lang === 'ar' && project && project.country_code === 'ae') {
            currentTilesLang = 'ar';
            this.baseLayer.setUrl(arabicTileUrl);
            if (this.baseLayer.setPreviewUrl) {
                this.baseLayer.setPreviewUrl(arabicPreviewTileUrl);
            }

        } else if (currentTilesLang === 'ar' && (lang !== 'ar' || (!project || project.country_code !== 'ae'))) {
            currentTilesLang = '';
            this.baseLayer.setUrl(tileUrl);
            if (this.baseLayer.setPreviewUrl) {
                this.baseLayer.setPreviewUrl(previewTileUrl);
            }
        }
    }

    updateTileUrl.call(this);

    this.baseLayer.addTo(this);

    this.on({
        langchange: updateTileUrl,
        projectchange: updateTileUrl,
        projectleave: updateTileUrl
    }, this);
});

DG.ApiKeyValidator = DG.Class.extend({
    initialize: function(apiKey, mapContainer) {
        this.apiKey = apiKey;
        this.endpoint = DG.config.keyServer + apiKey + DG.config.keyServices;
        this.isLoading = false;
        this.attempts = 0;
        this.lastTimeout = undefined;
        this.request = null;
        this.MAX_ATTEMPTS = 4;
        this.keyRequestInterval = [0, 2, 2, 2];
        this.isErrorWasShown = false;
        this.mapContainer = mapContainer;
    },

    validate: function(callback) {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;
        this.attempts = 0;
        this._makeAttempt(callback);
    },

    validateKeyResponse: function() {
        this.validate(function(response) {
            if (!response || this._isResponseInvalid(response)) {
                this._showError();
            }
        }.bind(this));
    },

    _makeAttempt: function(callback) {
        if (this.attempts > 0) {
            this.lastTimeout = window.setTimeout(function() {
                this._clearLastTimeout();
                this._executeRequest(callback);
            }.bind(this), this.keyRequestInterval[this.attempts] * 1000);
        } else {
            this._executeRequest(callback);
        }
    },

    _isResponseInvalid: function(response) {
        return (
            response.meta.code === 400 ||
            response.meta.code === 404 ||
            response.result &&
            (!response.result.service.is_active ||
                !response.result.is_active ||
                !['ok', 'exceeded'].includes(response.result.service.status.code)
            )
        );
    },

    _showError: function() {

        if (!this.isErrorWasShown && this.mapContainer) {
            var errorMessage = DG.DomUtil.create('div', 'dg-error-message');
            errorMessage.innerHTML = 'Your RasterJS API key is invalid. Please contact api@2gis.com to get RasterJS API key.';
            this.mapContainer.appendChild(errorMessage);
            this.isErrorWasShown = true;
        }
    },

    _executeRequest: function(callback) {
        this.request = DG.ajax(this.endpoint, {
            type: 'GET',
            success: function(response) {
                this.isLoading = false;
                callback(response);
            }.bind(this),
            error: function(xhr) {
                this._handleError(callback, xhr.status);
            }.bind(this)
        });
    },

    _handleError: function(callback, status) {
        this.attempts++;

        if (this.attempts < this.MAX_ATTEMPTS) {
            this._makeAttempt(callback);
        } else {
            this.isLoading = false;
            callback({
                meta: {
                    code: status,
                    message: 'Failed to validate API key'
                },
            });
        }
    },

    _clearLastTimeout: function() {
        if (this.lastTimeout !== undefined) {
            clearTimeout(this.lastTimeout);
            this.lastTimeout = undefined;
        }
    },

    destroy: function() {
        this._clearLastTimeout();
        this.isLoading = false;
    }
});

DG.Map.mergeOptions({
    tilesCheck: true
});

DG.Map.TilesCheck = DG.Handler.extend({
    initialize: function(map) {
        this._map = map;
        this._layer = map.baseLayer;

        this._moveStartEventCounter = 0;
        this._moveEndEventCounter = 0;

        this._loadingEventCounter = 0;
        this._loadEventCounter = 0;
    },

    addHooks: function() {
        this._map.on(this._mapEvents, this);
        this._layer.on(this._layerEvents, this);
    },

    removeHooks: function() {
        this._map.off(this._mapEvents, this);
        this._layer.off(this._layerEvents, this);
    },

    _mapEvents: {
        layeradd: function(e) {
            if (e.layer == this._layer) {
                this.enable();
            }
        },

        layerremove: function(e) {
            if (e.layer == this._layer) {
                this.disable();
            }
        },

        movestart: function() {
            this._stopWaiting();

            this._moveStartEventCounter++;
            this._isWaiting = true;
        },

        moveend: function() {
            this._moveEndEventCounter++;

            if (!this._isWaiting && this._moveStartEventCounter !== this._moveEndEventCounter) { return; }

            this._isMoveEnd = true;

            this._checkWaiting();
        }
    },

    _layerEvents: {
        loading: function() {
            this._loadingEventCounter++;
        },

        load: function() {
            this._loadEventCounter++;

            if (!this._isWaiting && this._loadingEventCounter !== this._loadEventCounter) { return; }

            this._isLoad = true;

            this._checkWaiting();
        }
    },

    _stopWaiting: function() {
        this._isWaiting = false;
        this._isMoveEnd = false;
        this._isLoad = false;
    },

    _checkWaiting: function() {
        if (this._isWaiting && this._isLoad && this._isMoveEnd) {
            this._stopWaiting();
            this._resetCounters();
            this._checkTiles();
        }
    },

    _checkTiles: function() {
        if (this._map.getTileLayersNumber() !== 0 || !this._map._loaded) { return; }

        var tileZoom = this._layer._tileZoom;
        var errorUrl = this._layer.options.errorTileUrl;
        var tiles = this._layer.getTiles();

        for (var i in tiles) {
            if (tiles[i].coords.z === tileZoom && tiles[i].el.src !== errorUrl) {
                return;
            }
        }

        this._map.zoomOut();
    },

    _resetCounters: function() {
        this._moveStartEventCounter = 0;
        this._moveEndEventCounter = 0;

        this._loadingEventCounter = 0;
        this._loadEventCounter = 0;
    }
});

DG.Map.addInitHook('addHandler', 'tilesCheck', DG.Map.TilesCheck);

/**
 * This customization fixes unwanted inertia movement after sudden drag stops
 * See https://github.com/Leaflet/Leaflet/pull/4048.
 * If this PR ever gets merged, this file can be removed.
 */
var onDragEnd = DG.Map.Drag.prototype._onDragEnd;

DG.Map.Drag.include({
    _rememberTimeAndPosition: function() {
        var time = this._lastTime = +new Date(),
            pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;

        this._positions.push(pos);
        this._times.push(time);

        // Remove all data points older than 50 ms
        while (time - this._times[0] > 50) {
            this._positions.shift();
            this._times.shift();
        }
    },

    _onDrag: function(e) {
        if (this._map.options.inertia) {
            this._rememberTimeAndPosition();
        }

        this._map
            .fire('move', e)
            .fire('drag', e);
    },

    _onDragEnd: function() {
        if (this._map.options.inertia && !DG.Browser.touch) {
            this._rememberTimeAndPosition();
        }

        onDragEnd.call(this);
    }
});

// from https://github.com/Turfjs/turf-inside/blob/master/index.js
DG.PolyUtil.inside = function(point, polygon, pointReduce) {
    pointReduce = pointReduce || DG.PolyUtil._defaultPointReduce;
    var polys = polygon.coordinates;
    var pt = pointReduce(point);

    // normalize to multipolygon
    if (polygon.type === 'Polygon') {
        polys = [polys];
    }

    var insidePoly = false;
    var i = 0;
    while (i < polys.length && !insidePoly) {
        // check if it is in the outer ring first
        if (this._inRing(pt, polys[i][0], pointReduce)) {
            var inHole = false;
            var k = 1;
            // check for the point in any of the holes
            while (k < polys[i].length && !inHole) {
                if (this._inRing(pt, polys[i][k], pointReduce)) {
                    inHole = true;
                }
                k++;
            }
            if (!inHole)  {
                insidePoly = true;
            }
        }
        i++;
    }
    return insidePoly;
};

// pt is [x,y] and ring is [[x,y], [x,y],..]
DG.PolyUtil._inRing = function(pt, ring, pointReduce) {
    var isInside = false;
    for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        var pi = pointReduce(ring[i]);
        var pj = pointReduce(ring[j]);
        var xi = pi[0], yi = pi[1];
        var xj = pj[0], yj = pj[1];
        var intersect = ((yi > pt[1]) !== (yj > pt[1])) &&
            (pt[0] < (xj - xi) * (pt[1] - yi) / (yj - yi) + xi);

        if (intersect) {
            isInside = !isInside;
        }
    }
    return isInside;
};

DG.PolyUtil._defaultPointReduce = function(point) {
    return point;
};

/**
 * В файле содежатся изменения для ускорения лифлета на мобильных девайсах
 */

if (DG.Browser.mobile) {
    (function() {
        /**
         * Хакаем addClass и removeClass, чтобы они не работали для определённых классов
         * Сделано так, чтобы не менять кучу методов в кишках лифлета
         *
         * leaflet-dragging и leaflet-drag-target вызывает длинный recalculate style
         */
        var addClass = L.DomUtil.addClass;
        L.DomUtil.addClass = function(el, name) {
            if (name === 'leaflet-dragging' ||
                name === 'leaflet-drag-target'
            ) {
                return;
            }

            addClass(el, name);
        };

        var removeClass = L.DomUtil.removeClass;
        L.DomUtil.removeClass = function(el, name) {
            if (name === 'leaflet-dragging' ||
                name === 'leaflet-drag-target'
            ) {
                return;
            }

            removeClass(el, name);
        }

        L.Draggable.include({
            /**
             * Добавлено округление позиции this._startPos.add(offset)._round()
             * И сравнение с предудыщей if (this._newPos && this._newPos.x == pos.x && this._newPos.y == pos.y) {
             * Чтобы обновление dom происходило только при реальном изменении
             * Убраны классы leaflet-dragging и leaflet-drag-target
             */
            _onMove: function(e) {
                // Ignore simulated events, since we handle both touch and
                // mouse explicitly; otherwise we risk getting duplicates of
                // touch events, see #4315.
                // Also ignore the event if disabled; this happens in IE11
                // under some circumstances, see #3666.
                if (e._simulated || !this._enabled) { return; }

                if (e.touches && e.touches.length > 1) {
                    this._moved = true;
                    return;
                }

                var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
                    newPoint = new L.Point(first.clientX, first.clientY),
                    offset = newPoint.subtract(this._startPoint);

                if (!offset.x && !offset.y) { return; }
                if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }

                L.DomEvent.preventDefault(e);

                if (!this._moved) {
                    // @event dragstart: Event
                    // Fired when a drag starts
                    this.fire('dragstart');

                    this._moved = true;
                    this._startPos = L.DomUtil.getPosition(this._element).subtract(offset);

                    this._lastTarget = e.target || e.srcElement;
                    // IE and Edge do not give the <use> element, so fetch it
                    // if necessary
                    if ((window.SVGElementInstance) && (this._lastTarget instanceof window.SVGElementInstance)) {
                        this._lastTarget = this._lastTarget.correspondingUseElement;
                    }
                }

                var pos = this._startPos.add(offset)._round();
                this._moving = true;

                L.Util.cancelAnimFrame(this._animRequest);
                this._lastEvent = e;

                if (this._newPos && this._newPos.x == pos.x && this._newPos.y == pos.y) {
                    return;
                }

                this._newPos = pos;
                this._animRequest = L.Util.requestAnimFrame(this._updatePosition, this, true);
            }
        });

        /**
         * Длительность всех инерций при движении карты теперь 1 секунда
         */
        L.Map.Drag.include({
            _onDragEnd: function(e) {
                var map = this._map,
                    options = map.options,

                    noInertia = !options.inertia || this._times.length < 2;

                map.fire('dragend', e);

                if (noInertia) {
                    map.fire('moveend');

                } else {

                    var direction = this._lastPos.subtract(this._positions[0]),
                        duration = (this._lastTime - this._times[0]) / 1000,
                        ease = options.easeLinearity,

                        speedVector = direction.multiplyBy(ease / duration),
                        speed = speedVector.distanceTo([0, 0]),

                        limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
                        limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),

                        decelerationDuration = 1, // limitedSpeed / (options.inertiaDeceleration * ease),
                        offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();

                    if (!offset.x && !offset.y) {
                        map.fire('moveend');

                    } else {
                        offset = map._limitOffset(offset, map.options.maxBounds);

                        L.Util.requestAnimFrame(function() {
                            map.panBy(offset, {
                                duration: decelerationDuration,
                                easeLinearity: ease,
                                noMoveStart: true,
                                animate: true
                            });
                        });
                    }
                }
            }
        })
    })();
}

L.MobileTileLayer = L.TileLayer.extend({
    initialize: function(url, options) {
        L.TileLayer.prototype.initialize.call(this, url, options);
        this._appleDevice = this._isAppleDevice()
        this._previewUrl = options.previewUrl;
    },

    setPreviewUrl: function(url) {
        this._previewUrl = url;
        this.redraw();
    },

    /**
     * Быстрое навешивание событий, вместо L.DomUtil.on используем простое присваивание
     */
    createTile: function(coords, done, url) {
        var tile = document.createElement('img');
        tile.onload = L.bind(this._tileOnLoad, this, done, tile);
        tile.onerror = L.bind(this._tileOnError, this, done, tile);

        if (this.options.crossOrigin) {
            tile.crossOrigin = '';
        }

        /*
         Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
         http://www.w3.org/TR/WCAG20-TECHS/H67
        */
        tile.alt = '';
        tile.src = this.getTileUrl(coords, url);

        return tile;
    },

    /**
     * Убран класс leaflet-tile
     * Добавлен хак для превью тайлов
     */
    _initTile: function(tile) {
        tile.style.position = 'absolute';

        var tileSize = this.getTileSize();
        tile.style.width = tileSize.x + 'px';
        tile.style.height = tileSize.y + 'px';

        tile.style.visibility = 'hidden';
        tile.style.pointerEvents = 'none';

        tile.onselectstart = L.Util.falseFn;
        tile.onmousemove = L.Util.falseFn;

        // without this hack, tiles disappear after zoom on Chrome for Android
        // https://github.com/Leaflet/Leaflet/issues/2078
        if (L.Browser.android && !L.Browser.android23) {
            tile.style.WebkitBackfaceVisibility = 'hidden';
        }

        return tile;
    },

    /**
     * Убран класс leaflet-tile-container
     */
    _updateLevels: function() {

        var zoom = this._tileZoom,
            maxZoom = this.options.maxZoom;

        if (zoom === undefined) { return undefined; }

        for (var z in this._levels) {
            if (this._levels[z].el.children.length || z === zoom) {
                this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
            } else {
                L.DomUtil.remove(this._levels[z].el);
                this._removeTilesAtZoom(z);
                delete this._levels[z];
            }
        }

        var level = this._levels[zoom],
            map = this._map;

        if (!level) {
            level = this._levels[zoom] = {};

            level.el = L.DomUtil.create('div', 'leaflet-zoom-animated', this._container);

            level.el.style.zIndex = maxZoom;

            level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
            level.zoom = zoom;

            this._setZoomTransform(level, map.getCenter(), map.getZoom());

            // force the browser to consider the newly added element for transition
            L.Util.falseFn(level.el.offsetWidth);
        }

        this._level = level;

        return level;
    },

    /**
     * Убрано добавление тайлов через documentFragment
     */
    _update: function(center) {
        var map = this._map;
        if (!map) { return; }
        var zoom = map.getZoom();

        if (center === undefined) { center = map.getCenter(); }
        if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom

        var pixelBounds = this._getTiledPixelBounds(center),
            tileRange = this._pxBoundsToTileRange(pixelBounds),
            tileCenter = tileRange.getCenter(),
            queue = [],
            margin = this.options.keepBuffer,
            noPruneRange = new L.Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
                tileRange.getTopRight().add([margin, -margin]));

        for (var key in this._tiles) {
            var c = this._tiles[key].coords;
            if (c.z !== this._tileZoom || !noPruneRange.contains(L.point(c.x, c.y))) {
                this._tiles[key].current = false;
            }
        }

        // _update just loads more tiles. If the tile zoom level differs too much
        // from the map's, let _setView reset levels and prune old tiles.
        if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }

        // create a queue of coordinates to load tiles from
        for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
            for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
                var coords = new L.Point(i, j);
                coords.z = this._tileZoom;

                if (!this._isValidTile(coords)) { continue; }

                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) {
                    tile.current = true;
                } else {
                    queue.push(coords);
                }
            }
        }

        // sort tile queue to load tiles in order of their distance to center
        queue.sort(function(a, b) {
            return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
        });

        if (queue.length !== 0) {
            // if it's the first batch of tiles to load
            if (!this._loading) {
                this._loading = true;
                // @event loading: Event
                // Fired when the grid layer starts loading tiles.
                this.fire('loading');
            }

            for (i = 0; i < queue.length; i++) {
                this._addTile(queue[i], this._level.el);
            }
        }
    },

    /**
     * We don't load preview tile:
     * - after zoom-in if a tile from a lower zoom is already shown
     * - after zoom-out if four tiles from a higher zoom is already shown
     */
    _needPreviewTile: function(coords) {
        if (this._tileZoom - this._map.getZoom() > 0) {
            // zoom in
            return !this._existTileFromLowerZoom(coords);
        } else {
            // zoom out
            return !this._existTilesFromHigherZoom(coords);
        }
    },

    _existTileFromLowerZoom: function(coords) {
        var coords2 = L.point(coords.x / 2, coords.y / 2)._floor();

        coords2.z = coords.z - 1;

        var key = this._tileCoordsToKey(coords2);
        var tile = this._tiles[key];
        return tile && !tile.preview;
    },

    _existTilesFromHigherZoom: function(coords) {
        var x = coords.x;
        var y = coords.y;

        for (var i = 2 * x; i < 2 * x + 2; i++) {
            for (var j = 2 * y; j < 2 * y + 2; j++) {
                var c = new L.Point(i, j);
                c.z = coords.z + 1;
                var key = this._tileCoordsToKey(c);
                if (!this._tiles[key]) {
                    return false;
                }
            }
        }

        return true;
    },

    _isAppleDevice: function() {
        var appleMobileRE = /ip(hone|od)/i;
        var appleTabletRE = /ipad/i;
        var touchMacRE = /Macintosh/i;

        var ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';

        if (!ua) {
            return false;
        }

        var isAppleMobile = appleMobileRE.test(ua);
        var isAppleTablet = appleTabletRE.test(ua);

        var isTouchMac =
            navigator.maxTouchPoints > 1 && touchMacRE.test(ua) && ua.indexOf('Safari') !== -1;

        return isAppleMobile || isAppleTablet || isTouchMac;
    },

    /**
     * Добавлена логика с превью тайлами
     */
    _addTile: function(coords, container) {
        var tilePos = this._getTilePos(coords),
            key = this._tileCoordsToKey(coords);

        var wrapCoords = this._wrapCoords(coords);
        var needPreview = this._needPreviewTile(wrapCoords);

        var url = needPreview ? this._previewUrl : this._url;
        var showPreviewForIphone = this._appleDevice && needPreview;
        var tile = this.createTile(wrapCoords, L.bind(showPreviewForIphone ? this._previewReady : this._tileReady, this, coords), url);

        this._initTile(tile);

        L.DomUtil.setPosition(tile, tilePos);

        // save tile in cache
        this._tiles[key] = {
            el: tile,
            preview: needPreview,
            coords: coords,
            current: true
        };

        container.appendChild(tile);
        // @event tileloadstart: TileEvent
        // Fired when a tile is requested and starts loading.
        this.fire('tileloadstart', {
            tile: tile,
            coords: coords
        });
    },

    _previewReady: function(coords, err, tile) {
        if (!this._map) { return; }

        var key = this._tileCoordsToKey(coords);

        tile = this._tiles[key];
        if (!tile) { return; }


        tile.el.onload = L.bind(this._tileReady, this, coords, err, tile);
        tile.el.onerror = L.bind(this._tileReady, this, coords, err, tile);
        tile.el.src = this.getTileUrl(coords, this._url);
    },

    /**
     * Убран fadeAnimated и класс leaflet-tile-loaded
     */
    _tileReady: function(coords, err, tile) {
        if (!this._map) { return; }

        if (err) {
            // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
        }

        var key = this._tileCoordsToKey(coords);

        tile = this._tiles[key];
        if (!tile) { return; }

        if (!this._appleDevice) {
        // Если у тайла уже есть оригинальная (не пожатая) картинка,
        // то заменим превью на нее
            if (tile.originalEl && tile.el.parentNode) {
                tile.el.parentNode.replaceChild(tile.originalEl, tile.el);
                tile.el = tile.originalEl;

                tile.originalEl = null;
                tile.preview = false;

                // Если у тайла есть только превью, то добавим его на карту
                // И начнем грузить оригинальный
            } else if (tile.preview) {
                tile.originalEl = this.createTile(this._wrapCoords(coords), L.bind(this._tileReady, this, coords), this._url);
                this._initTile(tile.originalEl);
                L.DomUtil.setPosition(tile.originalEl, this._getTilePos(coords));
            }
        }
        tile.loaded = +new Date();
        tile.active = true;
        this._pruneTiles();

        if (!err) {
            tile.el.style.visibility = '';

            // @event tileload: TileEvent
            // Fired when a tile loads.
            this.fire('tileload', {
                tile: tile.el,
                preview: tile.preview,
                coords: coords
            });
        }

        if (this._noTilesToLoad()) {
            this._loading = false;
            // @event load: Event
            // Fired when the grid layer loaded all visible tiles.
            this.fire('load');

            if (L.Browser.ielt9 || !this._map._fadeAnimated) {
                L.Util.requestAnimFrame(this._pruneTiles, this);
            } else {
                // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(L.bind(this._pruneTiles, this), 250);
            }
        }
    },

    /**
     * В отличие от оригинального метода, здесь url прокидывается параметром
     */
    getTileUrl: function(coords, url) {
        var data = {
            r: L.Browser.retina ? '@2x' : '',
            s: this._getSubdomain(coords),
            x: coords.x,
            y: coords.y,
            z: this._getZoomForUrl()
        };
        if (this._map && !this._map.options.crs.infinite) {
            var invertedY = this._globalTileRange.max.y - coords.y;
            if (this.options.tms) {
                data['y'] = invertedY;
            }
            data['-y'] = invertedY;
        }

        return L.Util.template(url, L.extend(data, this.options));
    },
});

DG.Control.Zoom.include(DG.Locale);
DG.Control.Zoom.Dictionary = {};

DG.Control.Zoom.include({
    onAdd: function(map) {
        var zoomName = 'dg-zoom',
            buttonTemplate = '<div class="dg-control-round__icon ' + zoomName + '__control ' + zoomName + '__button ' + zoomName + '__button_type_{type}"></div>',
            container = DG.DomUtil.create('div', zoomName);

        this._map = map;

        this._zoomInButton = this._createButton(DG.Util.template(buttonTemplate, {type : 'in'}), this.t('zoom_in'), 'dg-control-round ' + zoomName + '__in', container, this._zoomIn, this);
        this._zoomOutButton = this._createButton(DG.Util.template(buttonTemplate, {type : 'out'}), this.t('zoom_out'), 'dg-control-round ' + zoomName + '__out', container, this._zoomOut, this);

        this._updateDisabled();
        map.on('zoomend zoomlevelschange', this._updateDisabled, this);

        return container;
    },

    _originalCreateButton: DG.Control.Zoom.prototype._createButton,

    // set active state control on mobile devices
    _createButton: function() {
        var args = Array.prototype.slice.call(arguments);
        var link = this._originalCreateButton.apply(this, args);

        var icon = link.children[0];
        var linkActiveClass = 'dg-control-round_state_active';
        var iconActiveClass = 'dg-control-round__icon_state_active';

        DG.DomEvent
            .on(link, 'touchstart', function() {
                DG.DomUtil.addClass(link, linkActiveClass);
                DG.DomUtil.addClass(icon, iconActiveClass);
            })
            .on(link, 'touchend touchcancel', function() {
                DG.DomUtil.removeClass(link, linkActiveClass);
                DG.DomUtil.removeClass(icon, iconActiveClass);
            });

        return link;
    },

    _renderTranslation: function() {
        if (!this._zoomInButton || !this._zoomOutButton) {
            return;
        }

        this._zoomInButton.title = this.t('zoom_in');
        this._zoomOutButton.title = this.t('zoom_out');
    }
});

DG.Control.Zoom.Dictionary.ru = {
    zoom_in : 'Приблизить',
    zoom_out : 'Отдалить'
};

DG.Control.Zoom.Dictionary.it = {
    zoom_in : 'Zoom avanti',
    zoom_out : 'Zoom indietro'
};

DG.Control.Zoom.Dictionary.cs = {
    zoom_in : 'Přiblížit',
    zoom_out : 'Oddálit'
};

DG.Control.Zoom.Dictionary.en = {
    zoom_in : 'Zoom in',
    zoom_out : 'Zoom out'
};

DG.Control.Zoom.Dictionary.es = {
    zoom_in : 'Acercar',
    zoom_out : 'Alejar'
};

DG.Control.Zoom.Dictionary.ar = {
    zoom_in : '',
    zoom_out : ''
};

var dust = _dereq_('dustjs-linkedin');
_dereq_('dustjs-helpers');

DG.dust = function(name, data) {
    var result;

    // The callback is called synchronously, so this works
    dust.render(name, data, function(err, html) {
        result = html;
    });

    return result;
};

/**
 * Компонент отвечающий за копирайт на карте. В нем выводяться различные ссылки плюс логотип или кнопка.
 *
 * 1. Если в опциях карты передан logotype: true то будет логотип 2GIS
 * 2. Если на карте нет маркеров, то будет кнопка "Открыть в 2ГИС" и ссылка на 2ГИС (openLink2gis config.main.json)
 * 3. Если на карте есть 1 маркер, то будет кнопка "Доехать с 2ГИС" и ссылка на 2ГИС с параметрами для построения маршрута до этого маркера (ppLink2gis config.main.json)
 *
 * Компонент подписывается на события добавления и удаления слоев в карте, метод _mapEvents).
 * Если добавляется/удаляется маркер, то он добавляется/удаляется в массив _markers,
 * а затем первый маркер из этого массива сохраняется в _markerToRoute.
 * Поиск проезда будет предлагаться до маркера _markerToRoute.
 */

DG.Control.Attribution.include(DG.Locale);
DG.Control.Attribution.Dictionary = {};
DG.Control.Attribution.include({
    options: {
        position: 'bottomright'
    },

    _getLink: function(linkType) {
        /* eslint-disable camelcase */
        var dictionary = {
            ru: {
                copyright_logo: 'https://2gis.ru/?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_apilink: 'https://dev.2gis.ru/?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_license: 'https://law.2gis.ru/api-rules/',
                open_link: 'https://2gis.ru',
            },

            kz: {
                copyright_logo: 'https://2gis.kz/?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_apilink: 'https://dev.2gis.kz/?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_license: 'https://law.2gis.kz/api-rules/',
                open_link: 'https://2gis.kz',
            },

            it: {
                copyright_logo: 'https://2gis.it/?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_apilink: 'https://dev.2gis.com/?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_license: 'https://law.2gis.it/licensing-agreement/',
                open_link: 'https://2gis.ru',
            },

            cz: {
                copyright_logo: 'https://praha.2gis.cz/?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_apilink: 'https://dev.2gis.com/?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_license: 'https://law.2gis.cz/api-rules/',
                open_link: 'https://2gis.ru',
            },

            cl: {
                copyright_logo: 'https://santiago.2gis.cl/?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_apilink: 'https://dev.2gis.com/?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_license: 'https://law.2gis.cl/api-rules/',
                open_link: 'https://2gis.ru',
            },

            cy: {
                copyright_logo: 'https://info.2gis.com.cy/lemesos?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_apilink: 'https://dev.2gis.com/?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_license: 'https://law.2gis.com.cy/api-rules/',
                open_link: 'https://2gis.ru',
            },

            ae: {
                copyright_logo: 'https://2gis.ae/dubai?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_apilink: 'http://dev.2gis.com/?utm_source=copyright&utm_medium=map&utm_campaign=partners',
                copyright_license: 'https://law.2gis.ae/api-rules/',
                open_link: 'https://2gis.ae',
            }
        };
        /* eslint-enable camelcase */

        var countryCode = (this._countryCode in dictionary) ? this._countryCode : 'ru';

        return dictionary[countryCode][linkType];
    },

    _markerToRoute: undefined,
    _markers: [],

    _checkMarkerLayers: function() {
        this._markerToRoute = this._markers.length != 1 ? undefined : this._markers[0];
        this._update();
    },

    _mapEvents: {

        layeradd: function(e) {
            if (e.layer instanceof DG.Marker) {
                this._markers.push(e.layer)
                if (this._markers.length <= 2) {
                    this._checkMarkerLayers();
                }
            }
        },

        layerremove: function(e) {
            if (e.layer instanceof DG.Marker) {
                var currentMarkers = [];
                for (var i = 0; i < this._markers.length; i++) {
                    if (this._markers[i] !== e.layer) {
                        currentMarkers.push(this._markers[i])
                    }
                }
                this._markers = currentMarkers;
                if (this._markers.length <= 1) {
                    this._checkMarkerLayers();
                }
            }
        },

    },

    onAdd: function(map) {
        if (!map._copyright) {
            map._copyright = true;
            this._first = true;
        }

        this._isDefaultKey = !map.options.key;
        this._logotype = map.options.logotype;
        this._open2gis = this._getLink('open_link')

        this._map.on(this._mapEvents, this);

        map.attributionControl = this;
        this._container = DG.DomUtil.create('div', 'dg-attribution');
        DG.DomEvent.disableClickPropagation(this._container);

        for (var i in map._layers) {
            if (map._layers[i].getAttribution) {
                this.addAttribution(map._layers[i].getAttribution());
            }
        }

        this._update();

        DG.DomEvent
            .on(this._container, 'touchstart', this._updateLink, this)
        return this._container;
    },

    _updateLink: function(e) {
        if (e.target.name === 'linkButton') {
            this._open2gis = this._getOpenUrl();
            e.target.href = this._open2gis;
        }
    },

    _update: function(lang, countryCode) {
        if (!this._map) { return; }

        if (typeof countryCode !== 'undefined') {
            this._countryCode = countryCode;
        }

        var attribs = [];

        for (var i in this._attributions) {
            if (this._attributions[i]) {
                attribs.push(i);
            }
        }

        var prefixAndAttribs = [],
            copyright = '';

        if (this._first) {
            copyright = this._getAttributionHTML(lang);
        }

        if (this.options.prefix) {
            prefixAndAttribs.push(this.options.prefix);
        }
        if (attribs.length) {
            prefixAndAttribs.push(attribs.join(', '));
        }

        this._container.innerHTML = copyright + prefixAndAttribs.join(' | ');

    },


    _getOpenUrl: function() {
        if (this._markerToRoute) {
            return DG.Util.template(DG.config.ppLink2gis, {
                'gislink': this._getLink('open_link'),
                'center': this._map.getCenter().lng + ',' + this._map.getCenter().lat,
                'zoom': this._map.getZoom(),
                'rsType': this._map.getZoom() > 11 ? 'bus' : 'car',
                'point': this._markerToRoute._latlng.lng + ',' + this._markerToRoute._latlng.lat
            });
        }

        return DG.Util.template(DG.config.openLink2gis, {
            'gislink': this._getLink('open_link'),
            'center': this._map.getCenter().lng + ',' + this._map.getCenter().lat,
            'zoom': this._map.getZoom(),
        });
    },
    _getData: function(lang) {
        lang = lang || this._map.getLang();
        var btn =
        {
            name: 'open',
            label: this._markerToRoute ? this.t('route_on') : this.t('open_on'),
        }

        // Do not show link button if button don't have translate to current language or map options logotype set true
        var isHideButton = btn.label == 'open_on' || btn.label == 'route_on' || this._logotype;

        return {
            'logotype': isHideButton,
            'work_on': this.t('work_on'),
            'has_no_key': this._isDefaultKey ? this.t('has_no_key') : null,
            'lang': lang,
            'copyright_apilink': this._getLink('copyright_apilink'),
            'copyright_license': this._getLink('copyright_license'),
            'copyright_logo': this._getLink('copyright_logo'),
            'open2gis_link': this._open2gis,
            'open2gis_name': 'linkButton',
            'license_agreement': this.t('license_agreement'),
            'dir': lang !== 'ar' ? 'ltr' : 'rtl',
            'btn': btn
        };
    },
    _getAttributionHTML: function(lang) {
        return DG.dust('DGAttribution/copyright', this._getData(lang));
    },
    _renderTranslation: function(e) {
        this._update(e.lang);
    }
});

DG.Map.addInitHook(function() {
    if (!this._copyright) {
        DG.control.attribution().addTo(this);
    }
});

DG.Control.Attribution.Dictionary.ru = {
    license_agreement: 'Лицензионное соглашение',
    work_on: 'Работает на API 2ГИС',
    has_no_key: 'Для корректной работы Raster JS API нужен ключ. Помощь: api@2gis.ru',
    open_on: 'Открыть в 2ГИС',
    route_on: 'Доехать с 2ГИС'
};

DG.Control.Attribution.Dictionary.it = {
    license_agreement : 'Accordo di licenza',
    has_no_key: 'È richiesta una chiave per il corretto funzionamento di Raster JS API. Aiuto: api@2gis.ru',
    work_on: '2GIS API'
};

DG.Control.Attribution.Dictionary.cs = {
    license_agreement: 'Licenční smlouva',
    has_no_key: 'Pro správnou funkci Raster JS API je vyžadován klíč. Pomoc: api@2gis.ru',
    work_on: 'Pracuje na API 2GIS'
};

DG.Control.Attribution.Dictionary.en = {
    license_agreement: 'License agreement',
    has_no_key: 'A key is required for proper operation of Raster JS API. Help: api@2gis.ru',
    work_on: 'Uses 2GIS API'
};

DG.Control.Attribution.Dictionary.es = {
    license_agreement : 'Acuerdo de licencia',
    has_no_key: 'Se requiere una clave para el funcionamiento correcto de Raster JS API. Ayuda: api@2gis.ru',
    work_on: '2GIS API'
};

DG.Control.Attribution.Dictionary.ar = {
    license_agreement: 'إتفاقية ترخيص',
    work_on: 'يعمل بتطبيق 2GIS',
    has_no_key: 'مطلوب مفتاح للتشغيل الصحيح لـ Raster JS API. المساعدة: api@2gis.ru',
    open_on: 'Open in 2GIS',
    route_on: 'Route on 2GIS'
};

DG.Control.Location = DG.RoundControl.extend({

    statics: {
        Dictionary: {}
    },

    options: {
        iconClass: 'locate',
        position: DG.Browser.mobile ? 'bottomright' : 'topleft',
        drawCircle: true,
        follow: true,  // follow with zoom and pan the user's location
        stopFollowingOnDrag: false, // if follow is true, stop following when map is dragged
        metric: true,
        onLocationError: function(/*err*/) {
            // this event is called in case of any location error
            // that is not a time out error.
            // console.log(err.message);
        },
        onLocationOutsideMapBounds: function(/*context*/) {
            // this event is repeatedly called when the location changes
            // console.log(context.t('outsideMapBoundsMsg'));
        },
        locateOptions: {}
    },

    initialize: function(options) {
        DG.Util.setOptions(this, options);

        if (!navigator.geolocation) {
            this._disable = true;
            return;
        }

        this._event = undefined;

        this._locateOptions = {
            watch: true,  // if you overwrite this, visualization cannot be updated
            setView: true,
            maximumAge: Infinity,
            maxZoom: Infinity
        };
        DG.extend(this._locateOptions, this.options.locateOptions);

        this._resetVariables();

        this.on({
            'click': this._handleLocate,
            'add': this._initLocate
        });
    },

    _initLocate: function() {
        this._layer = new DG.LayerGroup();
        this._layer.addTo(this._map);

        // event hooks
        this._map.on({
            'locationfound': this._onLocationFound,
            'locationerror': this._onLocationError
        }, this);
    },

    _handleLocate: function() {
        if (this._active && (!this._event ||
            (this._map.getBounds().contains(this._event.latlng) ||
            this._isOutsideMapBounds()))) {
            this._stopLocate();
        } else {
            this._locateOnNextLocationFound = true;

            if (!this._active) {
                this._map.locate(this._locateOptions);
            }

            this._active = true;

            if (this.options.follow) {
                this._startFollowing();
            }

            this._clearError();

            if (this._event) {
                this._visualizeLocation();
            } else {
                this.setState('requesting');
            }
        }
    },

    _onLocationFound: function(e) {
        // no need to do anything if the location has not changed
        if (this._event &&
            (this._event.latlng.lat === e.latlng.lat &&
             this._event.latlng.lng === e.latlng.lng &&
             this._event.accuracy === e.accuracy)) {
            return;
        }

        if (!this._active) {
            return;
        }

        this._event = e;

        if (this.options.follow && this._following) {
            this._locateOnNextLocationFound = true;
        }

        this._visualizeLocation();
    },

    _startFollowing: function() {
        this._following = true;
        if (this.options.stopFollowingOnDrag) {
            this._map.on('dragstart', this._stopFollowing, this);
        }
    },

    _stopFollowing: function() {
        this._following = false;
        if (this.options.stopFollowingOnDrag) {
            this._map.off('dragstart', this._stopFollowing, this);
        }
        this._visualizeLocation();
    },

    _isOutsideMapBounds: function() {
        if (this._event === undefined) {
            return false;
        }
        return this._map.options.maxBounds &&
            !this._map.options.maxBounds.contains(this._event.latlng);
    },

    _visualizeLocation: function() {
        if (this._event.accuracy === undefined) {
            this._event.accuracy = 0;
        }

        var radius = this._event.accuracy;

        if (this._locateOnNextLocationFound) {
            if (this._isOutsideMapBounds()) {
                this.options.onLocationOutsideMapBounds(this);
            } else if (this._locateOptions.setView) {
                var project = this._map.projectDetector.getProject();
                var zoom = project ? project.maxZoom : DG.config.projectLeaveMaxZoom;
                zoom = Math.min(this._locateOptions.maxZoom, zoom);
                this._map.setView(this._event.latlng, zoom);
            }
            this._locateOnNextLocationFound = false;
        }

        // circle with the radius of the location's accuracy
        var style = {
            clickable: false,
            color: '#FFF',
            fillColor: '#FFF',
            fillOpacity: 0.4,
            weight: 0,
            opacity: 0.3
        };
        if (this.options.drawCircle) {
            if (!this._circle) {
                this._circle = DG.circle(this._event.latlng, radius, style)
                    .addTo(this._layer);
            } else {
                this._circle.setLatLng(this._event.latlng).setRadius(radius);
            }
        }

        var markerClass = 'dg-location__pin';

        markerClass += this._following ? (' ' + markerClass + 'state_following') : '';
        // small inner marker
        var m = {
            icon: DG.divIcon({
                className: markerClass,
                iconSize: [20, 20]
            })
        };

        if (!this._marker) {
            this._marker = DG.marker(this._event.latlng, m)
                .bindLabel(this.t('you_are_here'))
                .addTo(this._layer);
        } else {
            this._marker.setLatLng(this._event.latlng);
        }

        DG.DomEvent.on(this._marker, 'click', function() {
            this._map.fireEvent('dgLocateClick');
        }, this);

        if (!this._container) {
            return;
        }

        this.setState('active');
    },

    _resetVariables: function() {
        this._active = false;
        this._following = false;
    },


    _stopLocate: function() {
        this._map.stopLocate();
        this._map.off('dragstart', this._stopFollowing);

        this.setState();
        this._resetVariables();

        this._layer.clearLayers();
        this._marker = undefined;
        this._circle = undefined;
        this._event = undefined;
    },

    _onLocationError: function(err) {
        // ignore time out error if the location is watched
        if (err.code === 3 && this._locateOptions.watch) {
            return;
        }

        this._stopLocate();
        this._error = DG.DomUtil.create('div', 'dg-label dg-label_name_location-error', this._container);
        this._errorText = DG.DomUtil.create('div', 'dg-label__content', this._error);
        this._errorText.innerHTML = this.t('cant_find');

        var self = this;
        setTimeout(function() {
            self._clearError();
        }, 3000);

        //show location error
        this.options.onLocationError(err);
    },

    _clearError: function() {
        if (this._error) {
            this._container.removeChild(this._error);
            this._error = undefined;
            this._errorText = undefined;
        }
    },

    _renderTranslation: function() {
        if (this._link) {
            this._link.title = this.t('button_title');
        }
        if (this._marker) {
            this._marker.bindLabel(this.t('you_are_here'));
        }
    }
});

DG.control.location = function(options) {
    return new DG.Control.Location(options);
};

DG.Map.addInitHook(function() {
    if (this.options.locationControl) {
        this.locationControl = DG.control.location(this.options.locationControl);
        this.addControl(this.locationControl);
    }
});

DG.Control.Location.Dictionary.ru = {
    cant_find : 'Мы не смогли Вас найти',
    you_are_here : 'Вы здесь',
    button_title : 'Найти Вас на карте'
};

DG.Control.Location.Dictionary.it = {
    cant_find : 'Non siamo riusciti a localizzarti',
    you_are_here : 'Voi siete qui',
    button_title : 'Trova la tua posizione sulla mappa'
};

DG.Control.Location.Dictionary.cs = {
    cant_find : 'Nepodařilo se nám určit Vaši polohu',
    you_are_here : 'Jste tady',
    button_title : 'Určit Vaši polohu na mapě'
};

DG.Control.Location.Dictionary.en = {
    cant_find : 'We can\'t find you',
    you_are_here : 'You are here',
    button_title : 'Show your location'
};

DG.Control.Location.Dictionary.es = {
    cant_find : 'No pudimos encontrarte',
    you_are_here : 'Tú estás aquí',
    button_title : 'Encontrarte en el mapa'
};

DG.Control.Location.Dictionary.ar = {
    cant_find : 'لم نستطع تحديد موقعك',
    you_are_here : 'أنت هنا',
    button_title : 'موقعي'
};

// Inspired by Sindre Sorhus screenfull
DG.Screenfull = DG.Class.extend({
    _apiMap: [
        [
            'requestFullscreen',
            'exitFullscreen',
            'fullscreenElement',
            'fullscreenEnabled',
            'fullscreenchange',
            'fullscreenerror'
        ],
        [
            'webkitRequestFullscreen',
            'webkitExitFullscreen',
            'webkitFullscreenElement',
            'webkitFullscreenEnabled',
            'webkitfullscreenchange',
            'webkitfullscreenerror'

        ],
        [
            'mozRequestFullScreen',
            'mozCancelFullScreen',
            'mozFullScreenElement',
            'mozFullScreenEnabled',
            'mozfullscreenchange',
            'mozfullscreenerror'
        ],
        [
            'msRequestFullscreen',
            'msExitFullscreen',
            'msFullscreenElement',
            'msFullscreenEnabled',
            'MSFullscreenChange',
            'MSFullscreenError'
        ]
    ],

    initialize: function() {
        this.api = this._api();
    },

    request: function(elem) {
        var request = this.api.requestFullscreen;

        elem = elem || document.documentElement;
        elem[request](Element.ALLOW_KEYBOARD_INPUT);
    },

    exit: function() {
        document[this.api.exitFullscreen]();
    },

    isFullscreen: function() {
        return !!document[this.api.fullscreenElement];
    },

    isAvailable: function() {
        return Boolean(this.api);
    },

    _api: function() {
        var api = {},
            apiMap = this._apiMap;

        apiMap.forEach(function(val) {
            if (val && val[1] in document) {
                val.forEach(function(method, i) {
                    api[apiMap[0][i]] = method;
                });
            }
        });

        return api.requestFullscreen ? api : false;
    }
});

DG.screenfull = new DG.Screenfull();

DG.Control.Fullscreen = DG.RoundControl.extend({

    statics: {
        Dictionary: {}
    },

    options: {
        position: 'topright',
        iconClass: 'fullscreen'
    },

    initialize: function(options) {
        DG.Util.setOptions(this, options);
        this._isFullscreen = false;
        this.on('click', this._toggleFullscreen);
    },

    _toggleFullscreen: function() {
        if (!this._isFullscreen) {
            this._toggle(true, 'request', 'on', 'requestfullscreen');
        } else {
            this._toggle(false, 'exit', 'on', 'cancelfullscreen');
        }

        this._renderTranslation();
        this._map.invalidateSize();
    },

    _renderTranslation: function() {
        this._link.title = this.t(this._isFullscreen ? 'title_min' : 'title_max');
    },

    _toggle: function(isEnabled, method, list, event) {
        var container = this._map._container;

        this._isFullscreen = isEnabled;
        this.setState(isEnabled ? 'active' : '');

        DG.screenfull[method](container);
        DG.DomEvent[list](document, DG.screenfull.api.fullscreenchange, this._onFullScreenStateChange, this);
        this._map.fire(event);
    },

    _onFullScreenStateChange: function() {
        if (!DG.screenfull.isFullscreen()) {
            this._toggle(false, 'exit', 'on', 'cancelfullscreen');
        }
    }
});

DG.control.fullscreen = function(options) {
    return new DG.Control.Fullscreen(options);
};

DG.Map.mergeOptions({
    fullscreenControl: true
});

DG.Map.addInitHook(function() {
    if (this.options.fullscreenControl) {
        this.fullscreenControl = DG.control.fullscreen(this.options.fullscreenControl);

        if (DG.screenfull.isAvailable()) {
            this.addControl(this.fullscreenControl);
        }
    }
});

DG.Control.Fullscreen.Dictionary.ru = {
    title_max : 'Развернуть',
    title_min : 'Восстановить'
};

DG.Control.Fullscreen.Dictionary.it = {
    title_max : 'Espandi',
    title_min : 'Ripristina'
};

DG.Control.Fullscreen.Dictionary.cs = {
    title_max : 'Rozbalit',
    title_min : 'Obnovit'
};

DG.Control.Fullscreen.Dictionary.en = {
    title_max : 'Expand',
    title_min : 'Restore'
};

DG.Control.Fullscreen.Dictionary.es = {
    title_max : 'Maximizar',
    title_min : 'Restaurar'
};

DG.Control.Fullscreen.Dictionary.ar = {
    title_max : '',
    title_min : ''
};

DG.Meta = {};

DG.Meta.Layer = DG.Layer.extend({

    options: {
        tileSize: 256,

        minZoom: 0,
        maxZoom: 20,
        zoomOffset: 0,
        eventBubbling: 'transparent'
        // maxNativeZoom: <Number>,
        // detectRetina: <Number>,
        // zoomReverse: <Number>
        // attribution: <String>,
        // zIndex: <Number>,
        // bounds: <LatLngBounds>
    },

    initialize: function(source, options) { // (String, Object)
        DG.TileLayer.prototype.initialize.call(this, null, options);
        delete this._url;

        this._currentTileKey = '';
        this._currentTileData = [];
        this._lastEntity = undefined;
        this._dispatchMouseEvents = true;

        this._origin = DG.Meta.origin(source, {
            dataFilter: this.options.dataFilter
        });
    },

    getOrigin: function() { // () -> Object
        return this._origin;
    },

    onAdd: function(map) {
        this._resetView();

        map.metaLayers.push(this);

        map.on('rulerstart', this._disableDispatchMouseEvents, this);
        map.on('rulerend', this._enableDispatchMouseEvents, this);

        var self = this;

        if (DG.Browser.touchEnabled && this.options.isPoi) {
            map.eachLayer(function(layer) {
                if (layer instanceof L.TileLayer) {
                    // On every tile will be load meta tile.
                    layer.on('tileloadstart', self._onTileLoadStart, self);
                    // Load metatiles for already loaded tiles.
                    for (var tile in layer._tiles) {
                        self._onTileLoadStart({
                            coords: layer._tiles[tile].coords
                        });
                    }
                }
            });
        }
    },

    onRemove: function(map) {
        var self = this;

        if (DG.Browser.touchEnabled && this.options.isPoi) {
            map.eachLayer(function(layer) {
                if (layer instanceof L.TileLayer) {
                    // On every tile will be load meta tile.
                    layer.off('tileloadstart', self._onTileLoadStart);
                }
            });
        }

        this._tileZoom = null;

        var index = map.metaLayers.indexOf(this);
        if (index !== -1) {
            map.metaLayers.splice(index, 1);
        }

        map.off('rulerstart', this._disableDispatchMouseEvents, this);
        map.off('rulerend', this._enableDispatchMouseEvents, this);
    },

    getEvents: function() {
        return {
            viewprereset: this._invalidateAll,
            viewreset: this._resetView,
            zoom: this._resetView,
            moveend: this._onMoveEnd
        };
    },

    setUrl: function(url) {
        this._currentTileKey = '';
        this._currentTileData = [];
        this._lastEntity = undefined;
        this._dispatchMouseEvents = true;
        this._origin.setURL(url, true);
    },

    getHoveredObject: function(event) {
        var tileSize = this.getTileSize(),
            layerPoint = this._map.mouseEventToLayerPoint(event.originalEvent),
            tileOriginPoint = this._map.getPixelOrigin().add(layerPoint),
            tileCoord = tileOriginPoint.unscaleBy(tileSize).floor(),
            mouseTileOffset = DG.point(tileOriginPoint.x % tileSize.x, tileOriginPoint.y % tileSize.y),
            tileKey,
            zoom = this._map.getZoom(),
            self = this;

        if (zoom > (this.options.maxZoom + this.options.zoomOffset) ||
            zoom < (this.options.minZoom - this.options.zoomOffset) ||
            !this._isValidTile(tileCoord)) {
            return;
        }

        this._wrapCoords(tileCoord);

        tileCoord.z = this._getZoomForUrl();
        tileCoord.key = tileSize.x + 'x' + tileSize.y;
        tileCoord.apiKey = self._map.options.key;
        tileKey = this._origin.getTileKey(tileCoord);

        if (tileKey === this._currentTileKey) {
            self._lastEntity = self._getHoveredObject(mouseTileOffset);
        } else {
            this._origin.getTileData(tileCoord, function(tileData) {
                self._currentTileKey = tileKey;
                self._currentTileData = tileData;
                self._lastEntity = self._getHoveredObject(mouseTileOffset);
            });
        }

        return this._lastEntity;
    },

    _removeAllTiles: DG.GridLayer.prototype._removeAllTiles,
    _getZoomForUrl: DG.TileLayer.prototype._getZoomForUrl,
    getTileSize: DG.TileLayer.prototype.getTileSize,
    _isValidTile: DG.GridLayer.prototype._isValidTile,
    _wrapCoords: DG.GridLayer.prototype._wrapCoords,
    _resetView: DG.GridLayer.prototype._resetView,
    _resetGrid: DG.GridLayer.prototype._resetGrid,
    _invalidateAll: DG.GridLayer.prototype._invalidateAll,
    _pxBoundsToTileRange: DG.GridLayer.prototype._pxBoundsToTileRange,

    // Fix for https://github.com/Leaflet/Leaflet/compare/0726f12bbf33fcb18fe8bb541d5e3212bb1f5ab2...c263f2d8b1bd962b60474376cc4816a688052513#diff-f1e6be67599c594731fff6191c710420L579
    _onMoveEnd: function() {
        if (!this._map || this._map._animatingZoom) { return; }

        this._resetView();
    },

    _onTileLoadStart: function(e) {
        var tileSize = this.getTileSize();
        e.coords.key = tileSize.x + 'x' + tileSize.y;
        this._origin.getTileData(e.coords);
    },

    _enableDispatchMouseEvents: function() {
        this._dispatchMouseEvents = true;
    },

    _disableDispatchMouseEvents: function() {
        this._dispatchMouseEvents = false;
    },

    mapEvents: {
        mousemove: function(event) {
            this._fireMetalayerEvent('mousemove', event);
        },

        mouseover: function(event) {
            this._fireMetalayerEvent('mouseover', event);
        },

        mouseout: function(event) {
            this._fireMetalayerEvent('mouseout', event);
            this._currentTileKey = '';
        },

        click: function(event) {
            var tileSize = this.getTileSize(),
                layerPoint = this._map.mouseEventToLayerPoint(event.originalEvent),
                tileOriginPoint = this._map.getPixelOrigin().add(layerPoint),
                tileCoord = tileOriginPoint.unscaleBy(tileSize).floor(),
                mouseTileOffset = DG.point(tileOriginPoint.x % tileSize.x, tileOriginPoint.y % tileSize.y);
            tileCoord.z = this._getZoomForUrl();
            tileCoord.key = tileSize.x + 'x' + tileSize.y;
            var tileKey = this._origin.getTileKey(tileCoord);
            var self = this;

            // In this function the tile meta data are processed by metalayer.
            var onTileData = function(currentTileData) {
                self._currentTileData = currentTileData;
                self._currentTileKey = tileKey;
                self._lastEntity = self._getHoveredObject(mouseTileOffset);
                self._mouseDown = false;

                if (self._lastEntity) {
                    event.entity = self._lastEntity;
                    self._fireMetalayerEvent('click', event);
                }
            }

            // For more information about the code below see:
            // https://github.com/2gis/mapsapi/pull/501
            this._origin.getTileData(tileCoord, function(tileData) {
                if (tileData) {
                    onTileData(tileData);
                } else if (self._origin._requests[tileKey]) {
                    DG.DomEvent.stop(event);
                    self._origin._requests[tileKey].then(function() {
                        delete event.originalEvent._stopped;
                        onTileData(self._origin._tileStorage[tileKey]);
                        if (!event.originalEvent._stopped) {
                            var targets = event.eventTargets;
                            for (var i = event.eventTargetsMapIndex; i < targets.length; i++) {
                                targets[i].fire('click', event, true);
                                if (
                                    event.originalEvent._stopped ||
                                    (targets[i].options.nonBubblingEvents &&
                                    L.Util.indexOf(targets[i].options.nonBubblingEvents, 'click') !== -1)
                                ) {
                                    return;
                                }
                            }
                        }
                    });
                }
            });
        },

        dblclick: function(event) {
            this._fireMetalayerEvent('dblclick', event);
        },

        mousedown: function(event) {
            this._mouseDown = true;
            this._fireMetalayerEvent('mousedown', event);
        },

        contextmenu: function(event) {
            this._fireMetalayerEvent('contextmenu', event);
        }
    },

    _fireMetalayerEvent: function(type, mouseEvent) {
        if (!mouseEvent.entity || !this._dispatchMouseEvents) {
            return;
        }
        this.fire(type, {
            meta: mouseEvent.entity,
            latlng: this._map.mouseEventToLatLng(mouseEvent.originalEvent)
        });
        var isDragging = type === 'mousedown' || (this._mouseDown && type === 'mousemove');
        if (this.options.eventBubbling === 'layer' && !isDragging) {
            DG.DomEvent.stop(mouseEvent);
        }
    },

    _getHoveredObject: function(mouseTileOffset) {
        if (!this._currentTileData) {
            return;
        }

        for (var i = 0; i < this._currentTileData.length; i++) {
            if (DG.PolyUtil.inside(mouseTileOffset, this._currentTileData[i].geometry, this._pointReduceHelper)) {
                return this._currentTileData[i];
            }
        }
    },

    _pointReduceHelper: function(point) {
        return [point.x, point.y];
    },

    _setView: function(center, zoom, noPrune, noUpdate) {
        var tileZoom = Math.round(zoom),
            tileZoomChanged = this._tileZoom !== tileZoom;

        if (!noUpdate && tileZoomChanged) {
            this._tileZoom = tileZoom;
            this._resetGrid();
        }
    }
});

DG.Meta.layer = function(source, options) {
    return new DG.Meta.Layer(source, options);
};

DG.Meta.Origin = DG.Class.extend({

    options: {
        subdomains: '0123',
        dataFilter: null
    },

    _url: false,

    initialize: function(url, options) { // (String, Object)
        this._url = url;
        this._requests = {};

        this._tileStorage = {};

        options = DG.setOptions(this, options);

        if (typeof options.subdomains === 'string') {
            options.subdomains = options.subdomains.split('');
        }
    },

    getTileData: function(coord, clb) { // (Object) -> Object
        var tileKey = this.getTileKey(coord),
            self = this,
            callback = typeof clb === 'function' ? clb : function() {};

        // if the tile meta data request in progress, this function returns false, it is therefore synchronous.
        if (typeof this._tileStorage[tileKey] === 'undefined' && typeof this._requests[tileKey] === 'undefined') {
            this._tileStorage[tileKey] = false;
            var currentRequest = this._requests[tileKey] = this._requestData(coord).then(function(data) {
                if (self._requests[tileKey] !== currentRequest) {
                    callback(false);
                    return;
                }
                self.setTileData(tileKey, self.options.dataFilter ? self.options.dataFilter(data, coord) : data);
                delete self._requests[tileKey];
                callback(self._tileStorage[tileKey]);
            });
        } else {
            callback(this._tileStorage[tileKey]);
        }
    },

    setTileData: function(key, data) { // (Object/String, Object) -> Object
        if (typeof key !== 'string') {
            key = this.getTileKey(key);
        }

        data.forEach(function(entity) {
            if (entity.geometry.constructor !== Object) {
                entity.geometry = DG.Wkt.toGeoJSON(entity.geometry);
            }
            if (!this._tileStorage[key]) {
                this._tileStorage[key] = [];
            }
            this._tileStorage[key].push(entity);
        }, this);

        return this;
    },

    flush: function() { // () -> Object
        this._tileStorage = {};
        Object.keys(this._requests).forEach(function(tileKey) {
            if (this[tileKey].abort) {
                this[tileKey].abort();
            }
        }, this._requests);
        this._requests = {};

        return this;
    },

    setURL: function(url, flush) { // (String, Boolean) -> Object
        this._url = url;
        if (flush) {
            this.flush();
        }

        return this;
    },

    getTileKey: function(coord) { // (Object)-> String
        return [coord.x, coord.y, coord.z, coord.key].join(':');
    },

    _requestData: function(key) { // (String)
        if (this._url) {
            return this._performRequest(key);
        } else {
            return Promise.resolve([]);
        }
    },

    _performRequest: function(coords) { // (Object) -> Promise
        return DG.ajax(this._prepareURL(coords), {
            type: 'get',
            dataType: 'json'
        });
    },

    _prepareURL: function(coords) { // (Object) -> String
        return DG.Util.template(this._url, {
            x: coords.x,
            y: coords.y,
            z: coords.z,
            s: this._getSubdomain(coords),
            key: coords.apiKey
        });
    },

    _getSubdomain: DG.TileLayer.prototype._getSubdomain

});

DG.Meta.origin = function(source, options) {
    return new DG.Meta.Origin(source, options);
};

DG.Map.mergeOptions({
    poi: true
});

DG.Poi = DG.Handler.extend({

    options: {
        disableLabel: false
    },

    initialize: function(map, options) { // (Object)
        this._map = map;
        DG.Util.setOptions(this, options);

        var url = DG.config.protocol + (DG.Browser.retina ? DG.config.retinaPoiMetaServer : DG.config.poiMetaServer);

        this._metaLayer = DG.Meta.layer(url, {
            minZoom: DG.config.poiLayerMinZoom,
            maxNativeZoom: 19,
            detectRetina: DG.config.detectRetina,
            eventBubbling: 'layer',
            dataFilter: DG.bind(this._processData, this),
            isPoi: true
        });

        this._currentTilesLang = ''; // 'ar' | ''
    },

    addHooks: function() {
        this._map.addLayer(this._metaLayer);
        if (!this.options.disableLabel) {
            this._labelHelper = DG.label();
        }
        this._metaLayer.on(this._layerEventsListeners, this);
        this._map.on('langchange', this._updateUrl, this);
        this._map.on('projectchange', this._updateUrl, this);
        this._map.on('projectleave', this._updateUrl, this);
    },

    removeHooks: function() {
        this._map.removeLayer(this._metaLayer);
        if (!this.options.disableLabel) {
            this._map.removeLayer(this._labelHelper);
            this._labelHelper = null;
        }
        this._metaLayer.off(this._layerEventsListeners, this);
        this._map.off('langchange', this._updateUrl, this);
        this._map.off('projectchange', this._updateUrl, this);
        this._map.off('projectleave', this._updateUrl, this);
    },

    getMetaLayer: function() {
        return this._metaLayer;
    },

    _updateUrl: function() {
        var url = DG.config.protocol + (DG.Browser.retina ? DG.config.retinaPoiMetaServer : DG.config.poiMetaServer);
        var arabicUrl = DG.config.protocol +
            (DG.Browser.retina ? DG.config.arabicRetinaPoiMetaServer : DG.config.arabicPoiMetaServer);
        var lang = this._map.getLang();
        var project = this._map.projectDetector && this._map.projectDetector.getProject();

        // Change POI for Arabic language in Dubai project
        if (this._currentTilesLang === '' && lang === 'ar' && project && project.country_code === 'ae') {
            this._currentTilesLang = 'ar';
            this._metaLayer.setUrl(arabicUrl);

        } else if (this._currentTilesLang === 'ar' && (lang !== 'ar' || (!project || project.country_code !== 'ae'))) {
            this._currentTilesLang = '';
            this._metaLayer.setUrl(url);
        }
    },

    _processData: function(data, coord) {
        var tileOriginPoint = coord.scaleBy(this._metaLayer.getTileSize());
        var polygonLngLatToPoints = DG.bind(this._polygonLngLatToPoints, this, tileOriginPoint, coord.z);

        if (data.responseText === '') {
            return [];
        }

        return data.result.poi
            .map(function(item) {
                var hovers = item.hovers !== undefined
                    ? item.hovers
                    : [item.hover];

                return {
                    id: item.id,
                    hint: item.links[0].name,
                    linked: item.links[0],
                    geometry: hovers.map(DG.Wkt.toGeoJSON),
                };
            })
            .map(function(item) {
                var coordinates = item.geometry.reduce(function(result, item) {
                    if (item.type === 'Polygon') {
                        result.push(polygonLngLatToPoints(item.coordinates));
                    } else if (item.type === 'MultiPolygon') {
                        result = result.concat(item.coordinates.map(polygonLngLatToPoints));
                    }

                    return result;
                }, []);

                item.geometry = {
                    type: 'MultiPolygon',
                    coordinates: coordinates,
                };

                return item;
            });
    },

    _polygonLngLatToPoints: function(originPoint, zoom, polygon) {
        var map = this._map;

        return polygon.map(function(contour) {
            return contour.map(function(lngLat) {
                return map
                    .project([lngLat[1], lngLat[0]], zoom).round()
                    .subtract(originPoint);
            });
        });
    },

    _layerEventsListeners : {
        mouseover: function(e) { // (Object)
            this._setCursor('pointer');
            if (e.meta.hint && e.meta.hint.length && !this.options.disableLabel) {
                this._labelHelper
                    .setPosition(e.latlng)
                    .setContent(e.meta.hint)
                    .setZIndexOffset(300);
                this._map.addLayer(this._labelHelper);
            }
            this._map.fire('poihover', {
                latlng: e.latlng,
                meta: e.meta
            });
        },

        mouseout: function(e) {
            this._setCursor('');
            if (!this.options.disableLabel) {
                this._map.removeLayer(this._labelHelper);
            }
            this._map.fire('poileave', {
                latlng: e.latlng,
                meta: e.meta
            });
        },

        mousemove: function(e) { // (Object)
            if (!this.options.disableLabel) {
                this._labelHelper.setPosition(e.latlng);
            }
        }
    },

    _setCursor: function(cursor) { // (String)
        this._map.getContainer().style.cursor = cursor;
    }

});

DG.Map.addInitHook('addHandler', 'poi', DG.Poi);

DG.Map.mergeOptions({
    geoclicker: false
});

DG.Geoclicker = DG.Handler.extend({
    clickCount: 0,
    pendingClick: 0,
    timeout: 250, // should be equal to 'delay' value in DoubleTap event

    initialize: function(map, options) { // (Object)
        this._map = map;
        this._controller = new DG.Geoclicker.Controller(map, options);
    },

    addHooks: function() {
        this._toggleEvents(true);

        this._map
            .on('rulerstart', this._pause, this)
            .on('rulerend', this._unpause, this);
    },

    removeHooks: function() {
        this._toggleEvents();

        this._map
            .off('rulerstart', this._pause, this)
            .off('rulerend', this._unpause, this);
    },

    _checkOpenPopup: function() {
        if (DG.Browser.mobile && this._map._popup &&
            (this._map._popup.options.closeOnClick ||
            this._map.options.closePopupOnClick)) {
            this.popupWasOpen = true;
        }
    },

    _pause: function() {
        this._toggleEvents();
    },

    _unpause: function() {
        // Reenable event handling only in case geoclicker is enabled
        if (this.enabled()) {
            this._toggleEvents(true);
        }
    },

    _toggleEvents: function(flag) {
        this._map[flag ? 'on' : 'off'](this._mapEventsListeners, this);
        if (this._map.poi) {
            this._map.poi.getMetaLayer()[flag ? 'on' : 'off']('click', this._onMetaClick, this);
        }
    },

    getController: function() {
        return this._controller;
    },

    _onMetaClick: function(e) {
        this.clickCount = 0;
        clearTimeout(this.pendingClick);
        this.popupWasOpen = false;

        this._mapEventsListeners.click.call(this, e);
    },

    _mapEventsListeners: {
        langchange: function() {
            this._controller.reinvokeHandler();
        },

        popupclose: function(e) { // (Object)
            this._controller.handlePopupClose(e.popup);
        },

        click: function(e) { // (Object)
            if (this.clickCount === 0) {
                this.clickCount = 1;
                this._singleClick(e);
            } else {
                this.clickCount = 0;
                clearTimeout(this.pendingClick);
                this.popupWasOpen = false;
            }
        },

        dblclick: function() {
            if (DG.Browser.ielt9) {
                this.clickCount = 0;
                this.popupWasOpen = false;
                clearTimeout(this.pendingClick);
            }
        }
    },

    _singleClick: function(e) { // (Object)
        var self = this;

        clearTimeout(this.pendingClick);

        this.pendingClick = setTimeout(function() {
            if (e.meta) {
                self._checkOpenPopup();
                self._map.closePopup();
            }

            //  DGPopup's '_close' method is the only place where .popupWasOpen is modified
            //  It signals geoclicker that popup was open before user do a 'click' on map
            //  Multistage behavior is needed as this processing occurs after popup was already closed
            if (!self.popupWasOpen) {
                var zoom = self._map.getZoom();
                self._controller.handleClick(e.latlng, zoom, e.meta);
            }

            self.clickCount = 0;
            self.popupWasOpen = false;
        }, this.timeout);
    }
});

DG.Map.addInitHook('addHandler', 'geoclicker', DG.Geoclicker);

DG.Geoclicker.clampHelper = function(el, lineClamp) {
    var measure, text, lineWidth,
        lineStart, lineCount, wordStart,
        line, lineText, wasNewLine,
        ce = document.createElement.bind(document),
        ctn = document.createTextNode.bind(document);

    // measurement element is made a child of the clamped element to get it's style
    measure = ce('span');

    (function(s) {
        s.position = 'absolute'; // prevent page reflow
        s.whiteSpace = 'pre'; // cross-browser width results
        s.visibility = 'hidden'; // prevent drawing
        s.margin = '0 18px 8px 0';
    })(measure.style);

    // make sure the element belongs to the document
    if (!el.ownerDocument || el.ownerDocument !== document) {
        return;
    }
    // reset to safe starting values
    lineStart = wordStart = 0;
    lineCount = 1;
    wasNewLine = false;
    lineWidth = el.clientWidth;
    // get all the text, remove any line changes
    text = (el.textContent || el.innerText).replace(/\n/g, ' ');
    // remove all content
    while (el.firstChild !== null) {
        el.removeChild(el.firstChild);
    }
    // add measurement element within so it inherits styles
    el.appendChild(measure);
    // http://ejohn.org/blog/search-and-dont-replace/
    text.replace(/ |-/g, function(m, pos) {
        // ignore any further processing if we have total lines
        if (lineCount === lineClamp) {
            return;
        }
        // create a text node and place it in the measurement element
        measure.appendChild(ctn(text.substr(lineStart, pos - lineStart)));
        // have we exceeded allowed line width?
        if (lineWidth < measure.clientWidth) {
            if (wasNewLine) {
                // we have a long word so it gets a line of it's own
                lineText = text.substr(lineStart, pos + 1 - lineStart);
                // next line start position
                lineStart = pos + 1;
            } else {
                // grab the text until this word
                lineText = text.substr(lineStart, wordStart - lineStart);
                // next line start position
                lineStart = wordStart;
            }
            // create a line element
            line = ce('span');
            // add text to the line element
            line.appendChild(ctn(lineText));
            // add the line element to the container
            el.appendChild(line);
            line.className = 'dg-map-geoclicker__clamped-line';
            // yes, we created a new line
            wasNewLine = true;
            lineCount++;
        } else {
            // did not create a new line
            wasNewLine = false;
        }
        // remember last word start position
        wordStart = pos + 1;
        // clear measurement element
        measure.removeChild(measure.firstChild);
    });
    // remove the measurement element from the container
    el.removeChild(measure);
    // create the last line element
    line = ce('span');
    // give styles required for text-overflow to kick in
    line.className = 'dg-map-geoclicker__clamped-line dg-map-geoclicker__clamped-line_last';
    // add all remaining text to the line element
    line.appendChild(ctn(text.substr(lineStart)));
    // add the line element to the container
    el.appendChild(line);
};

DG.Geoclicker.Provider = {};

DG.Geoclicker.Provider.CatalogApi = DG.Class.extend({
    initialize: function(map) { // (Object)
        this._map = map;

        var apiUrl = DG.config.protocol +
            DG.config.webApiServer + '/' +
            DG.config.catalogVersion + '/';

        this._urlGeoSearch = apiUrl + 'items/geocode';
        this._urlGeoGet = apiUrl + 'items/byid';
        this._urlDetails = apiUrl + 'items/byid';
        this._urlFirmsInHouse = apiUrl + 'items';

        this._key = this._map.options.key || DG.config.geoclickerCatalogApiKey;
        this._geoFields = DG.config.geoAdditionalFields;
        this._firmInfoFields = DG.config.firmInfoFields;
    },

    getLocations: function(options) { // (Object)
        // Callback will receive array of found results or void if errors occurred or nothing was found.
        var zoom = options.zoom,
            latlng = options.latlng,
            hasCatalogKey = options.hasCatalogKey,
            beforeRequest = options.beforeRequest || function() {},
            types = this.getTypesByZoom(zoom),
            q = latlng.lng + ',' + latlng.lat;

        if (!types) {
            return Promise.reject('no type');
        }

        if (hasCatalogKey) {
            beforeRequest();
        }

        return this.geoSearch(q, types, zoom).then(DG.bind(function(result) {
            return this._filterResponse(result, types);
        }, this));
    },

    firmsInHouse: function(houseId, parameters) { // (String, Function, Number)
        parameters = parameters || {};

        /* eslint-disable camelcase */
        var params = {
            building_id: houseId,
            page: parameters.page || 1
        };
        /* eslint-enable camelcase */

        return this._performRequest(params, this._urlFirmsInHouse);
    },

    getFirmInfo: function(firmId) {
        return this._performRequest({
            type: 'filial',
            id: firmId,
            fields: this._firmInfoFields
        }, this._urlDetails);
    },

    geoSearch: function(q, types, zoomlevel) { // (String, String, Number)
        /* eslint-disable camelcase */
        var params = {
            point: q,
            type: types,
            zoom_level: zoomlevel,
            fields: this._geoFields
        };
        /* eslint-enable camelcase */

        return this._performRequest(params, this._urlGeoSearch);
    },

    geoGet: function(id) {
        var params = {
            id: id,
            fields: this._geoFields
        };

        return this._performRequest(params, this._urlGeoGet);
    },

    cancelLastRequest: function() {
        if (this._lastRequest) {
            this._lastRequest.abort();
        }
    },

    getTypesByZoom: function(zoom) { // (Number) -> String|Null
        var types = {
                'adm_div.settlement':   8,
                'adm_div.city':         8,
                'adm_div.division':     11,
                'adm_div.district':     12,
                'street':               14,
                'building':             14,
                'adm_div.place':        15,
                'attraction':           17
            },
            selectedTypes = [];

        Object.keys(types).forEach(function(type) {
            if (zoom >= types[type]) {
                selectedTypes.push(type);
            }
        });

        if (selectedTypes.length) {
            return selectedTypes.join(',');
        } else {
            return null;
        }
    },

    _performRequest: function(params, url) { // (Object, String, Function, Function)
        var data = DG.extend({key: this._key}, params);
        var type = 'get';

        this.cancelLastRequest();

        if (!DG.ajax.corsSupport) {
            type = data.format = 'jsonp';
        }

        this._lastRequest = DG.ajax(url, {
            type: type,
            data: data,
            timeout: this._timeoutMs,
            withCredentials: true
        });

        return this._lastRequest;
    },

    _filterResponse: function(response, allowedTypes) { // (Object, Array) -> Boolean|Object
        var result = {}, i, item, found, data, type;

        if (this._isNotFound(response)) {
            if (response && response.meta && response.meta.code === 403) {
                console.error('The catalog service is unavailable. Please contact api@2gis.com to get the RasterJS API key');
                return response
            }

            return false;
        }

        data = response.result.items;

        for (i = data.length - 1; i >= 0; i--) {
            item = data[i];

            type = item.type;
            if (item.subtype) {
                type += '.' + item.subtype;
            }

            if (allowedTypes && allowedTypes.indexOf(type) === -1) {
                continue;
            }

            result[type] = item;
            found = true;
        }

        if (found) {
            return result;
        } else {
            return false;
        }
    },

    _isNotFound: function(response) { // (Object) -> Boolean
        return !response ||
               !!response.meta && !!response.meta.error ||
               !response.result ||
               !response.result.items ||
               !response.result.items.length;
    }

});

DG.Geoclicker.Handler = {};

DG.Geoclicker.Handler.Default = DG.Class.extend({

    includes: DG.Locale,

    statics: {
        Dictionary: {}
    },

    _eventHandlers: {},

    initialize: function(controller, view, map) { // (Object, Object, Object)
        this._controller = controller;
        this._view = view;
        this._map = map;
    },

    handle: function() { // () -> Promise
        return Promise.resolve({
            tmpl: 'popupHeader',
            data: {'title': this.t('we_have_not')}
        });
    },

    addClickEvent: function() {
        this._view._popup.on('click', this._runEventHandlers, this);
        this._map.once('popupclose', this._removeClickEvent, this);
    },

    _removeClickEvent: function() {
        this._view._popup.off('click', this._runEventHandlers, this);
    },

    _addEventHandler: function(el, handler) { // (String, Function)
        this._eventHandlers[el] = handler;
    },

    _runEventHandlers: function(e) {
        var target = e.originalEvent.target;

        for (var eventClass in this._eventHandlers) {
            if (this._eventHandlers.hasOwnProperty(eventClass) && target.className.indexOf(eventClass) > -1) {
                DG.DomEvent.preventDefault(e.originalEvent);
                this._eventHandlers[eventClass].call(this, target);
                return;
            }
        }
    },

    _clearEventHandlers: function() {
        this._eventHandlers = {};
    },

    _getDirectionsUrl: function(name) {
        var project = this._map.projectDetector.getProject();
        if (!project) {
            return '';
        }

        return DG.Util.template(DG.config.ppnotLink, {
            'domain': project.domain,
            'projectCode': project.code,
            'center': this._map.getCenter().lng + ',' + this._map.getCenter().lat,
            'zoom': this._map.getZoom(),
            'name': encodeURIComponent(name),
            'rsType': project.transport ? 'bus' : 'car',
            'point': this._popup._latlng.lng + ',' + this._popup._latlng.lat
        });
    },

    _getDrilldown: function(object) {
        var admDivs = [],
            result;

        if (object.adm_div) {
            admDivs = object.adm_div
                .reduce(function(admDivs, admDiv) {
                    if (admDiv.name) {
                        admDivs.push(admDiv.name);
                    }

                    return admDivs;
                }, [])
                .reverse();
        }

        if (admDivs.length && object.address && object.address.postcode) {
            admDivs.push(object.address.postcode);
        }

        result = admDivs.join(', ');

        return result;
    }

});


DG.Geoclicker.Handler.HandlerExample = DG.Geoclicker.Handler.Default.extend({

    handle: function(results, type) { // (Object, String) -> Promise
        return Promise.resolve({
            tmpl: type + ':<br/>' + results[type].id
        });
    }
});

DG.Geoclicker.Handler.ApiError = DG.Geoclicker.Handler.Default.extend({
    handle: function() { // () -> Promise
        var header = this._view.render({
            tmpl: 'popupHeader',
            data: {
                title: this.t('apiErrorTitle')
            }
        });

        return Promise.resolve({
            header: header,
            tmpl: this.t('apiErrorBody')
        });
    }
});

DG.Geoclicker.Handler.CityArea = DG.Geoclicker.Handler.Default.extend({

    _polylineStyleDefault : {
        fillColor: '#ff9387',
        color: '#ff9387',
        noClip: true,
        opacity: 1
    },

    _polylineStyles : {
        11 : {
            fillOpacity: 0.18,
            weight: 1
        },
        12 : {
            fillOpacity: 0.12,
            weight: 1
        },
        13 : {
            fillOpacity: 0.08,
            weight: 2
        },
        18 : {
            fillOpacity: 0,
            weight: 3
        }
    },

    handle: function(results, type) { // (Object, String) -> Promise
        if (!results[type]) {
            return false;
        }

        if (!this._stylesInited) {
            this._initStyles();
        }

        // remove previous geometry see https://github.com/2gis/mapsapi/issues/213
        if (this._geometry) {
            this._map.removeLayer(this._geometry);
        }

        this._popup = this._view.getPopup();

        this._geometryZoomStyle = this._getPolyStyleNum();
        this._geometry = DG.Wkt.geoJsonLayer(results[type].geometry.selection, {
            style: this._polylineStyles[this._geometryZoomStyle],
            interactive: false
        }).addTo(this._map);

        this._map
            .on('zoomend', this._updateGeometry, this)
            .once('popupclose', this._clearPopup, this);

        return Promise.resolve(this._fillCityAreaObject(results, type));
    },

    _fillCityAreaObject: function(results, type) {
        var data = {
            name: this.t('noname'),
            drilldown: '',
            purpose: this.t(type),
            type: type.split('.').join('_')
        };

        data.drilldown = this._getDrilldown(results[type]);

        if (results[type].name) {
            data.name = results[type].name;
        }

        return {
            tmpl: 'cityarea',
            data: data,
            header: this._view.render({
                tmpl: 'popupHeader',
                data: {'title': data.name}
            })
        };
    },

    _initStyles : function() {
        this._stylesInited = true;

        Object.keys(this._polylineStyles).forEach(function(zoom) {
            DG.extend(this._polylineStyles[zoom], this._polylineStyleDefault);
        }, this);
    },

    _getPolyStyleNum: function() {
        var mapZoom = this._map.getZoom();

        return Object.keys(this._polylineStyles).filter(function(zoom) {
            return mapZoom <= zoom;
        })[0] || false;
    },

    _updateGeometry: function() {
        var newStyle = this._getPolyStyleNum();

        if (newStyle && newStyle !== this._geometryZoomStyle) {
            this._geometryZoomStyle = newStyle;
            this._geometry.setStyle(this._polylineStyles[newStyle]);
        }
    },

    _clearPopup: function() {
        this._map
            .removeLayer(this._geometry)
            .off('zoomend', this._updateGeometry, this);
    }

});

/*global FirmCard */
DG.Geoclicker.Handler.House = DG.Geoclicker.Handler.Default.extend({

    _firmsOnPage: 20,
    _scrollThrottleInterval: 400,
    _scrollHeightReserve: 60,

    options: {
        'showBooklet': true,
        'showPhotos': true,
        'showRouteSearch': true
    },

    handle: function(results) { // (Object) -> Promise
        if (!results.building) {
            return false;
        }

        // initialization setup
        this.firmCard = null;
        this._page = 1;
        this._houseObject = null;
        this._firmList = null;
        this._firmListObject = null;
        this._firmCardObject = null;
        this._onScroll = false;
        this._isFirmlistOpen = false;

        this._id = results.building.id;
        this._totalPages = 1;
        this._api = this._controller.getCatalogApi();
        this._popup = this._view.getPopup();
        this._initedPopupClose = false;
        this._directionsUrl = this._getDirectionsUrl(results.building.name);
        this._firmListLoader = this._view.initLoader(true);

        this._houseObject = this._fillHouseObject(results.building);

        return Promise.resolve(this._houseObject);
    },

    _isRouteSearchAllowed: function() { //() -> Boolean
        var project = this._controller.getMap().projectDetector.getProject();
        return project.transport || project.roads;
    },

    _firmCardSetup: function() { //() -> Object
        var project = this._controller.getMap().projectDetector.getProject();
        return {
            render: this._view.renderTemplate,
            lang: this._map.getLang(),
            domain: project ? project.domain : 'ru',
            ajax: DG.bind(this._api.getFirmInfo, this._api),
            timezoneOffset: project ? project.timeOffset : 0,
            map: this._map,
            popup: this._popup,
            isMobile: DG.Browser.mobile,
            showEntrance: DG.Entrance,
            gotoUrl: this._directionsUrl,
            onFirmReady: DG.bind(this._onFirmReady, this),
            onToggle: DG.bind(this._popup.resize, this._popup),
            showBooklet: this.options.showBooklet,
            showPhotos: this.options.showPhotos,
            showRouteSearch: this.options.showRouteSearch && this._isRouteSearchAllowed(),
            t: DG.bind(this.t, this)
        };
    },

    // init single firm card in case of poi
    _fillFirmCardObject: function(firmId) {
        var options = this._firmCardSetup();

        this.firmCard = new FirmCard(firmId, options);
        this._initPopupClose();
        return this.firmCard.getContainer();
    },

    _firmListSetup: function() {
        var options = this._firmCardSetup();

        DG.extend(options, {
            backBtn: DG.bind(this._showHousePopup, this),
            onFirmClick: DG.bind(this._onFirmListClick, this),
            onShowLess: DG.bind(this._showHousePopup, this),
            pasteLoader: DG.bind(this._pasteLoader, this)
        });

        return {
            firmCard: options,
            firmlistItemTmpl: 'firmlistItem',
            onListReady: DG.bind(this._renderFirmList, this)
        };
    },

    _initShortFirmList: function(firms) { //(Object) -> DOMElement
        var options = this._firmListSetup();

        this._shortFirmList = new FirmCard.List(firms, options);

        return this._shortFirmList.renderList();
    },

    _initFirmList: function(res) { //(Object) -> Promise
        if (!res) { return false; }

        var results = res.result.items,
            options = this._firmListSetup();

        options.firmCard.backBtn = DG.bind(this._showListPopup, this);

        if (this._shortFirmList) {
            this._shortFirmList._toggleEventHandlers(true);
        }

        this._firmList = new FirmCard.List(results, options);

        this._firmListObject = this._fillFirmListObject(this._firmList.renderList());
        this._clearAndRenderPopup(this._firmListObject);
    },

    _fillFirmListObject: function(firmList) { //(DOMElement) -> Object
        var self = this;

        return {
            tmpl: firmList,
            header: this._header,
            footer: this._view.render({
                tmpl: 'popupFooterBtns',
                data: {
                    btns: [
                        {
                            name: 'back',
                            label: this.t('back_button'),
                            icon: true
                        }
                    ]
                }
            }),
            afterRender: function() {
                self._initPopupClose();

                if (self._totalPages > 1 && self._firmListLoader) {
                    // "this" here is self._firmListObject
                    this.tmpl.parentNode.appendChild(self._firmListLoader);
                }
            }
        };
    },

    _onFirmReady: function(firmContentObject) {
        var self = this;
        firmContentObject.afterRender = function() {
            var headerTitle = self._popup._popupStructure.header.firstChild;
            if (!DG.Browser.ielt9) {
                if (headerTitle.offsetHeight > 72) { //TODO: magic number
                    DG.DomUtil.addClass(headerTitle, 'dg-popup__header-teaser');
                    if (!DG.Browser.webkit) {
                        DG.Geoclicker.clampHelper(headerTitle, 3);
                    }
                }
            }
        };
        this._clearAndRenderPopup(firmContentObject);
    },

    _showHousePopup: function() {
        this._popup.off('scroll', this._onScroll);
        this._clearAndRenderPopup(this._houseObject);
        if (this._shortFirmList) {
            this._shortFirmList._toggleEventHandlers();
        }
    },

    _onFirmListClick: function() {
        this._popup.off('scroll', this._onScroll);
    },

    _pasteLoader: function() {
        var loaderWrapper  = DG.DomUtil.create('div', 'dg-map-geoclicker__preloader-wrapper'),
            loader = this._view.initLoader();

        loaderWrapper.insertBefore(loader, loaderWrapper.firstChild);
        loaderWrapper.style.height = this._popup._contentNode.offsetHeight - 1 + 'px'; // MAGIC
        loaderWrapper.style.width = this._popup._contentNode.offsetWidth + 'px';
        this._clearAndRenderPopup({tmpl: loaderWrapper});
    },

    _initPopupClose: function() {
        if (this._initedPopupClose) { return; }

        this._controller.getMap().once('popupclose', DG.bind(this._onPopupClose, this));
        this._initedPopupClose = true;
    },

    _showListPopup: function() {
        var firmList = this._firmListObject;

        this._pasteLoader();

        if (!firmList) {
            firmList = this._api.firmsInHouse(this._id).then(DG.bind(this._initFirmList, this));
        } else {
            this._clearAndRenderPopup(firmList);
            this._firmList._toggleEventHandlers();
        }

        if (!this._onScroll) {
            this._onScroll = DG.Util.throttle(this._handlePopupScroll, this._scrollThrottleInterval, this);
        }

        this._popup.on('scroll', this._onScroll);
    },

    _renderFirmList: function() {
        if (!this._isFirmlistOpen) {
            this._popup.resize();
            this._isFirmlistOpen = true;
        }
    },

    _onPopupClose: function() {
        this._initedPopupClose = false;
        if (this._firmList) {
            this._firmList.clearList();
            this._firmList = null;
            this._popup.off('scroll', this._onScroll);
        }
        this._firmId = null;
        if (this.firmCard) {
            this.firmCard._toggleEventHandlers(true);
            this.firmCard = null;
        }
        this._firmListLoader = null;
        this._page = 1;
        this._clearEventHandlers();
    },

    _initShowMore: function() {
        var link = this._popup.findElement('.dg-popup__button_name_all');

        if (link) {
            this._addEventHandler('dg-popup__button_name_all', DG.bind(this._showListPopup, this));
        }
    },

    _clearAndRenderPopup: function(popupObject) {
        this._clearEventHandlers();
        this._popup.clear('header', 'footer');
        this._view.renderPopup(popupObject);
    },

    _appendFirmList: function(res) { // (Object)
        this._firmList.addFirms(res.result.items);
        this._popup._updateScrollPosition();
    },

    _handlePopupScroll: function(e) {
        var scroller = e.originalEvent.target || e.target._scroller;

        DG.DomEvent.stop(e);

        if (this._totalPages <= 1) { return; }
        if (scroller && scroller.scrollHeight <= scroller.scrollTop + scroller.offsetHeight + this._scrollHeightReserve) {
            this._handlePaging();
        }
    },

    _handlePaging: function() {
        this._page++;

        if (this._totalPages && this._page <= this._totalPages) {
            this._api.firmsInHouse(this._id, {page: this._page}).then(DG.bind(this._appendFirmList, this));
        }

        if (this._page === this._totalPages) {
            var loader = this._firmListLoader;

            if (loader && loader.parentNode) {
                loader.parentNode.removeChild(loader);
            }

            this._popup.off('scroll', this._onScroll);
        }
    }
});

DG.Geoclicker.Handler.House.include({
    _getAddressString: function(house) {
        if (!house.address || !house.address.components) {
            return '';
        }

        return house.address.components
            .filter(function(component) {
                return component.type === 'street_number';
            })
            .map(function(component) {
                return component.street + ', ' + component.number;
            })
            .join(' / ');
    },

    _fillBody: function(house) { // // (Object) -> (DOMElement)
        var data = {},
            wrapper = DG.DomUtil.create('div', 'dg-building-callout__body'),
            filials = house.links && house.links.branches;

        var drilldown = this._getDrilldown(house);

        if (house.building_name) {
            data.address = {
                header: this._getAddressString(house),
                drilldown: drilldown
            };
        } else if (drilldown) {
            data.address = {
                drilldown: drilldown
            };
        }

        data.purpose = house.purpose_name +
            (house.floors ? ', ' + this.t('n_floors', house.floors.ground_count) : '');

        if (filials && filials.count > 0) {
            this._totalPages = Math.ceil(house.links.branches.count / this._firmsOnPage);
        }

        if (house.links && house.links.attractions && house.links.attractions.length) {
            data.attractions = house.links.attractions.reduce(function(attractions, attraction) {
                if (attraction.name) {
                    attractions.push(attraction.name);
                }

                return attractions;
            }, []);
        }

        wrapper.innerHTML = this._view.render({
            tmpl: 'house',
            data: data
        });

        if (filials && filials.items) {
            wrapper.appendChild(this._initShortFirmList(filials.items));
        }

        return wrapper;
    },

    _fillHeader: function(house) { // (Object) -> (HTMLString)
        var header = {};

        if (house.building_name) {
            header.title = house.building_name;
        } else if (house.address && house.address.components) {
            header.title = this._getAddressString(house);
        } else {
            header.title = house.purpose_name;
        }

        this._header = this._view.render({
            tmpl: 'popupHeader',
            data: header
        });

        return this._header;
    },

    _fillFooter: function(house) { // (Object) -> (HTMLString)
        var btns = [];
        var houseFilials = house.links && house.links.branches;
        var filialsItemsCount = houseFilials &&
        houseFilials.items &&
        houseFilials.items.length || 0;

        // Decide if we need to display 'more organisations' button
        if (
            houseFilials &&
            houseFilials.count > filialsItemsCount
        ) {
            btns.push(this._getShowAllData(houseFilials.count));
        }

        if (this._isRouteSearchAllowed()) {
            btns.push({
                name: 'goto',
                label: this.t('go_to'),
                icon: true,
                href: this._directionsUrl
            });
        }

        return this._view.render({
            tmpl: 'popupFooterBtns',
            data: {'btns': btns}
        });
    },

    _getShowAllData: function(filialsCount) {
        return {
            name: 'all',
            label: this.t('show_organization_in_building', filialsCount)
        };
    },

    _fillHouseObject: function(house) { // (Object) -> (Object)
        var self = this;

        return {
            header: this._fillHeader(house),
            tmpl: this._fillBody(house),
            footer: this._fillFooter(house),
            afterRender: function() {
                self._initShowMore();
                self._initPopupClose();
            }
        };
    }
});

DG.Geoclicker.Handler.Poi = DG.Geoclicker.Handler.House.extend({

    handle: function(results) { // (Object) -> Promise
        if (!results.poi) {
            return false;
        }

        // initialization setup
        this.firmCard = null;
        this._page = 1;
        this._houseObject = null;
        this._firmList = null;
        this._firmListObject = null;
        this._firmCardObject = null;
        this._onScroll = false;
        this._isFirmlistOpen = false;

        this._id = results.poi.reference.id;
        this._totalPages = 1;
        this._api = this._controller.getCatalogApi();
        this._popup = this._view.getPopup();
        this._initedPopupClose = false;
        this._directionsUrl = this._getDirectionsUrl(results.poi.reference.name);
        this._firmListLoader = this._view.initLoader(true);

        // If the POI refers to a building (e.g. galleries in Santiago),
        // show a building callout
        if (results.poi.reference.type === 'building') {
            var self = this;

            return self._api.geoGet(results.poi.reference.id)
                .then(function(result) {
                    self._houseObject = self._fillHouseObject(result.result.items[0]);
                    return Promise.resolve(self._houseObject);
                });
        }

        // Otherwise, show a firm callout
        if (results.poi.reference.type === 'branch') {
            this._fillFirmCardObject(results.poi.reference.id);
            return true;
        }

        return false;
    }

});

DG.Geoclicker.Handler.Sight = DG.Geoclicker.Handler.Default.extend({

    handle: function(results) { // (Object, String) -> Promise
        if (!results.attraction) {
            return false;
        }

        this._popup = this._view.getPopup();
        this._initedPopupClose = false;

        return Promise.resolve(this._fillSightObject(results));
    },

    _fillSightObject: function(results) { // (Object) -> Object
        var attraction = results.attraction,
            data = {},
            self = this,
            footer = {
                btns: [
                    {
                        name: 'goto',
                        label: this.t('go_to'),
                        icon: true
                    }
                ]
            };

        if (attraction.name) {
            data.buildingName = attraction.name;
            data.purpose = attraction.subtype_name;
        } else {
            data.buildingName = attraction.subtype_name;
        }

        data.description = attraction.description;

        data.drillDown = this._getDrilldown(attraction);

        if (this._checkDescFieldHeight(data.description)) {
            data.showMoreText = this.t('show_more_about_sight');
        }

        footer.btns[0].href = this._getDirectionsUrl(data.buildingName);

        return {
            tmpl: 'sight',
            data: data,
            header: this._view.render({
                tmpl: 'popupHeader',
                data: {'title': data.buildingName}
            }),
            footer: this._view.render({
                tmpl: 'popupFooterBtns',
                data: footer
            }),
            afterRender: function() {
                if (self._needShowMore) {
                    self._initShowMore();
                }
                self._initPopupClose();
            }
        };
    },

    _initPopupClose: function() {
        if (this._initedPopupClose) {
            return;
        }

        this._controller.getMap().once('popupclose', DG.bind(this._clearPopup, this));
        this._initedPopupClose = true;
    },

    _clearPopup: function() {
        this._initedPopupClose = false;
        this._clearEventHandlers();
    },

    _showMoreText: function() {
        this._desc.style.maxHeight = '100%';
        this._link.parentNode.removeChild(this._link);
        this._popup.resize();
    },

    _initShowMore: function() {
        this._link = this._popup.findElement('.dg-map-geoclicker__show-more-sights-link');
        this._desc = this._popup.findElement('.dg-map-geoclicker__sight-description');

        if (this._link && this._desc) {
            this._addEventHandler('dg-map-geoclicker__show-more-sights-link', DG.bind(this._showMoreText, this));
        }
    },

    _checkDescFieldHeight: function(desc) {
        var el = DG.DomUtil.create('div', ''),
            height;

        el.style.visibility = 'hidden';
        el.innerHTML = desc;

        this._popup._contentNode.appendChild(el);
        height = el.offsetHeight;
        this._popup._contentNode.removeChild(el);
        this._needShowMore = (height > 40);

        return this._needShowMore;
    }
});

DG.Geoclicker.View = DG.Class.extend({

    initialize: function(map, options) { // (Object, Object)
        this._map = map;
        this._popup = DG.popup({
            maxHeight: 300,
            minHeight: 50,
            maxWidth: 385,
            minWidth: 310,
            sprawling: true,
            closeOnClick: true
        });

        if (options) {
            DG.Util.setOptions(this, options);
        }
    },

    initLoader: function(isSmall) {
        var loader = document.createElement('div');
        loader.innerHTML = DG.dust('DGGeoclicker/loader', {
            small: isSmall,
            anim: this._detectCssAnimation()
        });

        return loader.firstChild;
    },

    showPopup: function(latlng, content) { // (Object)
        this._popup
            .setContent(content)
            .setLatLng(latlng)
            .openOn(this._map);
    },

    render: function(options) { // (Object) -> String
        var html,
            data = {};

        options = options || {};
        options.tmpl = options.tmpl || '';

        if (options.data) {
            html = this.renderTemplate(options.tmpl, options.data);
        } else {
            html = options.tmpl;
        }

        if (options.beforeRender) {
            options.beforeRender();
        }

        if (options.popup) {
            if (options.header) {
                data.header = options.header;
            }
            if (options.footer) {
                data.footer = options.footer;
            }
            data.body = html;
            this._popup.setContent(data);
        }
        if (options.afterRender) {
            options.afterRender();
        }

        return html;
    },

    renderTemplate: function(name, data) {
        return DG.dust('DGGeoclicker/' + name, data);
    },

    renderPopup: function(options) { // (Object) -> String
        options.popup = true;
        return this.render(options);
    },

    getPopup: function() { // () -> Object
        return this._popup;
    },

    _detectCssAnimation: function() {
        var animation = false,
            domPrefixes = 'Webkit Moz O ms Khtml'.split(' '),
            elm = document.createElement('div');

        if (elm.style.animationName) { animation = true; }

        if (animation === false) {
            for (var i = 0; i < domPrefixes.length; i++) {
                if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                    animation = true;
                    break;
                }
            }
        }
        return animation;
    }
});

DG.Geoclicker.Controller = DG.Class.extend({

    options: {
        // if handler worked successfully, it should return rendering object that will be processed in View , otherwise it should return false
        // default handler always should return rendering object
        'handlersSequence': {
            'poi': DG.Geoclicker.Handler.Poi,
            'attraction': DG.Geoclicker.Handler.Sight,
            'building': DG.Geoclicker.Handler.House,
            'street': DG.Geoclicker.Handler.CityArea,
            'adm_div.place': DG.Geoclicker.Handler.CityArea,
            'adm_div.district': DG.Geoclicker.Handler.CityArea,
            'adm_div.division': DG.Geoclicker.Handler.CityArea,
            'adm_div.settlement': DG.Geoclicker.Handler.CityArea,
            'adm_div.city': DG.Geoclicker.Handler.CityArea,

            'default': DG.Geoclicker.Handler.Default,

            'apiError': DG.Geoclicker.Handler.ApiError

            // station_platform
            // project
            // station
            // crossbroad
            // metro
        }
    },

    initialize: function(map, options) { // (Object, Object)
        this._options = options;
        this._handlers = {};
        this._catalogApi = new DG.Geoclicker.Provider.CatalogApi(map);
        this._map = map;
        this._view = new DG.Geoclicker.View(map);

        this._renderHandlerResult = DG.bind(this._renderHandlerResult, this);
        this._lastHandleClickArguments = null;
        this._hasCatalogKey = false;
    },

    handlePopupClose: function(popup) { // (Object)
        if (popup === this._view.getPopup()) {
            this._lastHandleClickArguments = null;
            this._catalogApi.cancelLastRequest();
        }
    },

    handleClick: function(latlng, zoom, meta) { // (Object, Number, Object)
        var self = this,
            args = Array.prototype.slice.call(arguments, 0);

        function initShowPopup() {
            var loader = self._view.initLoader();
            self._view._popup.clear();
            self._view.showPopup(latlng, loader);
            self._lastHandleClickArguments = args;
        }

        if (meta && meta.linked && meta.linked.type != 'sight' && meta.linked.type != 'attraction') {
            if (meta.linked.type != 'branch' && meta.linked.type != 'building') {
                return;
            }

            initShowPopup();
            self.handleResponse({
                poi: {
                    reference: meta.linked
                }
            });
        } else {
            this._catalogApi.getLocations({
                latlng: latlng,
                zoom: zoom,
                beforeRequest: initShowPopup,
                hasCatalogKey: this._hasCatalogKey,
            }).then(function(result) {
                if (!result['meta'] || result['meta']['code'] !== 403) {
                    initShowPopup();
                    self._hasCatalogKey = true;
                }

                self.handleResponse(result);
            }, function(error) {
                self.handleResponse(error);
            });
        }
    },

    handleResponse: function(result) { // (Object)
        var type;

        if (!result) {
            this._runHandler('default');
            return;
        }

        if (result === 'no type') {
            return;
        }

        if (result === 'aborted') {
            this._runHandler('apiError');
            return;
        }

        type = this.findHandler(result);

        while (type) {
            if (this._runHandler(type, result)) {
                return;
            }
            delete result[type];

            type = this.findHandler(result);
        }
        this._runHandler('default');
    },

    findHandler: function(result) { // (Object) -> String|Null
        for (var i in this.options.handlersSequence) {
            if (result[i]) {
                return i;
            }
        }

        return null;
    },

    getCatalogApi: function() { // () -> Object
        return this._catalogApi;
    },

    getMap: function() {
        return this._map;
    },

    reinvokeHandler: function() {
        if (this._lastHandleClickArguments) {
            this.handleClick.apply(this, this._lastHandleClickArguments);
        }
    },

    _runHandler: function(type, data) { // (String, Object) -> Boolean
        data = data || {};
        this._initHandlerOnce(type);
        this._handlers[type].addClickEvent();

        var handlerResult = this._handlers[type].handle(data, type);

        return handlerResult && handlerResult.then ?
            handlerResult.then(this._renderHandlerResult) :
            handlerResult;
    },

    _renderHandlerResult: function(result) {
        this._view.renderPopup(result);
    },

    _initHandlerOnce: function(type) { // (String)
        if (!this._handlers[type]) {
            this._handlers[type] = new this.options.handlersSequence[type](this, this._view, this._map, this._options);
        }
    }
});

DG.Geoclicker.Handler.Default.Dictionary.it = DG.extend({
    apiErrorTitle: 'Oh oh, c\'è&nbsp;un&nbsp;errore',
    apiErrorBody: 'I nostri server si rifiutano di rispondere. Stiamo facendo del nostro meglio per convincerli a&nbsp;comportarsi bene. Ritorna tra qualche minuto.',
    we_have_not : 'Non disponiamo ancora di informazioni su questo posto',
    noname : 'Nome non indicato',
    'adm_div.place' : 'Luogo',
    'adm_div.division' : 'Zona',
    'adm_div.settlement' : 'Comune',
    street : 'Via',
    'adm_div.district' : 'Municipalità',
    'adm_div.city' : 'Сittà',
    go_to : 'Come arrivare',
    show_organization_in_building : ['{n} azienda in tutto', '{n} aziende in tutto'],
    show_more_about_sight : 'Maggiori informazioni',
    back_button: 'Indietro',
    n_floors : ['{n} piano', '{n} piani']
}, DG.Dictionary.it);

DG.Geoclicker.Handler.Default.Dictionary.ru = DG.extend({
    apiErrorTitle: 'Ошибочка вышла',
    apiErrorBody: 'Наши серверы отказываются отвечать. Мы уже прикладываем все силы, чтобы вразумить их. Возвращайтесь к&nbsp;нам через&nbsp;несколько минут.',
    we_have_not : 'Это место мы ещё не успели изучить',
    noname: 'Без названия',
    'adm_div.place': 'Место',
    'adm_div.division': 'Округ',
    'adm_div.settlement': 'Населенный пункт',
    street: 'Улица',
    'adm_div.district': 'Район',
    'adm_div.city': 'Город',
    go_to: 'Проехать сюда',
    show_organization_in_building: ['Всего {n} организация', 'Всего {n} организации', 'Всего {n} организаций'],
    show_more_about_sight: 'Подробнее',
    back_button: 'Назад',
    n_floors: ['{n} этаж', '{n} этажа', '{n} этажей']
}, DG.Dictionary.ru);

DG.Geoclicker.Handler.Default.Dictionary.en = DG.extend({
    apiErrorTitle: 'Oops! Error detected.',
    apiErrorBody: 'Our servers are not responding. We are doing our best to straighten them out. Please return to us in a few minutes.',
    we_have_not: 'We haven\'t collected info about this place yet',
    noname : 'No name',
    'adm_div.place' : 'Place',
    'adm_div.division' : 'Area',
    'adm_div.settlement' : 'Village',
    street : 'Street',
    'adm_div.district' : 'District',
    'adm_div.city' : 'City',
    go_to : 'Directions to here',
    show_organization_in_building : ['{n} organization total', '{n} organizations total'],
    back_button : 'Back',
    show_more_about_sight : 'More information',
    n_floors : ['{n} floor', '{n} floors']
}, DG.Dictionary.en);

DG.Geoclicker.Handler.Default.Dictionary.cs = DG.extend({
    apiErrorTitle: 'Chybička se&nbsp;vloudila',
    apiErrorBody: 'Naše servery odmítají reagovat. Již nyní vynakládáme veškeré úsilí, abychom je přivedli k rozumu. Zkuste akci opakovat za několik minut.',
    we_have_not : 'O tomto místě zatím nemáme informace',
    noname : 'Bez názvu',
    'adm_div.place' : 'Místo',
    'adm_div.division' : 'Správní obvod',
    'adm_div.settlement' : 'Obec',
    street : 'Ulice',
    'adm_div.district' : 'Městská část',
    'adm_div.city' : 'Město',
    go_to : 'Cesta sem',
    show_organization_in_building : ['Celkem {n} organizace', 'Celkem {n} organizace', 'Celkem {n} organizací'],
    back_button : 'Zpět',
    show_more_about_sight : 'Více',
    n_floors : ['{n} patro', '{n} patra', '{n} pater']
}, DG.Dictionary.cs);

DG.Geoclicker.Handler.Default.Dictionary.es = DG.extend({
    apiErrorTitle: 'Vaya, ha ocurrido un error',
    apiErrorBody: 'Nuestros servidores se niegan a responder. Ya nos estamos esforzando por hacerlos entrar en razón. Vuelva con nosotros pasados unos minutos.',
    we_have_not : 'Todavía no hemos recopilado la información sobre este lugar',
    noname : 'Sin nombre',
    'adm_div.place' : 'Lugar',
    'adm_div.division' : 'Comuna',
    'adm_div.settlement' : 'Población',
    street : 'Calle',
    'adm_div.district' : 'Comuna',
    'adm_div.city' : 'Ciudad',
    go_to : 'Ir para allá',
    show_organization_in_building : ['Total {n} organización', 'Total {n} organizaciones', 'Total {n} organizaciones'],
    show_more_about_sight : 'Read more',
    back_button: 'Atrás',
    n_floors : ['{n} piso', '{n} pisos']
}, DG.Dictionary.es);

var FirmCard = function (firm, options) {
    this._setOptions(options);
    this._firmContentObject = {};
    this._schedule = new FirmCard.Schedule({
        localLang: this.options.lang,
        dict: this.dict
    });

    this.render(firm);
};

FirmCard.prototype = {

    render: function (firmId) {
        if (!firmId) { return; }

        if (firmId !== this._firmId) {
            this._firmContentObject = {};
            this._renderCardById(firmId);
        } else {
            this._toggleEventHandlers();
        }

        return this._firmContentObject;
    },

    getSchedule: function () {
        return this._schedule;
    },

    getContainer: function () {
        return this._container;
    },

    _renderCardById: function (firmId) {
        var self = this;

        this.options.ajax(firmId).then(function (res) {
            if (!res) { return false; }
            var data = res.result.items;
            if (data !== 'undefined') {
                self._firmData = data[0];

                // Support for old WebAPI format.
                // TODO: remove this call after WebAPI release
                self._convertWebsite();

                self._firmId = firmId;
                self._renderFirmCard();
                self._toggleEventHandlers();
            }
        }, function (error) {
            self._renderError();
        });
    },

    _createFirmContainer: function () {
        var firm = document.createElement('div');
        firm.setAttribute('id', 'dg-map-firm-full-' + this._firmId);
        firm.setAttribute('class', 'dg-map-firm-full');

        return firm;
    },

    _getPaymentTypes: function (data) {
        var result = [],
            groupName = 'general_payment_type';

        if (!data.attribute_groups) {
            return result;
        }

        data.attribute_groups.forEach(function (group) {
            if (group.name) {
                return;
            }

            group.attributes.forEach(function (attr) {
                if (attr.tag.substring(0, groupName.length) === groupName) {
                    result.push(attr.name);
                }
            });
        });

        return result;
    },

    _groupRubrics: function (data) {
        var result = {
            primary: [],
            additional: []
        };

        if (!data.rubrics || !data.rubrics.length) {
            return result;
        }

        data.rubrics.forEach(function (rubric) {
            result[rubric.kind].push(rubric);
        });

        return result;
    },

    // Support for old WebAPI format.
    // TODO: remove this function after WebAPI release
    _convertWebsite: function () {
        if (!this._firmData.contact_groups) {
            return;
        }

        this._firmData.contact_groups.forEach(function (group) {
            if (!group.contacts) {
                return;
            }

            group.contacts.forEach(function (contact) {
                if (contact.type != 'website') {
                    return;
                }

                if (!contact.url) {
                    contact.url = contact.value;
                }
            });
        });
    },

    _renderFirmCard: function () {
        var firmCardBody, schedule, forecast, links, btns, paymentTypes, rubrics,
            data = this._firmData,
            container = this._container = this._createFirmContainer();

        schedule = this._schedule.transform(data.schedule, {
            zoneOffset: this.options.timezoneOffset,
            apiLang: this.options.lang,
            localLang: this.options.lang
        });

        forecast = this._schedule.forecast(schedule);

        paymentTypes = this._getPaymentTypes(data);
        rubrics = this._groupRubrics(data);

        firmCardBody = this._buildFirmCardBody(
            this._getConfigFirmCardBody(data, schedule, forecast, paymentTypes, rubrics)
        );

        links = this._fillHeaderLinks();
        btns = this._fillFooterButtons();

        //fill object for view render
        this._firmContentObject.header = this.options.render('firmCardHeader', {'firmName': data.name, 'links': links});
        container.innerHTML = firmCardBody;
        this._firmContentObject.tmpl = container;
        if (btns.length) {
            this._footerContainer = document.createElement('div');

            this._footerContainer.innerHTML = this.options.render('popupFooterBtns', {'btns': btns});
            this._firmContentObject.footer = this._footerContainer;
        }

        if (this.options.onFirmReady) {
            this.options.onFirmReady(this._firmContentObject);
        }
    },

    _renderError: function() {
        this._firmContentObject.header = this.options.render('popupHeader', {
            title: this.options.t('apiErrorTitle')
        });

        this._firmContentObject.tmpl = this.options.t('apiErrorBody');

        if (this.options.onFirmReady) {
            this.options.onFirmReady(this._firmContentObject);
        }
    },

    _getConfigFirmCardBody: function (data, schedule, forecast, attributes, rubrics) {
        return [
            {
                tmpl: 'firmCardAddr',
                data: {
                    address: data.address_name,
                    comment: data.address_comment
                }
            },
            {
                tmpl: 'firmCardContacts',
                data: {
                    groups: data.contact_groups
                }
            },
            {
                tmpl: 'firmCardSchedule',
                data: {
                    schedule: schedule,
                    forecast: forecast
                }
            },
            {
                tmpl: 'frimCardPayments',
                data: {
                    payments: attributes
                }
            },
            {
                tmpl: 'firmCardRubric',
                data: {
                    rubrics: rubrics
                }
            }
        ];
    },

    _buildFirmCardBody: function (parts) {
        var self = this;
        return parts.reduce(function (body, item) {
            var html = self.options.render(item.tmpl, item.data);
            return body + html;
        }, '');
    },

    _fillFooterButtons: function () {
        var btns = [];

        if (this.options.backBtn) {
            btns.push({ name: 'firm-card-back',
                        label: this.dict.t(this.options.lang, 'btnBack'),
                        icon: true
            });
        }

        if (this.options.showRouteSearch) {
            btns.push({ name: 'goto',
                        label: this.dict.t(this.options.lang, 'btnFindWay'),
                        icon: true,
                        href: this.options.gotoUrl
            });
        }

        if (
            this._firmData.links &&
                this._firmData.links.entrances &&
                this.options.showEntrance
        ) {
            btns.push({ name: 'show-entrance',
                        label: this.dict.t(this.options.lang, 'btnEntrance'),
                        icon: true
            });
        }

        return btns;
    },

    _fillHeaderLinks: function () {
        var links = [],
            reviewData = this._firmData.reviews,
            booklet,
            link;

        if (this._firmData.external_content) {
            this._firmData.external_content.forEach(function (el) {
                if (el && el.type == 'booklet') {
                    booklet = el;
                }
            });
        }

        if (reviewData && reviewData.is_reviewable) {
            links.push({
                name: 'flamp_stars',
                width: reviewData.rating * 20
            });
            links.push({
                name: 'flamp_reviews',
                label: this.dict.t(this.options.lang, 'linkReviews', reviewData.review_count ? reviewData.review_count : 0),
                href: FirmCard.DataHelper.getFlampUrl(this._firmId)
            });
        }

        // Retrieve photo data from external content block
        var photos;
        var externalContent = this._firmData.external_content;

        for (var i = 0; i < externalContent.length; i++) {
            if (
                externalContent[i].type == 'photo_album' &&
                externalContent[i].subtype == 'common'
            ) {
                photos = externalContent[i];
                break;
            }
        }

        if (!this.options.isMobile && photos && photos.count && this.options.showPhotos) {
            link = L.Util.template(DG.config.photosLink, {
                'id': this._firmId,
                'domain': this.options.domain
            });

            links.push({name: 'photos',
                href: link,
                label: this.dict.t(this.options.lang, 'linkPhoto', photos.count)
            });
        }

        if (!this.options.isMobile && booklet && booklet.url && this.options.showBooklet) {
            links.push({
                name: 'booklet',
                href:  booklet.url,
                label: this.dict.t(this.options.lang, 'linkBooklet')
            });
        }


        return links;
    },

    _events: {
        'dg-popup__button_name_firm-card-back': function() {
            this.options.backBtn();
            this._toggleEventHandlers(true);
        },
        'dg-popup__button_name_show-entrance': function() {
            var ent = new this.options.showEntrance({'vectors': this._firmData.links.entrances[0].geometry.vectors});
            ent.addTo(this.options.map);
            ent.fitBounds();
            this._toggleEventHandlers(true);
        },
        'dg-schedule__today': function() {
            this._onToggleSchedule();
        }
    },

    _toggleEventHandlers: function (flag) {
        this.options.popup[flag ? 'off' : 'on']('click', this._onClick, this);
        this.options.map[flag ? 'off' : 'on']('popupclose', this._onClose, this);
    },

    _onClick: function (e) {
        var target = e.originalEvent.target;

        for (var eventClass in this._events) {
            if (this._events.hasOwnProperty(eventClass) && target.className.indexOf(eventClass) > -1) {
                DG.DomEvent.preventDefault(e.originalEvent);
                this._events[eventClass].call(this, target);
                return;
            }
        }
    },

    _onClose: function (e) {
        this._toggleEventHandlers(true);
    },

    _onToggleSchedule: function () {
        var schedule = this._container.querySelector('.dg-schedule__table'),
            forecast = this._container.querySelector('.dg-schedule__now'),
            target = this._container.querySelector('.dg-schedule__today'),
            showClass = ' dg-schedule__today_shown_true';

        if (!schedule) { return; }

        if (schedule.style.display === 'block') {
            schedule.style.display = 'none';
            forecast.style.display = 'block';
            target.className = target.className.replace(showClass, '');
        } else {
            forecast.style.display = 'none';
            schedule.style.display = 'block';
            target.className += showClass;
        }

        if (this.options.onToggle) {
            this.options.onToggle();
        }
    },

    _setOptions: function (options) {
        var option,
            options = options || {};

        this.options = options;
        options.lang = options.lang || 'ru';

        for (option in options) {
            if (options.hasOwnProperty(option)) {
                this.options[option] = options[option];
            }
        }
    },

    _hasTouch: function () {
        return (('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0));
    }
};

FirmCard.DataHelper = {
	payMethods : [
		'americanexpress',
		'cash',
		'dinersclub',
		'goldcrown',
		'internet',
		'mastercard',
		'noncash',
		'visa'
	],

	_msgs : {},

	getFlampUrl : function (id) {
	    return DG.config.flampUrl.concat(id, '?', DG.config.flampGoogleAnalytics);
	},

	msg : function (msg) {
		if (this._msgs.hasOwnProperty(msg)) {
			return this._msgs[msg];
		}
		console && console.log("Cant't find translation for '" + msg + "'.");
		return msg.toString().replace('_', ' ');
	},

	getProjectTime: function (timezoneOffset, time) {
        var now, utc;

        if (time) {
            now = new Date(time);
        } else {
            now = new Date();
        }

        if (timezoneOffset) {
            utc = now.getTime() + (now.getTimezoneOffset() * 60000);
            return new Date(utc + (60000 * timezoneOffset));
        } else {
            return now;
        }
    }
};

/* global
    FirmCard: false
*/
(function () {
    FirmCard.List = function (firms, options) {
        this._firms = {}; // {'firmID': firmDomObj}
        this._setOptions(options);

        this._container = options && options.container || document.createElement('ul');
        this._container.setAttribute('class', 'dg-building-callout__list');

        this._eventHandlersInited = false;
        this._firmCard = this._createFirm();
        this.renderList(firms);
    };

    FirmCard.List.prototype = {

        renderList: function (firms) {
            if (firms) {
                this._toggleEventHandlers();
                this.addFirms(firms);
            }
            if (this.options.onListReady) {
                this.options.onListReady(this._container);
            }

            return this._container;
        },

        _processFirms: function (firms, action) {
            if (!firms) { return; }
            var method = '_' + action + 'Firm';
            if (this._isArray(firms)) {
                for (var i = 0, l = firms.length; i < l; i++) {
                    this[method](firms[i]);
                }
            } else {
                this[method](firms);
            }

        },

        addFirms: function(firms) {
            this._processFirms(firms, 'add');
        },

        removeFirms: function(firms) {
            this._processFirms(firms, 'remove');
        },

        setLang: function (newLang) {
            this.options.firmCard.lang = newLang;
        },

        getLang: function () {
            return this.options.firmCard.lang;
        },

        getContainer: function () {
            return this._container;
        },

        clearList : function () {
            this._firms = {};
            this._toggleEventHandlers(true);
            this._clearContainer();
        },

        _removeFirm: function (id) {
            if (!this._firms[id]) { return false; }
            this._container.removeChild(this._firms[id]);
            delete this._firms[id];
        },

        _addFirm: function (firmData) {
            var tmpl = this.options.firmlistItemTmpl,
                domFirm, firm, content;

            firm = {
                name: firmData.name,
                id: firmData.id.split('_').slice(0, 1)
            };

            if (!(firm.id in this._firms)) {

                domFirm = this._createListItem();

                content = tmpl ? this.options.firmCard.render(tmpl, {'firm': firm}) : firm.name;

                domFirm.insertAdjacentHTML('beforeend', content);

                this._firms[firm.id] = domFirm;
                this._container.appendChild(domFirm);
            }
        },

        _createListItem: function () {
            var item = document.createElement('li');
            item.setAttribute('class', 'dg-building-callout__list-item');

            return item;
        },

        _isArray: function (obj) {
            return {}.toString.call(obj) === '[object Array]';
        },

        _createFirm: function (firmData) {
            return new FirmCard(firmData, this.options.firmCard);
        },

        _isEmptyObj: function (obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    return false;
                }
            }

            return true;
        },

        _events: {
            'dg-popup__link': function(target) {
                var s = this._firmCard.render(target.id);

                this.options.firmCard[this._isEmptyObj(s) ? 'pasteLoader' : 'onFirmReady'](s);

                this.options.firmCard.onFirmClick && this.options.firmCard.onFirmClick();

                this._toggleEventHandlers(true);
            },
            'dg-building-callout__list-item': function(target) {
                target = target.children[0];

                this._events['dg-popup__link'].call(this, target);
            },
            'dg-popup__button_name_back': function() {
                this.options.firmCard.onShowLess();

                this._toggleEventHandlers(true);
            }
        },

        _toggleEventHandlers : function (flag) {
            this.options.firmCard.popup[flag ? 'off' : 'on']('click', this._onClick, this);
        },

        _onClick: function (e) {
            var target = e.originalEvent.target;

            for (var eventClass in this._events) {
                if (this._events.hasOwnProperty(eventClass) && target.className.indexOf(eventClass) > -1) {
                    DG.DomEvent.preventDefault(e.originalEvent);
                    this._events[eventClass].call(this, target);
                    return;
                }
            }
        },

        _clearContainer: function () {
            var container = this._container;

            while (container.hasChildNodes()) {
                container.removeChild(container.firstChild);
            }
        },

        _setOptions: function (options) {
            options || (options = {});
            this.options = options;
            this.options.firmCard || (this.options.firmCard = {});

            if (!options.firmCard.lang) {
                this.options.firmCard.lang = 'ru';
            }

            for (var option in options) {
                if (options.hasOwnProperty(option)) {
                    this.options[option] = options[option];
                }
            }
        }
    };
})();

/*global
    FirmCard:false
*/
FirmCard.Schedule = function (options) {
    options = options || {};

    this.localLang = options.localLang || 'ru';
    this.dict = options.dict;
    return this;
};

FirmCard.Schedule.prototype = {

    setLang: function (lang) {
        this.localLang = lang || 'ru';
        return this;
    },

    transform: function (model, params) {
        if (!model) {
            return;
        }
        params = params || {};

        function bind(fn, obj) { // (Function, Object) -> Function
            var args = arguments.length > 2 ? Array.prototype.slice.call(arguments, 2) : null;
            return function () {
                return fn.apply(obj, args || arguments);
            };
        }

        var todayKey, // Mon, Tue ...
            today, // Объект модели - текущий день недели
            from, // Самое раннее время открытия за день
            to, // Самое позднее время закрытия за день
            zoneOffset = params.zoneOffset || 0,
            schedule = {}, // Объект-расписание, формируемый под шаблон
            now = params.now || FirmCard.DataHelper.getProjectTime(zoneOffset).getTime(), // Current timestamp in milliseconds
            weekKeys = [], // Ключи дней недели, определяют порядок дней и первый день недели. 0 - первый день недели в регионе (не обязательно Mon)
            weekKeysLocal = [],
            weekFullKeysLocal = [],
            weekKeysShort =  [ 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun' ],
            weekKeysFull = ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'],
            localLang = params.localLang || this.localLang,
            localWorkingDays = params.localWorkingDays || [0, 1, 1, 1, 1, 1, 0],
            firstdayOffset = params.firstdayOffset || 1,
            minHoursToDisplayClosure = params.minHoursToDisplayClosure || 4,
            t = bind(this.dict.t, this.dict);


        function capitaliseFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        function getHours(str) {
            return str.substr(0, 2);
        }

        function getMinutes(str) {
            return str.substr(3, 2);
        }

        // Конвертация временной точки формата апи в формат отображения (25:00 -> 01:00)
        function formatTime(str) {
            var hours = +getHours(str) % 24 + '';

            if (hours.length === 1) {
                hours = '0' + hours;
            }

            return hours + ':' + getMinutes(str);
        }

        // Конвертация int числа в номер дня недели (диапазон 0-6)
        // отрицательные чила: -1 вернёт 6, -2 -> 5 и т.д
        // положительные: 7 -> 0, 8 -> 1
        function dayNum(n) {
            return (n + 70) % 7;
        }


        /* jshint ignore:start */
        // Возвращает последний элемент массива
        // Взято из Underscore.js http://underscorejs.org/#last
        function getArrayLast(arr, n) {
            if ( arr == null ) return void 0;
            if (   n == null ) return arr[ arr.length - 1 ];
            return slice.call( arr, Math.max(arr.length - n , 0) );
        }


        // Выполняет глубокое сравнение объектов
        // Взято из Underscore.js http://underscorejs.org/#isEqual
        // Упрощено для тех трёх сравнений, которые выполняются в Shedule.js
        function isEqual(obj1, obj2) {
            if ( obj1 === obj2 ) return true;
            if ( ! ( obj1 instanceof Object ) || ! ( obj2 instanceof Object ) ) return false;
            if ( obj1.constructor !== obj2.constructor ) return false;
            for ( var prop in obj1 ) {
                if ( ! obj1.hasOwnProperty( prop ) ) continue;
                if ( ! obj2.hasOwnProperty( prop ) ) return false;
                if ( obj1[ prop ] === obj2[ prop ] ) continue;
                if ( typeof( obj1[ prop ] ) !== "object" ) return false;
                if ( ! isEqual( obj1[ prop ],  obj2[ prop ] ) ) return false;
            }
            for ( prop in obj2 ) {
            if ( obj2.hasOwnProperty( prop ) && ! obj1.hasOwnProperty( prop ) ) return false;
            }

            return true;
        }

        // Generate an integer Array containing an arithmetic progression. A port of
        // the native Python `range()` function. See
        // [the Python documentation](http://docs.python.org/library/functions.html#range).
        function range(start, stop, step) {
        if (arguments.length <= 1) {
            stop = start || 0;
            start = 0;
        }
        step = arguments[2] || 1;

        var length = Math.max(Math.ceil((stop - start) / step), 0);
        var idx = 0;
        var range = new Array(length);
        while(idx < length) {
            range[idx++] = start;
            start += step;
        }

        return range;
        }


        //Заполняет свойства объекта значениями по умолчанию
        //Взято из Underscore.js http://underscorejs.org/#defaults
        function fillDefaults(obj) {
         var args = Array.prototype.slice.call(arguments, 1);
         args.forEach(function(source) {
            if (source) {
                for (var prop in source) {
                    if (obj[prop] === void 0) obj[prop] = source[prop];
                }
            }
        });
        return obj;
        }

        //Сортирует значения согласно с итератором
        //Взято с Underscore.js http://underscorejs.org/#sortBy
        function sortBy(obj, iterator){
            return pluck(obj.map( function(value, index, list) {
                return {
                        value: value,
                        index: index,
                        criteria: iterator.call(this, value, index, list)
                        };
                }).sort(function(left, right) {
                        var a = left.criteria;
                        var b = right.criteria;
                        if (a !== b) {
                        if (a > b || a === void 0) return 1;
                        if (a < b || b === void 0) return -1;
                        }
                return left.index - right.index;
                }), 'value');
        }

        /* jshint ignore:end */

        function pluck(arr, key){
            var i, rv = [];
            for (i = 0; i < arr.length; ++i) {
            rv[i] = arr[i][key];
            }
            return rv;
        }


        // Преобразовать расписание на день в упорядоченный массив временных отсечек (string)
        // Сейчас полагается, что API уже выдаёт сортированный массив
        function getSortedTimePoints(day) {
            var points = [],
                from, to,
                deltaHours, deltaMinutes;

            if (!day || !day.working_hours) {
                return [];
            }

            for (var i = 0 ; i < day.working_hours.length ; i++) {
                from = day.working_hours[i].from;
                to = day.working_hours[i].to;

                deltaHours = getHours(to) - getHours(from);
                deltaMinutes = getMinutes(to) - getMinutes(from);
                if (deltaHours < 0 || (deltaHours === 0 && deltaMinutes <= 0)) { // Если "до" меньше или равно "от" - значит указывает на завтра
                    to = (+getHours(to) + 24) + ':' + getMinutes(to); // (01:00 -> 25:00)
                }

                points[i * 2] = {
                    time: from,
                    type: 'open'
                };
                points[i * 2 + 1] = {
                    time: to,
                    type: day.working_hours.length - 1 === i ? 'close' : 'lunch'
                };
            }

            return points;
        }

        // Возвращает массив timestamp всех точек, всех дней недели, от сегодняшнего и в будущее
        // Например, сегодня среда, отсечки будут взяты для дат со среды (сегодня) по следующий вторник включительно
        function getTimeStamps(model) {
            var timestamps = [],
                out = [],
                timePoints,
                num = weekKeys.indexOf(todayKey); // Номер сегодняшнего дня недели (для данного региона)


            // Цикл по дням недели начиная с сегодняшнего
            var j; // Номер текущего дня в массиве weekKeys
            for (var i = 0 ; i < 7 ; i++) {
                j = dayNum(num + i);
                timePoints = getSortedTimePoints(model[weekKeys[j]]);
                // Цикл по точкам времени с конвертацией в timestamp
                timePoints.forEach(
                    /* jshint -W083 */
                    function (point) {
                    // now - обязательно! иначе будет браться текущий timestamp что чревато несовпадениями при медленном быстродействии
                    // Вычислить таймстемп для данного дня недели, часа и минуты, в будущем, но ближайший к now
                    var tsp = new Date(now);
                    tsp.setDate(tsp.getDate()+i);
                    tsp.setHours(getHours(point.time));
                    tsp.setMinutes(getMinutes(point.time));
                    var ts = tsp.getTime();



                    timestamps.push({
                        ts: ts,
                        type: point.type
                    });

                    if (timestamps[timestamps.length - 1] && timestamps[timestamps.length - 2]) {
                        // Парно удаляем совпадающие точки (они не имеют смысла - это сегодня 24:00 и завтра 00:00)
                        if (timestamps[timestamps.length - 1].ts === timestamps[timestamps.length - 2].ts) {
                            timestamps.pop();
                            timestamps.pop();
                        }
                    }

                    if (timestamps[timestamps.length - 1] && timestamps[timestamps.length - 2]) {
                        // Парно переносим точки в будущее, если они обе в прошлом (первая точка ([0]) должна быть всегда открытием!)
                        if (timestamps[timestamps.length - 1].ts <= now && timestamps[timestamps.length - 2].ts <= now) {
                            timestamps[timestamps.length - 1].ts += (7 * 24 * 60 * 60 * 1000);
                            timestamps[timestamps.length - 2].ts += (7 * 24 * 60 * 60 * 1000);
                        }
                    }
                }
                /* jshint +W083 */
                );
            }

            // Сортируем на возрастание, ведь возможно были переносы в будущее
            timestamps = sortBy(timestamps, function (timestamp) { return timestamp.ts; });

            // Удаляем попарно совпадающие точки времени
            i = 0;
            while (i < timestamps.length) {
                if (timestamps[i + 1] && timestamps[i].ts === timestamps[i + 1].ts) {
                    i++;
                } else {
                    out.push(timestamps[i].ts);
                }
                i++;
            }

            // Проверка на ежедневно-круглосуточность
            if (out.length === 2 && (out[1] - out[0]) === (7 * 24 * 60 * 60 * 1000)) {
                return [];
            }

            return timestamps;
        }

        function whenOpenInverse(h, d, num) {
            if (d === 1 && h > minHoursToDisplayClosure ) {
                return t(localLang, 'tommorow');
            } else if (d > 1) {
                /* jshint -W015 */
                switch (num) {
                    case 0: return t(localLang, 'nextSun');
                    case 1: return t(localLang, 'nextMon');
                    case 2: return t(localLang, 'nextTue');
                    case 3: return t(localLang, 'nextWed');
                    case 4: return t(localLang, 'nextThu');
                    case 5: return t(localLang, 'nextFri');
                    case 6: return t(localLang, 'nextSat');
                }
                /* jshint +W015 */
            }

            return;
        }


        //Возвращает интервал в целых днях, с поправкой на смену дня в полночь, между
        // @param timestampEnd и @param dateStart
        function dayInterval(timestampEnd, dateStart) {

            var oneDay = 1000 * 60 * 60 * 24,
                dateEnd = new Date(timestampEnd.ts);

            var diff;

            diff = Math.round((dateEnd - dateStart) / oneDay);

            if( timestampEnd.type==='open' && dateEnd.getHours() < 1 )
                { diff ++; }

            return diff;
        }


        // Поместить данные в объект для шаблона о сегодняшнем дне
        function setTodayString(today) {

            var timePoints,
                periods = [],
                timestamps;

            schedule.now = {};

            // Timestamps всех отсечек
            timestamps = getTimeStamps(model);

            if (!timestamps.length) {
                schedule.always = true; // Работает ежедневно круглосуточно
                schedule.now.open = true;
            }


            for (var i = 0 ; i < timestamps.length ; i++) {
                // Попали между точками i-1 и i // Мы находимся заведомо в будущем относительно 1
                if (now >= (timestamps[i - 1] && timestamps[i - 1].ts || 0) && now < timestamps[i].ts) {
                    var h = Math.floor((timestamps[i].ts - now) / (1000 * 60 * 60)), // Количество часов до следующего timestamp
                        m = Math.floor((timestamps[i].ts - now) / (1000 * 60) - h * 60), // Количество минут (без часов) до следующего timestamp
                        dayNow = new Date(now),

                        // открыто если следующая итерация не открытие
                        nowIsOpen = timestamps[i].type !== 'open';

                        //var d = dayOfYear(dayTs) - dayOfYear(dayNow);
                        //var d = dayInterval(dayTs, dayNow, nowIsOpen);
                        var d = dayInterval(timestamps[i], dayNow);



                    // округляем минуты до кратных 5
                    m = Math.floor(m / 10) * 10 ? Math.floor(m / 10) * 10 : 5;

                    schedule.now.open = nowIsOpen;
                    schedule.now.lunch = !!(timestamps[i - 1] && timestamps[i - 1].type === 'lunch' || getArrayLast(timestamps).type === 'lunch');

                    schedule.will = {
                        willType: timestamps[i].type,
                        d: d,
                        h: h,
                        m: m
                    };

                    // Когда закроется или откроется
                    var willWhen = new Date(timestamps[i].ts);
                    schedule.will.when = whenOpenInverse(h, d, willWhen.getDay());


                    var willTill = new Date(timestamps[i].ts),
                        strHours = willTill.getHours(),
                        strMinutes = willTill.getMinutes();

                    if (strHours < 10) { strHours = '0' + strHours; }
                    if (strMinutes < 10) { strMinutes = '0' + strMinutes; }

                    schedule.will.till = strHours+':'+strMinutes;
                }
            }

            if (!today) {
                return; // На сегодня расписания нет - сейчас закрыто
            }

            timePoints = pluck(getSortedTimePoints(today), 'time');

            // Цикл по периодам работы за день
            for (i = 2 ; i < timePoints.length ; i = i + 2) {
                periods.push({ from: timePoints[i - 1], to: timePoints[i] });
            }

            from = formatTime(timePoints[0]);
            to = formatTime(timePoints[timePoints.length - 1]);

            if (from === to) { // Круглосуточно
                schedule.today = {
                    alltime: true,
                    alltimeStr: t(localLang, 'worksAroundTheClock'),
                    from: '00:00',
                    to: '24:00'
                };
            } else { // От from до to
                schedule.today = {
                    from: from,
                    to: to
                };
            }

            if (periods.length > 0) { // Перерывы на обед
                schedule.lunch = periods;
                schedule.lunchStr = t(localLang, 'lunch');
            }
        }

        // Формирование объекта-таблицы-расписания для шаблона
        function makeTable() {
            var column = [],
                hasLunch = false;

            for (var j = 0 ; j < 7 ; j++) {
                var dayKey = weekKeys[j],
                    lunchMaxLength = 0;

                column[j] = {};

                if (model[dayKey]) {
                    var day = model[dayKey],
                        timePoints = pluck(getSortedTimePoints(day), 'time'),
                        lunch = []; // Отрезки времени (отсортированные моменты) на обеды

                    // Цикл по периодам работы за день
                    for (var i = 2 ; i < timePoints.length ; i = i + 2) {
                        hasLunch = true;
                        lunch.push({ from: timePoints[i - 1], to: timePoints[i] });
                    }
                    lunchMaxLength = Math.max(timePoints.length / 2, lunchMaxLength);

                    column[j] = {
                        from: formatTime(timePoints[0]),
                        to: formatTime(timePoints[timePoints.length - 1]),
                        lunch: lunch
                    };
                }

                if (dayKey === todayKey) { // Сегодняшний день надо подсветить
                    column[j].active = true;
                }

                column[j].key = weekKeysLocal[j];
            }

            // Дополнение пустыми объектами массивов lunch
            column.forEach( function (col) {
                if (col.lunch) {
                    fillDefaults(col.lunch, range(1, lunchMaxLength));
                }
            });

            return {
                table: column,
                hasLunch: hasLunch
            };
        }

        // Сгенерировать строку для всех дней model, совпадающих с day
        function makeSimpleString(day, model) {
            var points,
                out = {
                    dayList: [],
                    lunch: []
                },
                lunchesTime = [];

            if (day && day.working_hours && day.working_hours.length) {
                points = pluck(getSortedTimePoints(day), 'time');
                points.forEach( function (point, key) {
                    if (key === 0) {
                        out.from = formatTime(point);
                    } else if (key === points.length - 1) {
                        out.to = formatTime(point);
                    } else {
                        lunchesTime.push(formatTime(point));
                    }
                });
                for (var i = 0; i < lunchesTime.length; i += 2) {
                    out.lunch.push({
                        from: lunchesTime[i],
                        to: lunchesTime[i + 1],
                        lunchStr: capitaliseFirstLetter(t(localLang, 'lunch'))
                    });
                }

                if (out.from == '00:00' && out.to == '00:00') {
                    out.to = '24:00';
                }

                if (day.round_the_clock) {
                    out.alltime = true;
                    out.alltimeStr = t(localLang, 'worksAroundTheClock');
                }
            } else { // Выходной
                out.holiday = true;
            }

            // Формируем список дней на локальном языке
            var groupWorkingDays = [0, 0, 0, 0, 0, 0, 0]; // Флаги работы фирмы в дни текущей группы
            var flow = 0;

            weekKeys.forEach( function (dayKey, numKey) { // 'Mon', 0
                if (isEqual(model[dayKey], day) || (!model[dayKey] && day === null)) {
                    out.dayList.push(weekFullKeysLocal[numKey]);
                    groupWorkingDays[dayNum(numKey + firstdayOffset)] = 1;
                    flow++;
                } else {
                    if (flow > 2) { // Более 2 дней подряд
                        var lastDay = out.dayList.pop();

                        for (var i = 1 ; i < flow - 1 ; i++) {
                            out.dayList.pop();
                        }

                        out.dayList[out.dayList.length - 1] += ' — ' + lastDay;
                    }

                    flow = 0;
                }
            });

            // Список дней в данной группе идентичен списку будних дней, значит можно заменить словом "Будни"
            out.budni = isEqual(localWorkingDays, groupWorkingDays);
            // Список рабочих дней - все дни недели, значит нужно выводить фразу "Ежедневно"
            out.everyday = ( Math.min.apply(Math, groupWorkingDays) === 1 );

            if ( out.holiday ) { out.holidayStr = t(localLang, 'restDay', out.dayList.length).slice(2); }

            // Делаем из массива строку и поднимаем первый символ
            out.dayList = out.dayList.join(', ');
            out.dayList = out.dayList.charAt(0).toUpperCase() + out.dayList.slice(1);


            return out;
        }

        // Возвращает массив simple строк на основе массива дней days
        function makeAdvancedString(days, model) {
            var out = [];

            for (var i = days.length - 1 ; i >= 0 ; i--) {
                out.push(makeSimpleString(days[i], model));
            }

            return out;
        }

        // Заполняем названия дней недели, 1 - понедельник. В заполненных массивах понедельник это 0

        for (var i = 0 ; i < 7 ; i++) {
            weekKeys[i] = weekKeysShort[i];
            weekKeysLocal[i] = this.dict.t(localLang, weekKeysShort[i].toLowerCase());
            weekFullKeysLocal[i] = this.dict.t(localLang, weekKeysFull[i]);
        }

        // Вычисляем сегодняшний день недели (ссылку на объект дня в модели)
        todayKey = weekKeysShort[dayNum(new Date(now).getDay() - firstdayOffset)];
        today = model[todayKey]; // Объект расписания - текущий день недели
        setTodayString(today); // Сделать объект для шаблона - строка, которая описывает время работы сегодня

        // Находим количество разных расписаний и сохраняем их в массив
        var apiDifferentDays = [], // Массив различающихся дней из модели
            apiScheduleDaysCount = 0, // Количество описанных дней в расписании модели
            apiDifferentDaysCount = 0, // Количество разных дней в расписании модели
            differentWorkingHoursCount = []; // Количество рабочих часов в разных днях

        Object.keys(model).forEach( function(day) {
            if (model[day] && model[day].working_hours) { // Проверяем что это день, а не комментарий или что-то ещё
                apiScheduleDaysCount++;
                if (!isEqual(model[day], getArrayLast(apiDifferentDays))) {
                    apiDifferentDays.push(model[day]);
                }
            }
        });

        apiDifferentDaysCount = apiDifferentDays.length;
        // Если не все дни описаны в модели, значит есть ещё один тип дней - выходной (отсутствущий в модели)
        if (apiScheduleDaysCount < 7) {
            apiDifferentDaysCount++;
        }

        // Если разных более 2, то упростить не получится - делаем таблицу
        if (apiDifferentDaysCount > 2) {
            schedule.week = makeTable(model);
        } else { // Иначе, составляем комментарий из двух строк

            // Случай, когда все одинаковые
            if (apiDifferentDaysCount === 1) {
                schedule.week = {
                    evently: [makeSimpleString(model[weekKeys[0]], model)]
                };
            } else { // Остаётся случай, когда есть два типа дней
                // Определяем день с наибольшим количеством рабочих часов из числа разных дней
                for (i = 0 ; i < apiDifferentDaysCount ; i++) {
                    differentWorkingHoursCount[i] = 0;

                    if (apiDifferentDays[i]) {
                        var points = pluck(getSortedTimePoints(apiDifferentDays[i]), 'time');

                        for (var j = 0 ; j < points.length ; j = j + 2) {
                            var hours = (getHours(points[j + 1]) + getMinutes(points[j + 1]) / 60) - (getHours(points[j]) + getMinutes(points[j]) / 60);
                            differentWorkingHoursCount[i] += hours;
                        }
                    } else { // Выходной
                        apiDifferentDays[i] = null;
                    }
                }

                var apiSortedDifferentDays = sortBy(apiDifferentDays, function (day, key) {
                    return differentWorkingHoursCount[key];
                });

                schedule.week = {
                    evently: makeAdvancedString(apiSortedDifferentDays, model)
                };
            }
        }

        schedule.comment = model.comment;
        if (schedule.week && schedule.week.evently && schedule.week.evently.length === 1) {
            schedule.everyday = schedule.week.evently[0].everyday;
        }
        return schedule;
    },

    forecast: function (schedule, params) {
        var interval = '',
        open,
        today = {},
        nowText,
        maxHours = params && params.maxHours || 1;

        if (!schedule) {
            return {};
        }

        if (schedule.always) { // Круглосуточно ежедневно - более ничего выводить не нужно
            return {
                today: {
                    text: this.dict.t(this.localLang, 'aroundTheClock')
                },
                open: true
            };
        }

        // Формируем строку - через сколько произойдёт следующая инверсия открытости
        if (schedule.will && schedule.will.h < maxHours) {
            if (schedule.will.h) {
                interval += this.dict.t(this.localLang, 'nHours', schedule.will.h) + ' ';
            }

            if (schedule.will.m) {
                interval += this.dict.t(this.localLang, 'nMins', schedule.will.m);
            }
        }

        // Данные на сегодня
        if (schedule.today) {
            today.text = this.dict.t(this.localLang, 'today');
            if (schedule.everyday) {
                today.text = this.dict.t(this.localLang, 'everyday');
            }
            today.from = schedule.today.from;
            today.to = schedule.today.to;
            today.lunch = schedule.lunch;
            if (today.lunch) {
                today.lunchStr = this.dict.t(this.localLang, 'lunch');
            }
        } else {
            today.text = this.dict.t(this.localLang, 'todayIsRestDay');
        }

        // Текущий статус и прогноз
        if (schedule.always) { // Если круглосуточно, ничего кроме "Круглосуточно" выводить не нужно
            today.text = this.dict.t(this.localLang, 'aroundTheClock');
            open = true;
        } else if (schedule.now) {
            open = schedule.now.open;
            if (open) { // открыто
                if (schedule.will && schedule.will.willType === 'lunch') {
                    // далее - закрытие на обед
                    if (schedule.will && schedule.will.h < maxHours) {
                        // менее maxHours до закрытия  на обед
                        nowText = this.dict.t(this.localLang, '_in') + ' ' + this.dict.t(this.localLang, 'nMins', interval) + this.dict.t(this.localLang, 'isClosingOnDinner');
                    } else {
                        // больше maxHours до закрытия  на обед
                        nowText = this.dict.t(this.localLang, 'isOpen');
                    }

                } else {
                    // далее просто закрытие
                    if (schedule.will.h < maxHours) {
                        // менее maxHours до закрытия просто
                        nowText = this.dict.t(this.localLang, 'closeIn') + this.dict.t(this.localLang, 'nMins', interval);
                    } else {
                        // больше maxHours до закрытия просто
                        nowText = this.dict.t(this.localLang, 'isOpen');
                    }
                }
            } else { // закрыто
                if (schedule.will && schedule.will.when) {
                    // откроется не сегодня
                    nowText = this.dict.t(this.localLang, 'open') + schedule.will.when;
                } else {
                    // откроется сегодня
                    if (schedule.now && schedule.now.lunch) {
                        // сейчас обед
                        if (schedule.will.h < maxHours) {
                            // менее maxHours до открытия с обеда
                            nowText = this.dict.t(this.localLang, 'Lunch') + this.dict.t(this.localLang, 'openIn') + this.dict.t(this.localLang, 'nMins', interval);
                        } else {
                            // больше maxHours до открытия с обеда
                            nowText = this.dict.t(this.localLang, 'Lunch') + this.dict.t(this.localLang, 'openAt') + schedule.will.till;
                        }
                    } else {
                        // просто закрыто
                        if (schedule.will && schedule.will.h < maxHours) {
                            // менее maxHours до открытия просто
                            nowText = this.dict.t(this.localLang, 'openIn') + this.dict.t(this.localLang, 'nMins', interval);
                        } else {
                            // больше maxHours до открытия просто
                            nowText = this.dict.t(this.localLang, 'openAt') + schedule.will.till;
                        }
                    }
                }
            }
        }

        return {
            today: today,
            now: nowText,
            open: open,
            week: schedule.week,
            comment: schedule.comment,
            everyday: schedule.everyday
        };
    }
};

/*global
    FirmCard:false
*/
// FirmCard.dictionary = {};

FirmCard.prototype.dict = {

    t: function (lang, msg, argument) { // (String, Number) -> String
        var result,
            msgIsset = false,
            dictionaryMsg,
            exp;

        if (typeof this[lang] === 'undefined') {
            if (lang === 'ar') {
                lang = 'en';
            } else {
                lang = 'ru';
            }
        }
        dictionaryMsg = this[lang][msg];
        msgIsset = typeof dictionaryMsg !== 'undefined';
        if (!msgIsset) {
            return msg;
        }
        result = msgIsset ? dictionaryMsg : msg;

        if (argument !== undefined) {
            argument = parseInt(argument, 10);
            argument = isNaN(argument) ? 0 : argument;
            exp = this[lang].pluralRules(argument);
            result = argument + ' ' + dictionaryMsg[exp];
        }
        return result;
    },

    ru: {
        pluralRules: function (n) { // (Number)
            if (n % 10 === 1 && n % 100 !== 11) { // 1, 21
                return 0;
            }
            if ((n % 10 >= 2 && n % 10 <= 4 && (n % 10) % 1 === 0) && (n % 100 < 12 || n % 100 > 14)) { // 2, 3
                return 1;
            }

            if ((n % 10 === 0) || (n % 10 >= 5 && n % 10 <= 9 && (n % 10) % 1 === 0) || (n % 100 >= 11 && (n % 100) <= 14 && (n % 100) % 1 === 0)) { // 13, 17
                return 2;
            }
        },

        btnBack: 'Назад',
        btnFindWay: 'Проехать сюда',
        btnEntrance: 'Найти вход',
        linkReviews: ['отзыв', 'отзыва', 'отзывов'],
        linkPhoto: ['фото', 'фото', 'фото'],
        linkBooklet: 'Буклет',
        tommorow: 'завтра',
        afterTommorow: 'послезавтра',
        afterWeek: 'через неделю',
        nextSun: 'в воскресенье',
        nextMon: 'в понедельник',
        nextTue: 'во вторник',
        nextWed: 'в среду',
        nextThu: 'в четверг',
        nextFri: 'в пятницу',
        nextSat: 'в субботу',
        willOpen: 'откроется',
        willClose: 'закроется',
        isOpen: 'Открыто',
        openTill: 'Открыто до ',
        closeIn: 'Закроется через ',
        openAt: 'Откроется в ',
        openIn: 'Откроется через ',
        open: 'Откроется ',
        nHours: ['час', 'часа', 'часов'],
        nMins: ['минуту', 'минуты', 'минут'],
        lunch: 'обед',
        Lunch: 'Обед. ',
        workingDays: 'Рабочие дни',
        weekdays: 'Будние дни',
        restDay: ['выходной', 'выходные','выходные'],
        reviewsOnFlamp: 'Отзывы на Флампе',
        writeReviewOnFlamp: 'Написать отзыв на Флампе',
        payment: 'оплата',
        everyday: 'Ежедневно c',
        worksAroundTheClock: 'Работает круглосуточно',
        aroundTheClock: 'Круглосуточно',
        knowMore: 'узнать больше',
        toClose: 'до закрытия',
        monday: 'понедельник',
        tuesday: 'вторник',
        wednesday: 'среда',
        thursday: 'четверг',
        friday: 'пятница',
        saturday: 'суббота',
        sunday: 'воскресенье',
        mon: 'пон',
        tue: 'втр',
        wed: 'срд',
        thu: 'чтв',
        fri: 'птн',
        sat: 'сбт',
        sun: 'вск',
        toLunch: 'до обеда',
        today: 'Сегодня',
        lessThenHour: 'менее часа',
        youCouldLate: 'вы можете не успеть',
        workingTime: 'рабочее время',
        showAllOrgInRubric: 'Показать все организации рубрики',
        todayIsRestDay: 'Сегодня выходной',
        internet: 'Оплата через Интернет',
        noncash: 'Безналичный расчет',
        goldcrown: 'Золотая Корона',
        dinersclub: 'Diners Club',
        mastercard: 'Mastercard',
        maestrocard: 'MaestroCard',
        visa: 'Visa',
        cash: 'Наличный расчет',
        americanexpress: 'American Express',
        hour : 'час',
        less: 'менее',
        _in : 'Через',
        isClosingOnDinner : ' закрывается на обед'
    },

    it: {
        pluralRules: function (n) { // (Number)
            if (n === 1) { // 1
                return 0;
            } else {
                return 1; //0, 2, 3, 4 ..
            }
        },

        btnBack: 'Indietro',
        btnFindWay: 'Come arrivare ',
        btnEntrance: 'Trova l\'ingresso',
        linkReviews: ['recensione', 'recensioni'],
        linkPhoto: ['fotografia', 'fotografie'],
        linkBooklet: 'Sull\'azienda',
        tommorow: 'domani',
        afterTommorow: 'dopodomani',
        afterWeek: 'tra una settimana',
        nextSun: 'la domenica',
        nextMon: 'il lunedi',
        nextTue: 'il martedì',
        nextWed: 'il mercoledì',
        nextThu: 'il giovedi',
        nextFri: 'il venerdì',
        nextSat: 'il sabato',
        willOpen: 'apre',
        willClose: 'ciuso',
        isOpen: 'Aperto',
        openTill: 'Aperto fino alle ',
        closeIn: 'Chiude tra ',
        openAt: 'Apre alle ',
        openIn: 'Apre tra ',
        open: 'Apre ',
        nHours: ['ora', 'ore'],
        nMins: ['minuto', 'minuti'],
        lunch: 'pausa pranzo',
        Lunch: 'Pausa pranzo. ',
        workingDays: 'Giorni feriali',
        weekdays: 'Giorni feriali',
        restDay: ['chiusura','chiusura'],
        reviewsOnFlamp: 'Recensioni su Flamp',
        writeReviewOnFlamp: 'Scrivi una recensione su Flamp',
        payment: 'pagamento',
        everyday: 'Ogni giorno dalole',
        worksAroundTheClock: 'Operativo 24 ore su 24',
        aroundTheClock: '24 ore su 24',
        knowMore: 'ulteriori informazioni',
        toClose: 'fino alla chiusura',
        monday: 'lunedi',
        tuesday: 'martedì',
        wednesday: 'mercoledì',
        thursday: 'giovedi',
        friday: 'venerdì',
        saturday: 'sabato',
        sunday: 'domenica',
        mon: 'lun',
        tue: 'mar',
        wed: 'mer',
        thu: 'gio',
        fri: 'ven',
        sat: 'sab',
        sun: 'dom',
        toLunch: 'fino alla pausa pranzo',
        today: 'Oggi',
        lessThenHour: 'meno di un\'ora',
        youCouldLate: 'affrettarsi, chiusura imminente',
        workingTime: 'orario di lavoro',
        showAllOrgInRubric: 'Visualizza tutte le aziende della categoria',
        todayIsRestDay: 'oggi chiuso',
        internet: 'Pagamento on-line',
        noncash: 'Pagamento non in contanti',
        goldcrown: 'Zolotaja Korona',
        dinersclub: 'Diners Club',
        mastercard: 'MasterCard',
        maestrocard: 'MaestroCard',
        visa: 'Visa',
        cash: 'Pagamento in contanti',
        americanexpress: 'American Express',
        hour : 'un\'ora',
        less: 'meno di',
        _in : 'Tra',
        isClosingOnDinner : 'chiude per pausa pranzo'
    },

    en: {
        pluralRules: function (n) { // (Number)
            if (n === 1) { // 1
                return 0;
            } else {
                return 1; //0, 2, 3, 4 ..
            }
        },

        btnBack: 'Back',
        btnFindWay: 'Get here',
        btnEntrance: 'Find entrance',
        linkReviews: ['review', 'reviews'],
        linkPhoto: ['photo', 'photos'],
        linkBooklet: 'About company',
        tommorow: 'tomorrow',
        afterTommorow: 'the day after tomorrow',
        afterWeek: 'in a week',
        nextSun: 'on Sunday',
        nextMon: 'on Monday',
        nextTue: 'on Tuesday',
        nextWed: 'on Wednesday',
        nextThu: 'on Thursday',
        nextFri: 'on Friday',
        nextSat: 'on Saturday',
        willOpen: 'opens ',
        willClose: 'closes',
        isOpen: 'Open',
        openTill: 'Open till ',
        closeIn: 'Closes in ',
        openAt: 'Opens at ',
        openIn: 'Opens in ',
        open: 'Opens ',
        nHours: ['hour', 'hours'],
        nMins: ['minute', 'minutes'],
        lunch: 'lunch break',
        Lunch: 'Lunch break. ',
        workingDays: 'Working days',
        weekdays: 'Weekdays',
        restDay: ['day off','days off'],
        reviewsOnFlamp: 'Reviews on Flamp',
        writeReviewOnFlamp: 'Write a review on Flamp',
        payment: 'payment',
        everyday: 'Daily from',
        worksAroundTheClock: 'Open 24 hours',
        aroundTheClock: '24h',
        knowMore: 'see also',
        toClose: 'until closing',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
        toLunch: 'until lunch',
        today: 'Today',
        lessThenHour: 'less then one hour',
        youCouldLate: 'you might be late',
        workingTime: 'working hours',
        showAllOrgInRubric: 'Show all organizations in the category',
        todayIsRestDay: 'closed today',
        internet: 'Online',
        noncash: ' No-cash',
        goldcrown: 'Golden Crown',
        dinersclub: 'Diners Club',
        mastercard: 'Mastercard',
        maestrocard: 'MaestroCard',
        visa: 'Visa',
        cash: 'Cash',
        americanexpress: 'American Express',
        hour : 'hour',
        less: 'less',
        _in : 'In',
        isClosingOnDinner : 'will be closing for lunch'
    },

    cs: {
        pluralRules: function (n) { // (Number)
            return (n === 1) ? 0 : (n >= 2 && n <= 4) ? 1 : 2;
        },

        btnBack: 'Zpět',
        btnFindWay: 'Jet sem',
        btnEntrance: 'Hledat vstup',
        linkReviews: ['recenze', 'recenze', 'recenzí'],
        linkPhoto: ['fotografie', 'fotografie', 'fotografií'],
        linkBooklet: 'Leták',
        tommorow: 'zítra',
        afterTommorow: 'pozítří',
        afterWeek: 'za týden',
        nextSun: 'v neděli',
        nextMon: 'v pondělí',
        nextTue: 'v úterý',
        nextWed: 've středu',
        nextThu: 've čtvrtek',
        nextFri: 'v pátek',
        nextSat: 'v sobotu',
        willOpen: 'otevře se',
        willClose: 'zavře se',
        isOpen: 'Otevřeno',
        openTill: 'Otevřeno do ',
        closeIn: 'Zavře se za ',
        openAt: 'Otevře se v ',
        openIn: 'Otevře se za ',
        open: 'Otevře se ',
        nHours: [ 'hodinu' , 'hodiny' , 'hodin' ],
        nMins: [ 'minutu' , 'minuty' , 'minut' ],
        lunch: 'polední přestávka',
        Lunch: 'Polední přestávka. ',
        workingDays: 'Všední dny',
        weekdays: 'Všední dny',
        restDay: ['zavřeno', 'zavřeno'],
        reviewsOnFlamp: 'Recenze na Flampu',
        writeReviewOnFlamp: 'Napsat recenzi na Flampu',
        payment: 'platba',
        everyday: 'Denně od ',
        worksAroundTheClock: 'Pracuje nonstop',
        aroundTheClock: 'Nonstop',
        knowMore: 'dozvědět se více',
        toClose: 'do uzavření',
        monday: 'pondělí',
        tuesday: 'úterý',
        wednesday: 'středa',
        thursday: 'čtvrtek',
        friday: 'pátek',
        saturday: 'sobota',
        sunday: 'neděle',
        mon: 'po',
        tue: 'út',
        wed: 'st',
        thu: 'čt',
        fri: 'pá',
        sat: 'so',
        sun: 'ne',
        toLunch: 'do polední přestávky',
        today: 'Dnes',
        lessThenHour: 'méně než hodinu',
        youCouldLate: 'nemusíte to stihnout',
        workingTime: 'pracovní doba',
        showAllOrgInRubric: 'Zobrazit všechny organizace v rubrice',
        todayIsRestDay: 'Dnes je zavřeno',
        internet: 'Platba prostřednictvím Internetu',
        noncash: 'Bezhotovostní platba',
        goldcrown: 'Zolotaja Korona',
        dinersclub: 'Diners Club',
        mastercard: 'Mastercard',
        maestrocard: 'MaestroCard',
        visa: 'Visa',
        cash: 'Platba hotově',
        americanexpress: 'American Express',
        hour : 'hodinu',
        less: 'méně',
        _in : 'Za',
        isClosingOnDinner : 'začíná polední přestávka'
    },

    es: {
        pluralRules: function (n) { // (Number)
          return (n === 1) ? 0 : (n >= 2 && n <= 4) ? 1 : 2;
        },

        btnBack: 'Atrás',
        btnFindWay: 'Ir para allá',
        btnEntrance: 'Buscar acceso',
        linkReviews: ['comentario', 'comentarios', 'comentarios'],
        linkPhoto: ['foto', 'fotos', 'fotos'],
        linkBooklet: 'Folleto',
        tommorow: 'mañana',
        afterTommorow: 'pasado mañana',
        afterWeek: 'en una semana más',
        nextSun: 'el domingo',
        nextMon: 'el lunes',
        nextTue: 'el martes',
        nextWed: 'el miércoles',
        nextThu: 'el jueves',
        nextFri: 'el viernes',
        nextSat: 'el sábado',
        willOpen: 'se abrirá',
        willClose: 'se cerrará',
        isOpen: 'Abierto',
        openTill: 'Abierto hasta ',
        closeIn: 'Se cerrará dentro de ',
        openAt: 'Se abrirá el ',
        openIn: 'Se abrirá dentro de ',
        open: 'Se abrirá ',
        nHours: ['hora', 'horas', 'horas'],
        nMins: ['minuto', 'minutos', 'minutos'],
        lunch: 'hora de colación',
        Lunch: 'Hora de colación. ',
        workingDays: 'Días laborables',
        weekdays: 'Días laborables',
        restDay: ['cerrado','cerrado'],
        reviewsOnFlamp: 'Comentarios en Flamp',
        writeReviewOnFlamp: 'Escribir un comentario en Flamp',
        payment: 'pago',
        everyday: 'Cada día desde',
        worksAroundTheClock: 'Abierto las 24 horas',
        aroundTheClock: '24 horas',
        knowMore: 'para saber más',
        toClose: 'hasta el cierre',
        monday: 'lunes',
        tuesday: 'martes',
        wednesday: 'miércoles',
        thursday: 'jueves',
        friday: 'viernes',
        saturday: 'sábado',
        sunday: 'domingo',
        mon: 'lun',
        tue: 'mar',
        wed: 'mié',
        thu: 'jue',
        fri: 'vie',
        sat: 'sáb',
        sun: 'dom',
        toLunch: 'antes de la hora de colación',
        today: 'Hoy',
        lessThenHour: 'menos de una hora',
        youCouldLate: 'puede ser que no alcanzas a llegar',
        workingTime: 'horario de trabajo',
        showAllOrgInRubric: 'Mostrar todas las empresas de la categoría',
        todayIsRestDay: 'Hoy cerrado',
        internet: 'Pago por Internet',
        noncash: 'Pago sin efectivo',
        goldcrown: 'Zolotaya Korona',
        dinersclub: 'Diners Club',
        mastercard: 'Mastercard',
        maestrocard: 'MaestroCard',
        visa: 'Visa',
        cash: 'Pago en efectivo',
        americanexpress: 'American Express',
        hour : 'hora',
        less: 'menos de',
        _in : 'Dentro de',
        isClosingOnDinner : 'se cierra por hora de colación'
    }
};

DG.Traffic = DG.TileLayer.extend({
    options: {
        period: 0,
        disableLabel: false,
        updateWhenIdle: false // display new traffic tiles on move for mobile
    },

    statics: {
        Dictionary: {}
    },

    initialize: function(options) {
        this._tileUrl = DG.config.protocol + (DG.Browser.retina ? DG.config.retinaTrafficTileServer : DG.config.trafficTileServer);
        this._metaUrl = DG.config.protocol + (DG.Browser.retina ? DG.config.retinaTrafficMetaServer : DG.config.trafficMetaServer);
        this._timeUrl = DG.config.protocol + DG.config.trafficTimestampServer;
        this._updateInterval = DG.config.trafficLayerUpdateInterval;

        this._layersOptions = {
            errorTileUrl: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
            subdomains: '012345679',
            maxNativeZoom: 18,
            detectRetina: DG.config.detectRetina,
            minZoom: DG.config.trafficLayerMinZoom
        };

        options = DG.setOptions(this, DG.extend(options || {}, this._layersOptions));
        this._metaLayer = DG.Meta.layer(null, {
            detectRetina: options.detectRetina,
            maxNativeZoom: options.maxNativeZoom,
            dataFilter: DG.bind(this._processData, this),
            minZoom: options.minZoom
        });
        this._isDg = true;
        this._isOnRequest = false; // timestampString request flag
        this._onTimer = DG.bind(this._onTimer, this);
        DG.TileLayer.prototype.initialize.call(this, this._tileUrl, options);
    },

    // #setTime(day [0-6], time[0-23]) ????

    onAdd: function(map) {
        this._initContainer();
        this._levels = {};
        this._tiles = {};

        if (this.options.period) {
            this.options.timestampString = '';
            this._onAddSetParams(map);
        } else {
            var self = this;
            this._isOnRequest = true;
            this._getTimestampString()
                .then(
                    function(response) {
                        self.options.timestampString = '?' + response;
                    },
                    function() {
                        self.options.timestampString = '?' + (new Date()).getTime();
                    })
                .then(
                    function() {
                        self._isOnRequest = false;
                        if (self._map) { // if traffic layer has not been removed from map before server response and timestampString variable is assigned
                            self._onAddSetParams(map);
                        }
                    }
                );
        }
    },

    onRemove: function(map) {
        if (!this._isOnRequest) {
            clearInterval(this._updateTimer);

            map
                .removeLayer(this._metaLayer)
                .off('projectchange projectleave', this._onMapProjectChange, this);

            if (!this.options.disableLabel) {
                this._metaLayer.off(this._layerEventsListeners, this);
                this._map.removeLayer(this._labelHelper);
                this._labelHelper = null;
                this._map.off('langchange', this._updateLang, this);
            }

            DG.TileLayer.prototype.onRemove.call(this, map);
        } else {
            L.DomUtil.remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
        }
    },

    update: function() {
        var self = this;
        this._getTimestampString().then(
            function(response) {
                self.options.timestampString = '?' + response;
            },
            function() {
                self.options.timestampString = '?' + (new Date()).getTime();
            }).then(
            function() {
                self.fire('update', {timestamp: self.options.timestampString});
                self._layerEventsListeners.mouseout.call(self);
                self._metaLayer.getOrigin().setURL(self._prepareMetaURL(), self);
                self.redraw();
            }
        );
    },

    getSubdomain: function() {
        return this._layersOptions.subdomains[
            Math.floor(Math.random() * this._layersOptions.subdomains.length)
        ];
    },

    _updateLang: function() {
        var lang = this._map.getLang();
        if (lang === 'ar') {
            this._labelHelper.options.textDirection = 'rtl';
        } else {
            this._labelHelper.options.textDirection = 'auto';
        }
    },

    _getTimestampString: function() {
        return DG.ajax(
            DG.Util.template(
                this._timeUrl,
                DG.extend({
                    s : this.getSubdomain(),
                    projectCode: this._map.projectDetector.getProject().code
                }, this.options || {})),
            {type: 'get'}
        );
    },

    _onTimer: function() {
        if (this.options.period === 0) {
            this.update();
        }
    },

    _processData: function(trafficData, coord) {
        var tileOriginPoint = coord.scaleBy(this.getTileSize());
        var polygonLngLatToPoints = DG.bind(this._polygonLngLatToPoints, this, tileOriginPoint);
        var hints = {};

        if (!DG.Util.isArray(trafficData)) {    // TODO remove
            return [];
        }

        trafficData[1].forEach(function(item) {
            this[item.graph_id] = item.speed_text;
        }, hints);

        return trafficData[0]
            .map(function(item) {
                return {
                    id: item.graph_id,
                    speed: hints[item.graph_id],
                    geometry: DG.Wkt.toGeoJSON(item.geometry[0].object[0])
                };
            })
            .filter(function(item) {
                return item.geometry.type == 'Polygon' ||
                    item.geometry.type == 'MultiPolygon';
            })
            .map(function(item) {
                var geoJson = item.geometry;

                if (geoJson.type == 'Polygon') {
                    geoJson.coordinates = polygonLngLatToPoints(geoJson.coordinates);
                } else if (geoJson.type == 'MultiPolygon') {
                    geoJson.coordinates = geoJson.coordinates.map(polygonLngLatToPoints);
                }

                return item;
            });
    },

    _polygonLngLatToPoints: function(originPoint, polygon) {
        var map = this._map;

        return polygon.map(function(contour) {
            return contour.map(function(lngLat) {
                return map
                    .project([lngLat[1], lngLat[0]]).round()
                    .subtract(originPoint);
            });
        });
    },

    _prepareMetaURL: function() {
        return DG.Util.template(this._metaUrl, DG.extend({
            x: '{x}',
            y: '{y}',
            z: '{z}',
            s: '{s}'
        }, this.options));
    },

    _updateLayerProject: function() {
        var project = this._map.projectDetector.getProject();
        DG.setOptions(this, project && project.traffic ? {
            projectCode: project.code,
            bounds: project.latLngBounds,
            minZoom: Math.max(project.minZoom, this._layersOptions.minZoom),
            maxZoom: project.maxZoom
        } : {
            maxZoom: project ? project.maxZoom : DG.config.projectLeaveMaxZoom,
            minZoom: 0
        });
        this._metaLayer.getOrigin().setURL(this._prepareMetaURL());
    },

    _onMapProjectChange: function() {
        this._updateLayerProject();
        this.redraw();
    },

    _layerEventsListeners: {
        mouseover: function(e) { // (Object)
            this._setCursor('pointer');
            if (this._labelHelper && e.meta.speed) {
                this._labelHelper
                    .setPosition(e.latlng)
                    .setContent(e.meta.speed + ' ' + this.t('speed_unit_km_h'))
                    .addTo(this._map);
            }
        },
        mouseout: function() {
            this._setCursor('');
            if (this._labelHelper) {
                this._map.removeLayer(this._labelHelper);
            }
        },
        mousemove: function(e) {
            if (this._labelHelper) {
                this._labelHelper.setPosition(e.latlng);
            }
        }
    },

    _setCursor: function(cursor) { // (String)
        this._map.getContainer().style.cursor = cursor;
    },

    _onAddSetParams: function(map) {
        this._updateLayerProject();

        map
            .addLayer(this._metaLayer)
            .on('projectchange projectleave', this._onMapProjectChange, this);

        if (!this.options.disableLabel) {
            this._metaLayer.on(this._layerEventsListeners, this);
            this._labelHelper = DG.label();
            this._map.on('langchange', this._updateLang, this);
        }

        if (this._updateInterval) {
            this._updateTimer = setInterval(this._onTimer, this._updateInterval);
        }

        this._resetView();
        this._update();
    },

    _update: function(center) {
        if (!this._isOnRequest) {
            DG.TileLayer.prototype._update.call(this, center);
        }
    }

});

DG.Traffic.include(DG.Locale);

DG.traffic = function(options) { // (Object)
    return new DG.Traffic(options);
};

DG.Traffic.Dictionary.ru = {
    speed_unit_km_h: 'км/ч'
};

DG.Traffic.Dictionary.it = {
    speed_unit_km_h: 'km/h'
};

DG.Traffic.Dictionary.cs = {
    speed_unit_km_h: 'km/h'
};

DG.Traffic.Dictionary.es = {
    speed_unit_km_h: 'km/h'
};

DG.Traffic.Dictionary.en = {
    speed_unit_km_h: 'km/h'
};

DG.Traffic.Dictionary.ar = {
    speed_unit_km_h: 'كم/ساعة'
};

DG.Control.Traffic = DG.RoundControl.extend({
    options: {
        position: 'topright',
        iconClass: 'traffic'
    },

    statics: {
        Dictionary: {}
    },

    initialize: function(options) {
        this._trafficClass = 'dg-traffic-control';
        this._controlHideClass = 'dg-control-round_is-hidden_true';

        DG.setOptions(this, options);
        DG.extend(this, {
            _active: false,
            _trafficLayer: null
        }).on(this._controlEvents, this);
    },

    _controlEvents: {
        add: function() {
            this._trafficLayer = DG.traffic();
            this._map.on('zoomend projectchange projectleave', this._updateControlVisibility, this);
        },
        click: function() {
            this._active = !this._active;

            if (this._active) {
                this.setState('active');
                this._showTraffic();
            } else {
                this.setState('');
                this._hideTraffic();
            }
        },
        remove: function() {
            this.off(this._controlEvents, this);
            this._map.off('zoomend projectchange projectleave', this._updateControlVisibility, this);
            if (this._active) {
                this._map.removeLayer(this._trafficLayer);
                this._active = false;
            }
            this._trafficLayer = null;
        }
    },

    _showTraffic: function() { // ()
        this._updateTrafficScore();
        this._map.addLayer(this._trafficLayer);
    },

    _hideTraffic: function() { // ()
        this._handleDom('remove');
        this._map.removeLayer(this._trafficLayer);
    },

    _handleDom: function(method, score) {
        var a = this._link;

        a.innerHTML = isNaN(score) ? '' : score;
        DG.DomUtil[method + 'Class'](a, this._trafficClass);
        DG.DomUtil[method + 'Class'](a, this._trafficClass + '_color_' + this._scoreRate);
    },

    _getTrafficColor: function(score) { // (Number) -> String
        var result = 'green';

        if (score > 7) {
            result = 'red';
        } else if (score > 4) {
            result = 'yellow';
        }

        return result;
    },

    _updateControlVisibility: function() {
        var project = this._map.projectDetector.getProject(),
            projectHasTraffic = project && project.traffic,
            method = ((this._map.getZoom() < DG.config.trafficLayerMinZoom) ||
            (!projectHasTraffic)) ? 'addClass' : 'removeClass';

        DG.DomUtil[method](this._container, this._controlHideClass);
        if (this._active && projectHasTraffic) {
            this._updateTrafficScore();
        }
    },

    _updateTrafficScore: function() {
        var self = this;

        this._getTrafficScore().then(function(score) {
            score = parseInt(score, 10); // sometimes webapi returns something like '5,+'

            self._scoreRate = self._getTrafficColor(score);
            self._handleDom('add', score);
        });
    },

    _getTrafficScore: function() { // () -> Promise
        var url = DG.Util.template(
            DG.config.protocol + DG.config.trafficScoreServer,
            {
                s: this._trafficLayer.getSubdomain(),
                projectCode: this._map.projectDetector.getProject().code
            }
        );

        return DG.ajax(url, {type: 'get'});
    },

    _renderTranslation: function() { // ()
        this._link.title = this.t('button_title');
    }
});

DG.control.traffic = function(options) {
    return new DG.Control.Traffic(options);
};

DG.Map.mergeOptions({
    trafficControl: false
});

DG.Map.addInitHook(function() {
    if (this.options.trafficControl) {
        this.trafficControl = DG.control.traffic(this.options.trafficControl);
        this.addControl(this.trafficControl);
    }
});

DG.Control.Traffic.Dictionary.ru = {
    button_title: 'Пробки'
};

DG.Control.Traffic.Dictionary.it = {
    button_title: 'Colonna'
};

DG.Control.Traffic.Dictionary.cs = {
    button_title: 'Zácpy'
};

DG.Control.Traffic.Dictionary.es = {
    button_title: 'Taco'
};

DG.Control.Traffic.Dictionary.en = {
    button_title: 'Traffic'
};

DG.Control.Traffic.Dictionary.ar = {
    button_title: 'حركة السير'
};

DG.Ruler = DG.Layer.extend({

    options: {
        editable: true
    },

    includes: [DG.Locale],

    statics: {
        Dictionary: {}
    },

    initialize: function(latlngs, options) { // (Array, Object)
        DG.Util.setOptions(this, options);

        this._layers = {
            back : null,
            middle : null,
            front : null,
            mouse : null
        };
        this._points = [];

        this._layersContainer = DG.featureGroup();
        Object.keys(this._layers).forEach(function(name) {
            this._layersContainer.addLayer(this._layers[name] = DG.featureGroup());
        }, this);

        this._reset();

        if (DG.Browser.mobile) {
            delete this._lineMouseEvents.mouseover;
            delete this._lineMouseEvents.mouseout;
            delete this._lineMouseEvents.mousemove;
        } else {
            delete this._lineMouseEvents.click;
        }

        if (latlngs && latlngs.length) {
            this.setLatLngs(latlngs);
        }
    },

    onAdd: function(map) { // (Map)
        this._map = map.on('langchange', this._updateDistance, this);

        //  Pane for ruler Markers
        if (!this._map.getPane('rulerMarkerPane')) {
            this._map.createPane('rulerMarkerPane');
        }

        //  Main ruler pane (svg objects and runner)
        if (!this._map.getPane('rulerPane')) {
            this._map.createPane('rulerPane');
        }

        this._layersContainer.addTo(this._map);

        if (this._points.length) {
            this._layers.mouse.fire('layeradd');
            this._updateDistance();
        }

        this._layers.mouse.on(this._lineMouseEvents, this);
    },

    onRemove: function(map) { // (Map)
        map
            .off('langchange', this._updateDistance, this)
            .removeLayer(this._layersContainer);

        this._layers.mouse.off(this._lineMouseEvents, this);
        this._reset();
    },

    getTotalDistance: function() { // () -> Number
        return this._calcDistance();
    },

    spliceLatLngs: function(index) { // (Number, Number, args ...) -> Array
        var oldLength = this._points.length,
            mutationStart = index >= 0 ? Math.min(index, oldLength) : oldLength - index,
            removed = Array.prototype.splice.apply(this._points, arguments).map(function(point) {
                this._layers.mouse.removeLayer(point);
                return point.off().getLatLng();
            }, this),
            length = this._points.length;

        if (length) {
            for (var i = mutationStart; i < length; i++) {
                if (!(this._points[i] instanceof DG.Ruler.LayeredMarker)) {
                    this._points[i] = this._createPoint(this._points[i], this.options.iconStyles.large)
                        .on(this._pointEvents, this)
                        .once('add', this._addCloseHandler, this)
                        .addTo(this._layers.mouse, this._layers);
                }
                if (i && !this._points[i - 1]._legs) {
                    this._addLegs(this._points[i - 1]);
                }
                this._points[i].setPointStyle(this.options.iconStyles[i && i < length - 1 ? 'small' : 'large']);
                this._points[i]._pos = i;
            }
            this._removeLegs(this._points[length - 1]);
            if (oldLength > 0 && oldLength < length) {
                this._points[oldLength - 1].collapse();
            }
            if (this._points[mutationStart]) {
                this._updateLegs(this._points[mutationStart]);
            }
            if (mutationStart > 1) {
                this._points[mutationStart - 1].setPointStyle(this.options.iconStyles.small);
            }
            this._updateDistance();
            this._normalizeRulerPoints();
        }
        if (DG.Browser.touch && this._lineMarkerHelper) {
            this._lineMarkerHelper.collapse();
        }
        this._fireChangeEvent();
        return removed;
    },

    addLatLng: function(latlng) { // (LatLng) -> Ruler
        var lastPoint = this._points[this._points.length - 1] || null;
        latlng = DG.latLng(latlng);

        if (lastPoint) {
            latlng = this._normalizeLatLng(latlng, lastPoint.getLatLng());
        }

        this.spliceLatLngs(this._points.length, 0, latlng);
        return this;
    },

    getLatLngs: function() { // () -> Array
        return this._points.map(function(point) {
            return point.getLatLng();
        });
    },

    setLatLngs: function(latlngs) { // (Array) -> Ruler
        var args = latlngs.slice();
        args.unshift(0, this._points.length);
        this.spliceLatLngs.apply(this, args);
        return this;
    },

    _reset: function() { // ()
        DG.extend(this, {
            _lineMarkerHelper: null,
            _morphingNow: false
        });
    },

    _lineMouseEvents: {
        click: function(event) {
            var target = event.layer;
            if (target instanceof DG.Marker && target._pos !== this._points.length - 1) {
                if (this._lineMarkerHelper) {
                    this._lineMarkerHelper.collapse();
                }
                target.setText(this._getFormatedDistance(target));
                this._lineMarkerHelper = target;
            } else if (target instanceof DG.Path && this.options.editable) {
                var latlng = event.latlng,
                    insertPos = target._point._pos + 1;
                this.spliceLatLngs(insertPos, 0, latlng);
            }
        },
        mouseover: function(event) { // (MouseEvent)
            var target = event.layer;

            target._hovered = true;
            if (this._morphingNow) {
                return;
            }
            if (target instanceof DG.Marker && target._pos !== this._points.length - 1) {
                target.setText(this._getFormatedDistance(target));
            } else if (target instanceof DG.Path && !this._lineMarkerHelper) {
                var point = target._point;

                this._lineMarkerHelper = this._addRunningLabel(
                    this._nearestPoint(point._legs.middle, event.latlng),
                    point
                );
            }
        },
        mouseout: function(event) { // (MouseEvent)
            var target = event.layer,
                originalEv = event.originalEvent;

            target._hovered = false;
            if (this._morphingNow || target._pos === this._points.length - 1) {
                return;
            }
            if (target instanceof DG.Marker) {
                // collapse only when we move out from label container (if browser support relatedTarget)
                if (!originalEv.relatedTarget ||
                    (originalEv.relatedTarget !== target.querySelector('container') &&
                    originalEv.relatedTarget.parentNode !== target.querySelector('container'))) {
                    target.collapse();
                }
            } else {
                this._removeRunningLabel();
            }
        },
        mousemove: function(event) { // (MouseEvent)
            if (this._morphingNow || !this._lineMarkerHelper) {
                return;
            }

            var point = event.layer._point,
                latlng = this._nearestPoint(point._legs.middle, event.latlng);

            this._lineMarkerHelper
                .setLatLng(latlng)
                .setText(this._getFormatedDistance(point, point.getLatLng().distanceTo(latlng)));
        },
        layeradd: function() { // ()
            Object.keys(this._layers).forEach(function(name) {
                this._layers[name].bringToFront();
            }, this);
        }
    },

    _fireChangeEvent: function() {
        this.fire('changed', {latlngs : this.getLatLngs()});
    },

    _addRunningLabel: function(latlng, previousPoint) { // (LatLng, Ruler.LayeredMarker)
        var point = this._createPoint(latlng).addTo(this._layers.mouse, this._layers);
        var pane = this._map.getPane('rulerPane');
        pane.insertBefore(point._icon, pane.lastElementChild);
        return point.setText(this._getFormatedDistance(previousPoint, previousPoint.getLatLng().distanceTo(latlng)));
    },

    _removeRunningLabel: function() { // ()
        if (this._lineMarkerHelper) {
            this._layers.mouse.removeLayer(this._lineMarkerHelper);
            this._lineMarkerHelper = null;
        }
    },

    _insertPointInLine: function(event) { // (MouseEvent)
        var latlng = this._lineMarkerHelper.getLatLng(),
            insertPos = event.target._point._pos + 1,
            point;

        if (L.Browser.ie) {
            var path = event.originalEvent.target || event.originalEvent.srcElement,
                parent = path.parentNode;
            parent.appendChild(path); // IE click event leaking problem solution: we reappend mousedown event target element
        }

        L.DomEvent.stopPropagation(event.originalEvent);

        this.spliceLatLngs(insertPos, 0, latlng);
        point = this._points[insertPos];
        point.setText(this._getFormatedDistance(point));

        setTimeout(function() {
            if (document.createEvent) {
                var e = document.createEvent('MouseEvents');
                e.initMouseEvent('mouseup', false, false, document.defaultView, 1, 0, 0, 0, 0, false, false, false, false, 1, point._icon);
                document.dispatchEvent(e);

                e = document.createEvent('MouseEvents');
                e.initMouseEvent('mousedown', false, false, document.defaultView, 1, 0, 0, 0, 0, false, false, false, false, 1, point._icon);
                point._icon.dispatchEvent(e);
            } else {
                point._icon.fireEvent('onMouseUp', DG.extend(document.createEventObject(), {
                    button: 1,
                    bubbles: false,
                    cancelable: false
                }));
                point._icon.fireEvent('onMouseDown', DG.extend(document.createEventObject(), {
                    button: 1,
                    bubbles: false,
                    cancelable: false
                }));
            }
        }, 0);

        this._removeRunningLabel();

        this._updateLegs(point);
    },

    // Find the point on given polyline which is closest to given latlng
    _nearestPoint: function(polyline, latlng) { // (Polyline, LatLng) -> LatLng
        var self = this;

        // Convert everything to pixel coordinates
        var point = this._project(latlng);
        var linePoints = polyline.getLatLngs().map(function(latlng) {
            return self._project(latlng);
        });

        // First look for closest polyline segment
        var minDistance;
        var closestSegmentIndex;
        for (var i = 0; i < linePoints.length - 1; i++) {
            var distance = DG.LineUtil.pointToSegmentDistance(
                point,
                linePoints[i],
                linePoints[i + 1]
            );

            if (minDistance === undefined || distance < minDistance) {
                minDistance = distance;
                closestSegmentIndex = i;
            }
        }

        // Then look for closest point on that segment
        var closestPoint = DG.LineUtil.closestPointOnSegment(
            point,
            linePoints[closestSegmentIndex],
            linePoints[closestSegmentIndex + 1]
        );

        // Convert back to LatLng
        return this._unproject(closestPoint);
    },

    _addCloseHandler: function(event) { // (Event)
        event.target
            .on('click', this._deletePoint, this)
            .querySelector('remove-link').style.display = 'inline-block';
    },

    _createPoint: function(latlng, style) { // (LatLng, Object) -> Ruler.LayeredMarker
        var pointStyle = style ? style : this.options.iconStyles.large,
            layers = {};
        Object.keys(pointStyle).forEach(function(layer) {
            layers[layer] = DG.circleMarker(latlng, pointStyle[layer]);
        });

        return DG.Ruler.layeredMarker(latlng, {
            layers : layers,
            draggable : this.options.editable,
            textDirection: this._map.getLang() !== 'ar' ? 'auto' : 'rtl'
        });
    },

    // Moves curr LatLng to correct world if necessary so that ruler section
    // between curr and base can be plotted correctly. Returns a new LatLng
    // object.
    _normalizeLatLng: function(curr, base) { // (LatLng, LatLng) -> LatLng
        var diff = (curr.lng < base.lng) ? 360 : -360;

        var newLng = curr.lng;
        while (Math.abs(newLng - base.lng) > 180) {
            newLng += diff;
        }

        return DG.latLng(curr.lat, newLng);
    },

    // Rearranges ruler points between worlds based on point param so that all
    // ruler sections can be plotted correctly.
    _normalizeRulerPoints: function(point) { // (Ruler.LayeredMarker)
        point = point || this._points[0];

        var self = this;
        var position = point._pos;
        var changedPoints = [];
        var i, currPoint, prevPoint, latlng, normalized;

        // Check points to the right
        for (i = position + 1; i < this._points.length; i++) {
            currPoint = this._points[i];
            prevPoint = this._points[i - 1];

            latlng = currPoint.getLatLng();
            normalized = this._normalizeLatLng(latlng, prevPoint.getLatLng());

            if (!normalized.equals(latlng)) {
                currPoint.setLatLng(normalized);
                changedPoints.push(i);
            }
        }

        // Check points to the left
        for (i = position - 1; i >= 0; i--) {
            currPoint = this._points[i];
            prevPoint = this._points[i + 1];

            latlng = currPoint.getLatLng();
            normalized = this._normalizeLatLng(latlng, prevPoint.getLatLng());

            if (!normalized.equals(latlng)) {
                currPoint.setLatLng(normalized);
                changedPoints.push(i);
            }
        }

        // Update legs of all points that changed position
        changedPoints.sort().reduce(function(previous, current) {
            var skipPrevious = previous && previous === current - 1;

            self._updateLegs(self._points[current], skipPrevious);

            return current;
        }, null);
    },

    _pointEvents: {
        drag: function(event) { // (Event)
            var point = event.target;

            this._normalizeRulerPoints(point);

            if (!DG.Browser.touch && point !== this._points[this._points.length - 1]) {
                point.setText(this._getFormatedDistance(point));
            }

            this._updateLegs(point);
            this._updateDistance();
        },
        dragend: function(event) { // (Event)
            var point = event.target;
            this._morphingNow = false;
            if (!point._hovered && point !== this._points[this._points.length - 1]) {
                point.collapse();
            }
            this._fireChangeEvent();
        },
        dragstart: function() { // ()
            if (DG.Browser.touch && this._lineMarkerHelper) {
                this._lineMarkerHelper.collapse();
            }
            this._morphingNow = true;
        }
    },

    _deletePoint: function(event) { // (MouseEvent)
        var originalEvent = event.originalEvent,
            target = originalEvent.target  || originalEvent.srcElement;

        if (target.className !== 'dg-ruler__label-remove-link' &&
            target.className !== 'dg-ruler__remove-link-overlay') {
            return;
        }
        DG.DomEvent.stop(event.originalEvent);
        this.spliceLatLngs(event.target._pos, 1);
    },

    _degToRad: function(deg) {
        return (Math.PI / 180) * deg;
    },

    _radToDeg: function(rad) {
        return (180 / Math.PI) * rad;
    },

    // Map-independent project method
    _project: function(latlng) {
        if (this._map) {
            return this._map.project(latlng);
        }

        return DG.CRS.EPSG3857.latLngToPoint(latlng, 1);
    },

    // Map-independent unproject method
    _unproject: function(point) {
        if (this._map) {
            return this._map.unproject(point);
        }

        return DG.CRS.EPSG3857.pointToLatLng(point, 1);
    },

    // Calculates the size of angle point1-point-point2
    _calcAngle: function(point, point1, point2) { // (LatLng, LatLng, LatLng) -> Number
        point1 = this._normalizeLatLng(point1, point);
        point2 = this._normalizeLatLng(point2, point);

        point = this._project(point);
        point1 = this._project(point1);
        point2 = this._project(point2);

        var x1 = point1.x - point.x;
        var x2 = point2.x - point.x;
        var y1 = point1.y - point.y;
        var y2 = point2.y - point.y;

        var dotProduct = x1 * x2 + y1 * y2;
        var mag1 = Math.sqrt(x1 * x1 + y1 * y1);
        var mag2 = Math.sqrt(x2 * x2 + y2 * y2);

        return Math.acos(dotProduct / (mag1 * mag2));
    },

    // Calculates the midpoint on the great circle between two LatLngs
    _calcMidPoint: function(latlng1, latlng2) { // (LatLng, LatLng) -> LatLng
        var lon1 = this._degToRad(latlng1.lng);
        var lat1 = this._degToRad(latlng1.lat);

        var lon2 = this._degToRad(latlng2.lng);
        var lat2 = this._degToRad(latlng2.lat);

        // Based on formulae from
        // http://williams.best.vwh.net/avform.htm#Intermediate
        var d = Math.acos(Math.sin(lat1) * Math.sin(lat2) +
            Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon1 - lon2));

        // Split the arc in half
        var f = 0.5;

        var A = Math.sin((1 - f) * d) / Math.sin(d);
        var B = Math.sin(f * d) / Math.sin(d);

        var x = A * Math.cos(lat1) * Math.cos(lon1) +
            B * Math.cos(lat2) * Math.cos(lon2);

        var y = A * Math.cos(lat1) * Math.sin(lon1) +
            B * Math.cos(lat2) * Math.sin(lon2);

        var z = A * Math.sin(lat1) + B * Math.sin(lat2);

        var lat = Math.atan2(z, Math.sqrt(x * x + y * y));
        var lon = Math.atan2(y, x);

        return DG.latLng(this._radToDeg(lat), this._radToDeg(lon));
    },

    // Adaptive sampling algorithm based on
    // http://ariel.chronotext.org/dd/defigueiredo93adaptive.pdf
    _adaptiveSample: function(left, right, depth, middle) { // (LatLng, LatLng, Number[, LatLng]) -> LatLng[]
        if (depth > 9) {
            // Max recursion depth reached
            return [];
        }

        middle = middle || this._calcMidPoint(left, right);

        var leftMiddle = this._calcMidPoint(left, middle);
        var rightMiddle = this._calcMidPoint(middle, right);

        var angle1 = this._calcAngle(leftMiddle, middle, left);
        var angle2 = this._calcAngle(middle, left, right);
        var angle3 = this._calcAngle(rightMiddle, middle, right);

        // left --- leftMiddle --- middle --- rightMiddle --- right
        //            angle1       angle2       angle3

        var minAngle = 3.1;
        if (angle1 > minAngle && angle2 > minAngle && angle3 > minAngle) {
            // This section is straight enough, no intermediate points needed.
            return [];
        } else {
            // Angles are too small. Recursively sample halves of this section.
            var result = [];
            result = result.concat(this._adaptiveSample(left, middle, depth + 1, leftMiddle));
            result.push(middle);
            result = result.concat(this._adaptiveSample(middle, right, depth + 1, rightMiddle));

            return result;
        }
    },

    // Calculates the great circle arc between two LatLngs.
    _calcGreatCircle: function(latlng1, latlng2) { // (LatLng, LatLng) -> LatLng[]
        latlng2 = this._normalizeLatLng(latlng2, latlng1);

        // Special case: points are close to each other (within 1 degree)
        if (latlng1.equals(latlng2, 1)) {
            return [latlng1, latlng2];
        }

        // Special case: the great circle crosses a pole
        if (Math.abs(latlng2.lng - latlng1.lng) == 180) {
            // North or south pole?
            var latitude = (latlng1.lat + latlng2.lat > 0) ? 90 : -90;

            return [
                latlng1,
                DG.latLng(latitude, latlng1.lng),
                DG.latLng(latitude, latlng2.lng),
                latlng2
            ];
        }

        var result = [];

        result.push(latlng1);
        result = result.concat(this._adaptiveSample(latlng1, latlng2, 0));
        result.push(latlng2);

        // Make sure the arc doesn't jump between worlds
        for (var i = 1; i < result.length; i++) {
            result[i] = this._normalizeLatLng(result[i], result[i - 1]);
        }

        return result;
    },

    _addLegs: function(point) {
        var pathStyles = this.options.pathStyles;

        var greatCirclePoints = this._calcGreatCircle(
            point.getLatLng(),
            this._points[point._pos + 1].getLatLng()
        );

        point._legs = {};
        Object.keys(pathStyles).forEach(function(layer) {
            point._legs[layer] = DG.polyline(greatCirclePoints, pathStyles[layer]).addTo(this._layers[layer]);
        }, this);

        point._legs.mouse._point = point.once('remove', this._clearRemovingPointLegs, this);

        if (this.options.editable && !DG.Browser.mobile) {
            point._legs.mouse.on('mousedown', this._insertPointInLine, this);
        }

        if (this._map) {
            this._layers.mouse.addLayer(point._legs.mouse);
        }
    },

    _clearRemovingPointLegs: function(event) { // (Event)
        this._removeLegs(event.target);
    },

    _removeLegs: function(point) { // (Ruler.LayeredMarker)
        if (point._legs) {
            Object.keys(point._legs).forEach(function(layer) {
                this._layers[layer].removeLayer(point._legs[layer]);
            }, this);
            point._legs = null;
        }
    },

    _updateLegs: function(point, skipPrevious) { // (Ruler.LayeredMarker, Boolean)
        var latlng = point.getLatLng(),
            previousPoint = this._points[point._pos - 1],
            nextPoint = this._points[point._pos + 1],
            self = this,
            newPoints;

        if (previousPoint && !skipPrevious) {
            newPoints = self._calcGreatCircle(previousPoint.getLatLng(), latlng);

            Object.keys(previousPoint._legs).forEach(function(layer) {
                previousPoint._legs[layer].setLatLngs(newPoints);
            });
        }

        if (nextPoint) {
            newPoints = self._calcGreatCircle(latlng, nextPoint.getLatLng());

            Object.keys(point._legs).forEach(function(layer) {
                point._legs[layer].setLatLngs(newPoints);
            });
        }
    },

    _calcDistance: function(finishPoint, tail) { // (Ruler.LayeredMarker, Number) -> Number
        var distance = tail ? tail : 0,
            calcTo = finishPoint ? finishPoint._pos : this._points.length - 1;

        for (var i = 0; i < calcTo; i++) {
            distance += this._points[i].getLatLng().distanceTo(this._points[i + 1].getLatLng());
        }

        return distance;
    },

    _getFormatedDistance: function() { // () -> String
        var distance = this._calcDistance.apply(this, arguments),
            units = 'm';

        if (distance > 1000) {
            distance /= 1000;
            units = 'km';
            if (distance > 1000) {
                distance = distance.toFixed();
                distance = distance.slice(0, -3) + ' ' + distance.slice(-3);
            } else {
                distance = distance.toFixed(2).split('.').join(this.t('delimiter'));
            }
        } else {
            distance = Math.round(distance);
        }

        return [distance || 0, ' ', this.t(units)].join('');
    },

    _updateDistance: function() { // ()
        if (this._map && this._points.length) {
            this._points[this._points.length - 1].setText(this._getFormatedDistance());
        }
    }
});

DG.ruler = function(latlngs, options) { // (Array, Object)
    return new DG.Ruler(latlngs, options);
};

DG.Ruler.LayeredMarker = DG.Marker.extend({
    options: {
        draggable: false,
        keyboard: false,
        riseOnHover: true,
        pane: 'rulerMarkerPane',
        textDirection: 'auto', // 'auto' | 'ltr' | 'rtl'
        iconHTML: [
            '<img class="dg-ruler__label-spacer" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" width="26" height="26" />',
            '<div class="dg-ruler__label-container">',
            '    <div class="dg-ruler__point"></div>',
            '    <span class="dg-ruler__label-distance">0 км</span>',
            '    <span class="dg-ruler__label-remove-link"></span>',
            '    <div class="dg-ruler__remove-link-overlay"></div>',
            '</div>'
        ].join('\n')
    },

    statics: {
        domClass : 'dg-ruler__label'
    },

    addTo : function(map, layers) {
        Object.keys(this._layers).forEach(function(name) {
            layers[name].addLayer(this._layers[name]);
        }, this);

        this._viewport = layers;
        return DG.Marker.prototype.addTo.call(this.on('move', this._onMove), map);
    },

    onRemove : function(map) {
        Object.keys(this._layers).forEach(function(name) {
            this._viewport[name].removeLayer(this._layers[name]);
        }, this);
        this.off('move', this._onMove);
        this._viewport = null;
        this._style = null;
        return DG.Marker.prototype.onRemove.call(this, map);
    },

    setText : function(text) {
        if (this._iconCollapsed) {
            this.expand();
        }
        this._iconNodes.label.innerHTML = text;
        this._iconNodes.label.setAttribute('dir', this.options.textDirection);
        return this;
    },

    setPointStyle : function(style) {
        if (this._style !== style) {
            Object.keys(this._style = style).forEach(function(name) {
                this._layers[name].setStyle(style[name]);
            }, this);
        }
        return this;
    },

    expand : function() {
        this._iconCollapsed = false;
        this._iconNodes.container.style.display = 'block';
        this._iconNodes.spacer.style.display = 'none';
        return this;
    },

    collapse : function() {
        this._iconCollapsed = true;
        this._iconNodes.container.style.display = 'none';
        this._iconNodes.spacer.style.display = 'block';
        return this;
    },

    querySelector : function(selector) {
        return this._icon.querySelector('.' + DG.Ruler.LayeredMarker.domClass + '-' + selector);
    },

    _onMove : function(event) {
        var latlng = event.latlng;
        Object.keys(this._layers).forEach(function(name) {
            this._layers[name].setLatLng(latlng);
        }, this);
    },

    _initIcon : function() {
        DG.Marker.prototype._initIcon.call(this);
        this._iconCollapsed = true;
        this._icon.style.width = '';
        this._iconNodes = {
            label : this.querySelector('distance'),
            spacer : this.querySelector('spacer'),
            container : this.querySelector('container')
        };
    },

    // don't change icon zIndex
    _setPos: function(pos) {
        L.DomUtil.setPosition(this._icon, pos);

        if (this._shadow) {
            L.DomUtil.setPosition(this._shadow, pos);
        }
    },

    _afterInit : function() {
        this._layers = this.options.layers || null;
        this.options.icon = DG.divIcon({
            className: DG.Ruler.LayeredMarker.domClass,
            iconSize: [26, 26],
            iconAnchor: [13, 13],
            html: this.options.iconHTML
        });
    }

});

DG.Ruler.LayeredMarker.addInitHook('_afterInit');

DG.Ruler.layeredMarker = function(latlng, options) {
    return new DG.Ruler.LayeredMarker(latlng, options);
};

var rulerRenderer = DG.svg({pane: 'rulerPane'});
var hoverRenderer = DG.svg({pane: 'rulerPane'});

DG.Ruler.mergeOptions({
    pathStyles: {
        back: {
            color: '#fff',
            opacity: 1,
            weight: 12,
            pointerEvents: 'none',
            noClip: true,
            renderer: rulerRenderer,
            smoothFactor: 0
        },
        middle: {
            color: '#0da5d5',
            opacity: 1,
            weight: 4,
            pointerEvents: 'none',
            noClip: true,
            renderer: rulerRenderer,
            smoothFactor: 0
        },
        mouse: {
            color: '#fff',
            opacity: DG.Browser.vml ? 0.1 : 0,
            weight: DG.Browser.touch ? 40 : 20,
            pointerEvents: 'painted',
            noClip: true,
            renderer: hoverRenderer,
            smoothFactor: 0
        }
    },
    iconStyles: {
        large: {
            back: {
                color: '#fff',
                opacity: 1,
                fillColor: '#fff',
                fillOpacity: 1,
                weight: 1,
                radius: 13,
                renderer: rulerRenderer
            },
            middle: {
                color: '#0da5d5',
                opacity: 1,
                fillColor: '#0da5d5',
                fillOpacity: 1,
                weight: 1,
                radius: 9,
                renderer: rulerRenderer
            },
            front: {
                color: '#fff',
                opacity: 1,
                fillColor: '#0da5d5',
                fillOpacity: 1,
                weight: 4,
                radius: 5,
                renderer: rulerRenderer
            }
        },
        small: {
            back: {
                color: '#fff',
                opacity: 1,
                fillColor: '#fff',
                fillOpacity: 1,
                weight: 1,
                radius: 9,
                renderer: rulerRenderer
            },
            middle: {
                color: '#0da5d5',
                opacity: 1,
                fillColor: '#0da5d5',
                fillOpacity: 1,
                weight: 1,
                radius: 5,
                renderer: rulerRenderer
            },
            front: {
                color: '#fff',
                opacity: 1,
                fillColor: '#0da5d5',
                fillOpacity: 1,
                weight: 4,
                radius: 2,
                renderer: rulerRenderer
            }
        }
    }
});

DG.Ruler.Dictionary.ru = {
    km : 'км',
    m : 'м',
    delimiter : ','
};

DG.Ruler.Dictionary.it = {
    km : 'km',
    m : 'm',
    delimiter : ','
};

DG.Ruler.Dictionary.cs = {
    km: 'km',
    m: 'm',
    delimiter: ','
};

DG.Ruler.Dictionary.es = {
    km : 'km',
    m : 'm',
    delimiter : ','
};

DG.Ruler.Dictionary.en = {
    km : 'km',
    m : 'm',
    delimiter : '.'
};

DG.Ruler.Dictionary.ar = {
    km : 'كم',
    m : 'م',
    delimiter : '.'
};

DG.Control.Ruler = DG.RoundControl.extend({

    options: {
        position: 'topright',
        iconClass: 'ruler'
    },

    statics: {
        Dictionary: {}
    },

    initialize: function(options) {
        DG.setOptions(this, options);
        DG.extend(this, {
            _active: false,
            _drawingHelper: null,
            _geoclickerNeedRestore: false
        }).on(this._controlEvents, this);
    },

    _controlEvents: {
        add: function() {
            this._drawingHelper = DG.ruler([]);
        },
        click: function() {
            this._active = !this._active;

            if (this._active) {
                this.setState('active');
                this._startDrawing();
            } else {
                this.setState('');
                this._finishDrawing();
            }
        },
        remove: function() {
            this.off(this._controlEvents, this);
            if (this._active) {
                this._map.removeLayer(this._drawingHelper);
                this._active = false;
            }
            this._drawingHelper = null;
        }
    },

    _startDrawing: function() { // ()
        this._map
            .addLayer(this._drawingHelper)
            .on('click', this._handleMapClick, this);

        this._map.fire('rulerstart');
    },

    _finishDrawing: function() { // ()
        this._map
            .off('click', this._handleMapClick, this)
            .removeLayer(this._drawingHelper);

        this._drawingHelper.setLatLngs([]);

        this._map.fire('rulerend');
    },

    _handleMapClick: function(event) { // (MouseEvents)
        this._drawingHelper.addLatLng(event.latlng);
    },

    _renderTranslation: function() { // ()
        this._link.title = this.t('button_title');
    }
});

DG.control.ruler = function(options) {
    return new DG.Control.Ruler(options);
};

DG.Map.mergeOptions({
    rulerControl: false
});

DG.Map.addInitHook(function() {
    if (this.options.rulerControl) {
        this.rulerControl = DG.control.ruler(this.options.rulerControl);
        this.addControl(this.rulerControl);
    }
});

DG.Control.Ruler.Dictionary.ru = {
    button_title: 'Линейка'
};

DG.Control.Ruler.Dictionary.it = {
    button_title : 'Righello'
};

DG.Control.Ruler.Dictionary.cs = {
    button_title: 'Pravítko'
};

DG.Control.Ruler.Dictionary.es = {
    button_title : 'Regla'
};

DG.Control.Ruler.Dictionary.en = {
    button_title : 'Ruler'
};

DG.Control.Ruler.Dictionary.ar = {
    button_title: 'مسطرة'
};

(function(dust){dust.register("DGAttribution\/copyright",body_0);function body_0(chk,ctx){return chk.w("<div class=\"dg-attribution__copyright\"><ul class=\"dg-attribution__links\"><li class=\"dg-attribution__link-item\"><a href=\"").f(ctx.get(["copyright_apilink"], false),ctx,"h").w("\" target=\"_blank\" class=\"dg-attribution__link\" dir=\"").f(ctx.get(["dir"], false),ctx,"h").w("\">").f(ctx.get(["work_on"], false),ctx,"h").w("</a></li><li class=\"dg-attribution__link-item\"><a href=\"").f(ctx.get(["copyright_license"], false),ctx,"h").w("\" target=\"_blank\" class=\"dg-attribution__link\">").f(ctx.get(["license_agreement"], false),ctx,"h").w("</a></li>").x(ctx.get(["has_no_key"], false),ctx,{"block":body_1},{}).w("</ul>").x(ctx.get(["logotype"], false),ctx,{"else":body_2,"block":body_6},{}).w("</div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<li class=\"dg-attribution__warning-message\">").f(ctx.get(["has_no_key"], false),ctx,"h").w("</li>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.s(ctx.get(["btn"], false),ctx,{"block":body_3},{});}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<div class=\"dg-attribution__button-wrapper\"><a class=\"dg-attribution__open2gis-button_name_").f(ctx.get(["name"], false),ctx,"h").w(" dg-attribution__open2gis-button dg-attribution__open2gis-icon-button\"").x(ctx.get(["open2gis_link"], false),ctx,{"else":body_4,"block":body_5},{}).w(">").f(ctx.get(["label"], false),ctx,"h").w("</a></div>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("href=\"javascript:void(0)\"");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("href=").f(ctx.get(["open2gis_link"], false),ctx,"h").w(" target=\"_blank\" name=").f(ctx.get(["open2gis_name"], false),ctx,"h");}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.w("<a href=\"").f(ctx.get(["copyright_logo"], false),ctx,"h").w("\" target=\"_blank\" class=\"dg-attribution__logo-url\"></a>");}body_6.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/cityarea",body_0);function body_0(chk,ctx){return chk.w("<div class=\"dg-map-geoclicker__purpose dg-map-geoclicker__purpose_type_").f(ctx.get(["type"], false),ctx,"h").w("\">").f(ctx.get(["purpose"], false),ctx,"h").w("</div>").s(ctx.get(["drilldown"], false),ctx,{"block":body_1},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"dg-map-geoclicker__drilldown\">").f(ctx.get(["drilldown"], false),ctx,"h").w("</div>");}body_1.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/firmCardAddr",body_0);function body_0(chk,ctx){return chk.w("<address class=\"dg-firm-card__address dg-firm-card__icon\">").f(ctx.get(["address"], false),ctx,"h").s(ctx.get(["comment"], false),ctx,{"block":body_1},{}).w("</address>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<span class=\"dg-firm-card__comment\">&mdash; ").f(ctx.getPath(true, []),ctx,"h").w("</span>");}body_1.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/firmCardContacts",body_0);function body_0(chk,ctx){return chk.s(ctx.get(["groups"], false),ctx,{"block":body_1},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.s(ctx.get(["contacts"], false),ctx,{"block":body_2},{});}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.h("select",ctx,{"block":body_3},{"key":ctx.get(["type"], false),"type":"string"},"h");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.h("eq",ctx,{"block":body_4},{"value":"phone","type":"string"},"h").h("eq",ctx,{"block":body_6},{"value":"fax","type":"string"},"h").h("eq",ctx,{"block":body_8},{"value":"website","type":"string"},"h").h("eq",ctx,{"block":body_9},{"value":"email","type":"string"},"h");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<div class=\"dg-firm-card__phone dg-firm-card__icon\"><span class=\"dg-firm-card__phone-num\">").f(ctx.get(["text"], false),ctx,"h").s(ctx.get(["comment"], false),ctx,{"block":body_5},{}).w("</span></div>");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("<span class=\"dg-firm-card__comment\" title=\"").f(ctx.getPath(true, []),ctx,"h").w("\">&mdash;&nbsp;&nbsp;").f(ctx.getPath(true, []),ctx,"h").w("</span>");}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.w("<div class=\"dg-firm-card__phone dg-firm-card__icon\"><span class=\"dg-firm-card__phone-num\">").f(ctx.get(["text"], false),ctx,"h").s(ctx.get(["comment"], false),ctx,{"block":body_7},{}).w("</span></div>");}body_6.__dustBody=!0;function body_7(chk,ctx){return chk.w("<span class=\"dg-firm-card__comment\" title=\"").f(ctx.getPath(true, []),ctx,"h").w("\">&mdash;&nbsp;&nbsp;").f(ctx.getPath(true, []),ctx,"h").w("</span>");}body_7.__dustBody=!0;function body_8(chk,ctx){return chk.w("<div class=\"dg-firm-card__link dg-firm-card__site dg-firm-card__icon\"><a href=\"").f(ctx.get(["url"], false),ctx,"h").w("\" target=\"_blank\" class=\"dg-link_scheme_dark dg-firm-card__sitelink\">").f(ctx.get(["text"], false),ctx,"h").w("</a></div>");}body_8.__dustBody=!0;function body_9(chk,ctx){return chk.w("<div class=\"dg-firm-card__link dg-firm-card__email dg-firm-card__icon\"><a href=\"mailto:").f(ctx.get(["value"], false),ctx,"h").w("\">").f(ctx.get(["value"], false),ctx,"h").w("</a></div>");}body_9.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/firmCardHeader",body_0);function body_0(chk,ctx){return chk.w("<div class=\"dg-popup__header-title dg-popup__header-title_for_firmcard\" title=\"").f(ctx.get(["firmName"], false),ctx,"h").w("\">").f(ctx.get(["firmName"], false),ctx,"h").w("</div>").x(ctx.get(["links"], false),ctx,{"block":body_1},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"dg-popup__header-links\">").s(ctx.get(["links"], false),ctx,{"block":body_2},{}).w("</div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.h("eq",ctx,{"else":body_3,"block":body_6},{"key":body_7,"value":"flamp_stars","type":"string"},"h");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<a class=\"dg-popup__header-link dg-popup__link dg-popup__link_type_").f(ctx.get(["name"], false),ctx,"h").w("\"").x(ctx.get(["href"], false),ctx,{"else":body_4,"block":body_5},{}).w(">").f(ctx.get(["label"], false),ctx,"h").w("</a>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("href=\"javascript:void(0)\"");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("href=").f(ctx.get(["href"], false),ctx,"h").w(" target=\"_blank\"");}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.w("<div class=\"dg-popup__rating\"><div class=\"dg-popup__rating-stars\" style=\"width: ").f(ctx.get(["width"], false),ctx,"h").w("%\"></div></div>");}body_6.__dustBody=!0;function body_7(chk,ctx){return chk.f(ctx.get(["name"], false),ctx,"h");}body_7.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/firmCardRubric",body_0);function body_0(chk,ctx){return chk.s(ctx.get(["rubrics"], false),ctx,{"block":body_1},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<section class=\"dg-firm-card__rubrics\">").x(ctx.get(["primary"], false),ctx,{"block":body_2},{}).x(ctx.get(["additional"], false),ctx,{"block":body_4},{}).w("</section>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<ul class=\"dg-firm-card__rubrics-list dg-firm-card__rubrics-list_type_primary\">").s(ctx.get(["primary"], false),ctx,{"block":body_3},{}).w("</ul>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<li class=\"dg-firm-card__rubrics-list-item\">").f(ctx.get(["name"], false),ctx,"h").w("</li>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<ul class=\"dg-firm-card__rubrics-list dg-firm-card__rubrics-list_type_additional\">").s(ctx.get(["additional"], false),ctx,{"block":body_5},{}).w("</ul>");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("<li class=\"dg-firm-card__rubrics-list-item\">").f(ctx.get(["name"], false),ctx,"h").w("</li>");}body_5.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/firmCardSchedule",body_0);function body_0(chk,ctx){return chk.w("<div class=\"dg-firm-card__schedule dg-schedule dg-schedule_open_").x(ctx.getPath(false, ["forecast","open"]),ctx,{"else":body_1,"block":body_2},{}).w(" dg-schedule_works-everyday_").x(ctx.getPath(false, ["schedule","everyday"]),ctx,{"else":body_3,"block":body_4},{}).w("\">").x(ctx.get(["schedule"], false),ctx,{"block":body_5},{}).w("</div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("false");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("true");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("false");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("true");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.x(ctx.getPath(false, ["forecast","today"]),ctx,{"block":body_6},{}).s(ctx.getPath(false, ["forecast","now"]),ctx,{"block":body_10},{}).nx(ctx.getPath(false, ["schedule","everyday"]),ctx,{"block":body_12},{});}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.w("<div class=\"dg-schedule__today\"><div class=\"dg-schedule__today-inner\">").f(ctx.getPath(false, ["forecast","today","text"]),ctx,"h").w("&nbsp;").x(ctx.getPath(false, ["forecast","today","from"]),ctx,{"block":body_7},{}).x(ctx.getPath(false, ["schedule","lunch"]),ctx,{"block":body_8},{}).w("</div></div>");}body_6.__dustBody=!0;function body_7(chk,ctx){return chk.f(ctx.getPath(false, ["forecast","today","from"]),ctx,"h").w("&ndash;").f(ctx.getPath(false, ["forecast","today","to"]),ctx,"h");}body_7.__dustBody=!0;function body_8(chk,ctx){return chk.w(",&nbsp;").f(ctx.getPath(false, ["forecast","today","lunchStr"]),ctx,"h").w("&nbsp;").s(ctx.getPath(false, ["schedule","lunch"]),ctx,{"block":body_9},{});}body_8.__dustBody=!0;function body_9(chk,ctx){return chk.f(ctx.get(["from"], false),ctx,"h").w("&ndash;").f(ctx.get(["to"], false),ctx,"h");}body_9.__dustBody=!0;function body_10(chk,ctx){return chk.w("<div class=\"dg-schedule__now\"><span class=\"dg-schedule__now-text\">").f(ctx.getPath(true, []),ctx,"h").s(ctx.getPath(false, ["schedule","comment"]),ctx,{"block":body_11},{}).w("</span></div>");}body_10.__dustBody=!0;function body_11(chk,ctx){return chk.w(", ").f(ctx.getPath(true, []),ctx,"h");}body_11.__dustBody=!0;function body_12(chk,ctx){return chk.x(ctx.getPath(false, ["schedule","week"]),ctx,{"block":body_13},{});}body_12.__dustBody=!0;function body_13(chk,ctx){return chk.x(ctx.getPath(false, ["schedule","week","evently"]),ctx,{"block":body_14},{}).x(ctx.getPath(false, ["schedule","week","table"]),ctx,{"block":body_22},{});}body_13.__dustBody=!0;function body_14(chk,ctx){return chk.w("<div class=\"dg-schedule__table\">").s(ctx.getPath(false, ["schedule","week","evently"]),ctx,{"block":body_15},{}).w("</div>");}body_14.__dustBody=!0;function body_15(chk,ctx){return chk.w("<div class=\"dg-schedule__string\">").x(ctx.get(["alltime"], false),ctx,{"block":body_16},{}).x(ctx.get(["everyday"], false),ctx,{"else":body_17,"block":body_18},{}).x(ctx.get(["holiday"], false),ctx,{"else":body_19,"block":body_21},{}).w("</div>");}body_15.__dustBody=!0;function body_16(chk,ctx){return chk.f(ctx.get(["alltimeStr"], false),ctx,"h");}body_16.__dustBody=!0;function body_17(chk,ctx){return chk.f(ctx.get(["dayList"], false),ctx,"h");}body_17.__dustBody=!0;function body_18(chk,ctx){return chk.f(ctx.getPath(false, ["forecast","today","text"]),ctx,"h");}body_18.__dustBody=!0;function body_19(chk,ctx){return chk.w("<span class=\"schedule__string-time\">&nbsp;").f(ctx.get(["from"], false),ctx,"h").w("&ndash;").f(ctx.get(["to"], false),ctx,"h").w("</span>").s(ctx.get(["lunch"], false),ctx,{"block":body_20},{});}body_19.__dustBody=!0;function body_20(chk,ctx){return chk.w("<p>").f(ctx.get(["lunchStr"], false),ctx,"h").w("&mdash;<span class=\"schedule__string-time\">").f(ctx.get(["from"], false),ctx,"h").w("&ndash;").f(ctx.get(["to"], false),ctx,"h").w("</span></p>");}body_20.__dustBody=!0;function body_21(chk,ctx){return chk.w("&nbsp;&mdash;<span class=\"schedule__string-time\">&nbsp;").f(ctx.get(["holidayStr"], false),ctx,"h").w("</span>");}body_21.__dustBody=!0;function body_22(chk,ctx){return chk.w("<div><div class=\"dg-schedule__table\"><div class=\"dg-schedule__tc dg-schedule__tc_pre\"><div class=\"dg-schedule__day-name\">&nbsp;</div><div class=\"dg-schedule__table-clock dg-schedule__td\"></div>").x(ctx.getPath(false, ["schedule","week","hasLunch"]),ctx,{"block":body_23},{}).w("</div>").s(ctx.getPath(false, ["schedule","week","table"]),ctx,{"block":body_24},{}).w("</div>  </div>");}body_22.__dustBody=!0;function body_23(chk,ctx){return chk.w("<div class=\"dg-schedule__table-lunch dg-schedule__td\"></div>");}body_23.__dustBody=!0;function body_24(chk,ctx){return chk.h("if",ctx,{"block":body_25},{"cond":body_26},"h").w("<div class=\"dg-schedule__tc").x(ctx.get(["active"], false),ctx,{"block":body_27},{}).w("\"><div class=\"dg-schedule__day-name\">").f(ctx.get(["key"], false),ctx,"h").w("</div><div class=\"dg-schedule__td\">").x(ctx.get(["from"], false),ctx,{"else":body_28,"block":body_29},{}).w("</div>").s(ctx.get(["lunch"], false),ctx,{"block":body_30},{}).w("</div> ").h("if",ctx,{"block":body_33},{"cond":body_34},"h");}body_24.__dustBody=!0;function body_25(chk,ctx){return chk.w("<span class=\"dg-schedule__table-cell-group\">");}body_25.__dustBody=!0;function body_26(chk,ctx){return chk.w("(").f(ctx.get(["$idx"], false),ctx,"h").w(" == ").f(ctx.get(["$len"], false),ctx,"h").w(" - 2)");}body_26.__dustBody=!0;function body_27(chk,ctx){return chk.w(" dg-schedule__tc_active_true");}body_27.__dustBody=!0;function body_28(chk,ctx){return chk.w("&ndash;");}body_28.__dustBody=!0;function body_29(chk,ctx){return chk.f(ctx.get(["from"], false),ctx,"h").w(" ").f(ctx.get(["to"], false),ctx,"h");}body_29.__dustBody=!0;function body_30(chk,ctx){return chk.w("<div class=\"dg-schedule__td\">").x(ctx.get(["from"], false),ctx,{"else":body_31,"block":body_32},{}).w("</div>");}body_30.__dustBody=!0;function body_31(chk,ctx){return chk.w("&ndash;");}body_31.__dustBody=!0;function body_32(chk,ctx){return chk.f(ctx.get(["from"], false),ctx,"h").w(" ").f(ctx.get(["to"], false),ctx,"h");}body_32.__dustBody=!0;function body_33(chk,ctx){return chk.w("</span>");}body_33.__dustBody=!0;function body_34(chk,ctx){return chk.w("(").f(ctx.get(["$idx"], false),ctx,"h").w(" == ").f(ctx.get(["$len"], false),ctx,"h").w(")");}body_34.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/firmlistItem",body_0);function body_0(chk,ctx){return chk.w("<a id=\"").f(ctx.getPath(false, ["firm","id"]),ctx,"h").w("\" class=\"dg-popup__link\" href=\"#\">").f(ctx.getPath(false, ["firm","name"]),ctx,"h").w("</a>");}body_0.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/frimCardPayments",body_0);function body_0(chk,ctx){return chk.x(ctx.get(["payments"], false),ctx,{"block":body_1},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<section class=\"dg-firm-card__aa\"><ul class=\"dg-firm-card__aa-list\">").s(ctx.get(["payments"], false),ctx,{"block":body_2},{}).w("</ul></section>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<li class=\"dg-firm-card__aa-list-item\">").f(ctx.getPath(true, []),ctx,"h").w("</li>");}body_2.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/house",body_0);function body_0(chk,ctx){return chk.s(ctx.get(["address"], false),ctx,{"block":body_1},{}).s(ctx.get(["purpose"], false),ctx,{"block":body_4},{}).s(ctx.get(["attractions"], false),ctx,{"block":body_5},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<address class=\"dg-map-geoclicker__address\">").s(ctx.getPath(false, ["address","header"]),ctx,{"block":body_2},{}).s(ctx.getPath(false, ["address","drilldown"]),ctx,{"block":body_3},{}).w("</address>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"dg-map-geoclicker__address-header\">").f(ctx.getPath(true, []),ctx,"h").w("</div>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<div class=\"dg-map-geoclicker__address-drilldown\">").f(ctx.getPath(true, []),ctx,"h").w("</div>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<div class=\"dg-map-geoclicker__purpose\">").f(ctx.getPath(true, []),ctx,"h").w("</div>");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("<div class=\"dg-map-geoclicker__purpose dg-map-geoclicker__purpose_type_sight\">").f(ctx.getPath(true, []),ctx,"h").w("</div>");}body_5.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/loader",body_0);function body_0(chk,ctx){return chk.w("<div class=\"dg-preloader dg-preloader_scheme_regular dg-preloader_animation_").x(ctx.get(["anim"], false),ctx,{"else":body_1,"block":body_2},{}).x(ctx.get(["small"], false),ctx,{"block":body_3},{}).w("\"></div>");}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("false");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("true");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w(" dg-preloader_size_small");}body_3.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/popupFooter",body_0);function body_0(chk,ctx){return chk.w("<div class=\"dg-popup__footer-title\"><a class=\"dg-popup__show-less-house-link\" href=\"javascript:void(0)\">").f(ctx.get(["hideFirmsText"], false),ctx,"h").w("</a></div>");}body_0.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/popupFooterBtns",body_0);function body_0(chk,ctx){return chk.x(ctx.get(["btns"], false),ctx,{"block":body_1},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<footer class=\"dg-popup__footer-buttons\">").s(ctx.get(["btns"], false),ctx,{"block":body_2},{}).w("</footer>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<div class=\"dg-popup__footer-button-wrapper\"><a class=\"dg-popup__button_name_").f(ctx.get(["name"], false),ctx,"h").w(" dg-popup__footer-button").x(ctx.get(["icon"], false),ctx,{"block":body_3},{}).w("\"").x(ctx.get(["href"], false),ctx,{"else":body_4,"block":body_5},{}).w(">").f(ctx.get(["label"], false),ctx,"h").w("</a></div>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w(" dg-popup__footer-icon-button");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("href=\"javascript:void(0)\"");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("href=").f(ctx.get(["href"], false),ctx,"h").w(" target=\"_blank\"");}body_5.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/popupHeader",body_0);function body_0(chk,ctx){return chk.s(ctx.get(["title"], false),ctx,{"block":body_1},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"dg-popup__header-title\">").f(ctx.getPath(true, []),ctx,"h").w("</div>");}body_1.__dustBody=!0;return body_0}(dust));
(function(dust){dust.register("DGGeoclicker\/sight",body_0);function body_0(chk,ctx){return chk.s(ctx.get(["purpose"], false),ctx,{"block":body_1},{}).s(ctx.get(["address"], false),ctx,{"block":body_2},{}).s(ctx.get(["description"], false),ctx,{"block":body_5},{});}body_0.__dustBody=!0;function body_1(chk,ctx){return chk.w("<div class=\"dg-map-geoclicker__purpose dg-map-geoclicker__purpose_type_sight\">").f(ctx.getPath(true, []),ctx,"h").w("</div>");}body_1.__dustBody=!0;function body_2(chk,ctx){return chk.w("<address class=\"dg-map-geoclicker__address\">").s(ctx.getPath(false, ["address","header"]),ctx,{"block":body_3},{}).s(ctx.getPath(false, ["address","drilldown"]),ctx,{"block":body_4},{}).w("</address>");}body_2.__dustBody=!0;function body_3(chk,ctx){return chk.w("<div class=\"dg-map-geoclicker__address-header\">").f(ctx.getPath(true, []),ctx,"h").w("</div>");}body_3.__dustBody=!0;function body_4(chk,ctx){return chk.w("<div class=\"dg-map-geoclicker__address-drilldown\">").f(ctx.getPath(true, []),ctx,"h").w("</div>");}body_4.__dustBody=!0;function body_5(chk,ctx){return chk.w("<div class=\"dg-map-geoclicker__sight-description\">").f(ctx.getPath(true, []),ctx,"h").w("</div>").s(ctx.get(["showMoreText"], false),ctx,{"block":body_6},{});}body_5.__dustBody=!0;function body_6(chk,ctx){return chk.w("<a class=\"dg-map-geoclicker__show-more-sights-link\" href=\"javascript:void(0)\">").f(ctx.getPath(true, []),ctx,"h").w("</a>");}body_6.__dustBody=!0;return body_0}(dust));DG.fallbackProjectsList = JSON.parse('[{"bounds":"POLYGON((46.177718 41.743003,46.246708 41.777312,46.315699 41.777312,46.407686 41.863003,46.407686 41.897247,46.430683 41.897247,46.545667 41.880127,46.545667 41.82874,46.706646 41.82874,46.729642 41.845874,46.936614 41.691506,47.005605 41.622779,47.028602 41.571186,47.143586 41.571186,47.18958 41.467875,47.235574 41.433401,47.281567 41.329871,47.373555 41.278044,47.511536 41.24347,47.55753 41.208877,47.672514 41.226176,47.764502 41.191574,47.902483 41.24347,47.902483 41.295324,47.971473 41.347138,48.017467 41.433401,48.109455 41.50233,48.224439 41.519551,48.408414 41.605586,48.408414 41.657152,48.454408 41.691506,48.546395 41.777312,48.592389 41.845874,48.822358 41.948579,48.868351 41.948579,48.891348 41.880127,48.937342 41.845874,49.236301 41.485105,49.374283 41.278044,49.397279 41.260759,49.742233 40.861946,49.903211 40.75751,49.949204 40.722662,51.00706 40.425713,51.030057 40.408205,50.93807 40.145029,50.915073 40.127448,50.225167 40.162606,50.064189 40.162606,49.903211 40.109862,49.788226 40.004251,49.696239 39.774865,49.627248 39.58017,49.604251 39.491491,49.46627 39.08211,49.282295 38.580509,49.236301 38.40051,49.213305 38.382486,48.891348 38.41853,48.822358 38.436546,48.707373 38.382486,48.615386 38.382486,48.500402 38.508564,48.408414 38.580509,48.316427 38.580509,48.224439 38.67034,48.224439 38.706241,48.040464 38.795914,48.017467 38.813835,47.99447 38.867571,47.99447 38.903373,48.155448 38.974922,48.247436 38.974922,48.316427 39.028536,48.29343 39.08211,48.270433 39.099959,48.155448 39.17131,48.132452 39.17131,48.109455 39.260396,48.155448 39.331584,48.316427 39.36715,48.316427 39.402699,48.017467 39.668736,47.856489 39.651032,47.741505 39.58017,47.695511 39.58017,47.534533 39.721821,47.465542 39.774865,47.396552 39.774865,47.373555 39.757188,47.25857 39.863181,47.304564 39.933752,47.281567 39.951384,47.143586 39.951384,47.120589 40.004251,47.18958 40.021864,47.235574 40.074676,47.212577 40.127448,47.212577 40.180179,47.143586 40.197746,47.143586 40.267972,47.097592 40.303058,47.097592 40.320593,47.028602 40.355652,47.028602 40.425713,46.982608 40.460717,46.982608 40.530669,46.913617 40.548146,46.913617 40.65291,46.82163 40.687795,46.82163 40.740088,46.752639 40.75751,46.775636 40.844551,46.775636 41.000938,46.729642 41.10499,46.660652 41.10499,46.660652 41.208877,46.683649 41.208877,46.706646 41.295324,46.637655 41.381657,46.499674 41.416158,46.315699 41.519551,46.315699 41.605586,46.200714 41.622779,46.177718 41.743003))","code":"baku","country_code":"az","domain":"az","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true},"id":"209","name":"Bakı","time_zone":{"name":"Asia/Baku","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((31.988648 35.065604,32.011645 35.122053,32.011645 35.159663,32.080635 35.272392,32.218617 35.328697,32.333601 35.328697,32.471582 35.384964,32.586567 35.40371,32.609563 35.422453,32.655557 35.422453,32.678554 35.516099,32.747545 35.572234,32.885526 35.62833,32.977513 35.62833,33.276473 35.572234,33.552435 35.572234,33.690416 35.62833,33.874391 35.665706,34.081363 35.759068,34.495307 35.908221,34.564298 35.926845,34.702279 35.926845,34.725276 35.908221,34.84026 35.852321,34.886254 35.703064,34.84026 35.590937,34.771269 35.478654,34.702279 35.459924,34.610291 35.384964,34.518304 35.328697,34.357326 35.253615,34.265338 35.159663,34.288335 35.14086,34.357326 35.009116,34.357326 34.914882,34.288335 34.801659,34.265338 34.782774,34.10436 34.726091,34.012373 34.744989,33.897388 34.726091,33.828398 34.707188,33.805401 34.650453,33.460448 34.517921,33.276473 34.480016,33.207482 34.385178,33.115495 34.347212,32.908523 34.347212,32.701551 34.423126,32.63256 34.423126,32.402592 34.498971,32.26461 34.555809,32.218617 34.59368,32.19562 34.59368,32.172623 34.650453,32.057639 34.820541,32.011645 34.971435,32.011645 35.046779,31.988648 35.065604))","code":"cyprus","country_code":"cy","domain":"com.cy","flags":{"2gis_reviews":true,"flamp":false,"gdpr":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true},"id":"173","name":"Cyprus","time_zone":{"name":"Europe/Nicosia","offset":180},"type":"region","zoom_level":{"max":19,"min":9}},{"bounds":"POLYGON((51.995926 18.939718,51.995926 19.004961,52.616841 19.200535,52.915801 19.309088,52.984791 19.33079,53.95066 19.655969,54.571576 19.850762,54.870535 19.958877,55.008516 20.002103,55.238485 20.692079,55.49145 21.485965,55.675425 21.998624,55.215488 22.700507,55.215488 23.039531,55.284479 23.187588,55.307475 23.208725,55.468454 23.483208,55.537444 23.546469,55.560441 23.651837,55.514447 23.967432,55.583438 23.988444,55.629432 24.030458,55.767413 24.05146,55.79041 24.030458,55.997382 24.05146,55.997382 24.093454,55.951388 24.219352,55.79041 24.219352,55.813407 24.324173,55.836403 24.324173,55.836403 24.407967,55.79041 24.491705,55.767413 24.554472,55.79041 24.575388,55.836403 24.679912,55.813407 24.888699,55.8594 24.972115,56.020378 24.99296,56.043375 24.930414,55.997382 24.84697,56.043375 24.8261,56.043375 24.763469,56.112366 24.742585,56.181357 24.763469,56.22735 24.867836,56.319338 24.888699,56.342335 24.972115,56.52631 24.99296,56.5953 25.03464,56.5953 25.533689,56.572303 25.637398,56.549306 25.69958,56.457319 25.69958,56.296341 25.637398,56.296341 25.616663,56.22735 25.616663,56.15836 25.658129,56.15836 25.76173,56.181357 26.03067,56.043375 26.07199,55.997382 26.113297,55.905394 26.133944,55.882397 26.154588,55.905394 26.257754,55.928391 26.278376,56.020378 26.422627,56.273344 26.607829,56.549306 26.73113,56.687288 26.669496,56.733281 26.628388,56.779275 26.546128,56.779275 26.422627,56.802272 26.154588,57.285206 24.909558,57.423188 24.533553,57.584166 24.428906,58.274072 24.05146,58.665019 23.862319,58.87199 23.736071,58.87199 23.715017,58.940981 23.693961,58.963978 23.6097,58.986975 23.588627,59.101959 23.462114,59.17095 23.356594,59.193947 23.33548,59.216944 23.272118,59.23994 23.25099,59.262937 23.187588,59.377922 23.124155,59.469909 22.933677,59.492906 22.912497,59.515903 22.912497,59.630887 22.785342,59.837859 22.764139,59.97584 22.700507,60.067828 22.530679,60.067828 22.232977,60.044831 22.211688,60.021834 22.105196,59.929847 21.998624,59.883853 21.934642,59.883853 21.849288,59.860856 21.827941,59.768868 21.721161,59.699878 21.614301,59.676881 21.528757,59.653884 21.507363,59.584893 21.400345,59.5389 21.271821,59.23994 21.121734,59.078962 20.95002,59.101959 20.799608,59.124956 20.778109,59.216944 20.519875,59.193947 20.369037,59.032969 20.218051,58.917984 20.066918,58.87199 20.045316,58.87199 20.023711,58.757006 19.958877,58.688015 19.93726,58.550034 19.93726,58.527037 19.958877,58.251075 20.110114,58.0671 20.110114,58.044103 19.91564,58.021106 19.894017,58.021106 19.720927,57.952116 19.61265,57.998109 19.374185,57.998109 19.309088,58.090097 19.004961,58.0671 18.896209,57.952116 18.787386,57.745144 18.722059,57.469181 18.722059,57.239213 18.678493,57.216216 18.656706,57.147225 18.656706,56.940253 18.56953,56.871263 18.460497,56.871263 18.416865,56.802272 18.176688,56.779275 18.154838,56.779275 18.089269,56.710285 17.936181,56.5953 17.870531,56.641294 17.54192,56.618297 17.410307,56.503313 17.300558,56.319338 17.25664,56.250347 17.2786,55.905394 17.25664,55.698422 17.25664,55.49145 17.212711,55.468454 17.102844,55.42246 17.058879,55.376466 16.992912,55.353469 16.970918,55.169494 16.816887,55.077507 16.772855,54.939525 16.750835,54.801544 16.706788,54.617569 16.750835,54.594572 16.772855,54.525582 16.816887,54.433594 16.794872,54.433594 16.816887,54.226622 16.794872,54.111638 16.728813,54.019651 16.684761,53.881669 16.662731,53.812679 16.596626,53.605707 16.530498,53.490723 16.530498,53.237757 16.464348,53.168766 16.464348,53.053782 16.684761,53.007788 16.816887,52.984791 16.838899,52.984791 16.882916,52.961795 16.90492,52.938798 16.970918,52.869807 17.124823,52.754823 17.2786,52.754823 17.366415,52.731826 17.388363,52.685832 17.519991,52.616841 17.673436,52.432867 18.023676,52.156904 18.634916,52.087913 18.743837,51.995926 18.939718))","code":"oman","country_code":"om","domain":"om","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":false,"road_network":true},"id":"237","name":"Oman","time_zone":{"name":"Asia/Muscat","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((11.360454 45.115228,11.360454 45.309637,11.383451 45.680399,11.406448 45.728579,11.774398 45.728579,12.119351 45.712524,12.464304 45.712524,12.602285 45.680399,12.579289 45.082761,12.510298 45.066521,12.487301 45.082761,12.027364 45.082761,11.774398 45.098997,11.429445 45.098997,11.360454 45.115228))","code":"padova","country_code":"it","domain":"it","flags":{"2gis_reviews":false,"flamp":false,"gdpr":true,"metro":false,"public_transport":true,"road_network":false},"id":"66","name":"Padova","time_zone":{"name":"Europe/Rome","offset":120},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((14.212066 49.954501,14.212066 50.131727,14.235063 50.175931,14.649007 50.175931,14.717998 50.161201,14.717998 49.984084,14.695001 49.939703,14.235063 49.939703,14.212066 49.954501))","code":"praha","country_code":"cz","domain":"cz","flags":{"2gis_reviews":true,"flamp":false,"gdpr":true,"metro":true,"public_transport":true,"road_network":true},"id":"92","name":"Praha","time_zone":{"name":"Europe/Prague","offset":120},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.693328 23.693961,41.693328 23.757121,41.762318 23.778167,41.831309 23.757121,41.900299 23.757121,41.946293 23.841286,42.038281 23.841286,42.084274 23.925397,42.084274 23.988444,42.130268 24.030458,42.107271 24.135434,42.153265 24.219352,42.153265 24.324173,42.084274 24.5963,42.084274 24.659015,42.130268 24.700807,42.130268 24.721698,42.452224 24.721698,42.475221 24.659015,42.567209 24.491705,42.797177 24.491705,42.866168 24.554472,42.935159 24.575388,43.096137 24.554472,43.165127 24.638113,43.211121 24.721698,43.142131 24.805227,43.165127 24.888699,43.188124 24.909558,43.119134 24.930414,43.142131 24.99296,43.326105 25.055475,43.487084 25.201218,43.579071 25.201218,43.625065 25.159595,43.671059 25.159595,43.786043 25.326002,43.993015 25.326002,44.085002 25.450657,44.199987 25.47142,44.360965 25.49218,44.452952 25.575183,44.521943 25.575183,44.659924 25.512936,44.728915 25.512936,44.774908 25.658129,44.797905 25.678856,44.797905 25.7203,44.61393 25.968661,44.498946 26.113297,44.406958 26.381431,44.383962 26.607829,44.406958 26.956836,44.498946 26.997825,44.590933 26.997825,44.705918 27.018314,44.797905 26.956836,44.843899 26.956836,44.866896 27.100232,44.889893 27.325198,44.98188 27.570096,44.91289 27.631235,45.004877 27.69234,45.073868 27.671976,45.096865 27.570096,45.119861 27.406891,45.165855 27.304765,45.28084 27.243445,45.395824 27.222997,45.579799 27.222997,45.579799 27.120702,45.740777 27.05928,45.855761 26.956836,46.062733 26.813257,46.131724 26.83378,46.154721 26.854298,46.223711 26.83378,46.246708 26.813257,46.315699 26.792731,46.522671 26.690045,46.637655 26.669496,46.798633 26.648944,46.913617 26.669496,47.005605 26.587266,47.074595 26.587266,47.281567 26.402031,47.511536 26.402031,47.534533 26.34022,47.580527 26.195865,47.603524 26.175229,47.580527 26.03067,47.62652 25.989334,47.62652 25.865241,47.695511 25.803145,47.695511 25.69958,47.672514 25.69958,47.649517 25.554438,47.718508 25.450657,47.764502 25.242827,47.62652 25.159595,47.62652 25.013802,47.741505 24.867836,47.741505 24.533553,47.833492 24.533553,47.99447 24.554472,47.99447 24.491705,48.086458 24.324173,48.109455 24.303215,48.109455 24.198378,48.155448 24.114445,48.155448 24.05146,48.109455 23.967432,48.132452 23.82025,48.132452 23.588627,48.086458 23.419916,48.109455 23.356594,48.086458 22.9972,48.086458 22.912497,48.040464 22.615619,47.99447 22.40317,47.92548 22.296824,47.902483 22.275545,47.879486 22.169101,47.810495 22.041262,47.810495 21.9773,47.948477 21.891971,48.201442 21.891971,48.201442 21.849288,48.086458 21.785239,48.040464 21.742523,47.971473 21.721161,47.856489 21.550147,47.833492 21.400345,47.902483 21.357516,47.879486 21.057364,47.948477 20.992967,48.178445 20.713591,48.178445 20.692079,47.603524 19.482621,47.580527 19.46094,47.534533 19.33079,47.097592 19.33079,46.292702 19.309088,45.372827 19.309088,45.165855 19.222252,45.119861 19.222252,45.119861 19.309088,45.073868 19.439255,44.590933 19.417568,44.383962 19.417568,44.337968 19.482621,44.222983 19.46094,44.153993 19.482621,44.153993 19.547649,44.222983 19.569319,44.222983 19.699277,44.17699 19.93726,44.107999 20.002103,44.085002 20.110114,44.062005 20.261205,44.039008 20.282777,44.039008 20.519875,43.993015 20.519875,43.87803 20.606001,43.80904 20.670565,43.832037 20.692079,43.80904 20.821105,43.694055 21.014436,43.579071 21.121734,43.579071 21.207517,43.671059 21.378932,43.671059 21.421755,43.487084 21.507363,43.487084 21.699795,43.464087 21.721161,43.487084 21.870631,43.487084 21.9773,43.372099 22.041262,43.349102 22.190396,43.326105 22.190396,43.303109 22.296824,43.349102 22.360642,43.234118 22.466939,43.211121 22.530679,43.188124 22.551919,43.165127 22.615619,43.234118 22.67929,43.142131 22.721721,42.958156 22.721721,42.935159 22.742931,42.866168 22.891312,42.774181 22.891312,42.774181 22.912497,42.751184 22.912497,42.728187 23.018367,42.70519 23.08185,42.475221 23.103004,42.452224 23.166447,42.429227 23.272118,42.406231 23.272118,42.406231 23.419916,42.291246 23.462114,42.245253 23.588627,42.176262 23.6097,42.176262 23.588627,42.015284 23.588627,41.831309 23.630771,41.693328 23.693961))","code":"riyadh","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true},"id":"216","name":"Riyadh","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((-70.85336 -33.64176,-70.85336 -33.354102,-70.830364 -33.296456,-70.554401 -33.296456,-70.48541 -33.315676,-70.48541 -33.603461,-70.508407 -33.660903,-70.78437 -33.660903,-70.85336 -33.64176))","code":"santiago","country_code":"cl","domain":"cl","flags":{"2gis_reviews":false,"flamp":false,"gdpr":true,"metro":true,"public_transport":true,"road_network":true},"id":"101","name":"Santiago","time_zone":{"name":"America/Santiago","offset":-240},"type":"region","zoom_level":{"max":19,"min":9}},{"bounds":"POLYGON((51.444001 24.366077,51.444001 24.428906,51.581982 24.554472,51.581982 24.659015,52.018923 24.763469,52.271888 24.8261,52.363876 24.867836,52.340879 24.99296,52.40987 25.013802,52.47886 25.013802,52.501857 25.076306,52.639838 25.180408,52.84681 25.450657,52.869807 25.47142,52.938798 25.49218,52.984791 25.49218,54.111638 25.47142,54.226622 25.47142,54.341607 25.49218,55.1235 25.575183,55.284479 25.595925,55.376466 25.741017,55.42246 25.782439,55.514447 25.823847,55.767413 25.968661,55.79041 25.989334,55.8594 26.133944,55.882397 26.154588,55.905394 26.133944,55.997382 26.113297,56.043375 26.07199,56.181357 26.03067,56.15836 25.76173,56.15836 25.658129,56.22735 25.616663,56.296341 25.616663,56.296341 25.637398,56.457319 25.69958,56.549306 25.69958,56.572303 25.637398,56.5953 25.533689,56.5953 25.03464,56.52631 24.99296,56.342335 24.972115,56.319338 24.888699,56.22735 24.867836,56.181357 24.763469,56.112366 24.742585,56.043375 24.763469,56.043375 24.8261,55.997382 24.84697,56.043375 24.930414,56.020378 24.99296,55.8594 24.972115,55.813407 24.888699,55.836403 24.679912,55.79041 24.575388,55.767413 24.554472,55.79041 24.491705,55.836403 24.407967,55.836403 24.324173,55.813407 24.324173,55.79041 24.219352,55.951388 24.219352,55.997382 24.093454,55.997382 24.05146,55.79041 24.030458,55.767413 24.05146,55.629432 24.030458,55.583438 23.988444,55.514447 23.967432,55.560441 23.651837,55.537444 23.546469,55.468454 23.483208,55.307475 23.208725,55.284479 23.187588,55.215488 23.039531,55.215488 22.700507,55.1235 22.636846,54.916529 22.65807,54.893532 22.67929,54.341607 22.721721,54.272616 22.742931,53.835676 22.806543,53.674698 22.806543,53.14577 22.870125,52.984791 22.891312,52.869807 22.891312,52.84681 22.912497,52.662835 22.912497,52.662835 22.933677,52.570848 22.933677,52.340879 23.229859,52.156904 23.441017,52.018923 23.630771,51.765957 23.925397,51.67397 24.009453,51.581982 24.156418,51.581982 24.261291,51.535989 24.345126,51.444001 24.366077))","code":"dubai","country_code":"ae","domain":"ae","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"99","name":"UAE","time_zone":{"name":"Asia/Dubai","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((89.710795 54.632572,89.917767 54.765465,90.308713 54.738921,90.33171 54.77873,90.400701 54.844991,90.515685 54.911144,90.768651 54.911144,90.860638 54.85823,90.929629 54.85823,90.929629 54.8185,90.952626 54.805248,90.929629 54.725643,90.906632 54.71236,90.906632 54.659186,91.06761 54.59262,91.136601 54.579294,91.136601 54.552628,91.205591 54.539289,91.274582 54.485888,91.251585 54.419038,91.274582 54.405655,91.596538 54.432417,91.619535 54.419038,91.757516 54.419038,91.872501 54.35208,91.872501 54.311852,91.826507 54.285012,91.826507 54.137078,91.757516 54.09664,91.80351 53.988613,91.80351 53.94803,91.849504 53.920953,91.826507 53.853184,91.826507 53.758122,91.849504 53.744525,91.826507 53.649216,91.826507 53.540028,91.987485 53.471642,92.17146 53.361995,92.309441 53.307066,92.424426 53.307066,92.585404 53.265822,92.838369 53.252065,92.930357 53.155645,93.114332 53.08664,93.367297 52.934438,93.436288 52.865079,93.528275 52.67028,93.505279 52.628424,93.482282 52.614463,93.482282 52.474609,93.551272 52.474609,93.574269 52.432566,93.597266 52.334309,93.689254 52.292132,93.71225 52.249915,93.942219 52.16536,94.195185 52.080644,94.195185 52.052369,94.287172 51.995766,94.494144 51.896539,94.494144 51.797093,94.471147 51.754405,94.517141 51.711677,94.724113 51.711677,94.724113 51.654644,94.609128 51.640375,94.609128 51.626101,94.517141 51.611822,94.425153 51.56896,94.264175 51.583252,94.218182 51.611822,94.218182 51.654644,94.195185 51.668909,94.195185 51.68317,94.126194 51.725925,93.965216 51.853946,93.689254 52.066509,93.482282 52.151251,93.459285 52.151251,93.390294 52.193563,93.160326 52.278064,92.424426 52.348359,91.918494 52.544592,91.481554 52.572554,91.343573 52.67028,91.297579 52.712096,91.297579 52.726026,91.021617 52.920575,90.768651 53.072825,90.653667 53.196994,90.653667 53.224539,90.69966 53.279574,90.768651 53.320805,90.791648 53.361995,90.906632 53.403146,90.929629 53.444257,91.044613 53.485328,91.044613 53.540028,90.69966 53.608304,90.446695 53.676469,90.33171 53.717316,90.193729 53.839617,90.216726 53.934494,90.193729 53.97509,90.124739 54.042661,89.986757 54.204386,89.96376 54.204386,89.96376 54.217835,89.917767 54.271585,89.825779 54.405655,89.710795 54.632572))","code":"abakan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"69","name":"Абакан","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.876575 43.201679,39.876575 43.21844,40.014556 43.385799,40.037553 43.485993,40.083547 43.519355,40.106544 43.569362,40.221528 43.569362,40.244525 43.586022,40.405503 43.552697,40.520487 43.536028,40.543484 43.519355,40.612475 43.536028,40.635472 43.552697,40.658468 43.552697,40.727459 43.536028,40.842443 43.485993,40.934431 43.452614,40.980425 43.419216,41.210393 43.385799,41.210393 43.369084,41.325378 43.352364,41.417365 43.352364,41.440362 43.302177,41.463359 43.302177,41.60134 43.235197,41.693328 43.21844,41.716324 43.235197,41.739321 43.21844,41.854306 43.21844,41.877303 43.235197,42.038281 43.201679,42.107271 43.201679,42.130268 43.151368,42.107271 43.134588,42.038281 43.050621,41.900299 43.033813,41.900299 42.7136,41.946293 42.679797,41.923296 42.629058,41.854306 42.578277,41.831309 42.5444,41.785315 42.5444,41.785315 42.527455,41.716324 42.510505,41.578343 42.408709,41.279384 42.408709,41.256387 42.425686,41.23339 42.5444,41.210393 42.5444,41.210393 42.578277,41.049415 42.595208,41.026418 42.612135,40.957428 42.629058,40.842443 42.798028,40.773453 42.8149,40.750456 42.865487,40.681465 42.865487,40.405503 42.916033,40.336512 42.966538,40.267522 42.983364,40.198531 42.983364,40.06055 43.033813,39.968562 43.184913,39.876575 43.201679))","code":"abkhazia","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":false,"road_network":true,"truck_graph":true},"id":"248","name":"Абхазия","time_zone":{"name":"Asia/Tbilisi","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((49.788226 44.903867,49.788226 45.017774,49.880214 45.163892,49.972201 45.196313,50.133179 45.212516,50.363148 45.212516,50.547123 45.147675,50.708101 45.098997,50.869079 45.131454,51.099048 45.309637,51.168039 45.390445,51.283023 45.503383,51.765957 45.616094,52.156904 45.551715,52.294885 45.567817,52.455863 45.616094,52.570848 45.776718,52.731826 45.88888,52.823813 46.000816,52.84681 46.016789,53.697694 46.016789,53.789682 46.080632,53.95066 46.160333,53.996654 46.239918,54.249619 46.255822,54.341607 46.255822,54.548579 46.303504,54.68656 46.319388,54.847538 46.367015,55.05451 46.367015,55.077507 46.382882,55.284479 46.367015,55.468454 46.493817,55.537444 46.477983,55.629432 46.4146,55.767413 46.4146,55.836403 46.398743,55.8594 46.287614,55.836403 46.27172,55.997382 46.22401,56.020378 46.208098,56.089369 46.192181,56.15836 46.144402,56.22735 46.128466,56.273344 46.144402,56.480316 46.128466,56.52631 46.080632,56.549306 46.000816,56.5953 45.920885,56.641294 45.66433,56.664291 45.648256,56.733281 45.180105,56.319338 45.082761,55.997382 45.001515,55.997382 41.3126,55.905394 41.3126,55.79041 41.260759,55.767413 41.278044,55.652428 41.260759,55.445457 41.24347,55.330472 41.364399,55.261482 41.416158,55.100504 41.605586,55.05451 41.691506,54.939525 41.811602,54.916529 41.845874,54.939525 41.897247,54.709557 42.068194,54.456591 42.221653,54.341607 42.272723,54.272616 42.340753,54.157632 42.357749,53.996654 42.323752,53.927663 42.323752,53.58271 42.272723,53.490723 42.238681,53.444729 42.238681,53.191763 42.153495,53.076779 42.136444,53.053782 42.119388,52.984791 42.085263,52.685832 41.897247,52.501857 41.76016,52.340879 41.708677,52.248892 41.708677,52.225895 41.76016,52.225895 41.99987,52.202898 42.119388,52.225895 42.20462,52.294885 42.289737,52.40987 42.476591,52.386873 42.5444,52.317882 42.595208,52.202898 42.629058,51.903938 42.662889,51.74296 42.7136,51.719963 42.764271,51.67397 42.798028,51.604979 42.899189,51.535989 42.949708,51.421004 42.966538,51.260026 42.983364,51.122045 43.033813,51.099048 43.050621,51.053054 43.117804,51.076051 43.452614,50.984064 43.519355,50.93807 43.602677,50.892076 43.635974,50.823086 43.768976,50.708101 43.934814,50.547123 44.116703,50.478132 44.13321,50.317154 44.149714,50.179173 44.199195,50.087186 44.281572,50.018195 44.380272,50.018195 44.544403,49.903211 44.757084,49.788226 44.903867))","code":"aktau","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"196","name":"Актау","time_zone":{"name":"Asia/Aqtau","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((56.871263 50.308299,56.871263 50.367011,56.89426 50.410998,57.078235 50.557325,57.193219 50.586536,57.285206 50.571932,57.308203 50.528096,57.377194 50.513474,57.538172 50.528096,57.584166 50.498848,57.69915 50.498848,58.274072 50.440299,58.550034 50.35234,58.619025 50.337664,58.619025 50.308299,58.43505 50.161201,58.205081 49.984084,57.998109 49.776621,57.469181 49.418893,57.400191 49.403931,57.308203 49.433851,57.285206 49.478697,57.170222 49.865643,56.940253 50.190657,56.940253 50.264217,56.871263 50.308299))","code":"aktobe","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"167","name":"Актобе","time_zone":{"name":"Asia/Aqtobe","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((73.727969 45.196313,73.727969 45.244908,73.773963 45.293462,74.003932 45.293462,74.003932 45.325808,73.980935 45.374293,73.911944 45.74463,73.980935 45.856857,74.026929 45.88888,74.049926 46.000816,74.16491 46.144402,74.739832 46.525471,75.015794 46.557107,75.33775 46.683467,75.521725 46.715011,75.590716 46.699241,75.797688 46.715011,75.820685 46.730776,76.07365 46.730776,76.211631 46.636117,76.372609 46.651905,76.4416 46.620324,76.533588 46.620324,76.533588 46.636117,76.602578 46.667688,76.625575 46.667688,76.763556 46.604527,76.855544 46.588725,76.901538 46.557107,76.924534 46.572919,76.924534 46.620324,77.039519 46.636117,77.108509 46.572919,77.131506 46.525471,77.200497 46.525471,77.292484 46.557107,77.315481 46.604527,77.453462 46.604527,77.54545 46.636117,77.54545 46.715011,77.522453 46.730776,77.522453 46.79379,77.476459 47.15469,77.591444 47.201584,77.683431 47.201584,77.729425 47.170326,77.798416 47.170326,77.890403 47.232824,77.98239 47.232824,78.005387 47.185957,78.097375 47.185957,78.166365 47.264045,78.235356 47.279649,78.396334 47.201584,78.603306 47.123404,78.672297 47.107754,78.695293 47.060777,78.764284 47.060777,79.132234 47.092099,79.45419 46.825269,79.500184 46.79379,79.845137 46.85673,79.960121 46.888172,79.983118 46.903887,80.052109 46.903887,80.19009 46.85673,80.213087 46.79379,80.328071 46.746536,80.351068 46.730776,80.397062 46.730776,80.420059 46.715011,80.604034 46.651905,80.856999 46.572919,81.132962 46.572919,81.224949 46.509647,81.385927 46.477983,81.431921 46.446301,81.500912 46.493817,81.569902 46.477983,81.546906 46.4146,81.523909 46.398743,81.592899 46.319388,81.66189 46.27172,81.891859 46.096581,81.983846 45.872871,82.075834 45.808787,82.144824 45.728579,82.144824 45.583914,82.213815 45.551715,82.259809 45.551715,82.282805 45.535609,82.420787 45.471138,82.420787 45.455009,82.512774 45.438875,82.581765 45.358136,82.581765 45.212516,82.489777 45.180105,82.420787 45.180105,82.420787 45.196313,82.305802 45.212516,82.282805 45.228714,82.190818 45.228714,82.075834 45.212516,82.075834 45.244908,81.937852 45.228714,81.822868 45.325808,81.753877 45.374293,81.638893 45.358136,81.523909 45.293462,81.385927 45.261097,81.247946 45.244908,81.224949 45.228714,81.178956 45.228714,81.017977 45.163892,80.92599 45.163892,80.879996 45.131454,80.765012 45.147675,80.650028 45.131454,80.627031 45.115228,80.512046 45.115228,80.443056 45.098997,80.420059 45.050277,80.259081 45.050277,80.236084 45.034027,80.1211 45.050277,80.052109 45.001515,79.937125 44.952712,79.914128 44.903867,79.983118 44.822367,80.006115 44.806053,80.1211 44.806053,80.144096 44.822367,80.19009 44.773411,80.213087 44.724414,80.328071 44.708073,80.397062 44.626296,80.374065 44.495212,80.351068 44.478806,80.397062 44.31449,80.397062 44.116703,80.443056 44.083674,80.443056 44.01756,80.512046 43.901683,80.512046 43.835366,80.719018 43.552697,80.742015 43.435917,80.742015 43.385799,80.696021 43.352364,80.696021 43.318911,80.765012 43.318911,80.788009 43.168143,80.765012 43.151368,80.627031 43.151368,80.604034 43.134588,80.512046 43.084221,80.397062 43.050621,80.397062 42.983364,80.581037 42.916033,80.535043 42.882341,80.512046 42.882341,80.397062 42.831767,80.282078 42.831767,80.213087 42.679797,80.167093 42.645975,80.19009 42.561341,80.213087 42.5444,80.236084 42.5444,80.213087 42.425686,80.282078 42.272723,80.259081 42.221653,80.167093 42.221653,80.098103 42.323752,80.006115 42.357749,79.937125 42.442659,79.799143 42.442659,79.707156 42.476591,79.546178 42.459627,79.45419 42.49355,79.431193 42.5444,79.408197 42.5444,79.339206 42.595208,79.178228 42.679797,79.178228 42.747385,79.155231 42.798028,79.132234 42.781152,78.902265 42.781152,78.810278 42.8149,78.695293 42.8149,78.511319 42.882341,78.258353 42.865487,78.005387 42.865487,77.660434 42.916033,77.591444 42.916033,77.568447 42.932873,77.246491 42.916033,77.131506 42.966538,77.016522 42.966538,76.993525 42.983364,76.763556 42.949708,76.740559 42.916033,76.533588 42.916033,76.418603 42.865487,76.349613 42.865487,76.280622 42.916033,76.211631 42.916033,76.188635 42.932873,76.027656 42.916033,76.00466 42.932873,75.912672 42.949708,75.797688 42.932873,75.774691 42.949708,75.613713 43.000185,75.63671 43.017001,75.613713 43.067423,75.544722 43.084221,75.360747 43.151368,75.291757 43.285439,75.291757 43.352364,75.406741 43.435917,75.406741 43.485993,75.383744 43.536028,75.176772 43.519355,75.038791 43.602677,74.992797 43.635974,75.107782 43.719135,75.26876 43.818776,75.26876 43.934814,75.314753 43.967926,75.314753 44.13321,75.199769 44.23216,74.946803 44.347391,74.739832 44.363834,74.509863 44.478806,74.509863 44.708073,74.325888 44.854981,74.2339 44.871281,74.141913 44.920153,74.095919 45.082761,74.072922 45.131454,74.003932 45.131454,73.750966 45.115228,73.727969 45.196313))","code":"almaty","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"67","name":"Алматы","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((51.444001 55.029945,51.489995 55.082633,51.489995 55.122103,51.604979 55.148395,51.650973 55.200927,51.719963 55.200927,51.696967 55.161535,51.696967 55.095794,51.788954 55.056298,51.857945 55.043123,51.880942 55.082633,51.972929 55.056298,52.064917 55.056298,52.133907 55.095794,52.179901 55.095794,52.179901 55.056298,52.248892 55.043123,52.317882 55.082633,52.386873 55.082633,52.432867 55.108951,52.570848 55.135251,52.731826 55.122103,52.754823 55.108951,52.823813 55.108951,52.869807 55.135251,52.938798 55.148395,52.984791 55.17467,53.053782 55.17467,53.122773 55.135251,53.168766 55.135251,53.168766 55.108951,53.237757 55.108951,53.306748 55.043123,53.329744 55.029945,53.444729 54.990384,53.467726 54.977188,53.536716 54.897922,53.605707 54.884696,53.628704 54.871465,53.605707 54.85823,53.605707 54.805248,53.536716 54.791991,53.306748 54.738921,53.283751 54.725643,53.168766 54.725643,53.076779 54.672486,53.122773 54.579294,53.053782 54.565963,53.030785 54.525945,53.122773 54.392268,53.122773 54.338675,53.099776 54.325266,53.030785 54.338675,53.007788 54.298434,52.984791 54.285012,52.984791 54.271585,52.938798 54.271585,52.915801 54.311852,52.823813 54.325266,52.77782 54.35208,52.570848 54.35208,52.501857 54.378876,52.501857 54.445791,52.455863 54.472527,52.363876 54.419038,52.271888 54.445791,52.271888 54.432417,52.202898 54.432417,52.179901 54.378876,52.064917 54.338675,52.064917 54.378876,52.04192 54.419038,51.926935 54.419038,51.949932 54.512597,51.857945 54.539289,51.719963 54.552628,51.696967 54.565963,51.765957 54.605942,51.788954 54.685782,51.834948 54.699073,51.880942 54.831748,51.811951 54.831748,51.67397 54.85823,51.604979 54.844991,51.512992 54.871465,51.489995 54.977188,51.444001 55.029945))","code":"almetevsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"108","name":"Альметьевск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((177.328874 64.694355,177.328874 64.753271,177.558843 64.812058,177.627834 64.812058,177.788812 64.763078,177.811809 64.704183,177.58184 64.645161,177.558843 64.635311,177.466856 64.635311,177.328874 64.694355))","code":"anadyr","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"155","name":"Анадырь","time_zone":{"name":"Asia/Anadyr","offset":720},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.106544 45.115228,40.106544 45.180105,40.12954 45.180105,40.382506 45.196313,40.405503 45.244908,40.382506 45.293462,40.336512 45.325808,40.359509 45.438875,40.49749 45.438875,40.520487 45.471138,40.635472 45.487263,40.658468 45.471138,40.911434 45.487263,40.980425 45.406593,41.026418 45.277282,41.049415 45.228714,41.279384 45.228714,41.348375 45.212516,41.348375 45.115228,41.394368 45.082761,41.417365 45.034027,41.463359 44.985252,41.578343 44.985252,41.647334 44.968984,41.647334 44.887576,41.60134 44.789734,41.440362 44.675376,41.463359 44.65902,41.486356 44.609926,41.555346 44.593552,41.578343 44.544403,41.60134 44.528011,41.693328 44.495212,41.716324 44.478806,41.716324 44.462395,41.647334 44.413135,41.624337 44.363834,41.647334 44.347391,41.739321 44.298034,41.716324 44.199195,41.647334 44.116703,41.60134 44.116703,41.555346 44.083674,41.463359 44.00102,41.348375 44.00102,41.279384 44.01756,41.279384 44.083674,41.210393 44.083674,41.1644 44.116703,41.1644 44.149714,41.095409 44.248635,41.072412 44.330943,41.187396 44.363834,41.187396 44.528011,41.141403 44.64266,41.072412 44.708073,40.888437 44.773411,40.842443 44.773411,40.819447 44.757084,40.658468 44.708073,40.635472 44.724414,40.635472 44.773411,40.589478 44.806053,40.589478 44.854981,40.520487 44.936435,40.405503 45.034027,40.336512 45.050277,40.244525 45.115228,40.106544 45.115228))","code":"armawir","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"106","name":"Армавир","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.462631 64.308265,39.462631 64.821843,39.531622 64.831625,40.612475 64.821843,40.819447 64.821843,41.210393 64.812058,41.302381 64.812058,41.325378 64.78268,41.302381 64.655007,41.302381 64.58601,41.279384 64.318233,41.279384 64.298293,41.210393 64.288318,41.118406 64.288318,40.12954 64.298293,39.531622 64.298293,39.462631 64.308265))","code":"arkhangelsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"49","name":"Архангельск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((71.129323 51.123677,71.129323 51.253399,71.336295 51.310935,71.382288 51.310935,71.635254 51.325308,71.681248 51.354041,71.750238 51.354041,71.750238 51.339677,71.842226 51.224603,71.865223 51.152536,71.88822 51.008062,71.796232 50.950147,71.612257 50.921162,71.543267 50.892159,71.52027 50.877651,71.405285 50.863138,71.15232 51.02253,71.129323 51.123677))","code":"nur_sultan","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"68","name":"Астана","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.958883 48.284042,45.027874 48.39105,45.027874 48.421583,45.119861 48.467348,45.234846 48.482593,45.326833 48.452097,45.372827 48.452097,45.372827 48.497834,45.234846 48.513071,45.234846 48.558753,45.326833 48.558753,45.602796 48.604394,45.648789 48.634798,45.625793 48.680371,45.648789 48.998224,45.671786 49.013309,45.671786 49.583177,45.648789 49.598085,45.694783 49.627886,45.947749 49.627886,45.970746 49.612988,46.039736 49.627886,46.315699 49.612988,46.338696 49.598085,46.476677 49.612988,46.499674 49.568265,46.499674 49.148874,46.522671 49.133829,46.499674 49.02839,46.499674 48.847117,46.614658 48.801695,46.660652 48.801695,46.660652 48.74107,46.522671 48.467348,46.522671 48.421583,46.568664 48.421583,47.051599 48.284042,47.097592 48.284042,47.097592 48.253426,47.120589 48.238112,47.120589 48.100075,47.18958 48.084715,47.097592 48.023228,47.097592 48.007845,47.074595 47.992457,47.074595 47.946266,47.097592 47.946266,47.097592 47.930859,47.120589 47.915449,47.143586 47.838326,47.143586 47.791997,47.304564 47.71469,47.327561 47.699215,47.396552 47.699215,47.419549 47.776545,47.419549 47.822887,47.488539 47.822887,47.488539 47.807444,47.649517 47.761088,47.948477 47.745627,48.063461 47.761088,48.178445 47.71469,48.247436 47.637269,48.339423 47.513155,48.385417 47.482081,48.454408 47.404314,48.523398 47.404314,48.73037 47.07644,48.914345 46.888172,48.983336 46.778043,48.983336 46.730776,48.960339 46.730776,48.914345 46.699241,48.753367 46.683467,48.707373 46.715011,48.592389 46.715011,48.523398 46.699241,48.523398 46.651905,48.569392 46.620324,48.546395 46.604527,48.569392 46.557107,48.753367 46.557107,48.822358 46.477983,48.891348 46.462144,49.075323 46.398743,49.09832 46.382882,49.190308 46.382882,49.259298 46.287614,49.397279 46.239918,49.443273 46.208098,49.673242 46.144402,50.064189 46.096581,50.133179 46.080632,50.133179 46.04872,50.110183 46.04872,49.788226 45.88888,48.960339 45.471138,48.914345 45.438875,48.753367 45.390445,48.592389 45.390445,48.339423 45.438875,48.270433 45.438875,48.132452 45.325808,48.040464 45.261097,47.833492 45.244908,47.833492 45.293462,47.810495 45.309637,47.787499 45.358136,47.741505 45.406593,47.62652 45.406593,47.55753 45.422736,47.55753 45.487263,47.534533 45.503383,47.511536 45.567817,47.534533 45.648256,47.304564 45.66433,47.18958 45.616094,46.982608 45.616094,46.890621 45.567817,46.890621 45.519498,46.867624 45.471138,46.660652 45.471138,46.614658 45.438875,46.476677 45.438875,46.476677 45.487263,46.614658 45.503383,46.660652 45.535609,46.729642 45.551715,46.775636 45.583914,46.660652 45.66433,46.568664 45.680399,46.499674 45.712524,46.522671 45.728579,46.545667 45.776718,46.384689 45.824815,46.315699 45.904885,46.315699 45.952871,46.45368 45.984839,46.45368 46.160333,46.476677 46.27172,46.430683 46.319388,46.476677 46.367015,46.591661 46.367015,46.660652 46.446301,46.959611 46.462144,46.959611 46.525471,46.890621 46.572919,46.890621 46.636117,46.959611 46.715011,46.959611 46.809532,46.982608 46.85673,46.959611 46.966698,46.844627 46.998076,46.775636 47.045108,46.706646 47.123404,46.545667 47.388747,46.637655 47.466537,46.706646 47.482081,46.706646 47.544211,46.637655 47.559732,46.430683 47.419877,46.269705 47.419877,46.154721 47.482081,45.947749 47.606268,45.901755 47.683735,45.832764 47.730161,45.809768 47.791997,45.763774 47.822887,45.71778 47.900033,45.740777 48.007845,45.71778 48.023228,45.510808 48.007845,45.395824 48.100075,45.28084 48.100075,45.211849 48.176808,45.165855 48.176808,45.142858 48.222793,45.050871 48.253426,44.98188 48.268736,44.958883 48.284042))","code":"astrakhan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"8","name":"Астрахань","time_zone":{"name":"Europe/Astrakhan","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.074595 47.946266,47.074595 47.992457,47.097592 48.007845,47.097592 48.023228,47.18958 48.084715,47.120589 48.100075,47.120589 48.238112,47.18958 48.222793,47.281567 48.222793,47.787499 48.161471,48.684376 48.100075,48.960339 48.053981,49.328289 47.946266,49.443273 47.930859,49.443273 48.007845,49.512264 48.023228,49.673242 48.007845,49.765229 48.007845,49.811223 48.038607,49.995198 48.038607,50.248164 48.207469,50.731098 48.421583,50.823086 48.421583,50.892076 48.467348,51.00706 48.513071,51.076051 48.619599,51.283023 48.634798,51.398007 48.665185,51.834948 48.619599,51.811951 48.528303,51.834948 48.513071,51.949932 48.528303,52.04192 48.467348,52.202898 48.482593,52.432867 48.406319,52.501857 48.406319,52.547851 48.467348,52.547851 48.634798,52.570848 48.649994,52.593845 48.74107,52.708829 48.771392,52.708829 48.983134,52.77782 48.998224,52.84681 49.043467,52.984791 49.02839,53.21476 49.02839,53.237757 49.013309,53.398735 49.043467,53.398735 49.11878,53.559713 49.178949,53.628704 49.224027,53.743688 49.163914,53.858673 49.11878,53.904666 49.11878,53.927663 49.163914,53.996654 49.163914,54.019651 48.968039,54.019651 48.892497,54.042647 48.756233,54.295613 48.710729,54.31861 48.695552,54.341607 48.695552,54.479588 48.634798,54.548579 48.649994,54.571576 48.695552,54.571576 48.771392,54.68656 48.786546,54.732554 48.786546,54.755551 48.74107,54.870535 48.725902,54.916529 48.695552,54.939525 48.589185,54.893532 48.467348,54.893532 48.345217,54.962522 48.268736,54.939525 48.161471,54.939525 48.100075,55.100504 47.961667,55.100504 47.822887,55.1235 47.776545,55.077507 47.668251,55.05451 47.575249,55.077507 47.559732,55.077507 47.450988,55.031513 47.419877,55.031513 47.373176,55.008516 47.201584,55.1235 47.060777,55.1235 47.013758,55.169494 46.982389,55.238485 46.872453,55.445457 46.730776,55.468454 46.730776,55.49145 46.715011,55.698422 46.651905,56.296341 46.509647,56.319338 46.382882,56.434322 46.239918,56.434322 46.208098,56.457319 46.192181,56.480316 46.128466,56.273344 46.144402,56.22735 46.128466,56.15836 46.144402,56.089369 46.192181,56.020378 46.208098,55.997382 46.22401,55.836403 46.27172,55.8594 46.287614,55.836403 46.398743,55.767413 46.4146,55.629432 46.4146,55.537444 46.477983,55.468454 46.493817,55.284479 46.367015,55.077507 46.382882,55.05451 46.367015,54.847538 46.367015,54.68656 46.319388,54.548579 46.303504,54.341607 46.255822,54.249619 46.255822,53.996654 46.239918,53.95066 46.160333,53.789682 46.080632,53.697694 46.016789,52.84681 46.016789,52.754823 46.208098,52.708829 46.367015,52.708829 46.430453,52.77782 46.604527,52.639838 46.683467,52.501857 46.651905,52.386873 46.604527,52.202898 46.604527,52.133907 46.620324,51.834948 46.572919,51.719963 46.572919,51.512992 46.604527,51.444001 46.651905,51.421004 46.730776,51.398007 46.730776,51.352014 46.825269,51.283023 46.841002,51.122045 46.730776,51.099048 46.730776,50.179173 46.096581,50.133179 46.080632,50.133179 46.096581,50.064189 46.096581,49.673242 46.144402,49.443273 46.208098,49.397279 46.239918,49.259298 46.287614,49.190308 46.382882,49.09832 46.382882,49.075323 46.398743,48.891348 46.462144,48.822358 46.477983,48.753367 46.557107,48.569392 46.557107,48.546395 46.604527,48.569392 46.620324,48.523398 46.651905,48.523398 46.699241,48.592389 46.715011,48.707373 46.715011,48.753367 46.683467,48.914345 46.699241,48.960339 46.730776,48.983336 46.730776,48.983336 46.778043,48.914345 46.888172,48.73037 47.07644,48.523398 47.404314,48.454408 47.404314,48.385417 47.482081,48.339423 47.513155,48.247436 47.637269,48.178445 47.71469,48.063461 47.761088,47.948477 47.745627,47.649517 47.761088,47.488539 47.807444,47.488539 47.822887,47.419549 47.822887,47.419549 47.776545,47.396552 47.699215,47.327561 47.699215,47.304564 47.71469,47.143586 47.791997,47.143586 47.838326,47.120589 47.915449,47.097592 47.930859,47.097592 47.946266,47.074595 47.946266))","code":"atyrau","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"168","name":"Атырау","time_zone":{"name":"Asia/Atyrau","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.039519 53.730922,77.108509 53.826046,77.131506 53.893859,77.085513 53.94803,77.085513 53.97509,77.154503 53.988613,77.246491 54.042661,77.315481 54.042661,77.338478 54.083152,77.315481 54.123603,77.292484 54.137078,77.315481 54.177476,77.361475 54.204386,77.384472 54.204386,77.384472 54.217835,77.775419 54.217835,77.798416 54.204386,77.890403 54.204386,77.9134 54.217835,78.028384 54.231279,78.028384 54.244719,78.120372 54.258154,78.120372 54.311852,78.212359 54.338675,78.327344 54.298434,78.327344 54.271585,78.35034 54.271585,78.327344 54.217835,78.304347 54.204386,78.304347 54.177476,78.327344 54.164014,78.35034 54.09664,78.235356 54.09664,78.235356 54.056163,78.258353 54.042661,78.235356 54.029156,78.166365 54.015646,78.166365 53.94803,78.074378 53.920953,77.98239 53.920953,77.959394 53.880305,77.9134 53.853184,77.9134 53.798889,77.867406 53.798889,77.798416 53.826046,77.683431 53.81247,77.660434 53.785305,77.54545 53.785305,77.499456 53.717316,77.384472 53.703705,77.361475 53.717316,77.246491 53.703705,77.1775 53.676469,77.108509 53.676469,77.062516 53.717316,77.039519 53.730922))","code":"bagan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"176","name":"Баган","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.718508 51.967438,47.718508 52.052369,47.810495 52.052369,47.902483 52.024077,47.902483 51.981605,47.787499 51.967438,47.764502 51.953267,47.718508 51.967438))","code":"balakovo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"121","name":"Балаково","time_zone":{"name":"Europe/Saratov","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.407469 55.082633,77.407469 55.17467,77.522453 55.214049,77.660434 55.227167,77.683431 55.25339,77.591444 55.279595,77.591444 55.345033,77.660434 55.358108,77.844409 55.358108,77.9134 55.345033,78.120372 55.331954,78.28135 55.358108,78.373337 55.410363,78.442328 55.397306,78.534315 55.423416,78.626303 55.423416,78.695293 55.371178,78.741287 55.345033,78.902265 55.345033,78.925262 55.305783,78.902265 55.292691,78.925262 55.25339,78.948259 55.24028,78.925262 55.135251,78.971256 55.108951,78.994253 55.043123,78.994253 55.003575,78.695293 55.016762,78.695293 55.003575,78.488322 54.924361,78.419331 54.911144,78.373337 54.85823,78.189362 54.8185,77.959394 54.738921,77.959394 54.685782,77.936397 54.672486,77.890403 54.685782,77.775419 54.672486,77.614441 54.752195,77.614441 54.871465,77.522453 54.871465,77.499456 54.990384,77.476459 54.990384,77.407469 55.082633))","code":"barabinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"177","name":"Барабинск","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((82.351796 53.457952,82.351796 53.512687,82.420787 53.512687,82.420787 53.49901,82.535771 53.49901,82.558768 53.512687,82.535771 53.553692,82.650755 53.635583,82.650755 53.690089,82.742743 53.744525,82.76574 53.798889,83.20268 54.056163,83.317665 54.056163,83.340661 53.94803,83.409652 53.934494,83.478643 54.002132,83.478643 54.069659,83.57063 54.110123,83.777602 54.110123,83.846593 54.123603,83.915583 54.09664,83.984574 54.110123,83.984574 54.029156,84.007571 53.961562,84.214543 53.961562,84.283533 53.853184,84.352524 53.853184,84.398518 53.798889,84.467508 53.798889,84.490505 53.758122,84.467508 53.717316,84.421514 53.676469,84.352524 53.676469,84.283533 53.662845,84.283533 53.621946,84.30653 53.608304,84.352524 53.540028,84.444511 53.540028,84.559496 53.52636,84.582493 53.540028,84.651483 53.553692,84.720474 53.540028,84.743471 53.49901,84.858455 53.485328,84.904449 53.430558,85.019433 53.430558,85.088424 53.389434,85.019433 53.34827,85.065427 53.265822,84.996436 53.210769,85.04243 53.183216,85.203408 53.196994,85.226405 53.210769,85.387383 53.224539,85.387383 53.128056,85.479371 53.114255,85.479371 53.072825,85.433377 53.017524,85.364386 53.017524,85.226405 52.989846,85.203408 52.948297,85.249402 52.920575,85.249402 52.865079,85.111421 52.767788,84.789464 52.767788,84.743471 52.712096,84.743471 52.67028,84.720474 52.600498,84.67448 52.558575,84.605489 52.516612,84.559496 52.530604,84.536499 52.586528,84.467508 52.586528,84.30653 52.544592,84.283533 52.530604,84.099558 52.460599,84.030568 52.460599,83.93858 52.628424,83.961577 52.64238,84.122555 52.67028,84.122555 52.698162,84.099558 52.767788,84.030568 52.809511,83.984574 52.878959,83.86959 52.865079,83.800599 52.878959,83.823596 52.948297,83.754605 52.989846,83.754605 53.059007,83.777602 53.072825,83.754605 53.128056,83.524636 53.141852,83.432649 53.169432,83.432649 53.210769,83.317665 53.196994,83.271671 53.155645,83.156687 53.128056,83.110693 53.100449,82.972712 53.059007,82.880724 53.003687,82.788737 52.989846,82.719746 53.017524,82.673752 53.045183,82.696749 53.114255,82.627758 53.210769,82.604762 53.224539,82.581765 53.265822,82.420787 53.361995,82.420787 53.389434,82.39779 53.389434,82.351796 53.457952))","code":"barnaul","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"4","name":"Барнаул","time_zone":{"name":"Asia/Barnaul","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.358053 50.630318,36.358053 50.67406,36.427044 50.688632,36.496035 50.732319,36.588022 50.717761,36.611019 50.703199,36.771997 50.717761,36.932975 50.688632,36.932975 50.659484,36.886982 50.615729,36.840988 50.615729,36.771997 50.571932,36.771997 50.528096,36.703007 50.484218,36.634016 50.498848,36.611019 50.425651,36.542028 50.440299,36.542028 50.484218,36.427044 50.498848,36.404047 50.542712,36.38105 50.557325,36.38105 50.615729,36.358053 50.630318))","code":"belgorod","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"46","name":"Белгород","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((84.467508 51.981605,84.513502 52.009924,84.536499 52.052369,84.513502 52.066509,84.490505 52.1089,84.559496 52.1089,84.559496 52.16536,84.513502 52.221748,84.513502 52.263992,84.559496 52.292132,84.605489 52.362405,84.605489 52.516612,84.720474 52.586528,84.789464 52.600498,84.812461 52.614463,85.019433 52.64238,85.019433 52.656332,85.134417 52.67028,85.157414 52.628424,85.249402 52.628424,85.295396 52.656332,85.364386 52.656332,85.433377 52.586528,85.479371 52.502615,85.571358 52.460599,85.870317 52.446585,86.008299 52.306195,86.238267 52.16536,86.238267 52.038225,86.21527 52.024077,86.100286 52.080644,85.939308 52.094774,85.916311 52.123022,85.77833 52.1089,85.709339 52.094774,85.686342 52.052369,85.594355 51.981605,85.571358 51.967438,85.548361 51.910728,85.41038 51.882346,85.157414 51.868148,85.134417 51.882346,84.973439 51.868148,84.927446 51.839739,84.858455 51.853946,84.766468 51.896539,84.651483 51.882346,84.605489 51.896539,84.559496 51.924912,84.490505 51.939092,84.467508 51.981605))","code":"biysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"20","name":"Бийск","time_zone":{"name":"Asia/Barnaul","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((127.310679 50.469583,127.333676 50.542712,127.356673 50.542712,127.356673 50.615729,127.333676 50.615729,127.333676 50.644903,127.356673 50.688632,127.37967 50.703199,127.448661 50.790506,127.494654 50.819572,127.471657 50.892159,127.517651 50.935657,127.517651 51.008062,127.563645 51.036993,127.563645 51.123677,127.678629 51.166958,127.770617 51.181376,127.839607 51.166958,127.931595 51.19579,127.931595 51.325308,127.977589 51.354041,128.046579 51.454462,128.18456 51.483114,128.276548 51.483114,128.345539 51.526057,128.414529 51.511747,128.460523 51.46879,128.460523 51.382755,128.529514 51.224603,128.529514 51.181376,128.575507 51.152536,128.575507 51.065906,128.621501 50.99359,128.667495 50.964632,128.667495 50.848621,128.529514 50.819572,128.414529 50.775966,128.299545 50.67406,128.18456 50.67406,128.138567 50.630318,128.138567 50.615729,128.11557 50.615729,128.11557 50.601134,128.069576 50.601134,128.000586 50.586536,128.000586 50.542712,128.069576 50.484218,128.023582 50.454943,128.046579 50.381678,128.023582 50.308299,127.931595 50.278916,127.862604 50.278916,127.770617 50.220095,127.609639 50.205378,127.586642 50.249514,127.517651 50.249514,127.356673 50.29361,127.333676 50.322984,127.356673 50.425651,127.310679 50.469583))","code":"blagoveshensk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"52","name":"Благовещенск","time_zone":{"name":"Asia/Yakutsk","offset":540},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((101.071249 55.967759,101.071249 56.224312,101.094246 56.491856,101.163237 56.50455,101.50819 56.491856,101.830146 56.491856,102.037118 56.479159,102.060115 56.44104,102.037118 56.249873,102.037118 56.134713,102.014121 55.967759,101.991124 55.929128,101.600177 55.942009,101.163237 55.942009,101.071249 55.967759))","code":"bratsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"51","name":"Братск","time_zone":{"name":"Asia/Irkutsk","offset":480},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((34.10436 53.128056,34.10436 53.293322,34.150354 53.320805,34.150354 53.403146,34.173351 53.444257,34.242341 53.444257,34.357326 53.485328,34.47231 53.471642,34.564298 53.375717,34.587294 53.293322,34.610291 53.279574,34.610291 53.183216,34.403319 53.141852,34.265338 53.155645,34.219344 53.128056,34.10436 53.128056))","code":"bryansk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"62","name":"Брянск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((64.253258 39.863181,64.345246 39.827868,64.414236 39.827868,64.483227 39.845527,64.506224 39.827868,64.598211 39.827868,64.805183 39.986633,64.874174 39.986633,64.966161 39.880831,64.966161 39.774865,64.897171 39.757188,64.874174 39.739507,64.75919 39.721821,64.75919 39.70413,64.621208 39.686435,64.529221 39.651032,64.46023 39.651032,64.46023 39.70413,64.39124 39.721821,64.253258 39.792537,64.230261 39.792537,64.184268 39.827868,64.115277 39.845527,64.09228 39.863181,64.253258 39.863181))","code":"bukhara","country_code":"uz","domain":"uz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"251","name":"Бухара","time_zone":{"name":"Asia/Samarkand","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((31.068773 58.481344,31.114767 58.50538,31.137764 58.637286,31.206754 58.685128,31.413726 58.720967,31.436723 58.709025,31.505714 58.697079,31.528711 58.649252,31.597701 58.61334,31.620698 58.5294,31.551707 58.493364,31.436723 58.457292,31.367732 58.421182,31.275745 58.421182,31.275745 58.433222,31.229751 58.46932,31.206754 58.457292,31.09177 58.445259,31.068773 58.481344))","code":"v_novgorod","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"77","name":"Великий Новгород","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.142641 55.514667,76.142641 55.553709,76.211631 55.592713,76.211631 55.696535,76.188635 55.761284,76.234628 55.851751,76.372609 55.877561,76.372609 55.903353,76.395606 56.070585,76.349613 56.096249,76.349613 56.147525,76.280622 56.160334,76.211631 56.211525,76.211631 56.224312,76.280622 56.224312,76.326616 56.275417,76.395606 56.275417,76.4416 56.224312,76.533588 56.224312,76.625575 56.275417,76.717563 56.275417,76.786553 56.237095,76.924534 56.237095,76.993525 56.224312,77.223494 56.249873,77.200497 56.313702,77.1775 56.351948,77.246491 56.390156,77.292484 56.390156,77.292484 56.351948,77.315481 56.313702,77.430466 56.300945,77.568447 56.326455,77.660434 56.313702,77.706428 56.275417,77.706428 56.262647,77.637437 56.198733,77.660434 56.160334,77.729425 56.147525,77.798416 56.173138,77.867406 56.173138,77.867406 56.160334,77.752422 56.096249,77.637437 56.083419,77.568447 56.019206,77.499456 56.019206,77.430466 56.006351,77.430466 55.967759,77.522453 55.877561,77.54545 55.761284,77.499456 55.735397,77.499456 55.696535,77.430466 55.605706,77.407469 55.592713,77.154503 55.605706,77.085513 55.566715,76.970528 55.540699,76.832547 55.566715,76.763556 55.553709,76.694566 55.488617,76.602578 55.488617,76.602578 55.514667,76.418603 55.514667,76.395606 55.553709,76.303619 55.553709,76.280622 55.514667,76.142641 55.514667))","code":"vengerovo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"178","name":"Венгерово","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((131.381126 43.469306,131.404122 43.485993,131.565101 43.536028,131.634091 43.569362,131.703082 43.652615,131.841063 43.652615,131.910054 43.669252,131.979044 43.652615,132.048035 43.602677,132.346994 43.502676,132.369991 43.452614,132.369991 43.385799,132.346994 43.33564,132.255007 43.084221,132.117025 42.916033,131.956047 42.831767,131.818066 42.798028,131.680085 42.781152,131.565101 42.831767,131.588097 43.000185,131.473113 43.151368,131.404122 43.385799,131.381126 43.469306))","code":"vladivostok","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"25","name":"Владивосток","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((43.418093 42.899189,43.418093 42.949708,43.464087 42.966538,43.579071 42.949708,43.671059 43.101015,43.694055 43.117804,43.717052 43.117804,43.740049 43.201679,43.80904 43.302177,43.87803 43.268696,43.970018 43.268696,44.016012 43.235197,44.062005 43.235197,44.085002 43.302177,44.062005 43.318911,44.062005 43.369084,44.130996 43.419216,44.17699 43.419216,44.199987 43.369084,44.24598 43.369084,44.406958 43.302177,44.429955 43.285439,44.521943 43.251949,44.567937 43.251949,44.590933 43.235197,44.636927 43.21844,44.705918 43.268696,44.774908 43.151368,44.820902 43.151368,44.935886 43.050621,44.935886 42.932873,44.866896 42.882341,44.866896 42.848629,44.751911 42.848629,44.751911 42.865487,44.636927 42.882341,44.659924 42.798028,44.659924 42.747385,44.521943 42.747385,44.521943 42.7136,44.291974 42.7136,44.222983 42.629058,44.039008 42.595208,43.993015 42.561341,43.924024 42.561341,43.87803 42.595208,43.80904 42.595208,43.740049 42.612135,43.740049 42.662889,43.786043 42.696701,43.786043 42.764271,43.740049 42.764271,43.671059 42.798028,43.579071 42.865487,43.51008 42.865487,43.487084 42.882341,43.418093 42.899189))","code":"vladikavkaz","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"114","name":"Владикавказ","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.152537 56.070585,40.175534 56.211525,40.175534 56.326455,40.198531 56.44104,40.267522 56.466457,40.704462 56.466457,40.727459 56.428326,40.704462 56.390156,40.681465 56.198733,40.704462 56.109074,40.658468 56.083419,40.635472 56.019206,40.474493 56.019206,40.175534 56.032057,40.152537 56.070585))","code":"vladimir","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"59","name":"Владимир","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((43.87803 48.604394,43.947021 48.710729,43.924024 48.725902,43.901027 48.771392,43.924024 48.81684,44.062005 48.862248,44.085002 48.922727,44.199987 48.907614,44.291974 48.922727,44.314971 48.968039,44.360965 48.968039,44.567937 48.95294,44.590933 48.968039,44.61393 48.95294,44.820902 48.937836,45.004877 48.847117,45.050871 48.831981,45.073868 48.786546,45.004877 48.74107,44.98188 48.695552,45.027874 48.573971,44.98188 48.467348,45.027874 48.421583,45.027874 48.39105,44.958883 48.284042,44.728915 48.284042,44.61393 48.268736,44.590933 48.253426,44.360965 48.32993,44.24598 48.253426,44.17699 48.253426,44.062005 48.299342,43.970018 48.360499,43.993015 48.467348,43.970018 48.497834,43.901027 48.54353,43.87803 48.604394))","code":"volgograd","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"33","name":"Волгоград","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((42.015284 47.668251,42.038281 47.683735,42.107271 47.683735,42.130268 47.668251,42.176262 47.62177,42.383234 47.62177,42.383234 47.575249,42.314243 47.559732,42.314243 47.513155,42.291246 47.466537,42.130268 47.482081,42.061278 47.513155,42.015284 47.668251))","code":"volgodonsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"122","name":"Волгодонск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((37.668875 59.218851,37.78386 59.218851,37.78386 59.277644,37.875847 59.336337,38.036825 59.336337,38.059822 59.348063,38.2208 59.336337,38.335784 59.301133,38.427772 59.312872,38.58875 59.301133,38.611747 59.289391,38.841716 59.289391,39.048687 59.301133,39.232662 59.324606,39.301653 59.336337,39.370644 59.324606,39.462631 59.359785,39.531622 59.348063,39.554619 59.336337,39.6926 59.348063,39.784587 59.394928,39.945565 59.394928,40.06055 59.348063,40.12954 59.383218,40.244525 59.383218,40.221528 59.277644,40.198531 59.24238,40.313515 59.183526,40.290518 59.12457,40.244525 59.100959,40.198531 59.04186,40.06055 59.018192,39.991559 59.030028,39.968562 59.065512,39.876575 59.065512,39.784587 59.04186,39.6926 59.053688,39.669603 59.04186,39.209666 59.065512,38.818719 59.065512,38.795722 59.077332,38.58875 59.112766,38.358781 59.100959,38.266794 59.077332,37.875847 59.006352,37.714869 59.030028,37.691872 59.065512,37.668875 59.218851))","code":"vologda","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"78","name":"Вологда","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.818719 51.668909,38.841716 51.68317,38.933703 51.725925,38.933703 51.782868,39.025691 51.811313,39.025691 51.868148,39.048687 51.910728,39.140675 51.910728,39.232662 51.939092,39.347647 51.924912,39.370644 51.910728,39.508625 51.910728,39.531622 51.896539,39.669603 51.882346,39.669603 51.839739,39.623609 51.782868,39.600612 51.56896,39.577615 51.554663,39.600612 51.511747,39.577615 51.46879,39.416637 51.46879,39.39364 51.483114,39.255659 51.46879,39.232662 51.483114,39.094681 51.483114,39.025691 51.454462,38.9567 51.46879,38.9567 51.526057,38.979697 51.540363,38.9567 51.583252,38.841716 51.611822,38.818719 51.668909))","code":"voronezh","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"31","name":"Воронеж","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((45.34983 43.084221,45.34983 43.134588,45.418821 43.134588,45.579799 43.285439,45.579799 43.318911,45.487811 43.385799,45.579799 43.419216,45.71778 43.419216,45.740777 43.40251,45.855761 43.369084,45.970746 43.369084,45.993743 43.385799,46.039736 43.452614,46.338696 43.435917,46.338696 43.40251,46.407686 43.302177,46.407686 43.201679,46.200714 43.117804,46.177718 43.067423,46.062733 43.084221,45.901755 43.000185,45.671786 42.966538,45.648789 42.983364,45.579799 43.000185,45.533805 42.966538,45.464815 42.949708,45.395824 42.983364,45.395824 43.050621,45.34983 43.084221))","code":"grozny","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"115","name":"Грозный","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((78.879268 54.459161,78.879268 54.485888,79.01725 54.485888,79.063243 54.552628,79.08624 54.565963,79.08624 54.645881,79.132234 54.645881,79.132234 54.605942,79.201225 54.565963,79.431193 54.645881,79.45419 54.659186,79.569175 54.699073,79.569175 54.738921,79.477187 54.738921,79.431193 54.71236,79.362203 54.725643,79.293212 54.77873,79.316209 54.805248,79.431193 54.805248,79.546178 54.831748,79.569175 54.85823,79.661162 54.85823,79.707156 54.884696,79.776146 54.871465,79.868134 54.8185,79.960121 54.8185,80.144096 54.844991,80.167093 54.805248,80.167093 54.632572,80.213087 54.552628,80.351068 54.552628,80.397062 54.512597,80.397062 54.459161,80.328071 54.445791,80.213087 54.378876,80.075106 54.378876,80.029112 54.338675,80.029112 54.258154,79.914128 54.231279,79.891131 54.204386,79.477187 54.204386,79.45419 54.244719,79.431193 54.258154,79.431193 54.311852,79.362203 54.325266,79.247218 54.311852,79.224222 54.271585,79.178228 54.271585,79.109237 54.285012,78.948259 54.35208,78.948259 54.419038,78.879268 54.459161))","code":"dovolnoe","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"179","name":"Довольное","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((82.627758 68.596426,82.696749 68.613204,82.719746 68.613204,82.742743 68.604817,82.811733 68.596426,82.972712 68.562831,83.041702 68.554425,83.087696 68.537603,83.179683 68.537603,83.20268 68.529187,83.294668 68.554425,83.409652 68.546015,83.478643 68.520768,83.524636 68.470187,83.685615 68.478625,83.777602 68.495492,83.86959 68.495492,83.915583 68.529187,83.915583 68.554425,83.846593 68.537603,83.777602 68.537603,83.754605 68.588032,83.800599 68.604817,83.93858 68.646724,84.099558 68.613204,84.329527 68.613204,84.444511 68.62997,84.490505 68.663465,84.467508 68.67183,84.467508 68.696909,84.536499 68.721959,84.467508 68.780301,84.490505 68.805258,84.513502 68.81357,84.467508 68.904805,84.490505 68.962668,84.513502 68.970922,84.490505 68.979173,84.513502 69.05329,84.490505 69.06151,84.490505 69.110764,84.467508 69.110764,84.444511 69.151725,84.490505 69.176264,84.490505 69.200776,84.582493 69.225261,84.605489 69.282284,84.582493 69.306676,84.789464 69.331042,84.812461 69.371589,84.766468 69.420146,84.697477 69.428228,84.720474 69.468594,84.651483 69.476658,84.67448 69.516932,84.720474 69.533021,84.835458 69.589235,84.858455 69.613282,84.904449 69.629298,84.927446 69.6533,84.927446 69.693242,84.904449 69.693242,84.835458 69.788798,84.812461 69.796742,84.812461 69.852262,84.927446 69.868099,84.996436 69.907637,85.088424 69.907637,85.157414 69.939214,85.157414 69.970743,85.249402 69.978618,85.272399 69.98649,85.433377 69.98649,85.456374 70.010088,85.479371 70.017949,85.594355 70.010088,85.594355 70.002225,85.77833 70.017949,85.801327 70.041511,85.870317 70.065047,85.939308 70.104214,86.100286 70.119861,86.123283 70.127679,86.238267 70.174529,86.307258 70.205704,86.330255 70.221274,86.307258 70.260146,86.284261 70.260146,86.307258 70.283435,86.376249 70.283435,86.376249 70.298946,86.307258 70.306697,86.192274 70.329932,86.192274 70.353142,86.261264 70.391765,86.238267 70.422612,86.307258 70.445716,86.330255 70.468794,86.21527 70.491846,86.238267 70.530208,86.14628 70.545532,86.14628 70.576146,86.123283 70.599076,86.008299 70.591436,85.985302 70.599076,86.008299 70.637235,86.077289 70.629609,86.123283 70.644858,86.307258 70.644858,86.307258 70.660096,86.376249 70.682931,86.58322 70.690536,86.652211 70.652478,86.905177 70.629609,86.95117 70.629609,87.043158 70.606714,87.043158 70.568497,87.089152 70.55319,87.089152 70.530208,87.273126 70.499524,87.388111 70.491846,87.503095 70.499524,87.526092 70.491846,87.641076 70.491846,87.68707 70.507199,87.756061 70.507199,87.756061 70.484165,87.802055 70.484165,87.848048 70.499524,87.917039 70.530208,88.078017 70.530208,88.101014 70.537871,88.193001 70.545532,88.238995 70.530208,88.307986 70.530208,88.307986 70.537871,88.376976 70.545532,88.399973 70.55319,88.514958 70.568497,88.583948 70.591436,88.629942 70.62198,88.629942 70.66771,88.721929 70.682931,88.721929 70.743697,88.767923 70.758859,88.767923 70.796716,88.629942 70.842049,88.560951 70.894808,88.537954 70.902333,88.560951 70.954932,88.560951 70.984926,88.468964 70.999906,88.468964 71.029832,88.376976 71.029832,88.330983 71.044777,88.284989 71.044777,88.261992 71.052246,88.193001 71.059712,88.170004 71.067175,88.101014 71.074635,88.078017 71.104447,88.101014 71.111893,88.078017 71.119336,88.101014 71.126777,88.078017 71.141649,88.101014 71.17878,88.170004 71.186198,88.261992 71.186198,88.261992 71.201025,88.238995 71.238043,88.261992 71.245438,88.284989 71.267607,88.261992 71.274991,88.238995 71.311869,88.307986 71.311869,88.307986 71.319236,88.330983 71.326601,88.330983 71.348677,88.445967 71.348677,88.42297 71.385415,88.399973 71.392754,88.491961 71.414755,88.560951 71.407424,88.767923 71.436731,88.836914 71.436731,88.859911 71.465993,88.882907 71.473302,88.882907 71.502508,88.767923 71.524384,88.629942 71.53167,88.583948 71.57533,88.491961 71.604381,88.491961 71.655114,88.42297 71.662351,88.445967 71.698493,88.468964 71.705713,88.514958 71.756176,88.514958 71.784952,88.629942 71.806505,88.652939 71.828033,88.721929 71.82086,88.744926 71.828033,88.744926 71.863859,88.813917 71.87817,88.882907 71.885322,88.905904 71.921039,88.882907 71.963809,88.859911 71.970928,88.859911 72.013584,88.928901 72.034876,88.928901 72.098604,88.951898 72.119798,88.928901 72.197303,88.859911 72.232425,88.79092 72.232425,88.721929 72.239441,88.721929 72.260474,88.652939 72.281483,88.652939 72.316444,88.629942 72.323428,88.652939 72.330409,88.629942 72.379205,88.560951 72.427871,88.583948 72.427871,88.583948 72.441751,88.629942 72.441751,88.652939 72.483329,88.629942 72.517904,88.583948 72.531716,88.583948 72.552413,88.537954 72.573087,88.468964 72.573087,88.376976 72.552413,88.307986 72.559307,88.147008 72.559307,88.124011 72.538618,88.193001 72.517904,88.170004 72.510994,88.193001 72.490249,88.124011 72.455621,88.05502 72.46948,87.940036 72.476406,87.917039 72.504082,87.848048 72.510994,87.825051 72.504082,87.848048 72.483329,87.825051 72.462552,87.664073 72.462552,87.549089 72.455621,87.526092 72.434812,87.457101 72.427871,87.342117 72.420926,87.227133 72.427871,87.204136 72.448687,87.135145 72.490249,87.066155 72.510994,86.997164 72.517904,86.997164 72.531716,86.928173 72.538618,86.859183 72.524811,86.859183 72.504082,86.721202 72.490249,86.629214 72.448687,86.58322 72.434812,86.537227 72.448687,86.330255 72.455621,86.307258 72.434812,86.192274 72.427871,86.14628 72.41398,86.031295 72.41398,85.916311 72.40703,85.84732 72.386165,85.77833 72.40703,85.77833 72.427871,85.801327 72.434812,85.77833 72.483329,85.732336 72.510994,85.663345 72.531716,85.640349 72.559307,85.548361 72.573087,85.525364 72.593737,85.571358 72.607491,85.525364 72.676101,85.502367 72.676101,85.502367 72.71714,85.479371 72.751268,85.41038 72.812534,85.433377 72.846479,85.502367 72.85326,85.525364 72.880359,85.640349 72.914175,85.755333 72.968144,85.755333 72.974879,85.939308 72.974879,86.100286 72.981611,86.21527 72.974879,86.376249 72.934433,86.422242 72.92093,86.606217 72.92093,86.675208 72.934433,86.744198 72.968144,86.813189 72.961407,86.813189 72.94118,86.859183 72.92093,87.020161 72.92093,87.043158 72.927683,87.158142 72.934433,87.25013 72.947925,87.549089 72.968144,87.61808 72.974879,87.848048 73.035374,87.871045 73.042083,88.009026 73.042083,88.147008 73.062193,88.193001 73.075588,88.307986 73.075588,88.307986 73.082281,88.330983 73.088972,88.330983 73.115709,88.353979 73.162401,88.560951 73.195675,88.721929 73.195675,88.859911 73.175718,88.951898 73.175718,88.974895 73.182373,89.089879 73.202323,89.204864 73.202323,89.204864 73.208967,89.319848 73.215609,89.434832 73.208967,89.549817 73.228886,89.618807 73.222249,89.687798 73.202323,89.779785 73.189026,89.848776 73.189026,89.96376 73.169061,90.078745 73.162401,90.147735 73.162401,90.33171 73.189026,90.446695 73.222249,90.653667 73.242152,90.676663 73.248782,90.791648 73.248782,90.952626 73.268654,90.99862 73.268654,91.113604 73.288504,91.389566 73.295116,91.527548 73.255408,91.642532 73.255408,91.826507 73.275274,91.849504 73.295116,91.918494 73.314935,91.918494 73.341325,91.987485 73.354505,92.102469 73.354505,92.217454 73.374256,92.332438 73.374256,92.493416 73.354505,92.562407 73.334732,92.631397 73.328135,92.677391 73.295116,92.769379 73.28189,92.769379 73.242152,92.861366 73.215609,93.022344 73.175718,93.137329 73.195675,93.206319 73.215609,93.321304 73.208967,93.3443 73.202323,93.390294 73.202323,93.413291 73.23552,93.436288 73.255408,93.528275 73.262033,93.597266 73.228886,93.666257 73.23552,93.666257 73.262033,93.735247 73.275274,93.827235 73.268654,93.850232 73.262033,94.0802 73.262033,94.0802 73.255408,94.195185 73.248782,94.310169 73.23552,94.310169 73.195675,94.37916 73.189026,94.471147 73.189026,94.609128 73.135735,94.885091 73.115709,94.931085 73.102346,95.023072 73.102346,95.138056 73.135735,95.299035 73.129063,95.322031 73.135735,95.391022 73.149073,95.460013 73.149073,95.529003 73.169061,95.666984 73.182373,95.689981 73.175718,95.620991 73.142406,95.643988 73.109029,95.620991 73.082281,95.552 73.062193,95.552 73.035374,95.506006 73.021949,95.574997 72.947925,95.552 72.927683,95.620991 72.907417,95.712978 72.907417,95.827963 72.846479,95.942947 72.812534,95.942947 72.798938,95.850959 72.751268,95.91995 72.71714,95.896953 72.710307,95.827963 72.682947,95.827963 72.655545,95.91995 72.628101,95.942947 72.579973,95.91995 72.573087,95.873956 72.504082,96.011938 72.455621,96.034934 72.434812,95.965944 72.393123,95.988941 72.337388,96.011938 72.330409,95.988941 72.309457,96.011938 72.309457,95.988941 72.28848,95.91995 72.281483,95.91995 72.239441,95.965944 72.183235,95.965944 72.133914,95.91995 72.119798,95.873956 72.119798,95.850959 72.098604,95.91995 72.091534,95.988941 72.091534,95.965944 72.070308,95.942947 72.063227,95.942947 72.034876,95.965944 72.027781,95.942947 72.020684,95.965944 71.999376,96.034934 71.999376,96.126922 71.956688,96.126922 71.90676,96.080928 71.871016,96.057931 71.863859,96.057931 71.849537,96.195913 71.835204,96.218909 71.799323,96.195913 71.770569,96.172916 71.763374,96.241906 71.727356,96.264903 71.727356,96.2879 71.69127,96.310897 71.669585,96.379888 71.662351,96.448878 71.61889,96.425881 71.582597,96.402884 71.57533,96.333894 71.546235,96.356891 71.524384,96.586859 71.480607,96.65585 71.458682,96.793831 71.429408,96.793831 71.400091,96.770834 71.392754,96.747837 71.370728,96.724841 71.319236,96.65585 71.297126,96.540866 71.252831,96.540866 71.230645,96.586859 71.21584,96.563862 71.193613,96.540866 71.186198,96.540866 71.15651,96.563862 71.15651,96.540866 71.134214,96.471875 71.134214,96.425881 71.119336,96.356891 71.111893,96.356891 71.089547,97.092791 70.857137,97.161781 70.849595,97.299762 70.849595,97.345756 70.834501,97.529731 70.804279,97.598722 70.796716,97.621719 70.774011,97.667712 70.758859,97.598722 70.751279,97.506734 70.774011,97.506734 70.751279,97.575725 70.713337,97.529731 70.698139,97.552728 70.660096,97.506734 70.637235,97.506734 70.629609,97.39175 70.62198,97.368753 70.614348,97.39175 70.576146,97.46074 70.568497,97.506734 70.583792,97.644715 70.591436,97.667712 70.599076,97.782697 70.599076,97.989668 70.583792,98.012665 70.560845,98.035662 70.55319,98.035662 70.522541,98.012665 70.484165,98.081656 70.453412,98.081656 70.422612,98.104653 70.414905,98.173643 70.376325,98.150647 70.353142,97.943675 70.291192,97.851687 70.275675,97.82869 70.236832,97.805694 70.221274,97.805694 70.182327,97.782697 70.174529,97.667712 70.088556,97.690709 70.041511,97.667712 70.041511,97.644715 70.002225,97.943675 69.899735,97.989668 69.852262,98.058659 69.828486,98.081656 69.81262,98.012665 69.804682,97.943675 69.788798,97.920678 69.780852,97.82869 69.725142,97.736703 69.68526,97.552728 69.693242,97.529731 69.701222,97.414747 69.709198,97.345756 69.68526,97.253769 69.677274,97.184778 69.669286,97.184778 69.645302,97.138784 69.597254,97.092791 69.581214,97.0238 69.573189,97.000803 69.565161,96.701844 69.573189,96.586859 69.549097,96.586859 69.516932,96.471875 69.468594,96.379888 69.468594,96.310897 69.460527,96.2879 69.428228,96.011938 69.371589,96.011938 69.355379,95.850959 69.331042,95.666984 69.322923,95.414019 69.298549,95.230044 69.241568,95.092063 69.192609,95.092063 69.151725,94.954081 69.102563,94.862094 69.094358,94.862094 69.069726,94.908088 69.036841,94.908088 69.003906,94.977078 68.995665,94.977078 68.970922,94.908088 68.946151,94.74711 68.937888,94.678119 68.929622,94.678119 68.904805,94.632125 68.888245,94.632125 68.855087,94.471147 68.780301,94.402157 68.755316,94.37916 68.713612,94.310169 68.688552,94.287172 68.663465,94.218182 68.621589,94.195185 68.613204,94.195185 68.579635,94.172188 68.571235,94.172188 68.546015,94.195185 68.546015,94.195185 68.529187,94.241178 68.512345,94.264175 68.470187,94.218182 68.444855,94.195185 68.436404,94.195185 68.385634,94.126194 68.368686,94.034207 68.360207,93.919222 68.377162,93.896225 68.385634,93.873229 68.385634,93.758244 68.411033,93.597266 68.436404,93.436288 68.436404,93.3443 68.453302,93.183322 68.453302,93.068338 68.436404,92.999347 68.40257,92.930357 68.343239,92.792376 68.292261,92.769379 68.249692,92.769379 68.164315,92.700388 68.13864,92.700388 68.130075,91.895498 67.828291,91.895498 67.767462,91.872501 67.741344,91.80351 67.715196,91.80351 67.680288,91.711523 67.610315,91.619535 67.592789,91.527548 67.531347,91.504551 67.522556,91.389566 67.487361,91.36657 67.460931,91.297579 67.452114,91.205591 67.487361,91.136601 67.487361,90.975623 67.443294,90.952626 67.416815,90.814645 67.425645,90.745654 67.416815,90.676663 67.390306,90.538682 67.390306,90.515685 67.399146,90.400701 67.407982,90.377704 67.416815,90.216726 67.434471,90.124739 67.460931,90.009754 67.469744,89.710795 67.443294,89.710795 67.434471,89.618807 67.434471,89.572814 67.416815,89.503823 67.416815,89.273854 67.504965,89.15887 67.469744,89.15887 67.416815,89.112876 67.381463,88.974895 67.363768,88.859911 67.372617,88.721929 67.407982,88.675936 67.407982,88.560951 67.372617,88.491961 67.381463,88.445967 67.399146,88.238995 67.399146,88.170004 67.372617,88.101014 67.372617,88.05502 67.416815,87.940036 67.416815,87.940036 67.399146,87.871045 67.346059,87.503095 67.346059,87.457101 67.363768,87.342117 67.416815,87.273126 67.443294,87.112148 67.522556,86.905177 67.619073,86.859183 67.636579,86.790192 67.715196,86.721202 67.845642,86.629214 67.949477,86.58322 68.044252,87.802055 68.035652,87.848048 68.061442,87.871045 68.121507,87.894042 68.130075,87.894042 68.13864,87.963033 68.241169,88.261992 68.67183,88.284989 68.713612,88.307986 68.721959,88.307986 68.755316,88.330983 68.763647,88.353979 68.805258,88.42297 68.904805,88.445967 68.929622,88.514958 68.937888,92.309441 68.929622,92.355435 68.937888,92.470419 69.701222,92.424426 69.709198,91.757516 69.717172,88.859911 69.749036,88.698933 69.749036,88.307986 69.756994,88.124011 69.756994,86.008299 69.780852,85.985302 69.756994,85.985302 69.371589,85.732336 69.282284,85.686342 69.233416,85.686342 69.208941,85.824324 69.168087,85.939308 69.143539,86.008299 69.13535,86.054292 69.110764,86.054292 69.05329,85.985302 68.995665,85.916311 68.970922,85.824324 68.91308,85.824324 68.83849,85.893314 68.780301,85.962305 68.738644,86.21527 68.663465,86.284261 68.604817,86.307258 68.554425,86.238267 68.411033,86.261264 68.40257,86.284261 68.351725,86.560223 68.266729,86.58322 68.232642,86.445239 68.130075,86.445239 68.112936,86.376249 68.104362,86.261264 68.104362,86.238267 68.095784,85.916311 68.07862,85.801327 68.061442,85.686342 68.035652,85.686342 68.00122,85.709339 67.992605,85.686342 67.932203,85.663345 67.906269,85.594355 67.906269,85.525364 67.897617,85.433377 67.828291,85.433377 67.802241,85.341389 67.793551,85.226405 67.723915,85.226405 67.715196,85.180411 67.715196,85.180411 67.68902,85.249402 67.645327,85.318392 67.645327,85.364386 67.627827,85.318392 67.557699,85.203408 67.557699,85.203408 67.531347,85.111421 67.522556,85.04243 67.460931,84.996436 67.407982,84.927446 67.407982,84.904449 67.381463,84.950442 67.354915,85.111421 67.354915,85.134417 67.346059,85.065427 67.319472,85.04243 67.283976,84.927446 67.230633,84.789464 67.221731,84.720474 67.230633,84.651483 67.310603,84.582493 67.346059,84.444511 67.346059,84.398518 67.399146,84.398518 67.452114,84.421514 67.460931,84.398518 67.496165,84.260536 67.496165,84.214543 67.531347,84.214543 67.557699,84.099558 67.627827,83.984574 67.627827,83.961577 67.619073,83.93858 67.627827,83.800599 67.627827,83.800599 67.645327,83.777602 67.723915,83.708611 67.784858,83.685615 67.784858,83.639621 67.819611,83.57063 67.819611,83.478643 67.845642,83.50164 67.906269,83.363658 67.906269,83.386655 67.975363,83.317665 67.983985,83.294668 67.992605,83.248674 67.975363,83.13369 67.975363,83.110693 68.035652,83.13369 68.035652,83.294668 68.061442,83.317665 68.087204,83.340661 68.095784,83.340661 68.130075,83.271671 68.189962,83.225677 68.189962,83.156687 68.198504,83.179683 68.258212,83.13369 68.283754,83.064699 68.283754,82.949715 68.317765,82.903721 68.334751,82.788737 68.385634,82.719746 68.394104,82.696749 68.436404,82.673752 68.512345,82.650755 68.520768,82.627758 68.546015,82.627758 68.596426))","code":"dudinka_gp","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true,"traffic":true},"id":"277","name":"Дудинка гп","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":16,"min":9}},{"bounds":"POLYGON((68.783642 38.688293,68.829636 38.652383,68.898626 38.580509,68.875629 38.526557,68.806639 38.526557,68.760645 38.454557,68.691654 38.454557,68.668658 38.616455,68.783642 38.688293))","code":"dushanbe","country_code":"tj","domain":"tj","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"274","name":"Душанбе","time_zone":{"name":"Asia/Dushanbe","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((59.699878 56.820507,59.722875 56.883381,59.722875 56.971227,59.745872 57.008812,59.814862 57.008812,59.883853 57.033848,60.067828 57.058866,60.067828 57.083868,60.182812 57.196169,60.228806 57.208625,60.251803 57.258411,60.205809 57.283278,60.113822 57.320548,59.952843 57.308129,59.860856 57.345373,59.883853 57.43213,60.021834 57.50633,60.044831 57.50633,60.090825 57.531029,60.205809 57.543373,60.2748 57.50633,60.688743 57.50633,60.71174 57.493973,60.964706 57.481613,61.033696 57.444507,61.263665 57.43213,61.286662 57.444507,61.355653 57.444507,61.424643 57.407363,61.976568 57.394973,62.344518 57.283278,62.528493 57.283278,63.379377 57.270846,63.65534 57.1463,64.667202 57.12134,64.75919 57.133822,64.966161 57.133822,64.989158 57.12134,64.989158 57.033848,64.644205 57.033848,64.069283 56.996288,63.816318 56.95869,63.333383 56.870815,63.149409 56.870815,62.98843 56.782732,62.574487 56.757527,62.505496 56.732306,62.252531 56.732306,61.631615 56.719689,61.562624 56.694442,61.194674 56.707067,61.102687 56.643897,61.07969 56.605944,61.033696 56.580621,61.033696 56.529924,61.125684 56.479159,61.125684 56.415607,61.148681 56.351948,61.125684 56.351948,61.102687 56.313702,61.148681 56.288183,61.171678 56.198733,61.125684 56.198733,61.056693 56.185938,61.033696 56.198733,60.918712 56.198733,60.895715 56.211525,60.734737 56.237095,60.665746 56.249873,60.688743 56.275417,60.665746 56.313702,60.596756 56.313702,60.527765 56.224312,60.435778 56.224312,60.412781 56.237095,60.435778 56.275417,60.435778 56.339204,60.458775 56.351948,60.435778 56.390156,60.182812 56.390156,60.113822 56.415607,60.113822 56.453751,60.090825 56.466457,60.067828 56.555281,59.952843 56.593285,59.814862 56.593285,59.745872 56.6186,59.745872 56.719689,59.699878 56.820507))","code":"ekaterinburg","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"9","name":"Екатеринбург","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.450769 52.67028,38.565753 52.656332,38.634744 52.628424,38.634744 52.586528,38.519759 52.572554,38.427772 52.628424,38.450769 52.67028))","code":"elets","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"126","name":"Елец","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((67.518814 47.900033,67.541811 47.946266,67.702789 47.930859,67.794777 47.900033,67.794777 47.745627,67.77178 47.699215,67.679792 47.699215,67.541811 47.853759,67.518814 47.900033))","code":"zhezkazgan","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"242","name":"Жезказган","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.936397 54.605942,77.936397 54.672486,77.959394 54.685782,77.959394 54.738921,78.189362 54.8185,78.373337 54.85823,78.419331 54.911144,78.488322 54.924361,78.695293 55.003575,78.695293 55.016762,78.994253 55.003575,79.178228 54.924361,79.178228 54.871465,79.270215 54.844991,79.293212 54.805248,79.316209 54.805248,79.293212 54.77873,79.362203 54.725643,79.431193 54.71236,79.477187 54.738921,79.569175 54.738921,79.569175 54.699073,79.45419 54.659186,79.431193 54.645881,79.201225 54.565963,79.132234 54.605942,79.132234 54.645881,79.08624 54.645881,79.08624 54.565963,79.063243 54.552628,79.01725 54.485888,78.879268 54.485888,78.879268 54.459161,78.948259 54.419038,78.948259 54.35208,78.810278 54.338675,78.787281 54.325266,78.71829 54.311852,78.672297 54.285012,78.488322 54.298434,78.442328 54.298434,78.419331 54.285012,78.35034 54.271585,78.327344 54.271585,78.327344 54.298434,78.212359 54.338675,78.189362 54.378876,78.097375 54.432417,78.120372 54.525945,77.936397 54.605942))","code":"zdvinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"180","name":"Здвинск","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.79645 57.046359,40.86544 57.108853,40.934431 57.108853,40.957428 57.096363,41.141403 57.083868,41.210393 57.07137,41.210393 56.98376,41.187396 56.971227,41.187396 56.933604,41.210393 56.933604,41.210393 56.908501,41.095409 56.870815,40.934431 56.870815,40.86544 56.883381,40.819447 56.908501,40.79645 57.046359))","code":"ivanovo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"65","name":"Иваново","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((52.40987 57.320548,52.40987 57.38258,52.501857 57.444507,52.570848 57.45688,52.593845 57.444507,52.708829 57.283278,52.84681 57.270846,52.984791 57.245971,53.099776 57.233526,53.168766 57.233526,53.237757 57.158773,53.21476 57.07137,53.283751 57.046359,53.58271 57.046359,53.605707 57.033848,53.766685 57.046359,53.766685 57.12134,53.881669 57.158773,54.042647 57.171243,54.157632 57.171243,54.203626 57.133822,54.203626 57.058866,54.180629 57.046359,54.203626 56.98376,54.157632 56.95869,54.157632 56.908501,54.088641 56.870815,54.088641 56.795328,54.042647 56.744919,53.95066 56.744919,53.881669 56.807919,53.812679 56.807919,53.766685 56.782732,53.766685 56.681812,53.789682 56.669178,53.812679 56.580621,54.088641 56.50455,54.088641 56.491856,54.203626 56.479159,54.226622 56.466457,54.433594 56.402883,54.479588 56.402883,54.594572 56.326455,54.732554 56.313702,54.732554 56.288183,54.68656 56.249873,54.548579 56.224312,54.479588 56.160334,54.387601 56.147525,54.387601 56.083419,54.341607 56.032057,54.226622 56.032057,54.157632 56.070585,54.088641 56.083419,53.973657 56.160334,53.789682 56.275417,53.398735 56.428326,53.237757 56.466457,53.099776 56.529924,53.030785 56.580621,53.030785 56.643897,52.984791 56.65654,52.984791 56.669178,52.938798 56.681812,52.938798 56.757527,52.915801 56.845669,52.938798 56.858244,52.938798 57.008812,52.892804 57.033848,52.892804 57.183708,52.524854 57.320548,52.40987 57.320548))","code":"izhevsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"41","name":"Ижевск","time_zone":{"name":"Europe/Samara","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((101.117243 52.726026,101.117243 52.767788,101.278221 52.7817,101.301218 52.795608,101.853143 52.809511,102.68103 52.837304,103.002986 52.851193,103.094974 52.906708,103.232955 52.934438,103.278949 52.989846,103.34794 53.003687,103.370936 53.100449,103.34794 53.114255,103.370936 53.307066,103.393933 53.320805,103.370936 53.553692,103.34794 53.567352,103.393933 53.594658,103.485921 53.594658,103.577908 53.567352,103.692893 53.567352,103.738886 53.608304,104.221821 53.594658,104.911727 53.416854,104.980717 53.403146,105.003714 53.403146,105.026711 53.389434,105.187689 53.34827,105.578636 53.224539,105.555639 53.128056,105.877595 52.948297,105.946586 52.920575,105.969583 52.920575,105.969583 52.906708,106.038573 52.892836,106.06157 52.878959,106.291539 52.837304,106.42952 52.865079,107.027439 53.307066,107.119426 53.334539,107.119426 53.34827,107.188417 53.361995,107.280404 53.416854,107.349395 53.416854,107.418386 53.471642,107.556367 53.649216,107.579364 53.662845,107.671351 53.662845,107.786336 53.581007,108.016304 53.403146,108.085295 53.361995,108.085295 53.320805,108.016304 53.238304,107.418386 52.934438,107.004442 52.712096,106.521508 52.502615,106.176555 52.362405,105.99258 52.179463,105.969583 52.16536,105.969583 52.137139,105.946586 52.137139,105.831602 51.995766,105.670624 51.882346,105.417658 51.782868,105.25668 51.740167,105.118699 51.711677,105.095702 51.697426,104.796742 51.654644,104.635764 51.640375,104.589771 51.611822,104.635764 51.46879,104.612767 51.425793,104.52078 51.44013,104.244817 51.46879,104.129833 51.483114,103.899864 51.554663,103.876868 51.56896,103.715889 51.583252,103.600905 51.597539,103.600905 51.640375,103.623902 51.68317,103.600905 51.725925,103.531914 51.725925,103.232955 51.811313,103.209958 51.825528,103.094974 51.853946,103.071977 51.896539,103.025983 51.896539,102.888002 51.924912,102.865005 51.967438,102.819011 51.967438,102.68103 52.066509,102.61204 52.123022,102.566046 52.179463,102.566046 52.221748,102.497055 52.235833,102.382071 52.249915,102.31308 52.235833,102.175099 52.278064,102.106108 52.278064,102.083112 52.235833,102.060115 52.221748,101.94513 52.221748,101.922133 52.263992,101.922133 52.320254,101.715162 52.404515,101.669168 52.474609,101.600177 52.488614,101.462196 52.586528,101.393205 52.628424,101.278221 52.656332,101.117243 52.726026))","code":"irkutsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"11","name":"Иркутск","time_zone":{"name":"Asia/Irkutsk","offset":480},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((69.266576 56.147525,69.266576 56.185938,69.289573 56.198733,69.565536 56.173138,69.703517 56.121896,69.703517 56.057747,69.496545 55.993491,69.427554 55.993491,69.427554 56.006351,69.404558 56.019206,69.31257 56.121896,69.266576 56.147525))","code":"ishim","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true},"id":"205","name":"Ишим","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.580527 56.529924,47.580527 56.719689,47.603524 56.757527,47.92548 56.757527,48.132452 56.744919,48.155448 56.707067,48.132452 56.542605,48.132452 56.428326,48.040464 56.428326,47.92548 56.517239,47.649517 56.517239,47.580527 56.529924))","code":"yoshkarola","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"70","name":"Йошкар-Ола","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((42.314243 44.050626,42.314243 44.083674,42.360237 44.13321,42.544212 44.265106,42.613202 44.265106,42.774181 44.298034,42.981152 44.281572,42.981152 44.298034,43.188124 44.298034,43.303109 44.31449,43.349102 44.281572,43.487084 44.248635,43.556074 44.199195,43.533077 44.182706,43.533077 44.083674,43.51008 44.034095,43.533077 43.984475,43.602068 43.934814,43.602068 43.851952,43.44109 43.868534,43.395096 43.835366,43.326105 43.818776,43.303109 43.835366,43.234118 43.951372,43.142131 43.951372,43.119134 43.901683,42.981152 43.901683,42.866168 43.851952,42.843171 43.80218,42.659196 43.818776,42.636199 43.835366,42.636199 43.934814,42.590206 43.967926,42.567209 44.034095,42.498218 44.034095,42.475221 43.967926,42.383234 43.967926,42.314243 44.050626))","code":"minvody","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"89","name":"КавМинВоды","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((48.224439 55.890459,48.224439 55.929128,48.247436 55.942009,48.270433 55.980627,48.569392 55.967759,48.638383 56.006351,48.707373 55.993491,48.73037 56.006351,48.753367 55.993491,48.845355 56.019206,49.006333 56.006351,49.09832 56.006351,49.213305 55.993491,49.305292 56.019206,49.374283 56.006351,49.535261 56.006351,49.581254 55.954886,49.581254 55.916243,49.604251 55.877561,49.558258 55.825925,49.581254 55.735397,49.604251 55.696535,49.696239 55.696535,49.696239 55.631679,49.673242 55.566715,49.627248 55.527685,49.535261 55.527685,49.420276 55.566715,49.328289 55.553709,49.167311 55.462549,49.075323 55.462549,49.052326 55.501644,48.960339 55.579716,48.822358 55.579716,48.753367 55.540699,48.684376 55.540699,48.684376 55.566715,48.500402 55.566715,48.454408 55.540699,48.385417 55.540699,48.316427 55.553709,48.316427 55.696535,48.270433 55.722447,48.29343 55.825925,48.224439 55.890459))","code":"kazan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"21","name":"Казань","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((19.386362 54.619259,19.501347 54.685782,19.570337 54.77873,19.570337 54.85823,19.547341 54.871465,19.593334 54.990384,19.685322 55.095794,19.754312 55.135251,19.961284 55.17467,20.21425 55.17467,20.375228 55.1878,20.421222 55.214049,20.559203 55.331954,20.65119 55.384244,20.697184 55.384244,20.95015 55.292691,21.111128 55.266495,21.134125 55.266495,21.134125 54.977188,21.180118 54.844991,21.180118 54.77873,21.134125 54.725643,21.157122 54.632572,21.180118 54.565963,21.157122 54.552628,20.835165 54.552628,20.789172 54.525945,20.674187 54.525945,20.490212 54.499245,20.375228 54.512597,20.352231 54.525945,20.191253 54.512597,19.915291 54.552628,19.869297 54.552628,19.685322 54.445791,19.616331 54.445791,19.409359 54.579294,19.386362 54.619259))","code":"kaliningrad","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"40","name":"Калининград","time_zone":{"name":"Europe/Kaliningrad","offset":120},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.898116 54.459161,35.921113 54.472527,35.898116 54.645881,35.898116 54.725643,35.94411 54.765465,36.105088 54.765465,36.151082 54.791991,36.220072 54.844991,36.197075 54.911144,36.243069 54.950783,36.38105 54.977188,36.404047 55.016762,36.450041 55.043123,36.542028 55.148395,36.657013 55.161535,36.703007 55.095794,36.634016 55.029945,36.611019 55.016762,36.611019 54.924361,36.542028 54.911144,36.542028 54.897922,36.473038 54.831748,36.496035 54.791991,36.473038 54.699073,36.473038 54.36548,36.427044 54.325266,36.31206 54.325266,36.151082 54.311852,36.128085 54.325266,35.94411 54.325266,35.921113 54.36548,35.898116 54.459161))","code":"kaluga","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"61","name":"Калуга","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((61.539628 56.44104,61.631615 56.479159,61.700606 56.479159,61.723602 56.517239,61.723602 56.555281,61.792593 56.567953,61.976568 56.567953,62.18354 56.580621,62.252531 56.567953,62.252531 56.313702,62.229534 56.275417,61.746599 56.275417,61.700606 56.313702,61.608618 56.313702,61.585621 56.351948,61.562624 56.364688,61.539628 56.44104))","code":"k_uralskiy","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"109","name":"Каменск-Уральский","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((45.303836 50.057963,45.303836 50.102235,45.34983 50.146466,45.487811 50.146466,45.487811 50.102235,45.418821 50.028425,45.418821 50.013649,45.326833 50.013649,45.303836 50.057963))","code":"kamyshin","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"127","name":"Камышин","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((72.670113 49.969295,72.670113 49.998869,72.831091 50.072725,72.831091 50.131727,72.900082 50.190657,73.015066 50.190657,73.314026 50.146466,73.383016 50.102235,73.406013 50.028425,73.406013 49.821152,73.383016 49.687435,73.222038 49.64278,73.015066 49.65767,72.923079 49.672555,72.877085 49.702311,72.785098 49.776621,72.762101 49.850817,72.670113 49.969295))","code":"karaganda","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"84","name":"Караганда","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.1775 53.662845,77.1775 53.676469,77.246491 53.703705,77.361475 53.717316,77.384472 53.703705,77.499456 53.717316,77.54545 53.785305,77.660434 53.785305,77.683431 53.81247,77.798416 53.826046,77.867406 53.798889,77.9134 53.798889,77.9134 53.853184,77.959394 53.880305,77.98239 53.920953,78.074378 53.920953,78.166365 53.94803,78.166365 54.015646,78.235356 54.029156,78.258353 54.042661,78.235356 54.056163,78.235356 54.09664,78.35034 54.09664,78.327344 54.164014,78.304347 54.177476,78.304347 54.204386,78.327344 54.217835,78.35034 54.271585,78.419331 54.285012,78.442328 54.298434,78.488322 54.298434,78.488322 54.285012,78.580309 54.204386,78.603306 54.204386,78.6493 54.110123,78.580309 54.083152,78.557312 54.069659,78.557312 54.002132,78.603306 53.97509,78.580309 53.907408,78.557312 53.893859,78.580309 53.826046,78.580309 53.798889,78.672297 53.676469,78.672297 53.649216,78.626303 53.621946,78.6493 53.553692,78.626303 53.512687,78.465325 53.512687,78.373337 53.485328,78.28135 53.485328,78.235356 53.540028,78.235356 53.581007,78.212359 53.621946,78.143369 53.581007,77.98239 53.581007,77.9134 53.553692,77.936397 53.49901,78.051381 53.485328,78.051381 53.444257,77.936397 53.444257,77.936397 53.375717,77.9134 53.361995,77.890403 53.307066,77.821412 53.320805,77.798416 53.334539,77.499456 53.485328,77.384472 53.553692,77.200497 53.649216,77.1775 53.662845))","code":"karasuk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"181","name":"Карасук","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((78.442328 72.337388,78.488322 72.351338,78.488322 72.393123,78.626303 72.448687,78.6493 72.455621,78.6493 72.483329,78.741287 72.483329,78.764284 72.476406,80.994981 72.204333,82.075834 72.253466,82.144824 72.253466,82.236812 72.267479,82.282805 72.309457,82.351796 72.316444,82.374793 72.323428,82.374793 72.351338,82.420787 72.358309,82.420787 72.365277,82.535771 72.372242,82.627758 72.372242,82.627758 72.40703,82.719746 72.40703,82.742743 72.400078,82.857727 72.420926,82.972712 72.420926,82.995708 72.41398,83.087696 72.393123,83.156687 72.386165,83.20268 72.400078,83.317665 72.393123,83.340661 72.41398,83.340661 72.441751,83.432649 72.46948,83.455646 72.504082,83.524636 72.510994,83.547633 72.497167,83.754605 72.483329,83.800599 72.46948,83.892586 72.46948,83.915583 72.490249,83.984574 72.483329,84.007571 72.462552,83.961577 72.448687,83.984574 72.427871,84.076561 72.41398,84.007571 72.386165,84.030568 72.365277,84.099558 72.358309,84.122555 72.337388,84.145552 72.309457,84.214543 72.309457,84.237539 72.316444,84.214543 72.351338,84.283533 72.351338,84.283533 72.316444,84.467508 72.323428,84.490505 72.344364,84.559496 72.344364,84.582493 72.393123,84.628486 72.420926,84.605489 72.427871,84.651483 72.462552,84.720474 72.455621,84.743471 72.434812,84.858455 72.427871,84.904449 72.400078,85.157414 72.309457,85.203408 72.295475,85.341389 72.274482,85.364386 72.267479,85.525364 72.246455,85.594355 72.253466,85.663345 72.28848,85.824324 72.295475,85.870317 72.337388,85.84732 72.386165,85.916311 72.40703,86.031295 72.41398,86.14628 72.41398,86.192274 72.427871,86.307258 72.434812,86.330255 72.455621,86.537227 72.448687,86.58322 72.434812,86.629214 72.448687,86.721202 72.490249,86.859183 72.504082,86.859183 72.524811,86.928173 72.538618,86.997164 72.531716,86.997164 72.517904,87.066155 72.510994,87.135145 72.490249,87.204136 72.448687,87.227133 72.427871,87.342117 72.420926,87.457101 72.427871,87.526092 72.434812,87.549089 72.455621,87.664073 72.462552,87.825051 72.462552,87.848048 72.483329,87.825051 72.504082,87.848048 72.510994,87.917039 72.504082,87.940036 72.476406,88.05502 72.46948,88.124011 72.455621,88.193001 72.490249,88.170004 72.510994,88.193001 72.517904,88.124011 72.538618,88.147008 72.559307,88.307986 72.559307,88.376976 72.552413,88.468964 72.573087,88.537954 72.573087,88.583948 72.552413,88.583948 72.531716,88.629942 72.517904,88.652939 72.483329,88.629942 72.441751,88.583948 72.441751,88.583948 72.427871,88.560951 72.427871,88.629942 72.379205,88.652939 72.330409,88.629942 72.323428,88.652939 72.316444,88.652939 72.281483,88.721929 72.260474,88.721929 72.239441,88.79092 72.232425,88.859911 72.232425,88.928901 72.197303,88.951898 72.119798,88.928901 72.098604,88.928901 72.034876,88.859911 72.013584,88.859911 71.970928,88.882907 71.963809,88.905904 71.921039,88.882907 71.885322,88.813917 71.87817,88.744926 71.863859,88.744926 71.828033,88.721929 71.82086,88.652939 71.828033,88.629942 71.806505,88.514958 71.784952,88.514958 71.756176,88.468964 71.705713,88.445967 71.698493,88.42297 71.662351,88.491961 71.655114,88.491961 71.604381,88.583948 71.57533,88.629942 71.53167,88.767923 71.524384,88.882907 71.502508,88.882907 71.473302,88.859911 71.465993,88.836914 71.436731,88.767923 71.436731,88.560951 71.407424,88.491961 71.414755,88.399973 71.392754,88.42297 71.385415,88.445967 71.348677,88.330983 71.348677,88.330983 71.326601,88.307986 71.319236,88.307986 71.311869,88.238995 71.311869,88.261992 71.274991,88.284989 71.267607,88.261992 71.245438,88.238995 71.238043,88.261992 71.201025,88.261992 71.186198,88.170004 71.186198,88.101014 71.17878,88.078017 71.141649,88.101014 71.126777,88.078017 71.119336,88.101014 71.111893,88.078017 71.104447,88.101014 71.074635,88.170004 71.067175,88.193001 71.059712,88.261992 71.052246,88.284989 71.044777,88.330983 71.044777,88.376976 71.029832,88.468964 71.029832,88.468964 70.999906,88.560951 70.984926,88.560951 70.954932,88.537954 70.902333,88.560951 70.894808,88.629942 70.842049,88.767923 70.796716,88.767923 70.758859,88.721929 70.743697,88.721929 70.682931,88.629942 70.66771,88.629942 70.62198,88.583948 70.591436,88.514958 70.568497,88.399973 70.55319,88.376976 70.545532,88.307986 70.537871,88.307986 70.530208,88.238995 70.530208,88.193001 70.545532,88.101014 70.537871,88.078017 70.530208,87.917039 70.530208,87.848048 70.499524,87.802055 70.484165,87.756061 70.484165,87.756061 70.507199,87.68707 70.507199,87.641076 70.491846,87.526092 70.491846,87.503095 70.499524,87.388111 70.491846,87.273126 70.499524,87.089152 70.530208,87.089152 70.55319,87.043158 70.568497,87.043158 70.606714,86.95117 70.629609,86.905177 70.629609,86.652211 70.652478,86.58322 70.690536,86.376249 70.682931,86.307258 70.660096,86.307258 70.644858,86.123283 70.644858,86.077289 70.629609,86.008299 70.637235,85.985302 70.599076,86.008299 70.591436,86.123283 70.599076,86.14628 70.576146,86.14628 70.545532,86.238267 70.530208,86.21527 70.491846,86.330255 70.468794,86.307258 70.445716,86.238267 70.422612,86.261264 70.391765,86.192274 70.353142,86.192274 70.329932,86.307258 70.306697,86.376249 70.298946,86.376249 70.283435,86.307258 70.283435,86.284261 70.260146,86.307258 70.260146,86.330255 70.221274,86.307258 70.205704,86.238267 70.174529,86.123283 70.127679,86.100286 70.119861,85.939308 70.104214,85.870317 70.065047,85.801327 70.041511,85.77833 70.017949,85.594355 70.002225,85.594355 70.010088,85.479371 70.017949,85.456374 70.010088,85.433377 69.98649,85.272399 69.98649,85.249402 69.978618,85.157414 69.970743,85.157414 69.939214,85.088424 69.907637,84.996436 69.907637,84.927446 69.868099,84.812461 69.852262,84.812461 69.796742,84.835458 69.788798,84.904449 69.693242,84.927446 69.693242,84.927446 69.6533,84.904449 69.629298,84.858455 69.613282,84.835458 69.589235,84.720474 69.533021,84.67448 69.516932,84.651483 69.476658,84.720474 69.468594,84.697477 69.428228,84.766468 69.420146,84.812461 69.371589,84.789464 69.331042,84.582493 69.306676,84.605489 69.282284,84.582493 69.225261,84.490505 69.200776,84.490505 69.176264,84.444511 69.151725,84.467508 69.110764,84.490505 69.110764,84.490505 69.06151,84.513502 69.05329,84.490505 68.979173,84.513502 68.970922,84.490505 68.962668,84.467508 68.904805,84.513502 68.81357,84.490505 68.805258,84.467508 68.780301,84.536499 68.721959,84.467508 68.696909,84.467508 68.67183,84.490505 68.663465,84.444511 68.62997,84.329527 68.613204,84.099558 68.613204,83.93858 68.646724,83.800599 68.604817,83.754605 68.588032,83.777602 68.537603,83.846593 68.537603,83.915583 68.554425,83.915583 68.529187,83.86959 68.495492,83.777602 68.495492,83.685615 68.478625,83.524636 68.470187,83.478643 68.520768,83.409652 68.546015,83.294668 68.554425,83.20268 68.529187,83.179683 68.537603,83.087696 68.537603,83.041702 68.554425,82.972712 68.562831,82.811733 68.596426,82.742743 68.604817,82.719746 68.613204,82.719746 68.62997,82.83473 68.62997,82.880724 68.67183,82.83473 68.746981,82.788737 68.763647,82.673752 68.788623,82.558768 68.82188,82.558768 68.855087,82.489777 68.979173,82.443784 69.003906,82.420787 69.012144,82.420787 69.02038,82.39779 69.02038,82.328799 69.045067,82.351796 69.069726,82.420787 69.07794,82.46678 69.094358,82.46678 69.159908,82.420787 69.168087,82.351796 69.176264,82.305802 69.159908,82.190818 69.159908,82.02984 69.192609,81.845865 69.192609,81.799871 69.241568,81.822868 69.266007,81.960849 69.331042,81.960849 69.34727,81.799871 69.436307,81.730881 69.444384,81.66189 69.436307,81.66189 69.387787,81.638893 69.34727,81.66189 69.306676,81.592899 69.266007,81.546906 69.266007,81.523909 69.257864,81.431921 69.249717,81.339934 69.274147,81.270943 69.266007,81.224949 69.249717,81.063971 69.225261,81.017977 69.208941,80.92599 69.208941,80.92599 69.225261,80.811006 69.266007,80.742015 69.314801,80.535043 69.314801,80.282078 69.339157,80.282078 69.355379,80.167093 69.363486,80.098103 69.355379,80.075106 69.363486,79.914128 69.355379,79.776146 69.395881,79.776146 69.420146,79.707156 69.428228,79.638165 69.452457,79.615168 69.508883,79.592171 69.533021,79.569175 69.573189,79.500184 69.60527,79.477187 69.645302,79.408197 69.661294,79.3852 69.6533,79.362203 69.661294,79.293212 69.661294,79.270215 69.68526,79.201225 69.68526,79.08624 69.693242,79.08624 69.717172,79.155231 69.725142,79.155231 69.749036,79.109237 69.749036,79.109237 69.772902,79.08624 69.796742,79.01725 69.796742,79.01725 69.81262,79.040247 69.836414,78.902265 69.860182,78.902265 69.876012,78.971256 69.883923,79.063243 69.907637,79.063243 69.931324,79.109237 69.931324,79.155231 69.962865,79.155231 70.010088,79.201225 70.010088,79.201225 70.03366,79.224222 70.057205,79.362203 70.057205,79.339206 70.080723,79.339206 70.151118,79.431193 70.151118,79.431193 70.119861,79.546178 70.112039,79.569175 70.135495,79.661162 70.190123,79.661162 70.221274,79.684159 70.236832,79.75315 70.236832,79.75315 70.275675,79.82214 70.283435,79.891131 70.267912,79.937125 70.283435,80.052109 70.337672,80.1211 70.337672,80.144096 70.360872,80.1211 70.3686,80.144096 70.384046,80.213087 70.384046,80.213087 70.430316,80.351068 70.430316,80.374065 70.453412,80.443056 70.461104,80.604034 70.453412,80.673024 70.438018,80.673024 70.407194,80.719018 70.384046,80.811006 70.384046,80.811006 70.407194,80.834003 70.430316,80.719018 70.445716,80.673024 70.491846,80.742015 70.530208,80.742015 70.568497,80.788009 70.583792,80.788009 70.614348,80.811006 70.62198,80.788009 70.660096,80.650028 70.682931,80.650028 70.705739,80.673024 70.758859,80.696021 70.766436,80.719018 70.796716,80.650028 70.834501,80.604034 70.939918,80.604034 70.992417,80.581037 71.044777,80.420059 71.067175,80.213087 71.089547,80.075106 71.111893,80.006115 71.119336,79.45419 71.297126,79.224222 71.304499,79.155231 71.348677,79.155231 71.392754,79.316209 71.458682,79.339206 71.480607,79.362203 71.48791,79.362203 71.546235,79.316209 71.560788,79.316209 71.582597,79.3852 71.604381,79.546178 71.597123,79.569175 71.604381,79.730153 71.597123,79.730153 71.589861,79.845137 71.589861,79.937125 71.604381,80.006115 71.626141,80.029112 71.647875,80.144096 71.669585,80.144096 71.720144,80.098103 71.734565,80.1211 71.784952,80.075106 71.806505,80.098103 71.828033,80.19009 71.856699,80.305074 71.849537,80.305074 71.863859,80.351068 71.863859,80.351068 71.885322,80.305074 71.885322,80.259081 71.921039,80.1211 71.942436,80.075106 71.970928,79.960121 71.985158,79.937125 71.978044,79.891131 71.985158,79.891131 72.006482,79.845137 72.027781,79.707156 72.049057,79.569175 72.034876,79.569175 72.041968,79.500184 72.041968,79.431193 72.034876,79.408197 72.041968,79.224222 72.070308,79.155231 72.070308,79.08624 72.063227,79.063243 72.084461,78.994253 72.112736,78.925262 72.112736,78.902265 72.119798,78.879268 72.140968,78.764284 72.14802,78.764284 72.162114,78.6493 72.169157,78.626303 72.190271,78.603306 72.197303,78.626303 72.204333,78.6493 72.246455,78.603306 72.260474,78.603306 72.295475,78.511319 72.295475,78.442328 72.330409,78.442328 72.337388))","code":"karaul_sp","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true,"traffic":true},"id":"278","name":"Караул сп","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":16,"min":9}},{"bounds":"POLYGON((79.569175 54.85823,79.592171 54.937574,79.569175 54.950783,79.569175 54.990384,79.730153 55.003575,79.82214 55.016762,79.914128 55.082633,79.914128 55.122103,79.845137 55.122103,79.82214 55.135251,79.868134 55.214049,79.868134 55.292691,80.006115 55.331954,80.006115 55.371178,80.213087 55.566715,80.328071 55.566715,80.374065 55.540699,80.489049 55.553709,80.650028 55.592713,80.742015 55.618695,80.856999 55.605706,81.063971 55.644659,81.086968 55.644659,81.086968 55.501644,81.132962 55.475585,81.132962 55.436465,80.971984 55.410363,80.948987 55.371178,80.92599 55.358108,80.856999 55.279595,80.765012 55.279595,80.604034 55.24028,80.604034 55.200927,80.581037 55.029945,80.535043 54.977188,80.466053 54.937574,80.512046 54.897922,80.581037 54.897922,80.604034 54.844991,80.535043 54.752195,80.489049 54.738921,80.512046 54.672486,80.673024 54.605942,80.673024 54.539289,80.581037 54.539289,80.512046 54.525945,80.512046 54.472527,80.466053 54.445791,80.397062 54.459161,80.397062 54.512597,80.351068 54.552628,80.213087 54.552628,80.167093 54.632572,80.167093 54.805248,80.144096 54.844991,79.960121 54.8185,79.868134 54.8185,79.776146 54.871465,79.707156 54.884696,79.661162 54.85823,79.569175 54.85823))","code":"kargat","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"182","name":"Каргат","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((84.605489 55.709493,84.651483 55.709493,84.789464 55.748342,84.904449 55.761284,84.973439 55.722447,85.111421 55.696535,85.226405 55.657634,85.295396 55.657634,85.364386 55.696535,85.617352 55.683572,85.755333 55.657634,85.870317 55.657634,86.14628 55.709493,86.238267 55.761284,86.353252 55.748342,86.468236 55.592713,86.468236 55.475585,86.422242 55.318871,86.330255 55.292691,86.330255 55.24028,86.307258 55.200927,86.284261 55.214049,85.893314 55.214049,85.870317 55.200927,85.640349 55.214049,85.617352 55.227167,85.387383 55.25339,85.226405 55.345033,85.157414 55.436465,84.996436 55.423416,84.904449 55.358108,84.789464 55.371178,84.67448 55.371178,84.651483 55.410363,84.67448 55.423416,84.743471 55.449509,84.743471 55.514667,84.789464 55.553709,84.720474 55.644659,84.697477 55.683572,84.651483 55.683572,84.605489 55.709493))","code":"kemerovo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"5","name":"Кемерово","time_zone":{"name":"Asia/Novokuznetsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((49.006333 58.875843,49.02933 58.970808,49.167311 59.018192,49.259298 59.018192,49.374283 58.98266,49.443273 58.923358,49.650245 58.887728,49.696239 58.840164,49.765229 58.792534,49.903211 58.792534,49.949204 58.732905,49.949204 58.661215,49.926208 58.5294,49.949204 58.517392,49.949204 58.409137,49.328289 58.409137,49.144314 58.385035,49.02933 58.385035,49.052326 58.445259,49.052326 58.5294,49.02933 58.756769,49.052326 58.792534,49.121317 58.792534,49.121317 58.816357,49.006333 58.875843))","code":"kirov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"58","name":"Киров","time_zone":{"name":"Europe/Kirov","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.256387 56.339204,41.279384 56.402883,41.371371 56.402883,41.371371 56.364688,41.394368 56.351948,41.371371 56.300945,41.325378 56.300945,41.256387 56.339204))","code":"kovrov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"129","name":"Ковров","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((74.371882 62.337097,74.394879 62.36911,74.555857 62.36911,74.60185 62.390433,74.716835 62.390433,74.762829 62.411741,74.854816 62.411741,74.831819 62.315736,74.785825 62.251561,74.716835 62.251561,74.60185 62.219423,74.53286 62.165783,74.463869 62.176518,74.417875 62.230139,74.417875 62.305049,74.371882 62.337097))","code":"kogalym","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"207","name":"Когалым","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((67.725786 51.896539,67.863767 52.278064,67.909761 52.334309,67.909761 52.362405,68.001748 52.362405,68.001748 52.404515,68.047742 52.460599,68.001748 52.516612,68.070739 52.558575,68.116733 52.753872,68.13973 52.823409,67.978751 53.059007,68.001748 53.169432,67.955755 53.334539,68.369698 53.430558,68.484683 53.416854,68.50768 53.403146,68.990614 53.320805,69.151592 53.334539,69.197586 53.389434,69.289573 53.389434,69.473548 53.361995,69.634526 53.375717,70.301435 53.238304,70.301435 53.252065,70.370426 53.224539,70.439417 53.224539,70.462414 53.210769,70.646389 53.169432,70.738376 53.155645,72.141185 52.753872,72.279166 52.544592,72.302163 52.530604,72.302163 52.474609,72.072195 52.334309,71.083329 51.782868,71.060332 51.768639,70.899354 51.725925,70.85336 51.740167,70.669385 51.967438,70.646389 51.981605,70.646389 52.009924,70.623392 52.024077,70.41642 52.292132,70.140457 52.628424,69.979479 52.67028,69.634526 52.795608,69.335567 52.920575,69.31257 52.920575,69.266576 52.851193,69.243579 52.7817,69.197586 52.684223,69.105598 52.600498,69.059604 52.572554,68.990614 52.474609,68.94462 52.446585,68.898626 52.362405,68.737648 52.024077,68.737648 51.811313,68.668658 51.768639,68.346701 51.711677,67.84077 51.754405,67.725786 51.896539))","code":"kokshetau","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"201","name":"Кокшетау","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((136.532425 50.703199,136.532425 50.761422,136.601415 50.761422,136.900375 50.717761,137.015359 50.717761,137.08435 50.703199,137.245328 50.717761,137.314318 50.630318,137.314318 50.615729,137.291322 50.542712,137.268325 50.528096,137.268325 50.39634,137.245328 50.29361,137.15334 50.190657,137.061353 50.161201,136.946368 50.175931,136.946368 50.190657,136.78539 50.190657,136.693403 50.220095,136.693403 50.308299,136.762393 50.381678,136.739397 50.484218,136.739397 50.630318,136.693403 50.630318,136.693403 50.659484,136.624412 50.67406,136.601415 50.688632,136.532425 50.703199))","code":"komsomolsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"94","name":"Комсомольск-на-Амуре","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((62.896443 52.878959,62.896443 52.948297,62.91944 52.989846,62.98843 53.031356,63.172405 53.059007,63.402374 53.128056,63.471365 53.141852,63.471365 53.169432,63.494362 53.265822,63.609346 53.307066,63.678337 53.293322,63.793321 53.293322,63.862312 53.196994,64.138274 53.196994,64.207265 53.224539,64.230261 53.183216,64.207265 53.141852,64.115277 53.155645,63.747327 53.183216,63.701333 53.141852,63.540355 53.072825,63.540355 53.031356,63.448368 53.003687,63.379377 53.003687,63.264393 52.934438,63.126412 52.934438,63.080418 52.865079,63.011427 52.865079,62.896443 52.878959))","code":"kostanay","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"203","name":"Костанай","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.681859 57.754885,40.704462 57.8873,40.750456 57.936166,40.911434 57.936166,40.934431 57.923956,41.026418 57.936166,41.1644 57.911742,41.141403 57.801625,41.1644 57.764844,41.210393 57.764844,41.23339 57.752576,41.256387 57.691171,41.256387 57.641971,41.279384 57.641971,41.486356 57.555712,41.60134 57.543373,41.60134 57.493973,41.555346 57.444507,41.486356 57.43213,41.348375 57.357779,41.279384 57.357779,41.210393 57.38258,41.210393 57.407363,41.1644 57.419749,41.1644 57.43213,41.049415 57.469249,41.049415 57.50633,40.980425 57.568048,40.957428 57.605028,40.934431 57.617347,40.888437 57.678877,40.750456 57.678877,40.683624 57.738383,40.684641 57.738608,40.685957 57.740303,40.685957 57.752576,40.684641 57.75427,40.681859 57.754885))","code":"kostroma","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"34","name":"Кострома","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((79.868134 54.002132,79.914128 54.029156,79.937125 54.069659,79.868134 54.137078,79.891131 54.204386,79.914128 54.231279,80.029112 54.258154,80.029112 54.338675,80.075106 54.378876,80.213087 54.378876,80.328071 54.445791,80.397062 54.459161,80.466053 54.445791,80.512046 54.472527,80.512046 54.525945,80.581037 54.539289,80.673024 54.539289,80.673024 54.552628,80.788009 54.565963,80.902993 54.539289,80.92599 54.499245,81.040974 54.432417,80.994981 54.378876,80.971984 54.378876,80.834003 54.35208,80.834003 54.244719,80.742015 54.244719,80.696021 54.204386,80.673024 54.204386,80.673024 54.190933,80.55804 54.177476,80.535043 54.110123,80.374065 54.09664,80.351068 54.069659,80.236084 54.042661,80.19009 54.069659,80.075106 54.056163,80.075106 53.97509,79.937125 53.934494,79.891131 53.934494,79.868134 54.002132))","code":"kotchki","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"183","name":"Кочки","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.565753 44.968984,38.58875 45.115228,38.680737 45.196313,38.657741 45.277282,38.726731 45.325808,38.841716 45.325808,38.933703 45.293462,39.002694 45.293462,39.048687 45.358136,39.163672 45.358136,39.209666 45.325808,39.462631 45.309637,39.623609 45.390445,39.646606 45.438875,39.945565 45.438875,40.014556 45.455009,40.06055 45.390445,40.06055 45.277282,40.12954 45.228714,40.106544 45.212516,40.12954 45.180105,40.106544 45.180105,40.106544 45.115228,39.991559 45.082761,39.784587 45.131454,39.669603 45.147675,39.508625 45.050277,39.485628 45.001515,39.600612 44.920153,39.623609 44.871281,39.554619 44.806053,39.600612 44.740751,39.554619 44.691727,39.485628 44.64266,39.462631 44.593552,39.370644 44.560791,39.370644 44.511614,39.416637 44.511614,39.416637 44.462395,39.301653 44.44598,39.278656 44.42956,39.255659 44.44598,39.094681 44.44598,39.025691 44.396706,38.9567 44.413135,38.9567 44.478806,38.818719 44.511614,38.795722 44.495212,38.680737 44.495212,38.657741 44.511614,38.634744 44.65902,38.657741 44.773411,38.634744 44.887576,38.565753 44.968984))","code":"krasnodar","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"23","name":"Краснодар","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.657013 45.616094,36.657013 45.648256,36.68001 45.696464,37.369916 46.651905,37.369916 46.667688,37.461903 46.730776,37.4849 46.730776,37.622881 46.825269,38.151809 46.85673,38.335784 46.982389,38.634744 46.998076,38.680737 46.903887,38.680737 46.841002,38.749728 46.825269,38.887709 46.825269,38.887709 46.730776,38.864712 46.730776,38.864712 46.604527,38.910706 46.588725,38.933703 46.636117,39.071684 46.620324,39.094681 46.604527,39.186669 46.604527,39.209666 46.651905,39.232662 46.715011,39.255659 46.730776,39.255659 46.778043,39.32465 46.79379,39.485628 46.809532,39.623609 46.79379,40.014556 46.778043,40.083547 46.730776,40.106544 46.730776,40.106544 46.651905,40.083547 46.636117,40.06055 46.588725,40.083547 46.541292,40.198531 46.541292,40.221528 46.525471,40.290518 46.4146,40.267522 46.335269,40.313515 46.303504,40.382506 46.27172,40.727459 46.287614,40.773453 46.22401,40.911434 46.22401,40.934431 46.27172,40.980425 46.27172,40.980425 46.128466,41.072412 46.112526,41.118406 46.04872,41.118406 46.000816,41.1644 45.968857,41.1644 45.88888,41.210393 45.872871,41.256387 45.840838,41.256387 45.760676,41.210393 45.760676,41.1644 45.728579,41.141403 45.680399,41.049415 45.680399,41.003421 45.712524,40.888437 45.696464,40.842443 45.66433,40.842443 45.535609,40.911434 45.519498,40.911434 45.487263,40.658468 45.471138,40.635472 45.487263,40.520487 45.471138,40.49749 45.438875,40.359509 45.438875,40.336512 45.325808,40.382506 45.293462,40.405503 45.244908,40.382506 45.196313,40.12954 45.180105,40.106544 45.212516,40.12954 45.228714,40.06055 45.277282,40.06055 45.390445,40.014556 45.455009,39.945565 45.438875,39.646606 45.438875,39.623609 45.390445,39.462631 45.309637,39.209666 45.325808,39.163672 45.358136,39.048687 45.358136,39.002694 45.293462,38.933703 45.293462,38.841716 45.325808,38.726731 45.325808,38.657741 45.277282,38.519759 45.309637,38.2208 45.309637,38.174806 45.341974,38.036825 45.325808,37.691872 45.341974,37.576888 45.406593,36.726003 45.616094,36.657013 45.616094))","code":"krasnodarskiy_kray","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"283","name":"Краснодарский край","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((78.488322 54.285012,78.488322 54.298434,78.672297 54.285012,78.71829 54.311852,78.787281 54.325266,78.810278 54.338675,78.948259 54.35208,79.109237 54.285012,79.178228 54.271585,79.224222 54.271585,79.247218 54.311852,79.362203 54.325266,79.431193 54.311852,79.431193 54.258154,79.45419 54.244719,79.477187 54.204386,79.891131 54.204386,79.868134 54.137078,79.937125 54.069659,79.914128 54.029156,79.868134 54.002132,79.891131 53.934494,79.868134 53.920953,79.868134 53.826046,79.75315 53.826046,79.638165 53.81247,79.638165 53.771716,79.615168 53.730922,79.477187 53.690089,79.316209 53.703705,79.293212 53.690089,79.224222 53.676469,79.063243 53.690089,79.063243 53.662845,78.902265 53.676469,78.902265 53.662845,78.672297 53.649216,78.672297 53.676469,78.580309 53.798889,78.580309 53.826046,78.557312 53.893859,78.580309 53.907408,78.603306 53.97509,78.557312 54.002132,78.557312 54.069659,78.580309 54.083152,78.6493 54.110123,78.603306 54.204386,78.580309 54.204386,78.488322 54.285012))","code":"krasnozerskoe","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"184","name":"Краснозёрское","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((88.629942 55.436465,88.629942 55.462549,88.698933 55.540699,88.813917 55.579716,88.882907 55.644659,89.15887 55.709493,89.15887 55.722447,89.227861 55.735397,89.342845 55.77422,89.365842 55.877561,89.273854 55.903353,89.250857 56.019206,89.250857 56.070585,89.181867 56.083419,89.181867 56.121896,89.342845 56.173138,89.457829 56.262647,89.52682 56.288183,89.59581 56.288183,89.756789 56.237095,90.009754 56.249873,90.147735 56.339204,90.469692 56.364688,90.584676 56.402883,90.653667 56.402883,90.906632 56.567953,90.99862 56.669178,91.136601 56.795328,91.43556 57.07137,91.504551 57.158773,91.596538 57.345373,91.73452 57.493973,91.73452 57.50633,91.757516 57.50633,91.780513 57.543373,91.895498 57.654277,92.056476 57.728026,92.079473 57.764844,91.964488 57.875073,91.941491 57.948372,91.918494 57.960574,91.849504 58.118823,91.872501 58.215858,91.826507 58.360916,91.918494 58.421182,92.033479 58.50538,92.102469 58.5294,92.217454 58.5294,92.378432 58.421182,92.470419 58.372978,92.677391 58.203743,92.999347 58.155242,93.183322 58.082366,93.252313 58.045872,93.252313 57.984966,93.229316 57.972772,93.252313 57.960574,93.252313 57.8873,93.27531 57.875073,93.321304 57.752576,93.321304 57.678877,93.367297 57.555712,93.321304 57.50633,93.298307 57.50633,93.27531 57.370182,93.298307 57.357779,93.459285 57.258411,93.482282 57.083868,93.413291 57.008812,93.413291 56.95869,93.551272 56.83309,93.64326 56.782732,93.64326 56.757527,93.758244 56.643897,93.804238 56.555281,94.057204 56.415607,94.172188 56.415607,94.195185 56.428326,94.333166 56.428326,95.48301 56.479159,95.804966 56.262647,95.850959 56.211525,95.850959 56.160334,95.597994 56.019206,95.253041 55.954886,95.069066 55.825925,94.74711 55.644659,94.770107 55.566715,94.74711 55.527685,94.563135 55.501644,94.494144 55.436465,94.287172 55.345033,94.287172 55.279595,94.195185 55.25339,94.195185 55.24028,94.172188 55.227167,94.103197 55.161535,94.103197 55.108951,94.057204 55.082633,94.034207 55.003575,93.965216 54.937574,93.827235 54.937574,93.71225 54.844991,93.620263 54.831748,93.620263 54.752195,93.551272 54.738921,93.482282 54.765465,93.482282 54.805248,93.3443 54.831748,93.321304 54.871465,93.229316 54.897922,93.229316 54.977188,93.160326 55.043123,93.137329 55.082633,93.137329 55.200927,92.976351 55.292691,92.838369 55.292691,92.309441 55.108951,91.43556 54.897922,90.952626 54.805248,90.929629 54.8185,90.929629 54.85823,90.860638 54.85823,90.768651 54.911144,90.515685 54.911144,90.515685 55.029945,90.492688 55.069467,90.26272 55.069467,90.239723 55.108951,90.170732 55.148395,90.101742 55.108951,89.940764 55.108951,89.89477 55.082633,89.779785 55.082633,89.710795 55.016762,89.618807 55.016762,89.618807 55.082633,89.549817 55.069467,89.457829 55.069467,89.434832 55.029945,89.296851 55.043123,89.273854 55.082633,89.227861 55.122103,89.089879 55.122103,89.089879 55.1878,89.020889 55.227167,89.020889 55.305783,88.974895 55.345033,88.905904 55.345033,88.859911 55.397306,88.79092 55.397306,88.721929 55.436465,88.629942 55.436465))","code":"krasnoyarsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"7","name":"Красноярск","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((32.172623 45.422736,32.241614 45.535609,32.356598 45.648256,32.402592 45.648256,32.609563 45.74463,32.655557 45.776718,32.724548 45.808787,33.184485 45.920885,33.529438 46.016789,33.575432 46.04872,33.621426 46.144402,33.621426 46.208098,33.828398 46.208098,33.989376 46.128466,34.10436 46.112526,34.196348 46.064678,34.265338 46.04872,34.334329 46.064678,34.403319 46.016789,34.426316 45.968857,34.495307 45.952871,34.564298 45.968857,34.610291 46.000816,34.794266 45.872871,34.794266 45.824815,34.932247 45.760676,35.162216 45.776718,35.185213 45.792755,35.300197 45.792755,35.300197 45.760676,35.323194 45.760676,35.323194 45.728579,35.438179 45.648256,35.507169 45.551715,35.57616 45.535609,35.64515 45.616094,35.783132 45.66433,35.898116 45.66433,35.990104 45.632177,36.289063 45.680399,36.519032 45.66433,36.542028 45.648256,36.657013 45.648256,36.657013 45.616094,36.68001 45.471138,36.68001 45.390445,36.634016 45.325808,36.588022 45.293462,36.588022 45.244908,36.542028 45.212516,36.542028 45.147675,36.565025 45.034027,36.611019 44.920153,36.542028 44.871281,36.450041 44.838676,36.38105 44.838676,36.289063 44.806053,36.059094 44.806053,36.036097 44.789734,35.806129 44.773411,35.64515 44.822367,35.57616 44.773411,35.392185 44.708073,35.369188 44.65902,35.323194 44.64266,35.323194 44.626296,35.162216 44.577174,35.047232 44.560791,35.024235 44.577174,34.863257 44.593552,34.794266 44.577174,34.679282 44.528011,34.564298 44.363834,34.495307 44.347391,34.449313 44.31449,34.334329 44.265106,34.288335 44.23216,34.196348 44.199195,34.081363 44.199195,34.081363 44.182706,33.966379 44.166212,33.851395 44.182706,33.828398 44.166212,33.73641 44.166212,33.552435 44.21568,33.414454 44.265106,33.36846 44.298034,33.276473 44.31449,33.138492 44.44598,33.069501 44.528011,33.069501 44.609926,33.138492 44.724414,33.230479 44.789734,33.230479 44.871281,33.253476 44.920153,33.00051 45.001515,32.816535 45.131454,32.724548 45.098997,32.586567 45.098997,32.310604 45.163892,32.241614 45.228714,32.19562 45.325808,32.172623 45.422736))","code":"crimea","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"174","name":"Крым","time_zone":{"name":"Europe/Simferopol","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.407469 55.540699,77.407469 55.592713,77.430466 55.605706,77.499456 55.696535,77.499456 55.735397,77.54545 55.761284,77.522453 55.877561,77.430466 55.967759,77.430466 56.006351,77.499456 56.019206,77.568447 56.019206,77.637437 56.083419,77.752422 56.096249,77.867406 56.160334,77.867406 56.173138,77.936397 56.185938,78.166365 56.185938,78.235356 56.121896,78.212359 56.057747,78.212359 56.019206,78.258353 55.993491,78.258353 55.967759,78.212359 55.967759,78.028384 55.916243,78.028384 55.877561,78.097375 55.864658,78.212359 55.864658,78.35034 55.890459,78.488322 55.890459,78.488322 55.825925,78.511319 55.813005,78.626303 55.825925,78.695293 55.800081,78.810278 55.787153,78.833275 55.748342,78.902265 55.748342,78.925262 55.787153,78.971256 55.813005,78.994253 55.877561,79.01725 55.916243,79.109237 55.916243,79.109237 56.006351,79.293212 56.109074,79.362203 56.121896,79.408197 56.070585,79.523181 56.109074,79.638165 56.109074,79.684159 56.032057,79.684159 55.967759,79.707156 55.954886,79.684159 55.813005,79.730153 55.787153,79.730153 55.748342,79.615168 55.709493,79.615168 55.670605,79.523181 55.657634,79.500184 55.618695,79.3852 55.540699,79.316209 55.527685,79.270215 55.475585,79.155231 55.475585,79.08624 55.514667,79.01725 55.475585,78.971256 55.397306,78.994253 55.305783,78.925262 55.305783,78.902265 55.345033,78.741287 55.345033,78.695293 55.371178,78.626303 55.423416,78.534315 55.423416,78.442328 55.397306,78.373337 55.410363,78.28135 55.358108,78.120372 55.331954,77.9134 55.345033,77.844409 55.358108,77.821412 55.397306,77.706428 55.423416,77.568447 55.449509,77.54545 55.514667,77.407469 55.540699))","code":"kuibyshev","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"185","name":"Куйбышев","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((55.675425 52.684223,55.744416 52.726026,55.744416 52.767788,55.79041 52.878959,55.8594 52.892836,55.951388 52.892836,55.951388 52.851193,55.882397 52.7817,55.8594 52.712096,55.836403 52.67028,55.675425 52.67028,55.675425 52.684223))","code":"kumertau","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true},"id":"210","name":"Кумертау","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.418603 54.123603,76.418603 54.164014,76.487594 54.177476,76.533588 54.164014,76.648572 54.164014,76.671569 54.150548,76.763556 54.204386,76.80955 54.244719,76.855544 54.325266,76.786553 54.378876,76.80955 54.405655,76.901538 54.419038,76.924534 54.485888,76.993525 54.539289,76.993525 54.579294,77.131506 54.605942,77.108509 54.672486,77.246491 54.71236,77.246491 54.725643,77.361475 54.765465,77.384472 54.77873,77.453462 54.791991,77.522453 54.844991,77.522453 54.871465,77.614441 54.871465,77.614441 54.752195,77.775419 54.672486,77.890403 54.685782,77.936397 54.672486,77.936397 54.605942,78.120372 54.525945,78.097375 54.432417,78.189362 54.378876,78.212359 54.338675,78.120372 54.311852,78.120372 54.258154,78.028384 54.244719,78.028384 54.231279,77.9134 54.217835,77.890403 54.204386,77.798416 54.204386,77.775419 54.217835,77.384472 54.217835,77.384472 54.204386,77.361475 54.204386,77.315481 54.177476,77.292484 54.137078,77.315481 54.123603,77.338478 54.083152,77.315481 54.042661,77.246491 54.042661,77.154503 53.988613,77.085513 53.97509,77.085513 53.94803,77.131506 53.893859,77.108509 53.826046,77.039519 53.730922,76.993525 53.744525,76.579581 53.961562,76.533588 53.97509,76.533588 54.002132,76.510591 54.015646,76.418603 54.123603))","code":"kupino","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"186","name":"Купино","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((65.035152 55.475585,65.058149 55.488617,65.242124 55.527685,65.518086 55.527685,65.633071 55.436465,65.633071 55.423416,65.587077 55.384244,65.610074 55.318871,65.56408 55.24028,65.357108 55.24028,65.242124 55.279595,65.058149 55.358108,65.035152 55.475585))","code":"kurgan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"10","name":"Курган","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.852122 51.554663,35.852122 51.597539,35.875119 51.611822,35.898116 51.797093,35.94411 51.839739,36.059094 51.868148,36.128085 51.882346,36.174079 51.853946,36.335057 51.853946,36.427044 51.825528,36.450041 51.697426,36.427044 51.697426,36.427044 51.611822,36.358053 51.56896,35.967107 51.554663,35.852122 51.554663))","code":"kursk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"73","name":"Курск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((65.334111 44.871281,65.334111 44.936435,65.495089 44.985252,65.610074 44.968984,65.840042 44.740751,65.909033 44.691727,66.024017 44.65902,66.093008 44.609926,66.276983 44.44598,66.529949 44.298034,66.782914 44.21568,66.805911 44.199195,66.805911 44.13321,66.73692 44.116703,66.414964 44.182706,66.36897 44.265106,66.29998 44.281572,66.230989 44.363834,66.116005 44.44598,66.024017 44.44598,65.909033 44.495212,65.633071 44.64266,65.472093 44.740751,65.426099 44.838676,65.403102 44.838676,65.334111 44.871281))","code":"kyzylorda","country_code":"kz","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"240","name":"Кызылорда","time_zone":{"name":"Asia/Qyzylorda","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((69.266576 39.774865,69.289573 39.933752,69.358564 40.021864,69.427554 40.004251,69.450551 39.951384,69.496545 39.986633,69.473548 40.004251,69.519542 40.109862,69.657523 40.145029,69.772507 40.197746,70.025473 40.250422,70.140457 40.197746,70.163454 40.180179,70.324432 40.127448,70.439417 40.074676,70.531404 40.092272,70.577398 40.057077,70.646389 40.109862,70.646389 40.127448,70.738376 40.127448,70.78437 40.180179,70.830364 40.180179,70.968345 40.232868,70.991342 40.285517,71.106326 40.303058,71.15232 40.338125,71.244307 40.338125,71.359292 40.320593,71.428282 40.285517,71.497273 40.285517,71.543267 40.21531,71.612257 40.21531,71.635254 40.267972,71.704245 40.250422,71.704245 40.180179,71.819229 40.197746,71.842226 40.250422,71.980207 40.250422,72.003204 40.303058,72.003204 40.355652,72.164182 40.478212,72.233173 40.478212,72.348157 40.425713,72.417148 40.425713,72.417148 40.548146,72.394151 40.565618,72.440145 40.600548,72.440145 40.565618,72.601123 40.530669,72.624119 40.513188,72.670113 40.548146,72.670113 40.583085,72.739104 40.583085,72.785098 40.670355,72.831091 40.670355,72.992069 40.75751,73.153048 40.75751,73.153048 40.809749,73.176044 40.827152,73.06106 40.844551,72.992069 40.844551,72.946076 40.809749,72.854088 40.844551,72.762101 40.844551,72.601123 40.861946,72.578126 40.931478,72.440145 41.03564,72.302163 41.03564,72.302163 41.018291,72.187179 41.000938,72.187179 41.087659,72.164182 41.139637,72.003204 41.139637,71.88822 41.174266,71.911216 41.3126,71.88822 41.329871,71.796232 41.416158,71.773235 41.433401,71.704245 41.433401,71.58926 41.295324,71.474276 41.295324,71.451279 41.24347,71.451279 41.174266,71.428282 41.122316,71.267304 41.122316,71.267304 41.174266,71.198313 41.191574,71.129323 41.156954,71.014338 41.174266,70.922351 41.174266,70.85336 41.226176,70.78437 41.24347,70.78437 41.39891,70.669385 41.467875,70.646389 41.467875,70.531404 41.416158,70.48541 41.416158,70.324432 41.50233,70.209448 41.50233,70.186451 41.553979,70.209448 41.605586,70.347429 41.639968,70.646389 41.863003,70.646389 41.880127,70.761373 41.931473,70.78437 41.948579,70.830364 41.948579,70.830364 42.05112,70.876357 42.068194,70.945348 42.05112,71.106326 42.136444,71.22131 42.170541,71.198313 42.221653,71.083329 42.272723,71.014338 42.255704,70.991342 42.238681,70.945348 42.238681,70.876357 42.306747,70.876357 42.340753,70.945348 42.391727,70.991342 42.49355,71.060332 42.49355,71.037335 42.5444,71.014338 42.5444,71.014338 42.595208,71.15232 42.595208,71.175317 42.645975,71.267304 42.7136,71.267304 42.764271,71.336295 42.764271,71.428282 42.798028,71.497273 42.798028,71.612257 42.781152,71.704245 42.8149,71.865223 42.831767,72.003204 42.781152,72.049198 42.781152,72.118188 42.747385,72.279166 42.764271,72.348157 42.747385,72.509135 42.679797,72.624119 42.679797,72.716107 42.645975,72.854088 42.561341,72.877085 42.5444,73.084057 42.5444,73.107054 42.527455,73.222038 42.527455,73.291029 42.510505,73.337022 42.425686,73.498001 42.425686,73.498001 42.459627,73.42901 42.5444,73.475004 42.730495,73.520997 42.798028,73.520997 42.916033,73.543994 42.932873,73.566991 43.033813,73.612985 43.033813,73.635982 43.050621,73.704972 43.067423,73.819957 43.117804,73.888947 43.117804,73.957938 43.151368,73.957938 43.201679,74.095919 43.184913,74.16491 43.201679,74.2339 43.251949,74.302891 43.235197,74.463869 43.151368,74.578854 43.134588,74.716835 43.000185,74.854816 43.000185,74.9698 42.949708,75.130778 42.899189,75.130778 42.882341,75.360747 42.848629,75.452735 42.848629,75.475732 42.831767,75.7057 42.8149,75.774691 42.831767,75.797688 42.932873,75.912672 42.949708,76.00466 42.932873,76.027656 42.916033,76.188635 42.932873,76.211631 42.916033,76.280622 42.916033,76.349613 42.865487,76.418603 42.865487,76.533588 42.916033,76.740559 42.916033,76.763556 42.949708,76.993525 42.983364,77.016522 42.966538,77.131506 42.966538,77.246491 42.916033,77.568447 42.932873,77.591444 42.916033,77.660434 42.916033,78.005387 42.865487,78.258353 42.865487,78.511319 42.882341,78.695293 42.8149,78.810278 42.8149,78.902265 42.781152,79.132234 42.781152,79.155231 42.798028,79.178228 42.747385,79.178228 42.679797,79.339206 42.595208,79.408197 42.5444,79.431193 42.5444,79.45419 42.49355,79.546178 42.459627,79.707156 42.476591,79.799143 42.442659,79.937125 42.442659,80.006115 42.357749,80.098103 42.323752,80.167093 42.221653,80.144096 42.136444,80.213087 42.085263,80.213087 42.034041,80.075106 42.034041,80.006115 42.05112,79.983118 42.034041,79.868134 42.034041,79.776146 41.897247,79.661162 41.897247,79.592171 41.845874,79.431193 41.845874,79.316209 41.794459,79.224222 41.725842,79.155231 41.725842,79.132234 41.708677,79.063243 41.691506,79.040247 41.674331,78.971256 41.657152,78.856272 41.571186,78.764284 41.553979,78.695293 41.536767,78.672297 41.485105,78.557312 41.467875,78.534315 41.450641,78.373337 41.39891,78.212359 41.39891,78.143369 41.364399,78.143369 41.278044,78.028384 41.191574,77.936397 41.191574,77.798416 41.122316,77.798416 41.03564,77.660434 41.000938,77.522453 41.000938,77.361475 41.03564,77.338478 41.018291,77.154503 41.018291,77.108509 41.052984,76.970528 41.052984,76.740559 40.931478,76.717563 40.809749,76.648572 40.75751,76.648572 40.670355,76.625575 40.618007,76.556584 40.548146,76.533588 40.530669,76.533588 40.460717,76.418603 40.373174,76.349613 40.373174,76.303619 40.408205,76.234628 40.408205,76.188635 40.373174,76.096647 40.373174,75.935669 40.355652,75.935669 40.320593,75.682703 40.303058,75.682703 40.373174,75.7057 40.460717,75.63671 40.530669,75.613713 40.548146,75.613713 40.65291,75.498728 40.635461,75.245763 40.443217,75.130778 40.460717,75.107782 40.443217,74.9698 40.460717,74.877813 40.513188,74.808822 40.495702,74.808822 40.443217,74.854816 40.408205,74.877813 40.338125,74.716835 40.355652,74.670841 40.285517,74.60185 40.285517,74.555857 40.250422,74.394879 40.109862,74.302891 40.109862,74.2339 40.127448,74.003932 40.074676,73.911944 39.916116,73.911944 39.880831,73.842954 39.827868,73.842954 39.774865,73.934941 39.70413,73.934941 39.597892,73.911944 39.58017,73.865951 39.491491,73.750966 39.455988,73.635982 39.473742,73.566991 39.438229,73.498001 39.455988,73.383016 39.420466,73.360019 39.36715,73.268032 39.36715,73.222038 39.331584,73.107054 39.349369,72.992069 39.331584,72.923079 39.349369,72.854088 39.331584,72.69311 39.36715,72.417148 39.331584,72.348157 39.313794,72.25617 39.17131,72.187179 39.189136,72.164182 39.242588,72.095191 39.242588,72.049198 39.313794,72.026201 39.331584,71.95721 39.2782,71.842226 39.260396,71.773235 39.2782,71.750238 39.331584,71.773235 39.420466,71.704245 39.438229,71.566263 39.438229,71.52027 39.509236,71.543267 39.562443,71.474276 39.597892,71.428282 39.562443,71.359292 39.544712,71.336295 39.509236,71.129323 39.491491,71.083329 39.402699,71.014338 39.384927,70.991342 39.402699,70.807367 39.36715,70.738376 39.420466,70.738376 39.473742,70.646389 39.544712,70.646389 39.562443,70.554401 39.58017,70.531404 39.597892,70.347429 39.544712,70.301435 39.509236,70.232445 39.526976,70.209448 39.544712,70.117461 39.544712,70.094464 39.562443,70.025473 39.544712,69.910489 39.544712,69.841498 39.526976,69.726514 39.58017,69.611529 39.562443,69.473548 39.509236,69.358564 39.526976,69.289573 39.686435,69.31257 39.70413,69.289573 39.721821,69.266576 39.774865))","code":"bishkek","country_code":"kg","domain":"kg","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"112","name":"Кыргызстан","time_zone":{"name":"Asia/Bishkek","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.820685 56.415607,75.820685 56.491856,75.889675 56.517239,75.958666 56.529924,75.981663 56.567953,76.027656 56.631251,76.142641 56.631251,76.165638 56.669178,76.257625 56.694442,76.234628 56.883381,76.165638 56.946149,76.165638 56.98376,76.07365 57.208625,76.07365 57.233526,76.464597 57.221078,76.694566 57.221078,76.878541 57.171243,78.442328 57.171243,78.465325 57.1463,78.442328 57.108853,78.327344 56.95869,78.28135 56.946149,78.28135 56.908501,78.120372 56.870815,78.120372 56.770132,78.074378 56.732306,78.005387 56.744919,77.98239 56.782732,77.936397 56.807919,77.844409 56.757527,77.867406 56.669178,77.798416 56.65654,77.798416 56.567953,77.752422 56.542605,77.706428 56.567953,77.591444 56.567953,77.591444 56.50455,77.476459 56.466457,77.361475 56.402883,77.292484 56.390156,77.246491 56.390156,77.1775 56.351948,77.200497 56.313702,77.223494 56.249873,76.993525 56.224312,76.924534 56.237095,76.786553 56.237095,76.717563 56.275417,76.625575 56.275417,76.533588 56.224312,76.4416 56.224312,76.395606 56.275417,76.326616 56.275417,76.280622 56.224312,76.211631 56.224312,76.142641 56.262647,76.07365 56.262647,76.050653 56.351948,76.050653 56.402883,76.07365 56.44104,75.958666 56.44104,75.889675 56.402883,75.820685 56.415607))","code":"kyshtovka","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"187","name":"Кыштовка","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((27.71123 58.98266,27.71123 59.030028,27.757224 59.053688,27.803217 59.159955,27.872208 59.195305,27.872208 59.230617,27.918202 59.277644,28.07918 59.301133,28.14817 59.312872,28.171167 59.371503,28.14817 59.406634,27.826214 59.570095,27.895205 59.651529,28.010189 59.825367,28.07918 59.848477,28.194164 59.860026,28.631105 59.917711,28.746089 59.917711,28.746089 59.883112,28.769086 59.871571,28.953061 59.639908,29.022052 59.593382,29.045048 59.523473,29.275017 59.476786,29.367005 59.430034,29.435995 59.430034,29.435995 59.418336,29.504986 59.394928,29.734955 59.371503,29.849939 59.312872,29.91893 59.301133,30.079908 59.312872,30.148898 59.336337,30.332873 59.336337,30.424861 59.383218,30.539845 59.383218,30.700823 59.394928,30.769814 59.406634,30.815808 59.465104,30.884798 59.488463,30.999782 59.488463,31.068773 59.546792,31.045776 59.697974,31.09177 59.732766,31.114767 59.825367,31.229751 59.860026,31.206754 59.894649,31.137764 59.894649,31.160761 59.998303,31.367732 60.12455,31.666692 60.477748,31.712685 60.534358,31.919657 60.771044,31.942654 60.782272,31.942654 60.827142,32.103632 60.81593,32.862529 60.692342,32.93152 60.692342,32.954517 60.714848,33.115495 60.726095,33.230479 60.804715,33.207482 60.81593,33.207482 60.849554,33.322466 60.89433,33.437451 60.916694,33.460448 60.950212,33.437451 60.983694,33.483445 61.005996,33.575432 60.994847,33.575432 60.972537,33.713413 60.950212,33.73641 60.939043,33.805401 60.950212,33.874391 61.005996,33.897388 61.061682,33.920385 61.072807,33.920385 61.095046,33.759407 61.11727,33.690416 61.11727,33.644423 61.061682,33.575432 61.061682,33.506441 61.11727,33.483445 61.128376,33.483445 61.16167,33.552435 61.217083,33.759407 61.228154,34.242341 61.239221,34.357326 61.206009,34.403319 61.16167,34.47231 61.16167,34.47231 61.228154,34.587294 61.272399,34.679282 61.272399,34.748272 61.305541,34.932247 61.272399,34.955244 61.261343,35.070229 61.261343,35.139219 61.228154,35.20821 61.250284,35.300197 61.250284,35.323194 61.261343,35.323194 61.272399,35.369188 61.272399,35.369188 61.16167,35.438179 61.150576,35.691144 61.206009,35.714141 61.206009,35.691144 60.994847,35.530166 60.916694,35.507169 60.87195,35.438179 60.860754,35.323194 60.860754,35.231207 60.81593,35.20821 60.782272,35.185213 60.771044,35.20821 60.737338,35.231207 60.726095,35.254204 60.66982,35.277201 60.658553,35.300197 60.534358,35.277201 60.409685,35.277201 60.307322,35.20821 60.27313,35.185213 60.238902,35.185213 60.181776,35.162216 60.147453,35.20821 60.113093,35.20821 60.078698,35.139219 60.044267,35.139219 60.021293,35.254204 60.021293,35.346191 59.975297,35.484172 59.975297,35.484172 59.940758,35.415182 59.894649,35.392185 59.883112,35.392185 59.75594,35.438179 59.709576,35.622154 59.709576,35.622154 59.663146,35.57616 59.628282,35.553163 59.639908,35.507169 59.628282,35.507169 59.570095,35.461176 59.523473,35.392185 59.523473,35.323194 59.511807,35.323194 59.476786,35.369188 59.476786,35.438179 59.406634,35.323194 59.348063,35.323194 59.336337,35.369188 59.324606,35.323194 59.301133,35.231207 59.301133,35.139219 59.254139,35.047232 59.254139,34.932247 59.218851,34.863257 59.20708,34.84026 59.12457,34.771269 59.100959,34.748272 59.089147,34.702279 59.112766,34.564298 59.12457,34.541301 59.136369,34.47231 59.148164,34.357326 59.183526,34.242341 59.195305,34.196348 59.183526,34.081363 59.148164,33.943382 59.183526,33.943382 59.20708,33.828398 59.195305,33.805401 59.20708,33.805401 59.265894,33.621426 59.336337,33.621426 59.383218,33.414454 59.383218,33.345463 59.371503,33.345463 59.324606,33.276473 59.312872,33.207482 59.371503,33.092498 59.383218,33.069501 59.418336,32.977513 59.418336,32.977513 59.394928,32.93152 59.359785,32.862529 59.348063,32.816535 59.324606,32.747545 59.277644,32.770542 59.195305,32.63256 59.112766,32.609563 59.12457,32.494579 59.112766,32.425588 59.12457,32.425588 59.159955,32.333601 59.171743,32.287607 59.230617,32.310604 59.24238,32.287607 59.277644,32.218617 59.289391,32.172623 59.336337,32.103632 59.383218,31.965651 59.418336,31.781676 59.324606,31.689689 59.371503,31.574704 59.371503,31.528711 59.301133,31.574704 59.230617,31.528711 59.20708,31.482717 59.148164,31.482717 59.100959,31.321739 59.018192,31.252748 59.006352,31.183757 59.030028,31.160761 59.077332,31.068773 59.077332,30.999782 59.053688,30.976786 59.018192,30.953789 58.935227,30.769814 58.863954,30.700823 58.852061,30.72382 58.792534,30.677826 58.720967,30.562842 58.720967,30.401864 58.709025,30.378867 58.744839,30.263883 58.744839,30.240886 58.756769,30.125901 58.744839,30.125901 58.685128,30.079908 58.661215,30.102904 58.601361,30.148898 58.5294,30.033914 58.445259,29.895933 58.445259,29.872936 58.433222,29.803945 58.421182,29.711958 58.445259,29.573976 58.46932,29.573976 58.541404,29.527983 58.541404,29.435995 58.57739,29.367005 58.61334,29.25202 58.61334,29.275017 58.649252,29.275017 58.697079,29.206027 58.709025,29.137036 58.709025,29.045048 58.744839,29.045048 58.816357,28.930064 58.804448,28.88407 58.828262,28.746089 58.828262,28.677098 58.863954,28.562114 58.863954,28.44713 58.875843,28.286152 58.852061,28.217161 58.923358,28.125174 58.994508,28.056183 58.994508,28.010189 59.018192,27.895205 59.018192,27.757224 58.98266,27.71123 58.98266))","code":"pikalevo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true},"id":"213","name":"Ленинградская область","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((85.732336 54.445791,85.755333 54.459161,85.755333 54.738921,85.801327 54.765465,86.422242 54.77873,86.491233 54.765465,86.491233 54.459161,86.560223 54.405655,86.491233 54.36548,86.491233 54.204386,86.468236 54.190933,86.353252 54.177476,85.824324 54.177476,85.755333 54.217835,85.755333 54.35208,85.732336 54.445791))","code":"lenkuz","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"86","name":"Ленинск-Кузнецкий","time_zone":{"name":"Asia/Novokuznetsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.32465 52.600498,39.32465 52.64238,39.462631 52.739951,39.646606 52.739951,39.669603 52.726026,39.876575 52.712096,39.876575 52.614463,39.830581 52.614463,39.830581 52.572554,39.899572 52.516612,40.083547 52.516612,40.083547 52.474609,39.968562 52.432566,39.945565 52.432566,39.853578 52.488614,39.6926 52.488614,39.39364 52.432566,39.347647 52.460599,39.370644 52.502615,39.39364 52.516612,39.39364 52.586528,39.32465 52.600498))","code":"lipetsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"56","name":"Липецк","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((150.491526 59.465104,150.491526 59.511807,150.514522 59.511807,150.60651 59.546792,150.60651 59.663146,150.675501 59.709576,150.790485 59.732766,150.905469 59.732766,151.043451 59.709576,151.020454 59.628282,151.043451 59.570095,150.97446 59.465104,150.928466 59.430034,150.767488 59.418336,150.629507 59.441728,150.60651 59.453418,150.491526 59.465104))","code":"magadan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"158","name":"Магадан","time_zone":{"name":"Asia/Magadan","offset":660},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((58.481044 53.334539,58.481044 53.361995,58.527037 53.403146,58.550034 53.907408,58.573031 53.920953,59.262937 53.920953,59.423915 53.907408,59.492906 53.893859,59.492906 53.81247,59.469909 53.252065,59.423915 53.224539,59.400918 53.238304,58.550034 53.238304,58.481044 53.334539))","code":"magnitogorsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"26","name":"Магнитогорск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.255659 44.265106,39.278656 44.347391,39.278656 44.42956,39.301653 44.44598,39.416637 44.462395,39.416637 44.511614,39.370644 44.511614,39.370644 44.560791,39.462631 44.593552,39.485628 44.64266,39.554619 44.691727,39.600612 44.740751,39.554619 44.806053,39.623609 44.871281,39.600612 44.920153,39.485628 45.001515,39.508625 45.050277,39.669603 45.147675,39.784587 45.131454,39.991559 45.082761,40.106544 45.115228,40.244525 45.115228,40.336512 45.050277,40.405503 45.034027,40.520487 44.936435,40.589478 44.854981,40.589478 44.806053,40.635472 44.773411,40.635472 44.724414,40.658468 44.708073,40.819447 44.757084,40.842443 44.773411,40.888437 44.773411,41.072412 44.708073,41.141403 44.64266,41.187396 44.528011,41.187396 44.363834,41.072412 44.330943,41.095409 44.248635,41.1644 44.149714,41.1644 44.116703,41.118406 44.116703,40.911434 44.13321,40.911434 44.083674,40.934431 44.067152,40.911434 43.984475,40.819447 43.918251,40.750456 43.835366,40.750456 43.768976,40.704462 43.735753,40.727459 43.552697,40.658468 43.552697,40.612475 43.586022,40.474493 43.652615,40.451497 43.702512,40.359509 43.768976,40.290518 43.768976,40.221528 43.78558,40.175534 43.868534,40.106544 43.868534,40.037553 43.885111,39.968562 43.934814,39.76159 43.934814,39.715597 43.967926,39.439634 44.116703,39.416637 44.116703,39.255659 44.265106))","code":"maikop","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"131","name":"Майкоп","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((46.660652 42.865487,46.660652 42.916033,46.729642 42.932873,46.775636 43.067423,46.798633 43.067423,46.775636 43.151368,46.867624 43.184913,46.959611 43.184913,47.097592 43.134588,47.097592 43.117804,47.212577 43.117804,47.327561 43.201679,47.350558 43.285439,47.373555 43.469306,47.534533 43.719135,47.580527 43.918251,47.603524 44.00102,47.62652 44.01756,48.155448 44.034095,48.155448 43.918251,48.086458 43.818776,47.902483 43.702512,47.833492 43.502676,47.810495 43.485993,47.833492 43.369084,47.856489 43.352364,47.856489 43.21844,47.833492 43.201679,47.810495 43.117804,47.879486 43.033813,47.92548 43.033813,47.948477 42.966538,47.971473 42.966538,48.017467 42.8149,48.086458 42.764271,48.178445 42.645975,48.178445 42.595208,48.224439 42.561341,48.224439 42.5444,48.247436 42.5444,48.36242 42.442659,48.477405 42.272723,48.523398 42.238681,48.592389 42.136444,48.638383 42.102328,48.638383 42.068194,48.408414 41.982778,48.36242 41.948579,48.247436 41.948579,48.247436 42.016958,48.178445 42.102328,48.109455 42.102328,47.92548 42.272723,47.856489 42.37474,47.833492 42.425686,47.764502 42.5444,47.741505 42.5444,47.672514 42.595208,47.672514 42.645975,47.488539 42.7136,47.327561 42.7136,47.25857 42.696701,47.281567 42.645975,47.350558 42.629058,47.350558 42.578277,47.212577 42.578277,47.097592 42.629058,47.097592 42.645975,47.005605 42.696701,46.867624 42.781152,46.775636 42.848629,46.660652 42.865487))","code":"makhachkala","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"113","name":"Махачкала","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((57.170222 54.844991,57.170222 54.871465,57.216216 54.897922,57.239213 54.963988,57.193219 54.990384,57.193219 55.029945,57.469181 55.108951,57.998109 55.095794,57.998109 55.108951,58.0671 55.108951,58.251075 55.161535,58.297069 55.161535,58.366059 55.135251,58.366059 55.082633,58.412053 55.082633,58.43505 55.016762,58.504041 55.016762,58.527037 55.003575,58.573031 54.963988,58.688015 54.963988,58.803 55.016762,58.803 55.056298,58.780003 55.069467,58.711012 55.135251,58.550034 55.161535,58.527037 55.200927,58.573031 55.24028,58.665019 55.305783,58.780003 55.331954,58.940981 55.331954,58.963978 55.292691,58.986975 55.279595,59.078962 55.292691,59.101959 55.305783,59.262937 55.266495,59.331928 55.266495,59.377922 55.345033,59.377922 55.384244,59.515903 55.436465,59.676881 55.553709,59.791865 55.553709,59.929847 55.670605,60.389784 56.006351,60.550762 56.019206,60.665746 56.032057,60.71174 55.954886,60.803728 55.954886,60.918712 55.929128,60.941709 55.903353,60.826725 55.813005,60.803728 55.77422,60.665746 55.787153,60.619753 55.748342,60.619753 55.657634,60.688743 55.631679,60.688743 55.488617,60.573759 55.345033,60.481771 55.25339,60.458775 55.24028,60.481771 55.148395,60.481771 55.016762,60.458775 54.897922,60.389784 54.884696,60.2748 54.844991,60.251803 54.791991,60.044831 54.645881,59.998837 54.59262,59.998837 54.552628,60.067828 54.472527,60.067828 54.419038,59.97584 54.285012,59.90685 54.271585,59.791865 54.258154,59.423915 54.217835,59.377922 54.217835,59.377922 54.204386,59.308931 54.204386,59.17095 54.110123,58.87199 53.97509,58.87199 53.961562,58.734009 53.94803,58.665019 53.934494,58.642022 53.920953,58.550034 53.920953,58.43505 53.907408,58.274072 53.893859,58.205081 53.907408,58.205081 53.97509,58.251075 54.002132,58.366059 54.015646,58.458047 54.09664,58.504041 54.204386,58.596028 54.405655,58.619025 54.472527,58.642022 54.512597,58.711012 54.685782,58.734009 54.77873,58.688015 54.831748,58.550034 54.8185,58.481044 54.831748,58.320066 54.8185,58.297069 54.831748,58.159087 54.831748,58.113094 54.884696,58.044103 54.897922,57.998109 54.924361,57.929119 54.937574,57.653156 54.937574,57.170222 54.844991))","code":"miass","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"87","name":"Миасс и Златоуст","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((27.067317 53.907408,27.090314 53.97509,27.159305 54.042661,27.251292 54.069659,27.389274 54.069659,27.642239 54.056163,27.757224 54.069659,27.78022 54.056163,27.895205 54.029156,27.987192 54.029156,27.987192 53.988613,28.010189 53.94803,28.07918 53.907408,28.07918 53.853184,28.056183 53.853184,27.872208 53.826046,27.849211 53.81247,27.71123 53.771716,27.642239 53.730922,27.550252 53.730922,27.527255 53.717316,27.366277 53.690089,27.297286 53.717316,27.320283 53.81247,27.251292 53.826046,27.113311 53.880305,27.067317 53.907408))","code":"minsk","country_code":"by","domain":"by","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"217","name":"Минск","time_zone":{"name":"Europe/Minsk","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.382506 52.989846,40.451497 53.003687,40.520487 53.003687,40.589478 52.920575,40.589478 52.865079,40.451497 52.837304,40.405503 52.851193,40.382506 52.989846))","code":"michurinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"245","name":"Мичуринск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.726003 55.135251,36.794994 55.200927,36.817991 55.200927,36.978969 55.266495,36.978969 55.305783,36.932975 55.331954,36.886982 55.384244,36.794994 55.397306,36.817991 55.514667,36.794994 55.527685,36.771997 55.566715,36.794994 55.605706,36.771997 55.670605,36.771997 55.916243,36.794994 55.954886,36.749 56.057747,36.771997 56.147525,36.886982 56.198733,36.955972 56.211525,36.978969 56.249873,37.093953 56.262647,37.162944 56.198733,37.622881 56.224312,37.645878 56.237095,37.85285 56.224312,38.059822 56.237095,38.312788 56.224312,38.335784 56.237095,38.496763 56.237095,38.496763 56.249873,38.58875 56.249873,38.634744 56.224312,38.841716 56.224312,38.933703 56.313702,39.002694 56.313702,39.048687 56.249873,39.163672 56.185938,39.186669 56.147525,39.117678 56.096249,39.140675 55.980627,39.117678 55.967759,39.140675 55.851751,39.094681 55.825925,39.071684 55.761284,39.048687 55.761284,39.048687 55.683572,39.163672 55.644659,39.163672 55.579716,39.117678 55.553709,39.117678 55.475585,39.163672 55.436465,39.140675 55.397306,39.163672 55.331954,39.094681 55.266495,39.117678 55.095794,39.094681 55.095794,39.071684 55.029945,39.002694 55.016762,39.002694 54.977188,38.9567 54.977188,38.818719 55.029945,38.680737 55.029945,38.657741 54.990384,38.611747 54.990384,38.519759 55.043123,38.450769 55.043123,38.358781 55.003575,38.289791 55.016762,38.082819 55.016762,37.990831 55.043123,37.829853 55.029945,37.737866 55.003575,37.622881 55.016762,37.576888 54.990384,37.507897 54.990384,37.41591 54.963988,37.254931 54.977188,37.231935 55.003575,37.162944 55.003575,37.139947 55.016762,36.955972 55.082633,36.886982 55.069467,36.749 55.069467,36.726003 55.135251))","code":"moscow","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"32","name":"Москва","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":20,"min":9}},{"bounds":"MULTIPOLYGON(((35.162216 55.954886,35.162216 55.980627,35.323194 56.070585,35.323194 56.109074,35.300197 56.109074,35.300197 56.134713,35.323194 56.147525,35.323194 56.160334,35.346191 56.173138,35.346191 56.198733,35.323194 56.198733,35.323194 56.224312,35.392185 56.237095,35.484172 56.249873,35.484172 56.390156,35.438179 56.390156,35.438179 56.428326,35.57616 56.453751,35.599157 56.466457,35.668147 56.453751,35.783132 56.390156,35.94411 56.377424,36.059094 56.377424,36.082091 56.364688,36.151082 56.402883,36.289063 56.428326,36.31206 56.44104,36.427044 56.466457,36.450041 56.479159,36.542028 56.479159,36.611019 56.517239,36.657013 56.517239,36.817991 56.580621,36.886982 56.580621,37.024963 56.542605,37.093953 56.542605,37.139947 56.580621,37.139947 56.643897,37.162944 56.681812,37.093953 56.744919,37.093953 56.770132,37.208938 56.770132,37.277928 56.757527,37.392913 56.795328,37.530894 56.820507,37.553891 56.845669,37.530894 56.908501,37.714869 56.95869,37.829853 56.908501,37.921841 56.883381,37.967834 56.883381,37.990831 56.820507,37.990831 56.782732,38.082819 56.757527,38.197803 56.770132,38.243797 56.770132,38.312788 56.757527,38.312788 56.669178,38.335784 56.669178,38.335784 56.555281,38.289791 56.542605,38.335784 56.466457,38.381778 56.466457,38.427772 56.377424,38.427772 56.275417,38.496763 56.262647,38.496763 56.237095,38.335784 56.237095,38.312788 56.224312,38.059822 56.237095,37.85285 56.224312,37.645878 56.237095,37.622881 56.224312,37.162944 56.198733,37.093953 56.262647,36.978969 56.249873,36.955972 56.211525,36.886982 56.198733,36.771997 56.147525,36.749 56.057747,36.794994 55.954886,36.771997 55.916243,36.771997 55.670605,36.794994 55.605706,36.771997 55.566715,36.794994 55.527685,36.817991 55.514667,36.794994 55.397306,36.886982 55.384244,36.932975 55.331954,36.978969 55.305783,36.978969 55.266495,36.817991 55.200927,36.794994 55.200927,36.794994 55.227167,36.771997 55.266495,36.703007 55.266495,36.634016 55.279595,36.611019 55.318871,36.588022 55.331954,36.542028 55.305783,36.473038 55.305783,36.404047 55.292691,36.38105 55.279595,36.31206 55.200927,36.266066 55.17467,36.243069 55.1878,36.128085 55.1878,36.105088 55.200927,35.921113 55.24028,35.852122 55.24028,35.760135 55.279595,35.599157 55.292691,35.507169 55.24028,35.415182 55.24028,35.323194 55.266495,35.323194 55.292691,35.277201 55.318871,35.300197 55.358108,35.300197 55.436465,35.323194 55.449509,35.323194 55.553709,35.300197 55.553709,35.323194 55.566715,35.323194 55.579716,35.392185 55.592713,35.369188 55.644659,35.346191 55.657634,35.346191 55.709493,35.323194 55.709493,35.323194 55.787153,35.300197 55.800081,35.254204 55.851751,35.231207 55.864658,35.162216 55.954886)),((37.162944 55.003575,37.231935 55.003575,37.254931 54.977188,37.41591 54.963988,37.507897 54.990384,37.576888 54.990384,37.622881 55.016762,37.737866 55.003575,37.829853 55.029945,37.990831 55.043123,38.082819 55.016762,38.289791 55.016762,38.358781 55.003575,38.450769 55.043123,38.519759 55.043123,38.611747 54.990384,38.657741 54.990384,38.680737 55.029945,38.818719 55.029945,38.9567 54.977188,39.002694 54.977188,39.002694 55.016762,39.071684 55.029945,39.094681 55.095794,39.117678 55.095794,39.094681 55.266495,39.163672 55.331954,39.140675 55.397306,39.163672 55.436465,39.117678 55.475585,39.117678 55.553709,39.163672 55.579716,39.163672 55.644659,39.048687 55.683572,39.048687 55.761284,39.071684 55.761284,39.094681 55.825925,39.140675 55.851751,39.209666 55.83884,39.301653 55.851751,39.301653 55.800081,39.370644 55.77422,39.462631 55.77422,39.508625 55.748342,39.554619 55.787153,39.669603 55.800081,39.784587 55.83884,39.876575 55.83884,39.899572 55.800081,39.899572 55.748342,40.014556 55.683572,40.083547 55.605706,40.06055 55.540699,40.083547 55.527685,40.152537 55.527685,40.198531 55.488617,40.152537 55.436465,40.198531 55.358108,40.198531 55.345033,40.152537 55.266495,40.083547 55.25339,40.014556 55.214049,39.807584 55.200927,39.784587 55.161535,39.853578 55.095794,39.830581 55.029945,39.76159 55.016762,39.738594 55.003575,39.646606 55.016762,39.508625 54.963988,39.462631 54.897922,39.485628 54.897922,39.416637 54.85823,39.347647 54.77873,39.347647 54.738921,39.232662 54.725643,39.232662 54.645881,39.117678 54.645881,38.979697 54.619259,38.864712 54.619259,38.795722 54.512597,38.795722 54.459161,38.841716 54.459161,38.933703 54.432417,38.910706 54.392268,38.818719 54.378876,38.703734 54.338675,38.703734 54.258154,38.657741 54.258154,38.634744 54.271585,38.519759 54.298434,38.519759 54.36548,38.404775 54.472527,38.404775 54.525945,38.473766 54.565963,38.496763 54.605942,38.450769 54.645881,38.381778 54.645881,38.174806 54.699073,38.036825 54.71236,38.036825 54.752195,38.013828 54.765465,37.967834 54.844991,37.898844 54.844991,37.78386 54.831748,37.760863 54.738921,37.714869 54.725643,37.599885 54.738921,37.530894 54.77873,37.438906 54.844991,37.254931 54.831748,37.254931 54.844991,37.185941 54.85823,37.162944 55.003575)))","code":"moscow_region","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"241","name":"Московская область","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((28.424133 68.529187,28.424133 68.562831,28.44713 68.571235,28.51612 68.613204,28.539117 68.646724,28.585111 68.663465,28.654102 68.721959,28.677098 68.721959,28.746089 68.81357,28.769086 68.863381,28.677098 68.87996,28.470127 68.87996,28.424133 68.904805,28.424133 68.921353,28.654102 68.979173,28.769086 69.02038,28.861073 69.045067,28.930064 69.05329,28.999055 69.05329,29.068045 69.028612,29.091042 69.05329,29.229023 69.118962,29.229023 69.151725,29.275017 69.184438,29.275017 69.225261,29.298014 69.233416,29.275017 69.241568,29.25202 69.266007,29.275017 69.306676,29.344008 69.314801,29.367005 69.322923,29.435995 69.331042,29.573976 69.331042,29.688961 69.37969,29.734955 69.395881,29.849939 69.428228,29.964923 69.420146,29.98792 69.412061,30.056911 69.452457,30.102904 69.484719,30.102904 69.516932,30.171895 69.557131,30.125901 69.613282,30.125901 69.637302,30.056911 69.645302,30.079908 69.669286,30.148898 69.677274,30.286879 69.6533,30.470854 69.581214,30.562842 69.549097,30.861801 69.54106,30.930792 69.581214,30.930792 69.629298,30.884798 69.701222,30.861801 69.709198,30.861801 69.73311,30.792811 69.788798,30.930792 69.876012,30.953789 69.907637,30.999782 69.923431,31.068773 69.978618,31.183757 70.017949,31.229751 70.025806,31.551707 70.112039,31.666692 70.135495,31.82767 70.158924,32.080635 70.158924,32.19562 70.151118,32.448585 70.112039,32.471582 70.104214,32.908523 69.994359,33.023507 69.970743,33.115495 69.970743,33.345463 69.931324,33.506441 69.89183,33.552435 69.876012,33.713413 69.76495,33.73641 69.709198,33.713413 69.68526,33.782404 69.629298,33.874391 69.60527,34.035369 69.597254,34.173351 69.597254,34.380323 69.581214,34.403319 69.573189,34.518304 69.557131,34.771269 69.500831,34.932247 69.460527,35.323194 69.460527,35.57616 69.436307,35.599157 69.428228,35.691144 69.428228,35.990104 69.403973,36.197075 69.371589,36.220072 69.363486,36.38105 69.314801,36.565025 69.282284,36.588022 69.274147,36.886982 69.200776,36.978969 69.168087,37.093953 69.143539,37.369916 69.045067,37.438906 69.028612,37.507897 69.02038,37.806856 68.962668,37.898844 68.929622,38.105816 68.863381,38.243797 68.81357,38.358781 68.730303,38.404775 68.713612,38.473766 68.663465,38.58875 68.621589,38.634744 68.596426,38.9567 68.546015,39.186669 68.48706,39.186669 68.478625,39.76159 68.385634,40.888437 68.546015,41.187396 68.588032,41.210393 68.588032,41.210393 68.596426,41.302381 68.596426,41.371371 68.520768,41.417365 68.444855,41.463359 68.394104,41.647334 68.15576,41.670331 68.130075,41.716324 68.070033,42.452224 67.069893,42.498218 66.989121,42.314243 66.862941,42.199259 66.826769,42.153265 66.808663,41.555346 66.608616,41.210393 66.480466,41.210393 66.471287,40.727459 66.296246,40.566481 66.231448,40.221528 66.110666,39.715597 65.90495,39.439634 65.867368,39.278656 65.839146,39.232662 65.839146,39.232662 65.829732,39.163672 65.829732,39.140675 65.820314,38.910706 65.79204,38.634744 65.744847,38.381778 65.707031,38.312788 65.697568,37.875847 65.707031,37.85285 65.71649,37.139947 65.744847,37.070956 65.754293,36.771997 65.763735,36.082091 65.79204,36.0131 65.79204,35.921113 65.829732,35.875119 65.829732,35.806129 65.857964,35.369188 65.998663,35.323194 66.008016,35.323194 66.017365,35.254204 66.036052,35.070229 66.092033,35.047232 66.101352,34.84026 66.157189,34.633288 66.222177,34.610291 66.231448,33.989376 66.40694,33.644423 66.489641,33.621426 66.498813,33.506441 66.507982,33.230479 66.553775,33.138492 66.553775,32.93152 66.581211,32.63256 66.581211,32.56357 66.572069,32.540573 66.507982,32.517576 66.480466,32.448585 66.480466,32.356598 66.462105,32.356598 66.351654,32.287607 66.342428,32.126629 66.351654,31.965651 66.351654,31.850667 66.360877,31.804673 66.397734,31.804673 66.462105,31.758679 66.498813,31.689689 66.498813,31.620698 66.507982,31.597701 66.562924,31.574704 66.645109,31.505714 66.654224,30.976786 66.663335,30.447858 66.654224,29.91893 66.663335,29.321011 66.663335,29.25202 66.690649,29.160033 66.76334,29.114039 66.772412,29.068045 66.844861,29.045048 66.853903,28.999055 66.935124,29.022052 66.944131,29.045048 67.007094,29.068045 67.016075,29.275017 67.13253,29.298014 67.16825,29.344008 67.186091,29.412998 67.230633,29.435995 67.239532,29.435995 67.248427,29.458992 67.248427,29.481989 67.292855,29.61997 67.354915,29.642967 67.381463,29.688961 67.399146,29.803945 67.478555,29.91893 67.531347,29.941926 67.57525,29.941926 67.601554,29.98792 67.636579,29.98792 67.671552,29.61997 67.810928,29.481989 67.932203,29.458992 67.958109,29.435995 67.958109,29.435995 67.983985,29.390001 68.00122,29.321011 68.061442,29.206027 68.087204,29.022052 68.121507,28.999055 68.130075,28.953061 68.130075,28.930064 68.13864,28.861073 68.147202,28.677098 68.181416,28.631105 68.198504,28.470127 68.436404,28.424133 68.529187))","code":"murmansk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"96","name":"Мурманская область","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.946293 55.514667,41.946293 55.631679,41.992287 55.631679,42.061278 55.618695,42.084274 55.553709,42.084274 55.501644,42.015284 55.501644,41.946293 55.514667))","code":"murom","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"132","name":"Муром","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((51.030057 55.266495,51.076051 55.292691,51.122045 55.371178,51.214032 55.371178,51.214032 55.397306,51.168039 55.436465,51.283023 55.475585,51.421004 55.462549,51.535989 55.501644,51.581982 55.527685,51.558985 55.540699,51.558985 55.592713,51.489995 55.605706,51.489995 55.644659,51.444001 55.683572,51.466998 55.722447,51.466998 55.942009,51.535989 55.954886,51.650973 55.967759,51.696967 55.942009,51.765957 55.954886,51.765957 55.929128,51.926935 55.942009,51.949932 55.980627,52.018923 55.980627,52.064917 55.942009,52.087913 55.903353,52.156904 55.903353,52.225895 55.967759,52.202898 56.019206,52.294885 56.070585,52.40987 56.019206,52.47886 56.032057,52.455863 56.057747,52.501857 56.070585,52.547851 56.044904,52.685832 56.006351,52.685832 55.954886,52.800816 55.942009,52.938798 55.929128,52.984791 55.903353,52.984791 55.890459,53.076779 55.851751,53.237757 55.864658,53.306748 55.864658,53.421732 55.851751,53.421732 55.813005,53.375738 55.813005,53.375738 55.761284,53.444729 55.748342,53.467726 55.696535,53.513719 55.696535,53.513719 55.644659,53.375738 55.566715,53.375738 55.527685,53.421732 55.488617,53.490723 55.475585,53.490723 55.436465,53.421732 55.436465,53.329744 55.410363,53.191763 55.462549,53.14577 55.462549,53.122773 55.423416,53.053782 55.423416,52.984791 55.436465,52.984791 55.475585,52.892804 55.488617,52.869807 55.501644,52.800816 55.501644,52.754823 55.475585,52.639838 55.423416,52.501857 55.423416,52.386873 55.384244,52.363876 55.292691,52.386873 55.25339,52.40987 55.25339,52.386873 55.108951,52.386873 55.082633,52.317882 55.082633,52.248892 55.043123,52.179901 55.056298,52.179901 55.095794,52.133907 55.095794,52.064917 55.056298,51.972929 55.056298,51.880942 55.082633,51.857945 55.043123,51.788954 55.056298,51.696967 55.095794,51.696967 55.161535,51.719963 55.200927,51.650973 55.200927,51.581982 55.135251,51.466998 55.135251,51.466998 55.17467,51.535989 55.1878,51.535989 55.25339,51.421004 55.266495,51.329017 55.266495,51.30602 55.25339,51.122045 55.24028,51.030057 55.266495))","code":"nabchelny","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"29","name":"Набережные Челны","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.705918 43.268696,44.774908 43.268696,44.866896 43.235197,44.866896 43.184913,44.820902 43.151368,44.774908 43.151368,44.705918 43.268696))","code":"nazran","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"154","name":"Назрань","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((42.406231 43.251949,42.406231 43.419216,42.452224 43.452614,42.475221 43.569362,42.475221 43.635974,42.521215 43.635974,42.659196 43.685884,42.682193 43.735753,42.659196 43.818776,42.843171 43.80218,42.866168 43.851952,42.981152 43.901683,43.119134 43.901683,43.142131 43.951372,43.234118 43.951372,43.303109 43.835366,43.326105 43.818776,43.395096 43.835366,43.44109 43.868534,43.602068 43.851952,43.625065 43.835366,43.602068 43.78558,43.602068 43.685884,43.717052 43.635974,43.717052 43.586022,43.970018 43.435917,44.062005 43.369084,44.062005 43.318911,44.085002 43.302177,44.062005 43.235197,44.016012 43.235197,43.970018 43.268696,43.87803 43.268696,43.80904 43.302177,43.740049 43.201679,43.717052 43.117804,43.694055 43.117804,43.671059 43.101015,43.579071 42.949708,43.464087 42.966538,43.418093 42.949708,43.418093 42.899189,43.372099 42.899189,43.257115 42.916033,43.027146 43.033813,43.027146 43.101015,42.935159 43.134588,42.889165 43.168143,42.728187 43.184913,42.682193 43.151368,42.567209 43.168143,42.406231 43.251949))","code":"nalchik","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"134","name":"Нальчик","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((52.915801 67.619073,52.915801 67.662814,52.984791 67.671552,53.007788 67.680288,53.122773 67.697748,53.191763 67.68902,53.168766 67.627827,53.053782 67.601554,52.915801 67.619073))","code":"naryanmar","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"159","name":"Нарьян-Мар","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((132.553966 42.8149,132.553966 42.865487,132.622957 42.949708,132.829928 42.949708,133.128888 42.966538,133.243872 42.916033,133.243872 42.7136,133.220875 42.662889,132.783935 42.662889,132.553966 42.8149))","code":"nahodka","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"82","name":"Находка","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.785315 44.64266,41.808312 44.708073,41.877303 44.724414,42.038281 44.675376,42.038281 44.626296,42.015284 44.577174,41.831309 44.577174,41.785315 44.64266))","code":"nevinnomyssk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"135","name":"Невинномысск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.038791 61.19493,75.038791 61.250284,75.061788 61.305541,75.084785 61.316581,75.245763 61.305541,75.291757 61.261343,75.521725 61.250284,75.567719 61.272399,75.659706 61.272399,75.682703 61.261343,75.774691 61.228154,76.142641 61.239221,76.257625 61.183847,76.993525 61.183847,77.108509 61.172761,77.131506 61.16167,77.292484 61.172761,77.315481 61.16167,77.54545 61.139478,77.614441 61.11727,77.867406 61.10616,77.9134 61.095046,77.890403 61.017141,77.844409 60.81593,77.844409 60.782272,77.821412 60.771044,77.821412 60.737338,77.637437 60.613447,77.384472 60.60216,77.315481 60.613447,77.154503 60.692342,77.016522 60.692342,76.947531 60.714848,76.878541 60.748578,76.80955 60.759813,76.740559 60.81593,76.671569 60.81593,76.602578 60.87195,76.533588 60.87195,76.464597 60.860754,75.912672 60.860754,75.521725 60.961376,75.245763 61.050552,75.061788 61.139478,75.038791 61.19493))","code":"nizhnevartovsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"12","name":"Нижневартовск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((42.636199 56.185938,42.774181 56.262647,42.843171 56.275417,42.866168 56.288183,43.119134 56.300945,43.234118 56.300945,43.257115 56.339204,43.234118 56.479159,43.257115 56.517239,43.280112 56.580621,43.234118 56.631251,43.07314 56.6186,43.07314 56.669178,43.142131 56.681812,43.211121 56.744919,43.257115 56.744919,43.280112 56.807919,43.280112 56.820507,43.303109 56.83309,43.395096 56.83309,43.395096 56.732306,43.464087 56.719689,43.487084 56.681812,43.579071 56.6186,43.671059 56.6186,43.740049 56.555281,43.901027 56.567953,43.947021 56.517239,44.016012 56.517239,44.107999 56.491856,44.222983 56.491856,44.291974 56.479159,44.291974 56.390156,44.268977 56.377424,44.291974 56.262647,44.314971 56.198733,44.54494 56.147525,44.889893 56.160334,44.958883 56.160334,45.119861 56.109074,45.119861 56.019206,45.073868 55.980627,44.958883 55.980627,44.843899 55.967759,44.820902 55.980627,44.498946 55.980627,44.337968 56.044904,44.268977 56.057747,44.17699 56.057747,44.107999 56.032057,44.107999 55.967759,44.062005 55.890459,44.062005 55.735397,44.016012 55.631679,44.016012 55.540699,43.993015 55.475585,44.016012 55.436465,43.993015 55.371178,43.901027 55.305783,43.832037 55.305783,43.694055 55.371178,43.717052 55.475585,43.671059 55.527685,43.694055 55.527685,43.694055 55.566715,43.579071 55.579716,43.579071 55.605706,43.533077 55.631679,43.533077 55.696535,43.602068 55.748342,43.464087 55.825925,43.418093 56.006351,43.303109 56.032057,43.257115 56.185938,43.280112 56.198733,43.303109 56.275417,43.142131 56.275417,42.981152 56.249873,42.912162 56.237095,42.889165 56.198733,42.866168 56.185938,42.70519 56.185938,42.682193 56.173138,42.636199 56.185938))","code":"n_novgorod","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"19","name":"Нижний Новгород","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((58.642022 58.009341,58.848994 57.997155,58.87199 57.997155,58.940981 57.984966,59.055965 57.972772,59.469909 57.911742,59.745872 57.911742,59.768868 57.948372,59.768868 58.009341,59.791865 58.094522,60.113822 58.082366,60.182812 58.070205,60.251803 58.082366,60.320793 58.070205,60.34379 58.021522,60.412781 58.021522,60.527765 58.082366,60.596756 58.082366,60.619753 58.045872,60.527765 57.948372,60.458775 57.911742,60.389784 57.8873,60.320793 57.8873,60.251803 57.801625,60.228806 57.70346,60.159815 57.691171,60.021834 57.691171,59.699878 57.617347,59.584893 57.580379,59.400918 57.531029,59.308931 57.518682,59.308931 57.50633,59.262937 57.50633,59.23994 57.493973,59.078962 57.469249,59.078962 57.419749,59.009972 57.419749,58.986975 57.45688,58.963978 57.469249,58.87199 57.493973,58.87199 57.50633,58.803 57.50633,58.757006 57.543373,58.803 57.617347,58.780003 57.641971,58.711012 57.654277,58.711012 57.666579,58.848994 57.740303,58.848994 57.838368,58.757006 57.850607,58.688015 57.911742,58.665019 57.923956,58.642022 58.009341))","code":"ntagil","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"45","name":"Нижний Тагил","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((86.468236 53.97509,86.491233 54.015646,86.491233 54.069659,86.652211 54.110123,86.675208 54.123603,87.227133 54.123603,87.388111 54.190933,87.411108 54.204386,87.434105 54.204386,87.480098 54.231279,87.503095 54.271585,87.848048 54.231279,87.894042 54.204386,87.940036 54.204386,87.963033 54.190933,88.170004 54.110123,88.284989 54.069659,88.307986 54.069659,88.307986 54.056163,88.514958 53.988613,88.537954 53.97509,88.974895 53.81247,88.997892 53.744525,89.020889 53.744525,89.020889 53.703705,89.043886 53.635583,88.951898 53.608304,88.882907 53.608304,88.859911 53.594658,88.813917 53.581007,88.675936 53.512687,88.514958 53.416854,88.376976 53.403146,88.307986 53.389434,88.284989 53.389434,87.917039 53.34827,87.848048 53.334539,87.641076 53.320805,87.595083 53.416854,87.480098 53.49901,86.58322 53.49901,86.51423 53.512687,86.51423 53.920953,86.468236 53.97509))","code":"novokuznetsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"6","name":"Новокузнецк","time_zone":{"name":"Asia/Novokuznetsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.542028 45.147675,36.542028 45.212516,36.588022 45.244908,36.588022 45.293462,36.634016 45.325808,36.68001 45.390445,36.68001 45.471138,36.657013 45.616094,36.726003 45.616094,37.576888 45.406593,37.691872 45.341974,38.036825 45.325808,38.174806 45.341974,38.2208 45.309637,38.519759 45.309637,38.657741 45.277282,38.680737 45.196313,38.58875 45.115228,38.565753 44.968984,38.634744 44.887576,38.657741 44.773411,38.634744 44.65902,38.657741 44.511614,38.680737 44.495212,38.680737 44.44598,38.634744 44.380272,38.611747 44.330943,38.496763 44.149714,38.335784 44.166212,38.266794 44.182706,38.013828 44.265106,37.944838 44.347391,37.85285 44.396706,37.737866 44.44598,37.714869 44.462395,37.553891 44.462395,37.254931 44.560791,37.139947 44.64266,37.024963 44.822367,36.978969 44.854981,36.817991 44.903867,36.726003 44.903867,36.611019 44.920153,36.565025 45.034027,36.542028 45.147675))","code":"novorossiysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"74","name":"Новороссийск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((80.948987 54.378876,80.994981 54.405655,81.017977 54.445791,81.224949 54.459161,81.270943 54.432417,81.339934 54.445791,81.546906 54.525945,81.523909 54.605942,81.592899 54.619259,81.707884 54.632572,81.684887 54.685782,81.66189 54.699073,81.546906 54.791991,81.523909 54.8185,81.569902 54.871465,81.454918 54.937574,81.385927 54.937574,81.362931 54.977188,81.408924 55.003575,81.454918 55.056298,81.431921 55.122103,81.454918 55.135251,81.454918 55.279595,81.385927 55.292691,81.385927 55.331954,81.500912 55.371178,81.546906 55.397306,81.868862 55.449509,82.075834 55.501644,82.121827 55.501644,82.121827 55.540699,82.02984 55.644659,81.937852 55.77422,81.799871 55.929128,81.776874 55.967759,81.753877 55.967759,81.753877 56.006351,81.569902 56.224312,81.569902 56.237095,81.592899 56.249873,81.868862 56.300945,82.144824 56.326455,82.282805 56.351948,82.351796 56.351948,82.420787 56.390156,82.489777 56.402883,82.742743 56.415607,82.811733 56.428326,82.811733 56.517239,82.880724 56.529924,83.041702 56.529924,83.110693 56.542605,83.271671 56.453751,83.271671 56.415607,83.156687 56.351948,83.13369 56.262647,83.087696 56.237095,83.087696 56.224312,83.20268 56.211525,83.179683 56.147525,83.156687 56.134713,83.156687 56.109074,83.248674 56.109074,83.271671 56.096249,83.248674 56.032057,83.317665 55.980627,83.386655 55.916243,83.386655 55.877561,83.294668 55.813005,83.225677 55.748342,83.248674 55.709493,83.409652 55.709493,83.593627 55.683572,83.616624 55.696535,83.662618 55.735397,83.662618 55.77422,83.731608 55.787153,83.754605 55.83884,83.915583 55.980627,83.984574 56.019206,84.145552 56.032057,84.168549 56.044904,84.237539 56.044904,84.329527 55.993491,84.375521 55.993491,84.398518 56.032057,84.467508 56.044904,84.536499 56.006351,84.513502 55.916243,84.490505 55.903353,84.490505 55.864658,84.536499 55.864658,84.559496 55.825925,84.605489 55.77422,84.536499 55.735397,84.605489 55.696535,84.67448 55.683572,84.697477 55.670605,84.789464 55.553709,84.743471 55.514667,84.743471 55.449509,84.67448 55.423416,84.651483 55.410363,84.67448 55.371178,84.812461 55.371178,84.904449 55.345033,84.904449 55.279595,84.881452 55.279595,84.858455 55.214049,84.927446 55.161535,84.927446 55.095794,84.858455 55.003575,84.881452 54.963988,84.996436 54.937574,84.996436 54.897922,85.065427 54.85823,85.065427 54.8185,84.950442 54.765465,84.927446 54.752195,84.927446 54.71236,84.996436 54.672486,84.996436 54.632572,84.950442 54.605942,84.973439 54.552628,84.996436 54.539289,85.088424 54.459161,85.111421 54.445791,85.065427 54.419038,84.881452 54.35208,84.858455 54.338675,84.766468 54.338675,84.628486 54.258154,84.582493 54.217835,84.582493 54.204386,84.490505 54.150548,84.375521 54.164014,84.191546 54.177476,84.007571 54.123603,83.984574 54.110123,83.915583 54.09664,83.846593 54.123603,83.777602 54.110123,83.57063 54.110123,83.478643 54.069659,83.478643 54.002132,83.409652 53.934494,83.340661 53.94803,83.317665 54.056163,83.20268 54.056163,82.76574 53.798889,82.742743 53.744525,82.650755 53.690089,82.650755 53.635583,82.535771 53.553692,82.558768 53.512687,82.535771 53.49901,82.420787 53.49901,82.420787 53.512687,82.351796 53.512687,82.328799 53.553692,82.190818 53.608304,82.167821 53.662845,82.075834 53.662845,81.937852 53.717316,81.822868 53.703705,81.753877 53.771716,81.753877 53.826046,81.845865 53.880305,81.845865 53.920953,81.822868 53.961562,81.638893 53.97509,81.592899 53.920953,81.546906 53.934494,81.592899 54.015646,81.546906 54.029156,81.477915 54.069659,81.29394 54.069659,81.247946 54.09664,81.132962 54.123603,81.086968 54.204386,81.063971 54.204386,81.063971 54.217835,81.017977 54.258154,80.994981 54.271585,80.971984 54.338675,80.948987 54.378876))","code":"novosibirsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"1","name":"Новосибирск","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.991559 47.373176,39.991559 47.388747,40.014556 47.404314,40.037553 47.482081,40.083547 47.544211,40.106544 47.559732,40.175534 47.544211,40.152537 47.435435,40.198531 47.435435,40.267522 47.419877,40.152537 47.326433,40.014556 47.326433,40.014556 47.357599,39.991559 47.373176))","code":"novocherkassk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"137","name":"Новочеркасск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.784587 47.776545,39.807584 47.791997,39.853578 47.884613,39.922569 47.884613,39.945565 47.869189,39.991559 47.822887,40.014556 47.71469,39.968562 47.71469,39.807584 47.730161,39.784587 47.776545))","code":"novoshakhtinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"138","name":"Новошахтинск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.372609 66.092033,76.533588 66.157189,76.533588 66.166483,76.556584 66.175774,76.671569 66.185062,76.694566 66.175774,76.901538 66.185062,76.993525 66.185062,77.062516 66.13859,77.062516 66.110666,77.131506 66.064058,77.246491 66.036052,77.522453 66.036052,77.54545 66.045391,77.683431 66.092033,77.752422 66.092033,77.798416 66.073387,77.867406 66.082712,78.097375 66.129286,78.212359 66.13859,78.327344 66.092033,78.327344 66.073387,78.442328 65.998663,78.488322 65.979948,78.488322 65.970585,78.327344 65.867368,78.304347 65.857964,78.28135 65.829732,78.258353 65.829732,78.258353 65.810893,78.235356 65.801468,78.212359 65.773173,78.143369 65.735398,78.051381 65.725946,78.028384 65.697568,77.959394 65.688102,77.890403 65.659683,77.798416 65.659683,77.775419 65.650203,77.660434 65.640719,77.568447 65.678633,77.453462 65.707031,77.223494 65.801468,77.154503 65.801468,76.947531 65.79204,76.740559 65.820314,76.717563 65.829732,76.694566 65.829732,76.602578 65.886166,76.602578 65.89556,76.533588 65.90495,76.533588 65.914337,76.510591 65.914337,76.464597 65.9331,76.418603 66.02671,76.372609 66.092033))","code":"n_urengoy","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"139","name":"Новый Уренгой","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((85.686342 69.233416,85.732336 69.282284,85.985302 69.371589,85.985302 69.756994,86.008299 69.780852,88.124011 69.756994,88.307986 69.756994,88.698933 69.749036,88.859911 69.749036,91.757516 69.717172,92.424426 69.709198,92.470419 69.701222,92.355435 68.937888,92.309441 68.929622,88.514958 68.937888,88.445967 68.929622,88.42297 68.904805,88.353979 68.805258,88.330983 68.763647,88.307986 68.755316,88.307986 68.721959,88.284989 68.713612,88.261992 68.67183,87.963033 68.241169,87.894042 68.13864,87.894042 68.130075,87.871045 68.121507,87.848048 68.061442,87.802055 68.035652,86.58322 68.044252,86.58322 68.052849,86.51423 68.112936,86.445239 68.112936,86.445239 68.130075,86.58322 68.232642,86.560223 68.266729,86.284261 68.351725,86.261264 68.40257,86.238267 68.411033,86.307258 68.554425,86.284261 68.604817,86.21527 68.663465,85.962305 68.738644,85.893314 68.780301,85.824324 68.83849,85.824324 68.91308,85.916311 68.970922,85.985302 68.995665,86.054292 69.05329,86.054292 69.110764,86.008299 69.13535,85.939308 69.143539,85.824324 69.168087,85.686342 69.208941,85.686342 69.233416))","code":"norilsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"76","name":"Норильск","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((74.302891 63.662768,74.302891 63.845822,74.325888 63.876216,76.188635 63.876216,76.257625 63.866088,76.257625 63.662768,76.234628 63.303421,76.280622 63.28275,76.487594 63.272409,76.533588 63.272409,76.832547 63.262064,77.085513 63.251716,77.108509 63.241364,77.1775 63.096044,77.062516 62.970904,77.039519 62.970904,77.016522 62.981353,76.855544 62.991798,76.717563 63.023111,76.648572 63.033541,76.533588 63.002239,76.487594 62.981353,76.464597 62.981353,76.418603 62.960451,76.326616 62.960451,76.257625 63.023111,74.394879 63.023111,74.325888 63.033541,74.325888 63.303421,74.302891 63.662768))","code":"noyabrsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"103","name":"Ноябрьск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((65.150136 62.00429,65.150136 62.047438,65.334111 62.1443,65.403102 62.176518,65.495089 62.294359,65.748055 62.294359,65.817046 62.283666,65.794049 62.262267,65.771052 62.18725,65.886036 62.112047,65.886036 62.090526,65.863039 62.07976,65.886036 62.00429,65.863039 61.971888,65.656067 61.971888,65.56408 61.993493,65.219127 61.993493,65.150136 62.00429))","code":"nyagan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true},"id":"202","name":"Нягань","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((70.370426 57.345373,70.393423 57.407363,70.577398 57.45688,70.600395 57.493973,70.646389 57.493973,70.646389 57.50633,70.669385 57.50633,70.692382 57.518682,70.692382 57.555712,70.646389 57.580379,70.577398 57.605028,70.577398 57.666579,70.554401 57.70346,70.508407 57.728026,70.48541 57.764844,70.41642 57.777108,70.41642 57.875073,70.370426 57.899523,70.370426 57.936166,70.439417 57.948372,70.531404 58.106675,70.554401 58.118823,70.623392 58.203743,70.646389 58.215858,70.646389 58.252179,70.669385 58.264277,70.692382 58.31263,70.715379 58.31263,70.78437 58.457292,70.807367 58.46932,70.85336 58.5294,70.968345 58.517392,70.991342 58.50538,71.060332 58.50538,71.106326 58.46932,71.106326 58.445259,71.175317 58.433222,71.290301 58.397088,71.290301 58.348851,71.244307 58.324707,71.22131 58.264277,71.22131 58.106675,71.198313 58.094522,71.22131 58.058041,71.382288 58.070205,71.497273 58.070205,71.88822 58.106675,72.049198 58.106675,72.164182 58.021522,72.233173 58.009341,72.440145 58.009341,72.831091 57.997155,73.084057 58.130967,73.153048 58.155242,73.498001 58.143106,74.003932 58.143106,74.210904 58.130967,74.371882 58.203743,74.53286 58.264277,74.647844 58.300548,74.670841 58.348851,74.808822 58.409137,74.923807 58.433222,74.946803 58.493364,75.107782 58.565399,75.130778 58.565399,75.291757 58.50538,75.33775 58.46932,75.33775 58.433222,75.291757 58.433222,75.084785 58.348851,75.084785 58.324707,75.199769 58.240076,75.222766 58.203743,75.222766 58.179501,75.107782 58.143106,75.107782 58.094522,75.222766 58.070205,75.314753 58.021522,75.383744 58.009341,75.429738 57.984966,75.567719 57.936166,75.567719 57.70346,75.544722 57.666579,75.567719 57.629661,75.682703 57.629661,75.728697 57.592706,75.751694 57.531029,75.774691 57.50633,75.820685 57.407363,75.866678 57.38258,75.958666 57.394973,76.00466 57.357779,76.00466 57.332962,76.096647 57.233526,76.119644 57.1463,76.188635 56.98376,76.188635 56.946149,76.257625 56.883381,76.280622 56.694442,76.119644 56.6186,76.050653 56.6186,76.00466 56.555281,75.981663 56.542605,75.958666 56.50455,75.866678 56.50455,75.843681 56.466457,75.843681 56.415607,75.912672 56.428326,75.958666 56.453751,76.096647 56.453751,76.07365 56.364688,76.07365 56.313702,76.096647 56.275417,76.211631 56.262647,76.234628 56.224312,76.303619 56.160334,76.165638 56.134713,76.050653 56.147525,76.00466 56.147525,76.00466 56.121896,75.889675 56.121896,75.774691 56.109074,75.659706 56.044904,75.521725 56.019206,75.521725 55.980627,75.406741 55.929128,75.314753 55.903353,75.291757 55.83884,75.360747 55.787153,75.360747 55.748342,75.291757 55.735397,75.199769 55.735397,75.130778 55.748342,75.107782 55.735397,75.130778 55.670605,75.222766 55.657634,75.222766 55.618695,75.176772 55.592713,75.199769 55.553709,75.314753 55.553709,75.314753 55.501644,75.199769 55.462549,75.153775 55.384244,75.130778 55.384244,75.199769 55.318871,75.199769 55.279595,75.26876 55.24028,75.26876 55.200927,75.291757 55.1878,75.26876 55.17467,75.291757 55.108951,75.314753 55.095794,75.383744 55.043123,75.360747 54.897922,75.429738 54.897922,75.498728 54.911144,75.498728 54.831748,75.63671 54.805248,75.682703 54.725643,75.682703 54.685782,75.751694 54.685782,75.751694 54.699073,75.843681 54.645881,75.820685 54.565963,75.751694 54.539289,75.682703 54.539289,75.682703 54.137078,75.659706 54.110123,75.521725 54.110123,75.498728 54.09664,75.406741 54.083152,75.429738 53.988613,75.383744 53.961562,75.199769 53.866747,75.107782 53.81247,75.038791 53.798889,74.992797 53.826046,74.90081 53.826046,74.785825 53.81247,74.785825 53.758122,74.739832 53.758122,74.670841 53.744525,74.647844 53.676469,74.463869 53.676469,74.440872 53.635583,74.463869 53.540028,74.440872 53.52636,74.417875 53.471642,74.325888 53.471642,74.279894 53.540028,74.256897 53.581007,74.187907 53.594658,74.141913 53.567352,74.072922 53.567352,74.072922 53.594658,74.049926 53.635583,73.934941 53.649216,73.842954 53.594658,73.727969 53.608304,73.658979 53.594658,73.589988 53.52636,73.452007 53.444257,73.383016 53.457952,73.383016 53.52636,73.268032 53.567352,73.268032 53.649216,73.337022 53.703705,73.360019 53.717316,73.360019 53.771716,73.42901 53.785305,73.452007 53.866747,73.612985 53.866747,73.635982 53.853184,73.704972 53.866747,73.750966 54.002132,73.773963 54.015646,73.727969 54.056163,73.658979 54.056163,73.635982 54.015646,73.589988 54.015646,73.520997 54.002132,73.520997 53.94803,73.452007 53.961562,73.291029 53.94803,73.199041 53.97509,73.084057 53.97509,73.038063 54.042661,72.992069 54.042661,72.969073 54.09664,72.877085 54.09664,72.785098 54.123603,72.624119 54.123603,72.555129 54.110123,72.555129 54.042661,72.647116 54.042661,72.716107 54.002132,72.69311 53.961562,72.555129 53.97509,72.532132 53.934494,72.463141 53.920953,72.394151 53.934494,72.417148 54.015646,72.394151 54.110123,72.440145 54.110123,72.486138 54.137078,72.417148 54.150548,72.394151 54.164014,72.32516 54.177476,72.32516 54.204386,72.302163 54.311852,72.210176 54.35208,72.049198 54.36548,72.072195 54.325266,72.141185 54.285012,72.118188 54.244719,72.118188 54.204386,72.164182 54.204386,72.210176 54.177476,72.210176 54.137078,72.141185 54.137078,72.095191 54.164014,72.072195 54.204386,72.049198 54.204386,72.026201 54.217835,71.95721 54.231279,71.750238 54.244719,71.750238 54.137078,71.681248 54.09664,71.52027 54.110123,71.497273 54.123603,71.474276 54.164014,71.290301 54.177476,71.22131 54.110123,71.15232 54.110123,71.129323 54.150548,71.106326 54.164014,71.083329 54.204386,71.083329 54.258154,71.014338 54.271585,70.991342 54.311852,71.037335 54.338675,71.175317 54.311852,71.22131 54.36548,71.198313 54.459161,71.175317 54.459161,71.175317 54.579294,71.290301 54.619259,71.290301 54.645881,71.22131 54.699073,71.129323 54.699073,71.060332 54.765465,71.014338 54.844991,70.968345 54.871465,70.991342 54.911144,71.014338 54.977188,71.014338 55.069467,70.991342 55.108951,70.922351 55.122103,70.899354 55.1878,70.85336 55.214049,70.807367 55.292691,70.692382 55.292691,70.646389 55.266495,70.646389 55.25339,70.48541 55.266495,70.48541 55.318871,70.462414 55.410363,70.48541 55.423416,70.554401 55.488617,70.646389 55.501644,70.715379 55.540699,70.738376 55.579716,70.761373 55.592713,70.761373 55.618695,70.646389 55.618695,70.577398 55.631679,70.531404 55.683572,70.531404 55.722447,70.577398 55.748342,70.577398 55.800081,70.715379 55.800081,70.78437 55.83884,70.761373 55.851751,70.646389 55.83884,70.623392 55.825925,70.48541 55.851751,70.48541 55.890459,70.554401 55.903353,70.577398 55.916243,70.646389 55.929128,70.646389 55.942009,70.715379 55.954886,70.738376 55.993491,70.738376 56.032057,70.807367 56.044904,70.830364 56.006351,70.830364 55.980627,70.876357 55.980627,70.899354 56.096249,70.899354 56.134713,70.830364 56.147525,70.830364 56.198733,70.761373 56.237095,70.761373 56.262647,70.876357 56.300945,70.922351 56.300945,70.922351 56.377424,70.85336 56.402883,70.830364 56.390156,70.78437 56.390156,70.78437 56.453751,70.968345 56.453751,71.083329 56.517239,71.106326 56.605944,71.014338 56.669178,71.083329 56.681812,71.175317 56.643897,71.290301 56.643897,71.359292 56.631251,71.405285 56.681812,71.543267 56.669178,71.612257 56.757527,71.658251 56.757527,71.658251 56.858244,71.58926 56.946149,71.336295 57.07137,71.290301 57.096363,71.267304 57.1463,71.198313 57.183708,71.106326 57.208625,71.060332 57.332962,71.037335 57.345373,70.968345 57.370182,70.876357 57.357779,70.807367 57.370182,70.78437 57.357779,70.738376 57.308129,70.761373 57.245971,70.738376 57.233526,70.715379 57.196169,70.646389 57.196169,70.646389 57.208625,70.623392 57.208625,70.623392 57.233526,70.600395 57.270846,70.439417 57.283278,70.370426 57.345373))","code":"omsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"2","name":"Омск","time_zone":{"name":"Asia/Omsk","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((54.801544 51.325308,54.870535 51.397106,54.916529 51.483114,54.916529 51.711677,54.847538 51.725925,54.870535 51.853946,54.985519 51.939092,55.077507 51.953267,55.1235 51.924912,55.330472 51.924912,55.42246 51.896539,55.514447 51.839739,55.514447 51.782868,55.606435 51.725925,55.583438 51.668909,55.537444 51.668909,55.49145 51.611822,55.514447 51.526057,55.49145 51.511747,55.42246 51.425793,55.238485 51.310935,55.1235 51.138109,55.100504 51.123677,54.985519 51.109241,54.893532 51.152536,54.801544 51.325308))","code":"orenburg","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"48","name":"Оренбург","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((58.343062 51.109241,58.366059 51.123677,58.343062 51.152536,58.412053 51.19579,58.389056 51.239003,58.343062 51.26779,58.343062 51.325308,58.734009 51.325308,58.87199 51.253399,58.87199 51.239003,58.940981 51.239003,59.009972 51.224603,59.009972 51.152536,59.078962 51.094801,59.055965 51.02253,58.986975 51.008062,58.87199 51.02253,58.87199 51.036993,58.803 51.036993,58.642022 51.02253,58.527037 51.080355,58.366059 51.065906,58.366059 51.094801,58.343062 51.109241))","code":"orsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"142","name":"Орск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.852122 52.865079,35.852122 52.920575,35.875119 53.072825,35.967107 53.100449,36.266066 53.08664,36.31206 53.072825,36.31206 53.017524,36.335057 52.948297,36.289063 52.892836,36.289063 52.823409,36.174079 52.837304,35.990104 52.837304,35.852122 52.865079))","code":"orel","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"71","name":"Орёл","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.625575 52.16536,76.648572 52.249915,76.671569 52.404515,76.717563 52.446585,76.993525 52.474609,77.223494 52.446585,77.223494 52.207657,77.246491 52.024077,77.1775 52.009924,76.947531 51.981605,76.901538 52.009924,76.832547 52.009924,76.763556 52.024077,76.671569 52.16536,76.625575 52.16536))","code":"pavlodar","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"111","name":"Павлодар","time_zone":{"name":"Asia/Qyzylorda","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.728915 53.155645,44.774908 53.169432,44.774908 53.252065,44.797905 53.265822,44.820902 53.334539,45.027874 53.375717,45.073868 53.34827,45.28084 53.34827,45.34983 53.334539,45.34983 53.238304,45.395824 53.155645,45.372827 53.059007,45.303836 53.017524,45.142858 53.031356,45.119861 53.059007,45.027874 53.059007,45.004877 53.045183,44.797905 53.059007,44.728915 53.155645))","code":"penza","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"42","name":"Пенза","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((53.812679 56.782732,53.812679 56.807919,53.881669 56.807919,53.95066 56.744919,54.042647 56.744919,54.088641 56.795328,54.088641 56.870815,54.157632 56.908501,54.157632 56.95869,54.203626 56.98376,54.364604 56.971227,54.410597 57.008812,54.410597 57.046359,54.31861 57.096363,54.341607 57.133822,54.31861 57.270846,54.295613 57.308129,54.180629 57.308129,54.134635 57.345373,54.157632 57.394973,54.226622 57.407363,54.272616 57.444507,54.226622 57.469249,54.180629 57.469249,54.180629 57.50633,54.157632 57.50633,54.157632 57.531029,54.088641 57.531029,53.996654 57.580379,54.088641 57.605028,54.065644 57.666579,54.134635 57.715745,54.157632 57.777108,54.134635 57.813876,54.111638 57.948372,54.134635 57.960574,54.433594 57.960574,54.479588 58.009341,54.594572 58.021522,54.68656 58.009341,54.801544 58.021522,54.893532 58.070205,55.031513 58.045872,55.077507 58.070205,55.077507 58.118823,55.05451 58.118823,55.077507 58.155242,55.192491 58.179501,55.192491 58.252179,55.169494 58.264277,55.238485 58.324707,55.307475 58.360916,55.376466 58.360916,55.445457 58.397088,55.514447 58.385035,55.560441 58.336781,55.721419 58.324707,55.836403 58.300548,55.882397 58.276371,55.951388 58.288462,55.974385 58.324707,56.043375 58.336781,56.135363 58.385035,56.15836 58.421182,56.089369 58.457292,56.089369 58.601361,56.204353 58.709025,56.22735 58.720967,56.296341 58.852061,56.296341 58.911485,56.250347 58.958951,56.250347 59.006352,56.181357 59.04186,56.204353 59.12457,56.22735 59.136369,56.204353 59.218851,56.365331 59.301133,56.434322 59.324606,56.457319 59.336337,56.457319 59.383218,56.342335 59.394928,56.365331 59.430034,56.411325 59.453418,56.52631 59.581741,56.664291 59.605019,56.641294 59.639908,56.5953 59.663146,56.5953 59.686369,56.664291 59.744355,56.756278 59.744355,56.779275 59.732766,56.871263 59.616653,56.940253 59.605019,56.986247 59.558445,57.216216 59.488463,57.354197 59.394928,57.515175 59.265894,57.722147 59.159955,57.745144 59.053688,57.676153 58.970808,57.676153 58.852061,57.630159 58.780616,57.653156 58.744839,57.929119 58.565399,57.952116 58.070205,57.538172 57.850607,57.538172 57.826124,57.653156 57.813876,57.676153 57.801625,57.791138 57.789369,57.837131 57.740303,57.883125 57.740303,57.883125 57.715745,58.0671 57.691171,58.113094 57.678877,58.113094 57.605028,58.021106 57.592706,58.021106 57.555712,57.975112 57.531029,57.975112 57.50633,57.998109 57.493973,57.975112 57.357779,57.952116 57.320548,58.021106 57.283278,58.021106 57.183708,58.044103 57.171243,58.0671 57.108853,58.044103 57.046359,57.952116 57.07137,57.860128 57.021332,57.745144 56.946149,57.676153 56.946149,57.676153 56.921055,57.561169 56.895943,57.469181 56.908501,57.446184 56.946149,57.377194 56.946149,57.262209 56.895943,57.262209 56.858244,57.285206 56.795328,57.3312 56.770132,57.3312 56.694442,57.423188 56.669178,57.377194 56.6186,57.400191 56.593285,57.354197 56.453751,57.3312 56.390156,57.400191 56.364688,57.400191 56.326455,57.308203 56.313702,57.285206 56.275417,57.216216 56.262647,57.216216 56.198733,57.170222 56.160334,57.101231 56.160334,57.078235 56.147525,56.940253 56.109074,56.871263 56.121896,56.871263 56.160334,56.779275 56.173138,56.756278 56.224312,56.664291 56.249873,56.52631 56.313702,56.52631 56.351948,56.549306 56.364688,56.52631 56.390156,56.480316 56.377424,56.411325 56.390156,56.273344 56.313702,56.181357 56.313702,56.112366 56.300945,56.043375 56.313702,56.020378 56.351948,55.974385 56.351948,55.928391 56.44104,55.813407 56.428326,55.744416 56.44104,55.652428 56.402883,55.629432 56.390156,55.537444 56.390156,55.468454 56.326455,55.399463 56.326455,55.376466 56.313702,55.284479 56.326455,55.238485 56.351948,55.169494 56.326455,55.146497 56.339204,54.985519 56.339204,54.847538 56.415607,54.709557 56.44104,54.68656 56.491856,54.571576 56.529924,54.479588 56.428326,54.479588 56.402883,54.433594 56.402883,54.226622 56.466457,54.203626 56.479159,54.180629 56.517239,54.111638 56.555281,54.065644 56.593285,54.065644 56.631251,53.996654 56.6186,53.996654 56.605944,53.881669 56.593285,53.835676 56.6186,53.881669 56.669178,53.858673 56.757527,53.812679 56.782732))","code":"perm","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"16","name":"Пермь","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((32.862529 61.863633,32.885526 62.06899,32.908523 62.090526,33.00051 62.101288,33.253476 62.090526,33.483445 62.036657,33.782404 62.025872,33.989376 62.015083,34.058366 62.047438,34.081363 62.101288,34.403319 62.155043,35.20821 62.155043,35.323194 62.122802,35.392185 62.101288,35.461176 61.982692,35.415182 61.809361,35.392185 61.798496,35.323194 61.798496,35.323194 61.787626,35.300197 61.787626,35.093226 61.754994,34.702279 61.689626,34.610291 61.689626,34.173351 61.70053,34.10436 61.711431,34.10436 61.831082,33.920385 61.863633,33.897388 61.874476,33.713413 61.885314,33.66742 61.863633,33.414454 61.874476,33.345463 61.863633,33.276473 61.831082,33.161488 61.841936,33.092498 61.831082,32.93152 61.831082,32.862529 61.863633))","code":"petrozavodsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"80","name":"Петрозаводск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((68.116733 54.950783,68.13973 54.963988,68.20872 54.963988,68.231717 55.029945,68.300708 55.069467,68.20872 55.122103,68.20872 55.161535,68.231717 55.200927,68.346701 55.1878,68.369698 55.200927,68.530676 55.200927,68.645661 55.214049,68.645661 55.24028,68.714651 55.318871,68.714651 55.358108,68.783642 55.371178,68.898626 55.331954,68.967617 55.318871,69.013611 55.318871,68.990614 55.358108,68.921623 55.371178,68.921623 55.423416,69.105598 55.423416,69.220583 55.331954,69.289573 55.331954,69.381561 55.384244,69.450551 55.345033,69.749511 55.345033,69.772507 55.331954,69.841498 55.318871,69.956482 55.214049,70.071467 55.200927,70.163454 55.161535,70.278439 55.161535,70.48541 55.279595,70.48541 55.266495,70.646389 55.25339,70.646389 55.266495,70.715379 55.292691,70.807367 55.292691,70.876357 55.1878,70.899354 55.17467,70.945348 55.108951,70.991342 55.108951,71.014338 55.043123,71.014338 54.977188,70.991342 54.911144,70.968345 54.871465,70.646389 54.844991,70.347429 54.8185,69.703517 54.791991,69.657523 54.71236,69.473548 54.499245,69.358564 54.485888,69.197586 54.485888,68.875629 54.579294,68.691654 54.605942,68.461686 54.725643,68.461686 54.791991,68.277711 54.85823,68.116733 54.950783))","code":"petropavlovsk","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"170","name":"Петропавловск","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((156.907653 53.059007,156.93065 53.072825,157.045634 53.169432,157.114625 53.169432,157.183615 53.196994,157.206612 53.252065,157.2986 53.320805,157.459578 53.334539,157.459578 53.375717,157.528568 53.416854,157.643553 53.403146,157.73554 53.403146,158.241471 53.361995,158.402449 53.375717,158.793396 53.361995,158.954374 53.320805,158.954374 53.307066,159.023365 53.265822,159.138349 53.128056,159.161346 53.114255,159.299327 52.948297,159.092355 52.823409,159.023365 52.739951,158.954374 52.712096,158.954374 52.64238,158.931377 52.628424,158.90838 52.572554,158.885384 52.558575,158.885384 52.488614,158.90838 52.474609,158.862387 52.446585,158.563427 52.432566,158.494437 52.432566,158.310462 52.376446,158.264468 52.348359,158.149484 52.348359,158.080493 52.376446,157.321596 52.64238,156.93065 52.962151,156.907653 53.059007))","code":"p_kamchatskiy","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"95","name":"Петропавловск-Камчатский","time_zone":{"name":"Asia/Kamchatka","offset":720},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((27.550252 57.826124,27.596246 57.850607,27.895205 57.850607,27.941199 57.875073,28.14817 57.911742,28.332145 57.8873,28.424133 57.8873,28.493124 57.862842,28.493124 57.777108,28.470127 57.740303,28.309149 57.70346,28.171167 57.715745,28.125174 57.740303,28.056183 57.752576,28.010189 57.728026,27.872208 57.70346,27.803217 57.740303,27.688233 57.752576,27.550252 57.826124))","code":"pskov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"90","name":"Псков","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((83.93858 51.094801,83.961577 51.138109,84.076561 51.152536,84.099558 51.094801,84.145552 51.123677,84.168549 51.19579,84.191546 51.210199,84.214543 51.26779,84.329527 51.282176,84.398518 51.26779,84.536499 51.339677,84.628486 51.339677,84.697477 51.411452,84.766468 51.425793,84.835458 51.425793,84.904449 51.44013,84.973439 51.511747,85.134417 51.511747,85.157414 51.497433,85.272399 51.511747,85.272399 51.540363,85.433377 51.56896,85.479371 51.626101,85.479371 51.68317,85.594355 51.711677,85.617352 51.754405,85.617352 51.797093,85.548361 51.839739,85.594355 51.882346,85.594355 51.910728,85.548361 51.910728,85.571358 51.967438,85.594355 51.981605,85.686342 52.052369,85.709339 52.094774,85.77833 52.1089,85.916311 52.123022,85.939308 52.094774,86.100286 52.080644,86.21527 52.024077,86.238267 52.038225,86.399245 52.038225,86.445239 52.080644,86.445239 52.123022,86.629214 52.1089,86.790192 52.16536,86.790192 52.193563,86.744198 52.193563,86.767195 52.278064,86.698205 52.320254,86.652211 52.376446,86.675208 52.474609,86.652211 52.488614,86.652211 52.516612,86.767195 52.516612,86.790192 52.558575,86.813189 52.628424,86.905177 52.628424,86.905177 52.64238,87.020161 52.656332,87.135145 52.614463,87.181139 52.586528,87.31912 52.586528,87.388111 52.516612,87.411108 52.502615,87.61808 52.460599,87.641076 52.432566,87.779058 52.488614,87.848048 52.502615,87.894042 52.530604,88.032023 52.516612,88.193001 52.418543,88.284989 52.418543,88.307986 52.432566,88.307986 52.446585,88.42297 52.446585,88.445967 52.404515,88.445967 52.334309,88.399973 52.306195,88.376976 52.207657,88.376976 52.16536,88.353979 52.1089,88.307986 52.1089,88.215998 52.052369,88.147008 52.080644,88.078017 52.038225,88.078017 51.995766,88.009026 51.953267,87.963033 51.882346,87.940036 51.868148,87.894042 51.811313,87.986029 51.754405,88.078017 51.754405,88.101014 51.711677,88.009026 51.640375,87.986029 51.56896,87.940036 51.56896,87.940036 51.483114,88.009026 51.46879,88.078017 51.46879,88.101014 51.454462,88.170004 51.354041,88.284989 51.354041,88.307986 51.339677,88.42297 51.296558,88.537954 51.310935,88.698933 51.411452,88.675936 51.526057,88.813917 51.554663,88.836914 51.497433,88.997892 51.397106,88.974895 51.210199,89.043886 51.152536,89.043886 51.065906,89.204864 50.964632,89.273854 50.906663,89.388839 50.834099,89.641804 50.615729,89.641804 50.586536,89.802782 50.542712,89.825779 50.542712,89.848776 50.469583,89.825779 50.425651,89.710795 50.39634,89.687798 50.381678,89.618807 50.381678,89.572814 50.440299,89.503823 50.440299,89.480826 50.35234,89.411836 50.337664,89.365842 50.264217,89.342845 50.249514,89.342845 50.190657,89.503823 50.205378,89.52682 50.161201,89.52682 50.116983,89.572814 50.087482,89.52682 50.043196,89.59581 49.984084,89.641804 49.910093,89.664801 49.910093,89.641804 49.865643,89.687798 49.791469,89.733792 49.761768,89.733792 49.717182,89.618807 49.672555,89.503823 49.65767,89.388839 49.583177,89.296851 49.583177,89.227861 49.627886,89.204864 49.612988,89.250857 49.553349,89.135873 49.478697,88.974895 49.448804,88.905904 49.493636,88.882907 49.448804,88.813917 49.433851,88.79092 49.448804,88.698933 49.448804,88.606945 49.478697,88.445967 49.463753,88.42297 49.478697,88.353979 49.463753,88.238995 49.463753,88.170004 49.388964,88.193001 49.284068,88.032023 49.209006,87.963033 49.163914,87.802055 49.163914,87.802055 49.148874,87.733064 49.163914,87.664073 49.133829,87.526092 49.11878,87.503095 49.073606,87.411108 49.058539,87.388111 49.073606,87.31912 49.088669,87.296123 49.103727,87.296123 49.239044,87.181139 49.254057,87.066155 49.254057,86.95117 49.314061,86.95117 49.403931,86.836186 49.448804,86.836186 49.538427,86.744198 49.568265,86.675208 49.568265,86.606217 49.583177,86.629214 49.627886,86.698205 49.687435,86.767195 49.687435,86.767195 49.791469,86.698205 49.806313,86.629214 49.806313,86.606217 49.761768,86.537227 49.717182,86.51423 49.672555,86.399245 49.598085,86.330255 49.598085,86.261264 49.583177,86.261264 49.538427,86.21527 49.478697,86.14628 49.523501,86.077289 49.523501,86.054292 49.508571,85.962305 49.493636,85.916311 49.568265,85.824324 49.553349,85.801327 49.568265,85.663345 49.568265,85.617352 49.598085,85.502367 49.598085,85.433377 49.612988,85.272399 49.598085,85.203408 49.64278,85.203408 49.732048,85.157414 49.761768,85.111421 49.835987,85.04243 49.880464,84.973439 49.954501,85.019433 49.984084,85.04243 50.028425,84.950442 50.102235,84.835458 50.102235,84.835458 50.131727,84.766468 50.146466,84.697477 50.190657,84.490505 50.220095,84.490505 50.234807,84.352524 50.220095,84.260536 50.264217,84.237539 50.513474,84.191546 50.542712,84.122555 50.615729,84.099558 50.615729,84.099558 50.644903,84.168549 50.659484,84.260536 50.67406,84.283533 50.688632,84.490505 50.688632,84.536499 50.775966,84.559496 50.790506,84.559496 50.834099,84.444511 50.877651,84.467508 50.964632,84.352524 50.979114,84.329527 50.99359,84.214543 50.99359,83.984574 51.065906,83.93858 51.094801))","code":"gornoaltaysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"27","name":"Республика Алтай","time_zone":{"name":"Asia/Barnaul","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.347647 47.045108,39.347647 47.295248,39.485628 47.326433,39.531622 47.357599,39.600612 47.373176,39.669603 47.419877,39.784587 47.435435,39.853578 47.450988,39.853578 47.513155,39.968562 47.513155,40.037553 47.482081,40.014556 47.404314,39.968562 47.373176,39.945565 47.310843,39.991559 47.185957,39.922569 47.139049,39.922569 47.092099,39.876575 47.060777,39.76159 47.045108,39.738594 47.060777,39.347647 47.045108))","code":"rostov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"24","name":"Ростов-на-Дону","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((81.155959 51.511747,81.178956 51.554663,81.247946 51.56896,81.29394 51.554663,81.316937 51.511747,81.29394 51.46879,81.178956 51.46879,81.155959 51.511747))","code":"rubtsovsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"143","name":"Рубцовск","time_zone":{"name":"Asia/Barnaul","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.680737 58.070205,38.680737 58.118823,38.795722 58.106675,38.9567 58.106675,38.979697 58.021522,38.933703 57.997155,38.864712 57.997155,38.749728 58.058041,38.680737 58.070205))","code":"rybinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"144","name":"Рыбинск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.347647 54.765465,39.347647 54.77873,39.416637 54.85823,39.485628 54.897922,39.738594 54.884696,40.014556 54.884696,40.083547 54.871465,40.083547 54.525945,40.06055 54.485888,39.876575 54.485888,39.715597 54.472527,39.6926 54.485888,39.462631 54.485888,39.39364 54.499245,39.39364 54.71236,39.370644 54.752195,39.347647 54.765465))","code":"ryazan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"44","name":"Рязань","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((66.460958 66.507982,66.506952 66.617744,66.598939 66.635991,66.66793 66.635991,66.759917 66.617744,66.713924 66.581211,66.782914 66.535468,66.805911 66.471287,66.66793 66.452919,66.483955 66.498813,66.460958 66.507982))","code":"salekhard","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"160","name":"Салехард","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((49.535261 52.934438,49.650245 53.031356,49.788226 53.059007,49.811223 53.155645,49.788226 53.169432,49.788226 53.307066,49.719236 53.34827,49.673242 53.430558,49.696239 53.444257,49.788226 53.608304,49.811223 53.703705,49.903211 53.703705,50.018195 53.744525,50.133179 53.744525,50.317154 53.785305,50.432139 53.758122,50.524126 53.690089,50.57012 53.649216,50.57012 53.594658,50.662107 53.512687,50.800089 53.471642,50.984064 53.457952,51.099048 53.485328,51.37501 53.512687,51.604979 53.608304,51.627976 53.621946,51.857945 53.703705,51.949932 53.730922,52.087913 53.717316,52.11091 53.676469,52.225895 53.649216,52.202898 53.635583,52.202898 53.594658,52.133907 53.581007,51.972929 53.594658,51.857945 53.581007,51.719963 53.512687,51.535989 53.361995,51.421004 53.238304,51.37501 52.809511,51.237029 52.767788,51.076051 52.753872,50.823086 52.906708,50.754095 52.976001,50.501129 52.976001,50.478132 52.962151,50.409142 52.906708,49.995198 52.795608,49.604251 52.837304,49.558258 52.865079,49.535261 52.934438))","code":"samara","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"18","name":"Самара","time_zone":{"name":"Europe/Samara","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((66.621936 39.473742,66.621936 39.544712,66.828908 39.562443,66.805911 39.70413,66.897899 39.792537,66.966889 39.792537,66.966889 39.739507,67.03588 39.739507,67.150864 39.686435,67.150864 39.526976,67.10487 39.526976,67.058877 39.562443,66.966889 39.562443,66.943892 39.544712,66.920895 39.491491,66.621936 39.473742))","code":"samarkand","country_code":"uz","domain":"uz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"truck_graph":true},"id":"247","name":"Самарканд","time_zone":{"name":"Asia/Samarkand","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((26.446402 59.917711,26.446402 59.963788,26.469399 59.963788,26.722364 60.044267,27.113311 60.170339,27.297286 60.216064,27.435267 60.238902,27.596246 60.341479,27.71123 60.398327,27.688233 60.409685,27.688233 60.455076,27.734227 60.477748,27.757224 60.534358,27.78022 60.534358,27.803217 60.568277,27.849211 60.59087,27.872208 60.624729,27.918202 60.647283,28.401136 60.905514,28.51612 60.961376,28.631105 60.961376,28.677098 60.994847,28.677098 61.017141,28.769086 61.10616,28.838077 61.139478,28.953061 61.172761,28.999055 61.19493,29.114039 61.228154,29.275017 61.316581,29.298014 61.327617,29.435995 61.261343,29.55098 61.239221,29.573976 61.183847,29.688961 61.172761,29.780948 61.172761,30.079908 61.139478,30.148898 61.128376,30.286879 61.11727,30.493851 61.083929,30.953789 61.039419,31.114767 61.005996,31.82767 60.860754,31.919657 60.83835,31.942654 60.827142,31.942654 60.782272,31.919657 60.771044,31.712685 60.534358,31.666692 60.477748,31.367732 60.12455,31.160761 59.998303,31.137764 59.894649,31.206754 59.894649,31.229751 59.860026,31.114767 59.825367,31.09177 59.732766,31.045776 59.697974,31.068773 59.546792,30.999782 59.488463,30.884798 59.488463,30.815808 59.465104,30.769814 59.406634,30.700823 59.394928,30.539845 59.383218,30.424861 59.383218,30.332873 59.336337,30.148898 59.336337,30.079908 59.312872,29.91893 59.301133,29.849939 59.312872,29.734955 59.371503,29.504986 59.394928,29.435995 59.418336,29.435995 59.430034,29.367005 59.430034,29.275017 59.476786,29.045048 59.523473,29.022052 59.593382,28.953061 59.639908,28.769086 59.871571,28.746089 59.883112,28.746089 59.917711,28.631105 59.917711,28.194164 59.860026,28.07918 59.848477,28.010189 59.825367,27.895205 59.651529,27.826214 59.570095,27.619242 59.581741,26.906339 59.616653,26.837349 59.651529,26.446402 59.917711))","code":"spb","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"38","name":"Санкт-Петербург","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.843899 54.298434,44.958883 54.311852,45.119861 54.298434,45.487811 54.298434,45.533805 54.271585,45.510808 54.204386,45.510808 54.110123,45.694783 54.015646,45.786771 54.015646,45.809768 53.988613,45.786771 53.961562,45.71778 53.94803,45.648789 53.961562,45.533805 53.961562,45.464815 53.97509,45.28084 53.94803,45.28084 53.934494,45.257843 53.934494,45.211849 53.961562,45.050871 53.961562,44.935886 53.97509,44.866896 53.988613,44.866896 54.231279,44.843899 54.298434))","code":"saransk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"85","name":"Саранск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((45.303836 51.497433,45.326833 51.540363,45.487811 51.526057,45.556802 51.540363,45.556802 51.597539,45.533805 51.611822,45.510808 51.697426,45.579799 51.711677,45.671786 51.768639,45.740777 51.768639,45.809768 51.725925,46.016739 51.725925,46.08573 51.754405,46.08573 51.797093,46.200714 51.839739,46.407686 51.825528,46.430683 51.811313,46.407686 51.725925,46.522671 51.697426,46.568664 51.668909,46.522671 51.640375,46.499674 51.583252,46.407686 51.554663,46.361692 51.425793,46.361692 51.354041,46.338696 51.282176,46.223711 51.19579,46.108727 51.210199,45.947749 51.224603,45.648789 51.19579,45.556802 51.224603,45.487811 51.210199,45.372827 51.224603,45.34983 51.354041,45.372827 51.425793,45.326833 51.454462,45.303836 51.497433))","code":"saratov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"43","name":"Саратов","time_zone":{"name":"Europe/Saratov","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.292484 56.351948,77.292484 56.390156,77.361475 56.402883,77.476459 56.466457,77.591444 56.50455,77.591444 56.567953,77.706428 56.567953,77.752422 56.542605,77.798416 56.567953,77.798416 56.65654,77.867406 56.669178,77.844409 56.757527,77.936397 56.807919,77.98239 56.782732,78.005387 56.744919,78.074378 56.732306,78.120372 56.770132,78.120372 56.870815,78.28135 56.908501,78.28135 56.946149,78.327344 56.95869,78.442328 57.108853,79.08624 57.021332,79.3852 56.95869,79.546178 56.933604,79.592171 56.933604,79.592171 56.921055,79.75315 56.795328,79.960121 56.65654,80.259081 56.428326,80.535043 56.453751,80.535043 56.44104,80.489049 56.402883,80.374065 56.313702,80.259081 56.326455,79.75315 56.044904,79.684159 56.032057,79.638165 56.109074,79.523181 56.109074,79.408197 56.070585,79.362203 56.121896,79.293212 56.109074,79.109237 56.006351,79.109237 55.916243,79.01725 55.916243,78.994253 55.877561,78.971256 55.813005,78.925262 55.787153,78.902265 55.748342,78.833275 55.748342,78.810278 55.787153,78.695293 55.800081,78.626303 55.825925,78.511319 55.813005,78.488322 55.825925,78.488322 55.890459,78.35034 55.890459,78.212359 55.864658,78.097375 55.864658,78.028384 55.877561,78.028384 55.916243,78.212359 55.967759,78.258353 55.967759,78.258353 55.993491,78.212359 56.019206,78.212359 56.057747,78.235356 56.121896,78.166365 56.185938,77.936397 56.185938,77.867406 56.173138,77.798416 56.173138,77.729425 56.147525,77.660434 56.160334,77.637437 56.198733,77.706428 56.262647,77.706428 56.275417,77.660434 56.313702,77.568447 56.326455,77.430466 56.300945,77.315481 56.313702,77.292484 56.351948))","code":"severnoe","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"188","name":"Северное","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.579581 49.418893,76.602578 49.463753,76.717563 49.493636,76.832547 49.508571,77.039519 49.553349,77.154503 49.65767,77.1775 49.702311,77.154503 49.835987,77.154503 49.9249,77.223494 49.939703,77.269487 49.969295,77.407469 50.013649,77.499456 50.057963,77.568447 50.102235,77.683431 50.146466,77.706428 50.220095,77.798416 50.220095,77.890403 50.161201,78.327344 50.057963,78.442328 50.043196,78.511319 50.057963,78.626303 50.102235,78.787281 50.308299,78.764284 50.381678,78.764284 50.440299,78.672297 50.469583,78.672297 50.601134,78.695293 50.615729,78.695293 50.644903,78.672297 50.688632,78.534315 50.688632,78.465325 50.717761,78.465325 50.834099,78.419331 50.834099,78.35034 50.877651,78.28135 50.877651,78.189362 51.02253,78.143369 51.02253,78.120372 51.065906,78.097375 51.080355,78.120372 51.094801,78.120372 51.152536,78.258353 51.19579,78.304347 51.224603,78.511319 51.224603,78.672297 51.296558,78.787281 51.310935,78.787281 51.354041,78.741287 51.411452,78.787281 51.454462,78.971256 51.454462,79.08624 51.511747,79.08624 51.597539,79.224222 51.626101,79.247218 51.697426,79.339206 51.697426,79.362203 51.68317,79.477187 51.526057,79.684159 51.26779,79.707156 51.224603,80.006115 50.834099,80.029112 50.790506,80.075106 50.775966,80.075106 50.834099,80.167093 50.834099,80.213087 50.906663,80.328071 50.921162,80.397062 50.935657,80.489049 51.008062,80.489049 51.109241,80.443056 51.138109,80.443056 51.19579,80.512046 51.210199,80.604034 51.210199,80.650028 51.296558,80.788009 51.296558,80.902993 51.26779,80.948987 51.224603,80.971984 51.210199,81.040974 51.19579,81.063971 51.181376,81.132962 51.19579,81.178956 51.166958,81.155959 51.080355,81.086968 51.036993,81.086968 50.950147,81.201952 50.950147,81.339934 50.979114,81.408924 50.964632,81.454918 50.848621,81.477915 50.834099,81.454918 50.775966,81.523909 50.746873,81.592899 50.746873,81.615896 50.688632,81.638893 50.688632,81.66189 50.615729,81.66189 50.557325,81.707884 50.528096,81.684887 50.39634,81.684887 50.308299,81.615896 50.29361,81.500912 50.308299,81.477915 50.322984,81.385927 50.322984,81.362931 50.278916,81.362931 50.234807,81.201952 50.249514,81.109965 50.220095,81.109965 50.175931,81.224949 50.131727,81.362931 50.131727,81.339934 49.969295,81.477915 49.954501,81.569902 49.895281,81.684887 49.865643,81.707884 49.821152,81.684887 49.776621,81.638893 49.74691,81.66189 49.732048,81.730881 49.732048,81.822868 49.627886,81.868862 49.612988,82.052837 49.523501,82.075834 49.433851,82.167821 49.388964,82.305802 49.388964,82.39779 49.329051,82.535771 49.329051,82.604762 49.269065,82.627758 49.224027,82.673752 49.19398,82.696749 49.088669,82.719746 49.013309,82.811733 48.968039,82.903721 48.968039,82.926718 48.922727,82.903721 48.877375,82.83473 48.831981,82.83473 48.756233,82.880724 48.756233,82.880724 48.81684,82.949715 48.801695,82.949715 48.756233,83.156687 48.756233,83.179683 48.710729,83.156687 48.680371,83.179683 48.665185,83.225677 48.589185,83.340661 48.54353,83.409652 48.528303,83.455646 48.452097,83.616624 48.406319,83.616624 48.360499,83.50164 48.284042,83.50164 48.253426,82.995708 47.961667,82.995708 47.807444,82.972712 47.791997,83.018705 47.699215,83.13369 47.637269,83.156687 47.62177,83.156687 47.544211,83.225677 47.466537,83.179683 47.295248,83.179683 47.248437,83.156687 47.232824,83.087696 47.232824,83.018705 47.217206,83.018705 47.123404,82.949715 47.013758,82.926718 46.998076,82.903721 46.872453,82.880724 46.85673,82.880724 46.809532,82.811733 46.730776,82.742743 46.541292,82.650755 46.382882,82.535771 46.208098,82.46678 46.000816,82.420787 45.968857,82.374793 45.968857,82.328799 45.904885,82.351796 45.808787,82.282805 45.696464,82.259809 45.551715,82.213815 45.551715,82.144824 45.583914,82.144824 45.728579,82.075834 45.808787,81.983846 45.872871,81.891859 46.096581,81.66189 46.27172,81.592899 46.319388,81.523909 46.398743,81.546906 46.4146,81.569902 46.477983,81.500912 46.493817,81.431921 46.446301,81.385927 46.477983,81.224949 46.509647,81.132962 46.572919,80.856999 46.572919,80.604034 46.651905,80.420059 46.715011,80.397062 46.730776,80.351068 46.730776,80.328071 46.746536,80.213087 46.79379,80.19009 46.85673,80.052109 46.903887,79.983118 46.903887,79.960121 46.888172,79.845137 46.85673,79.500184 46.79379,79.45419 46.825269,79.132234 47.092099,78.764284 47.060777,78.695293 47.060777,78.672297 47.107754,78.603306 47.123404,78.396334 47.201584,78.235356 47.279649,78.166365 47.264045,78.097375 47.185957,78.005387 47.185957,77.98239 47.232824,77.890403 47.232824,77.798416 47.170326,77.729425 47.170326,77.683431 47.201584,77.591444 47.201584,77.476459 47.15469,77.269487 47.170326,77.200497 47.139049,77.200497 47.092099,77.131506 47.07644,76.947531 47.15469,76.832547 47.217206,76.832547 47.264045,76.878541 47.373176,76.901538 47.419877,77.039519 47.419877,77.039519 47.450988,76.993525 47.683735,77.039519 47.838326,77.131506 47.869189,77.131506 47.915449,77.1775 47.946266,77.200497 48.038607,77.315481 48.053981,77.315481 48.100075,77.246491 48.115431,77.154503 48.115431,77.062516 48.161471,77.062516 48.222793,77.131506 48.238112,77.131506 48.284042,77.016522 48.284042,76.924534 48.345217,76.855544 48.360499,76.855544 48.39105,76.878541 48.406319,76.901538 48.452097,76.947531 48.497834,77.154503 48.497834,77.292484 48.619599,77.315481 48.665185,77.315481 48.801695,77.292484 48.847117,77.154503 48.847117,76.878541 48.81684,76.855544 48.847117,76.832547 48.983134,76.878541 49.02839,76.993525 49.02839,76.993525 49.073606,76.924534 49.133829,76.855544 49.133829,76.80955 49.224027,76.602578 49.329051,76.579581 49.418893),(83.156687 48.680371,83.087696 48.710729,83.041702 48.710729,83.041702 48.634798,83.110693 48.619599,83.156687 48.680371))","code":"semey","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"169","name":"Семей","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((31.758679 54.71236,31.758679 54.805248,31.804673 54.884696,32.034642 54.884696,32.172623 54.937574,32.241614 54.897922,32.26461 54.831748,32.26461 54.752195,32.19562 54.71236,32.172623 54.672486,32.057639 54.685782,31.82767 54.685782,31.758679 54.71236))","code":"smolensk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"63","name":"Смоленск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.496763 44.13321,38.496763 44.149714,38.611747 44.330943,38.634744 44.380272,38.680737 44.44598,38.680737 44.495212,38.795722 44.495212,38.818719 44.511614,38.9567 44.478806,38.9567 44.413135,39.025691 44.396706,39.094681 44.44598,39.255659 44.44598,39.278656 44.42956,39.278656 44.347391,39.255659 44.265106,39.416637 44.116703,39.439634 44.116703,39.715597 43.967926,39.76159 43.934814,39.968562 43.934814,40.037553 43.885111,40.106544 43.868534,40.175534 43.868534,40.221528 43.78558,40.290518 43.768976,40.359509 43.78558,40.359509 43.768976,40.451497 43.702512,40.474493 43.652615,40.612475 43.586022,40.658468 43.552697,40.635472 43.552697,40.612475 43.536028,40.543484 43.519355,40.520487 43.536028,40.405503 43.552697,40.244525 43.586022,40.221528 43.569362,40.106544 43.569362,40.083547 43.519355,40.037553 43.485993,40.014556 43.385799,39.876575 43.21844,39.76159 43.235197,39.485628 43.435917,39.232662 43.652615,39.163672 43.735753,39.094681 43.752367,39.025691 43.835366,38.9567 43.851952,38.726731 44.01756,38.657741 44.050626,38.565753 44.116703,38.496763 44.13321))","code":"sochi","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"30","name":"Сочи","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.670331 44.952712,41.693328 45.066521,41.670331 45.066521,41.670331 45.180105,41.716324 45.244908,41.808312 45.261097,41.900299 45.228714,41.96929 45.244908,41.992287 45.261097,42.153265 45.277282,42.222256 45.244908,42.33724 45.180105,42.360237 45.098997,42.291246 44.985252,42.130268 44.936435,42.084274 44.903867,41.693328 44.903867,41.670331 44.952712))","code":"stavropol","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"57","name":"Ставрополь","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((37.714869 51.26779,37.714869 51.310935,37.737866 51.325308,37.714869 51.3684,37.737866 51.411452,37.944838 51.425793,38.059822 51.3684,38.082819 51.354041,38.082819 51.339677,38.036825 51.310935,38.059822 51.210199,38.036825 51.19579,37.990831 51.109241,37.898844 51.109241,37.829853 51.19579,37.714869 51.26779))","code":"staroskol","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"60","name":"Старый Оскол","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((55.721419 53.457952,55.721419 53.49901,55.79041 53.553692,55.813407 53.567352,55.813407 53.676469,55.951388 53.758122,55.974385 53.744525,56.066372 53.744525,56.135363 53.717316,56.15836 53.581007,56.135363 53.567352,56.135363 53.320805,55.997382 53.293322,55.8594 53.320805,55.721419 53.457952))","code":"sterlitamak","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"54","name":"Стерлитамак","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((72.394151 61.19493,72.394151 61.39375,73.612985 61.404759,73.79696 61.415764,73.773963 61.316581,73.79696 61.305541,73.79696 61.028282,73.773963 60.994847,73.383016 60.994847,72.946076 60.983694,72.417148 60.983694,72.417148 61.005996,72.394151 61.19493))","code":"surgut","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"39","name":"Сургут","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((50.156176 61.591314,50.20217 61.65689,50.271161 61.70053,50.294157 61.711431,50.294157 61.787626,50.386145 61.798496,50.409142 61.809361,50.478132 61.971888,50.524126 62.00429,50.616114 62.00429,50.708101 61.96108,50.800089 61.96108,50.961067 61.950267,51.030057 61.939452,51.053054 61.89615,51.283023 61.874476,51.30602 61.831082,51.329017 61.820223,51.444001 61.809361,51.444001 61.754994,51.37501 61.678718,51.30602 61.689626,51.237029 61.667806,51.237029 61.624119,51.191035 61.580371,51.122045 61.591314,51.053054 61.580371,51.00706 61.525599,50.93807 61.525599,50.754095 61.547519,50.593117 61.514633,50.432139 61.514633,50.317154 61.569424,50.225167 61.569424,50.156176 61.591314))","code":"syktyvkar","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"72","name":"Сыктывкар","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.795722 47.217206,38.818719 47.279649,38.9567 47.279649,38.979697 47.201584,38.9567 47.185957,38.864712 47.185957,38.795722 47.217206))","code":"taganrog","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"116","name":"Таганрог","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.23339 52.795608,41.256387 52.837304,41.417365 52.837304,41.509353 52.878959,41.53235 52.837304,41.647334 52.809511,41.624337 52.712096,41.60134 52.67028,41.624337 52.600498,41.578343 52.558575,41.417365 52.572554,41.302381 52.516612,41.256387 52.572554,41.256387 52.7817,41.23339 52.795608))","code":"tambov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"81","name":"Тамбов","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((71.037335 43.000185,71.037335 43.067423,71.106326 43.084221,71.313298 43.017001,71.451279 43.050621,71.58926 43.050621,71.612257 43.000185,71.497273 42.899189,71.52027 42.8149,71.336295 42.8149,71.313298 42.764271,71.267304 42.764271,71.244307 42.781152,71.15232 42.8149,71.15232 42.949708,71.037335 43.000185))","code":"taraz","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"221","name":"Тараз","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.107782 55.371178,75.130778 55.410363,75.176772 55.423416,75.153775 55.462549,75.291757 55.501644,75.291757 55.540699,75.406741 55.553709,75.429738 55.540699,75.521725 55.501644,75.567719 55.501644,75.567719 55.436465,75.544722 55.423416,75.613713 55.397306,75.659706 55.423416,75.682703 55.462549,75.820685 55.488617,75.889675 55.527685,75.912672 55.527685,76.027656 55.488617,76.119644 55.488617,76.142641 55.514667,76.280622 55.514667,76.303619 55.553709,76.395606 55.553709,76.418603 55.514667,76.395606 55.475585,76.395606 55.436465,76.326616 55.410363,76.234628 55.410363,76.211631 55.371178,76.372609 55.279595,76.372609 55.200927,76.326616 55.200927,76.326616 55.135251,76.464597 55.082633,76.464597 55.056298,76.418603 55.043123,76.326616 55.003575,76.280622 54.977188,76.188635 54.937574,76.211631 54.85823,76.096647 54.791991,76.027656 54.791991,75.866678 54.765465,75.751694 54.725643,75.751694 54.685782,75.7057 54.659186,75.659706 54.685782,75.659706 54.738921,75.590716 54.805248,75.498728 54.805248,75.475732 54.871465,75.475732 54.897922,75.406741 54.884696,75.33775 54.884696,75.314753 54.911144,75.383744 55.003575,75.314753 55.069467,75.291757 55.082633,75.26876 55.122103,75.245763 55.135251,75.26876 55.1878,75.245763 55.200927,75.245763 55.24028,75.199769 55.25339,75.176772 55.318871,75.107782 55.371178))","code":"tatarsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"189","name":"Татарск","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((69.082601 41.226176,69.128595 41.226176,69.151592 41.3126,69.197586 41.364399,69.31257 41.450641,69.427554 41.485105,69.427554 41.553979,69.542539 41.571186,69.611529 41.657152,69.749511 41.691506,69.772507 41.708677,69.933486 41.708677,69.979479 41.777312,70.071467 41.794459,70.071467 41.82874,70.140457 41.845874,70.324432 41.982778,70.324432 42.034041,70.439417 42.085263,70.531404 42.085263,70.577398 42.016958,70.669385 42.016958,70.738376 41.99987,70.761373 41.948579,70.78437 41.948579,70.761373 41.931473,70.646389 41.880127,70.646389 41.863003,70.347429 41.639968,70.209448 41.605586,70.186451 41.553979,70.163454 41.553979,70.002476 41.450641,69.818501 41.191574,69.703517 41.139637,69.450551 40.966217,69.381561 40.879336,69.289573 40.879336,69.266576 40.931478,69.289573 41.087659,69.266576 41.156954,69.174589 41.191574,69.082601 41.174266,69.082601 41.226176))","code":"tashkent","country_code":"uz","domain":"uz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":true,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"208","name":"Ташкент","time_zone":{"name":"Asia/Tashkent","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.530166 56.858244,35.530166 56.908501,35.553163 56.971227,35.668147 57.008812,35.737138 57.008812,35.806129 57.046359,35.898116 57.046359,36.31206 56.971227,36.358053 56.895943,36.335057 56.807919,36.335057 56.744919,36.266066 56.681812,36.036097 56.681812,35.875119 56.669178,35.622154 56.681812,35.553163 56.707067,35.57616 56.83309,35.530166 56.858244))","code":"tver","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"47","name":"Тверь","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((68.024745 57.899523,68.116733 57.923956,68.047742 57.972772,68.024745 57.984966,68.024745 58.324707,68.093736 58.336781,68.254714 58.348851,68.277711 58.336781,68.346701 58.360916,68.346701 58.397088,68.323705 58.433222,68.369698 58.457292,68.415692 58.517392,68.484683 58.50538,68.599667 58.50538,68.622664 58.517392,68.691654 58.50538,68.691654 58.46932,68.622664 58.433222,68.622664 58.143106,68.645661 58.082366,68.714651 58.082366,68.783642 58.009341,68.829636 58.009341,68.875629 58.033699,68.94462 58.021522,69.013611 57.960574,69.105598 57.911742,69.082601 57.875073,68.323705 57.838368,68.300708 57.850607,68.093736 57.862842,68.024745 57.899523))","code":"tobolsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"97","name":"Тобольск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.948477 53.361995,48.017467 53.403146,48.040464 53.471642,48.132452 53.485328,48.339423 53.471642,48.408414 53.567352,48.339423 53.608304,48.36242 53.649216,48.454408 53.649216,48.523398 53.662845,48.477405 53.744525,48.523398 53.758122,48.592389 53.730922,48.615386 53.717316,48.776364 53.730922,48.799361 53.717316,48.914345 53.703705,49.006333 53.730922,49.006333 53.907408,49.02933 53.94803,49.167311 54.042661,49.236301 54.056163,49.236301 54.09664,49.167311 54.164014,49.09832 54.177476,49.09832 54.204386,49.121317 54.204386,49.144314 54.217835,49.144314 54.285012,49.259298 54.311852,49.259298 54.338675,49.328289 54.35208,49.604251 54.311852,49.627248 54.271585,49.742233 54.204386,49.765229 54.204386,49.788226 54.190933,49.880214 54.164014,49.903211 54.150548,49.903211 54.083152,49.811223 53.920953,49.83422 53.853184,49.857217 53.826046,49.857217 53.785305,49.811223 53.703705,49.788226 53.608304,49.696239 53.444257,49.673242 53.430558,49.719236 53.34827,49.788226 53.307066,49.788226 53.169432,49.811223 53.155645,49.788226 53.059007,49.650245 53.031356,49.581254 53.045183,49.46627 53.045183,49.397279 53.017524,49.351286 52.989846,49.190308 53.003687,49.190308 52.948297,49.006333 52.892836,48.960339 52.892836,48.937342 52.934438,48.822358 52.948297,48.753367 52.962151,48.73037 52.976001,48.523398 52.989846,48.523398 52.948297,48.408414 52.962151,48.339423 52.989846,48.339423 53.059007,48.29343 53.059007,48.224439 53.031356,48.155448 53.045183,48.178445 53.141852,48.109455 53.183216,48.155448 53.238304,48.040464 53.279574,48.040464 53.307066,47.971473 53.320805,47.948477 53.361995))","code":"togliatti","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"22","name":"Тольятти","time_zone":{"name":"Europe/Samara","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((83.225677 55.748342,83.294668 55.813005,83.386655 55.877561,83.455646 55.890459,83.478643 55.916243,83.86959 56.185938,83.754605 56.567953,83.961577 56.681812,84.398518 56.744919,84.421514 56.782732,84.421514 56.83309,84.444511 56.921055,84.697477 56.908501,85.226405 56.883381,85.77833 56.98376,85.893314 57.046359,86.14628 57.158773,86.21527 57.158773,86.284261 57.096363,86.353252 56.98376,86.468236 56.946149,86.468236 56.908501,86.58322 56.883381,86.606217 56.845669,86.721202 56.858244,86.767195 56.820507,86.767195 56.782732,86.652211 56.782732,86.192274 56.845669,86.14628 56.757527,86.14628 56.643897,86.238267 56.643897,86.238267 56.631251,86.192274 56.605944,86.192274 56.567953,86.123283 56.555281,86.123283 56.517239,86.100286 56.479159,86.008299 56.479159,85.962305 56.428326,85.893314 56.428326,85.824324 56.415607,85.77833 56.339204,85.709339 56.339204,85.594355 56.300945,85.594355 56.275417,85.640349 56.249873,85.640349 56.211525,85.525364 56.211525,85.41038 56.198733,85.318392 56.224312,85.249402 56.224312,85.203408 56.198733,85.134417 56.198733,85.04243 56.121896,84.973439 56.121896,84.973439 56.147525,84.904449 56.160334,84.651483 56.096249,84.582493 56.083419,84.467508 56.044904,84.398518 56.032057,84.375521 55.993491,84.329527 55.993491,84.237539 56.044904,84.168549 56.044904,84.145552 56.032057,83.984574 56.019206,83.915583 55.980627,83.754605 55.83884,83.731608 55.787153,83.662618 55.77422,83.662618 55.735397,83.616624 55.696535,83.593627 55.683572,83.409652 55.709493,83.248674 55.709493,83.225677 55.748342))","code":"tomsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"3","name":"Томск","time_zone":{"name":"Asia/Tomsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((37.185941 54.231279,37.185941 54.271585,37.231935 54.298434,37.300925 54.378876,37.369916 54.392268,37.438906 54.432417,37.507897 54.419038,37.530894 54.432417,37.576888 54.419038,37.622881 54.338675,37.737866 54.35208,37.806856 54.378876,37.875847 54.36548,37.875847 54.325266,37.990831 54.338675,37.990831 54.35208,38.174806 54.35208,38.197803 54.36548,38.312788 54.35208,38.312788 54.325266,38.358781 54.325266,38.450769 54.244719,38.473766 54.204386,38.496763 54.204386,38.519759 54.137078,38.58875 54.123603,38.58875 54.002132,38.611747 53.988613,38.519759 53.893859,38.427772 53.826046,38.335784 53.826046,38.197803 53.866747,38.197803 53.893859,37.990831 53.907408,37.599885 53.907408,37.438906 53.893859,37.41591 54.042661,37.392913 54.083152,37.300925 54.056163,37.254931 54.083152,37.231935 54.150548,37.231935 54.204386,37.185941 54.231279))","code":"tula","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"36","name":"Тула","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((68.13973 43.235197,68.13973 43.302177,68.185723 43.352364,68.277711 43.352364,68.346701 43.385799,68.438689 43.536028,68.599667 43.552697,68.622664 43.502676,68.599667 43.452614,68.599667 43.318911,68.50768 43.285439,68.277711 43.21844,68.13973 43.235197))","code":"turkestan","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"232","name":"Туркестан","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((64.851177 57.295705,64.874174 57.38258,64.874174 57.45688,64.897171 57.45688,64.966161 57.444507,65.127139 57.407363,65.127139 57.38258,65.219127 57.38258,65.242124 57.357779,65.472093 57.308129,65.541083 57.308129,65.541083 57.295705,65.610074 57.308129,65.610074 57.345373,65.656067 57.370182,65.679064 57.407363,65.840042 57.407363,65.93203 57.345373,65.955027 57.295705,66.116005 57.258411,66.139002 57.245971,66.253986 57.258411,66.36897 57.245971,66.460958 57.245971,66.483955 57.283278,66.598939 57.295705,66.644933 57.357779,66.805911 57.357779,66.943892 57.38258,67.081874 57.50633,67.173861 57.568048,67.242852 57.543373,67.242852 57.50633,67.265848 57.481613,67.288845 57.419749,67.03588 57.158773,67.03588 56.946149,66.920895 56.757527,66.644933 56.707067,66.621936 56.593285,66.621936 56.415607,66.552945 56.402883,65.840042 56.415607,65.633071 56.415607,65.426099 56.428326,65.334111 56.402883,65.265121 56.415607,65.19613 56.453751,65.219127 56.491856,65.219127 56.580621,65.242124 56.845669,65.242124 56.895943,65.081146 56.895943,65.058149 56.933604,65.012155 57.021332,64.989158 57.033848,64.989158 57.12134,64.966161 57.133822,64.989158 57.221078,64.897171 57.295705,64.851177 57.295705))","code":"tyumen","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"13","name":"Тюмень","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((78.902265 55.292691,78.925262 55.305783,78.994253 55.305783,78.971256 55.397306,79.01725 55.475585,79.08624 55.514667,79.155231 55.475585,79.270215 55.475585,79.316209 55.527685,79.3852 55.540699,79.500184 55.618695,79.523181 55.657634,79.615168 55.670605,79.615168 55.709493,79.730153 55.748342,79.730153 55.787153,79.684159 55.813005,79.707156 55.954886,79.684159 55.967759,79.684159 56.032057,79.75315 56.044904,80.259081 56.326455,80.374065 56.313702,80.489049 56.402883,80.535043 56.44104,80.535043 56.453751,80.834003 56.491856,80.994981 56.517239,81.155959 56.529924,81.247946 56.529924,81.316937 56.466457,81.477915 56.326455,81.546906 56.237095,81.592899 56.237095,81.615896 56.198733,81.776874 56.006351,81.776874 55.967759,81.29394 55.813005,81.063971 55.735397,81.063971 55.644659,80.856999 55.605706,80.742015 55.618695,80.650028 55.592713,80.489049 55.553709,80.374065 55.540699,80.328071 55.566715,80.213087 55.566715,80.006115 55.371178,80.006115 55.331954,79.868134 55.292691,79.868134 55.214049,79.82214 55.135251,79.845137 55.122103,79.914128 55.122103,79.914128 55.082633,79.82214 55.016762,79.730153 55.003575,79.569175 54.990384,79.569175 54.950783,79.592171 54.937574,79.569175 54.85823,79.546178 54.831748,79.431193 54.805248,79.293212 54.805248,79.270215 54.844991,79.178228 54.871465,79.178228 54.924361,78.994253 55.003575,78.994253 55.043123,78.971256 55.108951,78.925262 55.135251,78.948259 55.24028,78.925262 55.25339,78.902265 55.292691))","code":"ubinskoe","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"190","name":"Убинское","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((100.634309 51.711677,100.680302 51.768639,100.910271 51.768639,101.14024 51.797093,101.163237 51.782868,101.232227 51.768639,101.393205 51.797093,101.50819 51.797093,101.669168 51.839739,101.922133 51.853946,101.968127 51.882346,102.152102 51.939092,102.175099 51.953267,102.405068 51.981605,102.566046 51.924912,102.635036 51.882346,102.796015 51.896539,102.819011 51.939092,102.819011 51.967438,102.910999 51.910728,103.071977 51.896539,103.094974 51.853946,103.209958 51.825528,103.232955 51.811313,103.531914 51.725925,103.600905 51.725925,103.623902 51.711677,103.600905 51.611822,103.623902 51.597539,103.692893 51.583252,103.78488 51.583252,103.945858 51.540363,104.129833 51.483114,104.244817 51.46879,104.52078 51.44013,104.612767 51.425793,104.635764 51.46879,104.589771 51.611822,104.635764 51.640375,104.796742 51.654644,105.095702 51.697426,105.118699 51.711677,105.25668 51.740167,105.417658 51.782868,105.670624 51.882346,105.831602 51.995766,105.946586 52.137139,105.969583 52.137139,105.969583 52.16536,105.99258 52.179463,106.176555 52.362405,106.521508 52.502615,107.004442 52.712096,107.418386 52.934438,108.016304 53.238304,108.085295 53.320805,108.085295 53.361995,108.154286 53.457952,108.292267 53.676469,108.384254 53.758122,108.453245 53.853184,108.545232 53.920953,108.568229 53.94803,108.683214 54.042661,108.844192 54.190933,108.844192 54.204386,108.867189 54.204386,108.890185 54.231279,108.959176 54.271585,108.982173 54.258154,109.212142 54.217835,109.235139 54.204386,109.281132 54.204386,109.304129 54.190933,109.534098 54.150548,109.580092 54.110123,109.603088 54.069659,109.626085 54.056163,109.902048 54.015646,110.10902 53.94803,110.201007 53.934494,110.224004 53.893859,110.155013 53.853184,110.063026 53.839617,109.994035 53.771716,109.833057 53.676469,109.787063 53.608304,109.718073 53.581007,109.695076 53.567352,109.672079 53.457952,109.580092 53.403146,109.580092 53.334539,109.235139 52.906708,109.189145 52.865079,109.07416 52.851193,108.913182 52.7817,108.913182 52.753872,108.890185 52.753872,108.821195 52.656332,108.752204 52.614463,108.729207 52.544592,108.706211 52.502615,108.614223 52.502615,108.453245 52.390483,108.453245 52.362405,108.430248 52.348359,108.361257 52.263992,108.338261 52.249915,108.315264 52.193563,108.246273 52.179463,108.200279 52.137139,108.177282 52.038225,108.154286 52.024077,108.131289 51.924912,108.177282 51.896539,108.154286 51.853946,108.085295 51.811313,108.039301 51.711677,108.016304 51.668909,107.993308 51.668909,107.970311 51.597539,107.855326 51.511747,107.786336 51.46879,107.53337 51.483114,107.464379 51.454462,107.349395 51.454462,107.234411 51.3684,107.234411 51.282176,107.188417 51.166958,107.119426 51.080355,107.09643 50.950147,107.119426 50.863138,107.09643 50.819572,107.142423 50.761422,107.142423 50.615729,107.119426 50.586536,106.981445 50.586536,106.958448 50.542712,106.935451 50.469583,106.912455 50.454943,106.889458 50.410998,106.958448 50.337664,107.004442 50.249514,106.958448 50.220095,106.889458 50.234807,106.843464 50.264217,106.72848 50.308299,106.567501 50.322984,106.291539 50.29361,106.199552 50.308299,106.176555 50.322984,106.084567 50.322984,106.015577 50.39634,105.99258 50.410998,106.084567 50.819572,106.199552 50.892159,106.199552 51.094801,106.038573 51.138109,105.969583 51.152536,105.969583 51.166958,105.946586 51.166958,105.877595 51.181376,105.348667 51.325308,105.026711 51.26779,104.95772 51.239003,104.934724 51.19579,104.842736 51.166958,104.819739 51.109241,104.704755 51.065906,104.635764 51.065906,104.543777 51.008062,103.232955 51.02253,103.163965 51.036993,103.163965 51.094801,103.140968 51.138109,102.933996 51.138109,102.796015 51.109241,102.773018 51.065906,102.589043 51.065906,102.589043 51.109241,102.497055 51.123677,102.106108 51.138109,102.129105 51.210199,102.106108 51.224603,102.083112 51.26779,102.129105 51.310935,102.106108 51.354041,101.899137 51.397106,101.784152 51.411452,101.738159 51.44013,101.623174 51.425793,101.554184 51.46879,101.50819 51.483114,101.439199 51.44013,101.347212 51.44013,101.232227 51.511747,101.117243 51.511747,101.094246 51.554663,101.025256 51.554663,100.956265 51.597539,100.887274 51.597539,100.795287 51.654644,100.657306 51.697426,100.634309 51.711677))","code":"ulanude","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"37","name":"Улан-Удэ","time_zone":{"name":"Asia/Irkutsk","offset":480},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.99447 54.378876,48.063461 54.472527,48.270433 54.459161,48.385417 54.472527,48.845355 54.472527,48.914345 54.405655,49.006333 54.35208,49.167311 54.338675,49.259298 54.338675,49.236301 54.298434,49.167311 54.298434,49.144314 54.258154,49.144314 54.217835,49.121317 54.204386,48.960339 54.204386,48.937342 54.177476,48.822358 54.164014,48.799361 54.150548,48.592389 54.110123,48.569392 54.069659,48.270433 54.09664,48.247436 54.110123,48.086458 54.110123,48.017467 54.204386,48.017467 54.231279,48.040464 54.325266,48.017467 54.338675,47.99447 54.378876))","code":"ulyanovsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"55","name":"Ульяновск","time_zone":{"name":"Europe/Ulyanovsk","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((49.926208 51.19579,50.018195 51.253399,50.179173 51.26779,50.20217 51.224603,50.271161 51.19579,50.340151 51.19579,50.455136 51.239003,50.915073 51.397106,50.984064 51.56896,50.961067 51.68317,51.030057 51.68317,51.053054 51.668909,51.191035 51.526057,51.352014 51.3684,51.352014 51.325308,51.466998 51.282176,51.535989 51.282176,51.74296 51.3684,51.880942 51.397106,51.995926 51.44013,52.156904 51.46879,52.432867 51.46879,52.501857 51.511747,52.593845 51.46879,52.662835 51.46879,52.731826 51.483114,52.800816 51.425793,52.869807 51.339677,52.984791 51.282176,52.984791 51.26779,53.122773 51.19579,53.122773 51.123677,52.984791 51.094801,52.823813 51.051452,52.570848 51.008062,52.11091 50.935657,51.972929 50.848621,51.972929 50.732319,51.995926 50.688632,51.903938 50.615729,51.880942 50.615729,51.857945 50.571932,51.788954 50.469583,51.398007 50.205378,51.283023 50.175931,51.122045 50.175931,50.984064 50.322984,50.984064 50.454943,51.053054 50.528096,51.053054 50.615729,51.076051 50.717761,51.099048 50.761422,51.076051 50.892159,51.099048 50.906663,51.076051 50.950147,50.478132 50.979114,50.248164 51.051452,50.133179 51.094801,49.972201 51.166958,49.926208 51.19579))","code":"uralsk","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"162","name":"Уральск","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((131.726079 43.768976,131.749076 43.818776,131.749076 43.918251,131.772072 43.967926,132.071032 43.967926,132.140022 43.951372,132.140022 43.768976,132.117025 43.719135,131.93305 43.719135,131.818066 43.702512,131.726079 43.768976))","code":"ussuriysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"83","name":"Уссурийск","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((82.420787 49.939703,82.443784 49.939703,82.443784 50.043196,82.489777 50.161201,82.558768 50.249514,82.558768 50.35234,82.719746 50.410998,83.662618 50.454943,83.731608 50.35234,83.731608 50.308299,83.685615 50.308299,83.363658 50.220095,83.248674 50.220095,83.156687 50.249514,83.087696 50.249514,83.018705 50.205378,82.995708 50.131727,82.995708 50.013649,83.386655 49.74691,83.708611 49.612988,83.754605 49.538427,83.731608 49.493636,83.57063 49.493636,83.524636 49.523501,83.386655 49.553349,83.386655 49.598085,83.317665 49.672555,83.018705 49.672555,82.949715 49.702311,82.949715 49.74691,82.880724 49.761768,82.719746 49.776621,82.627758 49.806313,82.581765 49.835987,82.512774 49.835987,82.420787 49.865643,82.420787 49.939703))","code":"ustkam","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"91","name":"Усть-Каменогорск","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.084785 55.735397,75.084785 55.761284,75.291757 55.748342,75.33775 55.748342,75.33775 55.800081,75.26876 55.83884,75.291757 55.903353,75.452735 55.967759,75.498728 56.006351,75.521725 56.044904,75.659706 56.057747,75.728697 56.121896,75.981663 56.134713,76.027656 56.160334,76.142641 56.160334,76.165638 56.147525,76.280622 56.160334,76.349613 56.147525,76.349613 56.096249,76.395606 56.070585,76.372609 55.903353,76.372609 55.877561,76.234628 55.851751,76.188635 55.761284,76.211631 55.696535,76.211631 55.592713,76.142641 55.553709,76.142641 55.514667,76.119644 55.488617,76.027656 55.488617,75.912672 55.527685,75.889675 55.527685,75.820685 55.488617,75.682703 55.462549,75.659706 55.423416,75.613713 55.397306,75.544722 55.423416,75.567719 55.436465,75.567719 55.501644,75.521725 55.501644,75.429738 55.540699,75.406741 55.553709,75.291757 55.540699,75.176772 55.540699,75.130778 55.579716,75.199769 55.644659,75.107782 55.670605,75.084785 55.735397))","code":"ust_tarka","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"191","name":"Усть-Тарка","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((53.375738 54.472527,53.398735 54.565963,53.513719 54.659186,53.513719 54.672486,53.628704 54.685782,53.651701 54.659186,53.766685 54.645881,53.835676 54.605942,53.927663 54.605942,54.019651 54.632572,54.088641 54.605942,54.157632 54.619259,54.272616 54.619259,54.364604 54.672486,54.617569 54.672486,54.709557 54.725643,54.778547 54.725643,54.847538 54.738921,55.008516 54.805248,55.1235 54.8185,55.169494 54.791991,55.307475 54.791991,55.468454 54.831748,55.514447 54.831748,55.514447 54.85823,55.537444 54.871465,55.583438 54.963988,55.49145 54.990384,55.445457 55.056298,55.238485 55.069467,55.169494 55.108951,55.169494 55.161535,55.353469 55.266495,55.376466 55.305783,55.330472 55.331954,55.353469 55.397306,55.399463 55.423416,55.468454 55.501644,55.537444 55.501644,55.652428 55.436465,55.721419 55.436465,55.79041 55.397306,56.089369 55.384244,56.204353 55.397306,56.480316 55.397306,56.503313 55.462549,56.549306 55.462549,56.687288 55.410363,56.733281 55.305783,56.733281 55.24028,56.710285 55.227167,56.687288 55.135251,56.664291 55.069467,56.5953 55.056298,56.52631 55.029945,56.52631 54.977188,56.480316 54.937574,56.503313 54.791991,56.388328 54.672486,56.388328 54.632572,56.342335 54.605942,56.388328 54.565963,56.319338 54.445791,56.181357 54.445791,56.089369 54.419038,56.020378 54.419038,55.905394 54.459161,55.836403 54.472527,55.652428 54.525945,55.560441 54.525945,55.537444 54.512597,55.330472 54.485888,55.307475 54.472527,55.192491 54.472527,54.939525 54.459161,54.824541 54.472527,54.778547 54.445791,54.68656 54.445791,54.594572 54.472527,54.387601 54.499245,54.341607 54.485888,54.272616 54.445791,54.203626 54.445791,54.088641 54.459161,53.95066 54.378876,53.766685 54.378876,53.444729 54.432417,53.421732 54.432417,53.375738 54.472527))","code":"ufa","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"17","name":"Уфа","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((53.191763 63.468254,53.191763 63.499055,53.260754 63.550317,53.513719 63.621928,53.697694 63.69336,53.812679 63.683166,54.088641 63.642356,54.203626 63.601486,54.226622 63.570796,54.157632 63.529823,54.019651 63.365344,53.996654 63.355033,53.881669 63.355033,53.743688 63.385956,53.559713 63.375652,53.191763 63.468254))","code":"ukhta","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"204","name":"Ухта","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((132.622957 48.862248,132.737941 48.907614,132.760938 48.922727,133.0369 48.922727,133.059897 48.937836,133.220875 48.95294,133.243872 48.95294,133.266869 48.877375,133.381853 48.831981,133.473841 48.831981,133.565828 48.74107,133.749803 48.74107,133.864788 48.665185,134.094756 48.634798,134.255734 48.680371,134.255734 48.725902,134.439709 48.725902,134.462706 48.680371,134.531697 48.665185,134.554694 48.619599,134.623684 48.604394,134.646681 48.619599,134.692675 48.589185,134.761666 48.573971,134.853653 48.619599,134.87665 48.634798,135.198606 48.634798,135.267597 48.619599,135.267597 48.32993,135.2446 48.284042,135.152612 48.284042,135.106619 48.253426,134.991634 48.238112,134.784663 48.345217,134.761666 48.345217,134.761666 48.360499,134.692675 48.406319,134.439709 48.421583,134.416713 48.436842,134.324725 48.436842,133.887785 48.482593,133.197878 48.619599,132.990907 48.649994,132.737941 48.665185,132.66895 48.695552,132.66895 48.771392,132.622957 48.801695,132.622957 48.862248))","code":"khabarovsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"35","name":"Хабаровск","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((68.875629 60.983694,68.875629 61.017141,68.921623 61.017141,68.921623 61.039419,68.967617 61.083929,69.082601 61.11727,69.128595 61.095046,69.197586 61.083929,69.243579 61.10616,69.335567 61.095046,69.427554 61.028282,69.427554 61.017141,69.404558 61.005996,69.381561 60.972537,69.128595 60.916694,69.082601 60.916694,68.875629 60.983694))","code":"kh_mansiysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"150","name":"Ханты-Мансийск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((46.535458 43.259124,46.541148 43.268721,46.542462 43.281203,46.551959 43.28555,46.570952 43.290521,46.582537 43.295467,46.614005 43.287527,46.625543 43.279002,46.624817 43.277832,46.623827 43.277209,46.623305 43.276984,46.623237 43.276944,46.623074 43.276769,46.622766 43.276572,46.622732 43.276525,46.622625 43.276271,46.622621 43.276203,46.622647 43.276125,46.622711 43.276062,46.622963 43.275918,46.623027 43.275871,46.623199 43.275634,46.623789 43.275037,46.625778 43.272249,46.625821 43.272161,46.626035 43.271457,46.626035 43.271347,46.626005 43.270972,46.625958 43.270869,46.624806 43.269568,46.62414 43.268584,46.624036 43.268484,46.623677 43.268263,46.623593 43.268221,46.623523 43.268151,46.623473 43.268076,46.623347 43.267823,46.62324 43.267531,46.623181 43.26731,46.623152 43.267082,46.623161 43.266852,46.623462 43.265283,46.623497 43.265137,46.623462 43.264948,46.623419 43.264848,46.623064 43.263577,46.623069 43.263495,46.623106 43.263422,46.623204 43.263357,46.623269 43.263341,46.623564 43.263354,46.623654 43.263341,46.623731 43.263307,46.623808 43.263241,46.623863 43.263169,46.623893 43.263069,46.623919 43.262544,46.62395 43.262475,46.624113 43.262328,46.624143 43.262262,46.624139 43.262191,46.624678 43.258032,46.62469 43.257869,46.624669 43.257804,46.624626 43.257744,46.624559 43.257702,46.624507 43.257645,46.624366 43.257458,46.624331 43.257391,46.624315 43.257295,46.624336 43.257242,46.624503 43.257123,46.62721 43.254007,46.627539 43.253591,46.62849 43.252289,46.628756 43.251893,46.629256 43.250959,46.629297 43.250675,46.629256 43.250414,46.629093 43.250048,46.628929 43.249794,46.627447 43.248284,46.627302 43.247941,46.627059 43.246842,46.626978 43.246311,46.627091 43.243581,46.627285 43.243132,46.627657 43.24266,46.628142 43.242223,46.629257 43.241478,46.637533 43.236811,46.637887 43.236487,46.63813 43.236067,46.639324 43.233578,46.639408 43.23319,46.639412 43.232819,46.639301 43.232431,46.638616 43.231138,46.638462 43.230669,46.638506 43.230233,46.638793 43.229651,46.639169 43.229295,46.640385 43.228632,46.641357 43.228277,46.641667 43.228034,46.641888 43.227646,46.644849 43.216819,46.648661 43.209742,46.64652 43.208119,46.63438 43.204182,46.627887 43.202295,46.621346 43.20096,46.615262 43.199958,46.608873 43.199291,46.602332 43.198957,46.596399 43.199235,46.591075 43.199847,46.584382 43.201294,46.577994 43.203297,46.572213 43.205411,46.566585 43.208415,46.562281 43.21131,46.559207 43.213867,46.552417 43.22056,46.538973 43.238001,46.538182 43.242044,46.538182 43.243175,46.538681 43.249086,46.538631 43.250217,46.538332 43.251239,46.535458 43.259124))","code":"khasavyurt","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true},"id":"151","name":"Хасавюрт","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((95.552 73.035374,95.552 73.062193,95.620991 73.082281,95.643988 73.109029,95.620991 73.142406,95.689981 73.175718,95.781969 73.175718,95.827963 73.208967,95.896953 73.215609,95.91995 73.222249,95.91995 73.242152,95.873956 73.268654,95.91995 73.314935,96.034934 73.347917,96.057931 73.380835,96.034934 73.41369,96.057931 73.433373,96.057931 73.47267,95.988941 73.505348,95.988941 73.531446,96.149919 73.57702,96.149919 73.603007,96.241906 73.615986,96.517869 73.615986,96.609856 73.641913,96.678847 73.648389,96.701844 73.654862,96.678847 73.68719,96.724841 73.732345,96.747837 73.732345,96.931812 73.764524,97.092791 73.80947,97.115787 73.841501,97.138784 73.841501,97.138784 73.905377,97.184778 73.930858,97.322759 73.943584,97.39175 73.937222,97.483737 73.918122,97.598722 73.924491,97.690709 73.962655,97.690709 73.981703,97.644715 74.007067,97.667712 74.057678,97.736703 74.063993,97.805694 74.095533,97.897681 74.101834,97.943675 74.08923,98.012665 74.082924,98.104653 74.101834,98.12765 74.120721,98.19664 74.152152,98.380615 74.158431,98.4956 74.152152,98.633581 74.101834,98.748565 74.095533,98.86355 74.101834,98.909543 74.133301,99.070521 74.133301,99.093518 74.139587,99.254496 74.145871,99.277493 74.139587,99.415475 74.133301,99.438471 74.152152,99.530459 74.189789,99.714434 74.214832,99.783424 74.246081,99.783424 74.252323,99.829418 74.264801,99.852415 74.302177,99.921406 74.320833,99.944403 74.339467,99.921406 74.345673,99.852415 74.351877,99.691437 74.370475,99.30049 74.37667,99.208503 74.413787,99.2315 74.419965,99.254496 74.413787,99.369481 74.413787,99.392478 74.419965,99.484465 74.413787,99.553456 74.432313,99.66844 74.444652,99.714434 74.438484,99.737431 74.432313,99.875412 74.382862,99.990396 74.364278,100.082384 74.364278,100.128378 74.37667,100.220365 74.438484,100.243362 74.444652,100.289356 74.481611,100.289356 74.500059,100.358346 74.506203,100.40434 74.524622,100.427337 74.530757,100.542321 74.524622,100.542321 74.549148,100.496327 74.561396,100.519324 74.579751,100.634309 74.591976,100.542321 74.652959,100.473331 74.677286,100.473331 74.695506,100.40434 74.713706,100.450334 74.798357,100.40434 74.810413,100.289356 74.816437,100.266359 74.834496,100.220365 74.846524,100.197368 74.876553,100.266359 74.900534,100.312352 74.91251,100.40434 74.918495,100.427337 74.91251,100.519324 74.918495,100.588315 74.948384,100.565318 75.013937,100.611312 75.025825,100.611312 75.043641,100.519324 75.061436,100.40434 75.055506,100.381343 75.049575,100.266359 75.055506,100.105381 75.049575,100.128378 75.08513,100.082384 75.096964,100.082384 75.102877,100.059387 75.102877,100.059387 75.120603,100.082384 75.126507,100.082384 75.132409,100.174371 75.144206,100.197368 75.150101,100.151374 75.185422,100.082384 75.191301,100.059387 75.191301,100.03639 75.208925,100.128378 75.23239,100.105381 75.261671,100.105381 75.279213,100.082384 75.279213,100.082384 75.285055,100.013393 75.302569,99.944403 75.308403,99.898409 75.331714,99.829418 75.337537,99.806421 75.343356,99.691437 75.35499,99.714434 75.378229,99.783424 75.384033,99.806421 75.401432,99.783424 75.401432,99.783424 75.41881,99.898409 75.41302,100.013393 75.41881,100.082384 75.41302,100.151374 75.41302,100.151374 75.430385,100.105381 75.44195,100.105381 75.453507,100.243362 75.453507,100.266359 75.470825,100.381343 75.476593,100.427337 75.511155,100.496327 75.511155,100.496327 75.534152,100.519324 75.562847,100.588315 75.557113,100.634309 75.557113,100.634309 75.57431,100.703299 75.580038,100.726296 75.585763,100.795287 75.591487,100.887274 75.614359,100.956265 75.620071,100.956265 75.631489,101.094246 75.631489,101.117243 75.6486,101.186234 75.6486,101.232227 75.637195,101.301218 75.642899,101.324215 75.659996,101.393205 75.66569,101.531187 75.699812,101.692165 75.716843,101.830146 75.728186,101.830146 75.733854,101.94513 75.73952,102.060115 75.733854,102.31308 75.77912,102.428065 75.807339,102.497055 75.812977,102.704027 75.852377,102.750021 75.852377,102.773018 75.86923,102.819011 75.880454,102.819011 75.914075,102.865005 75.942032,102.97999 75.95878,103.140968 75.981081,103.186961 75.997784,103.209958 76.014467,103.301946 76.036681,103.41693 76.053318,103.41693 76.108637,103.554911 76.136216,103.577908 76.141726,103.623902 76.174736,103.646899 76.180231,103.715889 76.20767,103.807877 76.20767,103.807877 76.224108,103.761883 76.235056,103.761883 76.240527,103.968855 76.267849,103.968855 76.284216,103.922861 76.295118,103.899864 76.311453,103.876868 76.349496,103.830874 76.360346,103.899864 76.376606,103.968855 76.382021,104.060843 76.382021,104.106836 76.392846,104.198824 76.403662,104.290811 76.403662,104.336805 76.41447,104.612767 76.41447,105.003714 76.398255,105.072705 76.41447,105.141695 76.409068,105.187689 76.398255,105.25668 76.398255,105.279677 76.41447,105.279677 76.430667,105.348667 76.457618,105.440655 76.463002,105.647627 76.511364,105.716617 76.511364,105.785608 76.495262,105.831602 76.495262,105.969583 76.516727,106.222548 76.543511,106.36053 76.543511,106.383527 76.548861,106.452517 76.543511,106.475514 76.505999,106.590498 76.489891,106.774473 76.489891,106.820467 76.463002,106.889458 76.463002,106.866461 76.495262,106.889458 76.500631,107.050436 76.495262,107.142423 76.516727,107.487376 76.671347,107.602361 76.72426,107.809333 76.813739,107.878323 76.845178,108.26927 77.016781,108.315264 77.02711,108.384254 77.021946,108.775201 76.933856,108.936179 76.928656,109.07416 76.939054,109.327126 76.954636,109.511101 76.954636,109.879051 76.933856,110.10902 76.928656,110.132017 76.933856,110.224004 76.949444,110.384982 76.970199,110.614951 76.985745,110.729935 76.990922,110.982901 76.990922,111.304857 76.970199,111.396844 76.970199,111.695804 76.939054,111.856782 76.913043,112.132744 76.855641,112.270726 76.850411,112.293722 76.845178,112.569685 76.834706,112.776657 76.818984,112.799654 76.813739,112.845647 76.813739,112.868644 76.808492,113.052619 76.782226,113.259591 76.72426,113.328582 76.708408,113.420569 76.666045,113.466563 76.655433,113.627541 76.6395,113.834513 76.602251,114.041485 76.543511,114.202463 76.484517,114.317447 76.430667,114.340444 76.403662,114.363441 76.338637,114.340444 76.333205,114.317447 76.262389,114.29445 76.218631,114.363441 76.147233,114.685397 75.992218,114.685397 75.986651,114.754388 75.925264,114.754388 75.796058,114.708394 75.716843,114.59341 75.642899,114.59341 75.625781,114.524419 75.551376,114.570413 75.470825,114.570413 75.401432,114.547416 75.360803,114.524419 75.360803,114.478425 75.290896,114.478425 75.25582,114.455428 75.249966,114.432431 75.220662,114.271453 75.132409,114.22546 75.120603,114.202463 75.102877,114.110475 75.061436,113.972494 75.025825,113.880507 74.996086,113.719528 74.930457,113.696532 74.924477,113.627541 74.894542,113.581547 74.894542,112.914638 74.870552,112.454701 74.689435,112.339716 74.646871,112.040757 74.598085,111.856782 74.573635,111.856782 74.567517,111.787791 74.561396,111.488832 74.518485,111.051891 74.444652,110.706938 74.37667,110.499966 74.333258,110.499966 74.314617,110.706938 74.271037,111.143879 74.189789,111.672807 74.139587,111.856782 74.114428,111.856782 74.108132,111.879779 74.108132,111.902776 74.013402,111.879779 73.99439,111.856782 73.988048,111.856782 73.981703,111.511829 73.899,111.373848 73.860689,111.304857 73.854295,111.28186 73.841501,111.258863 73.841501,111.189873 73.82229,111.074888 73.82229,111.005898 73.815881,110.890913 73.758093,110.867916 73.725901,110.867916 73.706557,110.982901 73.700104,111.074888 73.674266,111.166876 73.661332,111.212869 73.622471,111.258863 73.622471,111.258863 73.603007,111.189873 73.596514,111.005898 73.557503,110.890913 73.564011,110.84492 73.544479,110.84492 73.511876,110.729935 73.485749,110.706938 73.47921,110.637948 73.453032,110.637948 73.433373,110.591954 73.426814,110.568957 73.433373,110.499966 73.433373,110.453973 73.420253,110.247001 73.400555,110.132017 73.407124,110.132017 73.387411,110.315991 73.354505,110.407979 73.347917,110.453973 73.334732,110.522963 73.334732,110.591954 73.275274,110.614951 73.268654,110.614951 73.248782,110.453973 73.215609,110.430976 73.208967,110.361985 73.202323,110.361985 73.155738,110.522963 73.149073,110.591954 73.162401,110.775929 73.155738,110.798926 73.162401,110.84492 73.149073,110.798926 73.109029,110.775929 73.102346,110.821923 73.062193,110.84492 73.055492,110.821923 73.021949,110.752932 73.021949,110.683941 72.98834,110.706938 72.954667,110.798926 72.954667,110.867916 72.934433,110.821923 72.934433,110.798926 72.907417,110.706938 72.907417,110.637948 72.880359,110.660945 72.839695,110.706938 72.839695,110.729935 72.805737,110.660945 72.785331,110.683941 72.737625,110.706938 72.730799,110.706938 72.696632,110.775929 72.648688,110.890913 72.634966,110.91391 72.621234,110.890913 72.614364,110.890913 72.579973,110.959904 72.573087,111.074888 72.566198,111.143879 72.566198,111.304857 72.504082,111.28186 72.483329,111.120882 72.448687,111.028895 72.441751,111.051891 72.40703,111.028895 72.386165,111.097885 72.365277,111.166876 72.358309,111.327854 72.323428,111.350851 72.316444,111.557823 72.323428,111.580819 72.316444,111.64981 72.28848,111.64981 72.246455,111.603816 72.232425,111.603816 72.21136,111.695804 72.21136,111.695804 72.183235,111.718801 72.162114,111.787791 72.162114,111.856782 72.140968,111.856782 72.133914,111.994763 72.126858,111.994763 71.400091,112.201735 71.378073,112.293722 71.35603,112.362713 71.319236,112.500694 71.274991,112.523691 71.282372,112.638675 71.289751,112.638675 71.274991,112.707666 71.252831,112.684669 71.201025,112.546688 71.17878,112.523691 71.15651,112.546688 71.134214,112.569685 71.126777,112.592682 71.104447,112.500694 71.096998,112.477697 71.074635,112.362713 71.067175,112.270726 71.044777,112.270726 71.014874,112.201735 71.007392,112.132744 71.044777,112.086751 71.059712,112.01776 71.052246,111.994763 71.022354,111.948769 70.977432,111.856782 70.977432,111.856782 70.969935,111.787791 70.962435,111.695804 70.962435,111.626813 70.939918,111.557823 70.939918,111.465835 70.924893,111.442838 70.879748,111.350851 70.857137,111.166876 70.857137,111.028895 70.834501,110.959904 70.811838,110.84492 70.78915,110.821923 70.781582,110.798926 70.78915,110.729935 70.796716,110.568957 70.774011,110.499966 70.743697,110.499966 70.705739,110.338988 70.698139,110.269998 70.660096,110.201007 70.660096,110.132017 70.62198,110.10902 70.576146,110.132017 70.568497,110.132017 70.537871,110.086023 70.522541,110.10902 70.499524,110.10902 70.468794,110.224004 70.445716,110.247001 70.438018,110.315991 70.430316,110.292995 70.407194,110.10902 70.407194,110.086023 70.399481,110.017032 70.407194,109.994035 70.399481,109.925045 70.391765,109.764067 70.384046,109.718073 70.3686,109.649082 70.3686,109.580092 70.360872,109.603088 70.291192,109.580092 70.252378,109.488104 70.229054,109.465107 70.221274,109.44211 70.221274,109.44211 70.21349,109.37312 70.21349,109.304129 70.205704,109.304129 70.151118,109.350123 70.135495,109.350123 70.080723,109.419114 70.049359,109.534098 70.03366,109.534098 70.002225,109.488104 69.98649,109.396117 69.962865,109.396117 69.883923,109.37312 69.828486,109.327126 69.81262,109.327126 69.780852,109.212142 69.756994,108.982173 69.772902,108.913182 69.796742,108.913182 69.836414,108.706211 69.828486,108.683214 69.836414,108.568229 69.828486,108.499239 69.84434,108.338261 69.852262,108.246273 69.852262,108.223276 69.828486,108.154286 69.820554,108.131289 69.796742,108.062298 69.788798,108.016304 69.749036,108.016304 69.701222,107.924317 69.669286,107.855326 69.68526,107.671351 69.669286,107.53337 69.645302,107.464379 69.621292,107.280404 69.60527,107.280404 69.597254,107.188417 69.589235,107.119426 69.565161,106.981445 69.549097,106.866461 69.524978,106.751476 69.533021,106.636492 69.524978,106.590498 69.573189,106.475514 69.573189,106.383527 69.54106,106.337533 69.54106,106.314536 69.533021,106.245545 69.524978,106.176555 69.549097,106.084567 69.549097,106.06157 69.508883,105.831602 69.508883,105.808605 69.484719,105.831602 69.460527,105.808605 69.412061,105.647627 69.371589,105.532642 69.355379,105.417658 69.363486,105.371664 69.34727,105.302674 69.339157,105.233683 69.355379,105.25668 69.420146,105.141695 69.428228,104.980717 69.428228,104.95772 69.436307,104.88873 69.444384,104.819739 69.460527,104.658761 69.452457,104.52078 69.452457,104.451789 69.460527,104.382799 69.452457,104.382799 69.395881,104.336805 69.34727,104.221821 69.339157,104.129833 69.363486,104.060843 69.355379,104.014849 69.339157,103.899864 69.282284,103.830874 69.282284,103.692893 69.298549,103.669896 69.306676,103.623902 69.331042,103.554911 69.339157,103.554911 69.37969,103.531914 69.403973,103.370936 69.395881,103.34794 69.387787,103.140968 69.395881,103.025983 69.371589,102.956993 69.34727,102.888002 69.34727,102.750021 69.363486,102.704027 69.37969,102.61204 69.387787,102.589043 69.395881,102.520052 69.403973,102.336077 69.436307,102.31308 69.444384,102.175099 69.460527,102.175099 69.484719,102.221093 69.508883,101.968127 69.597254,101.738159 69.613282,101.57718 69.581214,101.462196 69.573189,101.393205 69.581214,101.347212 69.597254,101.186234 69.621292,101.025256 69.621292,100.864277 69.6533,100.795287 69.661294,100.726296 69.6533,100.680302 69.60527,100.611312 69.597254,100.542321 69.557131,100.473331 69.557131,100.40434 69.581214,100.381343 69.6533,100.427337 69.677274,100.40434 69.749036,100.289356 69.76495,100.312352 69.820554,100.266359 69.820554,100.220365 69.852262,100.082384 69.868099,99.967399 69.89183,99.806421 69.883923,99.760428 69.907637,99.553456 69.931324,99.346484 69.907637,99.323487 69.868099,99.369481 69.868099,99.369481 69.852262,99.30049 69.828486,99.323487 69.756994,99.277493 69.741074,99.185506 69.741074,99.070521 69.76495,99.001531 69.756994,98.840553 69.756994,98.633581 69.76495,98.610584 69.756994,98.518597 69.749036,98.357618 69.788798,98.334622 69.788798,98.219637 69.81262,98.19664 69.820554,98.081656 69.81262,98.058659 69.828486,97.989668 69.852262,97.943675 69.899735,97.644715 70.002225,97.667712 70.041511,97.690709 70.041511,97.667712 70.088556,97.782697 70.174529,97.805694 70.182327,97.805694 70.221274,97.82869 70.236832,97.851687 70.275675,97.943675 70.291192,98.150647 70.353142,98.173643 70.376325,98.104653 70.414905,98.081656 70.422612,98.081656 70.453412,98.012665 70.484165,98.035662 70.522541,98.035662 70.55319,98.012665 70.560845,97.989668 70.583792,97.782697 70.599076,97.667712 70.599076,97.644715 70.591436,97.506734 70.583792,97.46074 70.568497,97.39175 70.576146,97.368753 70.614348,97.39175 70.62198,97.506734 70.629609,97.506734 70.637235,97.552728 70.660096,97.529731 70.698139,97.575725 70.713337,97.506734 70.751279,97.506734 70.774011,97.598722 70.751279,97.667712 70.758859,97.621719 70.774011,97.598722 70.796716,97.529731 70.804279,97.345756 70.834501,97.299762 70.849595,97.161781 70.849595,97.092791 70.857137,96.356891 71.089547,96.356891 71.111893,96.425881 71.119336,96.471875 71.134214,96.540866 71.134214,96.563862 71.15651,96.540866 71.15651,96.540866 71.186198,96.563862 71.193613,96.586859 71.21584,96.540866 71.230645,96.540866 71.252831,96.65585 71.297126,96.724841 71.319236,96.747837 71.370728,96.770834 71.392754,96.793831 71.400091,96.793831 71.429408,96.65585 71.458682,96.586859 71.480607,96.356891 71.524384,96.333894 71.546235,96.402884 71.57533,96.425881 71.582597,96.448878 71.61889,96.379888 71.662351,96.310897 71.669585,96.2879 71.69127,96.264903 71.727356,96.241906 71.727356,96.172916 71.763374,96.195913 71.770569,96.218909 71.799323,96.195913 71.835204,96.057931 71.849537,96.057931 71.863859,96.080928 71.871016,96.126922 71.90676,96.126922 71.956688,96.034934 71.999376,95.965944 71.999376,95.942947 72.020684,95.965944 72.027781,95.942947 72.034876,95.942947 72.063227,95.965944 72.070308,95.988941 72.091534,95.91995 72.091534,95.850959 72.098604,95.873956 72.119798,95.91995 72.119798,95.965944 72.133914,95.965944 72.183235,95.91995 72.239441,95.91995 72.281483,95.988941 72.28848,96.011938 72.309457,95.988941 72.309457,96.011938 72.330409,95.988941 72.337388,95.965944 72.393123,96.034934 72.434812,96.011938 72.455621,95.873956 72.504082,95.91995 72.573087,95.942947 72.579973,95.91995 72.628101,95.827963 72.655545,95.827963 72.682947,95.896953 72.710307,95.91995 72.71714,95.850959 72.751268,95.942947 72.798938,95.942947 72.812534,95.827963 72.846479,95.712978 72.907417,95.620991 72.907417,95.552 72.927683,95.574997 72.947925,95.506006 73.021949,95.552 73.035374))","code":"khatanga_sp","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true,"traffic":true},"id":"276","name":"Хатанга сп","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":16,"min":9}},{"bounds":"POLYGON((76.211631 55.371178,76.234628 55.410363,76.326616 55.410363,76.395606 55.436465,76.395606 55.475585,76.418603 55.514667,76.602578 55.514667,76.602578 55.488617,76.694566 55.488617,76.763556 55.553709,76.832547 55.566715,76.970528 55.540699,77.085513 55.566715,77.154503 55.605706,77.407469 55.592713,77.407469 55.540699,77.54545 55.514667,77.568447 55.449509,77.706428 55.423416,77.821412 55.397306,77.844409 55.358108,77.660434 55.358108,77.591444 55.345033,77.591444 55.279595,77.683431 55.25339,77.660434 55.227167,77.522453 55.214049,77.407469 55.17467,77.407469 55.082633,77.476459 54.990384,77.499456 54.990384,77.522453 54.871465,77.522453 54.844991,77.453462 54.791991,77.384472 54.77873,77.361475 54.765465,77.246491 54.725643,77.246491 54.738921,76.901538 54.884696,76.80955 55.016762,76.694566 55.016762,76.671569 55.003575,76.602578 54.990384,76.533588 55.016762,76.533588 55.029945,76.464597 55.056298,76.464597 55.082633,76.326616 55.135251,76.326616 55.200927,76.372609 55.200927,76.372609 55.279595,76.211631 55.371178))","code":"chany","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"192","name":"Чаны","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((46.936614 56.211525,46.959611 56.249873,46.982608 56.249873,47.097592 56.288183,47.097592 56.300945,47.143586 56.326455,47.419549 56.326455,47.534533 56.313702,47.603524 56.300945,47.603524 56.134713,47.580527 56.121896,47.580527 56.006351,47.511536 55.967759,47.350558 55.980627,47.166583 55.980627,47.097592 55.993491,47.051599 55.993491,46.982608 56.006351,46.982608 56.070585,47.005605 56.083419,46.959611 56.173138,46.936614 56.211525))","code":"cheboksary","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"53","name":"Чебоксары","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((60.458775 54.897922,60.481771 55.043123,60.481771 55.17467,60.458775 55.24028,60.550762 55.318871,60.619753 55.397306,60.688743 55.488617,60.688743 55.631679,60.803728 55.696535,61.171678 55.761284,61.700606 55.735397,61.907577 55.592713,62.137546 55.410363,62.18354 55.410363,62.252531 55.358108,62.229534 55.345033,62.068556 55.292691,62.068556 55.25339,62.137546 55.24028,62.206537 55.1878,62.229534 55.122103,62.275527 55.095794,62.18354 54.990384,62.022562 54.977188,61.999565 54.937574,62.091552 54.884696,62.114549 54.8185,62.022562 54.738921,62.022562 54.725643,61.884581 54.311852,61.746599 54.09664,61.723602 54.029156,61.631615 54.015646,61.631615 53.988613,61.585621 53.988613,61.493634 54.029156,61.470637 54.083152,61.309659 54.083152,61.240668 54.09664,61.056693 54.190933,60.987703 54.177476,60.895715 54.190933,60.872718 54.177476,60.803728 54.164014,60.780731 54.204386,60.757734 54.204386,60.757734 54.217835,60.481771 54.699073,60.458775 54.897922))","code":"chelyabinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"15","name":"Челябинск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.934431 43.452614,40.980425 43.485993,41.072412 43.586022,41.348375 43.652615,41.463359 43.752367,41.53235 43.885111,41.60134 43.901683,41.739321 43.901683,41.854306 43.918251,41.923296 44.067152,41.992287 44.149714,41.992287 44.281572,42.061278 44.31449,42.360237 44.298034,42.475221 44.281572,42.544212 44.265106,42.360237 44.13321,42.314243 44.083674,42.314243 44.050626,42.383234 43.967926,42.475221 43.967926,42.498218 44.034095,42.567209 44.034095,42.590206 43.967926,42.636199 43.934814,42.636199 43.835366,42.659196 43.818776,42.682193 43.735753,42.659196 43.685884,42.521215 43.635974,42.475221 43.635974,42.475221 43.569362,42.452224 43.452614,42.406231 43.419216,42.406231 43.251949,42.383234 43.251949,42.33724 43.21844,42.130268 43.21844,42.107271 43.201679,42.038281 43.201679,41.877303 43.235197,41.854306 43.21844,41.739321 43.21844,41.716324 43.235197,41.693328 43.21844,41.60134 43.235197,41.463359 43.302177,41.440362 43.302177,41.417365 43.352364,41.325378 43.352364,41.210393 43.369084,41.210393 43.385799,40.980425 43.419216,40.934431 43.452614))","code":"cherkessk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"118","name":"Черкесск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.659706 54.137078,75.659706 54.539289,75.797688 54.565963,75.820685 54.645881,75.751694 54.685782,75.751694 54.725643,75.866678 54.765465,76.027656 54.791991,76.096647 54.791991,76.211631 54.85823,76.188635 54.937574,76.280622 54.977188,76.326616 55.003575,76.418603 55.043123,76.464597 55.056298,76.533588 55.029945,76.533588 55.016762,76.602578 54.990384,76.671569 55.003575,76.694566 55.016762,76.80955 55.016762,76.901538 54.884696,77.246491 54.738921,77.246491 54.71236,77.108509 54.672486,77.131506 54.605942,76.993525 54.579294,76.993525 54.539289,76.924534 54.485888,76.901538 54.419038,76.80955 54.405655,76.740559 54.392268,76.717563 54.35208,76.648572 54.325266,76.556584 54.325266,76.533588 54.311852,76.464597 54.298434,76.303619 54.338675,76.257625 54.338675,76.234628 54.298434,76.257625 54.258154,76.119644 54.217835,76.07365 54.217835,76.07365 54.204386,76.027656 54.204386,76.00466 54.190933,75.912672 54.177476,75.866678 54.150548,75.7057 54.110123,75.659706 54.137078))","code":"chistoozernoe","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"193","name":"Чистоозёрное","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((112.316719 52.052369,112.339716 52.123022,112.38571 52.207657,112.454701 52.221748,112.500694 52.249915,112.523691 52.320254,112.546688 52.348359,112.891641 52.334309,113.12161 52.418543,113.167604 52.446585,113.236594 52.460599,113.397572 52.460599,113.397572 52.432566,113.512557 52.334309,113.535553 52.320254,113.55855 52.263992,113.673535 52.221748,113.788519 52.207657,113.811516 52.16536,113.788519 51.953267,113.604544 51.839739,113.443566 51.811313,113.374575 51.782868,113.374575 51.740167,113.305585 51.740167,113.167604 51.825528,113.075616 51.825528,113.006625 51.868148,112.891641 51.896539,112.477697 51.924912,112.362713 51.967438,112.339716 52.038225,112.316719 52.052369))","code":"chita","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"64","name":"Чита","time_zone":{"name":"Asia/Chita","offset":540},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((80.466053 54.937574,80.535043 54.977188,80.581037 55.029945,80.604034 55.200927,80.604034 55.24028,80.765012 55.279595,80.856999 55.279595,80.92599 55.358108,80.948987 55.371178,80.971984 55.410363,81.132962 55.436465,81.132962 55.475585,81.086968 55.501644,81.086968 55.644659,81.063971 55.709493,81.086968 55.748342,81.29394 55.813005,81.615896 55.916243,81.730881 55.954886,81.753877 55.967759,81.776874 55.967759,81.799871 55.929128,81.937852 55.77422,82.02984 55.644659,82.121827 55.540699,82.121827 55.501644,82.075834 55.501644,81.868862 55.449509,81.546906 55.397306,81.500912 55.371178,81.385927 55.331954,81.385927 55.292691,81.454918 55.279595,81.454918 55.135251,81.431921 55.122103,81.454918 55.056298,81.408924 55.003575,81.362931 54.977188,81.385927 54.937574,81.454918 54.937574,81.569902 54.871465,81.523909 54.8185,81.546906 54.791991,81.66189 54.699073,81.684887 54.685782,81.707884 54.632572,81.592899 54.619259,81.523909 54.605942,81.546906 54.525945,81.339934 54.445791,81.270943 54.432417,81.224949 54.459161,81.017977 54.445791,80.92599 54.499245,80.902993 54.539289,80.788009 54.565963,80.673024 54.552628,80.673024 54.605942,80.512046 54.672486,80.489049 54.738921,80.535043 54.752195,80.604034 54.844991,80.581037 54.897922,80.512046 54.897922,80.466053 54.937574))","code":"chulym","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"166","name":"Чулым","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.083547 47.699215,40.083547 47.761088,40.106544 47.807444,40.175534 47.807444,40.244525 47.776545,40.359509 47.761088,40.359509 47.71469,40.175534 47.62177,40.152537 47.652762,40.083547 47.699215))","code":"shakhty","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"152","name":"Шахты","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((86.928173 53.457952,86.928173 53.49901,87.480098 53.49901,87.595083 53.416854,87.641076 53.320805,87.848048 53.334539,87.894042 53.252065,87.963033 53.252065,88.101014 53.196994,88.101014 53.141852,88.124011 53.128056,88.078017 52.948297,88.101014 52.934438,88.032023 52.7817,87.963033 52.726026,87.894042 52.712096,87.779058 52.753872,87.779058 52.837304,87.68707 52.892836,87.61808 52.906708,87.457101 52.892836,87.342117 53.003687,87.31912 53.059007,87.227133 53.141852,87.112148 53.210769,87.112148 53.279574,87.066155 53.307066,86.95117 53.444257,86.928173 53.457952))","code":"sheregesh","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"206","name":"Шерегеш","time_zone":{"name":"Asia/Novokuznetsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((68.737648 42.408709,68.737648 42.459627,68.829636 42.49355,68.898626 42.5444,68.921623 42.5444,68.921623 42.561341,69.036608 42.662889,69.128595 42.662889,69.220583 42.696701,69.381561 42.679797,69.404558 42.696701,69.519542 42.747385,69.542539 42.747385,69.565536 42.730495,69.496545 42.679797,69.496545 42.612135,69.565536 42.629058,69.726514 42.612135,70.071467 42.629058,70.140457 42.595208,70.140457 42.5444,70.025473 42.391727,70.071467 42.289737,70.232445 42.238681,70.301435 42.221653,70.301435 42.187583,70.255442 42.136444,70.04847 42.085263,69.979479 42.085263,69.933486 42.119388,69.841498 42.119388,69.68052 42.068194,69.450551 41.811602,69.450551 41.622779,69.381561 41.571186,69.059604 41.605586,69.013611 41.622779,68.94462 42.05112,68.737648 42.408709))","code":"shymkent","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"161","name":"Шымкент","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.199769 51.797093,75.360747 52.052369,75.429738 52.052369,75.498728 52.038225,75.498728 51.995766,75.360747 51.882346,75.383744 51.825528,75.544722 51.754405,75.590716 51.626101,75.889675 51.46879,76.00466 51.065906,75.958666 50.761422,75.63671 50.67406,75.291757 50.688632,75.26876 50.703199,75.245763 50.834099,75.33775 50.863138,75.521725 50.877651,75.590716 50.906663,75.567719 50.979114,75.406741 51.56896,75.245763 51.640375,75.199769 51.797093))","code":"ekibastuz","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"252","name":"Экибастуз","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.153993 46.335269,44.199987 46.382882,44.291974 46.382882,44.360965 46.367015,44.383962 46.319388,44.360965 46.303504,44.337968 46.255822,44.153993 46.255822,44.153993 46.335269))","code":"elista","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"153","name":"Элиста","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((140.602871 48.756233,140.602871 48.81684,140.671862 48.831981,140.717855 48.801695,141.246783 48.207469,141.292777 48.176808,141.292777 48.146129,141.315774 48.130782,141.660727 47.745627,141.683724 47.730161,141.706721 47.683735,141.982683 47.62177,142.097668 47.49762,142.166658 47.49762,142.281643 47.606268,142.350633 47.62177,142.350633 47.699215,142.419624 47.71469,142.419624 47.761088,142.350633 47.838326,142.350633 47.930859,142.442621 48.038607,142.465618 48.100075,142.442621 48.100075,142.396627 48.222793,142.396627 48.299342,142.442621 48.436842,142.465618 48.436842,142.488614 48.573971,142.442621 48.619599,142.442621 48.786546,142.465618 48.786546,142.511611 48.983134,142.534608 49.02839,142.488614 49.148874,142.488614 49.224027,142.511611 49.224027,142.557605 49.359017,142.534608 49.463753,142.787574 49.463753,142.856564 49.508571,142.925555 49.508571,143.086533 49.493636,143.086533 49.583177,143.017542 49.65767,143.040539 49.702311,143.224514 49.702311,143.523474 49.717182,143.592464 49.761768,143.753442 49.880464,143.822433 49.954501,143.91442 49.954501,144.029405 49.998869,144.259373 50.043196,144.305367 50.043196,144.328364 50.028425,144.328364 49.969295,144.351361 49.954501,144.466345 49.761768,144.466345 49.687435,144.558333 49.583177,144.558333 49.523501,144.604327 49.284068,144.627323 49.284068,144.65032 49.209006,144.94928 48.998224,145.01827 48.907614,145.01827 48.81684,145.064264 48.695552,145.064264 48.573971,144.972277 48.467348,144.765305 48.421583,144.673317 48.421583,144.489342 48.452097,144.397355 48.528303,144.328364 48.665185,144.305367 48.756233,144.098395 48.892497,143.868427 49.073606,143.661455 49.088669,143.638458 49.103727,143.500477 49.103727,143.339499 49.058539,143.316502 48.95294,143.293505 48.81684,143.270508 48.801695,143.10953 48.589185,143.040539 48.436842,143.017542 48.360499,142.994546 48.314638,142.902558 48.115431,142.902558 48.053981,142.856564 47.961667,142.856564 47.761088,142.925555 47.652762,143.063536 47.575249,143.155524 47.528685,143.178521 47.513155,143.247511 47.435435,143.270508 47.388747,143.293505 47.388747,143.362496 47.185957,143.362496 47.123404,143.54647 47.045108,143.638458 47.029435,143.707449 46.982389,143.799436 46.85673,143.822433 46.730776,143.84543 46.525471,143.891424 46.509647,143.937417 46.382882,143.91442 46.303504,143.776439 46.096581,143.776439 46.04872,143.707449 45.93688,143.638458 45.856857,143.500477 45.808787,143.362496 45.808787,143.178521 45.872871,143.10953 45.968857,143.086533 46.112526,143.086533 46.239918,143.017542 46.335269,142.902558 46.398743,142.833567 46.398743,142.672589 46.351144,142.580602 46.287614,142.534608 46.096581,142.465618 45.952871,142.37363 45.824815,142.304639 45.648256,142.281643 45.632177,141.913693 45.696464,141.752715 45.712524,141.706721 45.760676,141.729718 45.872871,141.683724 45.904885,141.614733 46.000816,141.614733 46.04872,141.591736 46.22401,141.56874 46.351144,141.545743 46.367015,141.522746 46.4146,141.499749 46.525471,141.499749 46.636117,141.545743 46.730776,141.614733 46.841002,141.63773 46.919596,141.660727 46.935301,141.729718 47.07644,141.729718 47.139049,141.706721 47.139049,141.63773 47.310843,141.63773 47.388747,141.430758 47.668251,141.315774 47.807444,141.292777 47.822887,141.292777 47.853759,141.26978 47.869189,141.062808 48.146129,140.625868 48.710729,140.602871 48.756233))","code":"yuzhnosakhalinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"88","name":"Южно-Сахалинск","time_zone":{"name":"Asia/Sakhalin","offset":660},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((126.620773 62.155043,126.666767 62.18725,126.758754 62.18725,126.919733 62.240852,127.126704 62.262267,127.149701 62.272968,127.149701 62.305049,127.310679 62.337097,127.632636 62.422389,128.023582 62.390433,128.069576 62.411741,128.253551 62.560473,128.48352 62.655695,128.989451 62.708464,129.472385 63.05439,129.518379 63.064809,129.58737 63.075225,129.702354 63.064809,129.909326 63.064809,130.622229 62.876695,130.691219 62.866209,131.105163 62.824226,131.519107 62.666256,131.542104 62.634561,131.611094 62.58166,131.818066 62.379773,132.209013 62.176518,132.415985 62.165783,132.576963 62.155043,132.622957 62.112047,132.645954 61.993493,132.530969 61.96108,132.484975 61.885314,132.369991 61.765875,132.301 61.624119,132.346994 61.514633,132.645954 61.437762,132.852925 61.382738,132.875922 61.382738,132.875922 61.360701,132.760938 61.28345,132.737941 61.183847,132.071032 60.81593,131.657088 60.658553,131.588097 60.624729,131.519107 60.624729,131.427119 60.658553,131.289138 60.714848,130.76021 61.039419,130.32327 61.206009,130.277276 61.206009,129.518379 61.217083,128.575507 61.228154,128.460523 61.28345,128.391532 61.360701,128.368535 61.503663,128.299545 61.547519,128.046579 61.547519,127.908598 61.613188,127.770617 61.635047,127.563645 61.711431,127.517651 61.73322,127.37967 61.765875,127.264686 61.820223,127.126704 61.831082,126.988723 61.885314,126.689764 61.982692,126.64377 61.993493,126.64377 62.036657,126.666767 62.06899,126.620773 62.155043))","code":"yakutsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"50","name":"Якутск","time_zone":{"name":"Asia/Yakutsk","offset":540},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.669603 57.555712,39.715597 57.605028,39.715597 57.764844,39.830581 57.777108,40.014556 57.777108,40.014556 57.740303,40.037553 57.654277,40.083547 57.629661,40.198531 57.592706,40.198531 57.543373,40.152537 57.50633,40.037553 57.50633,40.037553 57.518682,39.6926 57.518682,39.669603 57.555712))","code":"yaroslavl","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":true,"has_net_booklet":true,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"28","name":"Ярославль","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((43.44109 41.03564,43.44109 41.122316,43.602068 41.139637,43.763046 41.122316,43.832037 41.156954,43.924024 41.156954,43.947021 41.174266,44.107999 41.191574,44.17699 41.208877,44.199987 41.226176,44.475949 41.191574,44.54494 41.208877,44.659924 41.226176,44.774908 41.226176,44.797905 41.208877,44.797905 41.278044,44.91289 41.278044,44.935886 41.260759,45.027874 41.278044,45.050871 41.226176,45.050871 41.191574,45.188852 41.174266,45.188852 41.122316,45.119861 41.122316,45.096865 41.070324,45.188852 41.070324,45.188852 41.03564,45.326833 41.018291,45.34983 41.000938,45.395824 41.018291,45.441818 40.966217,45.602796 40.844551,45.579799 40.79234,45.395824 40.722662,45.372827 40.670355,45.395824 40.618007,45.441818 40.583085,45.441818 40.513188,45.579799 40.425713,45.671786 40.373174,45.786771 40.338125,45.809768 40.320593,45.901755 40.303058,45.970746 40.21531,45.970746 40.145029,45.924752 40.109862,45.878758 40.021864,45.625793 40.021864,45.625793 39.969011,45.786771 39.951384,45.832764 39.845527,45.924752 39.792537,45.993743 39.774865,46.154721 39.633323,46.200714 39.597892,46.292702 39.597892,46.338696 39.633323,46.407686 39.61561,46.45368 39.58017,46.545667 39.58017,46.545667 39.526976,46.476677 39.473742,46.384689 39.438229,46.384689 39.384927,46.476677 39.331584,46.545667 39.313794,46.568664 39.206958,46.499674 39.189136,46.45368 39.189136,46.476677 39.135643,46.522671 39.099959,46.545667 39.046399,46.522671 38.921267,46.545667 38.867571,46.292702 38.885474,46.269705 38.849664,46.154721 38.831752,46.154721 38.867571,46.08573 39.064257,46.016739 39.099959,45.993743 39.260396,45.901755 39.349369,45.809768 39.36715,45.809768 39.438229,45.832764 39.455988,45.809768 39.544712,45.763774 39.597892,45.694783 39.597892,45.648789 39.562443,45.579799 39.562443,45.533805 39.526976,45.464815 39.509236,45.372827 39.544712,45.28084 39.61561,45.257843 39.597892,45.188852 39.597892,45.188852 39.633323,45.119861 39.757188,45.050871 39.774865,45.004877 39.739507,44.866896 39.739507,44.751911 39.721821,44.682921 39.739507,44.54494 39.863181,44.452952 39.969011,44.383962 39.986633,44.268977 40.039473,44.199987 40.021864,43.901027 40.004251,43.648062 40.092272,43.625065 40.145029,43.671059 40.180179,43.648062 40.197746,43.625065 40.285517,43.602068 40.285517,43.579071 40.373174,43.602068 40.390692,43.533077 40.478212,43.625065 40.548146,43.694055 40.635461,43.717052 40.722662,43.717052 40.75751,43.648062 40.861946,43.648062 40.931478,43.44109 41.03564))","code":"armenia","country_code":"am","domain":"am","flags":{"2gis_reviews":true,"ctx_layer":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"253","name":"Հայաստան","time_zone":{"name":"Asia/Yerevan","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.842443 20.045316,40.842443 20.110114,40.980425 20.261205,41.026418 20.304346,41.049415 20.369037,41.095409 20.347476,41.072412 20.304346,41.118406 20.261205,41.187396 20.369037,41.210393 20.390594,41.210393 20.455248,41.279384 20.519875,41.279384 20.584474,41.325378 20.670565,41.325378 20.778109,41.394368 20.821105,41.486356 20.799608,41.53235 20.756606,41.60134 20.756606,41.739321 20.627526,41.854306 20.627526,41.877303 20.649047,41.946293 20.670565,41.96929 20.584474,42.107271 20.584474,42.107271 20.519875,42.130268 20.412148,42.015284 20.369037,41.96929 20.261205,41.900299 20.196469,41.831309 19.91564,41.785315 19.872391,41.785315 19.785858,41.762318 19.764217,41.739321 19.699277,41.578343 19.699277,41.555346 19.634311,41.555346 19.547649,41.394368 19.482621,41.279384 19.46094,41.256387 19.525976,41.210393 19.525976,41.141403 19.547649,41.187396 19.590986,41.1644 19.655969,41.095409 19.677625,41.026418 19.720927,41.026418 19.807495,40.911434 19.91564,40.842443 20.045316))","code":"el_baha","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":false},"id":"229","name":"الباحة","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((50.294157 25.885932,50.340151 26.175229,50.386145 26.381431,50.386145 26.484394,50.409142 26.546128,50.478132 26.566699,50.501129 26.648944,50.616114 26.710589,50.777092 26.648944,50.823086 26.566699,50.823086 26.484394,50.869079 26.44322,50.93807 26.298994,50.93807 26.257754,50.915073 26.237128,50.915073 26.07199,50.846082 26.010004,50.823086 25.885932,50.869079 25.76173,50.846082 25.658129,50.823086 25.637398,50.800089 25.575183,50.731098 25.575183,50.57012 25.595925,50.547123 25.595925,50.409142 25.7203,50.340151 25.865241,50.294157 25.885932))","code":"bahrain","country_code":"bh","domain":"bh","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"233","name":"البحرين","time_zone":{"name":"Asia/Bahrain","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((37.024963 31.451463,37.024963 31.510299,37.185941 31.569098,37.300925 31.588689,37.461903 31.647439,37.622881 31.667014,37.645878 31.686585,37.898844 31.745273,37.967834 31.764827,37.967834 31.529903,37.990831 31.392589,37.944838 31.314034,37.944838 31.196079,38.013828 31.196079,38.082819 31.176405,38.128813 31.274732,38.197803 31.294385,38.289791 31.215748,38.266794 31.156728,38.197803 31.137046,38.174806 30.920278,38.243797 30.861073,38.312788 30.900547,38.404775 30.900547,38.58875 30.940004,38.887709 30.920278,38.910706 30.959727,39.117678 30.979445,39.370644 30.959727,39.416637 30.920278,39.531622 30.940004,39.554619 30.959727,39.646606 30.959727,39.76159 30.861073,39.830581 30.880812,39.853578 30.900547,39.922569 30.880812,40.106544 30.782078,40.12954 30.762319,40.244525 30.782078,40.267522 30.841331,40.451497 30.841331,40.474493 30.821584,40.635472 30.762319,40.773453 30.782078,41.026418 30.801833,41.118406 30.762319,41.118406 30.584304,41.187396 30.564505,41.210393 30.584304,41.210393 30.6041,41.371371 30.623891,41.624337 30.564505,41.624337 30.524893,41.60134 30.505082,41.578343 30.445622,41.624337 30.386127,41.739321 30.386127,41.831309 30.306743,41.900299 30.207422,41.96929 30.187546,41.96929 30.108002,41.854306 30.088105,41.785315 30.048301,41.739321 29.94872,41.647334 29.94872,41.53235 29.849039,41.463359 29.849039,41.440362 29.769223,41.463359 29.629392,41.486356 29.569404,41.555346 29.569404,41.555346 29.489366,41.60134 29.409264,41.647334 29.369189,41.647334 29.16858,41.509353 29.16858,41.440362 29.10832,41.417365 29.007809,41.417365 28.92733,40.612475 28.92733,40.49749 28.866929,40.4285 28.846788,40.198531 28.746023,40.152537 28.70569,39.899572 28.645161,39.715597 28.483579,39.485628 28.443145,39.416637 28.402695,39.209666 28.382465,39.209666 28.564401,39.186669 28.624977,39.048687 28.624977,39.025691 28.685517,39.002694 28.806494,38.910706 28.9072,38.772725 28.947456,38.772725 29.208733,38.749728 29.268934,38.680737 29.268934,38.634744 29.309048,38.565753 29.309048,38.542756 29.288993,38.473766 29.208733,38.404775 29.208733,38.404775 29.10832,38.335784 29.007809,38.266794 29.007809,38.197803 29.027919,38.197803 29.148497,38.2208 29.208733,38.312788 29.288993,38.312788 29.369189,38.197803 29.509381,38.197803 29.529393,38.036825 29.589404,37.990831 29.589404,37.944838 29.549401,37.737866 29.569404,37.714869 29.629392,37.737866 29.669363,37.714869 29.689343,37.714869 29.829091,37.645878 29.849039,37.576888 29.90886,37.507897 29.928792,37.461903 30.008481,37.507897 30.048301,37.507897 30.088105,37.668875 30.366287,37.691872 30.366287,37.944838 30.505082,37.829853 30.643679,37.78386 30.683242,37.714869 30.762319,37.438906 31.038576,37.070956 31.392589,37.024963 31.451463))","code":"el_jouf","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":false},"id":"230","name":"الجوف","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((37.944838 31.196079,37.944838 31.314034,37.990831 31.392589,37.967834 31.529903,37.967834 31.764827,38.036825 31.784378,38.128813 31.803924,38.151809 31.823466,38.910706 31.999157,38.979697 32.018658,39.186669 32.155045,39.232662 32.174513,39.301653 32.135574,39.76159 32.057646,40.037553 32.018658,40.106544 31.999157,40.382506 31.960144,40.474493 31.921114,40.957428 31.647439,41.072412 31.588689,41.095409 31.569098,41.210393 31.510299,41.486356 31.35332,41.647334 31.294385,41.877303 31.196079,41.946293 31.176405,42.061278 31.11736,42.084274 31.11736,42.613202 30.742555,42.659196 30.703017,42.797177 30.6041,42.889165 30.544701,43.280112 30.267027,43.326105 30.227294,43.970018 29.769223,44.039008 29.709319,44.24598 29.569404,44.360965 29.469346,44.61393 29.288993,44.636927 29.268934,44.751911 29.188658,44.820902 29.188658,45.165855 29.16858,45.165855 29.128411,45.050871 29.068128,45.027874 28.9072,45.050871 28.887067,45.050871 28.725858,45.073868 28.725858,45.004877 28.463364,44.91289 28.220481,44.91289 28.200216,44.820902 27.956734,44.774908 27.956734,44.728915 27.997352,44.659924 27.997352,44.406958 28.220481,44.314971 28.220481,44.314971 28.240743,44.360965 28.240743,44.360965 28.32175,44.291974 28.443145,43.993015 28.422922,43.80904 28.382465,43.694055 28.402695,43.648062 28.443145,43.556074 28.443145,43.349102 28.523998,43.303109 28.523998,43.234118 28.402695,43.142131 28.382465,42.981152 28.443145,42.935159 28.443145,42.843171 28.50379,42.843171 28.604789,42.797177 28.645161,42.682193 28.665341,42.613202 28.70569,42.567209 28.806494,42.360237 28.826643,42.176262 28.866929,42.130268 28.9072,42.061278 28.9072,41.992287 28.866929,41.555346 28.887067,41.53235 28.92733,41.417365 28.92733,41.417365 29.007809,41.440362 29.10832,41.509353 29.16858,41.647334 29.16858,41.647334 29.369189,41.60134 29.409264,41.555346 29.489366,41.555346 29.569404,41.486356 29.569404,41.463359 29.629392,41.440362 29.769223,41.463359 29.849039,41.53235 29.849039,41.647334 29.94872,41.739321 29.94872,41.785315 30.048301,41.854306 30.088105,41.96929 30.108002,41.96929 30.187546,41.900299 30.207422,41.831309 30.306743,41.739321 30.386127,41.624337 30.386127,41.578343 30.445622,41.60134 30.505082,41.624337 30.524893,41.624337 30.564505,41.371371 30.623891,41.210393 30.6041,41.210393 30.584304,41.187396 30.564505,41.118406 30.584304,41.118406 30.762319,41.026418 30.801833,40.773453 30.782078,40.635472 30.762319,40.474493 30.821584,40.451497 30.841331,40.267522 30.841331,40.244525 30.782078,40.12954 30.762319,40.106544 30.782078,39.922569 30.880812,39.853578 30.900547,39.830581 30.880812,39.76159 30.861073,39.646606 30.959727,39.554619 30.959727,39.531622 30.940004,39.416637 30.920278,39.370644 30.959727,39.117678 30.979445,38.910706 30.959727,38.887709 30.920278,38.58875 30.940004,38.404775 30.900547,38.312788 30.900547,38.243797 30.861073,38.174806 30.920278,38.197803 31.137046,38.266794 31.156728,38.289791 31.215748,38.197803 31.294385,38.128813 31.274732,38.082819 31.176405,38.013828 31.196079,37.944838 31.196079))","code":"hudud_al_shamaliya","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":true},"id":"226","name":"الحدود الشمالية","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.659924 27.834786,44.659924 27.997352,44.728915 27.997352,44.774908 27.956734,44.820902 27.956734,44.91289 28.200216,44.91289 28.220481,45.004877 28.463364,45.073868 28.725858,45.050871 28.725858,45.050871 28.887067,45.027874 28.9072,45.050871 29.068128,45.165855 29.128411,45.165855 29.16858,45.28084 29.16858,45.395824 29.148497,46.292702 29.068128,46.476677 29.068128,46.476677 29.088226,46.591661 29.10832,46.614658 29.088226,46.913617 29.068128,47.028602 29.048025,47.097592 29.048025,47.304564 29.027919,47.327561 29.007809,47.465542 29.007809,47.55753 28.887067,47.603524 28.806494,47.603524 28.665341,47.62652 28.645161,47.718508 28.523998,48.408414 28.523998,48.431411 28.544201,48.569392 28.624977,48.707373 28.665341,48.753367 28.624977,49.144314 28.36223,49.167311 28.341992,49.236301 28.240743,49.236301 28.220481,49.259298 28.220481,49.282295 28.159674,49.512264 27.895777,49.604251 27.834786,49.650245 27.87545,49.765229 27.936419,49.926208 27.936419,49.972201 27.895777,50.363148 27.9161,50.432139 27.814448,50.432139 27.753411,50.363148 27.610859,50.20217 27.549708,50.064189 27.570096,50.087186 27.508922,50.156176 27.447715,50.386145 27.141169,50.409142 27.120702,50.455136 27.038799,50.478132 26.772201,50.478132 26.710589,50.501129 26.648944,50.478132 26.566699,50.409142 26.546128,50.386145 26.484394,50.386145 26.381431,50.340151 26.175229,50.294157 25.885932,50.340151 25.865241,50.409142 25.7203,50.547123 25.595925,50.57012 25.595925,50.57012 25.512936,50.616114 25.47142,50.616114 25.42989,50.685104 25.055475,50.708101 25.03464,50.708101 24.930414,50.800089 24.888699,50.823086 24.742585,50.93807 24.533553,51.099048 24.470776,51.237029 24.491705,51.352014 24.533553,51.37501 24.5963,51.444001 24.638113,51.581982 24.638113,51.581982 24.554472,51.444001 24.428906,51.444001 24.366077,51.535989 24.345126,51.581982 24.261291,51.581982 24.156418,51.67397 24.009453,51.765957 23.925397,52.018923 23.630771,52.156904 23.441017,52.340879 23.229859,52.570848 22.933677,52.662835 22.933677,52.662835 22.912497,52.84681 22.912497,52.869807 22.891312,52.984791 22.891312,53.14577 22.870125,53.674698 22.806543,53.835676 22.806543,54.272616 22.742931,54.341607 22.721721,54.893532 22.67929,54.916529 22.65807,55.1235 22.636846,55.215488 22.700507,55.675425 21.998624,55.49145 21.485965,55.238485 20.692079,55.008516 20.002103,54.870535 19.958877,54.571576 19.850762,53.95066 19.655969,52.984791 19.33079,52.915801 19.309088,52.616841 19.200535,51.995926 19.004961,51.995926 19.265675,51.972929 19.33079,47.534533 19.33079,47.580527 19.46094,47.603524 19.482621,48.178445 20.692079,48.178445 20.713591,47.948477 20.992967,47.879486 21.057364,47.902483 21.357516,47.833492 21.400345,47.856489 21.550147,47.971473 21.721161,48.040464 21.742523,48.086458 21.785239,48.201442 21.849288,48.201442 21.891971,47.948477 21.891971,47.810495 21.9773,47.810495 22.041262,47.879486 22.169101,47.902483 22.275545,47.92548 22.296824,47.99447 22.40317,48.040464 22.615619,48.086458 22.912497,48.086458 22.9972,48.109455 23.356594,48.086458 23.419916,48.132452 23.588627,48.132452 23.82025,48.109455 23.967432,48.155448 24.05146,48.155448 24.114445,48.109455 24.198378,48.109455 24.303215,48.086458 24.324173,47.99447 24.491705,47.99447 24.554472,47.833492 24.533553,47.741505 24.533553,47.741505 24.867836,47.62652 25.013802,47.62652 25.159595,47.764502 25.242827,47.718508 25.450657,47.649517 25.554438,47.672514 25.69958,47.695511 25.69958,47.695511 25.803145,47.62652 25.865241,47.62652 25.989334,47.580527 26.03067,47.603524 26.175229,47.580527 26.195865,47.534533 26.34022,47.511536 26.402031,47.281567 26.402031,47.074595 26.587266,47.005605 26.587266,46.913617 26.669496,46.798633 26.648944,46.637655 26.669496,46.522671 26.690045,46.315699 26.792731,46.246708 26.813257,46.223711 26.83378,46.154721 26.854298,46.131724 26.83378,46.062733 26.813257,45.855761 26.956836,45.740777 27.05928,45.579799 27.120702,45.579799 27.222997,45.395824 27.222997,45.28084 27.243445,45.165855 27.304765,45.119861 27.406891,45.096865 27.570096,45.073868 27.671976,45.004877 27.69234,44.935886 27.631235,44.866896 27.631235,44.705918 27.733058,44.659924 27.834786))","code":"dammam","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":true,"traffic":true},"id":"220","name":"الدمام","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.302381 25.512936,41.325378 25.616663,41.463359 25.741017,41.578343 25.741017,41.670331 25.782439,41.670331 25.865241,41.831309 25.865241,41.900299 25.947984,41.900299 25.989334,42.015284 26.051332,42.015284 26.133944,42.130268 26.216498,42.199259 26.237128,42.199259 26.34022,42.291246 26.463809,42.429227 26.463809,42.590206 26.525554,42.636199 26.648944,42.797177 26.792731,42.958156 26.915832,43.07314 26.956836,43.165127 27.05928,43.211121 27.120702,43.234118 27.141169,43.326105 27.18209,43.349102 27.243445,43.44109 27.325198,43.418093 27.508922,43.395096 27.529317,43.395096 27.610859,43.602068 27.753411,43.625065 27.773761,43.694055 27.794106,43.855034 27.814448,43.87803 27.834786,43.993015 27.834786,44.222983 28.037956,44.222983 28.159674,44.291974 28.220481,44.406958 28.220481,44.54494 28.098832,44.659924 28.017656,44.659924 27.834786,44.705918 27.733058,44.866896 27.631235,44.91289 27.631235,44.98188 27.570096,44.889893 27.325198,44.866896 27.100232,44.843899 26.956836,44.797905 26.956836,44.705918 27.018314,44.590933 26.997825,44.498946 26.997825,44.406958 26.956836,44.383962 26.607829,44.406958 26.381431,44.498946 26.113297,44.61393 25.968661,44.797905 25.7203,44.797905 25.678856,44.774908 25.658129,44.728915 25.512936,44.659924 25.512936,44.521943 25.575183,44.452952 25.575183,44.360965 25.49218,44.199987 25.47142,44.085002 25.450657,43.993015 25.326002,43.786043 25.326002,43.671059 25.159595,43.625065 25.159595,43.579071 25.201218,43.487084 25.201218,43.326105 25.055475,43.142131 24.99296,43.119134 24.930414,43.188124 24.909558,43.165127 24.888699,43.142131 24.805227,43.211121 24.721698,43.165127 24.638113,43.096137 24.554472,42.935159 24.575388,42.866168 24.554472,42.797177 24.491705,42.567209 24.491705,42.475221 24.659015,42.452224 24.721698,42.130268 24.721698,42.061278 24.951267,42.038281 24.972115,41.96929 25.117957,41.854306 25.222024,41.716324 25.180408,41.647334 25.201218,41.463359 25.346786,41.440362 25.409119,41.371371 25.49218,41.302381 25.512936))","code":"qasim","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":false},"id":"222","name":"القاسم","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((46.591661 29.10832,46.614658 29.16858,46.683649 29.188658,46.706646 29.248871,46.867624 29.429295,46.890621 29.489366,46.913617 29.509381,46.936614 29.589404,46.982608 29.6094,47.005605 29.709319,47.074595 29.849039,47.097592 29.849039,47.097592 29.928792,47.212577 30.028393,47.396552 30.108002,47.741505 30.108002,47.764502 30.088105,47.92548 30.028393,47.948477 30.008481,48.155448 30.028393,48.316427 29.928792,48.477405 29.789183,48.592389 29.669363,48.592389 29.589404,48.684376 29.429295,48.684376 29.329099,48.66138 29.268934,48.753367 29.10832,48.753367 29.048025,48.868351 29.027919,48.983336 28.967577,49.02933 28.826643,48.960339 28.766184,48.73037 28.70569,48.707373 28.665341,48.569392 28.624977,48.431411 28.544201,48.408414 28.523998,47.718508 28.523998,47.62652 28.645161,47.603524 28.665341,47.603524 28.806494,47.55753 28.887067,47.465542 29.007809,47.327561 29.007809,47.304564 29.027919,47.097592 29.048025,47.028602 29.048025,46.913617 29.068128,46.614658 29.088226,46.591661 29.10832))","code":"kuwait","country_code":"kw","domain":"kw","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"235","name":"الكويت","time_zone":{"name":"Asia/Kuwait","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.68001 27.304765,36.749 27.325198,36.794994 27.325198,36.817991 27.386473,36.932975 27.406891,36.932975 27.447715,37.04796 27.468121,37.254931 27.468121,37.323922 27.406891,37.41591 27.406891,37.438906 27.447715,37.691872 27.468121,37.737866 27.427305,37.898844 27.447715,37.944838 27.406891,37.967834 27.141169,38.059822 27.141169,38.105816 27.18209,38.128813 27.18209,38.289791 27.079758,38.312788 27.018314,38.450769 26.956836,38.473766 26.854298,38.703734 26.813257,38.726731 26.792731,38.841716 26.813257,38.864712 26.83378,38.933703 26.813257,38.9567 26.792731,39.163672 26.792731,39.278656 26.751668,39.531622 26.772201,39.646606 26.772201,39.669603 26.710589,39.669603 26.628388,39.784587 26.566699,39.784587 26.504976,39.876575 26.381431,39.876575 26.237128,39.922569 26.195865,39.945565 26.133944,39.968562 26.113297,39.945565 25.968661,39.968562 25.823847,39.968562 25.575183,39.945565 25.388345,39.968562 25.367568,40.083547 25.346786,40.198531 25.367568,40.244525 25.284421,40.313515 25.284421,40.336512 25.346786,40.405503 25.326002,40.4285 25.305213,40.474493 25.305213,40.474493 25.409119,40.543484 25.42989,40.612475 25.409119,40.727459 25.409119,40.773453 25.47142,40.79645 25.533689,40.911434 25.595925,40.980425 25.575183,40.980425 25.554438,41.210393 25.512936,41.302381 25.512936,41.371371 25.49218,41.440362 25.409119,41.463359 25.346786,41.647334 25.201218,41.716324 25.180408,41.854306 25.222024,41.96929 25.117957,42.038281 24.972115,42.061278 24.951267,42.130268 24.721698,42.130268 24.700807,42.084274 24.659015,42.084274 24.5963,42.153265 24.324173,42.153265 24.219352,42.107271 24.135434,42.130268 24.030458,42.084274 23.988444,42.084274 23.925397,42.038281 23.841286,41.946293 23.841286,41.900299 23.757121,41.831309 23.757121,41.762318 23.778167,41.693328 23.757121,41.693328 23.693961,41.463359 23.651837,41.394368 23.588627,41.371371 23.504298,41.348375 23.356594,41.371371 23.208725,41.440362 23.145302,41.440362 23.08185,41.348375 23.08185,41.23339 23.018367,41.210393 23.018367,41.210393 23.039531,41.141403 23.039531,41.095409 22.976029,41.072412 22.912497,41.026418 22.870125,40.957428 22.891312,40.842443 22.870125,40.79645 22.785342,40.79645 22.700507,40.750456 22.615619,40.635472 22.573156,40.566481 22.636846,40.49749 22.636846,40.451497 22.594389,40.382506 22.573156,40.336512 22.530679,40.221528 22.530679,40.152537 22.551919,40.152537 22.65807,40.083547 22.764139,39.991559 22.764139,39.830581 22.82774,39.830581 22.848934,39.876575 22.912497,39.853578 23.018367,39.807584 23.08185,39.715597 23.08185,39.554619 23.103004,39.531622 23.039531,39.301653 23.018367,39.278656 23.08185,39.163672 23.145302,39.140675 23.208725,39.117678 23.314363,39.025691 23.33548,38.887709 23.419916,38.887709 23.483208,38.795722 23.483208,38.772725 23.462114,38.2208 23.208725,38.151809 23.229859,37.85285 23.504298,37.760863 23.6097,37.714869 23.693961,37.4849 23.988444,37.346919 24.093454,37.231935 24.156418,37.162944 24.156418,37.070956 24.198378,37.070956 24.219352,37.461903 24.659015,37.507897 24.700807,37.576888 24.679912,37.806856 24.679912,37.806856 24.78435,37.921841 24.805227,38.036825 24.805227,38.036825 24.867836,37.921841 24.930414,37.898844 25.013802,37.829853 25.076306,37.85285 25.180408,37.78386 25.263626,37.78386 25.42989,37.737866 25.533689,37.714869 25.554438,37.714869 25.595925,37.829853 25.658129,37.829853 25.741017,37.760863 25.782439,37.599885 25.803145,37.530894 25.885932,37.553891 25.947984,37.507897 26.07199,37.438906 26.092645,37.323922 26.257754,37.323922 26.319609,37.208938 26.319609,37.185941 26.381431,37.208938 26.44322,37.11695 26.525554,37.093953 26.587266,37.11695 26.73113,37.04796 26.83378,36.955972 26.854298,36.932975 26.956836,36.932975 27.05928,36.863985 27.079758,36.726003 27.202545,36.726003 27.263889,36.68001 27.304765))","code":"medina","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":true,"traffic":true},"id":"219","name":"المدينة","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.695511 30.564505,47.741505 30.584304,47.856489 30.524893,47.856489 30.465446,47.810495 30.425794,47.764502 30.445622,47.695511 30.564505))","code":"basra","country_code":"iq","domain":"iq","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"243","name":"بصرة","time_zone":{"name":"Asia/Baghdad","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.346191 27.263889,35.346191 27.304765,35.64515 27.447715,35.64515 27.468121,36.588022 27.936419,36.634016 27.977045,36.634016 28.037956,36.565025 28.179947,36.31206 28.179947,36.31206 28.220481,36.289063 28.240743,36.174079 28.422922,36.105088 28.483579,36.036097 28.624977,36.0131 28.806494,36.059094 28.887067,36.036097 28.947456,36.0131 28.967577,35.990104 29.068128,36.036097 29.068128,36.105088 29.088226,36.128085 29.148497,36.059094 29.16858,36.059094 29.208733,36.128085 29.248871,36.473038 29.509381,36.703007 29.849039,36.726003 29.868984,36.863985 29.90886,37.024963 29.928792,37.461903 30.008481,37.507897 29.928792,37.576888 29.90886,37.645878 29.849039,37.714869 29.829091,37.714869 29.689343,37.737866 29.669363,37.714869 29.629392,37.737866 29.569404,37.944838 29.549401,37.990831 29.589404,38.036825 29.589404,38.197803 29.529393,38.197803 29.509381,38.312788 29.369189,38.312788 29.288993,38.2208 29.208733,38.197803 29.148497,38.197803 29.027919,38.266794 29.007809,38.335784 29.007809,38.404775 29.10832,38.404775 29.208733,38.473766 29.208733,38.542756 29.288993,38.565753 29.309048,38.634744 29.309048,38.680737 29.268934,38.749728 29.268934,38.772725 29.208733,38.772725 28.947456,38.910706 28.9072,39.002694 28.806494,39.025691 28.685517,39.048687 28.624977,39.186669 28.624977,39.209666 28.564401,39.209666 28.382465,39.186669 28.32175,39.140675 28.281254,39.140675 28.240743,39.186669 28.240743,39.186669 28.220481,39.232662 28.220481,39.255659 28.200216,39.39364 28.139397,39.39364 28.058252,39.301653 28.017656,39.209666 28.017656,39.255659 27.977045,39.531622 27.977045,39.623609 27.895777,39.738594 27.834786,39.830581 27.753411,39.922569 27.610859,39.922569 27.447715,39.945565 27.427305,39.922569 27.325198,39.991559 27.263889,40.037553 27.141169,40.014556 27.120702,39.922569 27.141169,39.853578 27.202545,39.76159 27.202545,39.738594 27.120702,39.807584 27.079758,39.830581 27.05928,39.807584 27.038799,39.669603 27.038799,39.600612 26.936336,39.531622 26.792731,39.531622 26.772201,39.278656 26.751668,39.163672 26.792731,38.9567 26.792731,38.933703 26.813257,38.864712 26.83378,38.841716 26.813257,38.726731 26.792731,38.703734 26.813257,38.473766 26.854298,38.450769 26.956836,38.312788 27.018314,38.289791 27.079758,38.128813 27.18209,38.105816 27.18209,38.059822 27.141169,37.967834 27.141169,37.944838 27.406891,37.898844 27.447715,37.737866 27.427305,37.691872 27.468121,37.438906 27.447715,37.41591 27.406891,37.323922 27.406891,37.254931 27.468121,37.04796 27.468121,36.932975 27.447715,36.932975 27.406891,36.817991 27.386473,36.794994 27.325198,36.749 27.325198,36.68001 27.304765,36.726003 27.263889,36.726003 27.202545,36.863985 27.079758,36.932975 27.05928,36.932975 26.956836,36.955972 26.854298,37.04796 26.83378,37.11695 26.73113,37.093953 26.587266,37.11695 26.525554,37.208938 26.44322,37.185941 26.381431,37.208938 26.319609,37.323922 26.319609,37.323922 26.257754,37.438906 26.092645,37.507897 26.07199,37.553891 25.947984,37.530894 25.885932,37.599885 25.803145,37.760863 25.782439,37.829853 25.741017,37.829853 25.658129,37.714869 25.595925,37.714869 25.554438,37.737866 25.533689,37.78386 25.42989,37.78386 25.263626,37.85285 25.180408,37.829853 25.076306,37.898844 25.013802,37.921841 24.930414,38.036825 24.867836,38.036825 24.805227,37.921841 24.805227,37.806856 24.78435,37.806856 24.679912,37.576888 24.679912,37.507897 24.700807,37.461903 24.659015,37.070956 24.219352,37.070956 24.198378,36.978969 24.219352,36.909978 24.366077,36.749 24.84697,36.726003 24.867836,36.634016 25.117957,36.450041 25.284421,36.266066 25.533689,36.243069 25.595925,36.243069 25.69958,36.289063 25.823847,36.266066 25.968661,36.128085 26.092645,36.036097 26.257754,35.898116 26.381431,35.829125 26.484394,35.806129 26.504976,35.599157 26.813257,35.530166 26.936336,35.507169 27.018314,35.415182 27.141169,35.346191 27.263889))","code":"tabuk","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":true},"id":"224","name":"تبوك","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.911434 17.366415,40.911434 17.410307,41.210393 17.519991,41.279384 17.54192,41.96929 17.78296,42.038281 17.848643,42.084274 17.9143,42.084274 18.045543,42.222256 18.045543,42.245253 17.979934,42.245253 17.892417,42.360237 17.826751,42.406231 17.739159,42.498218 17.804857,42.70519 17.78296,42.728187 17.761061,42.866168 17.78296,42.889165 17.717254,42.981152 17.695347,43.004149 17.629608,43.07314 17.585769,43.165127 17.585769,43.188124 17.498059,43.257115 17.498059,43.280112 17.519991,43.303109 17.498059,43.280112 17.432249,43.280112 17.388363,43.303109 17.388363,43.349102 17.322513,43.234118 17.212711,43.188124 17.146799,43.257115 17.058879,43.234118 16.992912,43.211121 16.970918,43.188124 16.882916,43.257115 16.816887,43.280112 16.750835,43.257115 16.728813,43.257115 16.640698,43.188124 16.618663,43.165127 16.596626,43.119134 16.50845,43.004149 16.50845,42.958156 16.442293,42.935159 16.376112,42.820174 16.354047,42.797177 16.376112,42.544212 16.376112,42.429227 16.243684,42.475221 16.089071,42.383234 16.044874,42.130268 15.97856,42.061278 16.089071,41.992287 16.066974,41.808312 16.111166,41.785315 16.199521,41.716324 16.265761,41.60134 16.287836,41.486356 16.398175,41.394368 16.552543,41.325378 16.618663,41.23339 16.750835,41.210393 16.772855,41.210393 16.816887,41.1644 16.860909,40.911434 17.366415))","code":"jizan","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":true},"id":"227","name":"جازان","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.140675 28.240743,39.140675 28.281254,39.186669 28.32175,39.209666 28.382465,39.416637 28.402695,39.485628 28.443145,39.715597 28.483579,39.899572 28.645161,40.152537 28.70569,40.198531 28.746023,40.4285 28.846788,40.49749 28.866929,40.612475 28.92733,41.53235 28.92733,41.555346 28.887067,41.992287 28.866929,42.061278 28.9072,42.130268 28.9072,42.176262 28.866929,42.360237 28.826643,42.567209 28.806494,42.613202 28.70569,42.682193 28.665341,42.797177 28.645161,42.843171 28.604789,42.843171 28.50379,42.935159 28.443145,42.981152 28.443145,43.142131 28.382465,43.234118 28.402695,43.303109 28.523998,43.349102 28.523998,43.556074 28.443145,43.648062 28.443145,43.694055 28.402695,43.80904 28.382465,43.993015 28.422922,44.291974 28.443145,44.360965 28.32175,44.360965 28.240743,44.314971 28.240743,44.314971 28.220481,44.291974 28.220481,44.222983 28.159674,44.222983 28.037956,43.993015 27.834786,43.87803 27.834786,43.855034 27.814448,43.694055 27.794106,43.625065 27.773761,43.602068 27.753411,43.395096 27.610859,43.395096 27.529317,43.418093 27.508922,43.44109 27.325198,43.349102 27.243445,43.326105 27.18209,43.234118 27.141169,43.211121 27.120702,43.165127 27.05928,43.07314 26.956836,42.958156 26.915832,42.797177 26.792731,42.636199 26.648944,42.590206 26.525554,42.429227 26.463809,42.291246 26.463809,42.199259 26.34022,42.199259 26.237128,42.130268 26.216498,42.015284 26.133944,42.015284 26.051332,41.900299 25.989334,41.900299 25.947984,41.831309 25.865241,41.670331 25.865241,41.670331 25.782439,41.578343 25.741017,41.463359 25.741017,41.325378 25.616663,41.302381 25.512936,41.210393 25.512936,40.980425 25.554438,40.980425 25.575183,40.911434 25.595925,40.79645 25.533689,40.773453 25.47142,40.727459 25.409119,40.612475 25.409119,40.543484 25.42989,40.474493 25.409119,40.474493 25.305213,40.4285 25.305213,40.405503 25.326002,40.336512 25.346786,40.313515 25.284421,40.244525 25.284421,40.198531 25.367568,40.083547 25.346786,39.968562 25.367568,39.945565 25.388345,39.968562 25.575183,39.968562 25.823847,39.945565 25.968661,39.968562 26.113297,39.945565 26.133944,39.922569 26.195865,39.876575 26.237128,39.876575 26.381431,39.784587 26.504976,39.784587 26.566699,39.669603 26.628388,39.669603 26.710589,39.646606 26.772201,39.531622 26.772201,39.531622 26.792731,39.600612 26.936336,39.669603 27.038799,39.807584 27.038799,39.830581 27.05928,39.807584 27.079758,39.738594 27.120702,39.76159 27.202545,39.853578 27.202545,39.922569 27.141169,40.014556 27.120702,40.037553 27.141169,39.991559 27.263889,39.922569 27.325198,39.945565 27.427305,39.922569 27.447715,39.922569 27.610859,39.830581 27.753411,39.738594 27.834786,39.623609 27.895777,39.531622 27.977045,39.255659 27.977045,39.209666 28.017656,39.301653 28.017656,39.39364 28.058252,39.39364 28.139397,39.255659 28.200216,39.232662 28.220481,39.186669 28.220481,39.186669 28.240743,39.140675 28.240743))","code":"hail","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":true},"id":"225","name":"حائل","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.520487 18.089269,40.520487 18.154838,40.635472 18.176688,40.681465 18.220381,41.210393 18.482309,41.325378 18.547729,41.371371 18.591328,41.394368 18.656706,41.60134 18.678493,41.60134 18.743837,41.624337 18.743837,41.578343 18.852688,41.463359 19.004961,41.509353 19.048442,41.555346 19.048442,41.624337 19.222252,41.716324 19.222252,41.831309 19.113642,41.900299 19.200535,41.923296 19.265675,41.923296 19.417568,41.854306 19.482621,41.831309 19.547649,41.831309 19.720927,41.739321 19.699277,41.762318 19.764217,41.785315 19.785858,41.785315 19.872391,41.831309 19.91564,41.900299 20.196469,41.96929 20.261205,42.015284 20.369037,42.107271 20.412148,42.130268 20.412148,42.153265 20.325913,42.222256 20.282777,42.291246 20.304346,42.314243 20.325913,42.406231 20.325913,42.429227 20.282777,42.544212 20.261205,42.636199 20.390594,42.70519 20.390594,42.70519 20.476793,42.797177 20.519875,42.912162 20.519875,42.981152 20.584474,43.07314 20.606001,43.165127 20.778109,43.234118 20.799608,43.44109 20.778109,43.625065 20.7351,43.625065 20.713591,43.740049 20.692079,43.80904 20.670565,43.87803 20.606001,43.993015 20.519875,44.039008 20.519875,44.039008 20.282777,44.062005 20.261205,44.085002 20.110114,44.107999 20.002103,44.17699 19.93726,44.222983 19.699277,44.222983 19.569319,44.153993 19.547649,44.153993 19.482621,44.222983 19.46094,44.337968 19.482621,44.383962 19.417568,44.383962 19.33079,44.452952 19.309088,44.452952 19.200535,44.383962 19.091912,44.383962 18.961469,44.314971 18.939718,44.24598 18.939718,44.199987 18.896209,44.130996 18.87445,44.107999 18.809156,44.107999 18.743837,43.993015 18.634916,43.970018 18.525925,43.947021 18.504119,43.947021 18.438682,43.87803 18.373221,43.855034 18.307735,43.855034 18.264064,43.763046 18.242224,43.763046 18.176688,43.717052 18.132984,43.671059 17.936181,43.625065 17.9143,43.602068 17.761061,43.625065 17.563846,43.671059 17.519991,43.717052 17.388363,43.602068 17.388363,43.464087 17.519991,43.395096 17.54192,43.326105 17.519991,43.303109 17.498059,43.280112 17.519991,43.257115 17.498059,43.188124 17.498059,43.165127 17.585769,43.07314 17.585769,43.004149 17.629608,42.981152 17.695347,42.889165 17.717254,42.866168 17.78296,42.728187 17.761061,42.70519 17.78296,42.498218 17.804857,42.406231 17.739159,42.360237 17.826751,42.245253 17.892417,42.245253 17.979934,42.222256 18.045543,42.084274 18.045543,42.084274 17.9143,42.038281 17.848643,41.96929 17.78296,41.279384 17.54192,41.210393 17.519991,40.911434 17.410307,40.86544 17.454189,40.750456 17.651524,40.612475 17.9143,40.589478 17.936181,40.520487 18.089269))","code":"asir","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":true},"id":"223","name":"عسير","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((50.57012 25.512936,50.57012 25.595925,50.731098 25.575183,50.800089 25.575183,50.823086 25.637398,50.846082 25.658129,50.869079 25.76173,50.823086 25.885932,50.846082 26.010004,50.915073 26.07199,50.915073 26.237128,50.93807 26.257754,51.030057 26.298994,51.053054 26.360827,51.145042 26.402031,51.30602 26.402031,51.489995 26.319609,51.558985 26.237128,51.581982 26.175229,51.857945 26.07199,52.501857 25.885932,52.570848 25.865241,52.639838 25.76173,52.662835 25.69958,52.662835 25.616663,52.639838 25.595925,52.501857 25.097133,52.501857 25.076306,52.47886 25.013802,52.40987 25.013802,52.340879 24.99296,52.363876 24.867836,52.271888 24.8261,52.018923 24.763469,51.581982 24.659015,51.466998 24.638113,51.398007 24.617208,51.329017 24.512631,51.099048 24.470776,50.93807 24.533553,50.823086 24.742585,50.800089 24.888699,50.708101 24.930414,50.708101 25.03464,50.685104 25.055475,50.616114 25.42989,50.616114 25.47142,50.57012 25.512936))","code":"qatar","country_code":"qa","domain":"qa","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"234","name":"قطر","time_zone":{"name":"Asia/Qatar","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.2208 23.166447,38.2208 23.208725,38.772725 23.462114,38.795722 23.483208,38.887709 23.483208,38.887709 23.419916,39.025691 23.33548,39.117678 23.314363,39.140675 23.208725,39.163672 23.145302,39.278656 23.08185,39.301653 23.018367,39.531622 23.039531,39.554619 23.103004,39.715597 23.08185,39.807584 23.08185,39.853578 23.018367,39.876575 22.912497,39.830581 22.848934,39.830581 22.82774,39.991559 22.764139,40.083547 22.764139,40.152537 22.65807,40.152537 22.551919,40.221528 22.530679,40.336512 22.530679,40.382506 22.573156,40.451497 22.594389,40.49749 22.636846,40.566481 22.636846,40.635472 22.573156,40.750456 22.615619,40.79645 22.700507,40.79645 22.785342,40.842443 22.870125,40.957428 22.891312,41.026418 22.870125,41.072412 22.912497,41.095409 22.976029,41.141403 23.039531,41.210393 23.039531,41.210393 23.018367,41.23339 23.018367,41.348375 23.08185,41.440362 23.08185,41.440362 23.145302,41.371371 23.208725,41.348375 23.356594,41.371371 23.504298,41.394368 23.588627,41.463359 23.651837,41.693328 23.693961,41.831309 23.630771,42.015284 23.588627,42.176262 23.588627,42.176262 23.6097,42.245253 23.588627,42.291246 23.462114,42.406231 23.419916,42.406231 23.272118,42.429227 23.272118,42.452224 23.166447,42.475221 23.103004,42.70519 23.08185,42.728187 23.018367,42.751184 22.912497,42.774181 22.912497,42.774181 22.891312,42.866168 22.891312,42.935159 22.742931,42.958156 22.721721,43.142131 22.721721,43.234118 22.67929,43.165127 22.615619,43.188124 22.551919,43.211121 22.530679,43.234118 22.466939,43.349102 22.360642,43.303109 22.296824,43.326105 22.190396,43.349102 22.190396,43.372099 22.041262,43.487084 21.9773,43.487084 21.870631,43.464087 21.721161,43.487084 21.699795,43.487084 21.507363,43.671059 21.421755,43.671059 21.378932,43.579071 21.207517,43.579071 21.121734,43.694055 21.014436,43.80904 20.821105,43.832037 20.692079,43.80904 20.670565,43.740049 20.692079,43.625065 20.713591,43.625065 20.7351,43.44109 20.778109,43.234118 20.799608,43.165127 20.778109,43.07314 20.606001,42.981152 20.584474,42.912162 20.519875,42.797177 20.519875,42.70519 20.476793,42.70519 20.390594,42.636199 20.390594,42.544212 20.261205,42.429227 20.282777,42.406231 20.325913,42.314243 20.325913,42.291246 20.304346,42.222256 20.282777,42.153265 20.325913,42.130268 20.412148,42.107271 20.519875,42.107271 20.584474,41.96929 20.584474,41.946293 20.670565,41.877303 20.649047,41.854306 20.627526,41.739321 20.627526,41.60134 20.756606,41.53235 20.756606,41.486356 20.799608,41.394368 20.821105,41.325378 20.778109,41.325378 20.670565,41.279384 20.584474,41.279384 20.519875,41.210393 20.455248,41.210393 20.390594,41.187396 20.369037,41.118406 20.261205,41.072412 20.304346,41.095409 20.347476,41.049415 20.369037,41.026418 20.304346,40.980425 20.261205,40.842443 20.110114,40.842443 20.045316,40.911434 19.91564,41.026418 19.807495,41.026418 19.720927,41.095409 19.677625,41.1644 19.655969,41.187396 19.590986,41.141403 19.547649,41.210393 19.525976,41.256387 19.525976,41.279384 19.46094,41.394368 19.482621,41.555346 19.547649,41.555346 19.634311,41.578343 19.699277,41.739321 19.699277,41.831309 19.720927,41.831309 19.547649,41.854306 19.482621,41.923296 19.417568,41.923296 19.265675,41.900299 19.200535,41.831309 19.113642,41.716324 19.222252,41.624337 19.222252,41.555346 19.048442,41.509353 19.048442,41.463359 19.004961,41.578343 18.852688,41.624337 18.743837,41.60134 18.743837,41.60134 18.678493,41.394368 18.656706,41.371371 18.591328,41.325378 18.547729,41.210393 18.482309,40.681465 18.220381,40.635472 18.176688,40.520487 18.154838,40.49749 18.176688,40.4285 18.438682,40.175534 18.678493,40.06055 18.765613,39.991559 18.830924,39.922569 18.939718,39.876575 19.178816,39.784587 19.439255,39.715597 19.590986,39.32465 20.088518,39.094681 20.541411,39.071684 20.606001,38.9567 20.821105,38.933703 20.821105,38.818719 21.014436,38.795722 21.035902,38.611747 21.614301,38.542756 21.721161,38.496763 21.849288,38.519759 22.083888,38.611747 22.360642,38.58875 22.381908,38.473766 22.530679,38.404775 22.636846,38.381778 22.700507,38.381778 22.806543,38.358781 22.912497,38.358781 22.954855,38.2208 23.166447))","code":"mekka","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":true,"traffic":true},"id":"218","name":"مكة","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((43.602068 17.761061,43.625065 17.9143,43.671059 17.936181,43.717052 18.132984,43.763046 18.176688,43.763046 18.242224,43.855034 18.264064,43.855034 18.307735,43.87803 18.373221,43.947021 18.438682,43.947021 18.504119,43.970018 18.525925,43.993015 18.634916,44.107999 18.743837,44.107999 18.809156,44.130996 18.87445,44.199987 18.896209,44.24598 18.939718,44.314971 18.939718,44.383962 18.961469,44.383962 19.091912,44.452952 19.200535,44.452952 19.309088,44.383962 19.33079,44.383962 19.417568,44.590933 19.417568,45.073868 19.439255,45.119861 19.309088,45.119861 19.222252,45.165855 19.222252,45.372827 19.309088,46.292702 19.309088,47.097592 19.33079,51.972929 19.33079,51.995926 19.265675,51.995926 18.983216,51.926935 18.961469,51.168039 18.830924,50.639111 18.743837,50.432139 18.722059,49.926208 18.678493,49.121317 18.591328,48.592389 18.351395,48.224439 18.176688,48.109455 18.023676,47.764502 17.60769,47.718508 17.563846,47.603524 17.410307,47.603524 17.388363,47.511536 17.190743,47.488539 17.102844,47.327561 17.014904,47.304564 16.992912,47.18958 16.926922,47.005605 16.926922,46.936614 16.992912,46.729642 17.25664,46.568664 17.234677,46.361692 17.212711,45.901755 17.25664,45.740777 17.2786,45.395824 17.300558,45.28084 17.366415,45.257843 17.388363,45.211849 17.388363,45.188852 17.410307,44.61393 17.410307,44.61393 17.388363,44.039008 17.388363,43.970018 17.322513,43.717052 17.344466,43.694055 17.388363,43.717052 17.410307,43.671059 17.519991,43.625065 17.563846,43.602068 17.761061))","code":"najran","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"public_transport":false,"road_network":true},"id":"228","name":"نجران","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((34.679282 27.671976,34.702279 27.733058,34.932247 28.098832,35.047232 28.179947,35.116222 28.179947,35.323194 28.159674,35.369188 28.159674,35.507169 28.098832,35.64515 27.733058,35.622154 27.549708,35.323194 27.427305,35.300197 27.427305,35.254204 27.386473,35.20821 27.406891,34.909251 27.631235,34.679282 27.671976))","code":"neom","country_code":"sa","domain":"sa","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true},"id":"250","name":"نيوم","time_zone":{"name":"Asia/Riyadh","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.279384 41.639968,41.325378 41.708677,41.486356 41.863003,41.486356 41.914363,41.348375 42.153495,41.348375 42.221653,41.279384 42.340753,41.279384 42.408709,41.578343 42.408709,41.716324 42.510505,41.785315 42.527455,41.785315 42.5444,41.831309 42.5444,41.854306 42.578277,41.923296 42.629058,41.946293 42.679797,41.900299 42.7136,41.900299 43.033813,42.038281 43.050621,42.107271 43.134588,42.130268 43.151368,42.107271 43.201679,42.130268 43.21844,42.33724 43.21844,42.383234 43.251949,42.406231 43.251949,42.567209 43.168143,42.682193 43.151368,42.728187 43.184913,42.889165 43.168143,42.935159 43.134588,43.027146 43.101015,43.027146 43.033813,43.142131 42.983364,43.142131 42.966538,43.07314 42.882341,42.475221 42.916033,42.429227 42.882341,42.360237 42.865487,42.360237 42.8149,42.383234 42.798028,42.544212 42.747385,42.544212 42.645975,42.590206 42.612135,42.590206 42.561341,42.567209 42.5444,42.544212 42.5444,42.498218 42.510505,42.429227 42.391727,42.383234 42.357749,42.291246 42.221653,42.291246 42.136444,42.222256 42.085263,42.245253 42.05112,42.360237 42.05112,42.429227 41.99987,42.659196 41.931473,42.659196 41.897247,42.636199 41.811602,42.521215 41.794459,42.521215 41.691506,42.590206 41.605586,42.590206 41.588388,42.613202 41.571186,42.544212 41.450641,42.498218 41.416158,42.452224 41.416158,42.245253 41.485105,41.992287 41.485105,41.96929 41.50233,41.877303 41.433401,41.831309 41.416158,41.693328 41.467875,41.647334 41.467875,41.302381 41.588388,41.279384 41.639968))","code":"batumi","country_code":"ge","domain":"ge","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"parking_layer":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true,"truck_graph":true},"id":"255","name":"ბათუმი","time_zone":{"name":"Asia/Tbilisi","offset":240},"type":"region","zoom_level":{"max":18,"min":9}}]');DG.config = {"host":null,"port":3000,"defaultSkin":"dark","defaultLang":"ru","trafficLayerMinZoom":10,"trafficLayerUpdateInterval":300000,"ppLink2gis":"{gislink}/directions/tab/{rsType}/points/|{point}?m={center}%2F{zoom}&routeLink=true","openLink2gis":"{gislink}/?m={center}%2F{zoom}&openLink=true","ppnotLink":"http://2gis.{domain}/{projectCode}/center/{center}/zoom/{zoom}/routeTab/rsType/{rsType}/to/{point}╎{name}","photosLink":"http://2gis.{domain}/photos/{id}","poiLayerMinZoom":0,"detectRetina":false,"webApiKey":"ruregt3044","webApiVersion":"2.0","catalogVersion":"3.0","regionListFields":"items.bounds,items.zoom_level,items.time_zone,items.code,items.flags,items.country_code,items.domain,items.default_pos","firmInfoFields":"items.reviews,items.links,items.external_content","geoAdditionalFields":"items.geometry.selection,items.links,items.adm_div,items.address,items.floors,items.description","geoclickerCatalogApiKey":"ruregt3044","projectLeaveMaxZoom":16,"flampUrl":"http://flamp.ru/r/","flampGoogleAnalytics":"utm_source=api2gis&utm_medium=api&utm_campaign=geoclicker","protocol":"http:","secureProtocol":"https:","baseUrl":"//maps.api.2gis.ru/2.0","key":"c5e4d7ec-f9d0-470f-b7f0-278f622f20e2","keyServer":"https://keys.api.2gis.com/public/v1/keys/","keyServices":"/services/tiles-raster-api","tileServer":"//tile{s}-sdk.maps.2gis.com/v2/tiles?x={x}&y={y}&z={z}&v=1&ts=online_sd&key={key}","retinaTileServer":"//tile{s}-sdk.maps.2gis.com/v2/tiles?x={x}&y={y}&z={z}&v=1&ts=online_hd&key={key}","previewTileServer":"//tile{s}-sdk.maps.2gis.com/v2/tiles?x={x}&y={y}&z={z}&v=1&size=64&ts=online_sd&key={key}","previewRetinaTileServer":"//tile{s}-sdk.maps.2gis.com/v2/tiles?x={x}&y={y}&z={z}&v=1&size=64&ts=online_hd&key={key}","arabicTileServer":"//tile{s}-sdk.maps.2gis.com/v2/tiles?x={x}&y={y}&z={z}&v=1&ts=online_sd_ar&key={key}","arabicRetinaTileServer":"//tile{s}-sdk.maps.2gis.com/v2/tiles?x={x}&y={y}&z={z}&v=1&ts=online_hd_ar&key={key}","arabicPreviewTileServer":"//tile{s}-sdk.maps.2gis.com/v2/tiles?x={x}&y={y}&z={z}&v=1&size=64&ts=online_sd_ar&key={key}","arabicPreviewRetinaTileServer":"//tile{s}-sdk.maps.2gis.com/v2/tiles?x={x}&y={y}&z={z}&v=1&size=64&ts=online_hd_ar&key={key}","trafficTileServer":"//traffic{s}.maps.2gis.com/{projectCode}/traffic/{z}/{x}/{y}/speed/{period}/{timestampString}","retinaTrafficTileServer":"//traffic{s}.maps.2gis.com/{projectCode}/traffic/{z}/{x}/{y}/speed/{period}/retina/{timestampString}","trafficMetaServer":"//meta{s}.maps.2gis.com/{projectCode}/meta/{z}/{x}/{y}/graph_speed/{period}/{timestampString}","retinaTrafficMetaServer":"//meta{s}.maps.2gis.com/{projectCode}/meta/{z}/{x}/{y}/graph_speed/{period}/retina/{timestampString}","trafficTimestampServer":"//traffic{s}.maps.2gis.com/{projectCode}/meta/speed/time/","trafficScoreServer":"//traffic{s}.maps.2gis.com/{projectCode}/meta/score/0/","poiMetaServer":"//tile{s}.maps.2gis.com/poi?x={x}&y={y}&z={z}&v=1&ts=online_sd","retinaPoiMetaServer":"//tile{s}.maps.2gis.com/poi?x={x}&y={y}&z={z}&v=1&ts=online_hd","arabicPoiMetaServer":"//tile{s}.maps.2gis.com/poi?x={x}&y={y}&z={z}&v=1&ts=online_sd_ar","arabicRetinaPoiMetaServer":"//tile{s}.maps.2gis.com/poi?x={x}&y={y}&z={z}&v=1&ts=online_hd_ar","webApiServer":"//catalog.api.2gis.ru","loadProjectListTimeout":5000};
}).call(this)}).call(this,_dereq_('_process'))
},{"../../../vendors/baron":7,"_process":6,"dustjs-helpers":2,"dustjs-linkedin":3,"html5shiv":4,"leaflet":5}],2:[function(_dereq_,module,exports){
(function(root, factory) {
  if (typeof define === 'function' && define.amd && define.amd.dust === true) {
    define(['dust.core'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(_dereq_('dustjs-linkedin'));
  } else {
    factory(root.dust);
  }
}(this, function(dust) {

function log(helper, msg, level) {
  level = level || "INFO";
  helper = helper ? '{@' + helper + '}: ' : '';
  dust.log(helper + msg, level);
}

var _deprecatedCache = {};
function _deprecated(target) {
  if(_deprecatedCache[target]) { return; }
  log(target, "Deprecation warning: " + target + " is deprecated and will be removed in a future version of dustjs-helpers", "WARN");
  log(null, "For help and a deprecation timeline, see https://github.com/linkedin/dustjs-helpers/wiki/Deprecated-Features#" + target.replace(/\W+/g, ""), "WARN");
  _deprecatedCache[target] = true;
}

function isSelect(context) {
  return context.stack.tail &&
         context.stack.tail.head &&
         typeof context.stack.tail.head.__select__ !== "undefined";
}

function getSelectState(context) {
  return isSelect(context) && context.get('__select__');
}

/**
 * Adds a special __select__ key behind the head of the context stack. Used to maintain the state
 * of {@select} blocks
 * @param context {Context} add state to this Context
 * @param opts {Object} add these properties to the state (`key` and `type`)
 */
function addSelectState(context, opts) {
  var head = context.stack.head,
      newContext = context.rebase(),
      key;

  if(context.stack && context.stack.tail) {
    newContext.stack = context.stack.tail;
  }

  var state = {
    isPending: false,
    isResolved: false,
    isDeferredComplete: false,
    deferreds: []
  };

  for(key in opts) {
    state[key] = opts[key];
  }

  return newContext
  .push({ "__select__": state })
  .push(head, context.stack.index, context.stack.of);
}

/**
 * After a {@select} or {@math} block is complete, they invoke this function
 */
function resolveSelectDeferreds(state) {
  var x, len;
  state.isDeferredPending = true;
  if(state.deferreds.length) {
    state.isDeferredComplete = true;
    for(x=0, len=state.deferreds.length; x<len; x++) {
      state.deferreds[x]();
    }
  }
  state.isDeferredPending = false;
}

/**
 * Used by {@contextDump}
 */
function jsonFilter(key, value) {
  if (typeof value === "function") {
    return value.toString()
      .replace(/(^\s+|\s+$)/mg, '')
      .replace(/\n/mg, '')
      .replace(/,\s*/mg, ', ')
      .replace(/\)\{/mg, ') {');
  }
  return value;
}

/**
 * Generate a truth test helper
 */
function truthTest(name, test) {
  return function(chunk, context, bodies, params) {
    return filter(chunk, context, bodies, params, name, test);
  };
}

/**
 * This function is invoked by truth test helpers
 */
function filter(chunk, context, bodies, params, helperName, test) {
  var body = bodies.block,
      skip = bodies['else'],
      selectState = getSelectState(context) || {},
      willResolve, key, value, type;

  // Once one truth test in a select passes, short-circuit the rest of the tests
  if (selectState.isResolved && !selectState.isDeferredPending) {
    return chunk;
  }

  // First check for a key on the helper itself, then look for a key on the {@select}
  if (params.hasOwnProperty('key')) {
    key = params.key;
  } else if (selectState.hasOwnProperty('key')) {
    key = selectState.key;
  } else {
    log(helperName, "No key specified", "WARN");
    return chunk;
  }

  type = params.type || selectState.type;

  key = coerce(context.resolve(key), type);
  value = coerce(context.resolve(params.value), type);

  if (test(key, value)) {
    // Once a truth test passes, put the select into "pending" state. Now we can render the body of
    // the truth test (which may contain truth tests) without altering the state of the select.
    if (!selectState.isPending) {
      willResolve = true;
      selectState.isPending = true;
    }
    if (body) {
      chunk = chunk.render(body, context);
    }
    if (willResolve) {
      selectState.isResolved = true;
    }
  } else if (skip) {
    chunk = chunk.render(skip, context);
  }
  return chunk;
}

function coerce(value, type) {
  if (type) {
    type = type.toLowerCase();
  }
  switch (type) {
    case 'number': return +value;
    case 'string': return String(value);
    case 'boolean':
      value = (value === 'false' ? false : value);
      return Boolean(value);
    case 'date': return new Date(value);
  }

  return value;
}

var helpers = {

  // Utility helping to resolve dust references in the given chunk
  // uses native Dust Context#resolve (available since Dust 2.6.2)
  "tap": function(input, chunk, context) {
    // deprecated for removal in 1.8
    _deprecated("tap");
    return context.resolve(input);
  },

  "sep": function(chunk, context, bodies) {
    var body = bodies.block;
    if (context.stack.index === context.stack.of - 1) {
      return chunk;
    }
    if (body) {
      return body(chunk, context);
    } else {
      return chunk;
    }
  },

  "first": function(chunk, context, bodies) {
    if (context.stack.index === 0) {
      return bodies.block(chunk, context);
    }
    return chunk;
  },

  "last": function(chunk, context, bodies) {
    if (context.stack.index === context.stack.of - 1) {
      return bodies.block(chunk, context);
    }
    return chunk;
  },

  /**
   * {@contextDump}
   * @param key {String} set to "full" to the full context stack, otherwise the current context is dumped
   * @param to {String} set to "console" to log to console, otherwise outputs to the chunk
   */
  "contextDump": function(chunk, context, bodies, params) {
    var to = context.resolve(params.to),
        key = context.resolve(params.key),
        target, output;
    switch(key) {
      case 'full':
        target = context.stack;
        break;
      default:
        target = context.stack.head;
    }
    output = JSON.stringify(target, jsonFilter, 2);
    switch(to) {
      case 'console':
        log('contextDump', output);
        break;
      default:
        output = output.replace(/</g, '\\u003c');
        chunk = chunk.write(output);
    }
    return chunk;
  },

  /**
   * {@math}
   * @param key first value
   * @param method {String} operation to perform
   * @param operand second value (not required for operations like `abs`)
   * @param round if truthy, round() the result
   */
  "math": function (chunk, context, bodies, params) {
    var key = params.key,
        method = params.method,
        operand = params.operand,
        round = params.round,
        output, state, x, len;

    if(!params.hasOwnProperty('key') || !params.method) {
      log("math", "`key` or `method` was not provided", "ERROR");
      return chunk;
    }

    key = parseFloat(context.resolve(key));
    operand = parseFloat(context.resolve(operand));

    switch(method) {
      case "mod":
        if(operand === 0) {
          log("math", "Division by 0", "ERROR");
        }
        output = key % operand;
        break;
      case "add":
        output = key + operand;
        break;
      case "subtract":
        output = key - operand;
        break;
      case "multiply":
        output = key * operand;
        break;
      case "divide":
        if(operand === 0) {
          log("math", "Division by 0", "ERROR");
        }
        output = key / operand;
        break;
      case "ceil":
      case "floor":
      case "round":
      case "abs":
        output = Math[method](key);
        break;
      case "toint":
        output = parseInt(key, 10);
        break;
      default:
        log("math", "Method `" + method + "` is not supported", "ERROR");
    }

    if (typeof output !== 'undefined') {
      if (round) {
        output = Math.round(output);
      }
      if (bodies && bodies.block) {
        context = addSelectState(context, { key: output });
        chunk = chunk.render(bodies.block, context);
        resolveSelectDeferreds(getSelectState(context));
      } else {
        chunk = chunk.write(output);
      }
    }

    return chunk;
  },

  /**
   * {@select}
   * Groups a set of truth tests and outputs the first one that passes.
   * Also contains {@any} and {@none} blocks.
   * @param key a value or reference to use as the left-hand side of comparisons
   * @param type coerce all truth test keys without an explicit type to this type
   */
  "select": function(chunk, context, bodies, params) {
    var body = bodies.block,
        state = {};

    if (params.hasOwnProperty('key')) {
      state.key = context.resolve(params.key);
    }
    if (params.hasOwnProperty('type')) {
      state.type = params.type;
    }

    if (body) {
      context = addSelectState(context, state);
      chunk = chunk.render(body, context);
      resolveSelectDeferreds(getSelectState(context));
    } else {
      log("select", "Missing body block", "WARN");
    }
    return chunk;
  },

  /**
   * Truth test helpers
   * @param key a value or reference to use as the left-hand side of comparisons
   * @param value a value or reference to use as the right-hand side of comparisons
   * @param type if specified, `key` and `value` will be forcibly cast to this type
   */
  "eq": truthTest('eq', function(left, right) {
    return left === right;
  }),
  "ne": truthTest('ne', function(left, right) {
    return left !== right;
  }),
  "lt": truthTest('lt', function(left, right) {
    return left < right;
  }),
  "lte": truthTest('lte', function(left, right) {
    return left <= right;
  }),
  "gt": truthTest('gt', function(left, right) {
    return left > right;
  }),
  "gte": truthTest('gte', function(left, right) {
    return left >= right;
  }),

  /**
   * {@any}
   * Outputs as long as at least one truth test inside a {@select} has passed.
   * Must be contained inside a {@select} block.
   * The passing truth test can be before or after the {@any} block.
   */
  "any": function(chunk, context, bodies, params) {
    var selectState = getSelectState(context);

    if(!selectState) {
      log("any", "Must be used inside a {@select} block", "ERROR");
    } else {
      if(selectState.isDeferredComplete) {
        log("any", "Must not be nested inside {@any} or {@none} block", "ERROR");
      } else {
        chunk = chunk.map(function(chunk) {
          selectState.deferreds.push(function() {
            if(selectState.isResolved) {
              chunk = chunk.render(bodies.block, context);
            }
            chunk.end();
          });
        });
      }
    }
    return chunk;
  },

  /**
   * {@none}
   * Outputs if no truth tests inside a {@select} pass.
   * Must be contained inside a {@select} block.
   * The position of the helper does not matter.
   */
  "none": function(chunk, context, bodies, params) {
    var selectState = getSelectState(context);

    if(!selectState) {
      log("none", "Must be used inside a {@select} block", "ERROR");
    } else {
      if(selectState.isDeferredComplete) {
        log("none", "Must not be nested inside {@any} or {@none} block", "ERROR");
      } else {
        chunk = chunk.map(function(chunk) {
          selectState.deferreds.push(function() {
            if(!selectState.isResolved) {
              chunk = chunk.render(bodies.block, context);
            }
            chunk.end();
          });
        });
      }
    }
    return chunk;
  },

  /**
  * {@size}
  * Write the size of the target to the chunk
  * Falsy values and true have size 0
  * Numbers are returned as-is
  * Arrays and Strings have size equal to their length
  * Objects have size equal to the number of keys they contain
  * Dust bodies are evaluated and the length of the string is returned
  * Functions are evaluated and the length of their return value is evaluated
  * @param key find the size of this value or reference
  */
  "size": function(chunk, context, bodies, params) {
    var key = params.key,
        value, k;

    key = context.resolve(params.key);
    if (!key || key === true) {
      value = 0;
    } else if(dust.isArray(key)) {
      value = key.length;
    } else if (!isNaN(parseFloat(key)) && isFinite(key)) {
      value = key;
    } else if (typeof key === "object") {
      value = 0;
      for(k in key){
        if(key.hasOwnProperty(k)){
          value++;
        }
      }
    } else {
      value = (key + '').length;
    }
    return chunk.write(value);
  }

};

for(var key in helpers) {
  dust.helpers[key] = helpers[key];
}

return dust;

}));

},{"dustjs-linkedin":3}],3:[function(_dereq_,module,exports){
(function (process){(function (){
(function (root, factory) {
  if (typeof define === 'function' && define.amd && define.amd.dust === true) {
    define('dust.core', [], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.dust = factory();
  }
}(this, function() {
  var dust = {
        "version": "3.0.1"
      },
      NONE = 'NONE', ERROR = 'ERROR', WARN = 'WARN', INFO = 'INFO', DEBUG = 'DEBUG',
      EMPTY_FUNC = function() {};

  dust.config = {
    whitespace: false,
    amd: false,
    cjs: false,
    cache: true
  };

  // Directive aliases to minify code
  dust._aliases = {
    "write": "w",
    "end": "e",
    "map": "m",
    "render": "r",
    "reference": "f",
    "section": "s",
    "exists": "x",
    "notexists": "nx",
    "block": "b",
    "partial": "p",
    "helper": "h"
  };

  (function initLogging() {
    /*global process, console*/
    var loggingLevels = { DEBUG: 0, INFO: 1, WARN: 2, ERROR: 3, NONE: 4 },
        consoleLog,
        log;

    if (typeof console !== 'undefined' && console.log) {
      consoleLog = console.log;
      if(typeof consoleLog === 'function') {
        log = function() {
          consoleLog.apply(console, arguments);
        };
      } else {
        log = function() {
          consoleLog(Array.prototype.slice.apply(arguments).join(' '));
        };
      }
    } else {
      log = EMPTY_FUNC;
    }

    /**
     * Filters messages based on `dust.debugLevel`.
     * This default implementation will print to the console if it exists.
     * @param {String|Error} message the message to print/throw
     * @param {String} type the severity of the message(ERROR, WARN, INFO, or DEBUG)
     * @public
     */
    dust.log = function(message, type) {
      type = type || INFO;
      if (loggingLevels[type] >= loggingLevels[dust.debugLevel]) {
        log('[DUST:' + type + ']', message);
        if (type === ERROR && dust.debugLevel === DEBUG && message instanceof Error && message.stack) {
          log('[DUST:' + type + ']', message.stack);
        }
      }
    };

    dust.debugLevel = NONE;
    if(typeof process !== 'undefined' && process.env && /\bdust\b/.test(process.env.DEBUG)) {
      dust.debugLevel = DEBUG;
    }

  }());

  dust.helpers = {};

  dust.cache = {};

  dust.register = function(name, tmpl) {
    if (!name) {
      return;
    }
    tmpl.templateName = name;
    if (dust.config.cache !== false) {
      dust.cache[name] = tmpl;
    }
  };

  dust.render = function(nameOrTemplate, context, callback) {
    var chunk = new Stub(callback).head;
    try {
      load(nameOrTemplate, chunk, context).end();
    } catch (err) {
      chunk.setError(err);
    }
  };

  dust.stream = function(nameOrTemplate, context) {
    var stream = new Stream(),
        chunk = stream.head;
    dust.nextTick(function() {
      try {
        load(nameOrTemplate, chunk, context).end();
      } catch (err) {
        chunk.setError(err);
      }
    });
    return stream;
  };

  /**
   * Extracts a template function (body_0) from whatever is passed.
   * @param nameOrTemplate {*} Could be:
   *   - the name of a template to load from cache
   *   - a CommonJS-compiled template (a function with a `template` property)
   *   - a template function
   * @param loadFromCache {Boolean} if false, don't look in the cache
   * @return {Function} a template function, if found
   */
  function getTemplate(nameOrTemplate, loadFromCache/*=true*/) {
    if(!nameOrTemplate) {
      return;
    }
    if(typeof nameOrTemplate === 'function' && nameOrTemplate.template) {
      // Sugar away CommonJS module templates
      return nameOrTemplate.template;
    }
    if(dust.isTemplateFn(nameOrTemplate)) {
      // Template functions passed directly
      return nameOrTemplate;
    }
    if(loadFromCache !== false) {
      // Try loading a template with this name from cache
      return dust.cache[nameOrTemplate];
    }
  }

  function load(nameOrTemplate, chunk, context) {
    if(!nameOrTemplate) {
      return chunk.setError(new Error('No template or template name provided to render'));
    }

    var template = getTemplate(nameOrTemplate, dust.config.cache);

    if (template) {
      return template(chunk, Context.wrap(context, template.templateName));
    } else {
      if (dust.onLoad) {
        return chunk.map(function(chunk) {
          // Alias just so it's easier to read that this would always be a name
          var name = nameOrTemplate;
          // Three possible scenarios for a successful callback:
          //   - `require(nameOrTemplate)(dust); cb()`
          //   - `src = readFile('src.dust'); cb(null, src)`
          //   - `compiledTemplate = require(nameOrTemplate)(dust); cb(null, compiledTemplate)`
          function done(err, srcOrTemplate) {
            var template;
            if (err) {
              return chunk.setError(err);
            }
            // Prefer a template that is passed via callback over the cached version.
            template = getTemplate(srcOrTemplate, false) || getTemplate(name, dust.config.cache);
            if (!template) {
              // It's a template string, compile it and register under `name`
              if(dust.compile) {
                template = dust.loadSource(dust.compile(srcOrTemplate, name));
              } else {
                return chunk.setError(new Error('Dust compiler not available'));
              }
            }
            template(chunk, Context.wrap(context, template.templateName)).end();
          }

          if(dust.onLoad.length === 3) {
            dust.onLoad(name, context.options, done);
          } else {
            dust.onLoad(name, done);
          }
        });
      }
      return chunk.setError(new Error('Template Not Found: ' + nameOrTemplate));
    }
  }

  dust.loadSource = function(source) {
    /*jshint evil:true*/
    return eval(source);
  };

  if (Array.isArray) {
    dust.isArray = Array.isArray;
  } else {
    dust.isArray = function(arr) {
      return Object.prototype.toString.call(arr) === '[object Array]';
    };
  }

  dust.nextTick = (function() {
    return function(callback) {
      setTimeout(callback, 0);
    };
  })();

  /**
   * Dust has its own rules for what is "empty"-- which is not the same as falsy.
   * Empty arrays, null, and undefined are empty
   */
  dust.isEmpty = function(value) {
    if (value === 0) {
      return false;
    }
    if (dust.isArray(value) && !value.length) {
      return true;
    }
    return !value;
  };

  dust.isEmptyObject = function(obj) {
    var key;
    if (obj === null) {
      return false;
    }
    if (obj === undefined) {
      return false;
    }
    if (obj.length > 0) {
      return false;
    }
    for (key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return false;
      }
    }
    return true;
  };

  dust.isTemplateFn = function(elem) {
    return typeof elem === 'function' &&
           elem.__dustBody;
  };

  /**
   * Decide somewhat-naively if something is a Thenable.  Matches Promises A+ Spec, section 1.2 “thenable” is an object or function that defines a then method."
   * @param elem {*} object to inspect
   * @return {Boolean} is `elem` a Thenable?
   */
  dust.isThenable = function(elem) {
    return elem &&  /* Beware: `typeof null` is `object` */
           (typeof elem === 'object' || typeof elem === 'function') &&
           typeof elem.then === 'function';
  };

  /**
   * Decide if an element is a function but not Thenable; it is prefereable to resolve a thenable function by its `.then` method.
   * @param elem {*} target of inspection
   * @return {Boolean} is `elem` a function without a `.then` property?
   */
  dust.isNonThenableFunction = function(elem) {
    return typeof elem === 'function' && !dust.isThenable(elem);
  };

  /**
   * Decide very naively if something is a Stream.
   * @param elem {*} object to inspect
   * @return {Boolean} is `elem` a Stream?
   */
  dust.isStreamable = function(elem) {
    return elem &&
           typeof elem.on === 'function' &&
           typeof elem.pipe === 'function';
  };

  // apply the filter chain and return the output string
  dust.filter = function(string, auto, filters, context) {
    var i, len, name, filter;
    if (filters) {
      for (i = 0, len = filters.length; i < len; i++) {
        name = filters[i];
        if (!name.length) {
          continue;
        }
        filter = dust.filters[name];
        if (name === 's') {
          auto = null;
        } else if (typeof filter === 'function') {
          string = filter(string, context);
        } else {
          dust.log('Invalid filter `' + name + '`', WARN);
        }
      }
    }
    // by default always apply the h filter, unless asked to unescape with |s
    if (auto) {
      string = dust.filters[auto](string, context);
    }
    return string;
  };

  dust.filters = {
    h: function(value) { return dust.escapeHtml(value); },
    j: function(value) { return dust.escapeJs(value); },
    u: encodeURI,
    uc: encodeURIComponent,
    js: function(value) { return dust.escapeJSON(value); },
    jp: function(value) {
      if (!JSON) {dust.log('JSON is undefined; could not parse `' + value + '`', WARN);
        return value;
      } else {
        return JSON.parse(value);
      }
    }
  };

  function Context(stack, global, options, blocks, templateName) {
    if(stack !== undefined && !(stack instanceof Stack)) {
      stack = new Stack(stack);
    }
    this.stack = stack;
    this.global = global;
    this.options = options;
    this.blocks = blocks;
    this.templateName = templateName;
    this._isContext = true;
  }

  dust.makeBase = dust.context = function(global, options) {
    return new Context(undefined, global, options);
  };

  dust.isContext = function(obj) {
    return typeof obj === "object" && obj._isContext === true;
  };

  /**
   * Factory function that creates a closure scope around a Thenable-callback.
   * Returns a function that can be passed to a Thenable that will resume a
   * Context lookup once the Thenable resolves with new data, adding that new
   * data to the lookup stack.
   */
  function getWithResolvedData(ctx, cur, down) {
    return function(data) {
      return ctx.push(data)._get(cur, down);
    };
  }

  Context.wrap = function(context, name) {
    if (dust.isContext(context)) {
      context.templateName = name;
      return context;
    }
    return new Context(context, {}, {}, null, name);
  };

  /**
   * Public API for getting a value from the context.
   * @method get
   * @param {string|array} path The path to the value. Supported formats are:
   * 'key'
   * 'path.to.key'
   * '.path.to.key'
   * ['path', 'to', 'key']
   * ['key']
   * @param {boolean} [cur=false] Boolean which determines if the search should be limited to the
   * current context (true), or if get should search in parent contexts as well (false).
   * @public
   * @returns {string|object}
   */
  Context.prototype.get = function(path, cur) {
    if (typeof path === 'string') {
      if (path[0] === '.') {
        cur = true;
        path = path.substr(1);
      }
      path = path.split('.');
    }
    return this._get(cur, path);
  };

  /**
   * Get a value from the context
   * @method _get
   * @param {boolean} cur Get only from the current context
   * @param {array} down An array of each step in the path
   * @private
   * @return {string | object}
   */
  Context.prototype._get = function(cur, down) {
    var ctx = this.stack || {},
        i = 1,
        value, first, len, ctxThis, fn;

    first = down[0];
    len = down.length;

    if (cur && len === 0) {
      ctxThis = ctx;
      ctx = ctx.head;
    } else {
      if (!cur) {
        // Search up the stack for the first value
        while (ctx) {
          if (ctx.isObject) {
            ctxThis = ctx.head;
            value = ctx.head[first];
            if (value !== undefined) {
              break;
            }
          }
          ctx = ctx.tail;
        }

        // Try looking in the global context if we haven't found anything yet
        if (value !== undefined) {
          ctx = value;
        } else {
          ctx = this.global && this.global[first];
        }
      } else if (ctx) {
        // if scope is limited by a leading dot, don't search up the tree
        if(ctx.head) {
          ctx = ctx.head[first];
        } else {
          // context's head is empty, value we are searching for is not defined
          ctx = undefined;
        }
      }

      while (ctx && i < len) {
        if (dust.isThenable(ctx)) {
          // Bail early by returning a Thenable for the remainder of the search tree
          return ctx.then(getWithResolvedData(this, cur, down.slice(i)));
        }
        ctxThis = ctx;
        ctx = ctx[down[i]];
        i++;
      }
    }

    if (dust.isNonThenableFunction(ctx)) {
      fn = function() {
        try {
          return ctx.apply(ctxThis, arguments);
        } catch (err) {
          dust.log(err, ERROR);
          throw err;
        }
      };
      fn.__dustBody = !!ctx.__dustBody;
      return fn;
    } else {
      if (ctx === undefined) {
        dust.log('Cannot find reference `{' + down.join('.') + '}` in template `' + this.getTemplateName() + '`', INFO);
      }
      return ctx;
    }
  };

  Context.prototype.getPath = function(cur, down) {
    return this._get(cur, down);
  };

  Context.prototype.push = function(head, idx, len) {
    if(head === undefined) {
      dust.log("Not pushing an undefined variable onto the context", INFO);
      return this;
    }
    return this.rebase(new Stack(head, this.stack, idx, len));
  };

  Context.prototype.pop = function() {
    var head = this.current();
    this.stack = this.stack && this.stack.tail;
    return head;
  };

  Context.prototype.rebase = function(head) {
    return new Context(head, this.global, this.options, this.blocks, this.getTemplateName());
  };

  Context.prototype.clone = function() {
    var context = this.rebase();
    context.stack = this.stack;
    return context;
  };

  Context.prototype.current = function() {
    return this.stack && this.stack.head;
  };

  Context.prototype.getBlock = function(key) {
    var blocks, len, fn;

    if (typeof key === 'function') {
      key = key(new Chunk(), this).data.join('');
    }

    blocks = this.blocks;

    if (!blocks) {
      dust.log('No blocks for context `' + key + '` in template `' + this.getTemplateName() + '`', DEBUG);
      return false;
    }

    len = blocks.length;
    while (len--) {
      fn = blocks[len][key];
      if (fn) {
        return fn;
      }
    }

    dust.log('Malformed template `' + this.getTemplateName() + '` was missing one or more blocks.');
    return false;
  };

  Context.prototype.shiftBlocks = function(locals) {
    var blocks = this.blocks,
        newBlocks;

    if (locals) {
      if (!blocks) {
        newBlocks = [locals];
      } else {
        newBlocks = blocks.concat([locals]);
      }
      return new Context(this.stack, this.global, this.options, newBlocks, this.getTemplateName());
    }
    return this;
  };

  Context.prototype.resolve = function(body) {
    var chunk;

    if(typeof body !== 'function') {
      return body;
    }
    chunk = new Chunk().render(body, this);
    if(chunk instanceof Chunk) {
      return chunk.data.join(''); // ie7 perf
    }
    return chunk;
  };

  Context.prototype.getTemplateName = function() {
    return this.templateName;
  };

  function Stack(head, tail, idx, len) {
    this.tail = tail;
    this.isObject = head && typeof head === 'object';
    this.head = head;
    this.index = idx;
    this.of = len;
  }

  function Stub(callback) {
    this.head = new Chunk(this);
    this.callback = callback;
    this.out = '';
  }

  Stub.prototype.flush = function() {
    var chunk = this.head;

    while (chunk) {
      if (chunk.flushable) {
        this.out += chunk.data.join(''); //ie7 perf
      } else if (chunk.error) {
        this.callback(chunk.error);
        dust.log('Rendering failed with error `' + chunk.error + '`', ERROR);
        this.flush = EMPTY_FUNC;
        return;
      } else {
        return;
      }
      chunk = chunk.next;
      this.head = chunk;
    }
    this.callback(null, this.out);
  };

  /**
   * Creates an interface sort of like a Streams2 ReadableStream.
   */
  function Stream() {
    this.head = new Chunk(this);
  }

  Stream.prototype.flush = function() {
    var chunk = this.head;

    while(chunk) {
      if (chunk.flushable) {
        this.emit('data', chunk.data.join('')); //ie7 perf
      } else if (chunk.error) {
        this.emit('error', chunk.error);
        this.emit('end');
        dust.log('Streaming failed with error `' + chunk.error + '`', ERROR);
        this.flush = EMPTY_FUNC;
        return;
      } else {
        return;
      }
      chunk = chunk.next;
      this.head = chunk;
    }
    this.emit('end');
  };

  /**
   * Executes listeners for `type` by passing data. Note that this is different from a
   * Node stream, which can pass an arbitrary number of arguments
   * @return `true` if event had listeners, `false` otherwise
   */
  Stream.prototype.emit = function(type, data) {
    var events = this.events || {},
        handlers = events[type] || [],
        i, l;

    if (!handlers.length) {
      dust.log('Stream broadcasting, but no listeners for `' + type + '`', DEBUG);
      return false;
    }

    handlers = handlers.slice(0);
    for (i = 0, l = handlers.length; i < l; i++) {
      handlers[i](data);
    }
    return true;
  };

  Stream.prototype.on = function(type, callback) {
    var events = this.events = this.events || {},
        handlers = events[type] = events[type] || [];

    if(typeof callback !== 'function') {
      dust.log('No callback function provided for `' + type + '` event listener', WARN);
    } else {
      handlers.push(callback);
    }
    return this;
  };

  /**
   * Pipes to a WritableStream. Note that backpressure isn't implemented,
   * so we just write as fast as we can.
   * @param stream {WritableStream}
   * @return self
   */
  Stream.prototype.pipe = function(stream) {
    if(typeof stream.write !== 'function' ||
       typeof stream.end !== 'function') {
      dust.log('Incompatible stream passed to `pipe`', WARN);
      return this;
    }

    var destEnded = false;

    if(typeof stream.emit === 'function') {
      stream.emit('pipe', this);
    }

    if(typeof stream.on === 'function') {
      stream.on('error', function() {
        destEnded = true;
      });
    }

    return this
    .on('data', function(data) {
      if(destEnded) {
        return;
      }
      try {
        stream.write(data, 'utf8');
      } catch (err) {
        dust.log(err, ERROR);
      }
    })
    .on('end', function() {
      if(destEnded) {
        return;
      }
      try {
        stream.end();
        destEnded = true;
      } catch (err) {
        dust.log(err, ERROR);
      }
    });
  };

  function Chunk(root, next, taps) {
    this.root = root;
    this.next = next;
    this.data = []; //ie7 perf
    this.flushable = false;
    this.taps = taps;
  }

  Chunk.prototype.write = function(data) {
    var taps = this.taps;

    if (taps) {
      data = taps.go(data);
    }
    this.data.push(data);
    return this;
  };

  Chunk.prototype.end = function(data) {
    if (data) {
      this.write(data);
    }
    this.flushable = true;
    this.root.flush();
    return this;
  };

  /**
   * Inserts a new chunk that can be used to asynchronously render or write to it
   * @param callback {Function} The function that will be called with the new chunk
   * @returns {Chunk} A copy of this chunk instance in order to further chain function calls on the chunk
   */
  Chunk.prototype.map = function(callback) {
    var cursor = new Chunk(this.root, this.next, this.taps),
        branch = new Chunk(this.root, cursor, this.taps);

    this.next = branch;
    this.flushable = true;
    try {
      callback(branch);
    } catch(err) {
      dust.log(err, ERROR);
      branch.setError(err);
    }
    return cursor;
  };

  /**
   * Like Chunk#map but additionally resolves a thenable.  If the thenable succeeds the callback is invoked with
   * a new chunk that can be used to asynchronously render or write to it, otherwise if the thenable is rejected
   * then the error body is rendered if available, an error is logged, and the callback is never invoked.
   * @param {Chunk} The current chunk to insert a new chunk
   * @param thenable {Thenable} the target thenable to await
   * @param context {Context} context to use to render the deferred chunk
   * @param bodies {Object} may optionally contain an "error" for when the thenable is rejected
   * @param callback {Function} The function that will be called with the new chunk
   * @returns {Chunk} A copy of this chunk instance in order to further chain function calls on the chunk
   */
  function mapThenable(chunk, thenable, context, bodies, callback) {
    return chunk.map(function(asyncChunk) {
      thenable.then(function(data) {
        try {
          callback(asyncChunk, data);
        } catch (err) {
          // handle errors the same way Chunk#map would.  This logic is only here since the thenable defers
          // logic such that the try / catch in Chunk#map would not capture it.
          dust.log(err, ERROR);
          asyncChunk.setError(err);
        }
      }, function(err) {
        dust.log('Unhandled promise rejection in `' + context.getTemplateName() + '`', INFO);
        asyncChunk.renderError(err, context, bodies).end();
      });
    });
  }

  Chunk.prototype.tap = function(tap) {
    var taps = this.taps;

    if (taps) {
      this.taps = taps.push(tap);
    } else {
      this.taps = new Tap(tap);
    }
    return this;
  };

  Chunk.prototype.untap = function() {
    this.taps = this.taps.tail;
    return this;
  };

  Chunk.prototype.render = function(body, context) {
    return body(this, context);
  };

  Chunk.prototype.reference = function(elem, context, auto, filters) {
    if (dust.isNonThenableFunction(elem)) {
      elem = elem.apply(context.current(), [this, context, null, {auto: auto, filters: filters}]);
      if (elem instanceof Chunk) {
        return elem;
      } else {
        return this.reference(elem, context, auto, filters);
      }
    }
    if (dust.isThenable(elem)) {
      return this.await(elem, context, null, auto, filters);
    } else if (dust.isStreamable(elem)) {
      return this.stream(elem, context, null, auto, filters);
    } else if (!dust.isEmpty(elem)) {
      return this.write(dust.filter(elem, auto, filters, context));
    } else {
      return this;
    }
  };

  Chunk.prototype.section = function(elem, context, bodies, params) {
    var body = bodies.block,
        skip = bodies['else'],
        chunk = this,
        i, len, head;

    if (dust.isNonThenableFunction(elem) && !dust.isTemplateFn(elem)) {
      try {
        elem = elem.apply(context.current(), [this, context, bodies, params]);
      } catch(err) {
        dust.log(err, ERROR);
        return this.setError(err);
      }
      // Functions that return chunks are assumed to have handled the chunk manually.
      // Make that chunk the current one and go to the next method in the chain.
      if (elem instanceof Chunk) {
        return elem;
      }
    }

    if (dust.isEmptyObject(bodies)) {
      // No bodies to render, and we've already invoked any function that was available in
      // hopes of returning a Chunk.
      return chunk;
    }

    if (!dust.isEmptyObject(params)) {
      context = context.push(params);
    }

    /*
    Dust's default behavior is to enumerate over the array elem, passing each object in the array to the block.
    When elem resolves to a value or object instead of an array, Dust sets the current context to the value
    and renders the block one time.
    */
    if (dust.isArray(elem)) {
      if (body) {
        len = elem.length;
        if (len > 0) {
          head = context.stack && context.stack.head || {};
          head.$len = len;
          for (i = 0; i < len; i++) {
            head.$idx = i;
            chunk = body(chunk, context.push(elem[i], i, len));
          }
          head.$idx = undefined;
          head.$len = undefined;
          return chunk;
        } else if (skip) {
          return skip(this, context);
        }
      }
    } else if (dust.isThenable(elem)) {
      return this.await(elem, context, bodies);
    } else if (dust.isStreamable(elem)) {
      return this.stream(elem, context, bodies);
    } else if (elem === true) {
     // true is truthy but does not change context
      if (body) {
        return body(this, context);
      }
    } else if (elem || elem === 0) {
       // everything that evaluates to true are truthy ( e.g. Non-empty strings and Empty objects are truthy. )
       // zero is truthy
       // for anonymous functions that did not returns a chunk, truthiness is evaluated based on the return value
      if (body) {
        return body(this, context.push(elem));
      }
     // nonexistent, scalar false value, scalar empty string, null,
     // undefined are all falsy
    } else if (skip) {
      return skip(this, context);
    }
    dust.log('Section without corresponding key in template `' + context.getTemplateName() + '`', DEBUG);
    return this;
  };

  Chunk.prototype.exists = function(elem, context, bodies) {
    var body = bodies.block,
        skip = bodies['else'];

    if (dust.isThenable(elem)) {
      return mapThenable(this, elem, context, bodies, function(chunk, data) {
        chunk.exists(data, context, bodies).end();
      });
    }

    if (!dust.isEmpty(elem)) {
      if (body) {
        return body(this, context);
      }
      dust.log('No block for exists check in template `' + context.getTemplateName() + '`', DEBUG);
    } else if (skip) {
      return skip(this, context);
    }
    return this;
  };

  Chunk.prototype.notexists = function(elem, context, bodies) {
    var body = bodies.block,
        skip = bodies['else'];

    if (dust.isThenable(elem)) {
      return mapThenable(this, elem, context, bodies, function(chunk, data) {
        chunk.notexists(data, context, bodies).end();
      });
    }

    if (dust.isEmpty(elem)) {
      if (body) {
        return body(this, context);
      }
      dust.log('No block for not-exists check in template `' + context.getTemplateName() + '`', DEBUG);
    } else if (skip) {
      return skip(this, context);
    }
    return this;
  };

  Chunk.prototype.block = function(elem, context, bodies) {
    var body = elem || bodies.block;

    if (body) {
      return body(this, context);
    }
    return this;
  };

  Chunk.prototype.partial = function(elem, context, partialContext, params) {
    var head;

    if(params === undefined) {
      // Compatibility for < 2.7.0 where `partialContext` did not exist
      params = partialContext;
      partialContext = context;
    }

    if (!dust.isEmptyObject(params)) {
      partialContext = partialContext.clone();
      head = partialContext.pop();
      partialContext = partialContext.push(params)
                                     .push(head);
    }

    if (dust.isTemplateFn(elem)) {
      // The eventual result of evaluating `elem` is a partial name
      // Load the partial after getting its name and end the async chunk
      return this.capture(elem, context, function(name, chunk) {
        load(name, chunk, partialContext).end();
      });
    } else {
      return load(elem, this, partialContext);
    }
  };

  Chunk.prototype.helper = function(name, context, bodies, params, auto) {
    var chunk = this,
        filters = params.filters,
        ret;

    // Pre-2.7.1 compat: if auto is undefined, it's an old template. Automatically escape
    if (auto === undefined) {
      auto = 'h';
    }

    // handle invalid helpers, similar to invalid filters
    if(dust.helpers[name]) {
      try {
        ret = dust.helpers[name](chunk, context, bodies, params);
        if (ret instanceof Chunk) {
          return ret;
        }
        if(typeof filters === 'string') {
          filters = filters.split('|');
        }
        if (!dust.isEmptyObject(bodies)) {
          return chunk.section(ret, context, bodies, params);
        }
        // Helpers act slightly differently from functions in context in that they will act as
        // a reference if they are self-closing (due to grammar limitations)
        // In the Chunk.await function we check to make sure bodies is null before acting as a reference
        return chunk.reference(ret, context, auto, filters);
      } catch(err) {
        dust.log('Error in helper `' + name + '`: ' + err.message, ERROR);
        return chunk.setError(err);
      }
    } else {
      dust.log('Helper `' + name + '` does not exist', WARN);
      return chunk;
    }
  };

  /**
   * Reserve a chunk to be evaluated once a thenable is resolved or rejected
   * @param thenable {Thenable} the target thenable to await
   * @param context {Context} context to use to render the deferred chunk
   * @param bodies {Object} must contain a "body", may contain an "error"
   * @param auto {String} automatically apply this filter if the Thenable is a reference
   * @param filters {Array} apply these filters if the Thenable is a reference
   * @return {Chunk}
   */
  Chunk.prototype.await = function(thenable, context, bodies, auto, filters) {
    return mapThenable(this, thenable, context, bodies, function(chunk, data) {
      if (bodies) {
        chunk.section(data, context, bodies).end();
      } else {
        // Actually a reference. Self-closing sections don't render
        chunk.reference(data, context, auto, filters).end();
      }
    });
  };

  /**
   * Render an error body if available
   * @param err {Error} error that occurred
   * @param context {Context} context to use to render the error
   * @param bodies {Object} may optionally contain an "error" which will be rendered
   * @return {Chunk}
   */
  Chunk.prototype.renderError = function(err, context, bodies) {
    var errorBody = bodies && bodies.error;
    if (errorBody) {
      return this.render(errorBody, context.push(err));
    }
    return this;
  };

  /**
   * Reserve a chunk to be evaluated with the contents of a streamable.
   * Currently an error event will bomb out the stream. Once an error
   * is received, we push it to an {:error} block if one exists, and log otherwise,
   * then stop listening to the stream.
   * @param streamable {Streamable} the target streamable that will emit events
   * @param context {Context} context to use to render each thunk
   * @param bodies {Object} must contain a "body", may contain an "error"
   * @return {Chunk}
   */
  Chunk.prototype.stream = function(stream, context, bodies, auto, filters) {
    var body = bodies && bodies.block;
    return this.map(function(chunk) {
      var ended = false;
      stream
        .on('data', function data(thunk) {
          if(ended) {
            return;
          }
          if(body) {
            // Fork a new chunk out of the blockstream so that we can flush it independently
            chunk = chunk.map(function(chunk) {
              chunk.render(body, context.push(thunk)).end();
            });
          } else if(!bodies) {
            // When actually a reference, don't fork, just write into the master async chunk
            chunk = chunk.reference(thunk, context, auto, filters);
          }
        })
        .on('error', function error(err) {
          if(ended) {
            return;
          }
          chunk.renderError(err, context, bodies);
          dust.log('Unhandled stream error in `' + context.getTemplateName() + '`', INFO);
          if(!ended) {
            ended = true;
            chunk.end();
          }
        })
        .on('end', function end() {
          if(!ended) {
            ended = true;
            chunk.end();
          }
        });
    });
  };

  Chunk.prototype.capture = function(body, context, callback) {
    return this.map(function(chunk) {
      var stub = new Stub(function(err, out) {
        if (err) {
          chunk.setError(err);
        } else {
          callback(out, chunk);
        }
      });
      body(stub.head, context).end();
    });
  };

  Chunk.prototype.setError = function(err) {
    this.error = err;
    this.root.flush();
    return this;
  };

  // Chunk aliases
  for(var f in Chunk.prototype) {
    if(dust._aliases[f]) {
      Chunk.prototype[dust._aliases[f]] = Chunk.prototype[f];
    }
  }

  function Tap(head, tail) {
    this.head = head;
    this.tail = tail;
  }

  Tap.prototype.push = function(tap) {
    return new Tap(tap, this);
  };

  Tap.prototype.go = function(value) {
    var tap = this;

    while(tap) {
      value = tap.head(value);
      tap = tap.tail;
    }
    return value;
  };

  var HCHARS = /[&<>"']/,
      AMP    = /&/g,
      LT     = /</g,
      GT     = />/g,
      QUOT   = /\"/g,
      SQUOT  = /\'/g;

  dust.escapeHtml = function(s) {
    if (typeof s === "string" || (s && typeof s.toString === "function")) {
      if (typeof s !== "string") {
        s = s.toString();
      }
      if (!HCHARS.test(s)) {
        return s;
      }
      return s.replace(AMP,'&amp;').replace(LT,'&lt;').replace(GT,'&gt;').replace(QUOT,'&quot;').replace(SQUOT, '&#39;');
    }
    return s;
  };

  var BS = /\\/g,
      FS = /\//g,
      CR = /\r/g,
      LS = /\u2028/g,
      PS = /\u2029/g,
      NL = /\n/g,
      LF = /\f/g,
      SQ = /'/g,
      DQ = /"/g,
      TB = /\t/g;

  dust.escapeJs = function(s) {
    if (typeof s === 'string') {
      return s
        .replace(BS, '\\\\')
        .replace(FS, '\\/')
        .replace(DQ, '\\"')
        .replace(SQ, '\\\'')
        .replace(CR, '\\r')
        .replace(LS, '\\u2028')
        .replace(PS, '\\u2029')
        .replace(NL, '\\n')
        .replace(LF, '\\f')
        .replace(TB, '\\t');
    }
    return s;
  };

  dust.escapeJSON = function(o) {
    if (!JSON) {
      dust.log('JSON is undefined; could not escape `' + o + '`', WARN);
      return o;
    } else {
      return JSON.stringify(o)
        .replace(LS, '\\u2028')
        .replace(PS, '\\u2029')
        .replace(LT, '\\u003c');
    }
  };

  return dust;

}));

}).call(this)}).call(this,_dereq_('_process'))
},{"_process":6}],4:[function(_dereq_,module,exports){
/**
* @preserve HTML5 Shiv 3.7.3 | @afarkas @jdalton @jon_neal @rem | MIT/GPL2 Licensed
*/
;(function(window, document) {
/*jshint evil:true */
  /** version */
  var version = '3.7.3-pre';

  /** Preset options */
  var options = window.html5 || {};

  /** Used to skip problem elements */
  var reSkip = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i;

  /** Not all elements can be cloned in IE **/
  var saveClones = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i;

  /** Detect whether the browser supports default html5 styles */
  var supportsHtml5Styles;

  /** Name of the expando, to work with multiple documents or to re-shiv one document */
  var expando = '_html5shiv';

  /** The id for the the documents expando */
  var expanID = 0;

  /** Cached data for each document */
  var expandoData = {};

  /** Detect whether the browser supports unknown elements */
  var supportsUnknownElements;

  (function() {
    try {
        var a = document.createElement('a');
        a.innerHTML = '<xyz></xyz>';
        //if the hidden property is implemented we can assume, that the browser supports basic HTML5 Styles
        supportsHtml5Styles = ('hidden' in a);

        supportsUnknownElements = a.childNodes.length == 1 || (function() {
          // assign a false positive if unable to shiv
          (document.createElement)('a');
          var frag = document.createDocumentFragment();
          return (
            typeof frag.cloneNode == 'undefined' ||
            typeof frag.createDocumentFragment == 'undefined' ||
            typeof frag.createElement == 'undefined'
          );
        }());
    } catch(e) {
      // assign a false positive if detection fails => unable to shiv
      supportsHtml5Styles = true;
      supportsUnknownElements = true;
    }

  }());

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a style sheet with the given CSS text and adds it to the document.
   * @private
   * @param {Document} ownerDocument The document.
   * @param {String} cssText The CSS text.
   * @returns {StyleSheet} The style element.
   */
  function addStyleSheet(ownerDocument, cssText) {
    var p = ownerDocument.createElement('p'),
        parent = ownerDocument.getElementsByTagName('head')[0] || ownerDocument.documentElement;

    p.innerHTML = 'x<style>' + cssText + '</style>';
    return parent.insertBefore(p.lastChild, parent.firstChild);
  }

  /**
   * Returns the value of `html5.elements` as an array.
   * @private
   * @returns {Array} An array of shived element node names.
   */
  function getElements() {
    var elements = html5.elements;
    return typeof elements == 'string' ? elements.split(' ') : elements;
  }

  /**
   * Extends the built-in list of html5 elements
   * @memberOf html5
   * @param {String|Array} newElements whitespace separated list or array of new element names to shiv
   * @param {Document} ownerDocument The context document.
   */
  function addElements(newElements, ownerDocument) {
    var elements = html5.elements;
    if(typeof elements != 'string'){
      elements = elements.join(' ');
    }
    if(typeof newElements != 'string'){
      newElements = newElements.join(' ');
    }
    html5.elements = elements +' '+ newElements;
    shivDocument(ownerDocument);
  }

   /**
   * Returns the data associated to the given document
   * @private
   * @param {Document} ownerDocument The document.
   * @returns {Object} An object of data.
   */
  function getExpandoData(ownerDocument) {
    var data = expandoData[ownerDocument[expando]];
    if (!data) {
        data = {};
        expanID++;
        ownerDocument[expando] = expanID;
        expandoData[expanID] = data;
    }
    return data;
  }

  /**
   * returns a shived element for the given nodeName and document
   * @memberOf html5
   * @param {String} nodeName name of the element
   * @param {Document} ownerDocument The context document.
   * @returns {Object} The shived element.
   */
  function createElement(nodeName, ownerDocument, data){
    if (!ownerDocument) {
        ownerDocument = document;
    }
    if(supportsUnknownElements){
        return ownerDocument.createElement(nodeName);
    }
    if (!data) {
        data = getExpandoData(ownerDocument);
    }
    var node;

    if (data.cache[nodeName]) {
        node = data.cache[nodeName].cloneNode();
    } else if (saveClones.test(nodeName)) {
        node = (data.cache[nodeName] = data.createElem(nodeName)).cloneNode();
    } else {
        node = data.createElem(nodeName);
    }

    // Avoid adding some elements to fragments in IE < 9 because
    // * Attributes like `name` or `type` cannot be set/changed once an element
    //   is inserted into a document/fragment
    // * Link elements with `src` attributes that are inaccessible, as with
    //   a 403 response, will cause the tab/window to crash
    // * Script elements appended to fragments will execute when their `src`
    //   or `text` property is set
    return node.canHaveChildren && !reSkip.test(nodeName) && !node.tagUrn ? data.frag.appendChild(node) : node;
  }

  /**
   * returns a shived DocumentFragment for the given document
   * @memberOf html5
   * @param {Document} ownerDocument The context document.
   * @returns {Object} The shived DocumentFragment.
   */
  function createDocumentFragment(ownerDocument, data){
    if (!ownerDocument) {
        ownerDocument = document;
    }
    if(supportsUnknownElements){
        return ownerDocument.createDocumentFragment();
    }
    data = data || getExpandoData(ownerDocument);
    var clone = data.frag.cloneNode(),
        i = 0,
        elems = getElements(),
        l = elems.length;
    for(;i<l;i++){
        clone.createElement(elems[i]);
    }
    return clone;
  }

  /**
   * Shivs the `createElement` and `createDocumentFragment` methods of the document.
   * @private
   * @param {Document|DocumentFragment} ownerDocument The document.
   * @param {Object} data of the document.
   */
  function shivMethods(ownerDocument, data) {
    if (!data.cache) {
        data.cache = {};
        data.createElem = ownerDocument.createElement;
        data.createFrag = ownerDocument.createDocumentFragment;
        data.frag = data.createFrag();
    }


    ownerDocument.createElement = function(nodeName) {
      //abort shiv
      if (!html5.shivMethods) {
          return data.createElem(nodeName);
      }
      return createElement(nodeName, ownerDocument, data);
    };

    ownerDocument.createDocumentFragment = Function('h,f', 'return function(){' +
      'var n=f.cloneNode(),c=n.createElement;' +
      'h.shivMethods&&(' +
        // unroll the `createElement` calls
        getElements().join().replace(/[\w\-:]+/g, function(nodeName) {
          data.createElem(nodeName);
          data.frag.createElement(nodeName);
          return 'c("' + nodeName + '")';
        }) +
      ');return n}'
    )(html5, data.frag);
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Shivs the given document.
   * @memberOf html5
   * @param {Document} ownerDocument The document to shiv.
   * @returns {Document} The shived document.
   */
  function shivDocument(ownerDocument) {
    if (!ownerDocument) {
        ownerDocument = document;
    }
    var data = getExpandoData(ownerDocument);

    if (html5.shivCSS && !supportsHtml5Styles && !data.hasCSS) {
      data.hasCSS = !!addStyleSheet(ownerDocument,
        // corrects block display not defined in IE6/7/8/9
        'article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}' +
        // adds styling not present in IE6/7/8/9
        'mark{background:#FF0;color:#000}' +
        // hides non-rendered elements
        'template{display:none}'
      );
    }
    if (!supportsUnknownElements) {
      shivMethods(ownerDocument, data);
    }
    return ownerDocument;
  }

  /*--------------------------------------------------------------------------*/

  /**
   * The `html5` object is exposed so that more elements can be shived and
   * existing shiving can be detected on iframes.
   * @type Object
   * @example
   *
   * // options can be changed before the script is included
   * html5 = { 'elements': 'mark section', 'shivCSS': false, 'shivMethods': false };
   */
  var html5 = {

    /**
     * An array or space separated string of node names of the elements to shiv.
     * @memberOf html5
     * @type Array|String
     */
    'elements': options.elements || 'abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video',

    /**
     * current version of html5shiv
     */
    'version': version,

    /**
     * A flag to indicate that the HTML5 style sheet should be inserted.
     * @memberOf html5
     * @type Boolean
     */
    'shivCSS': (options.shivCSS !== false),

    /**
     * Is equal to true if a browser supports creating unknown/HTML5 elements
     * @memberOf html5
     * @type boolean
     */
    'supportsUnknownElements': supportsUnknownElements,

    /**
     * A flag to indicate that the document's `createElement` and `createDocumentFragment`
     * methods should be overwritten.
     * @memberOf html5
     * @type Boolean
     */
    'shivMethods': (options.shivMethods !== false),

    /**
     * A string to describe the type of `html5` object ("default" or "default print").
     * @memberOf html5
     * @type String
     */
    'type': 'default',

    // shivs the document according to the specified `html5` object options
    'shivDocument': shivDocument,

    //creates a shived element
    createElement: createElement,

    //creates a shived documentFragment
    createDocumentFragment: createDocumentFragment,

    //extends list of elements
    addElements: addElements
  };

  /*--------------------------------------------------------------------------*/

  // expose html5
  window.html5 = html5;

  // shiv the document
  shivDocument(document);

  if(typeof module == 'object' && module.exports){
    module.exports = html5;
  }

}(typeof window !== "undefined" ? window : this, document));

},{}],5:[function(_dereq_,module,exports){

var L = {
	version: '1.0.1'
};

function expose() {
	var oldL = window.L;

	L.noConflict = function () {
		window.L = oldL;
		return this;
	};

	window.L = L;
}

// define Leaflet for Node module pattern loaders, including Browserify
if (typeof module === 'object' && typeof module.exports === 'object') {
	module.exports = L;

// define Leaflet as an AMD module
} else if (typeof define === 'function' && define.amd) {
	define(L);
}

// define Leaflet as a global L variable, saving the original L to restore later if needed
if (typeof window !== 'undefined') {
	expose();
}

/*
 * @namespace Util
 *
 * Various utility functions, used by Leaflet internally.
 */

L.Util = {

	// @function extend(dest: Object, src?: Object): Object
	// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
	extend: function (dest) {
		var i, j, len, src;

		for (j = 1, len = arguments.length; j < len; j++) {
			src = arguments[j];
			for (i in src) {
				dest[i] = src[i];
			}
		}
		return dest;
	},

	// @function create(proto: Object, properties?: Object): Object
	// Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
	create: Object.create || (function () {
		function F() {}
		return function (proto) {
			F.prototype = proto;
			return new F();
		};
	})(),

	// @function bind(fn: Function, …): Function
	// Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	// Has a `L.bind()` shortcut.
	bind: function (fn, obj) {
		var slice = Array.prototype.slice;

		if (fn.bind) {
			return fn.bind.apply(fn, slice.call(arguments, 1));
		}

		var args = slice.call(arguments, 2);

		return function () {
			return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
		};
	},

	// @function stamp(obj: Object): Number
	// Returns the unique ID of an object, assiging it one if it doesn't have it.
	stamp: function (obj) {
		/*eslint-disable */
		obj._leaflet_id = obj._leaflet_id || ++L.Util.lastId;
		return obj._leaflet_id;
		/*eslint-enable */
	},

	// @property lastId: Number
	// Last unique ID used by [`stamp()`](#util-stamp)
	lastId: 0,

	// @function throttle(fn: Function, time: Number, context: Object): Function
	// Returns a function which executes function `fn` with the given scope `context`
	// (so that the `this` keyword refers to `context` inside `fn`'s code). The function
	// `fn` will be called no more than one time per given amount of `time`. The arguments
	// received by the bound function will be any arguments passed when binding the
	// function, followed by any arguments passed when invoking the bound function.
	// Has an `L.bind` shortcut.
	throttle: function (fn, time, context) {
		var lock, args, wrapperFn, later;

		later = function () {
			// reset lock and call if queued
			lock = false;
			if (args) {
				wrapperFn.apply(context, args);
				args = false;
			}
		};

		wrapperFn = function () {
			if (lock) {
				// called too soon, queue to call later
				args = arguments;

			} else {
				// call and lock until later
				fn.apply(context, arguments);
				setTimeout(later, time);
				lock = true;
			}
		};

		return wrapperFn;
	},

	// @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
	// Returns the number `num` modulo `range` in such a way so it lies within
	// `range[0]` and `range[1]`. The returned value will be always smaller than
	// `range[1]` unless `includeMax` is set to `true`.
	wrapNum: function (x, range, includeMax) {
		var max = range[1],
		    min = range[0],
		    d = max - min;
		return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
	},

	// @function falseFn(): Function
	// Returns a function which always returns `false`.
	falseFn: function () { return false; },

	// @function formatNum(num: Number, digits?: Number): Number
	// Returns the number `num` rounded to `digits` decimals, or to 5 decimals by default.
	formatNum: function (num, digits) {
		var pow = Math.pow(10, digits || 5);
		return Math.round(num * pow) / pow;
	},

	// @function trim(str: String): String
	// Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
	trim: function (str) {
		return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	},

	// @function splitWords(str: String): String[]
	// Trims and splits the string on whitespace and returns the array of parts.
	splitWords: function (str) {
		return L.Util.trim(str).split(/\s+/);
	},

	// @function setOptions(obj: Object, options: Object): Object
	// Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
	setOptions: function (obj, options) {
		if (!obj.hasOwnProperty('options')) {
			obj.options = obj.options ? L.Util.create(obj.options) : {};
		}
		for (var i in options) {
			obj.options[i] = options[i];
		}
		return obj.options;
	},

	// @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
	// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
	// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
	// be appended at the end. If `uppercase` is `true`, the parameter names will
	// be uppercased (e.g. `'?A=foo&B=bar'`)
	getParamString: function (obj, existingUrl, uppercase) {
		var params = [];
		for (var i in obj) {
			params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
		}
		return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
	},

	// @function template(str: String, data: Object): String
	// Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
	// and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
	// `('Hello foo, bar')`. You can also specify functions instead of strings for
	// data values — they will be evaluated passing `data` as an argument.
	template: function (str, data) {
		return str.replace(L.Util.templateRe, function (str, key) {
			var value = data[key];

			if (value === undefined) {
				throw new Error('No value provided for variable ' + str);

			} else if (typeof value === 'function') {
				value = value(data);
			}
			return value;
		});
	},

	templateRe: /\{ *([\w_\-]+) *\}/g,

	// @function isArray(obj): Boolean
	// Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
	isArray: Array.isArray || function (obj) {
		return (Object.prototype.toString.call(obj) === '[object Array]');
	},

	// @function indexOf(array: Array, el: Object): Number
	// Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
	indexOf: function (array, el) {
		for (var i = 0; i < array.length; i++) {
			if (array[i] === el) { return i; }
		}
		return -1;
	},

	// @property emptyImageUrl: String
	// Data URI string containing a base64-encoded empty GIF image.
	// Used as a hack to free memory from unused images on WebKit-powered
	// mobile devices (by setting image `src` to this string).
	emptyImageUrl: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
};

(function () {
	// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/

	function getPrefixed(name) {
		return window['webkit' + name] || window['moz' + name] || window['ms' + name];
	}

	var lastTime = 0;

	// fallback for IE 7-8
	function timeoutDefer(fn) {
		var time = +new Date(),
		    timeToCall = Math.max(0, 16 - (time - lastTime));

		lastTime = time + timeToCall;
		return window.setTimeout(fn, timeToCall);
	}

	var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer,
	    cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
	               getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };


	// @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
	// Schedules `fn` to be executed when the browser repaints. `fn` is bound to
	// `context` if given. When `immediate` is set, `fn` is called immediately if
	// the browser doesn't have native support for
	// [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
	// otherwise it's delayed. Returns a request ID that can be used to cancel the request.
	L.Util.requestAnimFrame = function (fn, context, immediate) {
		if (immediate && requestFn === timeoutDefer) {
			fn.call(context);
		} else {
			return requestFn.call(window, L.bind(fn, context));
		}
	};

	// @function cancelAnimFrame(id: Number): undefined
	// Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
	L.Util.cancelAnimFrame = function (id) {
		if (id) {
			cancelFn.call(window, id);
		}
	};
})();

// shortcuts for most used utility functions
L.extend = L.Util.extend;
L.bind = L.Util.bind;
L.stamp = L.Util.stamp;
L.setOptions = L.Util.setOptions;


// @class Class
// @aka L.Class

// @section
// @uninheritable

// Thanks to John Resig and Dean Edwards for inspiration!

L.Class = function () {};

L.Class.extend = function (props) {

	// @function extend(props: Object): Function
	// [Extends the current class](#class-inheritance) given the properties to be included.
	// Returns a Javascript function that is a class constructor (to be called with `new`).
	var NewClass = function () {

		// call the constructor
		if (this.initialize) {
			this.initialize.apply(this, arguments);
		}

		// call all constructor hooks
		this.callInitHooks();
	};

	var parentProto = NewClass.__super__ = this.prototype;

	var proto = L.Util.create(parentProto);
	proto.constructor = NewClass;

	NewClass.prototype = proto;

	// inherit parent's statics
	for (var i in this) {
		if (this.hasOwnProperty(i) && i !== 'prototype') {
			NewClass[i] = this[i];
		}
	}

	// mix static properties into the class
	if (props.statics) {
		L.extend(NewClass, props.statics);
		delete props.statics;
	}

	// mix includes into the prototype
	if (props.includes) {
		L.Util.extend.apply(null, [proto].concat(props.includes));
		delete props.includes;
	}

	// merge options
	if (proto.options) {
		props.options = L.Util.extend(L.Util.create(proto.options), props.options);
	}

	// mix given properties into the prototype
	L.extend(proto, props);

	proto._initHooks = [];

	// add method for calling all hooks
	proto.callInitHooks = function () {

		if (this._initHooksCalled) { return; }

		if (parentProto.callInitHooks) {
			parentProto.callInitHooks.call(this);
		}

		this._initHooksCalled = true;

		for (var i = 0, len = proto._initHooks.length; i < len; i++) {
			proto._initHooks[i].call(this);
		}
	};

	return NewClass;
};


// @function include(properties: Object): this
// [Includes a mixin](#class-includes) into the current class.
L.Class.include = function (props) {
	L.extend(this.prototype, props);
	return this;
};

// @function mergeOptions(options: Object): this
// [Merges `options`](#class-options) into the defaults of the class.
L.Class.mergeOptions = function (options) {
	L.extend(this.prototype.options, options);
	return this;
};

// @function addInitHook(fn: Function): this
// Adds a [constructor hook](#class-constructor-hooks) to the class.
L.Class.addInitHook = function (fn) { // (Function) || (String, args...)
	var args = Array.prototype.slice.call(arguments, 1);

	var init = typeof fn === 'function' ? fn : function () {
		this[fn].apply(this, args);
	};

	this.prototype._initHooks = this.prototype._initHooks || [];
	this.prototype._initHooks.push(init);
	return this;
};

/*
 * @class Evented
 * @aka L.Evented
 * @inherits Class
 *
 * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
 *
 * @example
 *
 * ```js
 * map.on('click', function(e) {
 * 	alert(e.latlng);
 * } );
 * ```
 *
 * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
 *
 * ```js
 * function onClick(e) { ... }
 *
 * map.on('click', onClick);
 * map.off('click', onClick);
 * ```
 */


L.Evented = L.Class.extend({

	/* @method on(type: String, fn: Function, context?: Object): this
	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
	 *
	 * @alternative
	 * @method on(eventMap: Object): this
	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	 */
	on: function (types, fn, context) {

		// types can be a map of types/handlers
		if (typeof types === 'object') {
			for (var type in types) {
				// we don't process space-separated events here for performance;
				// it's a hot path since Layer uses the on(obj) syntax
				this._on(type, types[type], fn);
			}

		} else {
			// types can be a string of space-separated words
			types = L.Util.splitWords(types);

			for (var i = 0, len = types.length; i < len; i++) {
				this._on(types[i], fn, context);
			}
		}

		return this;
	},

	/* @method off(type: String, fn?: Function, context?: Object): this
	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
	 *
	 * @alternative
	 * @method off(eventMap: Object): this
	 * Removes a set of type/listener pairs.
	 *
	 * @alternative
	 * @method off: this
	 * Removes all listeners to all events on the object.
	 */
	off: function (types, fn, context) {

		if (!types) {
			// clear all listeners if called without arguments
			delete this._events;

		} else if (typeof types === 'object') {
			for (var type in types) {
				this._off(type, types[type], fn);
			}

		} else {
			types = L.Util.splitWords(types);

			for (var i = 0, len = types.length; i < len; i++) {
				this._off(types[i], fn, context);
			}
		}

		return this;
	},

	// attach listener (without syntactic sugar now)
	_on: function (type, fn, context) {
		this._events = this._events || {};

		/* get/init listeners for type */
		var typeListeners = this._events[type];
		if (!typeListeners) {
			typeListeners = [];
			this._events[type] = typeListeners;
		}

		if (context === this) {
			// Less memory footprint.
			context = undefined;
		}
		var newListener = {fn: fn, ctx: context},
		    listeners = typeListeners;

		// check if fn already there
		for (var i = 0, len = listeners.length; i < len; i++) {
			if (listeners[i].fn === fn && listeners[i].ctx === context) {
				return;
			}
		}

		listeners.push(newListener);
		typeListeners.count++;
	},

	_off: function (type, fn, context) {
		var listeners,
		    i,
		    len;

		if (!this._events) { return; }

		listeners = this._events[type];

		if (!listeners) {
			return;
		}

		if (!fn) {
			// Set all removed listeners to noop so they are not called if remove happens in fire
			for (i = 0, len = listeners.length; i < len; i++) {
				listeners[i].fn = L.Util.falseFn;
			}
			// clear all listeners for a type if function isn't specified
			delete this._events[type];
			return;
		}

		if (context === this) {
			context = undefined;
		}

		if (listeners) {

			// find fn and remove it
			for (i = 0, len = listeners.length; i < len; i++) {
				var l = listeners[i];
				if (l.ctx !== context) { continue; }
				if (l.fn === fn) {

					// set the removed listener to noop so that's not called if remove happens in fire
					l.fn = L.Util.falseFn;

					if (this._firingCount) {
						/* copy array in case events are being fired */
						this._events[type] = listeners = listeners.slice();
					}
					listeners.splice(i, 1);

					return;
				}
			}
		}
	},

	// @method fire(type: String, data?: Object, propagate?: Boolean): this
	// Fires an event of the specified type. You can optionally provide an data
	// object — the first argument of the listener function will contain its
	// properties. The event might can optionally be propagated to event parents.
	fire: function (type, data, propagate) {
		if (!this.listens(type, propagate)) { return this; }

		var event = L.Util.extend({}, data, {type: type, target: this});

		if (this._events) {
			var listeners = this._events[type];

			if (listeners) {
				this._firingCount = (this._firingCount + 1) || 1;
				for (var i = 0, len = listeners.length; i < len; i++) {
					var l = listeners[i];
					l.fn.call(l.ctx || this, event);
				}

				this._firingCount--;
			}
		}

		if (propagate) {
			// propagate the event to parents (set with addEventParent)
			this._propagateEvent(event);
		}

		return this;
	},

	// @method listens(type: String): Boolean
	// Returns `true` if a particular event type has any listeners attached to it.
	listens: function (type, propagate) {
		var listeners = this._events && this._events[type];
		if (listeners && listeners.length) { return true; }

		if (propagate) {
			// also check parents for listeners if event propagates
			for (var id in this._eventParents) {
				if (this._eventParents[id].listens(type, propagate)) { return true; }
			}
		}
		return false;
	},

	// @method once(…): this
	// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
	once: function (types, fn, context) {

		if (typeof types === 'object') {
			for (var type in types) {
				this.once(type, types[type], fn);
			}
			return this;
		}

		var handler = L.bind(function () {
			this
			    .off(types, fn, context)
			    .off(types, handler, context);
		}, this);

		// add a listener that's executed once and removed after that
		return this
		    .on(types, fn, context)
		    .on(types, handler, context);
	},

	// @method addEventParent(obj: Evented): this
	// Adds an event parent - an `Evented` that will receive propagated events
	addEventParent: function (obj) {
		this._eventParents = this._eventParents || {};
		this._eventParents[L.stamp(obj)] = obj;
		return this;
	},

	// @method removeEventParent(obj: Evented): this
	// Removes an event parent, so it will stop receiving propagated events
	removeEventParent: function (obj) {
		if (this._eventParents) {
			delete this._eventParents[L.stamp(obj)];
		}
		return this;
	},

	_propagateEvent: function (e) {
		for (var id in this._eventParents) {
			this._eventParents[id].fire(e.type, L.extend({layer: e.target}, e), true);
		}
	}
});

var proto = L.Evented.prototype;

// aliases; we should ditch those eventually

// @method addEventListener(…): this
// Alias to [`on(…)`](#evented-on)
proto.addEventListener = proto.on;

// @method removeEventListener(…): this
// Alias to [`off(…)`](#evented-off)

// @method clearAllEventListeners(…): this
// Alias to [`off()`](#evented-off)
proto.removeEventListener = proto.clearAllEventListeners = proto.off;

// @method addOneTimeEventListener(…): this
// Alias to [`once(…)`](#evented-once)
proto.addOneTimeEventListener = proto.once;

// @method fireEvent(…): this
// Alias to [`fire(…)`](#evented-fire)
proto.fireEvent = proto.fire;

// @method hasEventListeners(…): Boolean
// Alias to [`listens(…)`](#evented-listens)
proto.hasEventListeners = proto.listens;

L.Mixin = {Events: proto};

/*
 * @namespace Browser
 * @aka L.Browser
 *
 * A namespace with static properties for browser/feature detection used by Leaflet internally.
 *
 * @example
 *
 * ```js
 * if (L.Browser.ielt9) {
 *   alert('Upgrade your browser, dude!');
 * }
 * ```
 */

(function () {

	var ua = navigator.userAgent.toLowerCase(),
	    doc = document.documentElement,

	    ie = 'ActiveXObject' in window,

	    webkit    = ua.indexOf('webkit') !== -1,
	    phantomjs = ua.indexOf('phantom') !== -1,
	    android23 = ua.search('android [23]') !== -1,
	    chrome    = ua.indexOf('chrome') !== -1,
	    gecko     = ua.indexOf('gecko') !== -1  && !webkit && !window.opera && !ie,

	    win = navigator.platform.indexOf('Win') === 0,

	    mobile = typeof orientation !== 'undefined' || ua.indexOf('mobile') !== -1,
	    msPointer = !window.PointerEvent && window.MSPointerEvent,
	    pointer = window.PointerEvent || msPointer,

	    ie3d = ie && ('transition' in doc.style),
	    webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23,
	    gecko3d = 'MozPerspective' in doc.style,
	    opera12 = 'OTransition' in doc.style;


	var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
			(window.DocumentTouch && document instanceof window.DocumentTouch));

	L.Browser = {

		// @property ie: Boolean
		// `true` for all Internet Explorer versions (not Edge).
		ie: ie,

		// @property ielt9: Boolean
		// `true` for Internet Explorer versions less than 9.
		ielt9: ie && !document.addEventListener,

		// @property edge: Boolean
		// `true` for the Edge web browser.
		edge: 'msLaunchUri' in navigator && !('documentMode' in document),

		// @property webkit: Boolean
		// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
		webkit: webkit,

		// @property gecko: Boolean
		// `true` for gecko-based browsers like Firefox.
		gecko: gecko,

		// @property android: Boolean
		// `true` for any browser running on an Android platform.
		android: ua.indexOf('android') !== -1,

		// @property android23: Boolean
		// `true` for browsers running on Android 2 or Android 3.
		android23: android23,

		// @property chrome: Boolean
		// `true` for the Chrome browser.
		chrome: chrome,

		// @property safari: Boolean
		// `true` for the Safari browser.
		safari: !chrome && ua.indexOf('safari') !== -1,


		// @property win: Boolean
		// `true` when the browser is running in a Windows platform
		win: win,


		// @property ie3d: Boolean
		// `true` for all Internet Explorer versions supporting CSS transforms.
		ie3d: ie3d,

		// @property webkit3d: Boolean
		// `true` for webkit-based browsers supporting CSS transforms.
		webkit3d: webkit3d,

		// @property gecko3d: Boolean
		// `true` for gecko-based browsers supporting CSS transforms.
		gecko3d: gecko3d,

		// @property opera12: Boolean
		// `true` for the Opera browser supporting CSS transforms (version 12 or later).
		opera12: opera12,

		// @property any3d: Boolean
		// `true` for all browsers supporting CSS transforms.
		any3d: !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantomjs,


		// @property mobile: Boolean
		// `true` for all browsers running in a mobile device.
		mobile: mobile,

		// @property mobileWebkit: Boolean
		// `true` for all webkit-based browsers in a mobile device.
		mobileWebkit: mobile && webkit,

		// @property mobileWebkit3d: Boolean
		// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
		mobileWebkit3d: mobile && webkit3d,

		// @property mobileOpera: Boolean
		// `true` for the Opera browser in a mobile device.
		mobileOpera: mobile && window.opera,

		// @property mobileGecko: Boolean
		// `true` for gecko-based browsers running in a mobile device.
		mobileGecko: mobile && gecko,


		// @property touch: Boolean
		// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
		touch: !!touch,

		// @property msPointer: Boolean
		// `true` for browsers implementing the Microsoft touch events model (notably IE10).
		msPointer: !!msPointer,

		// @property pointer: Boolean
		// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
		pointer: !!pointer,


		// @property retina: Boolean
		// `true` for browsers on a high-resolution "retina" screen.
		retina: (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1
	};

}());

/*
 * @class Point
 * @aka L.Point
 *
 * Represents a point with `x` and `y` coordinates in pixels.
 *
 * @example
 *
 * ```js
 * var point = L.point(200, 300);
 * ```
 *
 * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
 *
 * ```js
 * map.panBy([200, 300]);
 * map.panBy(L.point(200, 300));
 * ```
 */

L.Point = function (x, y, round) {
	this.x = (round ? Math.round(x) : x);
	this.y = (round ? Math.round(y) : y);
};

L.Point.prototype = {

	// @method clone(): Point
	// Returns a copy of the current point.
	clone: function () {
		return new L.Point(this.x, this.y);
	},

	// @method add(otherPoint: Point): Point
	// Returns the result of addition of the current and the given points.
	add: function (point) {
		// non-destructive, returns a new point
		return this.clone()._add(L.point(point));
	},

	_add: function (point) {
		// destructive, used directly for performance in situations where it's safe to modify existing point
		this.x += point.x;
		this.y += point.y;
		return this;
	},

	// @method subtract(otherPoint: Point): Point
	// Returns the result of subtraction of the given point from the current.
	subtract: function (point) {
		return this.clone()._subtract(L.point(point));
	},

	_subtract: function (point) {
		this.x -= point.x;
		this.y -= point.y;
		return this;
	},

	// @method divideBy(num: Number): Point
	// Returns the result of division of the current point by the given number.
	divideBy: function (num) {
		return this.clone()._divideBy(num);
	},

	_divideBy: function (num) {
		this.x /= num;
		this.y /= num;
		return this;
	},

	// @method multiplyBy(num: Number): Point
	// Returns the result of multiplication of the current point by the given number.
	multiplyBy: function (num) {
		return this.clone()._multiplyBy(num);
	},

	_multiplyBy: function (num) {
		this.x *= num;
		this.y *= num;
		return this;
	},

	// @method scaleBy(scale: Point): Point
	// Multiply each coordinate of the current point by each coordinate of
	// `scale`. In linear algebra terms, multiply the point by the
	// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
	// defined by `scale`.
	scaleBy: function (point) {
		return new L.Point(this.x * point.x, this.y * point.y);
	},

	// @method unscaleBy(scale: Point): Point
	// Inverse of `scaleBy`. Divide each coordinate of the current point by
	// each coordinate of `scale`.
	unscaleBy: function (point) {
		return new L.Point(this.x / point.x, this.y / point.y);
	},

	// @method round(): Point
	// Returns a copy of the current point with rounded coordinates.
	round: function () {
		return this.clone()._round();
	},

	_round: function () {
		this.x = Math.round(this.x);
		this.y = Math.round(this.y);
		return this;
	},

	// @method floor(): Point
	// Returns a copy of the current point with floored coordinates (rounded down).
	floor: function () {
		return this.clone()._floor();
	},

	_floor: function () {
		this.x = Math.floor(this.x);
		this.y = Math.floor(this.y);
		return this;
	},

	// @method ceil(): Point
	// Returns a copy of the current point with ceiled coordinates (rounded up).
	ceil: function () {
		return this.clone()._ceil();
	},

	_ceil: function () {
		this.x = Math.ceil(this.x);
		this.y = Math.ceil(this.y);
		return this;
	},

	// @method distanceTo(otherPoint: Point): Number
	// Returns the cartesian distance between the current and the given points.
	distanceTo: function (point) {
		point = L.point(point);

		var x = point.x - this.x,
		    y = point.y - this.y;

		return Math.sqrt(x * x + y * y);
	},

	// @method equals(otherPoint: Point): Boolean
	// Returns `true` if the given point has the same coordinates.
	equals: function (point) {
		point = L.point(point);

		return point.x === this.x &&
		       point.y === this.y;
	},

	// @method contains(otherPoint: Point): Boolean
	// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
	contains: function (point) {
		point = L.point(point);

		return Math.abs(point.x) <= Math.abs(this.x) &&
		       Math.abs(point.y) <= Math.abs(this.y);
	},

	// @method toString(): String
	// Returns a string representation of the point for debugging purposes.
	toString: function () {
		return 'Point(' +
		        L.Util.formatNum(this.x) + ', ' +
		        L.Util.formatNum(this.y) + ')';
	}
};

// @factory L.point(x: Number, y: Number, round?: Boolean)
// Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.

// @alternative
// @factory L.point(coords: Number[])
// Expects an array of the form `[x, y]` instead.

// @alternative
// @factory L.point(coords: Object)
// Expects a plain object of the form `{x: Number, y: Number}` instead.
L.point = function (x, y, round) {
	if (x instanceof L.Point) {
		return x;
	}
	if (L.Util.isArray(x)) {
		return new L.Point(x[0], x[1]);
	}
	if (x === undefined || x === null) {
		return x;
	}
	if (typeof x === 'object' && 'x' in x && 'y' in x) {
		return new L.Point(x.x, x.y);
	}
	return new L.Point(x, y, round);
};

/*
 * @class Bounds
 * @aka L.Bounds
 *
 * Represents a rectangular area in pixel coordinates.
 *
 * @example
 *
 * ```js
 * var p1 = L.point(10, 10),
 * p2 = L.point(40, 60),
 * bounds = L.bounds(p1, p2);
 * ```
 *
 * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
 *
 * ```js
 * otherBounds.intersects([[10, 10], [40, 60]]);
 * ```
 */

L.Bounds = function (a, b) {
	if (!a) { return; }

	var points = b ? [a, b] : a;

	for (var i = 0, len = points.length; i < len; i++) {
		this.extend(points[i]);
	}
};

L.Bounds.prototype = {
	// @method extend(point: Point): this
	// Extends the bounds to contain the given point.
	extend: function (point) { // (Point)
		point = L.point(point);

		// @property min: Point
		// The top left corner of the rectangle.
		// @property max: Point
		// The bottom right corner of the rectangle.
		if (!this.min && !this.max) {
			this.min = point.clone();
			this.max = point.clone();
		} else {
			this.min.x = Math.min(point.x, this.min.x);
			this.max.x = Math.max(point.x, this.max.x);
			this.min.y = Math.min(point.y, this.min.y);
			this.max.y = Math.max(point.y, this.max.y);
		}
		return this;
	},

	// @method getCenter(round?: Boolean): Point
	// Returns the center point of the bounds.
	getCenter: function (round) {
		return new L.Point(
		        (this.min.x + this.max.x) / 2,
		        (this.min.y + this.max.y) / 2, round);
	},

	// @method getBottomLeft(): Point
	// Returns the bottom-left point of the bounds.
	getBottomLeft: function () {
		return new L.Point(this.min.x, this.max.y);
	},

	// @method getTopRight(): Point
	// Returns the top-right point of the bounds.
	getTopRight: function () { // -> Point
		return new L.Point(this.max.x, this.min.y);
	},

	// @method getSize(): Point
	// Returns the size of the given bounds
	getSize: function () {
		return this.max.subtract(this.min);
	},

	// @method contains(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle contains the given one.
	// @alternative
	// @method contains(point: Point): Boolean
	// Returns `true` if the rectangle contains the given point.
	contains: function (obj) {
		var min, max;

		if (typeof obj[0] === 'number' || obj instanceof L.Point) {
			obj = L.point(obj);
		} else {
			obj = L.bounds(obj);
		}

		if (obj instanceof L.Bounds) {
			min = obj.min;
			max = obj.max;
		} else {
			min = max = obj;
		}

		return (min.x >= this.min.x) &&
		       (max.x <= this.max.x) &&
		       (min.y >= this.min.y) &&
		       (max.y <= this.max.y);
	},

	// @method intersects(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle intersects the given bounds. Two bounds
	// intersect if they have at least one point in common.
	intersects: function (bounds) { // (Bounds) -> Boolean
		bounds = L.bounds(bounds);

		var min = this.min,
		    max = this.max,
		    min2 = bounds.min,
		    max2 = bounds.max,
		    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
		    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);

		return xIntersects && yIntersects;
	},

	// @method overlaps(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle overlaps the given bounds. Two bounds
	// overlap if their intersection is an area.
	overlaps: function (bounds) { // (Bounds) -> Boolean
		bounds = L.bounds(bounds);

		var min = this.min,
		    max = this.max,
		    min2 = bounds.min,
		    max2 = bounds.max,
		    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
		    yOverlaps = (max2.y > min.y) && (min2.y < max.y);

		return xOverlaps && yOverlaps;
	},

	isValid: function () {
		return !!(this.min && this.max);
	}
};


// @factory L.bounds(topLeft: Point, bottomRight: Point)
// Creates a Bounds object from two coordinates (usually top-left and bottom-right corners).
// @alternative
// @factory L.bounds(points: Point[])
// Creates a Bounds object from the points it contains
L.bounds = function (a, b) {
	if (!a || a instanceof L.Bounds) {
		return a;
	}
	return new L.Bounds(a, b);
};

/*
 * @class Transformation
 * @aka L.Transformation
 *
 * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
 * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
 * the reverse. Used by Leaflet in its projections code.
 *
 * @example
 *
 * ```js
 * var transformation = new L.Transformation(2, 5, -1, 10),
 * 	p = L.point(1, 2),
 * 	p2 = transformation.transform(p), //  L.point(7, 8)
 * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
 * ```
 */


// factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
// Creates a `Transformation` object with the given coefficients.
L.Transformation = function (a, b, c, d) {
	this._a = a;
	this._b = b;
	this._c = c;
	this._d = d;
};

L.Transformation.prototype = {
	// @method transform(point: Point, scale?: Number): Point
	// Returns a transformed point, optionally multiplied by the given scale.
	// Only accepts real `L.Point` instances, not arrays.
	transform: function (point, scale) { // (Point, Number) -> Point
		return this._transform(point.clone(), scale);
	},

	// destructive transform (faster)
	_transform: function (point, scale) {
		scale = scale || 1;
		point.x = scale * (this._a * point.x + this._b);
		point.y = scale * (this._c * point.y + this._d);
		return point;
	},

	// @method untransform(point: Point, scale?: Number): Point
	// Returns the reverse transformation of the given point, optionally divided
	// by the given scale. Only accepts real `L.Point` instances, not arrays.
	untransform: function (point, scale) {
		scale = scale || 1;
		return new L.Point(
		        (point.x / scale - this._b) / this._a,
		        (point.y / scale - this._d) / this._c);
	}
};

/*
 * @namespace DomUtil
 *
 * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
 * tree, used by Leaflet internally.
 *
 * Most functions expecting or returning a `HTMLElement` also work for
 * SVG elements. The only difference is that classes refer to CSS classes
 * in HTML and SVG classes in SVG.
 */

L.DomUtil = {

	// @function get(id: String|HTMLElement): HTMLElement
	// Returns an element given its DOM id, or returns the element itself
	// if it was passed directly.
	get: function (id) {
		return typeof id === 'string' ? document.getElementById(id) : id;
	},

	// @function getStyle(el: HTMLElement, styleAttrib: String): String
	// Returns the value for a certain style attribute on an element,
	// including computed values or values set through CSS.
	getStyle: function (el, style) {

		var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);

		if ((!value || value === 'auto') && document.defaultView) {
			var css = document.defaultView.getComputedStyle(el, null);
			value = css ? css[style] : null;
		}

		return value === 'auto' ? null : value;
	},

	// @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
	// Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
	create: function (tagName, className, container) {

		var el = document.createElement(tagName);
		el.className = className || '';

		if (container) {
			container.appendChild(el);
		}

		return el;
	},

	// @function remove(el: HTMLElement)
	// Removes `el` from its parent element
	remove: function (el) {
		var parent = el.parentNode;
		if (parent) {
			parent.removeChild(el);
		}
	},

	// @function empty(el: HTMLElement)
	// Removes all of `el`'s children elements from `el`
	empty: function (el) {
		while (el.firstChild) {
			el.removeChild(el.firstChild);
		}
	},

	// @function toFront(el: HTMLElement)
	// Makes `el` the last children of its parent, so it renders in front of the other children.
	toFront: function (el) {
		el.parentNode.appendChild(el);
	},

	// @function toBack(el: HTMLElement)
	// Makes `el` the first children of its parent, so it renders back from the other children.
	toBack: function (el) {
		var parent = el.parentNode;
		parent.insertBefore(el, parent.firstChild);
	},

	// @function hasClass(el: HTMLElement, name: String): Boolean
	// Returns `true` if the element's class attribute contains `name`.
	hasClass: function (el, name) {
		if (el.classList !== undefined) {
			return el.classList.contains(name);
		}
		var className = L.DomUtil.getClass(el);
		return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
	},

	// @function addClass(el: HTMLElement, name: String)
	// Adds `name` to the element's class attribute.
	addClass: function (el, name) {
		if (el.classList !== undefined) {
			var classes = L.Util.splitWords(name);
			for (var i = 0, len = classes.length; i < len; i++) {
				el.classList.add(classes[i]);
			}
		} else if (!L.DomUtil.hasClass(el, name)) {
			var className = L.DomUtil.getClass(el);
			L.DomUtil.setClass(el, (className ? className + ' ' : '') + name);
		}
	},

	// @function removeClass(el: HTMLElement, name: String)
	// Removes `name` from the element's class attribute.
	removeClass: function (el, name) {
		if (el.classList !== undefined) {
			el.classList.remove(name);
		} else {
			L.DomUtil.setClass(el, L.Util.trim((' ' + L.DomUtil.getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
		}
	},

	// @function setClass(el: HTMLElement, name: String)
	// Sets the element's class.
	setClass: function (el, name) {
		if (el.className.baseVal === undefined) {
			el.className = name;
		} else {
			// in case of SVG element
			el.className.baseVal = name;
		}
	},

	// @function getClass(el: HTMLElement): String
	// Returns the element's class.
	getClass: function (el) {
		return el.className.baseVal === undefined ? el.className : el.className.baseVal;
	},

	// @function setOpacity(el: HTMLElement, opacity: Number)
	// Set the opacity of an element (including old IE support).
	// `opacity` must be a number from `0` to `1`.
	setOpacity: function (el, value) {

		if ('opacity' in el.style) {
			el.style.opacity = value;

		} else if ('filter' in el.style) {
			L.DomUtil._setOpacityIE(el, value);
		}
	},

	_setOpacityIE: function (el, value) {
		var filter = false,
		    filterName = 'DXImageTransform.Microsoft.Alpha';

		// filters collection throws an error if we try to retrieve a filter that doesn't exist
		try {
			filter = el.filters.item(filterName);
		} catch (e) {
			// don't set opacity to 1 if we haven't already set an opacity,
			// it isn't needed and breaks transparent pngs.
			if (value === 1) { return; }
		}

		value = Math.round(value * 100);

		if (filter) {
			filter.Enabled = (value !== 100);
			filter.Opacity = value;
		} else {
			el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
		}
	},

	// @function testProp(props: String[]): String|false
	// Goes through the array of style names and returns the first name
	// that is a valid style name for an element. If no such name is found,
	// it returns false. Useful for vendor-prefixed styles like `transform`.
	testProp: function (props) {

		var style = document.documentElement.style;

		for (var i = 0; i < props.length; i++) {
			if (props[i] in style) {
				return props[i];
			}
		}
		return false;
	},

	// @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
	// Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
	// and optionally scaled by `scale`. Does not have an effect if the
	// browser doesn't support 3D CSS transforms.
	setTransform: function (el, offset, scale) {
		var pos = offset || new L.Point(0, 0);

		el.style[L.DomUtil.TRANSFORM] =
			(L.Browser.ie3d ?
				'translate(' + pos.x + 'px,' + pos.y + 'px)' :
				'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
			(scale ? ' scale(' + scale + ')' : '');
	},

	// @function setPosition(el: HTMLElement, position: Point)
	// Sets the position of `el` to coordinates specified by `position`,
	// using CSS translate or top/left positioning depending on the browser
	// (used by Leaflet internally to position its layers).
	setPosition: function (el, point) { // (HTMLElement, Point[, Boolean])

		/*eslint-disable */
		el._leaflet_pos = point;
		/*eslint-enable */

		if (L.Browser.any3d) {
			L.DomUtil.setTransform(el, point);
		} else {
			el.style.left = point.x + 'px';
			el.style.top = point.y + 'px';
		}
	},

	// @function getPosition(el: HTMLElement): Point
	// Returns the coordinates of an element previously positioned with setPosition.
	getPosition: function (el) {
		// this method is only used for elements previously positioned using setPosition,
		// so it's safe to cache the position for performance

		return el._leaflet_pos || new L.Point(0, 0);
	}
};


(function () {
	// prefix style property names

	// @property TRANSFORM: String
	// Vendor-prefixed fransform style name (e.g. `'webkitTransform'` for WebKit).
	L.DomUtil.TRANSFORM = L.DomUtil.testProp(
			['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);


	// webkitTransition comes first because some browser versions that drop vendor prefix don't do
	// the same for the transitionend event, in particular the Android 4.1 stock browser

	// @property TRANSITION: String
	// Vendor-prefixed transform style name.
	var transition = L.DomUtil.TRANSITION = L.DomUtil.testProp(
			['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);

	L.DomUtil.TRANSITION_END =
			transition === 'webkitTransition' || transition === 'OTransition' ? transition + 'End' : 'transitionend';

	// @function disableTextSelection()
	// Prevents the user from generating `selectstart` DOM events, usually generated
	// when the user drags the mouse through a page with text. Used internally
	// by Leaflet to override the behaviour of any click-and-drag interaction on
	// the map. Affects drag interactions on the whole document.

	// @function enableTextSelection()
	// Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
	if ('onselectstart' in document) {
		L.DomUtil.disableTextSelection = function () {
			L.DomEvent.on(window, 'selectstart', L.DomEvent.preventDefault);
		};
		L.DomUtil.enableTextSelection = function () {
			L.DomEvent.off(window, 'selectstart', L.DomEvent.preventDefault);
		};

	} else {
		var userSelectProperty = L.DomUtil.testProp(
			['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);

		L.DomUtil.disableTextSelection = function () {
			if (userSelectProperty) {
				var style = document.documentElement.style;
				this._userSelect = style[userSelectProperty];
				style[userSelectProperty] = 'none';
			}
		};
		L.DomUtil.enableTextSelection = function () {
			if (userSelectProperty) {
				document.documentElement.style[userSelectProperty] = this._userSelect;
				delete this._userSelect;
			}
		};
	}

	// @function disableImageDrag()
	// As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
	// for `dragstart` DOM events, usually generated when the user drags an image.
	L.DomUtil.disableImageDrag = function () {
		L.DomEvent.on(window, 'dragstart', L.DomEvent.preventDefault);
	};

	// @function enableImageDrag()
	// Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
	L.DomUtil.enableImageDrag = function () {
		L.DomEvent.off(window, 'dragstart', L.DomEvent.preventDefault);
	};

	// @function preventOutline(el: HTMLElement)
	// Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
	// of the element `el` invisible. Used internally by Leaflet to prevent
	// focusable elements from displaying an outline when the user performs a
	// drag interaction on them.
	L.DomUtil.preventOutline = function (element) {
		while (element.tabIndex === -1) {
			element = element.parentNode;
		}
		if (!element || !element.style) { return; }
		L.DomUtil.restoreOutline();
		this._outlineElement = element;
		this._outlineStyle = element.style.outline;
		element.style.outline = 'none';
		L.DomEvent.on(window, 'keydown', L.DomUtil.restoreOutline, this);
	};

	// @function restoreOutline()
	// Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
	L.DomUtil.restoreOutline = function () {
		if (!this._outlineElement) { return; }
		this._outlineElement.style.outline = this._outlineStyle;
		delete this._outlineElement;
		delete this._outlineStyle;
		L.DomEvent.off(window, 'keydown', L.DomUtil.restoreOutline, this);
	};
})();

/* @class LatLng
 * @aka L.LatLng
 *
 * Represents a geographical point with a certain latitude and longitude.
 *
 * @example
 *
 * ```
 * var latlng = L.latLng(50.5, 30.5);
 * ```
 *
 * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
 *
 * ```
 * map.panTo([50, 30]);
 * map.panTo({lon: 30, lat: 50});
 * map.panTo({lat: 50, lng: 30});
 * map.panTo(L.latLng(50, 30));
 * ```
 */

L.LatLng = function (lat, lng, alt) {
	if (isNaN(lat) || isNaN(lng)) {
		throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	}

	// @property lat: Number
	// Latitude in degrees
	this.lat = +lat;

	// @property lng: Number
	// Longitude in degrees
	this.lng = +lng;

	// @property alt: Number
	// Altitude in meters (optional)
	if (alt !== undefined) {
		this.alt = +alt;
	}
};

L.LatLng.prototype = {
	// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
	// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overriden by setting `maxMargin` to a small number.
	equals: function (obj, maxMargin) {
		if (!obj) { return false; }

		obj = L.latLng(obj);

		var margin = Math.max(
		        Math.abs(this.lat - obj.lat),
		        Math.abs(this.lng - obj.lng));

		return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
	},

	// @method toString(): String
	// Returns a string representation of the point (for debugging purposes).
	toString: function (precision) {
		return 'LatLng(' +
		        L.Util.formatNum(this.lat, precision) + ', ' +
		        L.Util.formatNum(this.lng, precision) + ')';
	},

	// @method distanceTo(otherLatLng: LatLng): Number
	// Returns the distance (in meters) to the given `LatLng` calculated using the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula).
	distanceTo: function (other) {
		return L.CRS.Earth.distance(this, L.latLng(other));
	},

	// @method wrap(): LatLng
	// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
	wrap: function () {
		return L.CRS.Earth.wrapLatLng(this);
	},

	// @method toBounds(sizeInMeters: Number): LatLngBounds
	// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters` meters apart from the `LatLng`.
	toBounds: function (sizeInMeters) {
		var latAccuracy = 180 * sizeInMeters / 40075017,
		    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);

		return L.latLngBounds(
		        [this.lat - latAccuracy, this.lng - lngAccuracy],
		        [this.lat + latAccuracy, this.lng + lngAccuracy]);
	},

	clone: function () {
		return new L.LatLng(this.lat, this.lng, this.alt);
	}
};



// @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
// Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).

// @alternative
// @factory L.latLng(coords: Array): LatLng
// Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.

// @alternative
// @factory L.latLng(coords: Object): LatLng
// Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.

L.latLng = function (a, b, c) {
	if (a instanceof L.LatLng) {
		return a;
	}
	if (L.Util.isArray(a) && typeof a[0] !== 'object') {
		if (a.length === 3) {
			return new L.LatLng(a[0], a[1], a[2]);
		}
		if (a.length === 2) {
			return new L.LatLng(a[0], a[1]);
		}
		return null;
	}
	if (a === undefined || a === null) {
		return a;
	}
	if (typeof a === 'object' && 'lat' in a) {
		return new L.LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
	}
	if (b === undefined) {
		return null;
	}
	return new L.LatLng(a, b, c);
};

/*
 * @class LatLngBounds
 * @aka L.LatLngBounds
 *
 * Represents a rectangular geographical area on a map.
 *
 * @example
 *
 * ```js
 * var southWest = L.latLng(40.712, -74.227),
 * northEast = L.latLng(40.774, -74.125),
 * bounds = L.latLngBounds(southWest, northEast);
 * ```
 *
 * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
 *
 * ```js
 * map.fitBounds([
 * 	[40.712, -74.227],
 * 	[40.774, -74.125]
 * ]);
 * ```
 */

L.LatLngBounds = function (southWest, northEast) { // (LatLng, LatLng) or (LatLng[])
	if (!southWest) { return; }

	var latlngs = northEast ? [southWest, northEast] : southWest;

	for (var i = 0, len = latlngs.length; i < len; i++) {
		this.extend(latlngs[i]);
	}
};

L.LatLngBounds.prototype = {

	// @method extend(latlng: LatLng): this
	// Extend the bounds to contain the given point

	// @alternative
	// @method extend(otherBounds: LatLngBounds): this
	// Extend the bounds to contain the given bounds
	extend: function (obj) {
		var sw = this._southWest,
		    ne = this._northEast,
		    sw2, ne2;

		if (obj instanceof L.LatLng) {
			sw2 = obj;
			ne2 = obj;

		} else if (obj instanceof L.LatLngBounds) {
			sw2 = obj._southWest;
			ne2 = obj._northEast;

			if (!sw2 || !ne2) { return this; }

		} else {
			return obj ? this.extend(L.latLng(obj) || L.latLngBounds(obj)) : this;
		}

		if (!sw && !ne) {
			this._southWest = new L.LatLng(sw2.lat, sw2.lng);
			this._northEast = new L.LatLng(ne2.lat, ne2.lng);
		} else {
			sw.lat = Math.min(sw2.lat, sw.lat);
			sw.lng = Math.min(sw2.lng, sw.lng);
			ne.lat = Math.max(ne2.lat, ne.lat);
			ne.lng = Math.max(ne2.lng, ne.lng);
		}

		return this;
	},

	// @method pad(bufferRatio: Number): LatLngBounds
	// Returns bigger bounds created by extending the current bounds by a given percentage in each direction.
	pad: function (bufferRatio) {
		var sw = this._southWest,
		    ne = this._northEast,
		    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
		    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;

		return new L.LatLngBounds(
		        new L.LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
		        new L.LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
	},

	// @method getCenter(): LatLng
	// Returns the center point of the bounds.
	getCenter: function () {
		return new L.LatLng(
		        (this._southWest.lat + this._northEast.lat) / 2,
		        (this._southWest.lng + this._northEast.lng) / 2);
	},

	// @method getSouthWest(): LatLng
	// Returns the south-west point of the bounds.
	getSouthWest: function () {
		return this._southWest;
	},

	// @method getNorthEast(): LatLng
	// Returns the north-east point of the bounds.
	getNorthEast: function () {
		return this._northEast;
	},

	// @method getNorthWest(): LatLng
	// Returns the north-west point of the bounds.
	getNorthWest: function () {
		return new L.LatLng(this.getNorth(), this.getWest());
	},

	// @method getSouthEast(): LatLng
	// Returns the south-east point of the bounds.
	getSouthEast: function () {
		return new L.LatLng(this.getSouth(), this.getEast());
	},

	// @method getWest(): Number
	// Returns the west longitude of the bounds
	getWest: function () {
		return this._southWest.lng;
	},

	// @method getSouth(): Number
	// Returns the south latitude of the bounds
	getSouth: function () {
		return this._southWest.lat;
	},

	// @method getEast(): Number
	// Returns the east longitude of the bounds
	getEast: function () {
		return this._northEast.lng;
	},

	// @method getNorth(): Number
	// Returns the north latitude of the bounds
	getNorth: function () {
		return this._northEast.lat;
	},

	// @method contains(otherBounds: LatLngBounds): Boolean
	// Returns `true` if the rectangle contains the given one.

	// @alternative
	// @method contains (latlng: LatLng): Boolean
	// Returns `true` if the rectangle contains the given point.
	contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
		if (typeof obj[0] === 'number' || obj instanceof L.LatLng) {
			obj = L.latLng(obj);
		} else {
			obj = L.latLngBounds(obj);
		}

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2, ne2;

		if (obj instanceof L.LatLngBounds) {
			sw2 = obj.getSouthWest();
			ne2 = obj.getNorthEast();
		} else {
			sw2 = ne2 = obj;
		}

		return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
		       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
	},

	// @method intersects(otherBounds: LatLngBounds): Boolean
	// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
	intersects: function (bounds) {
		bounds = L.latLngBounds(bounds);

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2 = bounds.getSouthWest(),
		    ne2 = bounds.getNorthEast(),

		    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
		    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);

		return latIntersects && lngIntersects;
	},

	// @method overlaps(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
	overlaps: function (bounds) {
		bounds = L.latLngBounds(bounds);

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2 = bounds.getSouthWest(),
		    ne2 = bounds.getNorthEast(),

		    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
		    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);

		return latOverlaps && lngOverlaps;
	},

	// @method toBBoxString(): String
	// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
	toBBoxString: function () {
		return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
	},

	// @method equals(otherBounds: LatLngBounds): Boolean
	// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds.
	equals: function (bounds) {
		if (!bounds) { return false; }

		bounds = L.latLngBounds(bounds);

		return this._southWest.equals(bounds.getSouthWest()) &&
		       this._northEast.equals(bounds.getNorthEast());
	},

	// @method isValid(): Boolean
	// Returns `true` if the bounds are properly initialized.
	isValid: function () {
		return !!(this._southWest && this._northEast);
	}
};

// TODO International date line?

// @factory L.latLngBounds(southWest: LatLng, northEast: LatLng)
// Creates a `LatLngBounds` object by defining south-west and north-east corners of the rectangle.

// @alternative
// @factory L.latLngBounds(latlngs: LatLng[])
// Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
L.latLngBounds = function (a, b) {
	if (a instanceof L.LatLngBounds) {
		return a;
	}
	return new L.LatLngBounds(a, b);
};

/*
 * @namespace Projection
 * @section
 * Leaflet comes with a set of already defined Projections out of the box:
 *
 * @projection L.Projection.LonLat
 *
 * Equirectangular, or Plate Carree projection — the most simple projection,
 * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
 * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
 * `EPSG:3395` and `Simple` CRS.
 */

L.Projection = {};

L.Projection.LonLat = {
	project: function (latlng) {
		return new L.Point(latlng.lng, latlng.lat);
	},

	unproject: function (point) {
		return new L.LatLng(point.y, point.x);
	},

	bounds: L.bounds([-180, -90], [180, 90])
};

/*
 * @namespace Projection
 * @projection L.Projection.SphericalMercator
 *
 * Spherical Mercator projection — the most common projection for online maps,
 * used by almost all free and commercial tile providers. Assumes that Earth is
 * a sphere. Used by the `EPSG:3857` CRS.
 */

L.Projection.SphericalMercator = {

	R: 6378137,
	MAX_LATITUDE: 85.0511287798,

	project: function (latlng) {
		var d = Math.PI / 180,
		    max = this.MAX_LATITUDE,
		    lat = Math.max(Math.min(max, latlng.lat), -max),
		    sin = Math.sin(lat * d);

		return new L.Point(
				this.R * latlng.lng * d,
				this.R * Math.log((1 + sin) / (1 - sin)) / 2);
	},

	unproject: function (point) {
		var d = 180 / Math.PI;

		return new L.LatLng(
			(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
			point.x * d / this.R);
	},

	bounds: (function () {
		var d = 6378137 * Math.PI;
		return L.bounds([-d, -d], [d, d]);
	})()
};

/*
 * @class CRS
 * @aka L.CRS
 * Abstract class that defines coordinate reference systems for projecting
 * geographical points into pixel (screen) coordinates and back (and to
 * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
 * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
 *
 * Leaflet defines the most usual CRSs by default. If you want to use a
 * CRS not defined by default, take a look at the
 * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
 */

L.CRS = {
	// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
	// Projects geographical coordinates into pixel coordinates for a given zoom.
	latLngToPoint: function (latlng, zoom) {
		var projectedPoint = this.projection.project(latlng),
		    scale = this.scale(zoom);

		return this.transformation._transform(projectedPoint, scale);
	},

	// @method pointToLatLng(point: Point, zoom: Number): LatLng
	// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
	// zoom into geographical coordinates.
	pointToLatLng: function (point, zoom) {
		var scale = this.scale(zoom),
		    untransformedPoint = this.transformation.untransform(point, scale);

		return this.projection.unproject(untransformedPoint);
	},

	// @method project(latlng: LatLng): Point
	// Projects geographical coordinates into coordinates in units accepted for
	// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
	project: function (latlng) {
		return this.projection.project(latlng);
	},

	// @method unproject(point: Point): LatLng
	// Given a projected coordinate returns the corresponding LatLng.
	// The inverse of `project`.
	unproject: function (point) {
		return this.projection.unproject(point);
	},

	// @method scale(zoom: Number): Number
	// Returns the scale used when transforming projected coordinates into
	// pixel coordinates for a particular zoom. For example, it returns
	// `256 * 2^zoom` for Mercator-based CRS.
	scale: function (zoom) {
		return 256 * Math.pow(2, zoom);
	},

	// @method zoom(scale: Number): Number
	// Inverse of `scale()`, returns the zoom level corresponding to a scale
	// factor of `scale`.
	zoom: function (scale) {
		return Math.log(scale / 256) / Math.LN2;
	},

	// @method getProjectedBounds(zoom: Number): Bounds
	// Returns the projection's bounds scaled and transformed for the provided `zoom`.
	getProjectedBounds: function (zoom) {
		if (this.infinite) { return null; }

		var b = this.projection.bounds,
		    s = this.scale(zoom),
		    min = this.transformation.transform(b.min, s),
		    max = this.transformation.transform(b.max, s);

		return L.bounds(min, max);
	},

	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	// Returns the distance between two geographical coordinates.

	// @property code: String
	// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
	//
	// @property wrapLng: Number[]
	// An array of two numbers defining whether the longitude (horizontal) coordinate
	// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
	// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
	//
	// @property wrapLat: Number[]
	// Like `wrapLng`, but for the latitude (vertical) axis.

	// wrapLng: [min, max],
	// wrapLat: [min, max],

	// @property infinite: Boolean
	// If true, the coordinate space will be unbounded (infinite in both axes)
	infinite: false,

	// @method wrapLatLng(latlng: LatLng): LatLng
	// Returns a `LatLng` where lat and lng has been wrapped according to the
	// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
	wrapLatLng: function (latlng) {
		var lng = this.wrapLng ? L.Util.wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
		    lat = this.wrapLat ? L.Util.wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
		    alt = latlng.alt;

		return L.latLng(lat, lng, alt);
	}
};

/*
 * @namespace CRS
 * @crs L.CRS.Simple
 *
 * A simple CRS that maps longitude and latitude into `x` and `y` directly.
 * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
 * axis should still be inverted (going from bottom to top). `distance()` returns
 * simple euclidean distance.
 */

L.CRS.Simple = L.extend({}, L.CRS, {
	projection: L.Projection.LonLat,
	transformation: new L.Transformation(1, 0, -1, 0),

	scale: function (zoom) {
		return Math.pow(2, zoom);
	},

	zoom: function (scale) {
		return Math.log(scale) / Math.LN2;
	},

	distance: function (latlng1, latlng2) {
		var dx = latlng2.lng - latlng1.lng,
		    dy = latlng2.lat - latlng1.lat;

		return Math.sqrt(dx * dx + dy * dy);
	},

	infinite: true
});

/*
 * @namespace CRS
 * @crs L.CRS.Earth
 *
 * Serves as the base for CRS that are global such that they cover the earth.
 * Can only be used as the base for other CRS and cannot be used directly,
 * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
 * meters.
 */

L.CRS.Earth = L.extend({}, L.CRS, {
	wrapLng: [-180, 180],

	// Mean Earth Radius, as recommended for use by
	// the International Union of Geodesy and Geophysics,
	// see http://rosettacode.org/wiki/Haversine_formula
	R: 6371000,

	// distance between two geographical points using spherical law of cosines approximation
	distance: function (latlng1, latlng2) {
		var rad = Math.PI / 180,
		    lat1 = latlng1.lat * rad,
		    lat2 = latlng2.lat * rad,
		    a = Math.sin(lat1) * Math.sin(lat2) +
		        Math.cos(lat1) * Math.cos(lat2) * Math.cos((latlng2.lng - latlng1.lng) * rad);

		return this.R * Math.acos(Math.min(a, 1));
	}
});

/*
 * @namespace CRS
 * @crs L.CRS.EPSG3857
 *
 * The most common CRS for online maps, used by almost all free and commercial
 * tile providers. Uses Spherical Mercator projection. Set in by default in
 * Map's `crs` option.
 */

L.CRS.EPSG3857 = L.extend({}, L.CRS.Earth, {
	code: 'EPSG:3857',
	projection: L.Projection.SphericalMercator,

	transformation: (function () {
		var scale = 0.5 / (Math.PI * L.Projection.SphericalMercator.R);
		return new L.Transformation(scale, 0.5, -scale, 0.5);
	}())
});

L.CRS.EPSG900913 = L.extend({}, L.CRS.EPSG3857, {
	code: 'EPSG:900913'
});

/*
 * @namespace CRS
 * @crs L.CRS.EPSG4326
 *
 * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
 */

L.CRS.EPSG4326 = L.extend({}, L.CRS.Earth, {
	code: 'EPSG:4326',
	projection: L.Projection.LonLat,
	transformation: new L.Transformation(1 / 180, 1, -1 / 180, 0.5)
});

/*
 * @class Map
 * @aka L.Map
 * @inherits Evented
 *
 * The central class of the API — it is used to create a map on a page and manipulate it.
 *
 * @example
 *
 * ```js
 * // initialize the map on the "map" div with a given center and zoom
 * var map = L.map('map', {
 * 	center: [51.505, -0.09],
 * 	zoom: 13
 * });
 * ```
 *
 */

L.Map = L.Evented.extend({

	options: {
		// @section Map State Options
		// @option crs: CRS = L.CRS.EPSG3857
		// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
		// sure what it means.
		crs: L.CRS.EPSG3857,

		// @option center: LatLng = undefined
		// Initial geographic center of the map
		center: undefined,

		// @option zoom: Number = undefined
		// Initial map zoom level
		zoom: undefined,

		// @option minZoom: Number = undefined
		// Minimum zoom level of the map. Overrides any `minZoom` option set on map layers.
		minZoom: undefined,

		// @option maxZoom: Number = undefined
		// Maximum zoom level of the map. Overrides any `maxZoom` option set on map layers.
		maxZoom: undefined,

		// @option layers: Layer[] = []
		// Array of layers that will be added to the map initially
		layers: [],

		// @option maxBounds: LatLngBounds = null
		// When this option is set, the map restricts the view to the given
		// geographical bounds, bouncing the user back when he tries to pan
		// outside the view. To set the restriction dynamically, use
		// [`setMaxBounds`](#map-setmaxbounds) method.
		maxBounds: undefined,

		// @option renderer: Renderer = *
		// The default method for drawing vector layers on the map. `L.SVG`
		// or `L.Canvas` by default depending on browser support.
		renderer: undefined,


		// @section Animation Options
		// @option fadeAnimation: Boolean = true
		// Whether the tile fade animation is enabled. By default it's enabled
		// in all browsers that support CSS3 Transitions except Android.
		fadeAnimation: true,

		// @option markerZoomAnimation: Boolean = true
		// Whether markers animate their zoom with the zoom animation, if disabled
		// they will disappear for the length of the animation. By default it's
		// enabled in all browsers that support CSS3 Transitions except Android.
		markerZoomAnimation: true,

		// @option transform3DLimit: Number = 2^23
		// Defines the maximum size of a CSS translation transform. The default
		// value should not be changed unless a web browser positions layers in
		// the wrong place after doing a large `panBy`.
		transform3DLimit: 8388608, // Precision limit of a 32-bit float

		// @section Interaction Options
		// @option zoomSnap: Number = 1
		// Forces the map's zoom level to always be a multiple of this, particularly
		// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
		// By default, the zoom level snaps to the nearest integer; lower values
		// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
		// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
		zoomSnap: 1,

		// @option zoomDelta: Number = 1
		// Controls how much the map's zoom level will change after a
		// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
		// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
		// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
		zoomDelta: 1,

		// @option trackResize: Boolean = true
		// Whether the map automatically handles browser window resize to update itself.
		trackResize: true
	},

	initialize: function (id, options) { // (HTMLElement or String, Object)
		options = L.setOptions(this, options);

		this._initContainer(id);
		this._initLayout();

		// hack for https://github.com/Leaflet/Leaflet/issues/1980
		this._onResize = L.bind(this._onResize, this);

		this._initEvents();

		if (options.maxBounds) {
			this.setMaxBounds(options.maxBounds);
		}

		if (options.zoom !== undefined) {
			this._zoom = this._limitZoom(options.zoom);
		}

		if (options.center && options.zoom !== undefined) {
			this.setView(L.latLng(options.center), options.zoom, {reset: true});
		}

		this._handlers = [];
		this._layers = {};
		this._zoomBoundLayers = {};
		this._sizeChanged = true;

		this.callInitHooks();

		this._addLayers(this.options.layers);
	},


	// @section Methods for modifying map state

	// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
	// Sets the view of the map (geographical center and zoom) with the given
	// animation options.
	setView: function (center, zoom) {
		// replaced by animation-powered implementation in Map.PanAnimation.js
		zoom = zoom === undefined ? this.getZoom() : zoom;
		this._resetView(L.latLng(center), zoom);
		return this;
	},

	// @method setZoom(zoom: Number, options: Zoom/pan options): this
	// Sets the zoom of the map.
	setZoom: function (zoom, options) {
		if (!this._loaded) {
			this._zoom = zoom;
			return this;
		}
		return this.setView(this.getCenter(), zoom, {zoom: options});
	},

	// @method zoomIn(delta?: Number, options?: Zoom options): this
	// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	zoomIn: function (delta, options) {
		delta = delta || (L.Browser.any3d ? this.options.zoomDelta : 1);
		return this.setZoom(this._zoom + delta, options);
	},

	// @method zoomOut(delta?: Number, options?: Zoom options): this
	// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	zoomOut: function (delta, options) {
		delta = delta || (L.Browser.any3d ? this.options.zoomDelta : 1);
		return this.setZoom(this._zoom - delta, options);
	},

	// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
	// Zooms the map while keeping a specified geographical point on the map
	// stationary (e.g. used internally for scroll zoom and double-click zoom).
	// @alternative
	// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
	// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
	setZoomAround: function (latlng, zoom, options) {
		var scale = this.getZoomScale(zoom),
		    viewHalf = this.getSize().divideBy(2),
		    containerPoint = latlng instanceof L.Point ? latlng : this.latLngToContainerPoint(latlng),

		    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
		    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));

		return this.setView(newCenter, zoom, {zoom: options});
	},

	_getBoundsCenterZoom: function (bounds, options) {

		options = options || {};
		bounds = bounds.getBounds ? bounds.getBounds() : L.latLngBounds(bounds);

		var paddingTL = L.point(options.paddingTopLeft || options.padding || [0, 0]),
		    paddingBR = L.point(options.paddingBottomRight || options.padding || [0, 0]),

		    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));

		zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;

		var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),

		    swPoint = this.project(bounds.getSouthWest(), zoom),
		    nePoint = this.project(bounds.getNorthEast(), zoom),
		    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);

		return {
			center: center,
			zoom: zoom
		};
	},

	// @method fitBounds(bounds: LatLngBounds, options: fitBounds options): this
	// Sets a map view that contains the given geographical bounds with the
	// maximum zoom level possible.
	fitBounds: function (bounds, options) {

		bounds = L.latLngBounds(bounds);

		if (!bounds.isValid()) {
			throw new Error('Bounds are not valid.');
		}

		var target = this._getBoundsCenterZoom(bounds, options);
		return this.setView(target.center, target.zoom, options);
	},

	// @method fitWorld(options?: fitBounds options): this
	// Sets a map view that mostly contains the whole world with the maximum
	// zoom level possible.
	fitWorld: function (options) {
		return this.fitBounds([[-90, -180], [90, 180]], options);
	},

	// @method panTo(latlng: LatLng, options?: Pan options): this
	// Pans the map to a given center.
	panTo: function (center, options) { // (LatLng)
		return this.setView(center, this._zoom, {pan: options});
	},

	// @method panBy(offset: Point): this
	// Pans the map by a given number of pixels (animated).
	panBy: function (offset) { // (Point)
		// replaced with animated panBy in Map.PanAnimation.js
		this.fire('movestart');

		this._rawPanBy(L.point(offset));

		this.fire('move');
		return this.fire('moveend');
	},

	// @method setMaxBounds(bounds: Bounds): this
	// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
	setMaxBounds: function (bounds) {
		bounds = L.latLngBounds(bounds);

		if (!bounds.isValid()) {
			this.options.maxBounds = null;
			return this.off('moveend', this._panInsideMaxBounds);
		} else if (this.options.maxBounds) {
			this.off('moveend', this._panInsideMaxBounds);
		}

		this.options.maxBounds = bounds;

		if (this._loaded) {
			this._panInsideMaxBounds();
		}

		return this.on('moveend', this._panInsideMaxBounds);
	},

	// @method setMinZoom(zoom: Number): this
	// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
	setMinZoom: function (zoom) {
		this.options.minZoom = zoom;

		if (this._loaded && this.getZoom() < this.options.minZoom) {
			return this.setZoom(zoom);
		}

		return this;
	},

	// @method setMaxZoom(zoom: Number): this
	// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
	setMaxZoom: function (zoom) {
		this.options.maxZoom = zoom;

		if (this._loaded && (this.getZoom() > this.options.maxZoom)) {
			return this.setZoom(zoom);
		}

		return this;
	},

	// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
	// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
	panInsideBounds: function (bounds, options) {
		this._enforcingBounds = true;
		var center = this.getCenter(),
		    newCenter = this._limitCenter(center, this._zoom, L.latLngBounds(bounds));

		if (!center.equals(newCenter)) {
			this.panTo(newCenter, options);
		}

		this._enforcingBounds = false;
		return this;
	},

	// @method invalidateSize(options: Zoom/Pan options): this
	// Checks if the map container size changed and updates the map if so —
	// call it after you've changed the map size dynamically, also animating
	// pan by default. If `options.pan` is `false`, panning will not occur.
	// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
	// that it doesn't happen often even if the method is called many
	// times in a row.

	// @alternative
	// @method invalidateSize(animate: Boolean): this
	// Checks if the map container size changed and updates the map if so —
	// call it after you've changed the map size dynamically, also animating
	// pan by default.
	invalidateSize: function (options) {
		if (!this._loaded) { return this; }

		options = L.extend({
			animate: false,
			pan: true
		}, options === true ? {animate: true} : options);

		var oldSize = this.getSize();
		this._sizeChanged = true;
		this._lastCenter = null;

		var newSize = this.getSize(),
		    oldCenter = oldSize.divideBy(2).round(),
		    newCenter = newSize.divideBy(2).round(),
		    offset = oldCenter.subtract(newCenter);

		if (!offset.x && !offset.y) { return this; }

		if (options.animate && options.pan) {
			this.panBy(offset);

		} else {
			if (options.pan) {
				this._rawPanBy(offset);
			}

			this.fire('move');

			if (options.debounceMoveend) {
				clearTimeout(this._sizeTimer);
				this._sizeTimer = setTimeout(L.bind(this.fire, this, 'moveend'), 200);
			} else {
				this.fire('moveend');
			}
		}

		// @section Map state change events
		// @event resize: ResizeEvent
		// Fired when the map is resized.
		return this.fire('resize', {
			oldSize: oldSize,
			newSize: newSize
		});
	},

	// @section Methods for modifying map state
	// @method stop(): this
	// Stops the currently running `panTo` or `flyTo` animation, if any.
	stop: function () {
		this.setZoom(this._limitZoom(this._zoom));
		if (!this.options.zoomSnap) {
			this.fire('viewreset');
		}
		return this._stop();
	},


	// TODO handler.addTo
	// TODO Appropiate docs section?
	// @section Other Methods
	// @method addHandler(name: String, HandlerClass: Function): this
	// Adds a new `Handler` to the map, given its name and constructor function.
	addHandler: function (name, HandlerClass) {
		if (!HandlerClass) { return this; }

		var handler = this[name] = new HandlerClass(this);

		this._handlers.push(handler);

		if (this.options[name]) {
			handler.enable();
		}

		return this;
	},

	// @method remove(): this
	// Destroys the map and clears all related event listeners.
	remove: function () {

		this._initEvents(true);

		if (this._containerId !== this._container._leaflet_id) {
			throw new Error('Map container is being reused by another instance');
		}

		try {
			// throws error in IE6-8
			delete this._container._leaflet_id;
			delete this._containerId;
		} catch (e) {
			/*eslint-disable */
			this._container._leaflet_id = undefined;
			/*eslint-enable */
			this._containerId = undefined;
		}

		L.DomUtil.remove(this._mapPane);

		if (this._clearControlPos) {
			this._clearControlPos();
		}

		this._clearHandlers();

		if (this._loaded) {
			// @section Map state change events
			// @event unload: Event
			// Fired when the map is destroyed with [remove](#map-remove) method.
			this.fire('unload');
		}

		for (var i in this._layers) {
			this._layers[i].remove();
		}

		return this;
	},

	// @section Other Methods
	// @method createPane(name: String, container?: HTMLElement): HTMLElement
	// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
	// then returns it. The pane is created as a children of `container`, or
	// as a children of the main map pane if not set.
	createPane: function (name, container) {
		var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
		    pane = L.DomUtil.create('div', className, container || this._mapPane);

		if (name) {
			this._panes[name] = pane;
		}
		return pane;
	},

	// @section Methods for Getting Map State

	// @method getCenter(): LatLng
	// Returns the geographical center of the map view
	getCenter: function () {
		this._checkIfLoaded();

		if (this._lastCenter && !this._moved()) {
			return this._lastCenter;
		}
		return this.layerPointToLatLng(this._getCenterLayerPoint());
	},

	// @method getZoom(): Number
	// Returns the current zoom level of the map view
	getZoom: function () {
		return this._zoom;
	},

	// @method getBounds(): LatLngBounds
	// Returns the geographical bounds visible in the current map view
	getBounds: function () {
		var bounds = this.getPixelBounds(),
		    sw = this.unproject(bounds.getBottomLeft()),
		    ne = this.unproject(bounds.getTopRight());

		return new L.LatLngBounds(sw, ne);
	},

	// @method getMinZoom(): Number
	// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
	getMinZoom: function () {
		return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
	},

	// @method getMaxZoom(): Number
	// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
	getMaxZoom: function () {
		return this.options.maxZoom === undefined ?
			(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
			this.options.maxZoom;
	},

	// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean): Number
	// Returns the maximum zoom level on which the given bounds fit to the map
	// view in its entirety. If `inside` (optional) is set to `true`, the method
	// instead returns the minimum zoom level on which the map view fits into
	// the given bounds in its entirety.
	getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
		bounds = L.latLngBounds(bounds);
		padding = L.point(padding || [0, 0]);

		var zoom = this.getZoom() || 0,
		    min = this.getMinZoom(),
		    max = this.getMaxZoom(),
		    nw = bounds.getNorthWest(),
		    se = bounds.getSouthEast(),
		    size = this.getSize().subtract(padding),
		    boundsSize = this.project(se, zoom).subtract(this.project(nw, zoom)),
		    snap = L.Browser.any3d ? this.options.zoomSnap : 1;

		var scale = Math.min(size.x / boundsSize.x, size.y / boundsSize.y);
		zoom = this.getScaleZoom(scale, zoom);

		if (snap) {
			zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
			zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
		}

		return Math.max(min, Math.min(max, zoom));
	},

	// @method getSize(): Point
	// Returns the current size of the map container (in pixels).
	getSize: function () {
		if (!this._size || this._sizeChanged) {
			this._size = new L.Point(
				this._container.clientWidth,
				this._container.clientHeight);

			this._sizeChanged = false;
		}
		return this._size.clone();
	},

	// @method getPixelBounds(): Bounds
	// Returns the bounds of the current map view in projected pixel
	// coordinates (sometimes useful in layer and overlay implementations).
	getPixelBounds: function (center, zoom) {
		var topLeftPoint = this._getTopLeftPoint(center, zoom);
		return new L.Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
	},

	// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
	// the map pane? "left point of the map layer" can be confusing, specially
	// since there can be negative offsets.
	// @method getPixelOrigin(): Point
	// Returns the projected pixel coordinates of the top left point of
	// the map layer (useful in custom layer and overlay implementations).
	getPixelOrigin: function () {
		this._checkIfLoaded();
		return this._pixelOrigin;
	},

	// @method getPixelWorldBounds(zoom?: Number): Bounds
	// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
	// If `zoom` is omitted, the map's current zoom level is used.
	getPixelWorldBounds: function (zoom) {
		return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
	},

	// @section Other Methods

	// @method getPane(pane: String|HTMLElement): HTMLElement
	// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
	getPane: function (pane) {
		return typeof pane === 'string' ? this._panes[pane] : pane;
	},

	// @method getPanes(): Object
	// Returns a plain object containing the names of all [panes](#map-pane) as keys and
	// the panes as values.
	getPanes: function () {
		return this._panes;
	},

	// @method getContainer: HTMLElement
	// Returns the HTML element that contains the map.
	getContainer: function () {
		return this._container;
	},


	// @section Conversion Methods

	// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
	// Returns the scale factor to be applied to a map transition from zoom level
	// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
	getZoomScale: function (toZoom, fromZoom) {
		// TODO replace with universal implementation after refactoring projections
		var crs = this.options.crs;
		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
		return crs.scale(toZoom) / crs.scale(fromZoom);
	},

	// @method getScaleZoom(scale: Number, fromZoom: Number): Number
	// Returns the zoom level that the map would end up at, if it is at `fromZoom`
	// level and everything is scaled by a factor of `scale`. Inverse of
	// [`getZoomScale`](#map-getZoomScale).
	getScaleZoom: function (scale, fromZoom) {
		var crs = this.options.crs;
		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
		var zoom = crs.zoom(scale * crs.scale(fromZoom));
		return isNaN(zoom) ? Infinity : zoom;
	},

	// @method project(latlng: LatLng, zoom: Number): Point
	// Projects a geographical coordinate `LatLng` according to the projection
	// of the map's CRS, then scales it according to `zoom` and the CRS's
	// `Transformation`. The result is pixel coordinate relative to
	// the CRS origin.
	project: function (latlng, zoom) {
		zoom = zoom === undefined ? this._zoom : zoom;
		return this.options.crs.latLngToPoint(L.latLng(latlng), zoom);
	},

	// @method unproject(point: Point, zoom: Number): LatLng
	// Inverse of [`project`](#map-project).
	unproject: function (point, zoom) {
		zoom = zoom === undefined ? this._zoom : zoom;
		return this.options.crs.pointToLatLng(L.point(point), zoom);
	},

	// @method layerPointToLatLng(point: Point): LatLng
	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	// returns the corresponding geographical coordinate (for the current zoom level).
	layerPointToLatLng: function (point) {
		var projectedPoint = L.point(point).add(this.getPixelOrigin());
		return this.unproject(projectedPoint);
	},

	// @method latLngToLayerPoint(latlng: LatLng): Point
	// Given a geographical coordinate, returns the corresponding pixel coordinate
	// relative to the [origin pixel](#map-getpixelorigin).
	latLngToLayerPoint: function (latlng) {
		var projectedPoint = this.project(L.latLng(latlng))._round();
		return projectedPoint._subtract(this.getPixelOrigin());
	},

	// @method wrapLatLng(latlng: LatLng): LatLng
	// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
	// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
	// CRS's bounds.
	// By default this means longitude is wrapped around the dateline so its
	// value is between -180 and +180 degrees.
	wrapLatLng: function (latlng) {
		return this.options.crs.wrapLatLng(L.latLng(latlng));
	},

	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	// Returns the distance between two geographical coordinates according to
	// the map's CRS. By default this measures distance in meters.
	distance: function (latlng1, latlng2) {
		return this.options.crs.distance(L.latLng(latlng1), L.latLng(latlng2));
	},

	// @method containerPointToLayerPoint(point: Point): Point
	// Given a pixel coordinate relative to the map container, returns the corresponding
	// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
	containerPointToLayerPoint: function (point) { // (Point)
		return L.point(point).subtract(this._getMapPanePos());
	},

	// @method layerPointToContainerPoint(point: Point): Point
	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	// returns the corresponding pixel coordinate relative to the map container.
	layerPointToContainerPoint: function (point) { // (Point)
		return L.point(point).add(this._getMapPanePos());
	},

	// @method containerPointToLatLng(point: Point): Point
	// Given a pixel coordinate relative to the map container, returns
	// the corresponding geographical coordinate (for the current zoom level).
	containerPointToLatLng: function (point) {
		var layerPoint = this.containerPointToLayerPoint(L.point(point));
		return this.layerPointToLatLng(layerPoint);
	},

	// @method latLngToContainerPoint(latlng: LatLng): Point
	// Given a geographical coordinate, returns the corresponding pixel coordinate
	// relative to the map container.
	latLngToContainerPoint: function (latlng) {
		return this.layerPointToContainerPoint(this.latLngToLayerPoint(L.latLng(latlng)));
	},

	// @method mouseEventToContainerPoint(ev: MouseEvent): Point
	// Given a MouseEvent object, returns the pixel coordinate relative to the
	// map container where the event took place.
	mouseEventToContainerPoint: function (e) {
		return L.DomEvent.getMousePosition(e, this._container);
	},

	// @method mouseEventToLayerPoint(ev: MouseEvent): Point
	// Given a MouseEvent object, returns the pixel coordinate relative to
	// the [origin pixel](#map-getpixelorigin) where the event took place.
	mouseEventToLayerPoint: function (e) {
		return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
	},

	// @method mouseEventToLatLng(ev: MouseEvent): LatLng
	// Given a MouseEvent object, returns geographical coordinate where the
	// event took place.
	mouseEventToLatLng: function (e) { // (MouseEvent)
		return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
	},


	// map initialization methods

	_initContainer: function (id) {
		var container = this._container = L.DomUtil.get(id);

		if (!container) {
			throw new Error('Map container not found.');
		} else if (container._leaflet_id) {
			throw new Error('Map container is already initialized.');
		}

		L.DomEvent.addListener(container, 'scroll', this._onScroll, this);
		this._containerId = L.Util.stamp(container);
	},

	_initLayout: function () {
		var container = this._container;

		this._fadeAnimated = this.options.fadeAnimation && L.Browser.any3d;

		L.DomUtil.addClass(container, 'leaflet-container' +
			(L.Browser.touch ? ' leaflet-touch' : '') +
			(L.Browser.retina ? ' leaflet-retina' : '') +
			(L.Browser.ielt9 ? ' leaflet-oldie' : '') +
			(L.Browser.safari ? ' leaflet-safari' : '') +
			(this._fadeAnimated ? ' leaflet-fade-anim' : ''));

		var position = L.DomUtil.getStyle(container, 'position');

		if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
			container.style.position = 'relative';
		}

		this._initPanes();

		if (this._initControlPos) {
			this._initControlPos();
		}
	},

	_initPanes: function () {
		var panes = this._panes = {};
		this._paneRenderers = {};

		// @section
		//
		// Panes are DOM elements used to control the ordering of layers on the map. You
		// can access panes with [`map.getPane`](#map-getpane) or
		// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
		// [`map.createPane`](#map-createpane) method.
		//
		// Every map has the following default panes that differ only in zIndex.
		//
		// @pane mapPane: HTMLElement = 'auto'
		// Pane that contains all other map panes

		this._mapPane = this.createPane('mapPane', this._container);
		L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));

		// @pane tilePane: HTMLElement = 200
		// Pane for `GridLayer`s and `TileLayer`s
		this.createPane('tilePane');
		// @pane overlayPane: HTMLElement = 400
		// Pane for vector overlays (`Path`s), like `Polyline`s and `Polygon`s
		this.createPane('shadowPane');
		// @pane shadowPane: HTMLElement = 500
		// Pane for overlay shadows (e.g. `Marker` shadows)
		this.createPane('overlayPane');
		// @pane markerPane: HTMLElement = 600
		// Pane for `Icon`s of `Marker`s
		this.createPane('markerPane');
		// @pane tooltipPane: HTMLElement = 650
		// Pane for tooltip.
		this.createPane('tooltipPane');
		// @pane popupPane: HTMLElement = 700
		// Pane for `Popup`s.
		this.createPane('popupPane');

		if (!this.options.markerZoomAnimation) {
			L.DomUtil.addClass(panes.markerPane, 'leaflet-zoom-hide');
			L.DomUtil.addClass(panes.shadowPane, 'leaflet-zoom-hide');
		}
	},


	// private methods that modify map state

	// @section Map state change events
	_resetView: function (center, zoom) {
		L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));

		var loading = !this._loaded;
		this._loaded = true;
		zoom = this._limitZoom(zoom);

		this.fire('viewprereset');

		var zoomChanged = this._zoom !== zoom;
		this
			._moveStart(zoomChanged)
			._move(center, zoom)
			._moveEnd(zoomChanged);

		// @event viewreset: Event
		// Fired when the map needs to redraw its content (this usually happens
		// on map zoom or load). Very useful for creating custom overlays.
		this.fire('viewreset');

		// @event load: Event
		// Fired when the map is initialized (when its center and zoom are set
		// for the first time).
		if (loading) {
			this.fire('load');
		}
	},

	_moveStart: function (zoomChanged) {
		// @event zoomstart: Event
		// Fired when the map zoom is about to change (e.g. before zoom animation).
		// @event movestart: Event
		// Fired when the view of the map starts changing (e.g. user starts dragging the map).
		if (zoomChanged) {
			this.fire('zoomstart');
		}
		return this.fire('movestart');
	},

	_move: function (center, zoom, data) {
		if (zoom === undefined) {
			zoom = this._zoom;
		}
		var zoomChanged = this._zoom !== zoom;

		this._zoom = zoom;
		this._lastCenter = center;
		this._pixelOrigin = this._getNewPixelOrigin(center);

		// @event zoom: Event
		// Fired repeatedly during any change in zoom level, including zoom
		// and fly animations.
		if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
			this.fire('zoom', data);
		}

		// @event move: Event
		// Fired repeatedly during any movement of the map, including pan and
		// fly animations.
		return this.fire('move', data);
	},

	_moveEnd: function (zoomChanged) {
		// @event zoomend: Event
		// Fired when the map has changed, after any animations.
		if (zoomChanged) {
			this.fire('zoomend');
		}

		// @event moveend: Event
		// Fired when the center of the map stops changing (e.g. user stopped
		// dragging the map).
		return this.fire('moveend');
	},

	_stop: function () {
		L.Util.cancelAnimFrame(this._flyToFrame);
		if (this._panAnim) {
			this._panAnim.stop();
		}
		return this;
	},

	_rawPanBy: function (offset) {
		L.DomUtil.setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
	},

	_getZoomSpan: function () {
		return this.getMaxZoom() - this.getMinZoom();
	},

	_panInsideMaxBounds: function () {
		if (!this._enforcingBounds) {
			this.panInsideBounds(this.options.maxBounds);
		}
	},

	_checkIfLoaded: function () {
		if (!this._loaded) {
			throw new Error('Set map center and zoom first.');
		}
	},

	// DOM event handling

	// @section Interaction events
	_initEvents: function (remove) {
		if (!L.DomEvent) { return; }

		this._targets = {};
		this._targets[L.stamp(this._container)] = this;

		var onOff = remove ? 'off' : 'on';

		// @event click: MouseEvent
		// Fired when the user clicks (or taps) the map.
		// @event dblclick: MouseEvent
		// Fired when the user double-clicks (or double-taps) the map.
		// @event mousedown: MouseEvent
		// Fired when the user pushes the mouse button on the map.
		// @event mouseup: MouseEvent
		// Fired when the user releases the mouse button on the map.
		// @event mouseover: MouseEvent
		// Fired when the mouse enters the map.
		// @event mouseout: MouseEvent
		// Fired when the mouse leaves the map.
		// @event mousemove: MouseEvent
		// Fired while the mouse moves over the map.
		// @event contextmenu: MouseEvent
		// Fired when the user pushes the right mouse button on the map, prevents
		// default browser context menu from showing if there are listeners on
		// this event. Also fired on mobile when the user holds a single touch
		// for a second (also called long press).
		// @event keypress: KeyboardEvent
		// Fired when the user presses a key from the keyboard while the map is focused.
		L.DomEvent[onOff](this._container, 'click dblclick mousedown mouseup ' +
			'mouseover mouseout mousemove contextmenu keypress', this._handleDOMEvent, this);

		if (this.options.trackResize) {
			L.DomEvent[onOff](window, 'resize', this._onResize, this);
		}

		if (L.Browser.any3d && this.options.transform3DLimit) {
			this[onOff]('moveend', this._onMoveEnd);
		}
	},

	_onResize: function () {
		L.Util.cancelAnimFrame(this._resizeRequest);
		this._resizeRequest = L.Util.requestAnimFrame(
		        function () { this.invalidateSize({debounceMoveend: true}); }, this);
	},

	_onScroll: function () {
		this._container.scrollTop  = 0;
		this._container.scrollLeft = 0;
	},

	_onMoveEnd: function () {
		var pos = this._getMapPanePos();
		if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
			// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
			// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
			this._resetView(this.getCenter(), this.getZoom());
		}
	},

	_findEventTargets: function (e, type) {
		var targets = [],
		    target,
		    isHover = type === 'mouseout' || type === 'mouseover',
		    src = e.target || e.srcElement,
		    dragging = false;

		while (src) {
			target = this._targets[L.stamp(src)];
			if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
				// Prevent firing click after you just dragged an object.
				dragging = true;
				break;
			}
			if (target && target.listens(type, true)) {
				if (isHover && !L.DomEvent._isExternalTarget(src, e)) { break; }
				targets.push(target);
				if (isHover) { break; }
			}
			if (src === this._container) { break; }
			src = src.parentNode;
		}
		if (!targets.length && !dragging && !isHover && L.DomEvent._isExternalTarget(src, e)) {
			targets = [this];
		}
		return targets;
	},

	_handleDOMEvent: function (e) {
		if (!this._loaded || L.DomEvent._skipped(e)) { return; }

		var type = e.type === 'keypress' && e.keyCode === 13 ? 'click' : e.type;

		if (type === 'mousedown') {
			// prevents outline when clicking on keyboard-focusable element
			L.DomUtil.preventOutline(e.target || e.srcElement);
		}

		this._fireDOMEvent(e, type);
	},

	_fireDOMEvent: function (e, type, targets) {

		if (e.type === 'click') {
			// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
			// @event preclick: MouseEvent
			// Fired before mouse click on the map (sometimes useful when you
			// want something to happen on click before any existing click
			// handlers start running).
			var synth = L.Util.extend({}, e);
			synth.type = 'preclick';
			this._fireDOMEvent(synth, synth.type, targets);
		}

		if (e._stopped) { return; }

		// Find the layer the event is propagating from and its parents.
		targets = (targets || []).concat(this._findEventTargets(e, type));

		if (!targets.length) { return; }

		var target = targets[0];
		if (type === 'contextmenu' && target.listens(type, true)) {
			L.DomEvent.preventDefault(e);
		}

		var data = {
			originalEvent: e
		};

		if (e.type !== 'keypress') {
			var isMarker = target instanceof L.Marker;
			data.containerPoint = isMarker ?
					this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
			data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
			data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
		}

		for (var i = 0; i < targets.length; i++) {
			targets[i].fire(type, data, true);
			if (data.originalEvent._stopped ||
				(targets[i].options.nonBubblingEvents && L.Util.indexOf(targets[i].options.nonBubblingEvents, type) !== -1)) { return; }
		}
	},

	_draggableMoved: function (obj) {
		obj = obj.dragging && obj.dragging.enabled() ? obj : this;
		return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
	},

	_clearHandlers: function () {
		for (var i = 0, len = this._handlers.length; i < len; i++) {
			this._handlers[i].disable();
		}
	},

	// @section Other Methods

	// @method whenReady(fn: Function, context?: Object): this
	// Runs the given function `fn` when the map gets initialized with
	// a view (center and zoom) and at least one layer, or immediately
	// if it's already initialized, optionally passing a function context.
	whenReady: function (callback, context) {
		if (this._loaded) {
			callback.call(context || this, {target: this});
		} else {
			this.on('load', callback, context);
		}
		return this;
	},


	// private methods for getting map state

	_getMapPanePos: function () {
		return L.DomUtil.getPosition(this._mapPane) || new L.Point(0, 0);
	},

	_moved: function () {
		var pos = this._getMapPanePos();
		return pos && !pos.equals([0, 0]);
	},

	_getTopLeftPoint: function (center, zoom) {
		var pixelOrigin = center && zoom !== undefined ?
			this._getNewPixelOrigin(center, zoom) :
			this.getPixelOrigin();
		return pixelOrigin.subtract(this._getMapPanePos());
	},

	_getNewPixelOrigin: function (center, zoom) {
		var viewHalf = this.getSize()._divideBy(2);
		return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
	},

	_latLngToNewLayerPoint: function (latlng, zoom, center) {
		var topLeft = this._getNewPixelOrigin(center, zoom);
		return this.project(latlng, zoom)._subtract(topLeft);
	},

	// layer point of the current center
	_getCenterLayerPoint: function () {
		return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
	},

	// offset of the specified place to the current center in pixels
	_getCenterOffset: function (latlng) {
		return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
	},

	// adjust center for view to get inside bounds
	_limitCenter: function (center, zoom, bounds) {

		if (!bounds) { return center; }

		var centerPoint = this.project(center, zoom),
		    viewHalf = this.getSize().divideBy(2),
		    viewBounds = new L.Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
		    offset = this._getBoundsOffset(viewBounds, bounds, zoom);

		// If offset is less than a pixel, ignore.
		// This prevents unstable projections from getting into
		// an infinite loop of tiny offsets.
		if (offset.round().equals([0, 0])) {
			return center;
		}

		return this.unproject(centerPoint.add(offset), zoom);
	},

	// adjust offset for view to get inside bounds
	_limitOffset: function (offset, bounds) {
		if (!bounds) { return offset; }

		var viewBounds = this.getPixelBounds(),
		    newBounds = new L.Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));

		return offset.add(this._getBoundsOffset(newBounds, bounds));
	},

	// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
	_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
		var projectedMaxBounds = L.bounds(
		        this.project(maxBounds.getNorthEast(), zoom),
		        this.project(maxBounds.getSouthWest(), zoom)
		    ),
		    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
		    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),

		    dx = this._rebound(minOffset.x, -maxOffset.x),
		    dy = this._rebound(minOffset.y, -maxOffset.y);

		return new L.Point(dx, dy);
	},

	_rebound: function (left, right) {
		return left + right > 0 ?
			Math.round(left - right) / 2 :
			Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
	},

	_limitZoom: function (zoom) {
		var min = this.getMinZoom(),
		    max = this.getMaxZoom(),
		    snap = L.Browser.any3d ? this.options.zoomSnap : 1;
		if (snap) {
			zoom = Math.round(zoom / snap) * snap;
		}
		return Math.max(min, Math.min(max, zoom));
	}
});

// @section

// @factory L.map(id: String, options?: Map options)
// Instantiates a map object given the DOM ID of a `<div>` element
// and optionally an object literal with `Map options`.
//
// @alternative
// @factory L.map(el: HTMLElement, options?: Map options)
// Instantiates a map object given an instance of a `<div>` HTML element
// and optionally an object literal with `Map options`.
L.map = function (id, options) {
	return new L.Map(id, options);
};


/*
 * @class Layer
 * @inherits Evented
 * @aka L.Layer
 * @aka ILayer
 *
 * A set of methods from the Layer base class that all Leaflet layers use.
 * Inherits all methods, options and events from `L.Evented`.
 *
 * @example
 *
 * ```js
 * var layer = L.Marker(latlng).addTo(map);
 * layer.addTo(map);
 * layer.remove();
 * ```
 *
 * @event add: Event
 * Fired after the layer is added to a map
 *
 * @event remove: Event
 * Fired after the layer is removed from a map
 */


L.Layer = L.Evented.extend({

	// Classes extending `L.Layer` will inherit the following options:
	options: {
		// @option pane: String = 'overlayPane'
		// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
		pane: 'overlayPane',
		nonBubblingEvents: []  // Array of events that should not be bubbled to DOM parents (like the map)
	},

	/* @section
	 * Classes extending `L.Layer` will inherit the following methods:
	 *
	 * @method addTo(map: Map): this
	 * Adds the layer to the given map
	 */
	addTo: function (map) {
		map.addLayer(this);
		return this;
	},

	// @method remove: this
	// Removes the layer from the map it is currently active on.
	remove: function () {
		return this.removeFrom(this._map || this._mapToAdd);
	},

	// @method removeFrom(map: Map): this
	// Removes the layer from the given map
	removeFrom: function (obj) {
		if (obj) {
			obj.removeLayer(this);
		}
		return this;
	},

	// @method getPane(name? : String): HTMLElement
	// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
	getPane: function (name) {
		return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
	},

	addInteractiveTarget: function (targetEl) {
		this._map._targets[L.stamp(targetEl)] = this;
		return this;
	},

	removeInteractiveTarget: function (targetEl) {
		delete this._map._targets[L.stamp(targetEl)];
		return this;
	},

	_layerAdd: function (e) {
		var map = e.target;

		// check in case layer gets added and then removed before the map is ready
		if (!map.hasLayer(this)) { return; }

		this._map = map;
		this._zoomAnimated = map._zoomAnimated;

		if (this.getEvents) {
			var events = this.getEvents();
			map.on(events, this);
			this.once('remove', function () {
				map.off(events, this);
			}, this);
		}

		this.onAdd(map);

		if (this.getAttribution && this._map.attributionControl) {
			this._map.attributionControl.addAttribution(this.getAttribution());
		}

		this.fire('add');
		map.fire('layeradd', {layer: this});
	}
});

/* @section Extension methods
 * @uninheritable
 *
 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
 *
 * @method onAdd(map: Map): this
 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
 *
 * @method onRemove(map: Map): this
 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
 *
 * @method getEvents(): Object
 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
 *
 * @method getAttribution(): String
 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
 *
 * @method beforeAdd(map: Map): this
 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
 */


/* @namespace Map
 * @section Layer events
 *
 * @event layeradd: LayerEvent
 * Fired when a new layer is added to the map.
 *
 * @event layerremove: LayerEvent
 * Fired when some layer is removed from the map
 *
 * @section Methods for Layers and Controls
 */
L.Map.include({
	// @method addLayer(layer: Layer): this
	// Adds the given layer to the map
	addLayer: function (layer) {
		var id = L.stamp(layer);
		if (this._layers[id]) { return this; }
		this._layers[id] = layer;

		layer._mapToAdd = this;

		if (layer.beforeAdd) {
			layer.beforeAdd(this);
		}

		this.whenReady(layer._layerAdd, layer);

		return this;
	},

	// @method removeLayer(layer: Layer): this
	// Removes the given layer from the map.
	removeLayer: function (layer) {
		var id = L.stamp(layer);

		if (!this._layers[id]) { return this; }

		if (this._loaded) {
			layer.onRemove(this);
		}

		if (layer.getAttribution && this.attributionControl) {
			this.attributionControl.removeAttribution(layer.getAttribution());
		}

		delete this._layers[id];

		if (this._loaded) {
			this.fire('layerremove', {layer: layer});
			layer.fire('remove');
		}

		layer._map = layer._mapToAdd = null;

		return this;
	},

	// @method hasLayer(layer: Layer): Boolean
	// Returns `true` if the given layer is currently added to the map
	hasLayer: function (layer) {
		return !!layer && (L.stamp(layer) in this._layers);
	},

	/* @method eachLayer(fn: Function, context?: Object): this
	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
	 * ```
	 * map.eachLayer(function(layer){
	 *     layer.bindPopup('Hello');
	 * });
	 * ```
	 */
	eachLayer: function (method, context) {
		for (var i in this._layers) {
			method.call(context, this._layers[i]);
		}
		return this;
	},

	_addLayers: function (layers) {
		layers = layers ? (L.Util.isArray(layers) ? layers : [layers]) : [];

		for (var i = 0, len = layers.length; i < len; i++) {
			this.addLayer(layers[i]);
		}
	},

	_addZoomLimit: function (layer) {
		if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
			this._zoomBoundLayers[L.stamp(layer)] = layer;
			this._updateZoomLevels();
		}
	},

	_removeZoomLimit: function (layer) {
		var id = L.stamp(layer);

		if (this._zoomBoundLayers[id]) {
			delete this._zoomBoundLayers[id];
			this._updateZoomLevels();
		}
	},

	_updateZoomLevels: function () {
		var minZoom = Infinity,
		    maxZoom = -Infinity,
		    oldZoomSpan = this._getZoomSpan();

		for (var i in this._zoomBoundLayers) {
			var options = this._zoomBoundLayers[i].options;

			minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
			maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
		}

		this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
		this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;

		// @section Map state change events
		// @event zoomlevelschange: Event
		// Fired when the number of zoomlevels on the map is changed due
		// to adding or removing a layer.
		if (oldZoomSpan !== this._getZoomSpan()) {
			this.fire('zoomlevelschange');
		}
	}
});

/*
 * @namespace Projection
 * @projection L.Projection.Mercator
 *
 * Elliptical Mercator projection — more complex than Spherical Mercator. Takes into account that Earth is a geoid, not a perfect sphere. Used by the EPSG:3395 CRS.
 */

L.Projection.Mercator = {
	R: 6378137,
	R_MINOR: 6356752.314245179,

	bounds: L.bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),

	project: function (latlng) {
		var d = Math.PI / 180,
		    r = this.R,
		    y = latlng.lat * d,
		    tmp = this.R_MINOR / r,
		    e = Math.sqrt(1 - tmp * tmp),
		    con = e * Math.sin(y);

		var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
		y = -r * Math.log(Math.max(ts, 1E-10));

		return new L.Point(latlng.lng * d * r, y);
	},

	unproject: function (point) {
		var d = 180 / Math.PI,
		    r = this.R,
		    tmp = this.R_MINOR / r,
		    e = Math.sqrt(1 - tmp * tmp),
		    ts = Math.exp(-point.y / r),
		    phi = Math.PI / 2 - 2 * Math.atan(ts);

		for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
			con = e * Math.sin(phi);
			con = Math.pow((1 - con) / (1 + con), e / 2);
			dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
			phi += dphi;
		}

		return new L.LatLng(phi * d, point.x * d / r);
	}
};

/*
 * @namespace CRS
 * @crs L.CRS.EPSG3395
 *
 * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
 */

L.CRS.EPSG3395 = L.extend({}, L.CRS.Earth, {
	code: 'EPSG:3395',
	projection: L.Projection.Mercator,

	transformation: (function () {
		var scale = 0.5 / (Math.PI * L.Projection.Mercator.R);
		return new L.Transformation(scale, 0.5, -scale, 0.5);
	}())
});

/*
 * @class GridLayer
 * @inherits Layer
 * @aka L.GridLayer
 *
 * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
 * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
 *
 *
 * @section Synchronous usage
 * @example
 *
 * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
 *
 * ```js
 * var CanvasLayer = L.GridLayer.extend({
 *     createTile: function(coords){
 *         // create a <canvas> element for drawing
 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
 *
 *         // setup tile width and height according to the options
 *         var size = this.getTileSize();
 *         tile.width = size.x;
 *         tile.height = size.y;
 *
 *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
 *         var ctx = tile.getContext('2d');
 *
 *         // return the tile so it can be rendered on screen
 *         return tile;
 *     }
 * });
 * ```
 *
 * @section Asynchronous usage
 * @example
 *
 * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
 *
 * ```js
 * var CanvasLayer = L.GridLayer.extend({
 *     createTile: function(coords, done){
 *         var error;
 *
 *         // create a <canvas> element for drawing
 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
 *
 *         // setup tile width and height according to the options
 *         var size = this.getTileSize();
 *         tile.width = size.x;
 *         tile.height = size.y;
 *
 *         // draw something asynchronously and pass the tile to the done() callback
 *         setTimeout(function() {
 *             done(error, tile);
 *         }, 1000);
 *
 *         return tile;
 *     }
 * });
 * ```
 *
 * @section
 */


L.GridLayer = L.Layer.extend({

	// @section
	// @aka GridLayer options
	options: {
		// @option tileSize: Number|Point = 256
		// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
		tileSize: 256,

		// @option opacity: Number = 1.0
		// Opacity of the tiles. Can be used in the `createTile()` function.
		opacity: 1,

		// @option updateWhenIdle: Boolean = depends
		// If `false`, new tiles are loaded during panning, otherwise only after it (for better performance). `true` by default on mobile browsers, otherwise `false`.
		updateWhenIdle: L.Browser.mobile,

		// @option updateWhenZooming: Boolean = true
		// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
		updateWhenZooming: true,

		// @option updateInterval: Number = 200
		// Tiles will not update more than once every `updateInterval` milliseconds when panning.
		updateInterval: 200,

		// @option attribution: String = null
		// String to be shown in the attribution control, describes the layer data, e.g. "© Mapbox".
		attribution: null,

		// @option zIndex: Number = 1
		// The explicit zIndex of the tile layer.
		zIndex: 1,

		// @option bounds: LatLngBounds = undefined
		// If set, tiles will only be loaded inside the set `LatLngBounds`.
		bounds: null,

		// @option minZoom: Number = 0
		// The minimum zoom level that tiles will be loaded at. By default the entire map.
		minZoom: 0,

		// @option maxZoom: Number = undefined
		// The maximum zoom level that tiles will be loaded at.
		maxZoom: undefined,

		// @option noWrap: Boolean = false
		// Whether the layer is wrapped around the antimeridian. If `true`, the
		// GridLayer will only be displayed once at low zoom levels. Has no
		// effect when the [map CRS](#map-crs) doesn't wrap around.
		noWrap: false,

		// @option pane: String = 'tilePane'
		// `Map pane` where the grid layer will be added.
		pane: 'tilePane',

		// @option className: String = ''
		// A custom class name to assign to the tile layer. Empty by default.
		className: '',

		// @option keepBuffer: Number = 2
		// When panning the map, keep this many rows and columns of tiles before unloading them.
		keepBuffer: 2
	},

	initialize: function (options) {
		L.setOptions(this, options);
	},

	onAdd: function () {
		this._initContainer();

		this._levels = {};
		this._tiles = {};

		this._resetView();
		this._update();
	},

	beforeAdd: function (map) {
		map._addZoomLimit(this);
	},

	onRemove: function (map) {
		this._removeAllTiles();
		L.DomUtil.remove(this._container);
		map._removeZoomLimit(this);
		this._container = null;
		this._tileZoom = null;
	},

	// @method bringToFront: this
	// Brings the tile layer to the top of all tile layers.
	bringToFront: function () {
		if (this._map) {
			L.DomUtil.toFront(this._container);
			this._setAutoZIndex(Math.max);
		}
		return this;
	},

	// @method bringToBack: this
	// Brings the tile layer to the bottom of all tile layers.
	bringToBack: function () {
		if (this._map) {
			L.DomUtil.toBack(this._container);
			this._setAutoZIndex(Math.min);
		}
		return this;
	},

	// @method getAttribution: String
	// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
	getAttribution: function () {
		return this.options.attribution;
	},

	// @method getContainer: HTMLElement
	// Returns the HTML element that contains the tiles for this layer.
	getContainer: function () {
		return this._container;
	},

	// @method setOpacity(opacity: Number): this
	// Changes the [opacity](#gridlayer-opacity) of the grid layer.
	setOpacity: function (opacity) {
		this.options.opacity = opacity;
		this._updateOpacity();
		return this;
	},

	// @method setZIndex(zIndex: Number): this
	// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
	setZIndex: function (zIndex) {
		this.options.zIndex = zIndex;
		this._updateZIndex();

		return this;
	},

	// @method isLoading: Boolean
	// Returns `true` if any tile in the grid layer has not finished loading.
	isLoading: function () {
		return this._loading;
	},

	// @method redraw: this
	// Causes the layer to clear all the tiles and request them again.
	redraw: function () {
		if (this._map) {
			this._removeAllTiles();
			this._update();
		}
		return this;
	},

	getEvents: function () {
		var events = {
			viewprereset: this._invalidateAll,
			viewreset: this._resetView,
			zoom: this._resetView,
			moveend: this._onMoveEnd
		};

		if (!this.options.updateWhenIdle) {
			// update tiles on move, but not more often than once per given interval
			if (!this._onMove) {
				this._onMove = L.Util.throttle(this._onMoveEnd, this.options.updateInterval, this);
			}

			events.move = this._onMove;
		}

		if (this._zoomAnimated) {
			events.zoomanim = this._animateZoom;
		}

		return events;
	},

	// @section Extension methods
	// Layers extending `GridLayer` shall reimplement the following method.
	// @method createTile(coords: Object, done?: Function): HTMLElement
	// Called only internally, must be overriden by classes extending `GridLayer`.
	// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
	// is specified, it must be called when the tile has finished loading and drawing.
	createTile: function () {
		return document.createElement('div');
	},

	// @section
	// @method getTileSize: Point
	// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
	getTileSize: function () {
		var s = this.options.tileSize;
		return s instanceof L.Point ? s : new L.Point(s, s);
	},

	_updateZIndex: function () {
		if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
			this._container.style.zIndex = this.options.zIndex;
		}
	},

	_setAutoZIndex: function (compare) {
		// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)

		var layers = this.getPane().children,
		    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min

		for (var i = 0, len = layers.length, zIndex; i < len; i++) {

			zIndex = layers[i].style.zIndex;

			if (layers[i] !== this._container && zIndex) {
				edgeZIndex = compare(edgeZIndex, +zIndex);
			}
		}

		if (isFinite(edgeZIndex)) {
			this.options.zIndex = edgeZIndex + compare(-1, 1);
			this._updateZIndex();
		}
	},

	_updateOpacity: function () {
		if (!this._map) { return; }

		// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
		if (L.Browser.ielt9) { return; }

		L.DomUtil.setOpacity(this._container, this.options.opacity);

		var now = +new Date(),
		    nextFrame = false,
		    willPrune = false;

		for (var key in this._tiles) {
			var tile = this._tiles[key];
			if (!tile.current || !tile.loaded) { continue; }

			var fade = Math.min(1, (now - tile.loaded) / 200);

			L.DomUtil.setOpacity(tile.el, fade);
			if (fade < 1) {
				nextFrame = true;
			} else {
				if (tile.active) { willPrune = true; }
				tile.active = true;
			}
		}

		if (willPrune && !this._noPrune) { this._pruneTiles(); }

		if (nextFrame) {
			L.Util.cancelAnimFrame(this._fadeFrame);
			this._fadeFrame = L.Util.requestAnimFrame(this._updateOpacity, this);
		}
	},

	_initContainer: function () {
		if (this._container) { return; }

		this._container = L.DomUtil.create('div', 'leaflet-layer ' + (this.options.className || ''));
		this._updateZIndex();

		if (this.options.opacity < 1) {
			this._updateOpacity();
		}

		this.getPane().appendChild(this._container);
	},

	_updateLevels: function () {

		var zoom = this._tileZoom,
		    maxZoom = this.options.maxZoom;

		if (zoom === undefined) { return undefined; }

		for (var z in this._levels) {
			if (this._levels[z].el.children.length || z === zoom) {
				this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
			} else {
				L.DomUtil.remove(this._levels[z].el);
				this._removeTilesAtZoom(z);
				delete this._levels[z];
			}
		}

		var level = this._levels[zoom],
		    map = this._map;

		if (!level) {
			level = this._levels[zoom] = {};

			level.el = L.DomUtil.create('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
			level.el.style.zIndex = maxZoom;

			level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
			level.zoom = zoom;

			this._setZoomTransform(level, map.getCenter(), map.getZoom());

			// force the browser to consider the newly added element for transition
			L.Util.falseFn(level.el.offsetWidth);
		}

		this._level = level;

		return level;
	},

	_pruneTiles: function () {
		if (!this._map) {
			return;
		}

		var key, tile;

		var zoom = this._map.getZoom();
		if (zoom > this.options.maxZoom ||
			zoom < this.options.minZoom) {
			this._removeAllTiles();
			return;
		}

		for (key in this._tiles) {
			tile = this._tiles[key];
			tile.retain = tile.current;
		}

		for (key in this._tiles) {
			tile = this._tiles[key];
			if (tile.current && !tile.active) {
				var coords = tile.coords;
				if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
					this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
				}
			}
		}

		for (key in this._tiles) {
			if (!this._tiles[key].retain) {
				this._removeTile(key);
			}
		}
	},

	_removeTilesAtZoom: function (zoom) {
		for (var key in this._tiles) {
			if (this._tiles[key].coords.z !== zoom) {
				continue;
			}
			this._removeTile(key);
		}
	},

	_removeAllTiles: function () {
		for (var key in this._tiles) {
			this._removeTile(key);
		}
	},

	_invalidateAll: function () {
		for (var z in this._levels) {
			L.DomUtil.remove(this._levels[z].el);
			delete this._levels[z];
		}
		this._removeAllTiles();

		this._tileZoom = null;
	},

	_retainParent: function (x, y, z, minZoom) {
		var x2 = Math.floor(x / 2),
		    y2 = Math.floor(y / 2),
		    z2 = z - 1,
		    coords2 = new L.Point(+x2, +y2);
		coords2.z = +z2;

		var key = this._tileCoordsToKey(coords2),
		    tile = this._tiles[key];

		if (tile && tile.active) {
			tile.retain = true;
			return true;

		} else if (tile && tile.loaded) {
			tile.retain = true;
		}

		if (z2 > minZoom) {
			return this._retainParent(x2, y2, z2, minZoom);
		}

		return false;
	},

	_retainChildren: function (x, y, z, maxZoom) {

		for (var i = 2 * x; i < 2 * x + 2; i++) {
			for (var j = 2 * y; j < 2 * y + 2; j++) {

				var coords = new L.Point(i, j);
				coords.z = z + 1;

				var key = this._tileCoordsToKey(coords),
				    tile = this._tiles[key];

				if (tile && tile.active) {
					tile.retain = true;
					continue;

				} else if (tile && tile.loaded) {
					tile.retain = true;
				}

				if (z + 1 < maxZoom) {
					this._retainChildren(i, j, z + 1, maxZoom);
				}
			}
		}
	},

	_resetView: function (e) {
		var animating = e && (e.pinch || e.flyTo);
		this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
	},

	_animateZoom: function (e) {
		this._setView(e.center, e.zoom, true, e.noUpdate);
	},

	_setView: function (center, zoom, noPrune, noUpdate) {
		var tileZoom = Math.round(zoom);
		if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
		    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
			tileZoom = undefined;
		}

		var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);

		if (!noUpdate || tileZoomChanged) {

			this._tileZoom = tileZoom;

			if (this._abortLoading) {
				this._abortLoading();
			}

			this._updateLevels();
			this._resetGrid();

			if (tileZoom !== undefined) {
				this._update(center);
			}

			if (!noPrune) {
				this._pruneTiles();
			}

			// Flag to prevent _updateOpacity from pruning tiles during
			// a zoom anim or a pinch gesture
			this._noPrune = !!noPrune;
		}

		this._setZoomTransforms(center, zoom);
	},

	_setZoomTransforms: function (center, zoom) {
		for (var i in this._levels) {
			this._setZoomTransform(this._levels[i], center, zoom);
		}
	},

	_setZoomTransform: function (level, center, zoom) {
		var scale = this._map.getZoomScale(zoom, level.zoom),
		    translate = level.origin.multiplyBy(scale)
		        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();

		if (L.Browser.any3d) {
			L.DomUtil.setTransform(level.el, translate, scale);
		} else {
			L.DomUtil.setPosition(level.el, translate);
		}
	},

	_resetGrid: function () {
		var map = this._map,
		    crs = map.options.crs,
		    tileSize = this._tileSize = this.getTileSize(),
		    tileZoom = this._tileZoom;

		var bounds = this._map.getPixelWorldBounds(this._tileZoom);
		if (bounds) {
			this._globalTileRange = this._pxBoundsToTileRange(bounds);
		}

		this._wrapX = crs.wrapLng && !this.options.noWrap && [
			Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
			Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
		];
		this._wrapY = crs.wrapLat && !this.options.noWrap && [
			Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
			Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
		];
	},

	_onMoveEnd: function () {
		if (!this._map || this._map._animatingZoom) { return; }

		this._update();
	},

	_getTiledPixelBounds: function (center) {
		var map = this._map,
		    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
		    scale = map.getZoomScale(mapZoom, this._tileZoom),
		    pixelCenter = map.project(center, this._tileZoom).floor(),
		    halfSize = map.getSize().divideBy(scale * 2);

		return new L.Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
	},

	// Private method to load tiles in the grid's active zoom level according to map bounds
	_update: function (center) {
		var map = this._map;
		if (!map) { return; }
		var zoom = map.getZoom();

		if (center === undefined) { center = map.getCenter(); }
		if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom

		var pixelBounds = this._getTiledPixelBounds(center),
		    tileRange = this._pxBoundsToTileRange(pixelBounds),
		    tileCenter = tileRange.getCenter(),
		    queue = [],
		    margin = this.options.keepBuffer,
		    noPruneRange = new L.Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
		                              tileRange.getTopRight().add([margin, -margin]));

		for (var key in this._tiles) {
			var c = this._tiles[key].coords;
			if (c.z !== this._tileZoom || !noPruneRange.contains(L.point(c.x, c.y))) {
				this._tiles[key].current = false;
			}
		}

		// _update just loads more tiles. If the tile zoom level differs too much
		// from the map's, let _setView reset levels and prune old tiles.
		if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }

		// create a queue of coordinates to load tiles from
		for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
			for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
				var coords = new L.Point(i, j);
				coords.z = this._tileZoom;

				if (!this._isValidTile(coords)) { continue; }

				var tile = this._tiles[this._tileCoordsToKey(coords)];
				if (tile) {
					tile.current = true;
				} else {
					queue.push(coords);
				}
			}
		}

		// sort tile queue to load tiles in order of their distance to center
		queue.sort(function (a, b) {
			return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
		});

		if (queue.length !== 0) {
			// if it's the first batch of tiles to load
			if (!this._loading) {
				this._loading = true;
				// @event loading: Event
				// Fired when the grid layer starts loading tiles.
				this.fire('loading');
			}

			// create DOM fragment to append tiles in one batch
			var fragment = document.createDocumentFragment();

			for (i = 0; i < queue.length; i++) {
				this._addTile(queue[i], fragment);
			}

			this._level.el.appendChild(fragment);
		}
	},

	_isValidTile: function (coords) {
		var crs = this._map.options.crs;

		if (!crs.infinite) {
			// don't load tile if it's out of bounds and not wrapped
			var bounds = this._globalTileRange;
			if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
			    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
		}

		if (!this.options.bounds) { return true; }

		// don't load tile if it doesn't intersect the bounds in options
		var tileBounds = this._tileCoordsToBounds(coords);
		return L.latLngBounds(this.options.bounds).overlaps(tileBounds);
	},

	_keyToBounds: function (key) {
		return this._tileCoordsToBounds(this._keyToTileCoords(key));
	},

	// converts tile coordinates to its geographical bounds
	_tileCoordsToBounds: function (coords) {

		var map = this._map,
		    tileSize = this.getTileSize(),

		    nwPoint = coords.scaleBy(tileSize),
		    sePoint = nwPoint.add(tileSize),

		    nw = map.unproject(nwPoint, coords.z),
		    se = map.unproject(sePoint, coords.z);

		if (!this.options.noWrap) {
			nw = map.wrapLatLng(nw);
			se = map.wrapLatLng(se);
		}

		return new L.LatLngBounds(nw, se);
	},

	// converts tile coordinates to key for the tile cache
	_tileCoordsToKey: function (coords) {
		return coords.x + ':' + coords.y + ':' + coords.z;
	},

	// converts tile cache key to coordinates
	_keyToTileCoords: function (key) {
		var k = key.split(':'),
		    coords = new L.Point(+k[0], +k[1]);
		coords.z = +k[2];
		return coords;
	},

	_removeTile: function (key) {
		var tile = this._tiles[key];
		if (!tile) { return; }

		L.DomUtil.remove(tile.el);

		delete this._tiles[key];

		// @event tileunload: TileEvent
		// Fired when a tile is removed (e.g. when a tile goes off the screen).
		this.fire('tileunload', {
			tile: tile.el,
			coords: this._keyToTileCoords(key)
		});
	},

	_initTile: function (tile) {
		L.DomUtil.addClass(tile, 'leaflet-tile');

		var tileSize = this.getTileSize();
		tile.style.width = tileSize.x + 'px';
		tile.style.height = tileSize.y + 'px';

		tile.onselectstart = L.Util.falseFn;
		tile.onmousemove = L.Util.falseFn;

		// update opacity on tiles in IE7-8 because of filter inheritance problems
		if (L.Browser.ielt9 && this.options.opacity < 1) {
			L.DomUtil.setOpacity(tile, this.options.opacity);
		}

		// without this hack, tiles disappear after zoom on Chrome for Android
		// https://github.com/Leaflet/Leaflet/issues/2078
		if (L.Browser.android && !L.Browser.android23) {
			tile.style.WebkitBackfaceVisibility = 'hidden';
		}
	},

	_addTile: function (coords, container) {
		var tilePos = this._getTilePos(coords),
		    key = this._tileCoordsToKey(coords);

		var tile = this.createTile(this._wrapCoords(coords), L.bind(this._tileReady, this, coords));

		this._initTile(tile);

		// if createTile is defined with a second argument ("done" callback),
		// we know that tile is async and will be ready later; otherwise
		if (this.createTile.length < 2) {
			// mark tile as ready, but delay one frame for opacity animation to happen
			L.Util.requestAnimFrame(L.bind(this._tileReady, this, coords, null, tile));
		}

		L.DomUtil.setPosition(tile, tilePos);

		// save tile in cache
		this._tiles[key] = {
			el: tile,
			coords: coords,
			current: true
		};

		container.appendChild(tile);
		// @event tileloadstart: TileEvent
		// Fired when a tile is requested and starts loading.
		this.fire('tileloadstart', {
			tile: tile,
			coords: coords
		});
	},

	_tileReady: function (coords, err, tile) {
		if (!this._map) { return; }

		if (err) {
			// @event tileerror: TileErrorEvent
			// Fired when there is an error loading a tile.
			this.fire('tileerror', {
				error: err,
				tile: tile,
				coords: coords
			});
		}

		var key = this._tileCoordsToKey(coords);

		tile = this._tiles[key];
		if (!tile) { return; }

		tile.loaded = +new Date();
		if (this._map._fadeAnimated) {
			L.DomUtil.setOpacity(tile.el, 0);
			L.Util.cancelAnimFrame(this._fadeFrame);
			this._fadeFrame = L.Util.requestAnimFrame(this._updateOpacity, this);
		} else {
			tile.active = true;
			this._pruneTiles();
		}

		if (!err) {
			L.DomUtil.addClass(tile.el, 'leaflet-tile-loaded');

			// @event tileload: TileEvent
			// Fired when a tile loads.
			this.fire('tileload', {
				tile: tile.el,
				coords: coords
			});
		}

		if (this._noTilesToLoad()) {
			this._loading = false;
			// @event load: Event
			// Fired when the grid layer loaded all visible tiles.
			this.fire('load');

			if (L.Browser.ielt9 || !this._map._fadeAnimated) {
				L.Util.requestAnimFrame(this._pruneTiles, this);
			} else {
				// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
				// to trigger a pruning.
				setTimeout(L.bind(this._pruneTiles, this), 250);
			}
		}
	},

	_getTilePos: function (coords) {
		return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
	},

	_wrapCoords: function (coords) {
		var newCoords = new L.Point(
			this._wrapX ? L.Util.wrapNum(coords.x, this._wrapX) : coords.x,
			this._wrapY ? L.Util.wrapNum(coords.y, this._wrapY) : coords.y);
		newCoords.z = coords.z;
		return newCoords;
	},

	_pxBoundsToTileRange: function (bounds) {
		var tileSize = this.getTileSize();
		return new L.Bounds(
			bounds.min.unscaleBy(tileSize).floor(),
			bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
	},

	_noTilesToLoad: function () {
		for (var key in this._tiles) {
			if (!this._tiles[key].loaded) { return false; }
		}
		return true;
	}
});

// @factory L.gridLayer(options?: GridLayer options)
// Creates a new instance of GridLayer with the supplied options.
L.gridLayer = function (options) {
	return new L.GridLayer(options);
};

/*
 * @class TileLayer
 * @inherits GridLayer
 * @aka L.TileLayer
 * Used to load and display tile layers on the map. Extends `GridLayer`.
 *
 * @example
 *
 * ```js
 * L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar'}).addTo(map);
 * ```
 *
 * @section URL template
 * @example
 *
 * A string of the following form:
 *
 * ```
 * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
 * ```
 *
 * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add @2x to the URL to load retina tiles.
 *
 * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
 *
 * ```
 * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
 * ```
 */


L.TileLayer = L.GridLayer.extend({

	// @section
	// @aka TileLayer options
	options: {
		// @option minZoom: Number = 0
		// Minimum zoom number.
		minZoom: 0,

		// @option maxZoom: Number = 18
		// Maximum zoom number.
		maxZoom: 18,

		// @option maxNativeZoom: Number = null
		// Maximum zoom number the tile source has available. If it is specified,
		// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
		// from `maxNativeZoom` level and auto-scaled.
		maxNativeZoom: null,

		// @option subdomains: String|String[] = 'abc'
		// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
		subdomains: 'abc',

		// @option errorTileUrl: String = ''
		// URL to the tile image to show in place of the tile that failed to load.
		errorTileUrl: '',

		// @option zoomOffset: Number = 0
		// The zoom number used in tile URLs will be offset with this value.
		zoomOffset: 0,

		// @option tms: Boolean = false
		// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
		tms: false,

		// @option zoomReverse: Boolean = false
		// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
		zoomReverse: false,

		// @option detectRetina: Boolean = false
		// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
		detectRetina: false,

		// @option crossOrigin: Boolean = false
		// If true, all tiles will have their crossOrigin attribute set to ''. This is needed if you want to access tile pixel data.
		crossOrigin: false
	},

	initialize: function (url, options) {

		this._url = url;

		options = L.setOptions(this, options);

		// detecting retina displays, adjusting tileSize and zoom levels
		if (options.detectRetina && L.Browser.retina && options.maxZoom > 0) {

			options.tileSize = Math.floor(options.tileSize / 2);

			if (!options.zoomReverse) {
				options.zoomOffset++;
				options.maxZoom--;
			} else {
				options.zoomOffset--;
				options.minZoom++;
			}

			options.minZoom = Math.max(0, options.minZoom);
		}

		if (typeof options.subdomains === 'string') {
			options.subdomains = options.subdomains.split('');
		}

		// for https://github.com/Leaflet/Leaflet/issues/137
		if (!L.Browser.android) {
			this.on('tileunload', this._onTileRemove);
		}
	},

	// @method setUrl(url: String, noRedraw?: Boolean): this
	// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
	setUrl: function (url, noRedraw) {
		this._url = url;

		if (!noRedraw) {
			this.redraw();
		}
		return this;
	},

	// @method createTile(coords: Object, done?: Function): HTMLElement
	// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
	// to return an `<img>` HTML element with the appropiate image URL given `coords`. The `done`
	// callback is called when the tile has been loaded.
	createTile: function (coords, done) {
		var tile = document.createElement('img');

		L.DomEvent.on(tile, 'load', L.bind(this._tileOnLoad, this, done, tile));
		L.DomEvent.on(tile, 'error', L.bind(this._tileOnError, this, done, tile));

		if (this.options.crossOrigin) {
			tile.crossOrigin = '';
		}

		/*
		 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
		 http://www.w3.org/TR/WCAG20-TECHS/H67
		*/
		tile.alt = '';

		tile.src = this.getTileUrl(coords);

		return tile;
	},

	// @section Extension methods
	// @uninheritable
	// Layers extending `TileLayer` might reimplement the following method.
	// @method getTileUrl(coords: Object): String
	// Called only internally, returns the URL for a tile given its coordinates.
	// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
	getTileUrl: function (coords) {
		var data = {
			r: L.Browser.retina ? '@2x' : '',
			s: this._getSubdomain(coords),
			x: coords.x,
			y: coords.y,
			z: this._getZoomForUrl()
		};
		if (this._map && !this._map.options.crs.infinite) {
			var invertedY = this._globalTileRange.max.y - coords.y;
			if (this.options.tms) {
				data['y'] = invertedY;
			}
			data['-y'] = invertedY;
		}

		return L.Util.template(this._url, L.extend(data, this.options));
	},

	_tileOnLoad: function (done, tile) {
		// For https://github.com/Leaflet/Leaflet/issues/3332
		if (L.Browser.ielt9) {
			setTimeout(L.bind(done, this, null, tile), 0);
		} else {
			done(null, tile);
		}
	},

	_tileOnError: function (done, tile, e) {
		var errorUrl = this.options.errorTileUrl;
		if (errorUrl) {
			tile.src = errorUrl;
		}
		done(e, tile);
	},

	getTileSize: function () {
		var map = this._map,
		    tileSize = L.GridLayer.prototype.getTileSize.call(this),
		    zoom = this._tileZoom + this.options.zoomOffset,
		    zoomN = this.options.maxNativeZoom;

		// increase tile size when overscaling
		return zoomN !== null && zoom > zoomN ?
				tileSize.divideBy(map.getZoomScale(zoomN, zoom)).round() :
				tileSize;
	},

	_onTileRemove: function (e) {
		e.tile.onload = null;
	},

	_getZoomForUrl: function () {

		var options = this.options,
		    zoom = this._tileZoom;

		if (options.zoomReverse) {
			zoom = options.maxZoom - zoom;
		}

		zoom += options.zoomOffset;

		return options.maxNativeZoom !== null ? Math.min(zoom, options.maxNativeZoom) : zoom;
	},

	_getSubdomain: function (tilePoint) {
		var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
		return this.options.subdomains[index];
	},

	// stops loading all tiles in the background layer
	_abortLoading: function () {
		var i, tile;
		for (i in this._tiles) {
			if (this._tiles[i].coords.z !== this._tileZoom) {
				tile = this._tiles[i].el;

				tile.onload = L.Util.falseFn;
				tile.onerror = L.Util.falseFn;

				if (!tile.complete) {
					tile.src = L.Util.emptyImageUrl;
					L.DomUtil.remove(tile);
				}
			}
		}
	}
});


// @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
// Instantiates a tile layer object given a `URL template` and optionally an options object.

L.tileLayer = function (url, options) {
	return new L.TileLayer(url, options);
};

/*
 * @class TileLayer.WMS
 * @inherits TileLayer
 * @aka L.TileLayer.WMS
 * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
 *
 * @example
 *
 * ```js
 * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
 * 	layers: 'nexrad-n0r-900913',
 * 	format: 'image/png',
 * 	transparent: true,
 * 	attribution: "Weather data © 2012 IEM Nexrad"
 * });
 * ```
 */

L.TileLayer.WMS = L.TileLayer.extend({

	// @section
	// @aka TileLayer.WMS options
	// If any custom options not documented here are used, they will be sent to the
	// WMS server as extra parameters in each request URL. This can be useful for
	// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
	defaultWmsParams: {
		service: 'WMS',
		request: 'GetMap',

		// @option layers: String = ''
		// **(required)** Comma-separated list of WMS layers to show.
		layers: '',

		// @option styles: String = ''
		// Comma-separated list of WMS styles.
		styles: '',

		// @option format: String = 'image/jpeg'
		// WMS image format (use `'image/png'` for layers with transparency).
		format: 'image/jpeg',

		// @option transparent: Boolean = false
		// If `true`, the WMS service will return images with transparency.
		transparent: false,

		// @option version: String = '1.1.1'
		// Version of the WMS service to use
		version: '1.1.1'
	},

	options: {
		// @option crs: CRS = null
		// Coordinate Reference System to use for the WMS requests, defaults to
		// map CRS. Don't change this if you're not sure what it means.
		crs: null,

		// @option uppercase: Boolean = false
		// If `true`, WMS request parameter keys will be uppercase.
		uppercase: false
	},

	initialize: function (url, options) {

		this._url = url;

		var wmsParams = L.extend({}, this.defaultWmsParams);

		// all keys that are not TileLayer options go to WMS params
		for (var i in options) {
			if (!(i in this.options)) {
				wmsParams[i] = options[i];
			}
		}

		options = L.setOptions(this, options);

		wmsParams.width = wmsParams.height = options.tileSize * (options.detectRetina && L.Browser.retina ? 2 : 1);

		this.wmsParams = wmsParams;
	},

	onAdd: function (map) {

		this._crs = this.options.crs || map.options.crs;
		this._wmsVersion = parseFloat(this.wmsParams.version);

		var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
		this.wmsParams[projectionKey] = this._crs.code;

		L.TileLayer.prototype.onAdd.call(this, map);
	},

	getTileUrl: function (coords) {

		var tileBounds = this._tileCoordsToBounds(coords),
		    nw = this._crs.project(tileBounds.getNorthWest()),
		    se = this._crs.project(tileBounds.getSouthEast()),

		    bbox = (this._wmsVersion >= 1.3 && this._crs === L.CRS.EPSG4326 ?
			    [se.y, nw.x, nw.y, se.x] :
			    [nw.x, se.y, se.x, nw.y]).join(','),

		    url = L.TileLayer.prototype.getTileUrl.call(this, coords);

		return url +
			L.Util.getParamString(this.wmsParams, url, this.options.uppercase) +
			(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
	},

	// @method setParams(params: Object, noRedraw?: Boolean): this
	// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
	setParams: function (params, noRedraw) {

		L.extend(this.wmsParams, params);

		if (!noRedraw) {
			this.redraw();
		}

		return this;
	}
});


// @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
// Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
L.tileLayer.wms = function (url, options) {
	return new L.TileLayer.WMS(url, options);
};

/*
 * @class ImageOverlay
 * @aka L.ImageOverlay
 * @inherits Interactive layer
 *
 * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
 *
 * @example
 *
 * ```js
 * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
 * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
 * L.imageOverlay(imageUrl, imageBounds).addTo(map);
 * ```
 */

L.ImageOverlay = L.Layer.extend({

	// @section
	// @aka ImageOverlay options
	options: {
		// @option opacity: Number = 1.0
		// The opacity of the image overlay.
		opacity: 1,

		// @option alt: String = ''
		// Text for the `alt` attribute of the image (useful for accessibility).
		alt: '',

		// @option interactive: Boolean = false
		// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
		interactive: false,

		// @option attribution: String = null
		// An optional string containing HTML to be shown on the `Attribution control`
		attribution: null,

		// @option crossOrigin: Boolean = false
		// If true, the image will have its crossOrigin attribute set to ''. This is needed if you want to access image pixel data.
		crossOrigin: false
	},

	initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
		this._url = url;
		this._bounds = L.latLngBounds(bounds);

		L.setOptions(this, options);
	},

	onAdd: function () {
		if (!this._image) {
			this._initImage();

			if (this.options.opacity < 1) {
				this._updateOpacity();
			}
		}

		if (this.options.interactive) {
			L.DomUtil.addClass(this._image, 'leaflet-interactive');
			this.addInteractiveTarget(this._image);
		}

		this.getPane().appendChild(this._image);
		this._reset();
	},

	onRemove: function () {
		L.DomUtil.remove(this._image);
		if (this.options.interactive) {
			this.removeInteractiveTarget(this._image);
		}
	},

	// @method setOpacity(opacity: Number): this
	// Sets the opacity of the overlay.
	setOpacity: function (opacity) {
		this.options.opacity = opacity;

		if (this._image) {
			this._updateOpacity();
		}
		return this;
	},

	setStyle: function (styleOpts) {
		if (styleOpts.opacity) {
			this.setOpacity(styleOpts.opacity);
		}
		return this;
	},

	// @method bringToFront(): this
	// Brings the layer to the top of all overlays.
	bringToFront: function () {
		if (this._map) {
			L.DomUtil.toFront(this._image);
		}
		return this;
	},

	// @method bringToBack(): this
	// Brings the layer to the bottom of all overlays.
	bringToBack: function () {
		if (this._map) {
			L.DomUtil.toBack(this._image);
		}
		return this;
	},

	// @method setUrl(url: String): this
	// Changes the URL of the image.
	setUrl: function (url) {
		this._url = url;

		if (this._image) {
			this._image.src = url;
		}
		return this;
	},

	setBounds: function (bounds) {
		this._bounds = bounds;

		if (this._map) {
			this._reset();
		}
		return this;
	},

	getAttribution: function () {
		return this.options.attribution;
	},

	getEvents: function () {
		var events = {
			zoom: this._reset,
			viewreset: this._reset
		};

		if (this._zoomAnimated) {
			events.zoomanim = this._animateZoom;
		}

		return events;
	},

	getBounds: function () {
		return this._bounds;
	},

	getElement: function () {
		return this._image;
	},

	_initImage: function () {
		var img = this._image = L.DomUtil.create('img',
				'leaflet-image-layer ' + (this._zoomAnimated ? 'leaflet-zoom-animated' : ''));

		img.onselectstart = L.Util.falseFn;
		img.onmousemove = L.Util.falseFn;

		img.onload = L.bind(this.fire, this, 'load');

		if (this.options.crossOrigin) {
			img.crossOrigin = '';
		}

		img.src = this._url;
		img.alt = this.options.alt;
	},

	_animateZoom: function (e) {
		var scale = this._map.getZoomScale(e.zoom),
		    offset = this._map._latLngToNewLayerPoint(this._bounds.getNorthWest(), e.zoom, e.center);

		L.DomUtil.setTransform(this._image, offset, scale);
	},

	_reset: function () {
		var image = this._image,
		    bounds = new L.Bounds(
		        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
		        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
		    size = bounds.getSize();

		L.DomUtil.setPosition(image, bounds.min);

		image.style.width  = size.x + 'px';
		image.style.height = size.y + 'px';
	},

	_updateOpacity: function () {
		L.DomUtil.setOpacity(this._image, this.options.opacity);
	}
});

// @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
// Instantiates an image overlay object given the URL of the image and the
// geographical bounds it is tied to.
L.imageOverlay = function (url, bounds, options) {
	return new L.ImageOverlay(url, bounds, options);
};

/*
 * @class Icon
 * @aka L.Icon
 * @inherits Layer
 *
 * Represents an icon to provide when creating a marker.
 *
 * @example
 *
 * ```js
 * var myIcon = L.icon({
 *     iconUrl: 'my-icon.png',
 *     iconRetinaUrl: 'my-icon@2x.png',
 *     iconSize: [38, 95],
 *     iconAnchor: [22, 94],
 *     popupAnchor: [-3, -76],
 *     shadowUrl: 'my-icon-shadow.png',
 *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
 *     shadowSize: [68, 95],
 *     shadowAnchor: [22, 94]
 * });
 *
 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
 * ```
 *
 * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
 *
 */

L.Icon = L.Class.extend({

	/* @section
	 * @aka Icon options
	 *
	 * @option iconUrl: String = null
	 * **(required)** The URL to the icon image (absolute or relative to your script path).
	 *
	 * @option iconRetinaUrl: String = null
	 * The URL to a retina sized version of the icon image (absolute or relative to your
	 * script path). Used for Retina screen devices.
	 *
	 * @option iconSize: Point = null
	 * Size of the icon image in pixels.
	 *
	 * @option iconAnchor: Point = null
	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
	 * will be aligned so that this point is at the marker's geographical location. Centered
	 * by default if size is specified, also can be set in CSS with negative margins.
	 *
	 * @option popupAnchor: Point = null
	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
	 *
	 * @option shadowUrl: String = null
	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
	 *
	 * @option shadowRetinaUrl: String = null
	 *
	 * @option shadowSize: Point = null
	 * Size of the shadow image in pixels.
	 *
	 * @option shadowAnchor: Point = null
	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
	 * as iconAnchor if not specified).
	 *
	 * @option className: String = ''
	 * A custom class name to assign to both icon and shadow images. Empty by default.
	 */

	initialize: function (options) {
		L.setOptions(this, options);
	},

	// @method createIcon(oldIcon?: HTMLElement): HTMLElement
	// Called internally when the icon has to be shown, returns a `<img>` HTML element
	// styled according to the options.
	createIcon: function (oldIcon) {
		return this._createIcon('icon', oldIcon);
	},

	// @method createShadow(oldIcon?: HTMLElement): HTMLElement
	// As `createIcon`, but for the shadow beneath it.
	createShadow: function (oldIcon) {
		return this._createIcon('shadow', oldIcon);
	},

	_createIcon: function (name, oldIcon) {
		var src = this._getIconUrl(name);

		if (!src) {
			if (name === 'icon') {
				throw new Error('iconUrl not set in Icon options (see the docs).');
			}
			return null;
		}

		var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
		this._setIconStyles(img, name);

		return img;
	},

	_setIconStyles: function (img, name) {
		var options = this.options;
		var sizeOption = options[name + 'Size'];

		if (typeof sizeOption === 'number') {
			sizeOption = [sizeOption, sizeOption];
		}

		var size = L.point(sizeOption),
		    anchor = L.point(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
		            size && size.divideBy(2, true));

		img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');

		if (anchor) {
			img.style.marginLeft = (-anchor.x) + 'px';
			img.style.marginTop  = (-anchor.y) + 'px';
		}

		if (size) {
			img.style.width  = size.x + 'px';
			img.style.height = size.y + 'px';
		}
	},

	_createImg: function (src, el) {
		el = el || document.createElement('img');
		el.src = src;
		return el;
	},

	_getIconUrl: function (name) {
		return L.Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
	}
});


// @factory L.icon(options: Icon options)
// Creates an icon instance with the given options.
L.icon = function (options) {
	return new L.Icon(options);
};

/*
 * @miniclass Icon.Default (Icon)
 * @aka L.Icon.Default
 * @section
 *
 * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
 * no icon is specified. Points to the blue marker image distributed with Leaflet
 * releases.
 *
 * In order to change the default icon, just change the properties of `L.Icon.Default.prototype.options`
 * (which is a set of `Icon options`).
 */

L.Icon.Default = L.Icon.extend({

	options: {
		iconUrl:       'marker-icon.png',
		iconRetinaUrl: 'marker-icon-2x.png',
		shadowUrl:     'marker-shadow.png',
		iconSize:    [25, 41],
		iconAnchor:  [12, 41],
		popupAnchor: [1, -34],
		tooltipAnchor: [16, -28],
		shadowSize:  [41, 41]
	},

	_getIconUrl: function (name) {
		if (!L.Icon.Default.imagePath) {	// Deprecated, backwards-compatibility only
			L.Icon.Default.imagePath = this._detectIconPath();
		}

		// @option imagePath: String
		// `L.Icon.Default` will try to auto-detect the absolute location of the
		// blue icon images. If you are placing these images in a non-standard
		// way, set this option to point to the right absolute path.
		return (this.options.imagePath || L.Icon.Default.imagePath) + L.Icon.prototype._getIconUrl.call(this, name);
	},

	_detectIconPath: function () {
		var el = L.DomUtil.create('div',  'leaflet-default-icon-path', document.body);
		var path = L.DomUtil.getStyle(el, 'background-image') ||
		           L.DomUtil.getStyle(el, 'backgroundImage');	// IE8

		document.body.removeChild(el);

		return path.indexOf('url') === 0 ?
			path.replace(/^url\([\"\']?/, '').replace(/marker-icon\.png[\"\']?\)$/, '') : '';
	}
});

/*
 * @class Marker
 * @inherits Interactive layer
 * @aka L.Marker
 * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
 *
 * @example
 *
 * ```js
 * L.marker([50.5, 30.5]).addTo(map);
 * ```
 */

L.Marker = L.Layer.extend({

	// @section
	// @aka Marker options
	options: {
		// @option icon: Icon = *
		// Icon class to use for rendering the marker. See [Icon documentation](#L.Icon) for details on how to customize the marker icon. If not specified, a new `L.Icon.Default` is used.
		icon: new L.Icon.Default(),

		// Option inherited from "Interactive layer" abstract class
		interactive: true,

		// @option draggable: Boolean = false
		// Whether the marker is draggable with mouse/touch or not.
		draggable: false,

		// @option keyboard: Boolean = true
		// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
		keyboard: true,

		// @option title: String = ''
		// Text for the browser tooltip that appear on marker hover (no tooltip by default).
		title: '',

		// @option alt: String = ''
		// Text for the `alt` attribute of the icon image (useful for accessibility).
		alt: '',

		// @option zIndexOffset: Number = 0
		// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
		zIndexOffset: 0,

		// @option opacity: Number = 1.0
		// The opacity of the marker.
		opacity: 1,

		// @option riseOnHover: Boolean = false
		// If `true`, the marker will get on top of others when you hover the mouse over it.
		riseOnHover: false,

		// @option riseOffset: Number = 250
		// The z-index offset used for the `riseOnHover` feature.
		riseOffset: 250,

		// @option pane: String = 'markerPane'
		// `Map pane` where the markers icon will be added.
		pane: 'markerPane',

		// FIXME: shadowPane is no longer a valid option
		nonBubblingEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu']
	},

	/* @section
	 *
	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
	 */

	initialize: function (latlng, options) {
		L.setOptions(this, options);
		this._latlng = L.latLng(latlng);
	},

	onAdd: function (map) {
		this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;

		if (this._zoomAnimated) {
			map.on('zoomanim', this._animateZoom, this);
		}

		this._initIcon();
		this.update();
	},

	onRemove: function (map) {
		if (this.dragging && this.dragging.enabled()) {
			this.options.draggable = true;
			this.dragging.removeHooks();
		}

		if (this._zoomAnimated) {
			map.off('zoomanim', this._animateZoom, this);
		}

		this._removeIcon();
		this._removeShadow();
	},

	getEvents: function () {
		return {
			zoom: this.update,
			viewreset: this.update
		};
	},

	// @method getLatLng: LatLng
	// Returns the current geographical position of the marker.
	getLatLng: function () {
		return this._latlng;
	},

	// @method setLatLng(latlng: LatLng): this
	// Changes the marker position to the given point.
	setLatLng: function (latlng) {
		var oldLatLng = this._latlng;
		this._latlng = L.latLng(latlng);
		this.update();

		// @event move: Event
		// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
		return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
	},

	// @method setZIndexOffset(offset: Number): this
	// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
	setZIndexOffset: function (offset) {
		this.options.zIndexOffset = offset;
		return this.update();
	},

	// @method setIcon(icon: Icon): this
	// Changes the marker icon.
	setIcon: function (icon) {

		this.options.icon = icon;

		if (this._map) {
			this._initIcon();
			this.update();
		}

		if (this._popup) {
			this.bindPopup(this._popup, this._popup.options);
		}

		return this;
	},

	getElement: function () {
		return this._icon;
	},

	update: function () {

		if (this._icon) {
			var pos = this._map.latLngToLayerPoint(this._latlng).round();
			this._setPos(pos);
		}

		return this;
	},

	_initIcon: function () {
		var options = this.options,
		    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');

		var icon = options.icon.createIcon(this._icon),
		    addIcon = false;

		// if we're not reusing the icon, remove the old one and init new one
		if (icon !== this._icon) {
			if (this._icon) {
				this._removeIcon();
			}
			addIcon = true;

			if (options.title) {
				icon.title = options.title;
			}
			if (options.alt) {
				icon.alt = options.alt;
			}
		}

		L.DomUtil.addClass(icon, classToAdd);

		if (options.keyboard) {
			icon.tabIndex = '0';
		}

		this._icon = icon;

		if (options.riseOnHover) {
			this.on({
				mouseover: this._bringToFront,
				mouseout: this._resetZIndex
			});
		}

		var newShadow = options.icon.createShadow(this._shadow),
		    addShadow = false;

		if (newShadow !== this._shadow) {
			this._removeShadow();
			addShadow = true;
		}

		if (newShadow) {
			L.DomUtil.addClass(newShadow, classToAdd);
		}
		this._shadow = newShadow;


		if (options.opacity < 1) {
			this._updateOpacity();
		}


		if (addIcon) {
			this.getPane().appendChild(this._icon);
		}
		this._initInteraction();
		if (newShadow && addShadow) {
			this.getPane('shadowPane').appendChild(this._shadow);
		}
	},

	_removeIcon: function () {
		if (this.options.riseOnHover) {
			this.off({
				mouseover: this._bringToFront,
				mouseout: this._resetZIndex
			});
		}

		L.DomUtil.remove(this._icon);
		this.removeInteractiveTarget(this._icon);

		this._icon = null;
	},

	_removeShadow: function () {
		if (this._shadow) {
			L.DomUtil.remove(this._shadow);
		}
		this._shadow = null;
	},

	_setPos: function (pos) {
		L.DomUtil.setPosition(this._icon, pos);

		if (this._shadow) {
			L.DomUtil.setPosition(this._shadow, pos);
		}

		this._zIndex = pos.y + this.options.zIndexOffset;

		this._resetZIndex();
	},

	_updateZIndex: function (offset) {
		this._icon.style.zIndex = this._zIndex + offset;
	},

	_animateZoom: function (opt) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();

		this._setPos(pos);
	},

	_initInteraction: function () {

		if (!this.options.interactive) { return; }

		L.DomUtil.addClass(this._icon, 'leaflet-interactive');

		this.addInteractiveTarget(this._icon);

		if (L.Handler.MarkerDrag) {
			var draggable = this.options.draggable;
			if (this.dragging) {
				draggable = this.dragging.enabled();
				this.dragging.disable();
			}

			this.dragging = new L.Handler.MarkerDrag(this);

			if (draggable) {
				this.dragging.enable();
			}
		}
	},

	// @method setOpacity(opacity: Number): this
	// Changes the opacity of the marker.
	setOpacity: function (opacity) {
		this.options.opacity = opacity;
		if (this._map) {
			this._updateOpacity();
		}

		return this;
	},

	_updateOpacity: function () {
		var opacity = this.options.opacity;

		L.DomUtil.setOpacity(this._icon, opacity);

		if (this._shadow) {
			L.DomUtil.setOpacity(this._shadow, opacity);
		}
	},

	_bringToFront: function () {
		this._updateZIndex(this.options.riseOffset);
	},

	_resetZIndex: function () {
		this._updateZIndex(0);
	}
});


// factory L.marker(latlng: LatLng, options? : Marker options)

// @factory L.marker(latlng: LatLng, options? : Marker options)
// Instantiates a Marker object given a geographical point and optionally an options object.
L.marker = function (latlng, options) {
	return new L.Marker(latlng, options);
};

/*
 * @class DivIcon
 * @aka L.DivIcon
 * @inherits Icon
 *
 * Represents a lightweight icon for markers that uses a simple `<div>`
 * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
 *
 * @example
 * ```js
 * var myIcon = L.divIcon({className: 'my-div-icon'});
 * // you can set .my-div-icon styles in CSS
 *
 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
 * ```
 *
 * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
 */

L.DivIcon = L.Icon.extend({
	options: {
		// @section
		// @aka DivIcon options
		iconSize: [12, 12], // also can be set through CSS

		// iconAnchor: (Point),
		// popupAnchor: (Point),

		// @option html: String = ''
		// Custom HTML code to put inside the div element, empty by default.
		html: false,

		// @option bgPos: Point = [0, 0]
		// Optional relative position of the background, in pixels
		bgPos: null,

		className: 'leaflet-div-icon'
	},

	createIcon: function (oldIcon) {
		var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
		    options = this.options;

		div.innerHTML = options.html !== false ? options.html : '';

		if (options.bgPos) {
			var bgPos = L.point(options.bgPos);
			div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
		}
		this._setIconStyles(div, 'icon');

		return div;
	},

	createShadow: function () {
		return null;
	}
});

// @factory L.divIcon(options: DivIcon options)
// Creates a `DivIcon` instance with the given options.
L.divIcon = function (options) {
	return new L.DivIcon(options);
};

/*
 * @class DivOverlay
 * @inherits Layer
 * @aka L.DivOverlay
 * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
 */

// @namespace DivOverlay
L.DivOverlay = L.Layer.extend({

	// @section
	// @aka DivOverlay options
	options: {
		// @option offset: Point = Point(0, 7)
		// The offset of the popup position. Useful to control the anchor
		// of the popup when opening it on some overlays.
		offset: [0, 7],

		// @option className: String = ''
		// A custom CSS class name to assign to the popup.
		className: '',

		// @option pane: String = 'popupPane'
		// `Map pane` where the popup will be added.
		pane: 'popupPane'
	},

	initialize: function (options, source) {
		L.setOptions(this, options);

		this._source = source;
	},

	onAdd: function (map) {
		this._zoomAnimated = map._zoomAnimated;

		if (!this._container) {
			this._initLayout();
		}

		if (map._fadeAnimated) {
			L.DomUtil.setOpacity(this._container, 0);
		}

		clearTimeout(this._removeTimeout);
		this.getPane().appendChild(this._container);
		this.update();

		if (map._fadeAnimated) {
			L.DomUtil.setOpacity(this._container, 1);
		}

		this.bringToFront();
	},

	onRemove: function (map) {
		if (map._fadeAnimated) {
			L.DomUtil.setOpacity(this._container, 0);
			this._removeTimeout = setTimeout(L.bind(L.DomUtil.remove, L.DomUtil, this._container), 200);
		} else {
			L.DomUtil.remove(this._container);
		}
	},

	// @namespace Popup
	// @method getLatLng: LatLng
	// Returns the geographical point of popup.
	getLatLng: function () {
		return this._latlng;
	},

	// @method setLatLng(latlng: LatLng): this
	// Sets the geographical point where the popup will open.
	setLatLng: function (latlng) {
		this._latlng = L.latLng(latlng);
		if (this._map) {
			this._updatePosition();
			this._adjustPan();
		}
		return this;
	},

	// @method getContent: String|HTMLElement
	// Returns the content of the popup.
	getContent: function () {
		return this._content;
	},

	// @method setContent(htmlContent: String|HTMLElement|Function): this
	// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
	setContent: function (content) {
		this._content = content;
		this.update();
		return this;
	},

	// @method getElement: String|HTMLElement
	// Alias for [getContent()](#popup-getcontent)
	getElement: function () {
		return this._container;
	},

	// @method update: null
	// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
	update: function () {
		if (!this._map) { return; }

		this._container.style.visibility = 'hidden';

		this._updateContent();
		this._updateLayout();
		this._updatePosition();

		this._container.style.visibility = '';

		this._adjustPan();
	},

	getEvents: function () {
		var events = {
			zoom: this._updatePosition,
			viewreset: this._updatePosition
		};

		if (this._zoomAnimated) {
			events.zoomanim = this._animateZoom;
		}
		return events;
	},

	// @method isOpen: Boolean
	// Returns `true` when the popup is visible on the map.
	isOpen: function () {
		return !!this._map && this._map.hasLayer(this);
	},

	// @method bringToFront: this
	// Brings this popup in front of other popups (in the same map pane).
	bringToFront: function () {
		if (this._map) {
			L.DomUtil.toFront(this._container);
		}
		return this;
	},

	// @method bringToBack: this
	// Brings this popup to the back of other popups (in the same map pane).
	bringToBack: function () {
		if (this._map) {
			L.DomUtil.toBack(this._container);
		}
		return this;
	},

	_updateContent: function () {
		if (!this._content) { return; }

		var node = this._contentNode;
		var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;

		if (typeof content === 'string') {
			node.innerHTML = content;
		} else {
			while (node.hasChildNodes()) {
				node.removeChild(node.firstChild);
			}
			node.appendChild(content);
		}
		this.fire('contentupdate');
	},

	_updatePosition: function () {
		if (!this._map) { return; }

		var pos = this._map.latLngToLayerPoint(this._latlng),
		    offset = L.point(this.options.offset),
		    anchor = this._getAnchor();

		if (this._zoomAnimated) {
			L.DomUtil.setPosition(this._container, pos.add(anchor));
		} else {
			offset = offset.add(pos).add(anchor);
		}

		var bottom = this._containerBottom = -offset.y,
		    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;

		// bottom position the popup in case the height of the popup changes (images loading etc)
		this._container.style.bottom = bottom + 'px';
		this._container.style.left = left + 'px';
	},

	_getAnchor: function () {
		return [0, 0];
	}

});

/*
 * @class Popup
 * @inherits DivOverlay
 * @aka L.Popup
 * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
 * open popups while making sure that only one popup is open at one time
 * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
 *
 * @example
 *
 * If you want to just bind a popup to marker click and then open it, it's really easy:
 *
 * ```js
 * marker.bindPopup(popupContent).openPopup();
 * ```
 * Path overlays like polylines also have a `bindPopup` method.
 * Here's a more complicated way to open a popup on a map:
 *
 * ```js
 * var popup = L.popup()
 * 	.setLatLng(latlng)
 * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
 * 	.openOn(map);
 * ```
 */


// @namespace Popup
L.Popup = L.DivOverlay.extend({

	// @section
	// @aka Popup options
	options: {
		// @option maxWidth: Number = 300
		// Max width of the popup, in pixels.
		maxWidth: 300,

		// @option minWidth: Number = 50
		// Min width of the popup, in pixels.
		minWidth: 50,

		// @option maxHeight: Number = null
		// If set, creates a scrollable container of the given height
		// inside a popup if its content exceeds it.
		maxHeight: null,

		// @option autoPan: Boolean = true
		// Set it to `false` if you don't want the map to do panning animation
		// to fit the opened popup.
		autoPan: true,

		// @option autoPanPaddingTopLeft: Point = null
		// The margin between the popup and the top left corner of the map
		// view after autopanning was performed.
		autoPanPaddingTopLeft: null,

		// @option autoPanPaddingBottomRight: Point = null
		// The margin between the popup and the bottom right corner of the map
		// view after autopanning was performed.
		autoPanPaddingBottomRight: null,

		// @option autoPanPadding: Point = Point(5, 5)
		// Equivalent of setting both top left and bottom right autopan padding to the same value.
		autoPanPadding: [5, 5],

		// @option keepInView: Boolean = false
		// Set it to `true` if you want to prevent users from panning the popup
		// off of the screen while it is open.
		keepInView: false,

		// @option closeButton: Boolean = true
		// Controls the presence of a close button in the popup.
		closeButton: true,

		// @option autoClose: Boolean = true
		// Set it to `false` if you want to override the default behavior of
		// the popup closing when user clicks the map (set globally by
		// the Map's [closePopupOnClick](#map-closepopuponclick) option).
		autoClose: true,

		// @option className: String = ''
		// A custom CSS class name to assign to the popup.
		className: ''
	},

	// @namespace Popup
	// @method openOn(map: Map): this
	// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
	openOn: function (map) {
		map.openPopup(this);
		return this;
	},

	onAdd: function (map) {
		L.DivOverlay.prototype.onAdd.call(this, map);

		// @namespace Map
		// @section Popup events
		// @event popupopen: PopupEvent
		// Fired when a popup is opened in the map
		map.fire('popupopen', {popup: this});

		if (this._source) {
			// @namespace Layer
			// @section Popup events
			// @event popupopen: PopupEvent
			// Fired when a popup bound to this layer is opened
			this._source.fire('popupopen', {popup: this}, true);
			// For non-path layers, we toggle the popup when clicking
			// again the layer, so prevent the map to reopen it.
			if (!(this._source instanceof L.Path)) {
				this._source.on('preclick', L.DomEvent.stopPropagation);
			}
		}
	},

	onRemove: function (map) {
		L.DivOverlay.prototype.onRemove.call(this, map);

		// @namespace Map
		// @section Popup events
		// @event popupclose: PopupEvent
		// Fired when a popup in the map is closed
		map.fire('popupclose', {popup: this});

		if (this._source) {
			// @namespace Layer
			// @section Popup events
			// @event popupclose: PopupEvent
			// Fired when a popup bound to this layer is closed
			this._source.fire('popupclose', {popup: this}, true);
			if (!(this._source instanceof L.Path)) {
				this._source.off('preclick', L.DomEvent.stopPropagation);
			}
		}
	},

	getEvents: function () {
		var events = L.DivOverlay.prototype.getEvents.call(this);

		if ('closeOnClick' in this.options ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
			events.preclick = this._close;
		}

		if (this.options.keepInView) {
			events.moveend = this._adjustPan;
		}

		return events;
	},

	_close: function () {
		if (this._map) {
			this._map.closePopup(this);
		}
	},

	_initLayout: function () {
		var prefix = 'leaflet-popup',
		    container = this._container = L.DomUtil.create('div',
			prefix + ' ' + (this.options.className || '') +
			' leaflet-zoom-animated');

		if (this.options.closeButton) {
			var closeButton = this._closeButton = L.DomUtil.create('a', prefix + '-close-button', container);
			closeButton.href = '#close';
			closeButton.innerHTML = '&#215;';

			L.DomEvent.on(closeButton, 'click', this._onCloseButtonClick, this);
		}

		var wrapper = this._wrapper = L.DomUtil.create('div', prefix + '-content-wrapper', container);
		this._contentNode = L.DomUtil.create('div', prefix + '-content', wrapper);

		L.DomEvent
			.disableClickPropagation(wrapper)
			.disableScrollPropagation(this._contentNode)
			.on(wrapper, 'contextmenu', L.DomEvent.stopPropagation);

		this._tipContainer = L.DomUtil.create('div', prefix + '-tip-container', container);
		this._tip = L.DomUtil.create('div', prefix + '-tip', this._tipContainer);
	},

	_updateLayout: function () {
		var container = this._contentNode,
		    style = container.style;

		style.width = '';
		style.whiteSpace = 'nowrap';

		var width = container.offsetWidth;
		width = Math.min(width, this.options.maxWidth);
		width = Math.max(width, this.options.minWidth);

		style.width = (width + 1) + 'px';
		style.whiteSpace = '';

		style.height = '';

		var height = container.offsetHeight,
		    maxHeight = this.options.maxHeight,
		    scrolledClass = 'leaflet-popup-scrolled';

		if (maxHeight && height > maxHeight) {
			style.height = maxHeight + 'px';
			L.DomUtil.addClass(container, scrolledClass);
		} else {
			L.DomUtil.removeClass(container, scrolledClass);
		}

		this._containerWidth = this._container.offsetWidth;
	},

	_animateZoom: function (e) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
		    anchor = this._getAnchor();
		L.DomUtil.setPosition(this._container, pos.add(anchor));
	},

	_adjustPan: function () {
		if (!this.options.autoPan || (this._map._panAnim && this._map._panAnim._inProgress)) { return; }

		var map = this._map,
		    marginBottom = parseInt(L.DomUtil.getStyle(this._container, 'marginBottom'), 10) || 0,
		    containerHeight = this._container.offsetHeight + marginBottom,
		    containerWidth = this._containerWidth,
		    layerPos = new L.Point(this._containerLeft, -containerHeight - this._containerBottom);

		layerPos._add(L.DomUtil.getPosition(this._container));

		var containerPos = map.layerPointToContainerPoint(layerPos),
		    padding = L.point(this.options.autoPanPadding),
		    paddingTL = L.point(this.options.autoPanPaddingTopLeft || padding),
		    paddingBR = L.point(this.options.autoPanPaddingBottomRight || padding),
		    size = map.getSize(),
		    dx = 0,
		    dy = 0;

		if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
			dx = containerPos.x + containerWidth - size.x + paddingBR.x;
		}
		if (containerPos.x - dx - paddingTL.x < 0) { // left
			dx = containerPos.x - paddingTL.x;
		}
		if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
			dy = containerPos.y + containerHeight - size.y + paddingBR.y;
		}
		if (containerPos.y - dy - paddingTL.y < 0) { // top
			dy = containerPos.y - paddingTL.y;
		}

		// @namespace Map
		// @section Popup events
		// @event autopanstart: Event
		// Fired when the map starts autopanning when opening a popup.
		if (dx || dy) {
			map
			    .fire('autopanstart')
			    .panBy([dx, dy]);
		}
	},

	_onCloseButtonClick: function (e) {
		this._close();
		L.DomEvent.stop(e);
	},

	_getAnchor: function () {
		// Where should we anchor the popup on the source layer?
		return L.point(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
	}

});

// @namespace Popup
// @factory L.popup(options?: Popup options, source?: Layer)
// Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
L.popup = function (options, source) {
	return new L.Popup(options, source);
};


/* @namespace Map
 * @section Interaction Options
 * @option closePopupOnClick: Boolean = true
 * Set it to `false` if you don't want popups to close when user clicks the map.
 */
L.Map.mergeOptions({
	closePopupOnClick: true
});


// @namespace Map
// @section Methods for Layers and Controls
L.Map.include({
	// @method openPopup(popup: Popup): this
	// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
	// @alternative
	// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
	// Creates a popup with the specified content and options and opens it in the given point on a map.
	openPopup: function (popup, latlng, options) {
		if (!(popup instanceof L.Popup)) {
			popup = new L.Popup(options).setContent(popup);
		}

		if (latlng) {
			popup.setLatLng(latlng);
		}

		if (this.hasLayer(popup)) {
			return this;
		}

		if (this._popup && this._popup.options.autoClose) {
			this.closePopup();
		}

		this._popup = popup;
		return this.addLayer(popup);
	},

	// @method closePopup(popup?: Popup): this
	// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
	closePopup: function (popup) {
		if (!popup || popup === this._popup) {
			popup = this._popup;
			this._popup = null;
		}
		if (popup) {
			this.removeLayer(popup);
		}
		return this;
	}
});

/*
 * @namespace Layer
 * @section Popup methods example
 *
 * All layers share a set of methods convenient for binding popups to it.
 *
 * ```js
 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
 * layer.openPopup();
 * layer.closePopup();
 * ```
 *
 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
 */

// @section Popup methods
L.Layer.include({

	// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
	// Binds a popup to the layer with the passed `content` and sets up the
	// neccessary event listeners. If a `Function` is passed it will receive
	// the layer as the first argument and should return a `String` or `HTMLElement`.
	bindPopup: function (content, options) {

		if (content instanceof L.Popup) {
			L.setOptions(content, options);
			this._popup = content;
			content._source = this;
		} else {
			if (!this._popup || options) {
				this._popup = new L.Popup(options, this);
			}
			this._popup.setContent(content);
		}

		if (!this._popupHandlersAdded) {
			this.on({
				click: this._openPopup,
				remove: this.closePopup,
				move: this._movePopup
			});
			this._popupHandlersAdded = true;
		}

		return this;
	},

	// @method unbindPopup(): this
	// Removes the popup previously bound with `bindPopup`.
	unbindPopup: function () {
		if (this._popup) {
			this.off({
				click: this._openPopup,
				remove: this.closePopup,
				move: this._movePopup
			});
			this._popupHandlersAdded = false;
			this._popup = null;
		}
		return this;
	},

	// @method openPopup(latlng?: LatLng): this
	// Opens the bound popup at the specificed `latlng` or at the default popup anchor if no `latlng` is passed.
	openPopup: function (layer, latlng) {
		if (!(layer instanceof L.Layer)) {
			latlng = layer;
			layer = this;
		}

		if (layer instanceof L.FeatureGroup) {
			for (var id in this._layers) {
				layer = this._layers[id];
				break;
			}
		}

		if (!latlng) {
			latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
		}

		if (this._popup && this._map) {
			// set popup source to this layer
			this._popup._source = layer;

			// update the popup (content, layout, ect...)
			this._popup.update();

			// open the popup on the map
			this._map.openPopup(this._popup, latlng);
		}

		return this;
	},

	// @method closePopup(): this
	// Closes the popup bound to this layer if it is open.
	closePopup: function () {
		if (this._popup) {
			this._popup._close();
		}
		return this;
	},

	// @method togglePopup(): this
	// Opens or closes the popup bound to this layer depending on its current state.
	togglePopup: function (target) {
		if (this._popup) {
			if (this._popup._map) {
				this.closePopup();
			} else {
				this.openPopup(target);
			}
		}
		return this;
	},

	// @method isPopupOpen(): boolean
	// Returns `true` if the popup bound to this layer is currently open.
	isPopupOpen: function () {
		return this._popup.isOpen();
	},

	// @method setPopupContent(content: String|HTMLElement|Popup): this
	// Sets the content of the popup bound to this layer.
	setPopupContent: function (content) {
		if (this._popup) {
			this._popup.setContent(content);
		}
		return this;
	},

	// @method getPopup(): Popup
	// Returns the popup bound to this layer.
	getPopup: function () {
		return this._popup;
	},

	_openPopup: function (e) {
		var layer = e.layer || e.target;

		if (!this._popup) {
			return;
		}

		if (!this._map) {
			return;
		}

		// prevent map click
		L.DomEvent.stop(e);

		// if this inherits from Path its a vector and we can just
		// open the popup at the new location
		if (layer instanceof L.Path) {
			this.openPopup(e.layer || e.target, e.latlng);
			return;
		}

		// otherwise treat it like a marker and figure out
		// if we should toggle it open/closed
		if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
			this.closePopup();
		} else {
			this.openPopup(layer, e.latlng);
		}
	},

	_movePopup: function (e) {
		this._popup.setLatLng(e.latlng);
	}
});

/*
 * Popup extension to L.Marker, adding popup-related methods.
 */

L.Marker.include({
	_getPopupAnchor: function () {
		return this.options.icon.options.popupAnchor || [0, 0];
	}
});

/*
 * @class Tooltip
 * @inherits DivOverlay
 * @aka L.Tooltip
 * Used to display small texts on top of map layers.
 *
 * @example
 *
 * ```js
 * marker.bindTooltip("my tooltip text").openTooltip();
 * ```
 * Note about tooltip offset. Leaflet takes two options in consideration
 * for computing tooltip offseting:
 * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
 *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
 *   move it to the bottom. Negatives will move to the left and top.
 * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
 *   should adapt this value if you use a custom icon.
 */


// @namespace Tooltip
L.Tooltip = L.DivOverlay.extend({

	// @section
	// @aka Tooltip options
	options: {
		// @option pane: String = 'tooltipPane'
		// `Map pane` where the tooltip will be added.
		pane: 'tooltipPane',

		// @option offset: Point = Point(0, 0)
		// Optional offset of the tooltip position.
		offset: [0, 0],

		// @option direction: String = 'auto'
		// Direction where to open the tooltip. Possible values are: `right`, `left`,
		// `top`, `bottom`, `center`, `auto`.
		// `auto` will dynamicaly switch between `right` and `left` according to the tooltip
		// position on the map.
		direction: 'auto',

		// @option permanent: Boolean = false
		// Whether to open the tooltip permanently or only on mouseover.
		permanent: false,

		// @option sticky: Boolean = false
		// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
		sticky: false,

		// @option interactive: Boolean = false
		// If true, the tooltip will listen to the feature events.
		interactive: false,

		// @option opacity: Number = 0.9
		// Tooltip container opacity.
		opacity: 0.9
	},

	onAdd: function (map) {
		L.DivOverlay.prototype.onAdd.call(this, map);
		this.setOpacity(this.options.opacity);

		// @namespace Map
		// @section Tooltip events
		// @event tooltipopen: TooltipEvent
		// Fired when a tooltip is opened in the map.
		map.fire('tooltipopen', {tooltip: this});

		if (this._source) {
			// @namespace Layer
			// @section Tooltip events
			// @event tooltipopen: TooltipEvent
			// Fired when a tooltip bound to this layer is opened.
			this._source.fire('tooltipopen', {tooltip: this}, true);
		}
	},

	onRemove: function (map) {
		L.DivOverlay.prototype.onRemove.call(this, map);

		// @namespace Map
		// @section Tooltip events
		// @event tooltipclose: TooltipEvent
		// Fired when a tooltip in the map is closed.
		map.fire('tooltipclose', {tooltip: this});

		if (this._source) {
			// @namespace Layer
			// @section Tooltip events
			// @event tooltipclose: TooltipEvent
			// Fired when a tooltip bound to this layer is closed.
			this._source.fire('tooltipclose', {tooltip: this}, true);
		}
	},

	getEvents: function () {
		var events = L.DivOverlay.prototype.getEvents.call(this);

		if (L.Browser.touch && !this.options.permanent) {
			events.preclick = this._close;
		}

		return events;
	},

	_close: function () {
		if (this._map) {
			this._map.closeTooltip(this);
		}
	},

	_initLayout: function () {
		var prefix = 'leaflet-tooltip',
		    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');

		this._contentNode = this._container = L.DomUtil.create('div', className);
	},

	_updateLayout: function () {},

	_adjustPan: function () {},

	_setPosition: function (pos) {
		var map = this._map,
		    container = this._container,
		    centerPoint = map.latLngToContainerPoint(map.getCenter()),
		    tooltipPoint = map.layerPointToContainerPoint(pos),
		    direction = this.options.direction,
		    tooltipWidth = container.offsetWidth,
		    tooltipHeight = container.offsetHeight,
		    offset = L.point(this.options.offset),
		    anchor = this._getAnchor();

		if (direction === 'top') {
			pos = pos.add(L.point(-tooltipWidth / 2 + offset.x, -tooltipHeight + offset.y + anchor.y));
		} else if (direction === 'bottom') {
			pos = pos.subtract(L.point(tooltipWidth / 2 - offset.x, -offset.y));
		} else if (direction === 'center') {
			pos = pos.subtract(L.point(tooltipWidth / 2 + offset.x, tooltipHeight / 2 - anchor.y + offset.y));
		} else if (direction === 'right' || direction === 'auto' && tooltipPoint.x < centerPoint.x) {
			direction = 'right';
			pos = pos.add([offset.x + anchor.x, anchor.y - tooltipHeight / 2 + offset.y]);
		} else {
			direction = 'left';
			pos = pos.subtract(L.point(tooltipWidth + anchor.x - offset.x, tooltipHeight / 2 - anchor.y - offset.y));
		}

		L.DomUtil.removeClass(container, 'leaflet-tooltip-right');
		L.DomUtil.removeClass(container, 'leaflet-tooltip-left');
		L.DomUtil.removeClass(container, 'leaflet-tooltip-top');
		L.DomUtil.removeClass(container, 'leaflet-tooltip-bottom');
		L.DomUtil.addClass(container, 'leaflet-tooltip-' + direction);
		L.DomUtil.setPosition(container, pos);
	},

	_updatePosition: function () {
		var pos = this._map.latLngToLayerPoint(this._latlng);
		this._setPosition(pos);
	},

	setOpacity: function (opacity) {
		this.options.opacity = opacity;

		if (this._container) {
			L.DomUtil.setOpacity(this._container, opacity);
		}
	},

	_animateZoom: function (e) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
		this._setPosition(pos);
	},

	_getAnchor: function () {
		// Where should we anchor the tooltip on the source layer?
		return L.point(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
	}

});

// @namespace Tooltip
// @factory L.tooltip(options?: Tooltip options, source?: Layer)
// Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
L.tooltip = function (options, source) {
	return new L.Tooltip(options, source);
};

// @namespace Map
// @section Methods for Layers and Controls
L.Map.include({

	// @method openTooltip(tooltip: Tooltip): this
	// Opens the specified tooltip.
	// @alternative
	// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
	// Creates a tooltip with the specified content and options and open it.
	openTooltip: function (tooltip, latlng, options) {
		if (!(tooltip instanceof L.Tooltip)) {
			tooltip = new L.Tooltip(options).setContent(tooltip);
		}

		if (latlng) {
			tooltip.setLatLng(latlng);
		}

		if (this.hasLayer(tooltip)) {
			return this;
		}

		return this.addLayer(tooltip);
	},

	// @method closeTooltip(tooltip?: Tooltip): this
	// Closes the tooltip given as parameter.
	closeTooltip: function (tooltip) {
		if (tooltip) {
			this.removeLayer(tooltip);
		}
		return this;
	}

});

/*
 * @namespace Layer
 * @section Tooltip methods example
 *
 * All layers share a set of methods convenient for binding tooltips to it.
 *
 * ```js
 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
 * layer.openTooltip();
 * layer.closeTooltip();
 * ```
 */

// @section Tooltip methods
L.Layer.include({

	// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
	// Binds a tooltip to the layer with the passed `content` and sets up the
	// neccessary event listeners. If a `Function` is passed it will receive
	// the layer as the first argument and should return a `String` or `HTMLElement`.
	bindTooltip: function (content, options) {

		if (content instanceof L.Tooltip) {
			L.setOptions(content, options);
			this._tooltip = content;
			content._source = this;
		} else {
			if (!this._tooltip || options) {
				this._tooltip = L.tooltip(options, this);
			}
			this._tooltip.setContent(content);

		}

		this._initTooltipInteractions();

		if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
			this.openTooltip();
		}

		return this;
	},

	// @method unbindTooltip(): this
	// Removes the tooltip previously bound with `bindTooltip`.
	unbindTooltip: function () {
		if (this._tooltip) {
			this._initTooltipInteractions(true);
			this.closeTooltip();
			this._tooltip = null;
		}
		return this;
	},

	_initTooltipInteractions: function (remove) {
		if (!remove && this._tooltipHandlersAdded) { return; }
		var onOff = remove ? 'off' : 'on',
		    events = {
			remove: this.closeTooltip,
			move: this._moveTooltip
		    };
		if (!this._tooltip.options.permanent) {
			events.mouseover = this._openTooltip;
			events.mouseout = this.closeTooltip;
			if (this._tooltip.options.sticky) {
				events.mousemove = this._moveTooltip;
			}
			if (L.Browser.touch) {
				events.click = this._openTooltip;
			}
		} else {
			events.add = this._openTooltip;
		}
		this[onOff](events);
		this._tooltipHandlersAdded = !remove;
	},

	// @method openTooltip(latlng?: LatLng): this
	// Opens the bound tooltip at the specificed `latlng` or at the default tooltip anchor if no `latlng` is passed.
	openTooltip: function (layer, latlng) {
		if (!(layer instanceof L.Layer)) {
			latlng = layer;
			layer = this;
		}

		if (layer instanceof L.FeatureGroup) {
			for (var id in this._layers) {
				layer = this._layers[id];
				break;
			}
		}

		if (!latlng) {
			latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
		}

		if (this._tooltip && this._map) {

			// set tooltip source to this layer
			this._tooltip._source = layer;

			// update the tooltip (content, layout, ect...)
			this._tooltip.update();

			// open the tooltip on the map
			this._map.openTooltip(this._tooltip, latlng);

			// Tooltip container may not be defined if not permanent and never
			// opened.
			if (this._tooltip.options.interactive && this._tooltip._container) {
				L.DomUtil.addClass(this._tooltip._container, 'leaflet-clickable');
				this.addInteractiveTarget(this._tooltip._container);
			}
		}

		return this;
	},

	// @method closeTooltip(): this
	// Closes the tooltip bound to this layer if it is open.
	closeTooltip: function () {
		if (this._tooltip) {
			this._tooltip._close();
			if (this._tooltip.options.interactive && this._tooltip._container) {
				L.DomUtil.removeClass(this._tooltip._container, 'leaflet-clickable');
				this.removeInteractiveTarget(this._tooltip._container);
			}
		}
		return this;
	},

	// @method toggleTooltip(): this
	// Opens or closes the tooltip bound to this layer depending on its current state.
	toggleTooltip: function (target) {
		if (this._tooltip) {
			if (this._tooltip._map) {
				this.closeTooltip();
			} else {
				this.openTooltip(target);
			}
		}
		return this;
	},

	// @method isTooltipOpen(): boolean
	// Returns `true` if the tooltip bound to this layer is currently open.
	isTooltipOpen: function () {
		return this._tooltip.isOpen();
	},

	// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
	// Sets the content of the tooltip bound to this layer.
	setTooltipContent: function (content) {
		if (this._tooltip) {
			this._tooltip.setContent(content);
		}
		return this;
	},

	// @method getTooltip(): Tooltip
	// Returns the tooltip bound to this layer.
	getTooltip: function () {
		return this._tooltip;
	},

	_openTooltip: function (e) {
		var layer = e.layer || e.target;

		if (!this._tooltip || !this._map) {
			return;
		}
		this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
	},

	_moveTooltip: function (e) {
		var latlng = e.latlng, containerPoint, layerPoint;
		if (this._tooltip.options.sticky && e.originalEvent) {
			containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
			layerPoint = this._map.containerPointToLayerPoint(containerPoint);
			latlng = this._map.layerPointToLatLng(layerPoint);
		}
		this._tooltip.setLatLng(latlng);
	}
});

/*
 * Tooltip extension to L.Marker, adding tooltip-related methods.
 */

L.Marker.include({
	_getTooltipAnchor: function () {
		return this.options.icon.options.tooltipAnchor || [0, 0];
	}
});

/*
 * @class LayerGroup
 * @aka L.LayerGroup
 * @inherits Layer
 *
 * Used to group several layers and handle them as one. If you add it to the map,
 * any layers added or removed from the group will be added/removed on the map as
 * well. Extends `Layer`.
 *
 * @example
 *
 * ```js
 * L.layerGroup([marker1, marker2])
 * 	.addLayer(polyline)
 * 	.addTo(map);
 * ```
 */

L.LayerGroup = L.Layer.extend({

	initialize: function (layers) {
		this._layers = {};

		var i, len;

		if (layers) {
			for (i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		}
	},

	// @method addLayer(layer: Layer): this
	// Adds the given layer to the group.
	addLayer: function (layer) {
		var id = this.getLayerId(layer);

		this._layers[id] = layer;

		if (this._map) {
			this._map.addLayer(layer);
		}

		return this;
	},

	// @method removeLayer(layer: Layer): this
	// Removes the given layer from the group.
	// @alternative
	// @method removeLayer(id: Number): this
	// Removes the layer with the given internal ID from the group.
	removeLayer: function (layer) {
		var id = layer in this._layers ? layer : this.getLayerId(layer);

		if (this._map && this._layers[id]) {
			this._map.removeLayer(this._layers[id]);
		}

		delete this._layers[id];

		return this;
	},

	// @method hasLayer(layer: Layer): Boolean
	// Returns `true` if the given layer is currently added to the group.
	hasLayer: function (layer) {
		return !!layer && (layer in this._layers || this.getLayerId(layer) in this._layers);
	},

	// @method clearLayers(): this
	// Removes all the layers from the group.
	clearLayers: function () {
		for (var i in this._layers) {
			this.removeLayer(this._layers[i]);
		}
		return this;
	},

	// @method invoke(methodName: String, …): this
	// Calls `methodName` on every layer contained in this group, passing any
	// additional parameters. Has no effect if the layers contained do not
	// implement `methodName`.
	invoke: function (methodName) {
		var args = Array.prototype.slice.call(arguments, 1),
		    i, layer;

		for (i in this._layers) {
			layer = this._layers[i];

			if (layer[methodName]) {
				layer[methodName].apply(layer, args);
			}
		}

		return this;
	},

	onAdd: function (map) {
		for (var i in this._layers) {
			map.addLayer(this._layers[i]);
		}
	},

	onRemove: function (map) {
		for (var i in this._layers) {
			map.removeLayer(this._layers[i]);
		}
	},

	// @method eachLayer(fn: Function, context?: Object): this
	// Iterates over the layers of the group, optionally specifying context of the iterator function.
	// ```js
	// group.eachLayer(function (layer) {
	// 	layer.bindPopup('Hello');
	// });
	// ```
	eachLayer: function (method, context) {
		for (var i in this._layers) {
			method.call(context, this._layers[i]);
		}
		return this;
	},

	// @method getLayer(id: Number): Layer
	// Returns the layer with the given internal ID.
	getLayer: function (id) {
		return this._layers[id];
	},

	// @method getLayers(): Layer[]
	// Returns an array of all the layers added to the group.
	getLayers: function () {
		var layers = [];

		for (var i in this._layers) {
			layers.push(this._layers[i]);
		}
		return layers;
	},

	// @method setZIndex(zIndex: Number): this
	// Calls `setZIndex` on every layer contained in this group, passing the z-index.
	setZIndex: function (zIndex) {
		return this.invoke('setZIndex', zIndex);
	},

	// @method getLayerId(layer: Layer): Number
	// Returns the internal ID for a layer
	getLayerId: function (layer) {
		return L.stamp(layer);
	}
});


// @factory L.layerGroup(layers: Layer[])
// Create a layer group, optionally given an initial set of layers.
L.layerGroup = function (layers) {
	return new L.LayerGroup(layers);
};

/*
 * @class FeatureGroup
 * @aka L.FeatureGroup
 * @inherits LayerGroup
 *
 * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
 *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
 *  * Events are propagated to the `FeatureGroup`, so if the group has an event
 * handler, it will handle events from any of the layers. This includes mouse events
 * and custom events.
 *  * Has `layeradd` and `layerremove` events
 *
 * @example
 *
 * ```js
 * L.featureGroup([marker1, marker2, polyline])
 * 	.bindPopup('Hello world!')
 * 	.on('click', function() { alert('Clicked on a member of the group!'); })
 * 	.addTo(map);
 * ```
 */

L.FeatureGroup = L.LayerGroup.extend({

	addLayer: function (layer) {
		if (this.hasLayer(layer)) {
			return this;
		}

		layer.addEventParent(this);

		L.LayerGroup.prototype.addLayer.call(this, layer);

		// @event layeradd: LayerEvent
		// Fired when a layer is added to this `FeatureGroup`
		return this.fire('layeradd', {layer: layer});
	},

	removeLayer: function (layer) {
		if (!this.hasLayer(layer)) {
			return this;
		}
		if (layer in this._layers) {
			layer = this._layers[layer];
		}

		layer.removeEventParent(this);

		L.LayerGroup.prototype.removeLayer.call(this, layer);

		// @event layerremove: LayerEvent
		// Fired when a layer is removed from this `FeatureGroup`
		return this.fire('layerremove', {layer: layer});
	},

	// @method setStyle(style: Path options): this
	// Sets the given path options to each layer of the group that has a `setStyle` method.
	setStyle: function (style) {
		return this.invoke('setStyle', style);
	},

	// @method bringToFront(): this
	// Brings the layer group to the top of all other layers
	bringToFront: function () {
		return this.invoke('bringToFront');
	},

	// @method bringToBack(): this
	// Brings the layer group to the top of all other layers
	bringToBack: function () {
		return this.invoke('bringToBack');
	},

	// @method getBounds(): LatLngBounds
	// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
	getBounds: function () {
		var bounds = new L.LatLngBounds();

		for (var id in this._layers) {
			var layer = this._layers[id];
			bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
		}
		return bounds;
	}
});

// @factory L.featureGroup(layers: Layer[])
// Create a feature group, optionally given an initial set of layers.
L.featureGroup = function (layers) {
	return new L.FeatureGroup(layers);
};

/*
 * @class Renderer
 * @inherits Layer
 * @aka L.Renderer
 *
 * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
 * DOM container of the renderer, its bounds, and its zoom animation.
 *
 * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
 * itself can be added or removed to the map. All paths use a renderer, which can
 * be implicit (the map will decide the type of renderer and use it automatically)
 * or explicit (using the [`renderer`](#path-renderer) option of the path).
 *
 * Do not use this class directly, use `SVG` and `Canvas` instead.
 *
 * @event update: Event
 * Fired when the renderer updates its bounds, center and zoom, for example when
 * its map has moved
 */

L.Renderer = L.Layer.extend({

	// @section
	// @aka Renderer options
	options: {
		// @option padding: Number = 0.1
		// How much to extend the clip area around the map view (relative to its size)
		// e.g. 0.1 would be 10% of map view in each direction
		padding: 0.1
	},

	initialize: function (options) {
		L.setOptions(this, options);
		L.stamp(this);
	},

	onAdd: function () {
		if (!this._container) {
			this._initContainer(); // defined by renderer implementations

			if (this._zoomAnimated) {
				L.DomUtil.addClass(this._container, 'leaflet-zoom-animated');
			}
		}

		this.getPane().appendChild(this._container);
		this._update();
	},

	onRemove: function () {
		L.DomUtil.remove(this._container);
	},

	getEvents: function () {
		var events = {
			viewreset: this._reset,
			zoom: this._onZoom,
			moveend: this._update
		};
		if (this._zoomAnimated) {
			events.zoomanim = this._onAnimZoom;
		}
		return events;
	},

	_onAnimZoom: function (ev) {
		this._updateTransform(ev.center, ev.zoom);
	},

	_onZoom: function () {
		this._updateTransform(this._map.getCenter(), this._map.getZoom());
	},

	_updateTransform: function (center, zoom) {
		var scale = this._map.getZoomScale(zoom, this._zoom),
		    position = L.DomUtil.getPosition(this._container),
		    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
		    currentCenterPoint = this._map.project(this._center, zoom),
		    destCenterPoint = this._map.project(center, zoom),
		    centerOffset = destCenterPoint.subtract(currentCenterPoint),

		    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);

		if (L.Browser.any3d) {
			L.DomUtil.setTransform(this._container, topLeftOffset, scale);
		} else {
			L.DomUtil.setPosition(this._container, topLeftOffset);
		}
	},

	_reset: function () {
		this._update();
		this._updateTransform(this._center, this._zoom);
	},

	_update: function () {
		// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
		// Subclasses are responsible of firing the 'update' event.
		var p = this.options.padding,
		    size = this._map.getSize(),
		    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();

		this._bounds = new L.Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());

		this._center = this._map.getCenter();
		this._zoom = this._map.getZoom();
	}
});


L.Map.include({
	// @namespace Map; @method getRenderer(layer: Path): Renderer
	// Returns the instance of `Renderer` that should be used to render the given
	// `Path`. It will ensure that the `renderer` options of the map and paths
	// are respected, and that the renderers do exist on the map.
	getRenderer: function (layer) {
		// @namespace Path; @option renderer: Renderer
		// Use this specific instance of `Renderer` for this path. Takes
		// precedence over the map's [default renderer](#map-renderer).
		var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;

		if (!renderer) {
			// @namespace Map; @option preferCanvas: Boolean = false
			// Whether `Path`s should be rendered on a `Canvas` renderer.
			// By default, all `Path`s are rendered in a `SVG` renderer.
			renderer = this._renderer = (this.options.preferCanvas && L.canvas()) || L.svg();
		}

		if (!this.hasLayer(renderer)) {
			this.addLayer(renderer);
		}
		return renderer;
	},

	_getPaneRenderer: function (name) {
		if (name === 'overlayPane' || name === undefined) {
			return false;
		}

		var renderer = this._paneRenderers[name];
		if (renderer === undefined) {
			renderer = (L.SVG && L.svg({pane: name})) || (L.Canvas && L.canvas({pane: name}));
			this._paneRenderers[name] = renderer;
		}
		return renderer;
	}
});

/*
 * @class Path
 * @aka L.Path
 * @inherits Interactive layer
 *
 * An abstract class that contains options and constants shared between vector
 * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
 */

L.Path = L.Layer.extend({

	// @section
	// @aka Path options
	options: {
		// @option stroke: Boolean = true
		// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
		stroke: true,

		// @option color: String = '#3388ff'
		// Stroke color
		color: '#3388ff',

		// @option weight: Number = 3
		// Stroke width in pixels
		weight: 3,

		// @option opacity: Number = 1.0
		// Stroke opacity
		opacity: 1,

		// @option lineCap: String= 'round'
		// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
		lineCap: 'round',

		// @option lineJoin: String = 'round'
		// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
		lineJoin: 'round',

		// @option dashArray: String = null
		// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
		dashArray: null,

		// @option dashOffset: String = null
		// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
		dashOffset: null,

		// @option fill: Boolean = depends
		// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
		fill: false,

		// @option fillColor: String = *
		// Fill color. Defaults to the value of the [`color`](#path-color) option
		fillColor: null,

		// @option fillOpacity: Number = 0.2
		// Fill opacity.
		fillOpacity: 0.2,

		// @option fillRule: String = 'evenodd'
		// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
		fillRule: 'evenodd',

		// className: '',

		// Option inherited from "Interactive layer" abstract class
		interactive: true
	},

	beforeAdd: function (map) {
		// Renderer is set here because we need to call renderer.getEvents
		// before this.getEvents.
		this._renderer = map.getRenderer(this);
	},

	onAdd: function () {
		this._renderer._initPath(this);
		this._reset();
		this._renderer._addPath(this);
		this._renderer.on('update', this._update, this);
	},

	onRemove: function () {
		this._renderer._removePath(this);
		this._renderer.off('update', this._update, this);
	},

	getEvents: function () {
		return {
			zoomend: this._project,
			viewreset: this._reset
		};
	},

	// @method redraw(): this
	// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
	redraw: function () {
		if (this._map) {
			this._renderer._updatePath(this);
		}
		return this;
	},

	// @method setStyle(style: Path options): this
	// Changes the appearance of a Path based on the options in the `Path options` object.
	setStyle: function (style) {
		L.setOptions(this, style);
		if (this._renderer) {
			this._renderer._updateStyle(this);
		}
		return this;
	},

	// @method bringToFront(): this
	// Brings the layer to the top of all path layers.
	bringToFront: function () {
		if (this._renderer) {
			this._renderer._bringToFront(this);
		}
		return this;
	},

	// @method bringToBack(): this
	// Brings the layer to the bottom of all path layers.
	bringToBack: function () {
		if (this._renderer) {
			this._renderer._bringToBack(this);
		}
		return this;
	},

	getElement: function () {
		return this._path;
	},

	_reset: function () {
		// defined in children classes
		this._project();
		this._update();
	},

	_clickTolerance: function () {
		// used when doing hit detection for Canvas layers
		return (this.options.stroke ? this.options.weight / 2 : 0) + (L.Browser.touch ? 10 : 0);
	}
});

/*
 * @namespace LineUtil
 *
 * Various utility functions for polyine points processing, used by Leaflet internally to make polylines lightning-fast.
 */

L.LineUtil = {

	// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
	// Improves rendering performance dramatically by lessening the number of points to draw.

	// @function simplify(points: Point[], tolerance: Number): Point[]
	// Dramatically reduces the number of points in a polyline while retaining
	// its shape and returns a new array of simplified points, using the
	// [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
	// Used for a huge performance boost when processing/displaying Leaflet polylines for
	// each zoom level and also reducing visual noise. tolerance affects the amount of
	// simplification (lesser value means higher quality but slower and with more points).
	// Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
	simplify: function (points, tolerance) {
		if (!tolerance || !points.length) {
			return points.slice();
		}

		var sqTolerance = tolerance * tolerance;

		// stage 1: vertex reduction
		points = this._reducePoints(points, sqTolerance);

		// stage 2: Douglas-Peucker simplification
		points = this._simplifyDP(points, sqTolerance);

		return points;
	},

	// @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
	// Returns the distance between point `p` and segment `p1` to `p2`.
	pointToSegmentDistance:  function (p, p1, p2) {
		return Math.sqrt(this._sqClosestPointOnSegment(p, p1, p2, true));
	},

	// @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
	// Returns the closest point from a point `p` on a segment `p1` to `p2`.
	closestPointOnSegment: function (p, p1, p2) {
		return this._sqClosestPointOnSegment(p, p1, p2);
	},

	// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
	_simplifyDP: function (points, sqTolerance) {

		var len = points.length,
		    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
		    markers = new ArrayConstructor(len);

		markers[0] = markers[len - 1] = 1;

		this._simplifyDPStep(points, markers, sqTolerance, 0, len - 1);

		var i,
		    newPoints = [];

		for (i = 0; i < len; i++) {
			if (markers[i]) {
				newPoints.push(points[i]);
			}
		}

		return newPoints;
	},

	_simplifyDPStep: function (points, markers, sqTolerance, first, last) {

		var maxSqDist = 0,
		    index, i, sqDist;

		for (i = first + 1; i <= last - 1; i++) {
			sqDist = this._sqClosestPointOnSegment(points[i], points[first], points[last], true);

			if (sqDist > maxSqDist) {
				index = i;
				maxSqDist = sqDist;
			}
		}

		if (maxSqDist > sqTolerance) {
			markers[index] = 1;

			this._simplifyDPStep(points, markers, sqTolerance, first, index);
			this._simplifyDPStep(points, markers, sqTolerance, index, last);
		}
	},

	// reduce points that are too close to each other to a single point
	_reducePoints: function (points, sqTolerance) {
		var reducedPoints = [points[0]];

		for (var i = 1, prev = 0, len = points.length; i < len; i++) {
			if (this._sqDist(points[i], points[prev]) > sqTolerance) {
				reducedPoints.push(points[i]);
				prev = i;
			}
		}
		if (prev < len - 1) {
			reducedPoints.push(points[len - 1]);
		}
		return reducedPoints;
	},


	// @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
	// Clips the segment a to b by rectangular bounds with the
	// [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
	// (modifying the segment points directly!). Used by Leaflet to only show polyline
	// points that are on the screen or near, increasing performance.
	clipSegment: function (a, b, bounds, useLastCode, round) {
		var codeA = useLastCode ? this._lastCode : this._getBitCode(a, bounds),
		    codeB = this._getBitCode(b, bounds),

		    codeOut, p, newCode;

		// save 2nd code to avoid calculating it on the next segment
		this._lastCode = codeB;

		while (true) {
			// if a,b is inside the clip window (trivial accept)
			if (!(codeA | codeB)) {
				return [a, b];
			}

			// if a,b is outside the clip window (trivial reject)
			if (codeA & codeB) {
				return false;
			}

			// other cases
			codeOut = codeA || codeB;
			p = this._getEdgeIntersection(a, b, codeOut, bounds, round);
			newCode = this._getBitCode(p, bounds);

			if (codeOut === codeA) {
				a = p;
				codeA = newCode;
			} else {
				b = p;
				codeB = newCode;
			}
		}
	},

	_getEdgeIntersection: function (a, b, code, bounds, round) {
		var dx = b.x - a.x,
		    dy = b.y - a.y,
		    min = bounds.min,
		    max = bounds.max,
		    x, y;

		if (code & 8) { // top
			x = a.x + dx * (max.y - a.y) / dy;
			y = max.y;

		} else if (code & 4) { // bottom
			x = a.x + dx * (min.y - a.y) / dy;
			y = min.y;

		} else if (code & 2) { // right
			x = max.x;
			y = a.y + dy * (max.x - a.x) / dx;

		} else if (code & 1) { // left
			x = min.x;
			y = a.y + dy * (min.x - a.x) / dx;
		}

		return new L.Point(x, y, round);
	},

	_getBitCode: function (p, bounds) {
		var code = 0;

		if (p.x < bounds.min.x) { // left
			code |= 1;
		} else if (p.x > bounds.max.x) { // right
			code |= 2;
		}

		if (p.y < bounds.min.y) { // bottom
			code |= 4;
		} else if (p.y > bounds.max.y) { // top
			code |= 8;
		}

		return code;
	},

	// square distance (to avoid unnecessary Math.sqrt calls)
	_sqDist: function (p1, p2) {
		var dx = p2.x - p1.x,
		    dy = p2.y - p1.y;
		return dx * dx + dy * dy;
	},

	// return closest point on segment or distance to that point
	_sqClosestPointOnSegment: function (p, p1, p2, sqDist) {
		var x = p1.x,
		    y = p1.y,
		    dx = p2.x - x,
		    dy = p2.y - y,
		    dot = dx * dx + dy * dy,
		    t;

		if (dot > 0) {
			t = ((p.x - x) * dx + (p.y - y) * dy) / dot;

			if (t > 1) {
				x = p2.x;
				y = p2.y;
			} else if (t > 0) {
				x += dx * t;
				y += dy * t;
			}
		}

		dx = p.x - x;
		dy = p.y - y;

		return sqDist ? dx * dx + dy * dy : new L.Point(x, y);
	}
};

/*
 * @class Polyline
 * @aka L.Polyline
 * @inherits Path
 *
 * A class for drawing polyline overlays on a map. Extends `Path`.
 *
 * @example
 *
 * ```js
 * // create a red polyline from an array of LatLng points
 * var latlngs = [
 * 	[-122.68, 45.51],
 * 	[-122.43, 37.77],
 * 	[-118.2, 34.04]
 * ];
 *
 * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
 *
 * // zoom the map to the polyline
 * map.fitBounds(polyline.getBounds());
 * ```
 *
 * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
 *
 * ```js
 * // create a red polyline from an array of arrays of LatLng points
 * var latlngs = [
 * 	[[-122.68, 45.51],
 * 	 [-122.43, 37.77],
 * 	 [-118.2, 34.04]],
 * 	[[-73.91, 40.78],
 * 	 [-87.62, 41.83],
 * 	 [-96.72, 32.76]]
 * ];
 * ```
 */

L.Polyline = L.Path.extend({

	// @section
	// @aka Polyline options
	options: {
		// @option smoothFactor: Number = 1.0
		// How much to simplify the polyline on each zoom level. More means
		// better performance and smoother look, and less means more accurate representation.
		smoothFactor: 1.0,

		// @option noClip: Boolean = false
		// Disable polyline clipping.
		noClip: false
	},

	initialize: function (latlngs, options) {
		L.setOptions(this, options);
		this._setLatLngs(latlngs);
	},

	// @method getLatLngs(): LatLng[]
	// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
	getLatLngs: function () {
		return this._latlngs;
	},

	// @method setLatLngs(latlngs: LatLng[]): this
	// Replaces all the points in the polyline with the given array of geographical points.
	setLatLngs: function (latlngs) {
		this._setLatLngs(latlngs);
		return this.redraw();
	},

	// @method isEmpty(): Boolean
	// Returns `true` if the Polyline has no LatLngs.
	isEmpty: function () {
		return !this._latlngs.length;
	},

	closestLayerPoint: function (p) {
		var minDistance = Infinity,
		    minPoint = null,
		    closest = L.LineUtil._sqClosestPointOnSegment,
		    p1, p2;

		for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
			var points = this._parts[j];

			for (var i = 1, len = points.length; i < len; i++) {
				p1 = points[i - 1];
				p2 = points[i];

				var sqDist = closest(p, p1, p2, true);

				if (sqDist < minDistance) {
					minDistance = sqDist;
					minPoint = closest(p, p1, p2);
				}
			}
		}
		if (minPoint) {
			minPoint.distance = Math.sqrt(minDistance);
		}
		return minPoint;
	},

	// @method getCenter(): LatLng
	// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
	getCenter: function () {
		// throws error when not yet added to map as this center calculation requires projected coordinates
		if (!this._map) {
			throw new Error('Must add layer to map before using getCenter()');
		}

		var i, halfDist, segDist, dist, p1, p2, ratio,
		    points = this._rings[0],
		    len = points.length;

		if (!len) { return null; }

		// polyline centroid algorithm; only uses the first ring if there are multiple

		for (i = 0, halfDist = 0; i < len - 1; i++) {
			halfDist += points[i].distanceTo(points[i + 1]) / 2;
		}

		// The line is so small in the current view that all points are on the same pixel.
		if (halfDist === 0) {
			return this._map.layerPointToLatLng(points[0]);
		}

		for (i = 0, dist = 0; i < len - 1; i++) {
			p1 = points[i];
			p2 = points[i + 1];
			segDist = p1.distanceTo(p2);
			dist += segDist;

			if (dist > halfDist) {
				ratio = (dist - halfDist) / segDist;
				return this._map.layerPointToLatLng([
					p2.x - ratio * (p2.x - p1.x),
					p2.y - ratio * (p2.y - p1.y)
				]);
			}
		}
	},

	// @method getBounds(): LatLngBounds
	// Returns the `LatLngBounds` of the path.
	getBounds: function () {
		return this._bounds;
	},

	// @method addLatLng(latlng: LatLng, latlngs? LatLng[]): this
	// Adds a given point to the polyline. By default, adds to the first ring of
	// the polyline in case of a multi-polyline, but can be overridden by passing
	// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
	addLatLng: function (latlng, latlngs) {
		latlngs = latlngs || this._defaultShape();
		latlng = L.latLng(latlng);
		latlngs.push(latlng);
		this._bounds.extend(latlng);
		return this.redraw();
	},

	_setLatLngs: function (latlngs) {
		this._bounds = new L.LatLngBounds();
		this._latlngs = this._convertLatLngs(latlngs);
	},

	_defaultShape: function () {
		return L.Polyline._flat(this._latlngs) ? this._latlngs : this._latlngs[0];
	},

	// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
	_convertLatLngs: function (latlngs) {
		var result = [],
		    flat = L.Polyline._flat(latlngs);

		for (var i = 0, len = latlngs.length; i < len; i++) {
			if (flat) {
				result[i] = L.latLng(latlngs[i]);
				this._bounds.extend(result[i]);
			} else {
				result[i] = this._convertLatLngs(latlngs[i]);
			}
		}

		return result;
	},

	_project: function () {
		var pxBounds = new L.Bounds();
		this._rings = [];
		this._projectLatlngs(this._latlngs, this._rings, pxBounds);

		var w = this._clickTolerance(),
		    p = new L.Point(w, w);

		if (this._bounds.isValid() && pxBounds.isValid()) {
			pxBounds.min._subtract(p);
			pxBounds.max._add(p);
			this._pxBounds = pxBounds;
		}
	},

	// recursively turns latlngs into a set of rings with projected coordinates
	_projectLatlngs: function (latlngs, result, projectedBounds) {
		var flat = latlngs[0] instanceof L.LatLng,
		    len = latlngs.length,
		    i, ring;

		if (flat) {
			ring = [];
			for (i = 0; i < len; i++) {
				ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
				projectedBounds.extend(ring[i]);
			}
			result.push(ring);
		} else {
			for (i = 0; i < len; i++) {
				this._projectLatlngs(latlngs[i], result, projectedBounds);
			}
		}
	},

	// clip polyline by renderer bounds so that we have less to render for performance
	_clipPoints: function () {
		var bounds = this._renderer._bounds;

		this._parts = [];
		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
			return;
		}

		if (this.options.noClip) {
			this._parts = this._rings;
			return;
		}

		var parts = this._parts,
		    i, j, k, len, len2, segment, points;

		for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
			points = this._rings[i];

			for (j = 0, len2 = points.length; j < len2 - 1; j++) {
				segment = L.LineUtil.clipSegment(points[j], points[j + 1], bounds, j, true);

				if (!segment) { continue; }

				parts[k] = parts[k] || [];
				parts[k].push(segment[0]);

				// if segment goes out of screen, or it's the last one, it's the end of the line part
				if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
					parts[k].push(segment[1]);
					k++;
				}
			}
		}
	},

	// simplify each clipped part of the polyline for performance
	_simplifyPoints: function () {
		var parts = this._parts,
		    tolerance = this.options.smoothFactor;

		for (var i = 0, len = parts.length; i < len; i++) {
			parts[i] = L.LineUtil.simplify(parts[i], tolerance);
		}
	},

	_update: function () {
		if (!this._map) { return; }

		this._clipPoints();
		this._simplifyPoints();
		this._updatePath();
	},

	_updatePath: function () {
		this._renderer._updatePoly(this);
	}
});

// @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
// Instantiates a polyline object given an array of geographical points and
// optionally an options object. You can create a `Polyline` object with
// multiple separate lines (`MultiPolyline`) by passing an array of arrays
// of geographic points.
L.polyline = function (latlngs, options) {
	return new L.Polyline(latlngs, options);
};

L.Polyline._flat = function (latlngs) {
	// true if it's a flat array of latlngs; false if nested
	return !L.Util.isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
};

/*
 * @namespace PolyUtil
 * Various utility functions for polygon geometries.
 */

L.PolyUtil = {};

/* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
 * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgeman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
 * Used by Leaflet to only show polygon points that are on the screen or near, increasing
 * performance. Note that polygon points needs different algorithm for clipping
 * than polyline, so there's a seperate method for it.
 */
L.PolyUtil.clipPolygon = function (points, bounds, round) {
	var clippedPoints,
	    edges = [1, 4, 2, 8],
	    i, j, k,
	    a, b,
	    len, edge, p,
	    lu = L.LineUtil;

	for (i = 0, len = points.length; i < len; i++) {
		points[i]._code = lu._getBitCode(points[i], bounds);
	}

	// for each edge (left, bottom, right, top)
	for (k = 0; k < 4; k++) {
		edge = edges[k];
		clippedPoints = [];

		for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
			a = points[i];
			b = points[j];

			// if a is inside the clip window
			if (!(a._code & edge)) {
				// if b is outside the clip window (a->b goes out of screen)
				if (b._code & edge) {
					p = lu._getEdgeIntersection(b, a, edge, bounds, round);
					p._code = lu._getBitCode(p, bounds);
					clippedPoints.push(p);
				}
				clippedPoints.push(a);

			// else if b is inside the clip window (a->b enters the screen)
			} else if (!(b._code & edge)) {
				p = lu._getEdgeIntersection(b, a, edge, bounds, round);
				p._code = lu._getBitCode(p, bounds);
				clippedPoints.push(p);
			}
		}
		points = clippedPoints;
	}

	return points;
};

/*
 * @class Polygon
 * @aka L.Polygon
 * @inherits Polyline
 *
 * A class for drawing polygon overlays on a map. Extends `Polyline`.
 *
 * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
 *
 *
 * @example
 *
 * ```js
 * // create a red polygon from an array of LatLng points
 * var latlngs = [[-111.03, 41],[-111.04, 45],[-104.05, 45],[-104.05, 41]];
 *
 * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
 *
 * // zoom the map to the polygon
 * map.fitBounds(polygon.getBounds());
 * ```
 *
 * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
 *
 * ```js
 * var latlngs = [
 *   [[-111.03, 41],[-111.04, 45],[-104.05, 45],[-104.05, 41]], // outer ring
 *   [[-108.58,37.29],[-108.58,40.71],[-102.50,40.71],[-102.50,37.29]] // hole
 * ];
 * ```
 *
 * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
 *
 * ```js
 * var latlngs = [
 *   [ // first polygon
 *     [[-111.03, 41],[-111.04, 45],[-104.05, 45],[-104.05, 41]], // outer ring
 *     [[-108.58,37.29],[-108.58,40.71],[-102.50,40.71],[-102.50,37.29]] // hole
 *   ],
 *   [ // second polygon
 *     [[-109.05, 37],[-109.03, 41],[-102.05, 41],[-102.04, 37],[-109.05, 38]]
 *   ]
 * ];
 * ```
 */

L.Polygon = L.Polyline.extend({

	options: {
		fill: true
	},

	isEmpty: function () {
		return !this._latlngs.length || !this._latlngs[0].length;
	},

	getCenter: function () {
		// throws error when not yet added to map as this center calculation requires projected coordinates
		if (!this._map) {
			throw new Error('Must add layer to map before using getCenter()');
		}

		var i, j, p1, p2, f, area, x, y, center,
		    points = this._rings[0],
		    len = points.length;

		if (!len) { return null; }

		// polygon centroid algorithm; only uses the first ring if there are multiple

		area = x = y = 0;

		for (i = 0, j = len - 1; i < len; j = i++) {
			p1 = points[i];
			p2 = points[j];

			f = p1.y * p2.x - p2.y * p1.x;
			x += (p1.x + p2.x) * f;
			y += (p1.y + p2.y) * f;
			area += f * 3;
		}

		if (area === 0) {
			// Polygon is so small that all points are on same pixel.
			center = points[0];
		} else {
			center = [x / area, y / area];
		}
		return this._map.layerPointToLatLng(center);
	},

	_convertLatLngs: function (latlngs) {
		var result = L.Polyline.prototype._convertLatLngs.call(this, latlngs),
		    len = result.length;

		// remove last point if it equals first one
		if (len >= 2 && result[0] instanceof L.LatLng && result[0].equals(result[len - 1])) {
			result.pop();
		}
		return result;
	},

	_setLatLngs: function (latlngs) {
		L.Polyline.prototype._setLatLngs.call(this, latlngs);
		if (L.Polyline._flat(this._latlngs)) {
			this._latlngs = [this._latlngs];
		}
	},

	_defaultShape: function () {
		return L.Polyline._flat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
	},

	_clipPoints: function () {
		// polygons need a different clipping algorithm so we redefine that

		var bounds = this._renderer._bounds,
		    w = this.options.weight,
		    p = new L.Point(w, w);

		// increase clip padding by stroke width to avoid stroke on clip edges
		bounds = new L.Bounds(bounds.min.subtract(p), bounds.max.add(p));

		this._parts = [];
		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
			return;
		}

		if (this.options.noClip) {
			this._parts = this._rings;
			return;
		}

		for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
			clipped = L.PolyUtil.clipPolygon(this._rings[i], bounds, true);
			if (clipped.length) {
				this._parts.push(clipped);
			}
		}
	},

	_updatePath: function () {
		this._renderer._updatePoly(this, true);
	}
});


// @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
L.polygon = function (latlngs, options) {
	return new L.Polygon(latlngs, options);
};

/*
 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
 */

/*
 * @class Rectangle
 * @aka L.Retangle
 * @inherits Polygon
 *
 * A class for drawing rectangle overlays on a map. Extends `Polygon`.
 *
 * @example
 *
 * ```js
 * // define rectangle geographical bounds
 * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
 *
 * // create an orange rectangle
 * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
 *
 * // zoom the map to the rectangle bounds
 * map.fitBounds(bounds);
 * ```
 *
 */


L.Rectangle = L.Polygon.extend({
	initialize: function (latLngBounds, options) {
		L.Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
	},

	// @method setBounds(latLngBounds: LatLngBounds): this
	// Redraws the rectangle with the passed bounds.
	setBounds: function (latLngBounds) {
		return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
	},

	_boundsToLatLngs: function (latLngBounds) {
		latLngBounds = L.latLngBounds(latLngBounds);
		return [
			latLngBounds.getSouthWest(),
			latLngBounds.getNorthWest(),
			latLngBounds.getNorthEast(),
			latLngBounds.getSouthEast()
		];
	}
});


// @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
L.rectangle = function (latLngBounds, options) {
	return new L.Rectangle(latLngBounds, options);
};

/*
 * @class CircleMarker
 * @aka L.CircleMarker
 * @inherits Path
 *
 * A circle of a fixed size with radius specified in pixels. Extends `Path`.
 */

L.CircleMarker = L.Path.extend({

	// @section
	// @aka CircleMarker options
	options: {
		fill: true,

		// @option radius: Number = 10
		// Radius of the circle marker, in pixels
		radius: 10
	},

	initialize: function (latlng, options) {
		L.setOptions(this, options);
		this._latlng = L.latLng(latlng);
		this._radius = this.options.radius;
	},

	// @method setLatLng(latLng: LatLng): this
	// Sets the position of a circle marker to a new location.
	setLatLng: function (latlng) {
		this._latlng = L.latLng(latlng);
		this.redraw();
		return this.fire('move', {latlng: this._latlng});
	},

	// @method getLatLng(): LatLng
	// Returns the current geographical position of the circle marker
	getLatLng: function () {
		return this._latlng;
	},

	// @method setRadius(radius: Number): this
	// Sets the radius of a circle marker. Units are in pixels.
	setRadius: function (radius) {
		this.options.radius = this._radius = radius;
		return this.redraw();
	},

	// @method getRadius(): Number
	// Returns the current radius of the circle
	getRadius: function () {
		return this._radius;
	},

	setStyle : function (options) {
		var radius = options && options.radius || this._radius;
		L.Path.prototype.setStyle.call(this, options);
		this.setRadius(radius);
		return this;
	},

	_project: function () {
		this._point = this._map.latLngToLayerPoint(this._latlng);
		this._updateBounds();
	},

	_updateBounds: function () {
		var r = this._radius,
		    r2 = this._radiusY || r,
		    w = this._clickTolerance(),
		    p = [r + w, r2 + w];
		this._pxBounds = new L.Bounds(this._point.subtract(p), this._point.add(p));
	},

	_update: function () {
		if (this._map) {
			this._updatePath();
		}
	},

	_updatePath: function () {
		this._renderer._updateCircle(this);
	},

	_empty: function () {
		return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
	}
});


// @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
// Instantiates a circle marker object given a geographical point, and an optional options object.
L.circleMarker = function (latlng, options) {
	return new L.CircleMarker(latlng, options);
};

/*
 * @class Circle
 * @aka L.Circle
 * @inherits CircleMarker
 *
 * A class for drawing circle overlays on a map. Extends `CircleMarker`.
 *
 * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
 *
 * @example
 *
 * ```js
 * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
 * ```
 */

L.Circle = L.CircleMarker.extend({

	initialize: function (latlng, options, legacyOptions) {
		if (typeof options === 'number') {
			// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
			options = L.extend({}, legacyOptions, {radius: options});
		}
		L.setOptions(this, options);
		this._latlng = L.latLng(latlng);

		if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }

		// @section
		// @aka Circle options
		// @option radius: Number; Radius of the circle, in meters.
		this._mRadius = this.options.radius;
	},

	// @method setRadius(radius: Number): this
	// Sets the radius of a circle. Units are in meters.
	setRadius: function (radius) {
		this._mRadius = radius;
		return this.redraw();
	},

	// @method getRadius(): Number
	// Returns the current radius of a circle. Units are in meters.
	getRadius: function () {
		return this._mRadius;
	},

	// @method getBounds(): LatLngBounds
	// Returns the `LatLngBounds` of the path.
	getBounds: function () {
		var half = [this._radius, this._radiusY || this._radius];

		return new L.LatLngBounds(
			this._map.layerPointToLatLng(this._point.subtract(half)),
			this._map.layerPointToLatLng(this._point.add(half)));
	},

	setStyle: L.Path.prototype.setStyle,

	_project: function () {

		var lng = this._latlng.lng,
		    lat = this._latlng.lat,
		    map = this._map,
		    crs = map.options.crs;

		if (crs.distance === L.CRS.Earth.distance) {
			var d = Math.PI / 180,
			    latR = (this._mRadius / L.CRS.Earth.R) / d,
			    top = map.project([lat + latR, lng]),
			    bottom = map.project([lat - latR, lng]),
			    p = top.add(bottom).divideBy(2),
			    lat2 = map.unproject(p).lat,
			    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
			            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;

			if (isNaN(lngR) || lngR === 0) {
				lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
			}

			this._point = p.subtract(map.getPixelOrigin());
			this._radius = isNaN(lngR) ? 0 : Math.max(Math.round(p.x - map.project([lat2, lng - lngR]).x), 1);
			this._radiusY = Math.max(Math.round(p.y - top.y), 1);

		} else {
			var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));

			this._point = map.latLngToLayerPoint(this._latlng);
			this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
		}

		this._updateBounds();
	}
});

// @factory L.circle(latlng: LatLng, options?: Circle options)
// Instantiates a circle object given a geographical point, and an options object
// which contains the circle radius.
// @alternative
// @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
// Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
// Do not use in new applications or plugins.
L.circle = function (latlng, options, legacyOptions) {
	return new L.Circle(latlng, options, legacyOptions);
};

/*
 * @class SVG
 * @inherits Renderer
 * @aka L.SVG
 *
 * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
 * Inherits `Renderer`.
 *
 * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
 * available in all web browsers, notably Android 2.x and 3.x.
 *
 * Although SVG is not available on IE7 and IE8, these browsers support
 * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
 * (a now deprecated technology), and the SVG renderer will fall back to VML in
 * this case.
 *
 * @example
 *
 * Use SVG by default for all paths in the map:
 *
 * ```js
 * var map = L.map('map', {
 * 	renderer: L.svg()
 * });
 * ```
 *
 * Use a SVG renderer with extra padding for specific vector geometries:
 *
 * ```js
 * var map = L.map('map');
 * var myRenderer = L.svg({ padding: 0.5 });
 * var line = L.polyline( coordinates, { renderer: myRenderer } );
 * var circle = L.circle( center, { renderer: myRenderer } );
 * ```
 */

L.SVG = L.Renderer.extend({

	getEvents: function () {
		var events = L.Renderer.prototype.getEvents.call(this);
		events.zoomstart = this._onZoomStart;
		return events;
	},

	_initContainer: function () {
		this._container = L.SVG.create('svg');

		// makes it possible to click through svg root; we'll reset it back in individual paths
		this._container.setAttribute('pointer-events', 'none');

		this._rootGroup = L.SVG.create('g');
		this._container.appendChild(this._rootGroup);
	},

	_onZoomStart: function () {
		// Drag-then-pinch interactions might mess up the center and zoom.
		// In this case, the easiest way to prevent this is re-do the renderer
		//   bounds and padding when the zooming starts.
		this._update();
	},

	_update: function () {
		if (this._map._animatingZoom && this._bounds) { return; }

		L.Renderer.prototype._update.call(this);

		var b = this._bounds,
		    size = b.getSize(),
		    container = this._container;

		// set size of svg-container if changed
		if (!this._svgSize || !this._svgSize.equals(size)) {
			this._svgSize = size;
			container.setAttribute('width', size.x);
			container.setAttribute('height', size.y);
		}

		// movement: update container viewBox so that we don't have to change coordinates of individual layers
		L.DomUtil.setPosition(container, b.min);
		container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));

		this.fire('update');
	},

	// methods below are called by vector layers implementations

	_initPath: function (layer) {
		var path = layer._path = L.SVG.create('path');

		// @namespace Path
		// @option className: String = null
		// Custom class name set on an element. Only for SVG renderer.
		if (layer.options.className) {
			L.DomUtil.addClass(path, layer.options.className);
		}

		if (layer.options.interactive) {
			L.DomUtil.addClass(path, 'leaflet-interactive');
		}

		this._updateStyle(layer);
	},

	_addPath: function (layer) {
		this._rootGroup.appendChild(layer._path);
		layer.addInteractiveTarget(layer._path);
	},

	_removePath: function (layer) {
		L.DomUtil.remove(layer._path);
		layer.removeInteractiveTarget(layer._path);
	},

	_updatePath: function (layer) {
		layer._project();
		layer._update();
	},

	_updateStyle: function (layer) {
		var path = layer._path,
		    options = layer.options;

		if (!path) { return; }

		if (options.stroke) {
			path.setAttribute('stroke', options.color);
			path.setAttribute('stroke-opacity', options.opacity);
			path.setAttribute('stroke-width', options.weight);
			path.setAttribute('stroke-linecap', options.lineCap);
			path.setAttribute('stroke-linejoin', options.lineJoin);

			if (options.dashArray) {
				path.setAttribute('stroke-dasharray', options.dashArray);
			} else {
				path.removeAttribute('stroke-dasharray');
			}

			if (options.dashOffset) {
				path.setAttribute('stroke-dashoffset', options.dashOffset);
			} else {
				path.removeAttribute('stroke-dashoffset');
			}
		} else {
			path.setAttribute('stroke', 'none');
		}

		if (options.fill) {
			path.setAttribute('fill', options.fillColor || options.color);
			path.setAttribute('fill-opacity', options.fillOpacity);
			path.setAttribute('fill-rule', options.fillRule || 'evenodd');
		} else {
			path.setAttribute('fill', 'none');
		}
	},

	_updatePoly: function (layer, closed) {
		this._setPath(layer, L.SVG.pointsToPath(layer._parts, closed));
	},

	_updateCircle: function (layer) {
		var p = layer._point,
		    r = layer._radius,
		    r2 = layer._radiusY || r,
		    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';

		// drawing a circle with two half-arcs
		var d = layer._empty() ? 'M0 0' :
				'M' + (p.x - r) + ',' + p.y +
				arc + (r * 2) + ',0 ' +
				arc + (-r * 2) + ',0 ';

		this._setPath(layer, d);
	},

	_setPath: function (layer, path) {
		layer._path.setAttribute('d', path);
	},

	// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
	_bringToFront: function (layer) {
		L.DomUtil.toFront(layer._path);
	},

	_bringToBack: function (layer) {
		L.DomUtil.toBack(layer._path);
	}
});


// @namespace SVG; @section
// There are several static functions which can be called without instantiating L.SVG:
L.extend(L.SVG, {
	// @function create(name: String): SVGElement
	// Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
	// corresponding to the class name passed. For example, using 'line' will return
	// an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
	create: function (name) {
		return document.createElementNS('http://www.w3.org/2000/svg', name);
	},

	// @function pointsToPath(rings: Point[], closed: Boolean): String
	// Generates a SVG path string for multiple rings, with each ring turning
	// into "M..L..L.." instructions
	pointsToPath: function (rings, closed) {
		var str = '',
		    i, j, len, len2, points, p;

		for (i = 0, len = rings.length; i < len; i++) {
			points = rings[i];

			for (j = 0, len2 = points.length; j < len2; j++) {
				p = points[j];
				str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
			}

			// closes the ring for polygons; "x" is VML syntax
			str += closed ? (L.Browser.svg ? 'z' : 'x') : '';
		}

		// SVG complains about empty path strings
		return str || 'M0 0';
	}
});

// @namespace Browser; @property svg: Boolean
// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
L.Browser.svg = !!(document.createElementNS && L.SVG.create('svg').createSVGRect);


// @namespace SVG
// @factory L.svg(options?: Renderer options)
// Creates a SVG renderer with the given options.
L.svg = function (options) {
	return L.Browser.svg || L.Browser.vml ? new L.SVG(options) : null;
};

/*
 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
 */

/*
 * @class SVG
 *
 * Although SVG is not available on IE7 and IE8, these browsers support [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language), and the SVG renderer will fall back to VML in this case.
 *
 * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
 * with old versions of Internet Explorer.
 */

// @namespace Browser; @property vml: Boolean
// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
L.Browser.vml = !L.Browser.svg && (function () {
	try {
		var div = document.createElement('div');
		div.innerHTML = '<v:shape adj="1"/>';

		var shape = div.firstChild;
		shape.style.behavior = 'url(#default#VML)';

		return shape && (typeof shape.adj === 'object');

	} catch (e) {
		return false;
	}
}());

// redefine some SVG methods to handle VML syntax which is similar but with some differences
L.SVG.include(!L.Browser.vml ? {} : {

	_initContainer: function () {
		this._container = L.DomUtil.create('div', 'leaflet-vml-container');
	},

	_update: function () {
		if (this._map._animatingZoom) { return; }
		L.Renderer.prototype._update.call(this);
		this.fire('update');
	},

	_initPath: function (layer) {
		var container = layer._container = L.SVG.create('shape');

		L.DomUtil.addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));

		container.coordsize = '1 1';

		layer._path = L.SVG.create('path');
		container.appendChild(layer._path);

		this._updateStyle(layer);
	},

	_addPath: function (layer) {
		var container = layer._container;
		this._container.appendChild(container);

		if (layer.options.interactive) {
			layer.addInteractiveTarget(container);
		}
	},

	_removePath: function (layer) {
		var container = layer._container;
		L.DomUtil.remove(container);
		layer.removeInteractiveTarget(container);
	},

	_updateStyle: function (layer) {
		var stroke = layer._stroke,
		    fill = layer._fill,
		    options = layer.options,
		    container = layer._container;

		container.stroked = !!options.stroke;
		container.filled = !!options.fill;

		if (options.stroke) {
			if (!stroke) {
				stroke = layer._stroke = L.SVG.create('stroke');
			}
			container.appendChild(stroke);
			stroke.weight = options.weight + 'px';
			stroke.color = options.color;
			stroke.opacity = options.opacity;

			if (options.dashArray) {
				stroke.dashStyle = L.Util.isArray(options.dashArray) ?
				    options.dashArray.join(' ') :
				    options.dashArray.replace(/( *, *)/g, ' ');
			} else {
				stroke.dashStyle = '';
			}
			stroke.endcap = options.lineCap.replace('butt', 'flat');
			stroke.joinstyle = options.lineJoin;

		} else if (stroke) {
			container.removeChild(stroke);
			layer._stroke = null;
		}

		if (options.fill) {
			if (!fill) {
				fill = layer._fill = L.SVG.create('fill');
			}
			container.appendChild(fill);
			fill.color = options.fillColor || options.color;
			fill.opacity = options.fillOpacity;

		} else if (fill) {
			container.removeChild(fill);
			layer._fill = null;
		}
	},

	_updateCircle: function (layer) {
		var p = layer._point.round(),
		    r = Math.round(layer._radius),
		    r2 = Math.round(layer._radiusY || r);

		this._setPath(layer, layer._empty() ? 'M0 0' :
				'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
	},

	_setPath: function (layer, path) {
		layer._path.v = path;
	},

	_bringToFront: function (layer) {
		L.DomUtil.toFront(layer._container);
	},

	_bringToBack: function (layer) {
		L.DomUtil.toBack(layer._container);
	}
});

if (L.Browser.vml) {
	L.SVG.create = (function () {
		try {
			document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
			return function (name) {
				return document.createElement('<lvml:' + name + ' class="lvml">');
			};
		} catch (e) {
			return function (name) {
				return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
			};
		}
	})();
}

/*
 * @class Canvas
 * @inherits Renderer
 * @aka L.Canvas
 *
 * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
 * Inherits `Renderer`.
 *
 * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
 * available in all web browsers, notably IE8, and overlapping geometries might
 * not display properly in some edge cases.
 *
 * @example
 *
 * Use Canvas by default for all paths in the map:
 *
 * ```js
 * var map = L.map('map', {
 * 	renderer: L.canvas()
 * });
 * ```
 *
 * Use a Canvas renderer with extra padding for specific vector geometries:
 *
 * ```js
 * var map = L.map('map');
 * var myRenderer = L.canvas({ padding: 0.5 });
 * var line = L.polyline( coordinates, { renderer: myRenderer } );
 * var circle = L.circle( center, { renderer: myRenderer } );
 * ```
 */

L.Canvas = L.Renderer.extend({

	onAdd: function () {
		L.Renderer.prototype.onAdd.call(this);

		this._layers = this._layers || {};

		// Redraw vectors since canvas is cleared upon removal,
		// in case of removing the renderer itself from the map.
		this._draw();
	},

	_initContainer: function () {
		var container = this._container = document.createElement('canvas');

		L.DomEvent
			.on(container, 'mousemove', L.Util.throttle(this._onMouseMove, 32, this), this)
			.on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this)
			.on(container, 'mouseout', this._handleMouseOut, this);

		this._ctx = container.getContext('2d');
	},

	_update: function () {
		if (this._map._animatingZoom && this._bounds) { return; }

		this._drawnLayers = {};

		L.Renderer.prototype._update.call(this);

		var b = this._bounds,
		    container = this._container,
		    size = b.getSize(),
		    m = L.Browser.retina ? 2 : 1;

		L.DomUtil.setPosition(container, b.min);

		// set canvas size (also clearing it); use double size on retina
		container.width = m * size.x;
		container.height = m * size.y;
		container.style.width = size.x + 'px';
		container.style.height = size.y + 'px';

		if (L.Browser.retina) {
			this._ctx.scale(2, 2);
		}

		// translate so we use the same path coordinates after canvas element moves
		this._ctx.translate(-b.min.x, -b.min.y);

		// Tell paths to redraw themselves
		this.fire('update');
	},

	_initPath: function (layer) {
		this._updateDashArray(layer);
		this._layers[L.stamp(layer)] = layer;
	},

	_addPath: L.Util.falseFn,

	_removePath: function (layer) {
		layer._removed = true;
		this._requestRedraw(layer);
	},

	_updatePath: function (layer) {
		this._redrawBounds = layer._pxBounds;
		this._draw(true);
		layer._project();
		layer._update();
		this._draw();
		this._redrawBounds = null;
	},

	_updateStyle: function (layer) {
		this._updateDashArray(layer);
		this._requestRedraw(layer);
	},

	_updateDashArray: function (layer) {
		if (layer.options.dashArray) {
			var parts = layer.options.dashArray.split(','),
			    dashArray = [],
			    i;
			for (i = 0; i < parts.length; i++) {
				dashArray.push(Number(parts[i]));
			}
			layer.options._dashArray = dashArray;
		}
	},

	_requestRedraw: function (layer) {
		if (!this._map) { return; }

		var padding = (layer.options.weight || 0) + 1;
		this._redrawBounds = this._redrawBounds || new L.Bounds();
		this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
		this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));

		this._redrawRequest = this._redrawRequest || L.Util.requestAnimFrame(this._redraw, this);
	},

	_redraw: function () {
		this._redrawRequest = null;

		this._draw(true); // clear layers in redraw bounds
		this._draw(); // draw layers

		this._redrawBounds = null;
	},

	_draw: function (clear) {
		this._clear = clear;
		var layer, bounds = this._redrawBounds;
		this._ctx.save();
		if (bounds) {
			this._ctx.beginPath();
			this._ctx.rect(bounds.min.x, bounds.min.y, bounds.max.x - bounds.min.x, bounds.max.y - bounds.min.y);
			this._ctx.clip();
		}

		for (var id in this._layers) {
			layer = this._layers[id];
			if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
				layer._updatePath();
			}
			if (clear && layer._removed) {
				delete layer._removed;
				delete this._layers[id];
			}
		}
		this._ctx.restore();  // Restore state before clipping.
	},

	_updatePoly: function (layer, closed) {

		var i, j, len2, p,
		    parts = layer._parts,
		    len = parts.length,
		    ctx = this._ctx;

		if (!len) { return; }

		this._drawnLayers[layer._leaflet_id] = layer;

		ctx.beginPath();

		if (ctx.setLineDash) {
			ctx.setLineDash(layer.options && layer.options._dashArray || []);
		}

		for (i = 0; i < len; i++) {
			for (j = 0, len2 = parts[i].length; j < len2; j++) {
				p = parts[i][j];
				ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
			}
			if (closed) {
				ctx.closePath();
			}
		}

		this._fillStroke(ctx, layer);

		// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
	},

	_updateCircle: function (layer) {

		if (layer._empty()) { return; }

		var p = layer._point,
		    ctx = this._ctx,
		    r = layer._radius,
		    s = (layer._radiusY || r) / r;

		this._drawnLayers[layer._leaflet_id] = layer;

		if (s !== 1) {
			ctx.save();
			ctx.scale(1, s);
		}

		ctx.beginPath();
		ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);

		if (s !== 1) {
			ctx.restore();
		}

		this._fillStroke(ctx, layer);
	},

	_fillStroke: function (ctx, layer) {
		var clear = this._clear,
		    options = layer.options;

		ctx.globalCompositeOperation = clear ? 'destination-out' : 'source-over';

		if (options.fill) {
			ctx.globalAlpha = clear ? 1 : options.fillOpacity;
			ctx.fillStyle = options.fillColor || options.color;
			ctx.fill(options.fillRule || 'evenodd');
		}

		if (options.stroke && options.weight !== 0) {
			ctx.globalAlpha = clear ? 1 : options.opacity;

			// if clearing shape, do it with the previously drawn line width
			layer._prevWeight = ctx.lineWidth = clear ? layer._prevWeight + 1 : options.weight;

			ctx.strokeStyle = options.color;
			ctx.lineCap = options.lineCap;
			ctx.lineJoin = options.lineJoin;
			ctx.stroke();
		}
	},

	// Canvas obviously doesn't have mouse events for individual drawn objects,
	// so we emulate that by calculating what's under the mouse on mousemove/click manually

	_onClick: function (e) {
		var point = this._map.mouseEventToLayerPoint(e), layers = [], layer;

		for (var id in this._layers) {
			layer = this._layers[id];
			if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
				L.DomEvent._fakeStop(e);
				layers.push(layer);
			}
		}
		if (layers.length)  {
			this._fireEvent(layers, e);
		}
	},

	_onMouseMove: function (e) {
		if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }

		var point = this._map.mouseEventToLayerPoint(e);
		this._handleMouseOut(e, point);
		this._handleMouseHover(e, point);
	},


	_handleMouseOut: function (e, point) {
		var layer = this._hoveredLayer;
		if (layer && (e.type === 'mouseout' || !layer._containsPoint(point))) {
			// if we're leaving the layer, fire mouseout
			L.DomUtil.removeClass(this._container, 'leaflet-interactive');
			this._fireEvent([layer], e, 'mouseout');
			this._hoveredLayer = null;
		}
	},

	_handleMouseHover: function (e, point) {
		var id, layer;

		for (id in this._drawnLayers) {
			layer = this._drawnLayers[id];
			if (layer.options.interactive && layer._containsPoint(point)) {
				L.DomUtil.addClass(this._container, 'leaflet-interactive'); // change cursor
				this._fireEvent([layer], e, 'mouseover');
				this._hoveredLayer = layer;
			}
		}

		if (this._hoveredLayer) {
			this._fireEvent([this._hoveredLayer], e);
		}
	},

	_fireEvent: function (layers, e, type) {
		this._map._fireDOMEvent(e, type || e.type, layers);
	},

	// TODO _bringToFront & _bringToBack, pretty tricky

	_bringToFront: L.Util.falseFn,
	_bringToBack: L.Util.falseFn
});

// @namespace Browser; @property canvas: Boolean
// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
L.Browser.canvas = (function () {
	return !!document.createElement('canvas').getContext;
}());

// @namespace Canvas
// @factory L.canvas(options?: Renderer options)
// Creates a Canvas renderer with the given options.
L.canvas = function (options) {
	return L.Browser.canvas ? new L.Canvas(options) : null;
};

L.Polyline.prototype._containsPoint = function (p, closed) {
	var i, j, k, len, len2, part,
	    w = this._clickTolerance();

	if (!this._pxBounds.contains(p)) { return false; }

	// hit detection for polylines
	for (i = 0, len = this._parts.length; i < len; i++) {
		part = this._parts[i];

		for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
			if (!closed && (j === 0)) { continue; }

			if (L.LineUtil.pointToSegmentDistance(p, part[k], part[j]) <= w) {
				return true;
			}
		}
	}
	return false;
};

L.Polygon.prototype._containsPoint = function (p) {
	var inside = false,
	    part, p1, p2, i, j, k, len, len2;

	if (!this._pxBounds.contains(p)) { return false; }

	// ray casting algorithm for detecting if point is in polygon
	for (i = 0, len = this._parts.length; i < len; i++) {
		part = this._parts[i];

		for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
			p1 = part[j];
			p2 = part[k];

			if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
				inside = !inside;
			}
		}
	}

	// also check if it's on polygon stroke
	return inside || L.Polyline.prototype._containsPoint.call(this, p, true);
};

L.CircleMarker.prototype._containsPoint = function (p) {
	return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
};

/*
 * @class GeoJSON
 * @aka L.GeoJSON
 * @inherits FeatureGroup
 *
 * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
 * GeoJSON data and display it on the map. Extends `FeatureGroup`.
 *
 * @example
 *
 * ```js
 * L.geoJSON(data, {
 * 	style: function (feature) {
 * 		return {color: feature.properties.color};
 * 	}
 * }).bindPopup(function (layer) {
 * 	return layer.feature.properties.description;
 * }).addTo(map);
 * ```
 */

L.GeoJSON = L.FeatureGroup.extend({

	/* @section
	 * @aka GeoJSON options
	 *
	 * @option pointToLayer: Function = *
	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
	 * The default is to spawn a default `Marker`:
	 * ```js
	 * function(geoJsonPoint, latlng) {
	 * 	return L.marker(latlng);
	 * }
	 * ```
	 *
	 * @option style: Function = *
	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
	 * called internally when data is added.
	 * The default value is to not override any defaults:
	 * ```js
	 * function (geoJsonFeature) {
	 * 	return {}
	 * }
	 * ```
	 *
	 * @option onEachFeature: Function = *
	 * A `Function` that will be called once for each created `Feature`, after it has
	 * been created and styled. Useful for attaching events and popups to features.
	 * The default is to do nothing with the newly created layers:
	 * ```js
	 * function (feature, layer) {}
	 * ```
	 *
	 * @option filter: Function = *
	 * A `Function` that will be used to decide whether to include a feature or not.
	 * The default is to include all features:
	 * ```js
	 * function (geoJsonFeature) {
	 * 	return true;
	 * }
	 * ```
	 * Note: dynamically changing the `filter` option will have effect only on newly
	 * added data. It will _not_ re-evaluate already included features.
	 *
	 * @option coordsToLatLng: Function = *
	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
	 * The default is the `coordsToLatLng` static method.
	 */

	initialize: function (geojson, options) {
		L.setOptions(this, options);

		this._layers = {};

		if (geojson) {
			this.addData(geojson);
		}
	},

	// @method addData( <GeoJSON> data ): Layer
	// Adds a GeoJSON object to the layer.
	addData: function (geojson) {
		var features = L.Util.isArray(geojson) ? geojson : geojson.features,
		    i, len, feature;

		if (features) {
			for (i = 0, len = features.length; i < len; i++) {
				// only add this if geometry or geometries are set and not null
				feature = features[i];
				if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
					this.addData(feature);
				}
			}
			return this;
		}

		var options = this.options;

		if (options.filter && !options.filter(geojson)) { return this; }

		var layer = L.GeoJSON.geometryToLayer(geojson, options);
		if (!layer) {
			return this;
		}
		layer.feature = L.GeoJSON.asFeature(geojson);

		layer.defaultOptions = layer.options;
		this.resetStyle(layer);

		if (options.onEachFeature) {
			options.onEachFeature(geojson, layer);
		}

		return this.addLayer(layer);
	},

	// @method resetStyle( <Path> layer ): Layer
	// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
	resetStyle: function (layer) {
		// reset any custom styles
		layer.options = L.Util.extend({}, layer.defaultOptions);
		this._setLayerStyle(layer, this.options.style);
		return this;
	},

	// @method setStyle( <Function> style ): Layer
	// Changes styles of GeoJSON vector layers with the given style function.
	setStyle: function (style) {
		return this.eachLayer(function (layer) {
			this._setLayerStyle(layer, style);
		}, this);
	},

	_setLayerStyle: function (layer, style) {
		if (typeof style === 'function') {
			style = style(layer.feature);
		}
		if (layer.setStyle) {
			layer.setStyle(style);
		}
	}
});

// @section
// There are several static functions which can be called without instantiating L.GeoJSON:
L.extend(L.GeoJSON, {
	// @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
	// Creates a `Layer` from a given GeoJSON feature. Can use a custom
	// [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
	// functions if provided as options.
	geometryToLayer: function (geojson, options) {

		var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
		    coords = geometry ? geometry.coordinates : null,
		    layers = [],
		    pointToLayer = options && options.pointToLayer,
		    coordsToLatLng = options && options.coordsToLatLng || this.coordsToLatLng,
		    latlng, latlngs, i, len;

		if (!coords && !geometry) {
			return null;
		}

		switch (geometry.type) {
		case 'Point':
			latlng = coordsToLatLng(coords);
			return pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng);

		case 'MultiPoint':
			for (i = 0, len = coords.length; i < len; i++) {
				latlng = coordsToLatLng(coords[i]);
				layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng));
			}
			return new L.FeatureGroup(layers);

		case 'LineString':
		case 'MultiLineString':
			latlngs = this.coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, coordsToLatLng);
			return new L.Polyline(latlngs, options);

		case 'Polygon':
		case 'MultiPolygon':
			latlngs = this.coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, coordsToLatLng);
			return new L.Polygon(latlngs, options);

		case 'GeometryCollection':
			for (i = 0, len = geometry.geometries.length; i < len; i++) {
				var layer = this.geometryToLayer({
					geometry: geometry.geometries[i],
					type: 'Feature',
					properties: geojson.properties
				}, options);

				if (layer) {
					layers.push(layer);
				}
			}
			return new L.FeatureGroup(layers);

		default:
			throw new Error('Invalid GeoJSON object.');
		}
	},

	// @function coordsToLatLng(coords: Array): LatLng
	// Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
	// or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
	coordsToLatLng: function (coords) {
		return new L.LatLng(coords[1], coords[0], coords[2]);
	},

	// @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
	// Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
	// `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
	// Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
	coordsToLatLngs: function (coords, levelsDeep, coordsToLatLng) {
		var latlngs = [];

		for (var i = 0, len = coords.length, latlng; i < len; i++) {
			latlng = levelsDeep ?
			        this.coordsToLatLngs(coords[i], levelsDeep - 1, coordsToLatLng) :
			        (coordsToLatLng || this.coordsToLatLng)(coords[i]);

			latlngs.push(latlng);
		}

		return latlngs;
	},

	// @function latLngToCoords(latlng: LatLng): Array
	// Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
	latLngToCoords: function (latlng) {
		return latlng.alt !== undefined ?
				[latlng.lng, latlng.lat, latlng.alt] :
				[latlng.lng, latlng.lat];
	},

	// @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
	// Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
	// `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
	latLngsToCoords: function (latlngs, levelsDeep, closed) {
		var coords = [];

		for (var i = 0, len = latlngs.length; i < len; i++) {
			coords.push(levelsDeep ?
				L.GeoJSON.latLngsToCoords(latlngs[i], levelsDeep - 1, closed) :
				L.GeoJSON.latLngToCoords(latlngs[i]));
		}

		if (!levelsDeep && closed) {
			coords.push(coords[0]);
		}

		return coords;
	},

	getFeature: function (layer, newGeometry) {
		return layer.feature ?
				L.extend({}, layer.feature, {geometry: newGeometry}) :
				L.GeoJSON.asFeature(newGeometry);
	},

	// @function asFeature(geojson: Object): Object
	// Normalize GeoJSON geometries/features into GeoJSON features.
	asFeature: function (geojson) {
		if (geojson.type === 'Feature') {
			return geojson;
		}

		return {
			type: 'Feature',
			properties: {},
			geometry: geojson
		};
	}
});

var PointToGeoJSON = {
	toGeoJSON: function () {
		return L.GeoJSON.getFeature(this, {
			type: 'Point',
			coordinates: L.GeoJSON.latLngToCoords(this.getLatLng())
		});
	}
};

L.Marker.include(PointToGeoJSON);

// @namespace CircleMarker
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
L.Circle.include(PointToGeoJSON);
L.CircleMarker.include(PointToGeoJSON);


// @namespace Polyline
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
L.Polyline.prototype.toGeoJSON = function () {
	var multi = !L.Polyline._flat(this._latlngs);

	var coords = L.GeoJSON.latLngsToCoords(this._latlngs, multi ? 1 : 0);

	return L.GeoJSON.getFeature(this, {
		type: (multi ? 'Multi' : '') + 'LineString',
		coordinates: coords
	});
};

// @namespace Polygon
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
L.Polygon.prototype.toGeoJSON = function () {
	var holes = !L.Polyline._flat(this._latlngs),
	    multi = holes && !L.Polyline._flat(this._latlngs[0]);

	var coords = L.GeoJSON.latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true);

	if (!holes) {
		coords = [coords];
	}

	return L.GeoJSON.getFeature(this, {
		type: (multi ? 'Multi' : '') + 'Polygon',
		coordinates: coords
	});
};


// @namespace LayerGroup
L.LayerGroup.include({
	toMultiPoint: function () {
		var coords = [];

		this.eachLayer(function (layer) {
			coords.push(layer.toGeoJSON().geometry.coordinates);
		});

		return L.GeoJSON.getFeature(this, {
			type: 'MultiPoint',
			coordinates: coords
		});
	},

	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `GeometryCollection`).
	toGeoJSON: function () {

		var type = this.feature && this.feature.geometry && this.feature.geometry.type;

		if (type === 'MultiPoint') {
			return this.toMultiPoint();
		}

		var isGeometryCollection = type === 'GeometryCollection',
		    jsons = [];

		this.eachLayer(function (layer) {
			if (layer.toGeoJSON) {
				var json = layer.toGeoJSON();
				jsons.push(isGeometryCollection ? json.geometry : L.GeoJSON.asFeature(json));
			}
		});

		if (isGeometryCollection) {
			return L.GeoJSON.getFeature(this, {
				geometries: jsons,
				type: 'GeometryCollection'
			});
		}

		return {
			type: 'FeatureCollection',
			features: jsons
		};
	}
});

// @namespace GeoJSON
// @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
// Creates a GeoJSON layer. Optionally accepts an object in
// [GeoJSON format](http://geojson.org/geojson-spec.html) to display on the map
// (you can alternatively add it later with `addData` method) and an `options` object.
L.geoJSON = function (geojson, options) {
	return new L.GeoJSON(geojson, options);
};
// Backward compatibility.
L.geoJson = L.geoJSON;

/*
 * @namespace DomEvent
 * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
 */

// Inspired by John Resig, Dean Edwards and YUI addEvent implementations.



var eventsKey = '_leaflet_events';

L.DomEvent = {

	// @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
	// Adds a listener function (`fn`) to a particular DOM event type of the
	// element `el`. You can optionally specify the context of the listener
	// (object the `this` keyword will point to). You can also pass several
	// space-separated types (e.g. `'click dblclick'`).

	// @alternative
	// @function on(el: HTMLElement, eventMap: Object, context?: Object): this
	// Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	on: function (obj, types, fn, context) {

		if (typeof types === 'object') {
			for (var type in types) {
				this._on(obj, type, types[type], fn);
			}
		} else {
			types = L.Util.splitWords(types);

			for (var i = 0, len = types.length; i < len; i++) {
				this._on(obj, types[i], fn, context);
			}
		}

		return this;
	},

	// @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
	// Removes a previously added listener function. If no function is specified,
	// it will remove all the listeners of that particular DOM event from the element.
	// Note that if you passed a custom context to on, you must pass the same
	// context to `off` in order to remove the listener.

	// @alternative
	// @function off(el: HTMLElement, eventMap: Object, context?: Object): this
	// Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	off: function (obj, types, fn, context) {

		if (typeof types === 'object') {
			for (var type in types) {
				this._off(obj, type, types[type], fn);
			}
		} else {
			types = L.Util.splitWords(types);

			for (var i = 0, len = types.length; i < len; i++) {
				this._off(obj, types[i], fn, context);
			}
		}

		return this;
	},

	_on: function (obj, type, fn, context) {
		var id = type + L.stamp(fn) + (context ? '_' + L.stamp(context) : '');

		if (obj[eventsKey] && obj[eventsKey][id]) { return this; }

		var handler = function (e) {
			return fn.call(context || obj, e || window.event);
		};

		var originalHandler = handler;

		if (L.Browser.pointer && type.indexOf('touch') === 0) {
			this.addPointerListener(obj, type, handler, id);

		} else if (L.Browser.touch && (type === 'dblclick') && this.addDoubleTapListener) {
			this.addDoubleTapListener(obj, handler, id);

		} else if ('addEventListener' in obj) {

			if (type === 'mousewheel') {
				obj.addEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);

			} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
				handler = function (e) {
					e = e || window.event;
					if (L.DomEvent._isExternalTarget(obj, e)) {
						originalHandler(e);
					}
				};
				obj.addEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);

			} else {
				if (type === 'click' && L.Browser.android) {
					handler = function (e) {
						return L.DomEvent._filterClick(e, originalHandler);
					};
				}
				obj.addEventListener(type, handler, false);
			}

		} else if ('attachEvent' in obj) {
			obj.attachEvent('on' + type, handler);
		}

		obj[eventsKey] = obj[eventsKey] || {};
		obj[eventsKey][id] = handler;

		return this;
	},

	_off: function (obj, type, fn, context) {

		var id = type + L.stamp(fn) + (context ? '_' + L.stamp(context) : ''),
		    handler = obj[eventsKey] && obj[eventsKey][id];

		if (!handler) { return this; }

		if (L.Browser.pointer && type.indexOf('touch') === 0) {
			this.removePointerListener(obj, type, id);

		} else if (L.Browser.touch && (type === 'dblclick') && this.removeDoubleTapListener) {
			this.removeDoubleTapListener(obj, id);

		} else if ('removeEventListener' in obj) {

			if (type === 'mousewheel') {
				obj.removeEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);

			} else {
				obj.removeEventListener(
					type === 'mouseenter' ? 'mouseover' :
					type === 'mouseleave' ? 'mouseout' : type, handler, false);
			}

		} else if ('detachEvent' in obj) {
			obj.detachEvent('on' + type, handler);
		}

		obj[eventsKey][id] = null;

		return this;
	},

	// @function stopPropagation(ev: DOMEvent): this
	// Stop the given event from propagation to parent elements. Used inside the listener functions:
	// ```js
	// L.DomEvent.on(div, 'click', function (ev) {
	// 	L.DomEvent.stopPropagation(ev);
	// });
	// ```
	stopPropagation: function (e) {

		if (e.stopPropagation) {
			e.stopPropagation();
		} else if (e.originalEvent) {  // In case of Leaflet event.
			e.originalEvent._stopped = true;
		} else {
			e.cancelBubble = true;
		}
		L.DomEvent._skipped(e);

		return this;
	},

	// @function disableScrollPropagation(el: HTMLElement): this
	// Adds `stopPropagation` to the element's `'mousewheel'` events (plus browser variants).
	disableScrollPropagation: function (el) {
		return L.DomEvent.on(el, 'mousewheel', L.DomEvent.stopPropagation);
	},

	// @function disableClickPropagation(el: HTMLElement): this
	// Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
	// `'mousedown'` and `'touchstart'` events (plus browser variants).
	disableClickPropagation: function (el) {
		var stop = L.DomEvent.stopPropagation;

		L.DomEvent.on(el, L.Draggable.START.join(' '), stop);

		return L.DomEvent.on(el, {
			click: L.DomEvent._fakeStop,
			dblclick: stop
		});
	},

	// @function preventDefault(ev: DOMEvent): this
	// Prevents the default action of the DOM Event `ev` from happening (such as
	// following a link in the href of the a element, or doing a POST request
	// with page reload when a `<form>` is submitted).
	// Use it inside listener functions.
	preventDefault: function (e) {

		if (e.preventDefault) {
			e.preventDefault();
		} else {
			e.returnValue = false;
		}
		return this;
	},

	// @function stop(ev): this
	// Does `stopPropagation` and `preventDefault` at the same time.
	stop: function (e) {
		return L.DomEvent
			.preventDefault(e)
			.stopPropagation(e);
	},

	// @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
	// Gets normalized mouse position from a DOM event relative to the
	// `container` or to the whole page if not specified.
	getMousePosition: function (e, container) {
		if (!container) {
			return new L.Point(e.clientX, e.clientY);
		}

		var rect = container.getBoundingClientRect();

		return new L.Point(
			e.clientX - rect.left - container.clientLeft,
			e.clientY - rect.top - container.clientTop);
	},

	// Chrome on Win scrolls double the pixels as in other platforms (see #4538),
	// and Firefox scrolls device pixels, not CSS pixels
	_wheelPxFactor: (L.Browser.win && L.Browser.chrome) ? 2 :
	                L.Browser.gecko ? window.devicePixelRatio :
	                1,

	// @function getWheelDelta(ev: DOMEvent): Number
	// Gets normalized wheel delta from a mousewheel DOM event, in vertical
	// pixels scrolled (negative if scrolling down).
	// Events from pointing devices without precise scrolling are mapped to
	// a best guess of 60 pixels.
	getWheelDelta: function (e) {
		return (L.Browser.edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
		       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / L.DomEvent._wheelPxFactor : // Pixels
		       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
		       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
		       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
		       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
		       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
		       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
		       0;
	},

	_skipEvents: {},

	_fakeStop: function (e) {
		// fakes stopPropagation by setting a special event flag, checked/reset with L.DomEvent._skipped(e)
		L.DomEvent._skipEvents[e.type] = true;
	},

	_skipped: function (e) {
		var skipped = this._skipEvents[e.type];
		// reset when checking, as it's only used in map container and propagates outside of the map
		this._skipEvents[e.type] = false;
		return skipped;
	},

	// check if element really left/entered the event target (for mouseenter/mouseleave)
	_isExternalTarget: function (el, e) {

		var related = e.relatedTarget;

		if (!related) { return true; }

		try {
			while (related && (related !== el)) {
				related = related.parentNode;
			}
		} catch (err) {
			return false;
		}
		return (related !== el);
	},

	// this is a horrible workaround for a bug in Android where a single touch triggers two click events
	_filterClick: function (e, handler) {
		var timeStamp = (e.timeStamp || (e.originalEvent && e.originalEvent.timeStamp)),
		    elapsed = L.DomEvent._lastClick && (timeStamp - L.DomEvent._lastClick);

		// are they closer together than 500ms yet more than 100ms?
		// Android typically triggers them ~300ms apart while multiple listeners
		// on the same event should be triggered far faster;
		// or check if click is simulated on the element, and if it is, reject any non-simulated events

		if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
			L.DomEvent.stop(e);
			return;
		}
		L.DomEvent._lastClick = timeStamp;

		handler(e);
	}
};

// @function addListener(…): this
// Alias to [`L.DomEvent.on`](#domevent-on)
L.DomEvent.addListener = L.DomEvent.on;

// @function removeListener(…): this
// Alias to [`L.DomEvent.off`](#domevent-off)
L.DomEvent.removeListener = L.DomEvent.off;

/*
 * @class Draggable
 * @aka L.Draggable
 * @inherits Evented
 *
 * A class for making DOM elements draggable (including touch support).
 * Used internally for map and marker dragging. Only works for elements
 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
 *
 * @example
 * ```js
 * var draggable = new L.Draggable(elementToDrag);
 * draggable.enable();
 * ```
 */

L.Draggable = L.Evented.extend({

	options: {
		// @option clickTolerance: Number = 3
		// The max number of pixels a user can shift the mouse pointer during a click
		// for it to be considered a valid click (as opposed to a mouse drag).
		clickTolerance: 3
	},

	statics: {
		START: L.Browser.touch ? ['touchstart', 'mousedown'] : ['mousedown'],
		END: {
			mousedown: 'mouseup',
			touchstart: 'touchend',
			pointerdown: 'touchend',
			MSPointerDown: 'touchend'
		},
		MOVE: {
			mousedown: 'mousemove',
			touchstart: 'touchmove',
			pointerdown: 'touchmove',
			MSPointerDown: 'touchmove'
		}
	},

	// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline: Boolean)
	// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
	initialize: function (element, dragStartTarget, preventOutline) {
		this._element = element;
		this._dragStartTarget = dragStartTarget || element;
		this._preventOutline = preventOutline;
	},

	// @method enable()
	// Enables the dragging ability
	enable: function () {
		if (this._enabled) { return; }

		L.DomEvent.on(this._dragStartTarget, L.Draggable.START.join(' '), this._onDown, this);

		this._enabled = true;
	},

	// @method disable()
	// Disables the dragging ability
	disable: function () {
		if (!this._enabled) { return; }

		L.DomEvent.off(this._dragStartTarget, L.Draggable.START.join(' '), this._onDown, this);

		this._enabled = false;
		this._moved = false;
	},

	_onDown: function (e) {
		// Ignore simulated events, since we handle both touch and
		// mouse explicitly; otherwise we risk getting duplicates of
		// touch events, see #4315.
		// Also ignore the event if disabled; this happens in IE11
		// under some circumstances, see #3666.
		if (e._simulated || !this._enabled) { return; }

		this._moved = false;

		if (L.DomUtil.hasClass(this._element, 'leaflet-zoom-anim')) { return; }

		if (L.Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches) || !this._enabled) { return; }
		L.Draggable._dragging = true;  // Prevent dragging multiple objects at once.

		if (this._preventOutline) {
			L.DomUtil.preventOutline(this._element);
		}

		L.DomUtil.disableImageDrag();
		L.DomUtil.disableTextSelection();

		if (this._moving) { return; }

		// @event down: Event
		// Fired when a drag is about to start.
		this.fire('down');

		var first = e.touches ? e.touches[0] : e;

		this._startPoint = new L.Point(first.clientX, first.clientY);

		L.DomEvent
			.on(document, L.Draggable.MOVE[e.type], this._onMove, this)
			.on(document, L.Draggable.END[e.type], this._onUp, this);
	},

	_onMove: function (e) {
		// Ignore simulated events, since we handle both touch and
		// mouse explicitly; otherwise we risk getting duplicates of
		// touch events, see #4315.
		// Also ignore the event if disabled; this happens in IE11
		// under some circumstances, see #3666.
		if (e._simulated || !this._enabled) { return; }

		if (e.touches && e.touches.length > 1) {
			this._moved = true;
			return;
		}

		var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
		    newPoint = new L.Point(first.clientX, first.clientY),
		    offset = newPoint.subtract(this._startPoint);

		if (!offset.x && !offset.y) { return; }
		if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }

		L.DomEvent.preventDefault(e);

		if (!this._moved) {
			// @event dragstart: Event
			// Fired when a drag starts
			this.fire('dragstart');

			this._moved = true;
			this._startPos = L.DomUtil.getPosition(this._element).subtract(offset);

			L.DomUtil.addClass(document.body, 'leaflet-dragging');

			this._lastTarget = e.target || e.srcElement;
			// IE and Edge do not give the <use> element, so fetch it
			// if necessary
			if ((window.SVGElementInstance) && (this._lastTarget instanceof SVGElementInstance)) {
				this._lastTarget = this._lastTarget.correspondingUseElement;
			}
			L.DomUtil.addClass(this._lastTarget, 'leaflet-drag-target');
		}

		this._newPos = this._startPos.add(offset);
		this._moving = true;

		L.Util.cancelAnimFrame(this._animRequest);
		this._lastEvent = e;
		this._animRequest = L.Util.requestAnimFrame(this._updatePosition, this, true);
	},

	_updatePosition: function () {
		var e = {originalEvent: this._lastEvent};

		// @event predrag: Event
		// Fired continuously during dragging *before* each corresponding
		// update of the element's position.
		this.fire('predrag', e);
		L.DomUtil.setPosition(this._element, this._newPos);

		// @event drag: Event
		// Fired continuously during dragging.
		this.fire('drag', e);
	},

	_onUp: function (e) {
		// Ignore simulated events, since we handle both touch and
		// mouse explicitly; otherwise we risk getting duplicates of
		// touch events, see #4315.
		// Also ignore the event if disabled; this happens in IE11
		// under some circumstances, see #3666.
		if (e._simulated || !this._enabled) { return; }

		L.DomUtil.removeClass(document.body, 'leaflet-dragging');

		if (this._lastTarget) {
			L.DomUtil.removeClass(this._lastTarget, 'leaflet-drag-target');
			this._lastTarget = null;
		}

		for (var i in L.Draggable.MOVE) {
			L.DomEvent
				.off(document, L.Draggable.MOVE[i], this._onMove, this)
				.off(document, L.Draggable.END[i], this._onUp, this);
		}

		L.DomUtil.enableImageDrag();
		L.DomUtil.enableTextSelection();

		if (this._moved && this._moving) {
			// ensure drag is not fired after dragend
			L.Util.cancelAnimFrame(this._animRequest);

			// @event dragend: DragEndEvent
			// Fired when the drag ends.
			this.fire('dragend', {
				distance: this._newPos.distanceTo(this._startPos)
			});
		}

		this._moving = false;
		L.Draggable._dragging = false;
	}
});

/*
	L.Handler is a base class for handler classes that are used internally to inject
	interaction features like dragging to classes like Map and Marker.
*/

// @class Handler
// @aka L.Handler
// Abstract class for map interaction handlers

L.Handler = L.Class.extend({
	initialize: function (map) {
		this._map = map;
	},

	// @method enable(): this
	// Enables the handler
	enable: function () {
		if (this._enabled) { return this; }

		this._enabled = true;
		this.addHooks();
		return this;
	},

	// @method disable(): this
	// Disables the handler
	disable: function () {
		if (!this._enabled) { return this; }

		this._enabled = false;
		this.removeHooks();
		return this;
	},

	// @method enabled(): Boolean
	// Returns `true` if the handler is enabled
	enabled: function () {
		return !!this._enabled;
	}

	// @section Extension methods
	// Classes inheriting from `Handler` must implement the two following methods:
	// @method addHooks()
	// Called when the handler is enabled, should add event hooks.
	// @method removeHooks()
	// Called when the handler is disabled, should remove the event hooks added previously.
});

/*
 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
 */

// @namespace Map
// @section Interaction Options
L.Map.mergeOptions({
	// @option dragging: Boolean = true
	// Whether the map be draggable with mouse/touch or not.
	dragging: true,

	// @section Panning Inertia Options
	// @option inertia: Boolean = *
	// If enabled, panning of the map will have an inertia effect where
	// the map builds momentum while dragging and continues moving in
	// the same direction for some time. Feels especially nice on touch
	// devices. Enabled by default unless running on old Android devices.
	inertia: !L.Browser.android23,

	// @option inertiaDeceleration: Number = 3000
	// The rate with which the inertial movement slows down, in pixels/second².
	inertiaDeceleration: 3400, // px/s^2

	// @option inertiaMaxSpeed: Number = Infinity
	// Max speed of the inertial movement, in pixels/second.
	inertiaMaxSpeed: Infinity, // px/s

	// @option easeLinearity: Number = 0.2
	easeLinearity: 0.2,

	// TODO refactor, move to CRS
	// @option worldCopyJump: Boolean = false
	// With this option enabled, the map tracks when you pan to another "copy"
	// of the world and seamlessly jumps to the original one so that all overlays
	// like markers and vector layers are still visible.
	worldCopyJump: false,

	// @option maxBoundsViscosity: Number = 0.0
	// If `maxBounds` is set, this option will control how solid the bounds
	// are when dragging the map around. The default value of `0.0` allows the
	// user to drag outside the bounds at normal speed, higher values will
	// slow down map dragging outside bounds, and `1.0` makes the bounds fully
	// solid, preventing the user from dragging outside the bounds.
	maxBoundsViscosity: 0.0
});

L.Map.Drag = L.Handler.extend({
	addHooks: function () {
		if (!this._draggable) {
			var map = this._map;

			this._draggable = new L.Draggable(map._mapPane, map._container);

			this._draggable.on({
				down: this._onDown,
				dragstart: this._onDragStart,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this);

			this._draggable.on('predrag', this._onPreDragLimit, this);
			if (map.options.worldCopyJump) {
				this._draggable.on('predrag', this._onPreDragWrap, this);
				map.on('zoomend', this._onZoomEnd, this);

				map.whenReady(this._onZoomEnd, this);
			}
		}
		L.DomUtil.addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
		this._draggable.enable();
		this._positions = [];
		this._times = [];
	},

	removeHooks: function () {
		L.DomUtil.removeClass(this._map._container, 'leaflet-grab');
		L.DomUtil.removeClass(this._map._container, 'leaflet-touch-drag');
		this._draggable.disable();
	},

	moved: function () {
		return this._draggable && this._draggable._moved;
	},

	moving: function () {
		return this._draggable && this._draggable._moving;
	},

	_onDown: function () {
		this._map._stop();
	},

	_onDragStart: function () {
		var map = this._map;

		if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
			var bounds = L.latLngBounds(this._map.options.maxBounds);

			this._offsetLimit = L.bounds(
				this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
				this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
					.add(this._map.getSize()));

			this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
		} else {
			this._offsetLimit = null;
		}

		map
		    .fire('movestart')
		    .fire('dragstart');

		if (map.options.inertia) {
			this._positions = [];
			this._times = [];
		}
	},

	_onDrag: function (e) {
		if (this._map.options.inertia) {
			var time = this._lastTime = +new Date(),
			    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;

			this._positions.push(pos);
			this._times.push(time);

			if (time - this._times[0] > 50) {
				this._positions.shift();
				this._times.shift();
			}
		}

		this._map
		    .fire('move', e)
		    .fire('drag', e);
	},

	_onZoomEnd: function () {
		var pxCenter = this._map.getSize().divideBy(2),
		    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);

		this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
		this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
	},

	_viscousLimit: function (value, threshold) {
		return value - (value - threshold) * this._viscosity;
	},

	_onPreDragLimit: function () {
		if (!this._viscosity || !this._offsetLimit) { return; }

		var offset = this._draggable._newPos.subtract(this._draggable._startPos);

		var limit = this._offsetLimit;
		if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
		if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
		if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
		if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }

		this._draggable._newPos = this._draggable._startPos.add(offset);
	},

	_onPreDragWrap: function () {
		// TODO refactor to be able to adjust map pane position after zoom
		var worldWidth = this._worldWidth,
		    halfWidth = Math.round(worldWidth / 2),
		    dx = this._initialWorldOffset,
		    x = this._draggable._newPos.x,
		    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
		    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
		    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;

		this._draggable._absPos = this._draggable._newPos.clone();
		this._draggable._newPos.x = newX;
	},

	_onDragEnd: function (e) {
		var map = this._map,
		    options = map.options,

		    noInertia = !options.inertia || this._times.length < 2;

		map.fire('dragend', e);

		if (noInertia) {
			map.fire('moveend');

		} else {

			var direction = this._lastPos.subtract(this._positions[0]),
			    duration = (this._lastTime - this._times[0]) / 1000,
			    ease = options.easeLinearity,

			    speedVector = direction.multiplyBy(ease / duration),
			    speed = speedVector.distanceTo([0, 0]),

			    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
			    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),

			    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
			    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();

			if (!offset.x && !offset.y) {
				map.fire('moveend');

			} else {
				offset = map._limitOffset(offset, map.options.maxBounds);

				L.Util.requestAnimFrame(function () {
					map.panBy(offset, {
						duration: decelerationDuration,
						easeLinearity: ease,
						noMoveStart: true,
						animate: true
					});
				});
			}
		}
	}
});

// @section Handlers
// @property dragging: Handler
// Map dragging handler (by both mouse and touch).
L.Map.addInitHook('addHandler', 'dragging', L.Map.Drag);

/*
 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
 */

// @namespace Map
// @section Interaction Options

L.Map.mergeOptions({
	// @option doubleClickZoom: Boolean|String = true
	// Whether the map can be zoomed in by double clicking on it and
	// zoomed out by double clicking while holding shift. If passed
	// `'center'`, double-click zoom will zoom to the center of the
	//  view regardless of where the mouse was.
	doubleClickZoom: true
});

L.Map.DoubleClickZoom = L.Handler.extend({
	addHooks: function () {
		this._map.on('dblclick', this._onDoubleClick, this);
	},

	removeHooks: function () {
		this._map.off('dblclick', this._onDoubleClick, this);
	},

	_onDoubleClick: function (e) {
		var map = this._map,
		    oldZoom = map.getZoom(),
		    delta = map.options.zoomDelta,
		    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;

		if (map.options.doubleClickZoom === 'center') {
			map.setZoom(zoom);
		} else {
			map.setZoomAround(e.containerPoint, zoom);
		}
	}
});

// @section Handlers
//
// Map properties include interaction handlers that allow you to control
// interaction behavior in runtime, enabling or disabling certain features such
// as dragging or touch zoom (see `Handler` methods). For example:
//
// ```js
// map.doubleClickZoom.disable();
// ```
//
// @property doubleClickZoom: Handler
// Double click zoom handler.
L.Map.addInitHook('addHandler', 'doubleClickZoom', L.Map.DoubleClickZoom);

/*
 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
 */

// @namespace Map
// @section Interaction Options
L.Map.mergeOptions({
	// @section Mousewheel options
	// @option scrollWheelZoom: Boolean|String = true
	// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
	// it will zoom to the center of the view regardless of where the mouse was.
	scrollWheelZoom: true,

	// @option wheelDebounceTime: Number = 40
	// Limits the rate at which a wheel can fire (in milliseconds). By default
	// user can't zoom via wheel more often than once per 40 ms.
	wheelDebounceTime: 40,

	// @option wheelPxPerZoomLevel: Number = 60
	// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
	// mean a change of one full zoom level. Smaller values will make wheel-zooming
	// faster (and vice versa).
	wheelPxPerZoomLevel: 60
});

L.Map.ScrollWheelZoom = L.Handler.extend({
	addHooks: function () {
		L.DomEvent.on(this._map._container, 'mousewheel', this._onWheelScroll, this);

		this._delta = 0;
	},

	removeHooks: function () {
		L.DomEvent.off(this._map._container, 'mousewheel', this._onWheelScroll, this);
	},

	_onWheelScroll: function (e) {
		var delta = L.DomEvent.getWheelDelta(e);

		var debounce = this._map.options.wheelDebounceTime;

		this._delta += delta;
		this._lastMousePos = this._map.mouseEventToContainerPoint(e);

		if (!this._startTime) {
			this._startTime = +new Date();
		}

		var left = Math.max(debounce - (+new Date() - this._startTime), 0);

		clearTimeout(this._timer);
		this._timer = setTimeout(L.bind(this._performZoom, this), left);

		L.DomEvent.stop(e);
	},

	_performZoom: function () {
		var map = this._map,
		    zoom = map.getZoom(),
		    snap = this._map.options.zoomSnap || 0;

		map._stop(); // stop panning and fly animations if any

		// map the delta with a sigmoid function to -4..4 range leaning on -1..1
		var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
		    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
		    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
		    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;

		this._delta = 0;
		this._startTime = null;

		if (!delta) { return; }

		if (map.options.scrollWheelZoom === 'center') {
			map.setZoom(zoom + delta);
		} else {
			map.setZoomAround(this._lastMousePos, zoom + delta);
		}
	}
});

// @section Handlers
// @property scrollWheelZoom: Handler
// Scroll wheel zoom handler.
L.Map.addInitHook('addHandler', 'scrollWheelZoom', L.Map.ScrollWheelZoom);

/*
 * @class PosAnimation
 * @aka L.PosAnimation
 * @inherits Evented
 * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
 *
 * @example
 * ```js
 * var fx = new L.PosAnimation();
 * fx.run(el, [300, 500], 0.5);
 * ```
 *
 * @constructor L.PosAnimation()
 * Creates a `PosAnimation` object.
 *
 */

L.PosAnimation = L.Evented.extend({

	// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
	// Run an animation of a given element to a new position, optionally setting
	// duration in seconds (`0.25` by default) and easing linearity factor (3rd
	// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
	// `0.5` by default).
	run: function (el, newPos, duration, easeLinearity) {
		this.stop();

		this._el = el;
		this._inProgress = true;
		this._duration = duration || 0.25;
		this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);

		this._startPos = L.DomUtil.getPosition(el);
		this._offset = newPos.subtract(this._startPos);
		this._startTime = +new Date();

		// @event start: Event
		// Fired when the animation starts
		this.fire('start');

		this._animate();
	},

	// @method stop()
	// Stops the animation (if currently running).
	stop: function () {
		if (!this._inProgress) { return; }

		this._step(true);
		this._complete();
	},

	_animate: function () {
		// animation loop
		this._animId = L.Util.requestAnimFrame(this._animate, this);
		this._step();
	},

	_step: function (round) {
		var elapsed = (+new Date()) - this._startTime,
		    duration = this._duration * 1000;

		if (elapsed < duration) {
			this._runFrame(this._easeOut(elapsed / duration), round);
		} else {
			this._runFrame(1);
			this._complete();
		}
	},

	_runFrame: function (progress, round) {
		var pos = this._startPos.add(this._offset.multiplyBy(progress));
		if (round) {
			pos._round();
		}
		L.DomUtil.setPosition(this._el, pos);

		// @event step: Event
		// Fired continuously during the animation.
		this.fire('step');
	},

	_complete: function () {
		L.Util.cancelAnimFrame(this._animId);

		this._inProgress = false;
		// @event end: Event
		// Fired when the animation ends.
		this.fire('end');
	},

	_easeOut: function (t) {
		return 1 - Math.pow(1 - t, this._easeOutPower);
	}
});

/*
 * Extends L.Map to handle panning animations.
 */

L.Map.include({

	setView: function (center, zoom, options) {

		zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
		center = this._limitCenter(L.latLng(center), zoom, this.options.maxBounds);
		options = options || {};

		this._stop();

		if (this._loaded && !options.reset && options !== true) {

			if (options.animate !== undefined) {
				options.zoom = L.extend({animate: options.animate}, options.zoom);
				options.pan = L.extend({animate: options.animate, duration: options.duration}, options.pan);
			}

			// try animating pan or zoom
			var moved = (this._zoom !== zoom) ?
				this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
				this._tryAnimatedPan(center, options.pan);

			if (moved) {
				// prevent resize handler call, the view will refresh after animation anyway
				clearTimeout(this._sizeTimer);
				return this;
			}
		}

		// animation didn't start, just reset the map view
		this._resetView(center, zoom);

		return this;
	},

	panBy: function (offset, options) {
		offset = L.point(offset).round();
		options = options || {};

		if (!offset.x && !offset.y) {
			return this.fire('moveend');
		}
		// If we pan too far, Chrome gets issues with tiles
		// and makes them disappear or appear in the wrong place (slightly offset) #2602
		if (options.animate !== true && !this.getSize().contains(offset)) {
			this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
			return this;
		}

		if (!this._panAnim) {
			this._panAnim = new L.PosAnimation();

			this._panAnim.on({
				'step': this._onPanTransitionStep,
				'end': this._onPanTransitionEnd
			}, this);
		}

		// don't fire movestart if animating inertia
		if (!options.noMoveStart) {
			this.fire('movestart');
		}

		// animate pan unless animate: false specified
		if (options.animate !== false) {
			L.DomUtil.addClass(this._mapPane, 'leaflet-pan-anim');

			var newPos = this._getMapPanePos().subtract(offset).round();
			this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
		} else {
			this._rawPanBy(offset);
			this.fire('move').fire('moveend');
		}

		return this;
	},

	_onPanTransitionStep: function () {
		this.fire('move');
	},

	_onPanTransitionEnd: function () {
		L.DomUtil.removeClass(this._mapPane, 'leaflet-pan-anim');
		this.fire('moveend');
	},

	_tryAnimatedPan: function (center, options) {
		// difference between the new and current centers in pixels
		var offset = this._getCenterOffset(center)._floor();

		// don't animate too far unless animate: true specified in options
		if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }

		this.panBy(offset, options);

		return true;
	}
});

/*
 * Extends L.Map to handle zoom animations.
 */

// @namespace Map
// @section Animation Options
L.Map.mergeOptions({
	// @option zoomAnimation: Boolean = true
	// Whether the map zoom animation is enabled. By default it's enabled
	// in all browsers that support CSS3 Transitions except Android.
	zoomAnimation: true,

	// @option zoomAnimationThreshold: Number = 4
	// Won't animate zoom if the zoom difference exceeds this value.
	zoomAnimationThreshold: 4
});

var zoomAnimated = L.DomUtil.TRANSITION && L.Browser.any3d && !L.Browser.mobileOpera;

if (zoomAnimated) {

	L.Map.addInitHook(function () {
		// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
		this._zoomAnimated = this.options.zoomAnimation;

		// zoom transitions run with the same duration for all layers, so if one of transitionend events
		// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
		if (this._zoomAnimated) {

			this._createAnimProxy();

			L.DomEvent.on(this._proxy, L.DomUtil.TRANSITION_END, this._catchTransitionEnd, this);
		}
	});
}

L.Map.include(!zoomAnimated ? {} : {

	_createAnimProxy: function () {

		var proxy = this._proxy = L.DomUtil.create('div', 'leaflet-proxy leaflet-zoom-animated');
		this._panes.mapPane.appendChild(proxy);

		this.on('zoomanim', function (e) {
			var prop = L.DomUtil.TRANSFORM,
			    transform = proxy.style[prop];

			L.DomUtil.setTransform(proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));

			// workaround for case when transform is the same and so transitionend event is not fired
			if (transform === proxy.style[prop] && this._animatingZoom) {
				this._onZoomTransitionEnd();
			}
		}, this);

		this.on('load moveend', function () {
			var c = this.getCenter(),
			    z = this.getZoom();
			L.DomUtil.setTransform(proxy, this.project(c, z), this.getZoomScale(z, 1));
		}, this);
	},

	_catchTransitionEnd: function (e) {
		if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
			this._onZoomTransitionEnd();
		}
	},

	_nothingToAnimate: function () {
		return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
	},

	_tryAnimatedZoom: function (center, zoom, options) {

		if (this._animatingZoom) { return true; }

		options = options || {};

		// don't animate if disabled, not supported or zoom difference is too large
		if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
		        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }

		// offset is the pixel coords of the zoom origin relative to the current center
		var scale = this.getZoomScale(zoom),
		    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);

		// don't animate if the zoom origin isn't within one screen from the current center, unless forced
		if (options.animate !== true && !this.getSize().contains(offset)) { return false; }

		L.Util.requestAnimFrame(function () {
			this
			    ._moveStart(true)
			    ._animateZoom(center, zoom, true);
		}, this);

		return true;
	},

	_animateZoom: function (center, zoom, startAnim, noUpdate) {
		if (startAnim) {
			this._animatingZoom = true;

			// remember what center/zoom to set after animation
			this._animateToCenter = center;
			this._animateToZoom = zoom;

			L.DomUtil.addClass(this._mapPane, 'leaflet-zoom-anim');
		}

		// @event zoomanim: ZoomAnimEvent
		// Fired on every frame of a zoom animation
		this.fire('zoomanim', {
			center: center,
			zoom: zoom,
			noUpdate: noUpdate
		});

		// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
		setTimeout(L.bind(this._onZoomTransitionEnd, this), 250);
	},

	_onZoomTransitionEnd: function () {
		if (!this._animatingZoom) { return; }

		L.DomUtil.removeClass(this._mapPane, 'leaflet-zoom-anim');

		this._animatingZoom = false;

		this._move(this._animateToCenter, this._animateToZoom);

		// This anim frame should prevent an obscure iOS webkit tile loading race condition.
		L.Util.requestAnimFrame(function () {
			this._moveEnd(true);
		}, this);
	}
});

// @namespace Map
// @section Methods for modifying map state
L.Map.include({

	// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
	// Sets the view of the map (geographical center and zoom) performing a smooth
	// pan-zoom animation.
	flyTo: function (targetCenter, targetZoom, options) {

		options = options || {};
		if (options.animate === false || !L.Browser.any3d) {
			return this.setView(targetCenter, targetZoom, options);
		}

		this._stop();

		var from = this.project(this.getCenter()),
		    to = this.project(targetCenter),
		    size = this.getSize(),
		    startZoom = this._zoom;

		targetCenter = L.latLng(targetCenter);
		targetZoom = targetZoom === undefined ? startZoom : targetZoom;

		var w0 = Math.max(size.x, size.y),
		    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
		    u1 = (to.distanceTo(from)) || 1,
		    rho = 1.42,
		    rho2 = rho * rho;

		function r(i) {
			var s1 = i ? -1 : 1,
			    s2 = i ? w1 : w0,
			    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
			    b1 = 2 * s2 * rho2 * u1,
			    b = t1 / b1,
			    sq = Math.sqrt(b * b + 1) - b;

			    // workaround for floating point precision bug when sq = 0, log = -Infinite,
			    // thus triggering an infinite loop in flyTo
			    var log = sq < 0.000000001 ? -18 : Math.log(sq);

			return log;
		}

		function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
		function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
		function tanh(n) { return sinh(n) / cosh(n); }

		var r0 = r(0);

		function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
		function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }

		function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }

		var start = Date.now(),
		    S = (r(1) - r0) / rho,
		    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;

		function frame() {
			var t = (Date.now() - start) / duration,
			    s = easeOut(t) * S;

			if (t <= 1) {
				this._flyToFrame = L.Util.requestAnimFrame(frame, this);

				this._move(
					this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
					this.getScaleZoom(w0 / w(s), startZoom),
					{flyTo: true});

			} else {
				this
					._move(targetCenter, targetZoom)
					._moveEnd(true);
			}
		}

		this._moveStart(true);

		frame.call(this);
		return this;
	},

	// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
	// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
	// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
	flyToBounds: function (bounds, options) {
		var target = this._getBoundsCenterZoom(bounds, options);
		return this.flyTo(target.center, target.zoom, options);
	}
});

/*
 * Extends the event handling code with double tap support for mobile browsers.
 */

L.extend(L.DomEvent, {

	_touchstart: L.Browser.msPointer ? 'MSPointerDown' : L.Browser.pointer ? 'pointerdown' : 'touchstart',
	_touchend: L.Browser.msPointer ? 'MSPointerUp' : L.Browser.pointer ? 'pointerup' : 'touchend',

	// inspired by Zepto touch code by Thomas Fuchs
	addDoubleTapListener: function (obj, handler, id) {
		var last, touch,
		    doubleTap = false,
		    delay = 250;

		function onTouchStart(e) {
			var count;

			if (L.Browser.pointer) {
				count = L.DomEvent._pointersCount;
			} else {
				count = e.touches.length;
			}

			if (count > 1) { return; }

			var now = Date.now(),
			    delta = now - (last || now);

			touch = e.touches ? e.touches[0] : e;
			doubleTap = (delta > 0 && delta <= delay);
			last = now;
		}

		function onTouchEnd() {
			if (doubleTap && !touch.cancelBubble) {
				if (L.Browser.pointer) {
					// work around .type being readonly with MSPointer* events
					var newTouch = {},
					    prop, i;

					for (i in touch) {
						prop = touch[i];
						newTouch[i] = prop && prop.bind ? prop.bind(touch) : prop;
					}
					touch = newTouch;
				}
				touch.type = 'dblclick';
				handler(touch);
				last = null;
			}
		}

		var pre = '_leaflet_',
		    touchstart = this._touchstart,
		    touchend = this._touchend;

		obj[pre + touchstart + id] = onTouchStart;
		obj[pre + touchend + id] = onTouchEnd;
		obj[pre + 'dblclick' + id] = handler;

		obj.addEventListener(touchstart, onTouchStart, false);
		obj.addEventListener(touchend, onTouchEnd, false);

		// On some platforms (notably, chrome on win10 + touchscreen + mouse),
		// the browser doesn't fire touchend/pointerup events but does fire
		// native dblclicks. See #4127.
		if (!L.Browser.edge) {
			obj.addEventListener('dblclick', handler, false);
		}

		return this;
	},

	removeDoubleTapListener: function (obj, id) {
		var pre = '_leaflet_',
		    touchstart = obj[pre + this._touchstart + id],
		    touchend = obj[pre + this._touchend + id],
		    dblclick = obj[pre + 'dblclick' + id];

		obj.removeEventListener(this._touchstart, touchstart, false);
		obj.removeEventListener(this._touchend, touchend, false);
		if (!L.Browser.edge) {
			obj.removeEventListener('dblclick', dblclick, false);
		}

		return this;
	}
});

/*
 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
 */

L.extend(L.DomEvent, {

	POINTER_DOWN:   L.Browser.msPointer ? 'MSPointerDown'   : 'pointerdown',
	POINTER_MOVE:   L.Browser.msPointer ? 'MSPointerMove'   : 'pointermove',
	POINTER_UP:     L.Browser.msPointer ? 'MSPointerUp'     : 'pointerup',
	POINTER_CANCEL: L.Browser.msPointer ? 'MSPointerCancel' : 'pointercancel',
	TAG_WHITE_LIST: ['INPUT', 'SELECT', 'OPTION'],

	_pointers: {},
	_pointersCount: 0,

	// Provides a touch events wrapper for (ms)pointer events.
	// ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890

	addPointerListener: function (obj, type, handler, id) {

		if (type === 'touchstart') {
			this._addPointerStart(obj, handler, id);

		} else if (type === 'touchmove') {
			this._addPointerMove(obj, handler, id);

		} else if (type === 'touchend') {
			this._addPointerEnd(obj, handler, id);
		}

		return this;
	},

	removePointerListener: function (obj, type, id) {
		var handler = obj['_leaflet_' + type + id];

		if (type === 'touchstart') {
			obj.removeEventListener(this.POINTER_DOWN, handler, false);

		} else if (type === 'touchmove') {
			obj.removeEventListener(this.POINTER_MOVE, handler, false);

		} else if (type === 'touchend') {
			obj.removeEventListener(this.POINTER_UP, handler, false);
			obj.removeEventListener(this.POINTER_CANCEL, handler, false);
		}

		return this;
	},

	_addPointerStart: function (obj, handler, id) {
		var onDown = L.bind(function (e) {
			if (e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
				// In IE11, some touch events needs to fire for form controls, or
				// the controls will stop working. We keep a whitelist of tag names that
				// need these events. For other target tags, we prevent default on the event.
				if (this.TAG_WHITE_LIST.indexOf(e.target.tagName) < 0) {
					L.DomEvent.preventDefault(e);
				} else {
					return;
				}
			}

			this._handlePointer(e, handler);
		}, this);

		obj['_leaflet_touchstart' + id] = onDown;
		obj.addEventListener(this.POINTER_DOWN, onDown, false);

		// need to keep track of what pointers and how many are active to provide e.touches emulation
		if (!this._pointerDocListener) {
			var pointerUp = L.bind(this._globalPointerUp, this);

			// we listen documentElement as any drags that end by moving the touch off the screen get fired there
			document.documentElement.addEventListener(this.POINTER_DOWN, L.bind(this._globalPointerDown, this), true);
			document.documentElement.addEventListener(this.POINTER_MOVE, L.bind(this._globalPointerMove, this), true);
			document.documentElement.addEventListener(this.POINTER_UP, pointerUp, true);
			document.documentElement.addEventListener(this.POINTER_CANCEL, pointerUp, true);

			this._pointerDocListener = true;
		}
	},

	_globalPointerDown: function (e) {
		this._pointers[e.pointerId] = e;
		this._pointersCount++;
	},

	_globalPointerMove: function (e) {
		if (this._pointers[e.pointerId]) {
			this._pointers[e.pointerId] = e;
		}
	},

	_globalPointerUp: function (e) {
		delete this._pointers[e.pointerId];
		this._pointersCount--;
	},

	_handlePointer: function (e, handler) {
		e.touches = [];
		for (var i in this._pointers) {
			e.touches.push(this._pointers[i]);
		}
		e.changedTouches = [e];

		handler(e);
	},

	_addPointerMove: function (obj, handler, id) {
		var onMove = L.bind(function (e) {
			// don't fire touch moves when mouse isn't down
			if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }

			this._handlePointer(e, handler);
		}, this);

		obj['_leaflet_touchmove' + id] = onMove;
		obj.addEventListener(this.POINTER_MOVE, onMove, false);
	},

	_addPointerEnd: function (obj, handler, id) {
		var onUp = L.bind(function (e) {
			this._handlePointer(e, handler);
		}, this);

		obj['_leaflet_touchend' + id] = onUp;
		obj.addEventListener(this.POINTER_UP, onUp, false);
		obj.addEventListener(this.POINTER_CANCEL, onUp, false);
	}
});

/*
 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
 */

// @namespace Map
// @section Interaction Options
L.Map.mergeOptions({
	// @section Touch interaction options
	// @option touchZoom: Boolean|String = *
	// Whether the map can be zoomed by touch-dragging with two fingers. If
	// passed `'center'`, it will zoom to the center of the view regardless of
	// where the touch events (fingers) were. Enabled for touch-capable web
	// browsers except for old Androids.
	touchZoom: L.Browser.touch && !L.Browser.android23,

	// @option bounceAtZoomLimits: Boolean = true
	// Set it to false if you don't want the map to zoom beyond min/max zoom
	// and then bounce back when pinch-zooming.
	bounceAtZoomLimits: true
});

L.Map.TouchZoom = L.Handler.extend({
	addHooks: function () {
		L.DomUtil.addClass(this._map._container, 'leaflet-touch-zoom');
		L.DomEvent.on(this._map._container, 'touchstart', this._onTouchStart, this);
	},

	removeHooks: function () {
		L.DomUtil.removeClass(this._map._container, 'leaflet-touch-zoom');
		L.DomEvent.off(this._map._container, 'touchstart', this._onTouchStart, this);
	},

	_onTouchStart: function (e) {
		var map = this._map;
		if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }

		var p1 = map.mouseEventToContainerPoint(e.touches[0]),
		    p2 = map.mouseEventToContainerPoint(e.touches[1]);

		this._centerPoint = map.getSize()._divideBy(2);
		this._startLatLng = map.containerPointToLatLng(this._centerPoint);
		if (map.options.touchZoom !== 'center') {
			this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
		}

		this._startDist = p1.distanceTo(p2);
		this._startZoom = map.getZoom();

		this._moved = false;
		this._zooming = true;

		map._stop();

		L.DomEvent
		    .on(document, 'touchmove', this._onTouchMove, this)
		    .on(document, 'touchend', this._onTouchEnd, this);

		L.DomEvent.preventDefault(e);
	},

	_onTouchMove: function (e) {
		if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }

		var map = this._map,
		    p1 = map.mouseEventToContainerPoint(e.touches[0]),
		    p2 = map.mouseEventToContainerPoint(e.touches[1]),
		    scale = p1.distanceTo(p2) / this._startDist;


		this._zoom = map.getScaleZoom(scale, this._startZoom);

		if (!map.options.bounceAtZoomLimits && (
			(this._zoom < map.getMinZoom() && scale < 1) ||
			(this._zoom > map.getMaxZoom() && scale > 1))) {
			this._zoom = map._limitZoom(this._zoom);
		}

		if (map.options.touchZoom === 'center') {
			this._center = this._startLatLng;
			if (scale === 1) { return; }
		} else {
			// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
			var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
			if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
			this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
		}

		if (!this._moved) {
			map._moveStart(true);
			this._moved = true;
		}

		L.Util.cancelAnimFrame(this._animRequest);

		var moveFn = L.bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
		this._animRequest = L.Util.requestAnimFrame(moveFn, this, true);

		L.DomEvent.preventDefault(e);
	},

	_onTouchEnd: function () {
		if (!this._moved || !this._zooming) {
			this._zooming = false;
			return;
		}

		this._zooming = false;
		L.Util.cancelAnimFrame(this._animRequest);

		L.DomEvent
		    .off(document, 'touchmove', this._onTouchMove)
		    .off(document, 'touchend', this._onTouchEnd);

		// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
		if (this._map.options.zoomAnimation) {
			this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
		} else {
			this._map._resetView(this._center, this._map._limitZoom(this._zoom));
		}
	}
});

// @section Handlers
// @property touchZoom: Handler
// Touch zoom handler.
L.Map.addInitHook('addHandler', 'touchZoom', L.Map.TouchZoom);

/*
 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
 */

// @namespace Map
// @section Interaction Options
L.Map.mergeOptions({
	// @section Touch interaction options
	// @option tap: Boolean = true
	// Enables mobile hacks for supporting instant taps (fixing 200ms click
	// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
	tap: true,

	// @option tapTolerance: Number = 15
	// The max number of pixels a user can shift his finger during touch
	// for it to be considered a valid tap.
	tapTolerance: 15
});

L.Map.Tap = L.Handler.extend({
	addHooks: function () {
		L.DomEvent.on(this._map._container, 'touchstart', this._onDown, this);
	},

	removeHooks: function () {
		L.DomEvent.off(this._map._container, 'touchstart', this._onDown, this);
	},

	_onDown: function (e) {
		if (!e.touches) { return; }

		L.DomEvent.preventDefault(e);

		this._fireClick = true;

		// don't simulate click or track longpress if more than 1 touch
		if (e.touches.length > 1) {
			this._fireClick = false;
			clearTimeout(this._holdTimeout);
			return;
		}

		var first = e.touches[0],
		    el = first.target;

		this._startPos = this._newPos = new L.Point(first.clientX, first.clientY);

		// if touching a link, highlight it
		if (el.tagName && el.tagName.toLowerCase() === 'a') {
			L.DomUtil.addClass(el, 'leaflet-active');
		}

		// simulate long hold but setting a timeout
		this._holdTimeout = setTimeout(L.bind(function () {
			if (this._isTapValid()) {
				this._fireClick = false;
				this._onUp();
				this._simulateEvent('contextmenu', first);
			}
		}, this), 1000);

		this._simulateEvent('mousedown', first);

		L.DomEvent.on(document, {
			touchmove: this._onMove,
			touchend: this._onUp
		}, this);
	},

	_onUp: function (e) {
		clearTimeout(this._holdTimeout);

		L.DomEvent.off(document, {
			touchmove: this._onMove,
			touchend: this._onUp
		}, this);

		if (this._fireClick && e && e.changedTouches) {

			var first = e.changedTouches[0],
			    el = first.target;

			if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
				L.DomUtil.removeClass(el, 'leaflet-active');
			}

			this._simulateEvent('mouseup', first);

			// simulate click if the touch didn't move too much
			if (this._isTapValid()) {
				this._simulateEvent('click', first);
			}
		}
	},

	_isTapValid: function () {
		return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
	},

	_onMove: function (e) {
		var first = e.touches[0];
		this._newPos = new L.Point(first.clientX, first.clientY);
		this._simulateEvent('mousemove', first);
	},

	_simulateEvent: function (type, e) {
		var simulatedEvent = document.createEvent('MouseEvents');

		simulatedEvent._simulated = true;
		e.target._simulatedClick = true;

		simulatedEvent.initMouseEvent(
		        type, true, true, window, 1,
		        e.screenX, e.screenY,
		        e.clientX, e.clientY,
		        false, false, false, false, 0, null);

		e.target.dispatchEvent(simulatedEvent);
	}
});

// @section Handlers
// @property tap: Handler
// Mobile touch hacks (quick tap and touch hold) handler.
if (L.Browser.touch && !L.Browser.pointer) {
	L.Map.addInitHook('addHandler', 'tap', L.Map.Tap);
}

/*
 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
 * (zoom to a selected bounding box), enabled by default.
 */

// @namespace Map
// @section Interaction Options
L.Map.mergeOptions({
	// @option boxZoom: Boolean = true
	// Whether the map can be zoomed to a rectangular area specified by
	// dragging the mouse while pressing the shift key.
	boxZoom: true
});

L.Map.BoxZoom = L.Handler.extend({
	initialize: function (map) {
		this._map = map;
		this._container = map._container;
		this._pane = map._panes.overlayPane;
	},

	addHooks: function () {
		L.DomEvent.on(this._container, 'mousedown', this._onMouseDown, this);
	},

	removeHooks: function () {
		L.DomEvent.off(this._container, 'mousedown', this._onMouseDown, this);
	},

	moved: function () {
		return this._moved;
	},

	_resetState: function () {
		this._moved = false;
	},

	_onMouseDown: function (e) {
		if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }

		this._resetState();

		L.DomUtil.disableTextSelection();
		L.DomUtil.disableImageDrag();

		this._startPoint = this._map.mouseEventToContainerPoint(e);

		L.DomEvent.on(document, {
			contextmenu: L.DomEvent.stop,
			mousemove: this._onMouseMove,
			mouseup: this._onMouseUp,
			keydown: this._onKeyDown
		}, this);
	},

	_onMouseMove: function (e) {
		if (!this._moved) {
			this._moved = true;

			this._box = L.DomUtil.create('div', 'leaflet-zoom-box', this._container);
			L.DomUtil.addClass(this._container, 'leaflet-crosshair');

			this._map.fire('boxzoomstart');
		}

		this._point = this._map.mouseEventToContainerPoint(e);

		var bounds = new L.Bounds(this._point, this._startPoint),
		    size = bounds.getSize();

		L.DomUtil.setPosition(this._box, bounds.min);

		this._box.style.width  = size.x + 'px';
		this._box.style.height = size.y + 'px';
	},

	_finish: function () {
		if (this._moved) {
			L.DomUtil.remove(this._box);
			L.DomUtil.removeClass(this._container, 'leaflet-crosshair');
		}

		L.DomUtil.enableTextSelection();
		L.DomUtil.enableImageDrag();

		L.DomEvent.off(document, {
			contextmenu: L.DomEvent.stop,
			mousemove: this._onMouseMove,
			mouseup: this._onMouseUp,
			keydown: this._onKeyDown
		}, this);
	},

	_onMouseUp: function (e) {
		if ((e.which !== 1) && (e.button !== 1)) { return; }

		this._finish();

		if (!this._moved) { return; }
		// Postpone to next JS tick so internal click event handling
		// still see it as "moved".
		setTimeout(L.bind(this._resetState, this), 0);

		var bounds = new L.LatLngBounds(
		        this._map.containerPointToLatLng(this._startPoint),
		        this._map.containerPointToLatLng(this._point));

		this._map
			.fitBounds(bounds)
			.fire('boxzoomend', {boxZoomBounds: bounds});
	},

	_onKeyDown: function (e) {
		if (e.keyCode === 27) {
			this._finish();
		}
	}
});

// @section Handlers
// @property boxZoom: Handler
// Box (shift-drag with mouse) zoom handler.
L.Map.addInitHook('addHandler', 'boxZoom', L.Map.BoxZoom);

/*
 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
 */

// @namespace Map
// @section Keyboard Navigation Options
L.Map.mergeOptions({
	// @option keyboard: Boolean = true
	// Makes the map focusable and allows users to navigate the map with keyboard
	// arrows and `+`/`-` keys.
	keyboard: true,

	// @option keyboardPanDelta: Number = 80
	// Amount of pixels to pan when pressing an arrow key.
	keyboardPanDelta: 80
});

L.Map.Keyboard = L.Handler.extend({

	keyCodes: {
		left:    [37],
		right:   [39],
		down:    [40],
		up:      [38],
		zoomIn:  [187, 107, 61, 171],
		zoomOut: [189, 109, 54, 173]
	},

	initialize: function (map) {
		this._map = map;

		this._setPanDelta(map.options.keyboardPanDelta);
		this._setZoomDelta(map.options.zoomDelta);
	},

	addHooks: function () {
		var container = this._map._container;

		// make the container focusable by tabbing
		if (container.tabIndex <= 0) {
			container.tabIndex = '0';
		}

		L.DomEvent.on(container, {
			focus: this._onFocus,
			blur: this._onBlur,
			mousedown: this._onMouseDown
		}, this);

		this._map.on({
			focus: this._addHooks,
			blur: this._removeHooks
		}, this);
	},

	removeHooks: function () {
		this._removeHooks();

		L.DomEvent.off(this._map._container, {
			focus: this._onFocus,
			blur: this._onBlur,
			mousedown: this._onMouseDown
		}, this);

		this._map.off({
			focus: this._addHooks,
			blur: this._removeHooks
		}, this);
	},

	_onMouseDown: function () {
		if (this._focused) { return; }

		var body = document.body,
		    docEl = document.documentElement,
		    top = body.scrollTop || docEl.scrollTop,
		    left = body.scrollLeft || docEl.scrollLeft;

		this._map._container.focus();

		window.scrollTo(left, top);
	},

	_onFocus: function () {
		this._focused = true;
		this._map.fire('focus');
	},

	_onBlur: function () {
		this._focused = false;
		this._map.fire('blur');
	},

	_setPanDelta: function (panDelta) {
		var keys = this._panKeys = {},
		    codes = this.keyCodes,
		    i, len;

		for (i = 0, len = codes.left.length; i < len; i++) {
			keys[codes.left[i]] = [-1 * panDelta, 0];
		}
		for (i = 0, len = codes.right.length; i < len; i++) {
			keys[codes.right[i]] = [panDelta, 0];
		}
		for (i = 0, len = codes.down.length; i < len; i++) {
			keys[codes.down[i]] = [0, panDelta];
		}
		for (i = 0, len = codes.up.length; i < len; i++) {
			keys[codes.up[i]] = [0, -1 * panDelta];
		}
	},

	_setZoomDelta: function (zoomDelta) {
		var keys = this._zoomKeys = {},
		    codes = this.keyCodes,
		    i, len;

		for (i = 0, len = codes.zoomIn.length; i < len; i++) {
			keys[codes.zoomIn[i]] = zoomDelta;
		}
		for (i = 0, len = codes.zoomOut.length; i < len; i++) {
			keys[codes.zoomOut[i]] = -zoomDelta;
		}
	},

	_addHooks: function () {
		L.DomEvent.on(document, 'keydown', this._onKeyDown, this);
	},

	_removeHooks: function () {
		L.DomEvent.off(document, 'keydown', this._onKeyDown, this);
	},

	_onKeyDown: function (e) {
		if (e.altKey || e.ctrlKey || e.metaKey) { return; }

		var key = e.keyCode,
		    map = this._map,
		    offset;

		if (key in this._panKeys) {

			if (map._panAnim && map._panAnim._inProgress) { return; }

			offset = this._panKeys[key];
			if (e.shiftKey) {
				offset = L.point(offset).multiplyBy(3);
			}

			map.panBy(offset);

			if (map.options.maxBounds) {
				map.panInsideBounds(map.options.maxBounds);
			}

		} else if (key in this._zoomKeys) {
			map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);

		} else if (key === 27) {
			map.closePopup();

		} else {
			return;
		}

		L.DomEvent.stop(e);
	}
});

// @section Handlers
// @section Handlers
// @property keyboard: Handler
// Keyboard navigation handler.
L.Map.addInitHook('addHandler', 'keyboard', L.Map.Keyboard);

/*
 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
 */


/* @namespace Marker
 * @section Interaction handlers
 *
 * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
 *
 * ```js
 * marker.dragging.disable();
 * ```
 *
 * @property dragging: Handler
 * Marker dragging handler (by both mouse and touch).
 */

L.Handler.MarkerDrag = L.Handler.extend({
	initialize: function (marker) {
		this._marker = marker;
	},

	addHooks: function () {
		var icon = this._marker._icon;

		if (!this._draggable) {
			this._draggable = new L.Draggable(icon, icon, true);
		}

		this._draggable.on({
			dragstart: this._onDragStart,
			drag: this._onDrag,
			dragend: this._onDragEnd
		}, this).enable();

		L.DomUtil.addClass(icon, 'leaflet-marker-draggable');
	},

	removeHooks: function () {
		this._draggable.off({
			dragstart: this._onDragStart,
			drag: this._onDrag,
			dragend: this._onDragEnd
		}, this).disable();

		if (this._marker._icon) {
			L.DomUtil.removeClass(this._marker._icon, 'leaflet-marker-draggable');
		}
	},

	moved: function () {
		return this._draggable && this._draggable._moved;
	},

	_onDragStart: function () {
		// @section Dragging events
		// @event dragstart: Event
		// Fired when the user starts dragging the marker.

		// @event movestart: Event
		// Fired when the marker starts moving (because of dragging).

		this._oldLatLng = this._marker.getLatLng();
		this._marker
		    .closePopup()
		    .fire('movestart')
		    .fire('dragstart');
	},

	_onDrag: function (e) {
		var marker = this._marker,
		    shadow = marker._shadow,
		    iconPos = L.DomUtil.getPosition(marker._icon),
		    latlng = marker._map.layerPointToLatLng(iconPos);

		// update shadow position
		if (shadow) {
			L.DomUtil.setPosition(shadow, iconPos);
		}

		marker._latlng = latlng;
		e.latlng = latlng;
		e.oldLatLng = this._oldLatLng;

		// @event drag: Event
		// Fired repeatedly while the user drags the marker.
		marker
		    .fire('move', e)
		    .fire('drag', e);
	},

	_onDragEnd: function (e) {
		// @event dragend: DragEndEvent
		// Fired when the user stops dragging the marker.

		// @event moveend: Event
		// Fired when the marker stops moving (because of dragging).
		delete this._oldLatLng;
		this._marker
		    .fire('moveend')
		    .fire('dragend', e);
	}
});

/*
 * @class Control
 * @aka L.Control
 *
 * L.Control is a base class for implementing map controls. Handles positioning.
 * All other controls extend from this class.
 */

L.Control = L.Class.extend({
	// @section
	// @aka Control options
	options: {
		// @option position: String = 'topright'
		// The position of the control (one of the map corners). Possible values are `'topleft'`,
		// `'topright'`, `'bottomleft'` or `'bottomright'`
		position: 'topright'
	},

	initialize: function (options) {
		L.setOptions(this, options);
	},

	/* @section
	 * Classes extending L.Control will inherit the following methods:
	 *
	 * @method getPosition: string
	 * Returns the position of the control.
	 */
	getPosition: function () {
		return this.options.position;
	},

	// @method setPosition(position: string): this
	// Sets the position of the control.
	setPosition: function (position) {
		var map = this._map;

		if (map) {
			map.removeControl(this);
		}

		this.options.position = position;

		if (map) {
			map.addControl(this);
		}

		return this;
	},

	// @method getContainer: HTMLElement
	// Returns the HTMLElement that contains the control.
	getContainer: function () {
		return this._container;
	},

	// @method addTo(map: Map): this
	// Adds the control to the given map.
	addTo: function (map) {
		this.remove();
		this._map = map;

		var container = this._container = this.onAdd(map),
		    pos = this.getPosition(),
		    corner = map._controlCorners[pos];

		L.DomUtil.addClass(container, 'leaflet-control');

		if (pos.indexOf('bottom') !== -1) {
			corner.insertBefore(container, corner.firstChild);
		} else {
			corner.appendChild(container);
		}

		return this;
	},

	// @method remove: this
	// Removes the control from the map it is currently active on.
	remove: function () {
		if (!this._map) {
			return this;
		}

		L.DomUtil.remove(this._container);

		if (this.onRemove) {
			this.onRemove(this._map);
		}

		this._map = null;

		return this;
	},

	_refocusOnMap: function (e) {
		// if map exists and event is not a keyboard event
		if (this._map && e && e.screenX > 0 && e.screenY > 0) {
			this._map.getContainer().focus();
		}
	}
});

L.control = function (options) {
	return new L.Control(options);
};

/* @section Extension methods
 * @uninheritable
 *
 * Every control should extend from `L.Control` and (re-)implement the following methods.
 *
 * @method onAdd(map: Map): HTMLElement
 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
 *
 * @method onRemove(map: Map)
 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
 */

/* @namespace Map
 * @section Methods for Layers and Controls
 */
L.Map.include({
	// @method addControl(control: Control): this
	// Adds the given control to the map
	addControl: function (control) {
		control.addTo(this);
		return this;
	},

	// @method removeControl(control: Control): this
	// Removes the given control from the map
	removeControl: function (control) {
		control.remove();
		return this;
	},

	_initControlPos: function () {
		var corners = this._controlCorners = {},
		    l = 'leaflet-',
		    container = this._controlContainer =
		            L.DomUtil.create('div', l + 'control-container', this._container);

		function createCorner(vSide, hSide) {
			var className = l + vSide + ' ' + l + hSide;

			corners[vSide + hSide] = L.DomUtil.create('div', className, container);
		}

		createCorner('top', 'left');
		createCorner('top', 'right');
		createCorner('bottom', 'left');
		createCorner('bottom', 'right');
	},

	_clearControlPos: function () {
		L.DomUtil.remove(this._controlContainer);
	}
});

/*
 * @class Control.Zoom
 * @aka L.Control.Zoom
 * @inherits Control
 *
 * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
 */

L.Control.Zoom = L.Control.extend({
	// @section
	// @aka Control.Zoom options
	options: {
		position: 'topleft',

		// @option zoomInText: String = '+'
		// The text set on the 'zoom in' button.
		zoomInText: '+',

		// @option zoomInTitle: String = 'Zoom in'
		// The title set on the 'zoom in' button.
		zoomInTitle: 'Zoom in',

		// @option zoomOutText: String = '-'
		// The text set on the 'zoom out' button.
		zoomOutText: '-',

		// @option zoomOutTitle: String = 'Zoom out'
		// The title set on the 'zoom out' button.
		zoomOutTitle: 'Zoom out'
	},

	onAdd: function (map) {
		var zoomName = 'leaflet-control-zoom',
		    container = L.DomUtil.create('div', zoomName + ' leaflet-bar'),
		    options = this.options;

		this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
		        zoomName + '-in',  container, this._zoomIn);
		this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
		        zoomName + '-out', container, this._zoomOut);

		this._updateDisabled();
		map.on('zoomend zoomlevelschange', this._updateDisabled, this);

		return container;
	},

	onRemove: function (map) {
		map.off('zoomend zoomlevelschange', this._updateDisabled, this);
	},

	disable: function () {
		this._disabled = true;
		this._updateDisabled();
		return this;
	},

	enable: function () {
		this._disabled = false;
		this._updateDisabled();
		return this;
	},

	_zoomIn: function (e) {
		if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
			this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
		}
	},

	_zoomOut: function (e) {
		if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
			this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
		}
	},

	_createButton: function (html, title, className, container, fn) {
		var link = L.DomUtil.create('a', className, container);
		link.innerHTML = html;
		link.href = '#';
		link.title = title;

		L.DomEvent
		    .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
		    .on(link, 'click', L.DomEvent.stop)
		    .on(link, 'click', fn, this)
		    .on(link, 'click', this._refocusOnMap, this);

		return link;
	},

	_updateDisabled: function () {
		var map = this._map,
		    className = 'leaflet-disabled';

		L.DomUtil.removeClass(this._zoomInButton, className);
		L.DomUtil.removeClass(this._zoomOutButton, className);

		if (this._disabled || map._zoom === map.getMinZoom()) {
			L.DomUtil.addClass(this._zoomOutButton, className);
		}
		if (this._disabled || map._zoom === map.getMaxZoom()) {
			L.DomUtil.addClass(this._zoomInButton, className);
		}
	}
});

// @namespace Map
// @section Control options
// @option zoomControl: Boolean = true
// Whether a [zoom control](#control-zoom) is added to the map by default.
L.Map.mergeOptions({
	zoomControl: true
});

L.Map.addInitHook(function () {
	if (this.options.zoomControl) {
		this.zoomControl = new L.Control.Zoom();
		this.addControl(this.zoomControl);
	}
});

// @namespace Control.Zoom
// @factory L.control.zoom(options: Control.Zoom options)
// Creates a zoom control
L.control.zoom = function (options) {
	return new L.Control.Zoom(options);
};

/*
 * @class Control.Attribution
 * @aka L.Control.Attribution
 * @inherits Control
 *
 * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
 */

L.Control.Attribution = L.Control.extend({
	// @section
	// @aka Control.Attribution options
	options: {
		position: 'bottomright',

		// @option prefix: String = 'Leaflet'
		// The HTML text shown before the attributions. Pass `false` to disable.
		prefix: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
	},

	initialize: function (options) {
		L.setOptions(this, options);

		this._attributions = {};
	},

	onAdd: function (map) {
		map.attributionControl = this;
		this._container = L.DomUtil.create('div', 'leaflet-control-attribution');
		if (L.DomEvent) {
			L.DomEvent.disableClickPropagation(this._container);
		}

		// TODO ugly, refactor
		for (var i in map._layers) {
			if (map._layers[i].getAttribution) {
				this.addAttribution(map._layers[i].getAttribution());
			}
		}

		this._update();

		return this._container;
	},

	// @method setPrefix(prefix: String): this
	// Sets the text before the attributions.
	setPrefix: function (prefix) {
		this.options.prefix = prefix;
		this._update();
		return this;
	},

	// @method addAttribution(text: String): this
	// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
	addAttribution: function (text) {
		if (!text) { return this; }

		if (!this._attributions[text]) {
			this._attributions[text] = 0;
		}
		this._attributions[text]++;

		this._update();

		return this;
	},

	// @method removeAttribution(text: String): this
	// Removes an attribution text.
	removeAttribution: function (text) {
		if (!text) { return this; }

		if (this._attributions[text]) {
			this._attributions[text]--;
			this._update();
		}

		return this;
	},

	_update: function () {
		if (!this._map) { return; }

		var attribs = [];

		for (var i in this._attributions) {
			if (this._attributions[i]) {
				attribs.push(i);
			}
		}

		var prefixAndAttribs = [];

		if (this.options.prefix) {
			prefixAndAttribs.push(this.options.prefix);
		}
		if (attribs.length) {
			prefixAndAttribs.push(attribs.join(', '));
		}

		this._container.innerHTML = prefixAndAttribs.join(' | ');
	}
});

// @namespace Map
// @section Control options
// @option attributionControl: Boolean = true
// Whether a [attribution control](#control-attribution) is added to the map by default.
L.Map.mergeOptions({
	attributionControl: true
});

L.Map.addInitHook(function () {
	if (this.options.attributionControl) {
		new L.Control.Attribution().addTo(this);
	}
});

// @namespace Control.Attribution
// @factory L.control.attribution(options: Control.Attribution options)
// Creates an attribution control.
L.control.attribution = function (options) {
	return new L.Control.Attribution(options);
};

/*
 * @class Control.Scale
 * @aka L.Control.Scale
 * @inherits Control
 *
 * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
 *
 * @example
 *
 * ```js
 * L.control.scale().addTo(map);
 * ```
 */

L.Control.Scale = L.Control.extend({
	// @section
	// @aka Control.Scale options
	options: {
		position: 'bottomleft',

		// @option maxWidth: Number = 100
		// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
		maxWidth: 100,

		// @option metric: Boolean = True
		// Whether to show the metric scale line (m/km).
		metric: true,

		// @option imperial: Boolean = True
		// Whether to show the imperial scale line (mi/ft).
		imperial: true

		// @option updateWhenIdle: Boolean = false
		// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
	},

	onAdd: function (map) {
		var className = 'leaflet-control-scale',
		    container = L.DomUtil.create('div', className),
		    options = this.options;

		this._addScales(options, className + '-line', container);

		map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		map.whenReady(this._update, this);

		return container;
	},

	onRemove: function (map) {
		map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	},

	_addScales: function (options, className, container) {
		if (options.metric) {
			this._mScale = L.DomUtil.create('div', className, container);
		}
		if (options.imperial) {
			this._iScale = L.DomUtil.create('div', className, container);
		}
	},

	_update: function () {
		var map = this._map,
		    y = map.getSize().y / 2;

		var maxMeters = map.distance(
				map.containerPointToLatLng([0, y]),
				map.containerPointToLatLng([this.options.maxWidth, y]));

		this._updateScales(maxMeters);
	},

	_updateScales: function (maxMeters) {
		if (this.options.metric && maxMeters) {
			this._updateMetric(maxMeters);
		}
		if (this.options.imperial && maxMeters) {
			this._updateImperial(maxMeters);
		}
	},

	_updateMetric: function (maxMeters) {
		var meters = this._getRoundNum(maxMeters),
		    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';

		this._updateScale(this._mScale, label, meters / maxMeters);
	},

	_updateImperial: function (maxMeters) {
		var maxFeet = maxMeters * 3.2808399,
		    maxMiles, miles, feet;

		if (maxFeet > 5280) {
			maxMiles = maxFeet / 5280;
			miles = this._getRoundNum(maxMiles);
			this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);

		} else {
			feet = this._getRoundNum(maxFeet);
			this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
		}
	},

	_updateScale: function (scale, text, ratio) {
		scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
		scale.innerHTML = text;
	},

	_getRoundNum: function (num) {
		var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
		    d = num / pow10;

		d = d >= 10 ? 10 :
		    d >= 5 ? 5 :
		    d >= 3 ? 3 :
		    d >= 2 ? 2 : 1;

		return pow10 * d;
	}
});


// @factory L.control.scale(options?: Control.Scale options)
// Creates an scale control with the given options.
L.control.scale = function (options) {
	return new L.Control.Scale(options);
};

/*
 * @class Control.Layers
 * @aka L.Control.Layers
 * @inherits Control
 *
 * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control.html)). Extends `Control`.
 *
 * @example
 *
 * ```js
 * var baseLayers = {
 * 	"Mapbox": mapbox,
 * 	"OpenStreetMap": osm
 * };
 *
 * var overlays = {
 * 	"Marker": marker,
 * 	"Roads": roadsLayer
 * };
 *
 * L.control.layers(baseLayers, overlays).addTo(map);
 * ```
 *
 * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
 *
 * ```js
 * {
 *     "<someName1>": layer1,
 *     "<someName2>": layer2
 * }
 * ```
 *
 * The layer names can contain HTML, which allows you to add additional styling to the items:
 *
 * ```js
 * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
 * ```
 */


L.Control.Layers = L.Control.extend({
	// @section
	// @aka Control.Layers options
	options: {
		// @option collapsed: Boolean = true
		// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
		collapsed: true,
		position: 'topright',

		// @option autoZIndex: Boolean = true
		// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
		autoZIndex: true,

		// @option hideSingleBase: Boolean = false
		// If `true`, the base layers in the control will be hidden when there is only one.
		hideSingleBase: false
	},

	initialize: function (baseLayers, overlays, options) {
		L.setOptions(this, options);

		this._layers = [];
		this._lastZIndex = 0;
		this._handlingClick = false;

		for (var i in baseLayers) {
			this._addLayer(baseLayers[i], i);
		}

		for (i in overlays) {
			this._addLayer(overlays[i], i, true);
		}
	},

	onAdd: function (map) {
		this._initLayout();
		this._update();

		this._map = map;
		map.on('zoomend', this._checkDisabledLayers, this);

		return this._container;
	},

	onRemove: function () {
		this._map.off('zoomend', this._checkDisabledLayers, this);

		for (var i = 0; i < this._layers.length; i++) {
			this._layers[i].layer.off('add remove', this._onLayerChange, this);
		}
	},

	// @method addBaseLayer(layer: Layer, name: String): this
	// Adds a base layer (radio button entry) with the given name to the control.
	addBaseLayer: function (layer, name) {
		this._addLayer(layer, name);
		return (this._map) ? this._update() : this;
	},

	// @method addOverlay(layer: Layer, name: String): this
	// Adds an overlay (checkbox entry) with the given name to the control.
	addOverlay: function (layer, name) {
		this._addLayer(layer, name, true);
		return (this._map) ? this._update() : this;
	},

	// @method removeLayer(layer: Layer): this
	// Remove the given layer from the control.
	removeLayer: function (layer) {
		layer.off('add remove', this._onLayerChange, this);

		var obj = this._getLayer(L.stamp(layer));
		if (obj) {
			this._layers.splice(this._layers.indexOf(obj), 1);
		}
		return (this._map) ? this._update() : this;
	},

	// @method expand(): this
	// Expand the control container if collapsed.
	expand: function () {
		L.DomUtil.addClass(this._container, 'leaflet-control-layers-expanded');
		this._form.style.height = null;
		var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
		if (acceptableHeight < this._form.clientHeight) {
			L.DomUtil.addClass(this._form, 'leaflet-control-layers-scrollbar');
			this._form.style.height = acceptableHeight + 'px';
		} else {
			L.DomUtil.removeClass(this._form, 'leaflet-control-layers-scrollbar');
		}
		this._checkDisabledLayers();
		return this;
	},

	// @method collapse(): this
	// Collapse the control container if expanded.
	collapse: function () {
		L.DomUtil.removeClass(this._container, 'leaflet-control-layers-expanded');
		return this;
	},

	_initLayout: function () {
		var className = 'leaflet-control-layers',
		    container = this._container = L.DomUtil.create('div', className);

		// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
		container.setAttribute('aria-haspopup', true);

		L.DomEvent.disableClickPropagation(container);
		if (!L.Browser.touch) {
			L.DomEvent.disableScrollPropagation(container);
		}

		var form = this._form = L.DomUtil.create('form', className + '-list');

		if (this.options.collapsed) {
			if (!L.Browser.android) {
				L.DomEvent.on(container, {
					mouseenter: this.expand,
					mouseleave: this.collapse
				}, this);
			}

			var link = this._layersLink = L.DomUtil.create('a', className + '-toggle', container);
			link.href = '#';
			link.title = 'Layers';

			if (L.Browser.touch) {
				L.DomEvent
				    .on(link, 'click', L.DomEvent.stop)
				    .on(link, 'click', this.expand, this);
			} else {
				L.DomEvent.on(link, 'focus', this.expand, this);
			}

			// work around for Firefox Android issue https://github.com/Leaflet/Leaflet/issues/2033
			L.DomEvent.on(form, 'click', function () {
				setTimeout(L.bind(this._onInputClick, this), 0);
			}, this);

			this._map.on('click', this.collapse, this);
			// TODO keyboard accessibility
		} else {
			this.expand();
		}

		this._baseLayersList = L.DomUtil.create('div', className + '-base', form);
		this._separator = L.DomUtil.create('div', className + '-separator', form);
		this._overlaysList = L.DomUtil.create('div', className + '-overlays', form);

		container.appendChild(form);
	},

	_getLayer: function (id) {
		for (var i = 0; i < this._layers.length; i++) {

			if (this._layers[i] && L.stamp(this._layers[i].layer) === id) {
				return this._layers[i];
			}
		}
	},

	_addLayer: function (layer, name, overlay) {
		layer.on('add remove', this._onLayerChange, this);

		this._layers.push({
			layer: layer,
			name: name,
			overlay: overlay
		});

		if (this.options.autoZIndex && layer.setZIndex) {
			this._lastZIndex++;
			layer.setZIndex(this._lastZIndex);
		}
	},

	_update: function () {
		if (!this._container) { return this; }

		L.DomUtil.empty(this._baseLayersList);
		L.DomUtil.empty(this._overlaysList);

		var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;

		for (i = 0; i < this._layers.length; i++) {
			obj = this._layers[i];
			this._addItem(obj);
			overlaysPresent = overlaysPresent || obj.overlay;
			baseLayersPresent = baseLayersPresent || !obj.overlay;
			baseLayersCount += !obj.overlay ? 1 : 0;
		}

		// Hide base layers section if there's only one layer.
		if (this.options.hideSingleBase) {
			baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
			this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
		}

		this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';

		return this;
	},

	_onLayerChange: function (e) {
		if (!this._handlingClick) {
			this._update();
		}

		var obj = this._getLayer(L.stamp(e.target));

		// @namespace Map
		// @section Layer events
		// @event baselayerchange: LayersControlEvent
		// Fired when the base layer is changed through the [layer control](#control-layers).
		// @event overlayadd: LayersControlEvent
		// Fired when an overlay is selected through the [layer control](#control-layers).
		// @event overlayremove: LayersControlEvent
		// Fired when an overlay is deselected through the [layer control](#control-layers).
		// @namespace Control.Layers
		var type = obj.overlay ?
			(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
			(e.type === 'add' ? 'baselayerchange' : null);

		if (type) {
			this._map.fire(type, obj);
		}
	},

	// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
	_createRadioElement: function (name, checked) {

		var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
				name + '"' + (checked ? ' checked="checked"' : '') + '/>';

		var radioFragment = document.createElement('div');
		radioFragment.innerHTML = radioHtml;

		return radioFragment.firstChild;
	},

	_addItem: function (obj) {
		var label = document.createElement('label'),
		    checked = this._map.hasLayer(obj.layer),
		    input;

		if (obj.overlay) {
			input = document.createElement('input');
			input.type = 'checkbox';
			input.className = 'leaflet-control-layers-selector';
			input.defaultChecked = checked;
		} else {
			input = this._createRadioElement('leaflet-base-layers', checked);
		}

		input.layerId = L.stamp(obj.layer);

		L.DomEvent.on(input, 'click', this._onInputClick, this);

		var name = document.createElement('span');
		name.innerHTML = ' ' + obj.name;

		// Helps from preventing layer control flicker when checkboxes are disabled
		// https://github.com/Leaflet/Leaflet/issues/2771
		var holder = document.createElement('div');

		label.appendChild(holder);
		holder.appendChild(input);
		holder.appendChild(name);

		var container = obj.overlay ? this._overlaysList : this._baseLayersList;
		container.appendChild(label);

		this._checkDisabledLayers();
		return label;
	},

	_onInputClick: function () {
		var inputs = this._form.getElementsByTagName('input'),
		    input, layer, hasLayer;
		var addedLayers = [],
		    removedLayers = [];

		this._handlingClick = true;

		for (var i = inputs.length - 1; i >= 0; i--) {
			input = inputs[i];
			layer = this._getLayer(input.layerId).layer;
			hasLayer = this._map.hasLayer(layer);

			if (input.checked && !hasLayer) {
				addedLayers.push(layer);

			} else if (!input.checked && hasLayer) {
				removedLayers.push(layer);
			}
		}

		// Bugfix issue 2318: Should remove all old layers before readding new ones
		for (i = 0; i < removedLayers.length; i++) {
			this._map.removeLayer(removedLayers[i]);
		}
		for (i = 0; i < addedLayers.length; i++) {
			this._map.addLayer(addedLayers[i]);
		}

		this._handlingClick = false;

		this._refocusOnMap();
	},

	_checkDisabledLayers: function () {
		var inputs = this._form.getElementsByTagName('input'),
		    input,
		    layer,
		    zoom = this._map.getZoom();

		for (var i = inputs.length - 1; i >= 0; i--) {
			input = inputs[i];
			layer = this._getLayer(input.layerId).layer;
			input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
			                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);

		}
	},

	_expand: function () {
		// Backward compatibility, remove me in 1.1.
		return this.expand();
	},

	_collapse: function () {
		// Backward compatibility, remove me in 1.1.
		return this.collapse();
	}

});


// @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
// Creates an attribution control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
L.control.layers = function (baseLayers, overlays, options) {
	return new L.Control.Layers(baseLayers, overlays, options);
};

/*
 * Provides L.Map with convenient shortcuts for using browser geolocation features.
 */

// @namespace Map

L.Map.include({
	// @section Geolocation methods
	_defaultLocateOptions: {
		timeout: 10000,
		watch: false
		// setView: false
		// maxZoom: <Number>
		// maximumAge: 0
		// enableHighAccuracy: false
	},

	// @method locate(options?: Locate options): this
	// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
	// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
	// and optionally sets the map view to the user's location with respect to
	// detection accuracy (or to the world view if geolocation failed).
	// Note that, if your page doesn't use HTTPS, this method will fail in
	// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
	// See `Locate options` for more details.
	locate: function (options) {

		options = this._locateOptions = L.extend({}, this._defaultLocateOptions, options);

		if (!('geolocation' in navigator)) {
			this._handleGeolocationError({
				code: 0,
				message: 'Geolocation not supported.'
			});
			return this;
		}

		var onResponse = L.bind(this._handleGeolocationResponse, this),
		    onError = L.bind(this._handleGeolocationError, this);

		if (options.watch) {
			this._locationWatchId =
			        navigator.geolocation.watchPosition(onResponse, onError, options);
		} else {
			navigator.geolocation.getCurrentPosition(onResponse, onError, options);
		}
		return this;
	},

	// @method stopLocate(): this
	// Stops watching location previously initiated by `map.locate({watch: true})`
	// and aborts resetting the map view if map.locate was called with
	// `{setView: true}`.
	stopLocate: function () {
		if (navigator.geolocation && navigator.geolocation.clearWatch) {
			navigator.geolocation.clearWatch(this._locationWatchId);
		}
		if (this._locateOptions) {
			this._locateOptions.setView = false;
		}
		return this;
	},

	_handleGeolocationError: function (error) {
		var c = error.code,
		    message = error.message ||
		            (c === 1 ? 'permission denied' :
		            (c === 2 ? 'position unavailable' : 'timeout'));

		if (this._locateOptions.setView && !this._loaded) {
			this.fitWorld();
		}

		// @section Location events
		// @event locationerror: ErrorEvent
		// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
		this.fire('locationerror', {
			code: c,
			message: 'Geolocation error: ' + message + '.'
		});
	},

	_handleGeolocationResponse: function (pos) {
		var lat = pos.coords.latitude,
		    lng = pos.coords.longitude,
		    latlng = new L.LatLng(lat, lng),
		    bounds = latlng.toBounds(pos.coords.accuracy),
		    options = this._locateOptions;

		if (options.setView) {
			var zoom = this.getBoundsZoom(bounds);
			this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
		}

		var data = {
			latlng: latlng,
			bounds: bounds,
			timestamp: pos.timestamp
		};

		for (var i in pos.coords) {
			if (typeof pos.coords[i] === 'number') {
				data[i] = pos.coords[i];
			}
		}

		// @event locationfound: LocationEvent
		// Fired when geolocation (using the [`locate`](#map-locate) method)
		// went successfully.
		this.fire('locationfound', data);
	}
});

},{}],6:[function(_dereq_,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],7:[function(_dereq_,module,exports){
(function(window, undefined) {
    'use strict';

    if (!window) return; // Server side

var
    _baron = window.baron, // Stored baron value for noConflict usage
    $ = window.jQuery, // Trying to use jQuery
    origin = {
        v: { // Vertical
            x: 'Y', pos: 'top', crossPos: 'left', size: 'height', crossSize: 'width',
            client: 'clientHeight', crossClient: 'clientWidth', offset: 'offsetHeight', crossOffset: 'offsetWidth', offsetPos: 'offsetTop',
            scroll: 'scrollTop', scrollSize: 'scrollHeight'
        },
        h: { // Horizontal
            x: 'X', pos: 'left', crossPos: 'top', size: 'width', crossSize: 'height',
            client: 'clientWidth', crossClient: 'clientHeight', offset: 'offsetWidth', crossOffset: 'offsetHeight', offsetPos: 'offsetLeft',
            scroll: 'scrollLeft', scrollSize: 'scrollWidth'
        }
    },

    each = function(obj, iterator) {
        var i = 0;

        if (obj.length === undefined || obj === window) obj = [obj];

        while (obj[i]) {
            iterator.call(this, obj[i], i);
            i++;
        }
    },

    baron = function(params) { // this - window or jQuery instance
        var jQueryMode = false,//(this && this[0] && this[0].nodeType),
            roots,
            $;

        params = params || {};
        $ = params.$ || window.jQuery;

        if (jQueryMode) {
            params.root = roots = this;
        } else {
            roots = $(params.root || params.scroller);
        }

        return new baron.fn.constructor(roots, params, $);
    };

    baron.fn = {
        constructor: function(roots, input, $) {
            var params = validate(input);

            params.$ = $;
            each.call(this, roots, function(root, i) {
                var localParams = clone(params);

                if (params.root && params.scroller) {
                    localParams.scroller = params.$(params.scroller, root);
                    if (!localParams.scroller.length) {
                        localParams.scroller = root;
                    }
                } else {
                    localParams.scroller = root;
                }

                localParams.root = root;
                this[i] = init(localParams);
                this.length = i + 1;
            });

            this.params = params;
        },

        dispose: function() {
            var params = this.params;

            each(this, function(item) {
                item.dispose(params);
            });
            this.params = null;
        },

        update: function() {
            var i = 0;

            while (this[i]) {
                this[i].update.apply(this[i], arguments);
                i++;
            }
        },

        baron: function(params) {
            params.root = [];
            params.scroller = this.params.scroller;

            each.call(this, this, function(elem) {
                params.root.push(elem.root);
            });
            params.direction = (this.params.direction == 'v') ? 'h' : 'v';
            params._chain = true;

            return baron(params);
        }
    };

    function manageEvents(item, eventManager, mode) {
        item._eventHandlers = item._eventHandlers || [ // Creating new functions for one baron item only one time
            {
                // onScroll:
                element: item.scroller,

                handler: function(e) {
                    item.scroll(e);
                },

                type: 'scroll'
            }, {
                // onMouseDown:
                element: item.bar,

                handler: function(e) {
                    e.preventDefault ? e.preventDefault() : e.returnValue = false; // Text selection disabling in Opera... and all other browsers?
                    item.selection(); // Disable text selection in ie8
                    item.drag.now = 1; // Save private byte
                },

                type: 'touchstart mousedown'
            }, {
                // onMouseUp:
                element: document,

                handler: function() {
                    item.selection(1); // Enable text selection
                    item.drag.now = 0;
                },

                type: 'mouseup blur touchend'
            }, {
                // onCoordinateReset:
                element: item.bar,

                handler: function(e) {
                    if (e.button != 2) { // Not RM
                        item._pos0(e);
                    }
                },

                type: 'touchstart mousedown'
            }, {
                // onMouseMove:
                element: document,

                handler: function(e) {
                    if (item.drag.now) {
                        item.drag(e);
                    }
                },

                type: 'mousemove touchmove'
            }, {
                // onResize:
                element: window,

                handler: function() {
                    item.update();
                },

                type: 'resize'
            }, {
                // sizeChange:
                element: item.root,

                handler: function() {
                    item.update();
                },

                type: 'sizeChange'
            }
        ];

        each(item._eventHandlers, function(event) {
            if (event.element) {
                eventManager(event.element, event.type, event.handler, mode);
            }
        });

        // if (item.scroller) {
        //     event(item.scroller, 'scroll', item._eventHandlers.onScroll, mode);
        // }
        // if (item.bar) {
        //     event(item.bar, 'touchstart mousedown', item._eventHandlers.onMouseDown, mode);
        // }
        // event(document, 'mouseup blur touchend', item._eventHandlers.onMouseUp, mode);
        // event(document, 'touchstart mousedown', item._eventHandlers.onCoordinateReset, mode);
        // event(document, 'mousemove touchmove', item._eventHandlers.onMouseMove, mode);
        // event(window, 'resize', item._eventHandlers.onResize, mode);
        // if (item.root) {
        //     event(item.root, 'sizeChange', item._eventHandlers.onResize, mode); // Custon event for alternate baron update mechanism
        // }
    }

    function manageAttr(node, direction, mode) {
        var attrName = 'data-baron-' + direction;

        if (mode == 'on') {
            node.setAttribute(attrName, 'inited');
        } else if (mode == 'off') {
            node.removeAttribute(attrName);
        } else {
            return node.getAttribute(attrName);
        }
    }

    function init(params) {
        if (manageAttr(params.root, params.direction)) return;

        var out = new item.prototype.constructor(params); // __proto__ of returning object is baron.prototype

        manageEvents(out, params.event, 'on');

        manageAttr(out.root, params.direction, 'on');

        out.update();

        return out;
    }

    function clone(input) {
        var output = {};

        input = input || {};

        for (var key in input) {
            if (input.hasOwnProperty(key)) {
                output[key] = input[key];
            }
        }

        return output;
    }

    function validate(input) {
        var output = clone(input);

        output.direction = output.direction || 'v';

        var event = input.event || function(elem, event, func, mode) {
            output.$(elem)[mode || 'on'](event, func);
        };

        output.event = function(elems, e, func, mode) {
            each(elems, function(elem) {
                event(elem, e, func, mode);
            });
        };

        return output;
    }

    function fire(eventName) {
        /* jshint validthis:true */
        if (this.events && this.events[eventName]) {
            for (var i = 0 ; i < this.events[eventName].length ; i++) {
                var args = Array.prototype.slice.call( arguments, 1 );

                this.events[eventName][i].apply(this, args);
            }
        }
    }

    var item = {};

    item.prototype = {
        constructor: function(params) {
            var $,
                barPos,
                scrollerPos0,
                track,
                resizePauseTimer,
                scrollPauseTimer,
                pause,
                scrollLastFire,
                resizeLastFire;

            resizeLastFire = scrollLastFire = new Date().getTime();

            $ = this.$ = params.$;
            this.event = params.event;
            this.events = {};

            function getNode(sel, context) {
                return $(sel, context)[0]; // Can be undefined
            }

            // DOM elements
            this.root = params.root; // Always html node, not just selector
            this.scroller = getNode(params.scroller); // (params.scroller) ? getNode(params.scroller, this.root) : this.root;
            this.bar = getNode(params.bar, this.root);
            track = this.track = getNode(params.track, this.root);
            if (!this.track && this.bar) {
                track = this.bar.parentNode;
            }
            this.clipper = this.scroller.parentNode;

            // Parameters
            this.direction = params.direction;
            this.origin = origin[this.direction];
            this.barOnCls = params.barOnCls;
            this.barTopLimit = 0;
            pause = params.pause * 1000 || 0;

            // Updating height or width of bar
            function setBarSize(size) {
                /* jshint validthis:true */
                var barMinSize = this.barMinSize || 20;

                if (size > 0 && size < barMinSize) {
                    size = barMinSize;
                }

                if (this.bar) {
                    $(this.bar).css(this.origin.size, parseInt(size, 10) + 'px');
                }
            }

            // Updating top or left bar position
            function posBar(pos) {
                /* jshint validthis:true */
                if (this.bar) {
                    $(this.bar).css(this.origin.pos, +pos + 'px');
                }
            }

            // Free path for bar
            function k() {
                /* jshint validthis:true */
                return track[this.origin.client] - this.barTopLimit - this.bar[this.origin.offset];
            }

            // Relative content top position to bar top position
            function relToPos(r) {
                /* jshint validthis:true */
                return r * k.call(this) + this.barTopLimit;
            }

            // Bar position to relative content position
            function posToRel(t) {
                /* jshint validthis:true */
                return (t - this.barTopLimit) / k.call(this);
            }

            // Cursor position in main direction in px // Now with iOs support
            this.cursor = function(e) {
                return e['client' + this.origin.x] || (((e.originalEvent || e).touches || {})[0] || {})['page' + this.origin.x];
            };

            // Text selection pos preventing
            function dontPosSelect() {
                return false;
            }

            this.pos = function(x) { // Absolute scroller position in px
                var ie = 'page' + this.origin.x + 'Offset',
                    key = (this.scroller[ie]) ? ie : this.origin.scroll;

                if (x !== undefined) this.scroller[key] = x;

                return this.scroller[key];
            };

            this.rpos = function(r) { // Relative scroller position (0..1)
                var free = this.scroller[this.origin.scrollSize] - this.scroller[this.origin.client],
                    x;

                if (r) x = this.pos(r * free);
                else x = this.pos();

                return x / (free || 1);
            };

            // Switch on the bar by adding user-defined CSS classname to scroller
            this.barOn = function(dispose) {
                if (this.barOnCls) {
                    if (dispose || this.scroller[this.origin.client] >= this.scroller[this.origin.scrollSize]) {
                        $(this.root).removeClass(this.barOnCls);
                    } else {
                        $(this.root).addClass(this.barOnCls);
                    }
                }
            };

            this._pos0 = function(e) {
                scrollerPos0 = this.cursor(e) - barPos;
            };

            this.drag = function(e) {
                this.scroller[this.origin.scroll] = posToRel.call(this, this.cursor(e) - scrollerPos0) * (this.scroller[this.origin.scrollSize] - this.scroller[this.origin.client]);
            };

            // Text selection preventing on drag
            this.selection = function(enable) {
                this.event(document, 'selectpos selectstart', dontPosSelect, enable ? 'off' : 'on');
            };

            // onResize & DOM modified handler
            this.resize = function() {
                var self = this,
                    delay = 0;

                if (new Date().getTime() - resizeLastFire < pause) {
                    clearTimeout(resizePauseTimer);
                    delay = pause;
                }

                function upd() {
                    var delta = self.scroller[self.origin.crossOffset] - self.scroller[self.origin.crossClient];

                    if (params.freeze && !self.clipper.style[self.origin.crossSize]) { // Sould fire only once
                        $(self.clipper).css(self.origin.crossSize, self.clipper[self.origin.crossClient] - delta + 'px');
                    }
                    $(self.scroller).css(self.origin.crossSize, self.clipper[self.origin.crossClient] + delta + 'px');

                    Array.prototype.unshift.call(arguments, 'resize');
                    fire.apply(self, arguments);

                    resizeLastFire = new Date().getTime();
                }

                if (delay) {
                    resizePauseTimer = setTimeout(upd, delay);
                } else {
                    upd();
                }
            };

            // onScroll handler
            this.scroll = function() {
                var oldBarSize, newBarSize,
                    delay = 0,
                    self = this;

                if (new Date().getTime() - scrollLastFire < pause) {
                    clearTimeout(scrollPauseTimer);
                    delay = pause;
                }

                function upd() {
                    if (self.bar) {
                        newBarSize = (track[self.origin.client] - self.barTopLimit) * self.scroller[self.origin.client] / self.scroller[self.origin.scrollSize];

                        // Positioning bar
                        if (oldBarSize != newBarSize) {
                            setBarSize.call(self, newBarSize);
                            oldBarSize = newBarSize;
                        }

                        barPos = relToPos.call(self, self.rpos());

                        posBar.call(self, barPos);
                    }

                    Array.prototype.unshift.call( arguments, 'scroll' );
                    fire.apply(self, arguments);

                    scrollLastFire = new Date().getTime();
                }

                if (delay) {
                    scrollPauseTimer = setTimeout(upd, delay);
                } else {
                    upd();
                }

            };

            return this;
        },

        update: function(params) {
            fire.call(this, 'upd', params); // Обновляем параметры всех плагинов

            this.resize(1);
            this.barOn();
            this.scroll();

            return this;
        },

        dispose: function(params) {
            manageEvents(this, this.event, 'off');
            manageAttr(this.root, params.direction, 'off');
            $(this.scroller).css(this.origin.crossSize, '');
            this.barOn(true);
            fire.call(this, 'dispose');
        },

        on: function(eventName, func, arg) {
            var names = eventName.split(' ');

            for (var i = 0 ; i < names.length ; i++) {
                if (names[i] == 'init') {
                    func.call(this, arg);
                } else {
                    this.events[names[i]] = this.events[names[i]] || [];

                    this.events[names[i]].push(function(userArg) {
                        func.call(this, userArg || arg);
                    });
                }
            }
        }
    };

    baron.fn.constructor.prototype = baron.fn;
    item.prototype.constructor.prototype = item.prototype;

    // Use when you need "baron" global var for another purposes
    baron.noConflict = function() {
        window.baron = _baron; // Restoring original value of "baron" global var
        return baron;
    };

    baron.version = '0.6.6';

    if ($ && $.fn) { // Adding baron to jQuery as plugin
        $.fn.baron = baron;
    }
    window.baron = baron; // Use noConflict method if you need window.baron var for another purposes

    var fix = function(userParams) {
        var elements, viewPortSize,
            params = { // Default params
                outside: '',
                before: '',
                after: '',
                past: '',
                future: '',
                radius: 0,
                minView: 0
            },
            topFixHeights = [], // inline style for element
            topRealHeights = [], // real offset position when not fixed
            headerTops = [],
            scroller = this.scroller,
            eventManager = this.event,
            $ = this.$,
            self = this;

        function fixElement(i, pos) {
            if (viewPortSize < (params.minView || 0)) { // No headers fixing when no enought space for viewport
                pos = undefined;
            }

            if (pos !== undefined) {
                pos += 'px';
                this.$(elements[i]).css(this.origin.pos, pos).addClass(params.outside);
            } else {
                this.$(elements[i]).css(this.origin.pos, '').removeClass(params.outside);
            }
        }

        function bubbleWheel(e) {
            try {
                i = document.createEvent('WheelEvent'); // i - for extra byte
                // evt.initWebKitWheelEvent(deltaX, deltaY, window, screenX, screenY, clientX, clientY, ctrlKey, altKey, shiftKey, metaKey);
                i.initWebKitWheelEvent(e.originalEvent.wheelDeltaX, e.originalEvent.wheelDeltaY);
                scroller.dispatchEvent(i);
                e.preventDefault();
            } catch (e) {}
        }

        function init(_params) {
            var pos;

            for (var key in _params) {
                params[key] = _params[key];
            }

            elements = this.$(params.elements, this.scroller);

            if (elements) {
                viewPortSize = this.scroller[this.origin.client];
                for (var i = 0 ; i < elements.length ; i++) {
                    // Variable header heights
                    pos = {};
                    pos[this.origin.size] = elements[i][this.origin.offset];
                    if (elements[i].parentNode !== this.scroller) {
                        this.$(elements[i].parentNode).css(pos);
                    }
                    pos = {};
                    pos[this.origin.crossSize] = elements[i].parentNode[this.origin.crossClient];
                    this.$(elements[i]).css(pos);

                    // Between fixed headers
                    viewPortSize -= elements[i][this.origin.offset];

                    headerTops[i] = elements[i].parentNode[this.origin.offsetPos]; // No paddings for parentNode

                    // Summary elements height above current
                    topFixHeights[i] = (topFixHeights[i - 1] || 0); // Not zero because of negative margins
                    topRealHeights[i] = (topRealHeights[i - 1] || Math.min(headerTops[i], 0));

                    if (elements[i - 1]) {
                        topFixHeights[i] += elements[i - 1][this.origin.offset];
                        topRealHeights[i] += elements[i - 1][this.origin.offset];
                    }

                    if ( !(i == 0 && headerTops[i] == 0)/* && force */) {
                        this.event(elements[i], 'mousewheel', bubbleWheel, 'off');
                        this.event(elements[i], 'mousewheel', bubbleWheel);
                    }
                }

                if (params.limiter && elements[0]) { // Bottom edge of first header as top limit for track
                    if (this.track && this.track != this.scroller) {
                        pos = {};
                        pos[this.origin.pos] = elements[0].parentNode[this.origin.offset];
                        this.$(this.track).css(pos);
                    } else {
                        this.barTopLimit = elements[0].parentNode[this.origin.offset];
                    }
                    // this.barTopLimit = elements[0].parentNode[this.origin.offset];
                    this.scroll();
                }

                if (params.limiter === false) { // undefined (in second fix instance) should have no influence on bar limit
                    this.barTopLimit = 0;
                }
            }

            var event = {
                element: elements,

                handler: function() {
                    var parent = $(this)[0].parentNode,
                        top = parent.offsetTop,
                        num;

                    // finding num -> elements[num] === this
                    for (var i = 0 ; i < elements.length ; i++ ) {
                        if (elements[i] === this) num = i;
                    }

                    var pos = top - topFixHeights[num];

                    if (params.scroll) { // User defined callback
                        params.scroll({
                            x1: self.scroller.scrollTop,
                            x2: pos
                        });
                    } else {
                        self.scroller.scrollTop = pos;
                    }
                },

                type: 'click'
            };

            if (params.clickable) {
                this._eventHandlers.push(event); // For auto-dispose
                eventManager(event.element, event.type, event.handler, 'off');
                eventManager(event.element, event.type, event.handler, 'on');
            }
        }

        this.on('init', init, userParams);

        this.on('init scroll', function() {
            var fixState, hTop,
                fixFlag = []; // 1 - past, 2 - future, 3 - current (not fixed)

            if (elements) {
                var change;

                // fixFlag update
                for (var i = 0 ; i < elements.length ; i++) {
                    fixState = 0;
                    if (headerTops[i] - this.pos() < topRealHeights[i] + params.radius) {
                        // Header trying to go up
                        fixState = 1;
                        hTop = topFixHeights[i];
                    } else if (headerTops[i] - this.pos() > topRealHeights[i] + viewPortSize - params.radius) {
                        // Header trying to go down
                        fixState = 2;
                        hTop = topFixHeights[i] + viewPortSize;
                    } else {
                        // Header in viewport
                        fixState = 3;
                        hTop = undefined;
                    }
                    if (fixState != fixFlag[i]) {
                        fixElement.call(this, i, hTop);
                        fixFlag[i] = fixState;
                        change = true;
                    }
                }

                // Adding positioning classes (on last top and first bottom header)
                if (change) { // At leats one change in elements flag structure occured
                    for (i = 0 ; i < elements.length ; i++) {
                        if (fixFlag[i] == 1 && params.past) {
                            this.$(elements[i]).addClass(params.past).removeClass(params.future);
                        }

                        if (fixFlag[i] == 2 && params.future) {
                            this.$(elements[i]).addClass(params.future).removeClass(params.past);
                        }

                        if (fixFlag[i] == 3 && (params.future || params.past)) {
                            this.$(elements[i]).removeClass(params.past).removeClass(params.future);
                        }

                        if (fixFlag[i] != fixFlag[i + 1] && fixFlag[i] == 1 && params.before) {
                            this.$(elements[i]).addClass(params.before).removeClass(params.after); // Last top fixed header
                        } else if (fixFlag[i] != fixFlag[i - 1] && fixFlag[i] == 2 && params.after) {
                            this.$(elements[i]).addClass(params.after).removeClass(params.before); // First bottom fixed header
                        } else {
                            this.$(elements[i]).removeClass(params.before).removeClass(params.after);
                        }
                    }
                }
            }
        });

        this.on('resize upd', function(updParams) {
            init.call(this, updParams && updParams.fix);
        });
    };

    baron.fn.fix = function(params) {
        var i = 0;

        while (this[i]) {
            fix.call(this[i], params);
            i++;
        }

        return this;
    };

    var controls = function(params) {
        var forward, backward, track, screen,
            self = this; // AAAAAA!!!!!11

        screen = params.screen || 0.9;

        if (params.forward) {
            forward = this.$(params.forward, this.clipper);

            this.event(forward, 'click', function() {
                var y = self.pos() - params.delta || 30;

                self.pos(y);
            });
        }

        if (params.backward) {
            backward = this.$(params.backward, this.clipper);

            this.event(backward, 'click', function() {
                var y = self.pos() + params.delta || 30;

                self.pos(y);
            });
        }

        if (params.track) {
            if (params.track === true) {
                track = this.track;
            } else {
                track = this.$(params.track, this.clipper)[0];
            }

            if (track) {
                this.event(track, 'mousedown', function(e) {
                    var x = e['offset' + self.origin.x],
                        xBar = self.bar[self.origin.offsetPos],
                        sign = 0;

                    if (x < xBar) {
                        sign = -1;
                    } else if (x > xBar + self.bar[self.origin.offset]) {
                        sign = 1;
                    }

                    var y = self.pos() + sign * screen * self.scroller[self.origin.client];
                    self.pos(y);
                });
            }
        }

    };

    baron.fn.controls = function(params) {
        var i = 0;

        while (this[i]) {
            controls.call(this[i], params);
            i++;
        }

        return this;
    };

    var pull = function(params) {
        var block = this.$(params.block),
            size = params.size || this.origin.size,
            limit = params.limit || 80,
            onExpand = params.onExpand,
            elements = params.elements || [],
            inProgress = params.inProgress || '',
            self = this,
            _insistence = 0,
            _zeroXCount = 0,
            _interval,
            _timer,
            _x = 0,
            _onExpandCalled,
            _waiting = params.waiting || 500,
            _on;

        function getSize() {
            return self.scroller[self.origin.scroll] + self.scroller[self.origin.offset];
        }

        // Scroller content height
        function getContentSize() {
            return self.scroller[self.origin.scrollSize];
        }

        // Scroller height
        function getScrollerSize() {
            return self.scroller[self.origin.client];
        }

        function step(x, force) {
            var k = x * 0.0005;

            return Math.floor(force - k * (x + 550));
        }

        function toggle(on) {
            _on = on;

            if (on) {
                update(); // First time with no delay
                _interval = setInterval(update, 200);
            } else {
                clearInterval(_interval);
            }
        }

        function update() {
            var pos = {},
                height = getSize(),
                scrollHeight = getContentSize(),
                dx,
                op4,
                scrollInProgress = _insistence == 1;

            op4 = 0; // Возвращающая сила
            if (_insistence > 0) {
                op4 = 40;
            }
            //if (_insistence > -1) {
                dx = step(_x, op4);
                if (height >= scrollHeight - _x && _insistence > -1) {
                    if (scrollInProgress) {
                        _x += dx;
                    }
                } else {
                    _x = 0;
                }

                if (_x < 0) _x = 0;

                pos[size] = _x + 'px';
                if (getScrollerSize() <= getContentSize()) {
                    self.$(block).css(pos);
                    for (var i = 0 ; i < elements.length ; i++) {
                        self.$(elements[i].self).css(elements[i].property, Math.min(_x / limit * 100, 100) + '%');
                    }
                }

                if (inProgress && _x) {
                    self.$(self.root).addClass(inProgress);
                }

                if (_x == 0) {
                    if (params.onCollapse) {
                        params.onCollapse();
                    }
                }

                _insistence = 0;
                _timer = setTimeout(function() {
                    _insistence = -1;
                }, _waiting);
            //}

            if (onExpand && _x > limit && !_onExpandCalled) {
                onExpand();
                _onExpandCalled = true;
            }

            if (_x == 0) {
                _zeroXCount++;
            } else {
                _zeroXCount = 0;

            }
            if (_zeroXCount > 1) {
                toggle(false);
                _onExpandCalled = false;
                if (inProgress) {
                    self.$(self.root).removeClass(inProgress);
                }
            }
        }

        this.on('init', function() {
            toggle(true);
        });

        this.on('dispose', function() {
            toggle(false);
        });

        this.event(this.scroller, 'mousewheel DOMMouseScroll', function(e) {
            var down = e.wheelDelta < 0 || (e.originalEvent && e.originalEvent.wheelDelta < 0) || e.detail > 0;

            if (down) {
                _insistence = 1;
                clearTimeout(_timer);
                if (!_on && getSize() >= getContentSize()) {
                    toggle(true);
                }
            }
            //  else {
            //     toggle(false);
            // }
        });
    };

    baron.fn.pull = function(params) {
        var i = 0;

        while (this[i]) {
            pull.call(this[i], params);
            i++;
        }

        return this;
    };
})(window);

},{}]},{},[1]);
